import { jsx as v, Fragment as ze, jsxs as s1 } from "react/jsx-runtime";
import * as d from "react";
import G, { forwardRef as x1, useLayoutEffect as Zu, useEffect as Te, useState as d2, createElement as s2, createContext as s3, useId as kE, useContext as Rt, useRef as Be, useCallback as R1, useMemo as j1, memo as Ne, cloneElement as LE, Component as EE, isValidElement as TE, Fragment as N6 } from "react";
import * as Pi from "react-dom";
import Xv, { unstable_batchedUpdates as RE } from "react-dom";
function z7(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function e0(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = z7(o, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const i = r[o];
          typeof i == "function" ? i() : z7(e[o], null);
        }
      };
  };
}
function F1(...e) {
  return d.useCallback(e0(...e), e);
}
// @__NO_SIDE_EFFECTS__
function w0(e) {
  const t = /* @__PURE__ */ PE(e), n = d.forwardRef((r, o) => {
    const { children: i, ...a } = r, s = d.Children.toArray(i), l = s.find(AE);
    if (l) {
      const c = l.props.children, f = s.map((u) => u === l ? d.Children.count(c) > 1 ? d.Children.only(null) : d.isValidElement(c) ? c.props.children : null : u);
      return /* @__PURE__ */ v(t, { ...a, ref: o, children: d.isValidElement(c) ? d.cloneElement(c, void 0, f) : null });
    }
    return /* @__PURE__ */ v(t, { ...a, ref: o, children: i });
  });
  return n.displayName = `${e}.Slot`, n;
}
var Ai = /* @__PURE__ */ w0("Slot");
// @__NO_SIDE_EFFECTS__
function PE(e) {
  const t = d.forwardRef((n, r) => {
    const { children: o, ...i } = n;
    if (d.isValidElement(o)) {
      const a = OE(o), s = IE(i, o.props);
      return o.type !== d.Fragment && (s.ref = r ? e0(r, a) : a), d.cloneElement(o, s);
    }
    return d.Children.count(o) > 1 ? d.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var Qv = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function Jv(e) {
  const t = ({ children: n }) => /* @__PURE__ */ v(ze, { children: n });
  return t.displayName = `${e}.Slottable`, t.__radixId = Qv, t;
}
function AE(e) {
  return d.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Qv;
}
function IE(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...s) => {
      const l = i(...s);
      return o(...s), l;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function OE(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function eb(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (n = eb(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function tb() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++) (e = arguments[n]) && (t = eb(e)) && (r && (r += " "), r += t);
  return r;
}
const U7 = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, G7 = tb, Z2 = (e, t) => (n) => {
  var r;
  if (t?.variants == null) return G7(e, n?.class, n?.className);
  const { variants: o, defaultVariants: i } = t, a = Object.keys(o).map((c) => {
    const f = n?.[c], u = i?.[c];
    if (f === null) return null;
    const h = U7(f) || U7(u);
    return o[c][h];
  }), s = n && Object.entries(n).reduce((c, f) => {
    let [u, h] = f;
    return h === void 0 || (c[u] = h), c;
  }, {}), l = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((c, f) => {
    let { class: u, className: h, ...p } = f;
    return Object.entries(p).every((g) => {
      let [m, b] = g;
      return Array.isArray(b) ? b.includes({
        ...i,
        ...s
      }[m]) : {
        ...i,
        ...s
      }[m] === b;
    }) ? [
      ...c,
      u,
      h
    ] : c;
  }, []);
  return G7(e, a, l, n?.class, n?.className);
}, Ku = "-", NE = (e) => {
  const t = BE(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (a) => {
      const s = a.split(Ku);
      return s[0] === "" && s.length !== 1 && s.shift(), nb(s, t) || DE(a);
    },
    getConflictingClassGroupIds: (a, s) => {
      const l = n[a] || [];
      return s && r[a] ? [...l, ...r[a]] : l;
    }
  };
}, nb = (e, t) => {
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], r = t.nextPart.get(n), o = r ? nb(e.slice(1), r) : void 0;
  if (o)
    return o;
  if (t.validators.length === 0)
    return;
  const i = e.join(Ku);
  return t.validators.find(({
    validator: a
  }) => a(i))?.classGroupId;
}, Y7 = /^\[(.+)\]$/, DE = (e) => {
  if (Y7.test(e)) {
    const t = Y7.exec(e)[1], n = t?.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, BE = (e) => {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return $E(Object.entries(e.classGroups), n).forEach(([i, a]) => {
    D6(a, r, i, t);
  }), r;
}, D6 = (e, t, n, r) => {
  e.forEach((o) => {
    if (typeof o == "string") {
      const i = o === "" ? t : Z7(t, o);
      i.classGroupId = n;
      return;
    }
    if (typeof o == "function") {
      if (FE(o)) {
        D6(o(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: n
      });
      return;
    }
    Object.entries(o).forEach(([i, a]) => {
      D6(a, Z7(t, i), n, r);
    });
  });
}, Z7 = (e, t) => {
  let n = e;
  return t.split(Ku).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, FE = (e) => e.isThemeGetter, $E = (e, t) => t ? e.map(([n, r]) => {
  const o = r.map((i) => typeof i == "string" ? t + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(([a, s]) => [t + a, s])) : i);
  return [n, o];
}) : e, WE = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const o = (i, a) => {
    n.set(i, a), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(i) {
      let a = n.get(i);
      if (a !== void 0)
        return a;
      if ((a = r.get(i)) !== void 0)
        return o(i, a), a;
    },
    set(i, a) {
      n.has(i) ? n.set(i, a) : o(i, a);
    }
  };
}, rb = "!", VE = (e) => {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, r = t.length === 1, o = t[0], i = t.length, a = (s) => {
    const l = [];
    let c = 0, f = 0, u;
    for (let b = 0; b < s.length; b++) {
      let y = s[b];
      if (c === 0) {
        if (y === o && (r || s.slice(b, b + i) === t)) {
          l.push(s.slice(f, b)), f = b + i;
          continue;
        }
        if (y === "/") {
          u = b;
          continue;
        }
      }
      y === "[" ? c++ : y === "]" && c--;
    }
    const h = l.length === 0 ? s : s.substring(f), p = h.startsWith(rb), g = p ? h.substring(1) : h, m = u && u > f ? u - f : void 0;
    return {
      modifiers: l,
      hasImportantModifier: p,
      baseClassName: g,
      maybePostfixModifierPosition: m
    };
  };
  return n ? (s) => n({
    className: s,
    parseClassName: a
  }) : a;
}, HE = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}, jE = (e) => ({
  cache: WE(e.cacheSize),
  parseClassName: VE(e),
  ...NE(e)
}), qE = /\s+/, zE = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: o
  } = t, i = [], a = e.trim().split(qE);
  let s = "";
  for (let l = a.length - 1; l >= 0; l -= 1) {
    const c = a[l], {
      modifiers: f,
      hasImportantModifier: u,
      baseClassName: h,
      maybePostfixModifierPosition: p
    } = n(c);
    let g = !!p, m = r(g ? h.substring(0, p) : h);
    if (!m) {
      if (!g) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      if (m = r(h), !m) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      g = !1;
    }
    const b = HE(f).join(":"), y = u ? b + rb : b, C = y + m;
    if (i.includes(C))
      continue;
    i.push(C);
    const _ = o(m, g);
    for (let M = 0; M < _.length; ++M) {
      const S = _[M];
      i.push(y + S);
    }
    s = c + (s.length > 0 ? " " + s : s);
  }
  return s;
};
function UE() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = ob(t)) && (r && (r += " "), r += n);
  return r;
}
const ob = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = ob(e[r])) && (n && (n += " "), n += t);
  return n;
};
function GE(e, ...t) {
  let n, r, o, i = a;
  function a(l) {
    const c = t.reduce((f, u) => u(f), e());
    return n = jE(c), r = n.cache.get, o = n.cache.set, i = s, s(l);
  }
  function s(l) {
    const c = r(l);
    if (c)
      return c;
    const f = zE(l, n);
    return o(l, f), f;
  }
  return function() {
    return i(UE.apply(null, arguments));
  };
}
const qe = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, ib = /^\[(?:([a-z-]+):)?(.+)\]$/i, YE = /^\d+\/\d+$/, ZE = /* @__PURE__ */ new Set(["px", "full", "screen"]), KE = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, XE = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, QE = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, JE = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, eT = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, zt = (e) => I3(e) || ZE.has(e) || YE.test(e), d0 = (e) => J3(e, "length", lT), I3 = (e) => !!e && !Number.isNaN(Number(e)), Bs = (e) => J3(e, "number", I3), Sn = (e) => !!e && Number.isInteger(Number(e)), tT = (e) => e.endsWith("%") && I3(e.slice(0, -1)), Y1 = (e) => ib.test(e), f0 = (e) => KE.test(e), nT = /* @__PURE__ */ new Set(["length", "size", "percentage"]), rT = (e) => J3(e, nT, ab), oT = (e) => J3(e, "position", ab), iT = /* @__PURE__ */ new Set(["image", "url"]), aT = (e) => J3(e, iT, uT), sT = (e) => J3(e, "", cT), Mn = () => !0, J3 = (e, t, n) => {
  const r = ib.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}, lT = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  XE.test(e) && !QE.test(e)
), ab = () => !1, cT = (e) => JE.test(e), uT = (e) => eT.test(e), dT = () => {
  const e = qe("colors"), t = qe("spacing"), n = qe("blur"), r = qe("brightness"), o = qe("borderColor"), i = qe("borderRadius"), a = qe("borderSpacing"), s = qe("borderWidth"), l = qe("contrast"), c = qe("grayscale"), f = qe("hueRotate"), u = qe("invert"), h = qe("gap"), p = qe("gradientColorStops"), g = qe("gradientColorStopPositions"), m = qe("inset"), b = qe("margin"), y = qe("opacity"), C = qe("padding"), _ = qe("saturate"), M = qe("scale"), S = qe("sepia"), k = qe("skew"), L = qe("space"), P = qe("translate"), I = () => ["auto", "contain", "none"], O = () => ["auto", "hidden", "clip", "visible", "scroll"], E = () => ["auto", Y1, t], B = () => [Y1, t], W = () => ["", zt, d0], F = () => ["auto", I3, Y1], z = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], D = () => ["solid", "dashed", "dotted", "double", "none"], Z = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], U = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], $ = () => ["", "0", Y1], q = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], K = () => [I3, Y1];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [Mn],
      spacing: [zt, d0],
      blur: ["none", "", f0, Y1],
      brightness: K(),
      borderColor: [e],
      borderRadius: ["none", "", "full", f0, Y1],
      borderSpacing: B(),
      borderWidth: W(),
      contrast: K(),
      grayscale: $(),
      hueRotate: K(),
      invert: $(),
      gap: B(),
      gradientColorStops: [e],
      gradientColorStopPositions: [tT, d0],
      inset: E(),
      margin: E(),
      opacity: K(),
      padding: B(),
      saturate: K(),
      scale: K(),
      sepia: $(),
      skew: K(),
      space: B(),
      translate: B()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", Y1]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [f0]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": q()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": q()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...z(), Y1]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: O()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": O()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": O()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: I()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": I()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": I()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [m]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [m]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [m]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [m]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [m]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [m]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [m]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [m]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [m]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Sn, Y1]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: E()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", Y1]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: $()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: $()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Sn, Y1]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Mn]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Sn, Y1]
        }, Y1]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": F()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": F()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Mn]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Sn, Y1]
        }, Y1]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": F()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": F()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", Y1]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", Y1]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [h]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [h]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [h]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...U()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...U(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...U(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [C]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [C]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [C]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [C]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [C]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [C]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [C]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [C]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [C]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [b]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [b]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [b]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [b]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [b]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [b]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [b]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [b]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [b]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [L]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [L]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", Y1, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [Y1, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [Y1, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [f0]
        }, f0]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [Y1, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [Y1, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [Y1, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [Y1, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", f0, d0]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Bs]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Mn]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", Y1]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", I3, Bs]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", zt, Y1]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", Y1]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", Y1]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [y]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [y]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...D(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", zt, d0]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", zt, Y1]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: B()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", Y1]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", Y1]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [y]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...z(), oT]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", rT]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, aT]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [g]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [g]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [g]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [p]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [y]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...D(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [y]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: D()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [o]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...D()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [zt, Y1]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [zt, d0]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: W()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [y]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [zt, d0]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", f0, sT]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Mn]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [y]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...Z(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": Z()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", f0, Y1]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [c]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [f]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [u]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [_]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [S]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [c]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [f]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [u]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [y]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [_]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [S]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [a]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [a]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [a]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", Y1]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: K()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", Y1]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: K()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", Y1]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [M]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [M]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [M]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Sn, Y1]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [P]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [P]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [k]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [k]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", Y1]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", Y1]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": B()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": B()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": B()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": B()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": B()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": B()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": B()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": B()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": B()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": B()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": B()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": B()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": B()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": B()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": B()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": B()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": B()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": B()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", Y1]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [zt, d0, Bs]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, fT = /* @__PURE__ */ GE(dT);
function e1(...e) {
  return fT(tb(e));
}
const Or = Z2(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full text-sm font-medium transition-colors duration-500 ease-in-out focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&:is(a)]:no-underline [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-slate-700 text-white shadow hover:bg-indigo-500",
        destructive: "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
        outline: "border border-slate-200 bg-white text-slate-700 hover:divide-indigo-500 hover:border-indigo-500 hover:text-indigo-500",
        secondary: "bg-slate-200 text-slate-700 shadow-sm hover:bg-indigo-200",
        ghost: "hover:bg-indigo-100 hover:text-accent-foreground",
        link: "text-slate-700 underline underline-offset-4 hover:text-indigo-500 [&:is(a)]:no-underline"
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-6 px-3 py-2 text-xs",
        lg: "h-10 px-8 py-2",
        icon: "size-9 p-2"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), dt = d.forwardRef(
  ({ className: e, variant: t, size: n, asChild: r = !1, ...o }, i) => /* @__PURE__ */ v(
    r ? Ai : "button",
    {
      ...o,
      className: e1(Or({ variant: t, size: n }), e),
      style: void 0,
      ref: i
    }
  )
);
dt.displayName = "LBButton";
function p1(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e?.(o), n === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
function hT(e, t) {
  const n = d.createContext(t), r = (i) => {
    const { children: a, ...s } = i, l = d.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ v(n.Provider, { value: l, children: a });
  };
  r.displayName = e + "Provider";
  function o(i) {
    const a = d.useContext(n);
    if (a) return a;
    if (t !== void 0) return t;
    throw new Error(`\`${i}\` must be used within \`${e}\``);
  }
  return [r, o];
}
function o2(e, t = []) {
  let n = [];
  function r(i, a) {
    const s = d.createContext(a), l = n.length;
    n = [...n, a];
    const c = (u) => {
      const { scope: h, children: p, ...g } = u, m = h?.[e]?.[l] || s, b = d.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ v(m.Provider, { value: b, children: p });
    };
    c.displayName = i + "Provider";
    function f(u, h) {
      const p = h?.[e]?.[l] || s, g = d.useContext(p);
      if (g) return g;
      if (a !== void 0) return a;
      throw new Error(`\`${u}\` must be used within \`${i}\``);
    }
    return [c, f];
  }
  const o = () => {
    const i = n.map((a) => d.createContext(a));
    return function(s) {
      const l = s?.[e] || i;
      return d.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    };
  };
  return o.scopeName = e, [r, pT(o, ...t)];
}
function pT(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const a = r.reduce((s, { useScope: l, scopeName: c }) => {
        const u = l(i)[`__scope${c}`];
        return { ...s, ...u };
      }, {});
      return d.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Ii(e) {
  const t = e + "CollectionProvider", [n, r] = o2(t), [o, i] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), a = (m) => {
    const { scope: b, children: y } = m, C = G.useRef(null), _ = G.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ v(o, { scope: b, itemMap: _, collectionRef: C, children: y });
  };
  a.displayName = t;
  const s = e + "CollectionSlot", l = /* @__PURE__ */ w0(s), c = G.forwardRef(
    (m, b) => {
      const { scope: y, children: C } = m, _ = i(s, y), M = F1(b, _.collectionRef);
      return /* @__PURE__ */ v(l, { ref: M, children: C });
    }
  );
  c.displayName = s;
  const f = e + "CollectionItemSlot", u = "data-radix-collection-item", h = /* @__PURE__ */ w0(f), p = G.forwardRef(
    (m, b) => {
      const { scope: y, children: C, ..._ } = m, M = G.useRef(null), S = F1(b, M), k = i(f, y);
      return G.useEffect(() => (k.itemMap.set(M, { ref: M, ..._ }), () => void k.itemMap.delete(M))), /* @__PURE__ */ v(h, { [u]: "", ref: S, children: C });
    }
  );
  p.displayName = f;
  function g(m) {
    const b = i(e + "CollectionConsumer", m);
    return G.useCallback(() => {
      const C = b.collectionRef.current;
      if (!C) return [];
      const _ = Array.from(C.querySelectorAll(`[${u}]`));
      return Array.from(b.itemMap.values()).sort(
        (k, L) => _.indexOf(k.ref.current) - _.indexOf(L.ref.current)
      );
    }, [b.collectionRef, b.itemMap]);
  }
  return [
    { Provider: a, Slot: c, ItemSlot: p },
    g,
    r
  ];
}
var r2 = globalThis?.document ? d.useLayoutEffect : () => {
}, mT = d[" useId ".trim().toString()] || (() => {
}), gT = 0;
function t2(e) {
  const [t, n] = d.useState(mT());
  return r2(() => {
    n((r) => r ?? String(gT++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
var vT = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], y1 = vT.reduce((e, t) => {
  const n = /* @__PURE__ */ w0(`Primitive.${t}`), r = d.forwardRef((o, i) => {
    const { asChild: a, ...s } = o, l = a ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ v(l, { ...s, ref: i });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function sb(e, t) {
  e && Pi.flushSync(() => e.dispatchEvent(t));
}
function u2(e) {
  const t = d.useRef(e);
  return d.useEffect(() => {
    t.current = e;
  }), d.useMemo(() => (...n) => t.current?.(...n), []);
}
var bT = d[" useInsertionEffect ".trim().toString()] || r2;
function E2({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: r
}) {
  const [o, i, a] = yT({
    defaultProp: t,
    onChange: n
  }), s = e !== void 0, l = s ? e : o;
  {
    const f = d.useRef(e !== void 0);
    d.useEffect(() => {
      const u = f.current;
      u !== s && console.warn(
        `${r} is changing from ${u ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), f.current = s;
    }, [s, r]);
  }
  const c = d.useCallback(
    (f) => {
      if (s) {
        const u = CT(f) ? f(e) : f;
        u !== e && a.current?.(u);
      } else
        i(f);
    },
    [s, e, i, a]
  );
  return [l, c];
}
function yT({
  defaultProp: e,
  onChange: t
}) {
  const [n, r] = d.useState(e), o = d.useRef(n), i = d.useRef(t);
  return bT(() => {
    i.current = t;
  }, [t]), d.useEffect(() => {
    o.current !== n && (i.current?.(n), o.current = n);
  }, [n, o]), [n, r, i];
}
function CT(e) {
  return typeof e == "function";
}
var wT = d.createContext(void 0);
function l3(e) {
  const t = d.useContext(wT);
  return e || t || "ltr";
}
var Fs = "rovingFocusGroup.onEntryFocus", _T = { bubbles: !1, cancelable: !0 }, Nr = "RovingFocusGroup", [B6, lb, xT] = Ii(Nr), [ST, en] = o2(
  Nr,
  [xT]
), [MT, kT] = ST(Nr), cb = d.forwardRef(
  (e, t) => /* @__PURE__ */ v(B6.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ v(B6.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ v(LT, { ...e, ref: t }) }) })
);
cb.displayName = Nr;
var LT = d.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: o = !1,
    dir: i,
    currentTabStopId: a,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: l,
    onEntryFocus: c,
    preventScrollOnEntryFocus: f = !1,
    ...u
  } = e, h = d.useRef(null), p = F1(t, h), g = l3(i), [m, b] = E2({
    prop: a,
    defaultProp: s ?? null,
    onChange: l,
    caller: Nr
  }), [y, C] = d.useState(!1), _ = u2(c), M = lb(n), S = d.useRef(!1), [k, L] = d.useState(0);
  return d.useEffect(() => {
    const P = h.current;
    if (P)
      return P.addEventListener(Fs, _), () => P.removeEventListener(Fs, _);
  }, [_]), /* @__PURE__ */ v(
    MT,
    {
      scope: n,
      orientation: r,
      dir: g,
      loop: o,
      currentTabStopId: m,
      onItemFocus: d.useCallback(
        (P) => b(P),
        [b]
      ),
      onItemShiftTab: d.useCallback(() => C(!0), []),
      onFocusableItemAdd: d.useCallback(
        () => L((P) => P + 1),
        []
      ),
      onFocusableItemRemove: d.useCallback(
        () => L((P) => P - 1),
        []
      ),
      children: /* @__PURE__ */ v(
        y1.div,
        {
          tabIndex: y || k === 0 ? -1 : 0,
          "data-orientation": r,
          ...u,
          ref: p,
          style: { outline: "none", ...e.style },
          onMouseDown: p1(e.onMouseDown, () => {
            S.current = !0;
          }),
          onFocus: p1(e.onFocus, (P) => {
            const I = !S.current;
            if (P.target === P.currentTarget && I && !y) {
              const O = new CustomEvent(Fs, _T);
              if (P.currentTarget.dispatchEvent(O), !O.defaultPrevented) {
                const E = M().filter((D) => D.focusable), B = E.find((D) => D.active), W = E.find((D) => D.id === m), z = [B, W, ...E].filter(
                  Boolean
                ).map((D) => D.ref.current);
                fb(z, f);
              }
            }
            S.current = !1;
          }),
          onBlur: p1(e.onBlur, () => C(!1))
        }
      )
    }
  );
}), ub = "RovingFocusGroupItem", db = d.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: o = !1,
      tabStopId: i,
      children: a,
      ...s
    } = e, l = t2(), c = i || l, f = kT(ub, n), u = f.currentTabStopId === c, h = lb(n), { onFocusableItemAdd: p, onFocusableItemRemove: g, currentTabStopId: m } = f;
    return d.useEffect(() => {
      if (r)
        return p(), () => g();
    }, [r, p, g]), /* @__PURE__ */ v(
      B6.ItemSlot,
      {
        scope: n,
        id: c,
        focusable: r,
        active: o,
        children: /* @__PURE__ */ v(
          y1.span,
          {
            tabIndex: u ? 0 : -1,
            "data-orientation": f.orientation,
            ...s,
            ref: t,
            onMouseDown: p1(e.onMouseDown, (b) => {
              r ? f.onItemFocus(c) : b.preventDefault();
            }),
            onFocus: p1(e.onFocus, () => f.onItemFocus(c)),
            onKeyDown: p1(e.onKeyDown, (b) => {
              if (b.key === "Tab" && b.shiftKey) {
                f.onItemShiftTab();
                return;
              }
              if (b.target !== b.currentTarget) return;
              const y = RT(b, f.orientation, f.dir);
              if (y !== void 0) {
                if (b.metaKey || b.ctrlKey || b.altKey || b.shiftKey) return;
                b.preventDefault();
                let _ = h().filter((M) => M.focusable).map((M) => M.ref.current);
                if (y === "last") _.reverse();
                else if (y === "prev" || y === "next") {
                  y === "prev" && _.reverse();
                  const M = _.indexOf(b.currentTarget);
                  _ = f.loop ? PT(_, M + 1) : _.slice(M + 1);
                }
                setTimeout(() => fb(_));
              }
            }),
            children: typeof a == "function" ? a({ isCurrentTabStop: u, hasTabStop: m != null }) : a
          }
        )
      }
    );
  }
);
db.displayName = ub;
var ET = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function TT(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function RT(e, t, n) {
  const r = TT(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return ET[r];
}
function fb(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function PT(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var Xu = cb, Qu = db;
function AT(e, t) {
  return d.useReducer((n, r) => t[n][r] ?? n, e);
}
var i2 = (e) => {
  const { present: t, children: n } = e, r = IT(t), o = typeof n == "function" ? n({ present: r.isPresent }) : d.Children.only(n), i = F1(r.ref, OT(o));
  return typeof n == "function" || r.isPresent ? d.cloneElement(o, { ref: i }) : null;
};
i2.displayName = "Presence";
function IT(e) {
  const [t, n] = d.useState(), r = d.useRef(null), o = d.useRef(e), i = d.useRef("none"), a = e ? "mounted" : "unmounted", [s, l] = AT(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return d.useEffect(() => {
    const c = go(r.current);
    i.current = s === "mounted" ? c : "none";
  }, [s]), r2(() => {
    const c = r.current, f = o.current;
    if (f !== e) {
      const h = i.current, p = go(c);
      e ? l("MOUNT") : p === "none" || c?.display === "none" ? l("UNMOUNT") : l(f && h !== p ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, l]), r2(() => {
    if (t) {
      let c;
      const f = t.ownerDocument.defaultView ?? window, u = (p) => {
        const m = go(r.current).includes(p.animationName);
        if (p.target === t && m && (l("ANIMATION_END"), !o.current)) {
          const b = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", c = f.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = b);
          });
        }
      }, h = (p) => {
        p.target === t && (i.current = go(r.current));
      };
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", u), t.addEventListener("animationend", u), () => {
        f.clearTimeout(c), t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", u), t.removeEventListener("animationend", u);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: d.useCallback((c) => {
      r.current = c ? getComputedStyle(c) : null, n(c);
    }, [])
  };
}
function go(e) {
  return e?.animationName || "none";
}
function OT(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Oi = "Tabs", [NT, M01] = o2(Oi, [
  en
]), hb = en(), [DT, Ju] = NT(Oi), pb = d.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: n,
      value: r,
      onValueChange: o,
      defaultValue: i,
      orientation: a = "horizontal",
      dir: s,
      activationMode: l = "automatic",
      ...c
    } = e, f = l3(s), [u, h] = E2({
      prop: r,
      onChange: o,
      defaultProp: i ?? "",
      caller: Oi
    });
    return /* @__PURE__ */ v(
      DT,
      {
        scope: n,
        baseId: t2(),
        value: u,
        onValueChange: h,
        orientation: a,
        dir: f,
        activationMode: l,
        children: /* @__PURE__ */ v(
          y1.div,
          {
            dir: f,
            "data-orientation": a,
            ...c,
            ref: t
          }
        )
      }
    );
  }
);
pb.displayName = Oi;
var mb = "TabsList", gb = d.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, loop: r = !0, ...o } = e, i = Ju(mb, n), a = hb(n);
    return /* @__PURE__ */ v(
      Xu,
      {
        asChild: !0,
        ...a,
        orientation: i.orientation,
        dir: i.dir,
        loop: r,
        children: /* @__PURE__ */ v(
          y1.div,
          {
            role: "tablist",
            "aria-orientation": i.orientation,
            ...o,
            ref: t
          }
        )
      }
    );
  }
);
gb.displayName = mb;
var vb = "TabsTrigger", bb = d.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: r, disabled: o = !1, ...i } = e, a = Ju(vb, n), s = hb(n), l = wb(a.baseId, r), c = _b(a.baseId, r), f = r === a.value;
    return /* @__PURE__ */ v(
      Qu,
      {
        asChild: !0,
        ...s,
        focusable: !o,
        active: f,
        children: /* @__PURE__ */ v(
          y1.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": f,
            "aria-controls": c,
            "data-state": f ? "active" : "inactive",
            "data-disabled": o ? "" : void 0,
            disabled: o,
            id: l,
            ...i,
            ref: t,
            onMouseDown: p1(e.onMouseDown, (u) => {
              !o && u.button === 0 && u.ctrlKey === !1 ? a.onValueChange(r) : u.preventDefault();
            }),
            onKeyDown: p1(e.onKeyDown, (u) => {
              [" ", "Enter"].includes(u.key) && a.onValueChange(r);
            }),
            onFocus: p1(e.onFocus, () => {
              const u = a.activationMode !== "manual";
              !f && !o && u && a.onValueChange(r);
            })
          }
        )
      }
    );
  }
);
bb.displayName = vb;
var yb = "TabsContent", Cb = d.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: r, forceMount: o, children: i, ...a } = e, s = Ju(yb, n), l = wb(s.baseId, r), c = _b(s.baseId, r), f = r === s.value, u = d.useRef(f);
    return d.useEffect(() => {
      const h = requestAnimationFrame(() => u.current = !1);
      return () => cancelAnimationFrame(h);
    }, []), /* @__PURE__ */ v(i2, { present: o || f, children: ({ present: h }) => /* @__PURE__ */ v(
      y1.div,
      {
        "data-state": f ? "active" : "inactive",
        "data-orientation": s.orientation,
        role: "tabpanel",
        "aria-labelledby": l,
        hidden: !h,
        id: c,
        tabIndex: 0,
        ...a,
        ref: t,
        style: {
          ...e.style,
          animationDuration: u.current ? "0s" : void 0
        },
        children: h && i
      }
    ) });
  }
);
Cb.displayName = yb;
function wb(e, t) {
  return `${e}-trigger-${t}`;
}
function _b(e, t) {
  return `${e}-content-${t}`;
}
var BT = pb, FT = gb, $T = bb, WT = Cb;
const VT = BT;
VT.displayName = "LBTabs";
const HT = x1(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  FT,
  {
    ref: n,
    ...t,
    style: void 0,
    className: e1(
      "inline-flex h-9 items-center justify-center gap-1 rounded-full border border-slate-200 bg-white px-0.75",
      e
    )
  }
));
HT.displayName = "LBTabsList";
const jT = x1(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  $T,
  {
    ref: n,
    ...t,
    style: void 0,
    className: e1(
      "inline-flex w-full items-center justify-center whitespace-nowrap rounded-full px-5 py-1 text-sm font-medium text-slate-700 ring-offset-background transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-slate-200 [&:is(a)]:no-underline",
      e
    )
  }
));
jT.displayName = "LBTabsTrigger";
const qT = x1(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  WT,
  {
    ref: n,
    ...t,
    style: void 0,
    className: e1(
      "mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      e
    )
  }
));
qT.displayName = "LBTabsContent";
function zT(e, t = globalThis?.document) {
  const n = u2(e);
  d.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var UT = "DismissableLayer", F6 = "dismissableLayer.update", GT = "dismissableLayer.pointerDownOutside", YT = "dismissableLayer.focusOutside", K7, xb = d.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), c3 = d.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: i,
      onInteractOutside: a,
      onDismiss: s,
      ...l
    } = e, c = d.useContext(xb), [f, u] = d.useState(null), h = f?.ownerDocument ?? globalThis?.document, [, p] = d.useState({}), g = F1(t, (L) => u(L)), m = Array.from(c.layers), [b] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), y = m.indexOf(b), C = f ? m.indexOf(f) : -1, _ = c.layersWithOutsidePointerEventsDisabled.size > 0, M = C >= y, S = XT((L) => {
      const P = L.target, I = [...c.branches].some((O) => O.contains(P));
      !M || I || (o?.(L), a?.(L), L.defaultPrevented || s?.());
    }, h), k = QT((L) => {
      const P = L.target;
      [...c.branches].some((O) => O.contains(P)) || (i?.(L), a?.(L), L.defaultPrevented || s?.());
    }, h);
    return zT((L) => {
      C === c.layers.size - 1 && (r?.(L), !L.defaultPrevented && s && (L.preventDefault(), s()));
    }, h), d.useEffect(() => {
      if (f)
        return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (K7 = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(f)), c.layers.add(f), X7(), () => {
          n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = K7);
        };
    }, [f, h, n, c]), d.useEffect(() => () => {
      f && (c.layers.delete(f), c.layersWithOutsidePointerEventsDisabled.delete(f), X7());
    }, [f, c]), d.useEffect(() => {
      const L = () => p({});
      return document.addEventListener(F6, L), () => document.removeEventListener(F6, L);
    }, []), /* @__PURE__ */ v(
      y1.div,
      {
        ...l,
        ref: g,
        style: {
          pointerEvents: _ ? M ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: p1(e.onFocusCapture, k.onFocusCapture),
        onBlurCapture: p1(e.onBlurCapture, k.onBlurCapture),
        onPointerDownCapture: p1(
          e.onPointerDownCapture,
          S.onPointerDownCapture
        )
      }
    );
  }
);
c3.displayName = UT;
var ZT = "DismissableLayerBranch", KT = d.forwardRef((e, t) => {
  const n = d.useContext(xb), r = d.useRef(null), o = F1(t, r);
  return d.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ v(y1.div, { ...e, ref: o });
});
KT.displayName = ZT;
function XT(e, t = globalThis?.document) {
  const n = u2(e), r = d.useRef(!1), o = d.useRef(() => {
  });
  return d.useEffect(() => {
    const i = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          Sb(
            GT,
            n,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = l, t.addEventListener("click", o.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function QT(e, t = globalThis?.document) {
  const n = u2(e), r = d.useRef(!1);
  return d.useEffect(() => {
    const o = (i) => {
      i.target && !r.current && Sb(YT, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function X7() {
  const e = new CustomEvent(F6);
  document.dispatchEvent(e);
}
function Sb(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? sb(o, i) : o.dispatchEvent(i);
}
var $s = 0;
function Ni() {
  d.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? Q7()), document.body.insertAdjacentElement("beforeend", e[1] ?? Q7()), $s++, () => {
      $s === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), $s--;
    };
  }, []);
}
function Q7() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Ws = "focusScope.autoFocusOnMount", Vs = "focusScope.autoFocusOnUnmount", J7 = { bubbles: !1, cancelable: !0 }, JT = "FocusScope", Dr = d.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i,
    ...a
  } = e, [s, l] = d.useState(null), c = u2(o), f = u2(i), u = d.useRef(null), h = F1(t, (m) => l(m)), p = d.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  d.useEffect(() => {
    if (r) {
      let m = function(_) {
        if (p.paused || !s) return;
        const M = _.target;
        s.contains(M) ? u.current = M : m0(u.current, { select: !0 });
      }, b = function(_) {
        if (p.paused || !s) return;
        const M = _.relatedTarget;
        M !== null && (s.contains(M) || m0(u.current, { select: !0 }));
      }, y = function(_) {
        if (document.activeElement === document.body)
          for (const S of _)
            S.removedNodes.length > 0 && m0(s);
      };
      document.addEventListener("focusin", m), document.addEventListener("focusout", b);
      const C = new MutationObserver(y);
      return s && C.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", m), document.removeEventListener("focusout", b), C.disconnect();
      };
    }
  }, [r, s, p.paused]), d.useEffect(() => {
    if (s) {
      tf.add(p);
      const m = document.activeElement;
      if (!s.contains(m)) {
        const y = new CustomEvent(Ws, J7);
        s.addEventListener(Ws, c), s.dispatchEvent(y), y.defaultPrevented || (eR(iR(Mb(s)), { select: !0 }), document.activeElement === m && m0(s));
      }
      return () => {
        s.removeEventListener(Ws, c), setTimeout(() => {
          const y = new CustomEvent(Vs, J7);
          s.addEventListener(Vs, f), s.dispatchEvent(y), y.defaultPrevented || m0(m ?? document.body, { select: !0 }), s.removeEventListener(Vs, f), tf.remove(p);
        }, 0);
      };
    }
  }, [s, c, f, p]);
  const g = d.useCallback(
    (m) => {
      if (!n && !r || p.paused) return;
      const b = m.key === "Tab" && !m.altKey && !m.ctrlKey && !m.metaKey, y = document.activeElement;
      if (b && y) {
        const C = m.currentTarget, [_, M] = tR(C);
        _ && M ? !m.shiftKey && y === M ? (m.preventDefault(), n && m0(_, { select: !0 })) : m.shiftKey && y === _ && (m.preventDefault(), n && m0(M, { select: !0 })) : y === C && m.preventDefault();
      }
    },
    [n, r, p.paused]
  );
  return /* @__PURE__ */ v(y1.div, { tabIndex: -1, ...a, ref: h, onKeyDown: g });
});
Dr.displayName = JT;
function eR(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (m0(r, { select: t }), document.activeElement !== n) return;
}
function tR(e) {
  const t = Mb(e), n = ef(t, e), r = ef(t.reverse(), e);
  return [n, r];
}
function Mb(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function ef(e, t) {
  for (const n of e)
    if (!nR(n, { upTo: t })) return n;
}
function nR(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function rR(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function m0(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && rR(e) && t && e.select();
  }
}
var tf = oR();
function oR() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && n?.pause(), e = nf(e, t), e.unshift(t);
    },
    remove(t) {
      e = nf(e, t), e[0]?.resume();
    }
  };
}
function nf(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function iR(e) {
  return e.filter((t) => t.tagName !== "A");
}
const aR = ["top", "right", "bottom", "left"], _0 = Math.min, U2 = Math.max, Go = Math.round, vo = Math.floor, Et = (e) => ({
  x: e,
  y: e
}), sR = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, lR = {
  start: "end",
  end: "start"
};
function $6(e, t, n) {
  return U2(e, _0(t, n));
}
function t0(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function n0(e) {
  return e.split("-")[0];
}
function tn(e) {
  return e.split("-")[1];
}
function e5(e) {
  return e === "x" ? "y" : "x";
}
function t5(e) {
  return e === "y" ? "height" : "width";
}
function x0(e) {
  return ["top", "bottom"].includes(n0(e)) ? "y" : "x";
}
function n5(e) {
  return e5(x0(e));
}
function cR(e, t, n) {
  n === void 0 && (n = !1);
  const r = tn(e), o = n5(e), i = t5(o);
  let a = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (a = Yo(a)), [a, Yo(a)];
}
function uR(e) {
  const t = Yo(e);
  return [W6(e), t, W6(t)];
}
function W6(e) {
  return e.replace(/start|end/g, (t) => lR[t]);
}
function dR(e, t, n) {
  const r = ["left", "right"], o = ["right", "left"], i = ["top", "bottom"], a = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? o : r : t ? r : o;
    case "left":
    case "right":
      return t ? i : a;
    default:
      return [];
  }
}
function fR(e, t, n, r) {
  const o = tn(e);
  let i = dR(n0(e), n === "start", r);
  return o && (i = i.map((a) => a + "-" + o), t && (i = i.concat(i.map(W6)))), i;
}
function Yo(e) {
  return e.replace(/left|right|bottom|top/g, (t) => sR[t]);
}
function hR(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function kb(e) {
  return typeof e != "number" ? hR(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Zo(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function rf(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const i = x0(t), a = n5(t), s = t5(a), l = n0(t), c = i === "y", f = r.x + r.width / 2 - o.width / 2, u = r.y + r.height / 2 - o.height / 2, h = r[s] / 2 - o[s] / 2;
  let p;
  switch (l) {
    case "top":
      p = {
        x: f,
        y: r.y - o.height
      };
      break;
    case "bottom":
      p = {
        x: f,
        y: r.y + r.height
      };
      break;
    case "right":
      p = {
        x: r.x + r.width,
        y: u
      };
      break;
    case "left":
      p = {
        x: r.x - o.width,
        y: u
      };
      break;
    default:
      p = {
        x: r.x,
        y: r.y
      };
  }
  switch (tn(t)) {
    case "start":
      p[a] -= h * (n && c ? -1 : 1);
      break;
    case "end":
      p[a] += h * (n && c ? -1 : 1);
      break;
  }
  return p;
}
const pR = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: a
  } = n, s = i.filter(Boolean), l = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let c = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: f,
    y: u
  } = rf(c, r, l), h = r, p = {}, g = 0;
  for (let m = 0; m < s.length; m++) {
    const {
      name: b,
      fn: y
    } = s[m], {
      x: C,
      y: _,
      data: M,
      reset: S
    } = await y({
      x: f,
      y: u,
      initialPlacement: r,
      placement: h,
      strategy: o,
      middlewareData: p,
      rects: c,
      platform: a,
      elements: {
        reference: e,
        floating: t
      }
    });
    f = C ?? f, u = _ ?? u, p = {
      ...p,
      [b]: {
        ...p[b],
        ...M
      }
    }, S && g <= 50 && (g++, typeof S == "object" && (S.placement && (h = S.placement), S.rects && (c = S.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : S.rects), {
      x: f,
      y: u
    } = rf(c, h, l)), m = -1);
  }
  return {
    x: f,
    y: u,
    placement: h,
    strategy: o,
    middlewareData: p
  };
};
async function ar(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: i,
    rects: a,
    elements: s,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: f = "viewport",
    elementContext: u = "floating",
    altBoundary: h = !1,
    padding: p = 0
  } = t0(t, e), g = kb(p), b = s[h ? u === "floating" ? "reference" : "floating" : u], y = Zo(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(b))) == null || n ? b : b.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(s.floating)),
    boundary: c,
    rootBoundary: f,
    strategy: l
  })), C = u === "floating" ? {
    x: r,
    y: o,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, _ = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(s.floating)), M = await (i.isElement == null ? void 0 : i.isElement(_)) ? await (i.getScale == null ? void 0 : i.getScale(_)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = Zo(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: C,
    offsetParent: _,
    strategy: l
  }) : C);
  return {
    top: (y.top - S.top + g.top) / M.y,
    bottom: (S.bottom - y.bottom + g.bottom) / M.y,
    left: (y.left - S.left + g.left) / M.x,
    right: (S.right - y.right + g.right) / M.x
  };
}
const mR = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: i,
      platform: a,
      elements: s,
      middlewareData: l
    } = t, {
      element: c,
      padding: f = 0
    } = t0(e, t) || {};
    if (c == null)
      return {};
    const u = kb(f), h = {
      x: n,
      y: r
    }, p = n5(o), g = t5(p), m = await a.getDimensions(c), b = p === "y", y = b ? "top" : "left", C = b ? "bottom" : "right", _ = b ? "clientHeight" : "clientWidth", M = i.reference[g] + i.reference[p] - h[p] - i.floating[g], S = h[p] - i.reference[p], k = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(c));
    let L = k ? k[_] : 0;
    (!L || !await (a.isElement == null ? void 0 : a.isElement(k))) && (L = s.floating[_] || i.floating[g]);
    const P = M / 2 - S / 2, I = L / 2 - m[g] / 2 - 1, O = _0(u[y], I), E = _0(u[C], I), B = O, W = L - m[g] - E, F = L / 2 - m[g] / 2 + P, z = $6(B, F, W), D = !l.arrow && tn(o) != null && F !== z && i.reference[g] / 2 - (F < B ? O : E) - m[g] / 2 < 0, Z = D ? F < B ? F - B : F - W : 0;
    return {
      [p]: h[p] + Z,
      data: {
        [p]: z,
        centerOffset: F - z - Z,
        ...D && {
          alignmentOffset: Z
        }
      },
      reset: D
    };
  }
}), gR = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: i,
        rects: a,
        initialPlacement: s,
        platform: l,
        elements: c
      } = t, {
        mainAxis: f = !0,
        crossAxis: u = !0,
        fallbackPlacements: h,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: g = "none",
        flipAlignment: m = !0,
        ...b
      } = t0(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const y = n0(o), C = x0(s), _ = n0(s) === s, M = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), S = h || (_ || !m ? [Yo(s)] : uR(s)), k = g !== "none";
      !h && k && S.push(...fR(s, m, g, M));
      const L = [s, ...S], P = await ar(t, b), I = [];
      let O = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (f && I.push(P[y]), u) {
        const F = cR(o, a, M);
        I.push(P[F[0]], P[F[1]]);
      }
      if (O = [...O, {
        placement: o,
        overflows: I
      }], !I.every((F) => F <= 0)) {
        var E, B;
        const F = (((E = i.flip) == null ? void 0 : E.index) || 0) + 1, z = L[F];
        if (z)
          return {
            data: {
              index: F,
              overflows: O
            },
            reset: {
              placement: z
            }
          };
        let D = (B = O.filter((Z) => Z.overflows[0] <= 0).sort((Z, U) => Z.overflows[1] - U.overflows[1])[0]) == null ? void 0 : B.placement;
        if (!D)
          switch (p) {
            case "bestFit": {
              var W;
              const Z = (W = O.filter((U) => {
                if (k) {
                  const $ = x0(U.placement);
                  return $ === C || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  $ === "y";
                }
                return !0;
              }).map((U) => [U.placement, U.overflows.filter(($) => $ > 0).reduce(($, q) => $ + q, 0)]).sort((U, $) => U[1] - $[1])[0]) == null ? void 0 : W[0];
              Z && (D = Z);
              break;
            }
            case "initialPlacement":
              D = s;
              break;
          }
        if (o !== D)
          return {
            reset: {
              placement: D
            }
          };
      }
      return {};
    }
  };
};
function of(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function af(e) {
  return aR.some((t) => e[t] >= 0);
}
const vR = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...o
      } = t0(e, t);
      switch (r) {
        case "referenceHidden": {
          const i = await ar(t, {
            ...o,
            elementContext: "reference"
          }), a = of(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: a,
              referenceHidden: af(a)
            }
          };
        }
        case "escaped": {
          const i = await ar(t, {
            ...o,
            altBoundary: !0
          }), a = of(i, n.floating);
          return {
            data: {
              escapedOffsets: a,
              escaped: af(a)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function bR(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), a = n0(n), s = tn(n), l = x0(n) === "y", c = ["left", "top"].includes(a) ? -1 : 1, f = i && l ? -1 : 1, u = t0(t, e);
  let {
    mainAxis: h,
    crossAxis: p,
    alignmentAxis: g
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: u.mainAxis || 0,
    crossAxis: u.crossAxis || 0,
    alignmentAxis: u.alignmentAxis
  };
  return s && typeof g == "number" && (p = s === "end" ? g * -1 : g), l ? {
    x: p * f,
    y: h * c
  } : {
    x: h * c,
    y: p * f
  };
}
const yR = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: i,
        placement: a,
        middlewareData: s
      } = t, l = await bR(t, e);
      return a === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: o + l.x,
        y: i + l.y,
        data: {
          ...l,
          placement: a
        }
      };
    }
  };
}, CR = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: i = !0,
        crossAxis: a = !1,
        limiter: s = {
          fn: (b) => {
            let {
              x: y,
              y: C
            } = b;
            return {
              x: y,
              y: C
            };
          }
        },
        ...l
      } = t0(e, t), c = {
        x: n,
        y: r
      }, f = await ar(t, l), u = x0(n0(o)), h = e5(u);
      let p = c[h], g = c[u];
      if (i) {
        const b = h === "y" ? "top" : "left", y = h === "y" ? "bottom" : "right", C = p + f[b], _ = p - f[y];
        p = $6(C, p, _);
      }
      if (a) {
        const b = u === "y" ? "top" : "left", y = u === "y" ? "bottom" : "right", C = g + f[b], _ = g - f[y];
        g = $6(C, g, _);
      }
      const m = s.fn({
        ...t,
        [h]: p,
        [u]: g
      });
      return {
        ...m,
        data: {
          x: m.x - n,
          y: m.y - r,
          enabled: {
            [h]: i,
            [u]: a
          }
        }
      };
    }
  };
}, wR = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: i,
        middlewareData: a
      } = t, {
        offset: s = 0,
        mainAxis: l = !0,
        crossAxis: c = !0
      } = t0(e, t), f = {
        x: n,
        y: r
      }, u = x0(o), h = e5(u);
      let p = f[h], g = f[u];
      const m = t0(s, t), b = typeof m == "number" ? {
        mainAxis: m,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...m
      };
      if (l) {
        const _ = h === "y" ? "height" : "width", M = i.reference[h] - i.floating[_] + b.mainAxis, S = i.reference[h] + i.reference[_] - b.mainAxis;
        p < M ? p = M : p > S && (p = S);
      }
      if (c) {
        var y, C;
        const _ = h === "y" ? "width" : "height", M = ["top", "left"].includes(n0(o)), S = i.reference[u] - i.floating[_] + (M && ((y = a.offset) == null ? void 0 : y[u]) || 0) + (M ? 0 : b.crossAxis), k = i.reference[u] + i.reference[_] + (M ? 0 : ((C = a.offset) == null ? void 0 : C[u]) || 0) - (M ? b.crossAxis : 0);
        g < S ? g = S : g > k && (g = k);
      }
      return {
        [h]: p,
        [u]: g
      };
    }
  };
}, _R = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        rects: i,
        platform: a,
        elements: s
      } = t, {
        apply: l = () => {
        },
        ...c
      } = t0(e, t), f = await ar(t, c), u = n0(o), h = tn(o), p = x0(o) === "y", {
        width: g,
        height: m
      } = i.floating;
      let b, y;
      u === "top" || u === "bottom" ? (b = u, y = h === (await (a.isRTL == null ? void 0 : a.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (y = u, b = h === "end" ? "top" : "bottom");
      const C = m - f.top - f.bottom, _ = g - f.left - f.right, M = _0(m - f[b], C), S = _0(g - f[y], _), k = !t.middlewareData.shift;
      let L = M, P = S;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (P = _), (r = t.middlewareData.shift) != null && r.enabled.y && (L = C), k && !h) {
        const O = U2(f.left, 0), E = U2(f.right, 0), B = U2(f.top, 0), W = U2(f.bottom, 0);
        p ? P = g - 2 * (O !== 0 || E !== 0 ? O + E : U2(f.left, f.right)) : L = m - 2 * (B !== 0 || W !== 0 ? B + W : U2(f.top, f.bottom));
      }
      await l({
        ...t,
        availableWidth: P,
        availableHeight: L
      });
      const I = await a.getDimensions(s.floating);
      return g !== I.width || m !== I.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Di() {
  return typeof window < "u";
}
function nn(e) {
  return Lb(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function G2(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Dt(e) {
  var t;
  return (t = (Lb(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Lb(e) {
  return Di() ? e instanceof Node || e instanceof G2(e).Node : !1;
}
function mt(e) {
  return Di() ? e instanceof Element || e instanceof G2(e).Element : !1;
}
function Pt(e) {
  return Di() ? e instanceof HTMLElement || e instanceof G2(e).HTMLElement : !1;
}
function sf(e) {
  return !Di() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof G2(e).ShadowRoot;
}
function Br(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = gt(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function xR(e) {
  return ["table", "td", "th"].includes(nn(e));
}
function Bi(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function r5(e) {
  const t = o5(), n = mt(e) ? gt(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function SR(e) {
  let t = S0(e);
  for (; Pt(t) && !V3(t); ) {
    if (r5(t))
      return t;
    if (Bi(t))
      return null;
    t = S0(t);
  }
  return null;
}
function o5() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function V3(e) {
  return ["html", "body", "#document"].includes(nn(e));
}
function gt(e) {
  return G2(e).getComputedStyle(e);
}
function Fi(e) {
  return mt(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function S0(e) {
  if (nn(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    sf(e) && e.host || // Fallback.
    Dt(e)
  );
  return sf(t) ? t.host : t;
}
function Eb(e) {
  const t = S0(e);
  return V3(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Pt(t) && Br(t) ? t : Eb(t);
}
function sr(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = Eb(e), i = o === ((r = e.ownerDocument) == null ? void 0 : r.body), a = G2(o);
  if (i) {
    const s = V6(a);
    return t.concat(a, a.visualViewport || [], Br(o) ? o : [], s && n ? sr(s) : []);
  }
  return t.concat(o, sr(o, [], n));
}
function V6(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Tb(e) {
  const t = gt(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = Pt(e), i = o ? e.offsetWidth : n, a = o ? e.offsetHeight : r, s = Go(n) !== i || Go(r) !== a;
  return s && (n = i, r = a), {
    width: n,
    height: r,
    $: s
  };
}
function i5(e) {
  return mt(e) ? e : e.contextElement;
}
function O3(e) {
  const t = i5(e);
  if (!Pt(t))
    return Et(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = Tb(t);
  let a = (i ? Go(n.width) : n.width) / r, s = (i ? Go(n.height) : n.height) / o;
  return (!a || !Number.isFinite(a)) && (a = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: a,
    y: s
  };
}
const MR = /* @__PURE__ */ Et(0);
function Rb(e) {
  const t = G2(e);
  return !o5() || !t.visualViewport ? MR : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function kR(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== G2(e) ? !1 : t;
}
function K0(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), i = i5(e);
  let a = Et(1);
  t && (r ? mt(r) && (a = O3(r)) : a = O3(e));
  const s = kR(i, n, r) ? Rb(i) : Et(0);
  let l = (o.left + s.x) / a.x, c = (o.top + s.y) / a.y, f = o.width / a.x, u = o.height / a.y;
  if (i) {
    const h = G2(i), p = r && mt(r) ? G2(r) : r;
    let g = h, m = V6(g);
    for (; m && r && p !== g; ) {
      const b = O3(m), y = m.getBoundingClientRect(), C = gt(m), _ = y.left + (m.clientLeft + parseFloat(C.paddingLeft)) * b.x, M = y.top + (m.clientTop + parseFloat(C.paddingTop)) * b.y;
      l *= b.x, c *= b.y, f *= b.x, u *= b.y, l += _, c += M, g = G2(m), m = V6(g);
    }
  }
  return Zo({
    width: f,
    height: u,
    x: l,
    y: c
  });
}
function a5(e, t) {
  const n = Fi(e).scrollLeft;
  return t ? t.left + n : K0(Dt(e)).left + n;
}
function Pb(e, t, n) {
  n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), o = r.left + t.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    a5(e, r)
  )), i = r.top + t.scrollTop;
  return {
    x: o,
    y: i
  };
}
function LR(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const i = o === "fixed", a = Dt(r), s = t ? Bi(t.floating) : !1;
  if (r === a || s && i)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = Et(1);
  const f = Et(0), u = Pt(r);
  if ((u || !u && !i) && ((nn(r) !== "body" || Br(a)) && (l = Fi(r)), Pt(r))) {
    const p = K0(r);
    c = O3(r), f.x = p.x + r.clientLeft, f.y = p.y + r.clientTop;
  }
  const h = a && !u && !i ? Pb(a, l, !0) : Et(0);
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - l.scrollLeft * c.x + f.x + h.x,
    y: n.y * c.y - l.scrollTop * c.y + f.y + h.y
  };
}
function ER(e) {
  return Array.from(e.getClientRects());
}
function TR(e) {
  const t = Dt(e), n = Fi(e), r = e.ownerDocument.body, o = U2(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = U2(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let a = -n.scrollLeft + a5(e);
  const s = -n.scrollTop;
  return gt(r).direction === "rtl" && (a += U2(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: i,
    x: a,
    y: s
  };
}
function RR(e, t) {
  const n = G2(e), r = Dt(e), o = n.visualViewport;
  let i = r.clientWidth, a = r.clientHeight, s = 0, l = 0;
  if (o) {
    i = o.width, a = o.height;
    const c = o5();
    (!c || c && t === "fixed") && (s = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: i,
    height: a,
    x: s,
    y: l
  };
}
function PR(e, t) {
  const n = K0(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, i = Pt(e) ? O3(e) : Et(1), a = e.clientWidth * i.x, s = e.clientHeight * i.y, l = o * i.x, c = r * i.y;
  return {
    width: a,
    height: s,
    x: l,
    y: c
  };
}
function lf(e, t, n) {
  let r;
  if (t === "viewport")
    r = RR(e, n);
  else if (t === "document")
    r = TR(Dt(e));
  else if (mt(t))
    r = PR(t, n);
  else {
    const o = Rb(e);
    r = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return Zo(r);
}
function Ab(e, t) {
  const n = S0(e);
  return n === t || !mt(n) || V3(n) ? !1 : gt(n).position === "fixed" || Ab(n, t);
}
function AR(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = sr(e, [], !1).filter((s) => mt(s) && nn(s) !== "body"), o = null;
  const i = gt(e).position === "fixed";
  let a = i ? S0(e) : e;
  for (; mt(a) && !V3(a); ) {
    const s = gt(a), l = r5(a);
    !l && s.position === "fixed" && (o = null), (i ? !l && !o : !l && s.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || Br(a) && !l && Ab(e, a)) ? r = r.filter((f) => f !== a) : o = s, a = S0(a);
  }
  return t.set(e, r), r;
}
function IR(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const a = [...n === "clippingAncestors" ? Bi(t) ? [] : AR(t, this._c) : [].concat(n), r], s = a[0], l = a.reduce((c, f) => {
    const u = lf(t, f, o);
    return c.top = U2(u.top, c.top), c.right = _0(u.right, c.right), c.bottom = _0(u.bottom, c.bottom), c.left = U2(u.left, c.left), c;
  }, lf(t, s, o));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function OR(e) {
  const {
    width: t,
    height: n
  } = Tb(e);
  return {
    width: t,
    height: n
  };
}
function NR(e, t, n) {
  const r = Pt(t), o = Dt(t), i = n === "fixed", a = K0(e, !0, i, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Et(0);
  if (r || !r && !i)
    if ((nn(t) !== "body" || Br(o)) && (s = Fi(t)), r) {
      const h = K0(t, !0, i, t);
      l.x = h.x + t.clientLeft, l.y = h.y + t.clientTop;
    } else o && (l.x = a5(o));
  const c = o && !r && !i ? Pb(o, s) : Et(0), f = a.left + s.scrollLeft - l.x - c.x, u = a.top + s.scrollTop - l.y - c.y;
  return {
    x: f,
    y: u,
    width: a.width,
    height: a.height
  };
}
function Hs(e) {
  return gt(e).position === "static";
}
function cf(e, t) {
  if (!Pt(e) || gt(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return Dt(e) === n && (n = n.ownerDocument.body), n;
}
function Ib(e, t) {
  const n = G2(e);
  if (Bi(e))
    return n;
  if (!Pt(e)) {
    let o = S0(e);
    for (; o && !V3(o); ) {
      if (mt(o) && !Hs(o))
        return o;
      o = S0(o);
    }
    return n;
  }
  let r = cf(e, t);
  for (; r && xR(r) && Hs(r); )
    r = cf(r, t);
  return r && V3(r) && Hs(r) && !r5(r) ? n : r || SR(e) || n;
}
const DR = async function(e) {
  const t = this.getOffsetParent || Ib, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: NR(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function BR(e) {
  return gt(e).direction === "rtl";
}
const FR = {
  convertOffsetParentRelativeRectToViewportRelativeRect: LR,
  getDocumentElement: Dt,
  getClippingRect: IR,
  getOffsetParent: Ib,
  getElementRects: DR,
  getClientRects: ER,
  getDimensions: OR,
  getScale: O3,
  isElement: mt,
  isRTL: BR
};
function Ob(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function $R(e, t) {
  let n = null, r;
  const o = Dt(e);
  function i() {
    var s;
    clearTimeout(r), (s = n) == null || s.disconnect(), n = null;
  }
  function a(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), i();
    const c = e.getBoundingClientRect(), {
      left: f,
      top: u,
      width: h,
      height: p
    } = c;
    if (s || t(), !h || !p)
      return;
    const g = vo(u), m = vo(o.clientWidth - (f + h)), b = vo(o.clientHeight - (u + p)), y = vo(f), _ = {
      rootMargin: -g + "px " + -m + "px " + -b + "px " + -y + "px",
      threshold: U2(0, _0(1, l)) || 1
    };
    let M = !0;
    function S(k) {
      const L = k[0].intersectionRatio;
      if (L !== l) {
        if (!M)
          return a();
        L ? a(!1, L) : r = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      L === 1 && !Ob(c, e.getBoundingClientRect()) && a(), M = !1;
    }
    try {
      n = new IntersectionObserver(S, {
        ..._,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(S, _);
    }
    n.observe(e);
  }
  return a(!0), i;
}
function WR(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, c = i5(e), f = o || i ? [...c ? sr(c) : [], ...sr(t)] : [];
  f.forEach((y) => {
    o && y.addEventListener("scroll", n, {
      passive: !0
    }), i && y.addEventListener("resize", n);
  });
  const u = c && s ? $R(c, n) : null;
  let h = -1, p = null;
  a && (p = new ResizeObserver((y) => {
    let [C] = y;
    C && C.target === c && p && (p.unobserve(t), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var _;
      (_ = p) == null || _.observe(t);
    })), n();
  }), c && !l && p.observe(c), p.observe(t));
  let g, m = l ? K0(e) : null;
  l && b();
  function b() {
    const y = K0(e);
    m && !Ob(m, y) && n(), m = y, g = requestAnimationFrame(b);
  }
  return n(), () => {
    var y;
    f.forEach((C) => {
      o && C.removeEventListener("scroll", n), i && C.removeEventListener("resize", n);
    }), u?.(), (y = p) == null || y.disconnect(), p = null, l && cancelAnimationFrame(g);
  };
}
const VR = yR, HR = CR, jR = gR, qR = _R, zR = vR, uf = mR, UR = wR, GR = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: FR,
    ...n
  }, i = {
    ...o.platform,
    _c: r
  };
  return pR(e, t, {
    ...o,
    platform: i
  });
};
var Wo = typeof document < "u" ? Zu : Te;
function Ko(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!Ko(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = o[r];
      if (!(i === "_owner" && e.$$typeof) && !Ko(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Nb(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function df(e, t) {
  const n = Nb(e);
  return Math.round(t * n) / n;
}
function js(e) {
  const t = d.useRef(e);
  return Wo(() => {
    t.current = e;
  }), t;
}
function YR(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: i,
      floating: a
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: c
  } = e, [f, u] = d.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [h, p] = d.useState(r);
  Ko(h, r) || p(r);
  const [g, m] = d.useState(null), [b, y] = d.useState(null), C = d.useCallback((U) => {
    U !== k.current && (k.current = U, m(U));
  }, []), _ = d.useCallback((U) => {
    U !== L.current && (L.current = U, y(U));
  }, []), M = i || g, S = a || b, k = d.useRef(null), L = d.useRef(null), P = d.useRef(f), I = l != null, O = js(l), E = js(o), B = js(c), W = d.useCallback(() => {
    if (!k.current || !L.current)
      return;
    const U = {
      placement: t,
      strategy: n,
      middleware: h
    };
    E.current && (U.platform = E.current), GR(k.current, L.current, U).then(($) => {
      const q = {
        ...$,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: B.current !== !1
      };
      F.current && !Ko(P.current, q) && (P.current = q, Pi.flushSync(() => {
        u(q);
      }));
    });
  }, [h, t, n, E, B]);
  Wo(() => {
    c === !1 && P.current.isPositioned && (P.current.isPositioned = !1, u((U) => ({
      ...U,
      isPositioned: !1
    })));
  }, [c]);
  const F = d.useRef(!1);
  Wo(() => (F.current = !0, () => {
    F.current = !1;
  }), []), Wo(() => {
    if (M && (k.current = M), S && (L.current = S), M && S) {
      if (O.current)
        return O.current(M, S, W);
      W();
    }
  }, [M, S, W, O, I]);
  const z = d.useMemo(() => ({
    reference: k,
    floating: L,
    setReference: C,
    setFloating: _
  }), [C, _]), D = d.useMemo(() => ({
    reference: M,
    floating: S
  }), [M, S]), Z = d.useMemo(() => {
    const U = {
      position: n,
      left: 0,
      top: 0
    };
    if (!D.floating)
      return U;
    const $ = df(D.floating, f.x), q = df(D.floating, f.y);
    return s ? {
      ...U,
      transform: "translate(" + $ + "px, " + q + "px)",
      ...Nb(D.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: $,
      top: q
    };
  }, [n, s, D.floating, f.x, f.y]);
  return d.useMemo(() => ({
    ...f,
    update: W,
    refs: z,
    elements: D,
    floatingStyles: Z
  }), [f, W, z, D, Z]);
}
const ZR = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? uf({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? uf({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
}, KR = (e, t) => ({
  ...VR(e),
  options: [e, t]
}), XR = (e, t) => ({
  ...HR(e),
  options: [e, t]
}), QR = (e, t) => ({
  ...UR(e),
  options: [e, t]
}), JR = (e, t) => ({
  ...jR(e),
  options: [e, t]
}), eP = (e, t) => ({
  ...qR(e),
  options: [e, t]
}), tP = (e, t) => ({
  ...zR(e),
  options: [e, t]
}), nP = (e, t) => ({
  ...ZR(e),
  options: [e, t]
});
var rP = "Arrow", Db = d.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...i } = e;
  return /* @__PURE__ */ v(
    y1.svg,
    {
      ...i,
      ref: t,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ v("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Db.displayName = rP;
var oP = Db;
function $i(e) {
  const [t, n] = d.useState(void 0);
  return r2(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const i = o[0];
        let a, s;
        if ("borderBoxSize" in i) {
          const l = i.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          a = c.inlineSize, s = c.blockSize;
        } else
          a = e.offsetWidth, s = e.offsetHeight;
        n({ width: a, height: s });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var s5 = "Popper", [Bb, Bt] = o2(s5), [iP, Fb] = Bb(s5), $b = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = d.useState(null);
  return /* @__PURE__ */ v(iP, { scope: t, anchor: r, onAnchorChange: o, children: n });
};
$b.displayName = s5;
var Wb = "PopperAnchor", Vb = d.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...o } = e, i = Fb(Wb, n), a = d.useRef(null), s = F1(t, a);
    return d.useEffect(() => {
      i.onAnchorChange(r?.current || a.current);
    }), r ? null : /* @__PURE__ */ v(y1.div, { ...o, ref: s });
  }
);
Vb.displayName = Wb;
var l5 = "PopperContent", [aP, sP] = Bb(l5), Hb = d.forwardRef(
  (e, t) => {
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: o = 0,
      align: i = "center",
      alignOffset: a = 0,
      arrowPadding: s = 0,
      avoidCollisions: l = !0,
      collisionBoundary: c = [],
      collisionPadding: f = 0,
      sticky: u = "partial",
      hideWhenDetached: h = !1,
      updatePositionStrategy: p = "optimized",
      onPlaced: g,
      ...m
    } = e, b = Fb(l5, n), [y, C] = d.useState(null), _ = F1(t, (Y) => C(Y)), [M, S] = d.useState(null), k = $i(M), L = k?.width ?? 0, P = k?.height ?? 0, I = r + (i !== "center" ? "-" + i : ""), O = typeof f == "number" ? f : { top: 0, right: 0, bottom: 0, left: 0, ...f }, E = Array.isArray(c) ? c : [c], B = E.length > 0, W = {
      padding: O,
      boundary: E.filter(cP),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: B
    }, { refs: F, floatingStyles: z, placement: D, isPositioned: Z, middlewareData: U } = YR({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: I,
      whileElementsMounted: (...Y) => WR(...Y, {
        animationFrame: p === "always"
      }),
      elements: {
        reference: b.anchor
      },
      middleware: [
        KR({ mainAxis: o + P, alignmentAxis: a }),
        l && XR({
          mainAxis: !0,
          crossAxis: !1,
          limiter: u === "partial" ? QR() : void 0,
          ...W
        }),
        l && JR({ ...W }),
        eP({
          ...W,
          apply: ({ elements: Y, rects: Q, availableWidth: N, availableHeight: j }) => {
            const { width: t1, height: T } = Q.reference, u1 = Y.floating.style;
            u1.setProperty("--radix-popper-available-width", `${N}px`), u1.setProperty("--radix-popper-available-height", `${j}px`), u1.setProperty("--radix-popper-anchor-width", `${t1}px`), u1.setProperty("--radix-popper-anchor-height", `${T}px`);
          }
        }),
        M && nP({ element: M, padding: s }),
        uP({ arrowWidth: L, arrowHeight: P }),
        h && tP({ strategy: "referenceHidden", ...W })
      ]
    }), [$, q] = zb(D), K = u2(g);
    r2(() => {
      Z && K?.();
    }, [Z, K]);
    const V = U.arrow?.x, n1 = U.arrow?.y, o1 = U.arrow?.centerOffset !== 0, [r1, X] = d.useState();
    return r2(() => {
      y && X(window.getComputedStyle(y).zIndex);
    }, [y]), /* @__PURE__ */ v(
      "div",
      {
        ref: F.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...z,
          transform: Z ? z.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: r1,
          "--radix-popper-transform-origin": [
            U.transformOrigin?.x,
            U.transformOrigin?.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...U.hide?.referenceHidden && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ v(
          aP,
          {
            scope: n,
            placedSide: $,
            onArrowChange: S,
            arrowX: V,
            arrowY: n1,
            shouldHideArrow: o1,
            children: /* @__PURE__ */ v(
              y1.div,
              {
                "data-side": $,
                "data-align": q,
                ...m,
                ref: _,
                style: {
                  ...m.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: Z ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
Hb.displayName = l5;
var jb = "PopperArrow", lP = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, qb = d.forwardRef(function(t, n) {
  const { __scopePopper: r, ...o } = t, i = sP(jb, r), a = lP[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ v(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [a]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ v(
          oP,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
qb.displayName = jb;
function cP(e) {
  return e !== null;
}
var uP = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    const { placement: n, rects: r, middlewareData: o } = t, a = o.arrow?.centerOffset !== 0, s = a ? 0 : e.arrowWidth, l = a ? 0 : e.arrowHeight, [c, f] = zb(n), u = { start: "0%", center: "50%", end: "100%" }[f], h = (o.arrow?.x ?? 0) + s / 2, p = (o.arrow?.y ?? 0) + l / 2;
    let g = "", m = "";
    return c === "bottom" ? (g = a ? u : `${h}px`, m = `${-l}px`) : c === "top" ? (g = a ? u : `${h}px`, m = `${r.floating.height + l}px`) : c === "right" ? (g = `${-l}px`, m = a ? u : `${p}px`) : c === "left" && (g = `${r.floating.width + l}px`, m = a ? u : `${p}px`), { data: { x: g, y: m } };
  }
});
function zb(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var rn = $b, on = Vb, Fr = Hb, $r = qb, dP = "Portal", an = d.forwardRef((e, t) => {
  const { container: n, ...r } = e, [o, i] = d.useState(!1);
  r2(() => i(!0), []);
  const a = n || o && globalThis?.document?.body;
  return a ? Xv.createPortal(/* @__PURE__ */ v(y1.div, { ...r, ref: t }), a) : null;
});
an.displayName = dP;
var fP = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, b3 = /* @__PURE__ */ new WeakMap(), bo = /* @__PURE__ */ new WeakMap(), yo = {}, qs = 0, Ub = function(e) {
  return e && (e.host || Ub(e.parentNode));
}, hP = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = Ub(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, pP = function(e, t, n, r) {
  var o = hP(t, Array.isArray(e) ? e : [e]);
  yo[n] || (yo[n] = /* @__PURE__ */ new WeakMap());
  var i = yo[n], a = [], s = /* @__PURE__ */ new Set(), l = new Set(o), c = function(u) {
    !u || s.has(u) || (s.add(u), c(u.parentNode));
  };
  o.forEach(c);
  var f = function(u) {
    !u || l.has(u) || Array.prototype.forEach.call(u.children, function(h) {
      if (s.has(h))
        f(h);
      else
        try {
          var p = h.getAttribute(r), g = p !== null && p !== "false", m = (b3.get(h) || 0) + 1, b = (i.get(h) || 0) + 1;
          b3.set(h, m), i.set(h, b), a.push(h), m === 1 && g && bo.set(h, !0), b === 1 && h.setAttribute(n, "true"), g || h.setAttribute(r, "true");
        } catch (y) {
          console.error("aria-hidden: cannot operate on ", h, y);
        }
    });
  };
  return f(t), s.clear(), qs++, function() {
    a.forEach(function(u) {
      var h = b3.get(u) - 1, p = i.get(u) - 1;
      b3.set(u, h), i.set(u, p), h || (bo.has(u) || u.removeAttribute(r), bo.delete(u)), p || u.removeAttribute(n);
    }), qs--, qs || (b3 = /* @__PURE__ */ new WeakMap(), b3 = /* @__PURE__ */ new WeakMap(), bo = /* @__PURE__ */ new WeakMap(), yo = {});
  };
}, Wi = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = fP(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), pP(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, St = function() {
  return St = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, St.apply(this, arguments);
};
function Gb(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function mP(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, o = t.length, i; r < o; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var Vo = "right-scroll-bar-position", Ho = "width-before-scroll-bar", gP = "with-scroll-bars-hidden", vP = "--removed-body-scroll-bar-size";
function zs(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function bP(e, t) {
  var n = d2(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var yP = typeof window < "u" ? d.useLayoutEffect : d.useEffect, ff = /* @__PURE__ */ new WeakMap();
function CP(e, t) {
  var n = bP(null, function(r) {
    return e.forEach(function(o) {
      return zs(o, r);
    });
  });
  return yP(function() {
    var r = ff.get(n);
    if (r) {
      var o = new Set(r), i = new Set(e), a = n.current;
      o.forEach(function(s) {
        i.has(s) || zs(s, null);
      }), i.forEach(function(s) {
        o.has(s) || zs(s, a);
      });
    }
    ff.set(n, e);
  }, [e]), n;
}
function wP(e) {
  return e;
}
function _P(e, t) {
  t === void 0 && (t = wP);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var a = t(i, r);
      return n.push(a), function() {
        n = n.filter(function(s) {
          return s !== a;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var a = n;
        n = [], a.forEach(i);
      }
      n = {
        push: function(s) {
          return i(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var a = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(i), a = n;
      }
      var l = function() {
        var f = a;
        a = [], f.forEach(i);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), n = {
        push: function(f) {
          a.push(f), c();
        },
        filter: function(f) {
          return a = a.filter(f), n;
        }
      };
    }
  };
  return o;
}
function xP(e) {
  e === void 0 && (e = {});
  var t = _P(null);
  return t.options = St({ async: !0, ssr: !1 }, e), t;
}
var Yb = function(e) {
  var t = e.sideCar, n = Gb(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return d.createElement(r, St({}, n));
};
Yb.isSideCarExport = !0;
function SP(e, t) {
  return e.useMedium(t), Yb;
}
var Zb = xP(), Us = function() {
}, Vi = d.forwardRef(function(e, t) {
  var n = d.useRef(null), r = d.useState({
    onScrollCapture: Us,
    onWheelCapture: Us,
    onTouchMoveCapture: Us
  }), o = r[0], i = r[1], a = e.forwardProps, s = e.children, l = e.className, c = e.removeScrollBar, f = e.enabled, u = e.shards, h = e.sideCar, p = e.noIsolation, g = e.inert, m = e.allowPinchZoom, b = e.as, y = b === void 0 ? "div" : b, C = e.gapMode, _ = Gb(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), M = h, S = CP([n, t]), k = St(St({}, _), o);
  return d.createElement(
    d.Fragment,
    null,
    f && d.createElement(M, { sideCar: Zb, removeScrollBar: c, shards: u, noIsolation: p, inert: g, setCallbacks: i, allowPinchZoom: !!m, lockRef: n, gapMode: C }),
    a ? d.cloneElement(d.Children.only(s), St(St({}, k), { ref: S })) : d.createElement(y, St({}, k, { className: l, ref: S }), s)
  );
});
Vi.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Vi.classNames = {
  fullWidth: Ho,
  zeroRight: Vo
};
var MP = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function kP() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = MP();
  return t && e.setAttribute("nonce", t), e;
}
function LP(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function EP(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var TP = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = kP()) && (LP(t, n), EP(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, RP = function() {
  var e = TP();
  return function(t, n) {
    d.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Kb = function() {
  var e = RP(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, PP = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Gs = function(e) {
  return parseInt(e || "", 10) || 0;
}, AP = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Gs(n), Gs(r), Gs(o)];
}, IP = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return PP;
  var t = AP(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, OP = Kb(), N3 = "data-scroll-locked", NP = function(e, t, n, r) {
  var o = e.left, i = e.top, a = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(gP, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body[`).concat(N3, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Vo, ` {
    right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(Ho, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(Vo, " .").concat(Vo, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(Ho, " .").concat(Ho, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(N3, `] {
    `).concat(vP, ": ").concat(s, `px;
  }
`);
}, hf = function() {
  var e = parseInt(document.body.getAttribute(N3) || "0", 10);
  return isFinite(e) ? e : 0;
}, DP = function() {
  d.useEffect(function() {
    return document.body.setAttribute(N3, (hf() + 1).toString()), function() {
      var e = hf() - 1;
      e <= 0 ? document.body.removeAttribute(N3) : document.body.setAttribute(N3, e.toString());
    };
  }, []);
}, BP = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  DP();
  var i = d.useMemo(function() {
    return IP(o);
  }, [o]);
  return d.createElement(OP, { styles: NP(i, !t, o, n ? "" : "!important") });
}, H6 = !1;
if (typeof window < "u")
  try {
    var Co = Object.defineProperty({}, "passive", {
      get: function() {
        return H6 = !0, !0;
      }
    });
    window.addEventListener("test", Co, Co), window.removeEventListener("test", Co, Co);
  } catch {
    H6 = !1;
  }
var y3 = H6 ? { passive: !1 } : !1, FP = function(e) {
  return e.tagName === "TEXTAREA";
}, Xb = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !FP(e) && n[t] === "visible")
  );
}, $P = function(e) {
  return Xb(e, "overflowY");
}, WP = function(e) {
  return Xb(e, "overflowX");
}, pf = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = Qb(e, r);
    if (o) {
      var i = Jb(e, r), a = i[1], s = i[2];
      if (a > s)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, VP = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, HP = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, Qb = function(e, t) {
  return e === "v" ? $P(t) : WP(t);
}, Jb = function(e, t) {
  return e === "v" ? VP(t) : HP(t);
}, jP = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, qP = function(e, t, n, r, o) {
  var i = jP(e, window.getComputedStyle(t).direction), a = i * r, s = n.target, l = t.contains(s), c = !1, f = a > 0, u = 0, h = 0;
  do {
    var p = Jb(e, s), g = p[0], m = p[1], b = p[2], y = m - b - i * g;
    (g || y) && Qb(e, s) && (u += y, h += g), s instanceof ShadowRoot ? s = s.host : s = s.parentNode;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (f && Math.abs(u) < 1 || !f && Math.abs(h) < 1) && (c = !0), c;
}, wo = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, mf = function(e) {
  return [e.deltaX, e.deltaY];
}, gf = function(e) {
  return e && "current" in e ? e.current : e;
}, zP = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, UP = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, GP = 0, C3 = [];
function YP(e) {
  var t = d.useRef([]), n = d.useRef([0, 0]), r = d.useRef(), o = d.useState(GP++)[0], i = d.useState(Kb)[0], a = d.useRef(e);
  d.useEffect(function() {
    a.current = e;
  }, [e]), d.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var m = mP([e.lockRef.current], (e.shards || []).map(gf), !0).filter(Boolean);
      return m.forEach(function(b) {
        return b.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), m.forEach(function(b) {
          return b.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = d.useCallback(function(m, b) {
    if ("touches" in m && m.touches.length === 2 || m.type === "wheel" && m.ctrlKey)
      return !a.current.allowPinchZoom;
    var y = wo(m), C = n.current, _ = "deltaX" in m ? m.deltaX : C[0] - y[0], M = "deltaY" in m ? m.deltaY : C[1] - y[1], S, k = m.target, L = Math.abs(_) > Math.abs(M) ? "h" : "v";
    if ("touches" in m && L === "h" && k.type === "range")
      return !1;
    var P = pf(L, k);
    if (!P)
      return !0;
    if (P ? S = L : (S = L === "v" ? "h" : "v", P = pf(L, k)), !P)
      return !1;
    if (!r.current && "changedTouches" in m && (_ || M) && (r.current = S), !S)
      return !0;
    var I = r.current || S;
    return qP(I, b, m, I === "h" ? _ : M);
  }, []), l = d.useCallback(function(m) {
    var b = m;
    if (!(!C3.length || C3[C3.length - 1] !== i)) {
      var y = "deltaY" in b ? mf(b) : wo(b), C = t.current.filter(function(S) {
        return S.name === b.type && (S.target === b.target || b.target === S.shadowParent) && zP(S.delta, y);
      })[0];
      if (C && C.should) {
        b.cancelable && b.preventDefault();
        return;
      }
      if (!C) {
        var _ = (a.current.shards || []).map(gf).filter(Boolean).filter(function(S) {
          return S.contains(b.target);
        }), M = _.length > 0 ? s(b, _[0]) : !a.current.noIsolation;
        M && b.cancelable && b.preventDefault();
      }
    }
  }, []), c = d.useCallback(function(m, b, y, C) {
    var _ = { name: m, delta: b, target: y, should: C, shadowParent: ZP(y) };
    t.current.push(_), setTimeout(function() {
      t.current = t.current.filter(function(M) {
        return M !== _;
      });
    }, 1);
  }, []), f = d.useCallback(function(m) {
    n.current = wo(m), r.current = void 0;
  }, []), u = d.useCallback(function(m) {
    c(m.type, mf(m), m.target, s(m, e.lockRef.current));
  }, []), h = d.useCallback(function(m) {
    c(m.type, wo(m), m.target, s(m, e.lockRef.current));
  }, []);
  d.useEffect(function() {
    return C3.push(i), e.setCallbacks({
      onScrollCapture: u,
      onWheelCapture: u,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", l, y3), document.addEventListener("touchmove", l, y3), document.addEventListener("touchstart", f, y3), function() {
      C3 = C3.filter(function(m) {
        return m !== i;
      }), document.removeEventListener("wheel", l, y3), document.removeEventListener("touchmove", l, y3), document.removeEventListener("touchstart", f, y3);
    };
  }, []);
  var p = e.removeScrollBar, g = e.inert;
  return d.createElement(
    d.Fragment,
    null,
    g ? d.createElement(i, { styles: UP(o) }) : null,
    p ? d.createElement(BP, { gapMode: e.gapMode }) : null
  );
}
function ZP(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const KP = SP(Zb, YP);
var Wr = d.forwardRef(function(e, t) {
  return d.createElement(Vi, St({}, e, { ref: t, sideCar: KP }));
});
Wr.classNames = Vi.classNames;
var j6 = ["Enter", " "], XP = ["ArrowDown", "PageUp", "Home"], ey = ["ArrowUp", "PageDown", "End"], QP = [...XP, ...ey], JP = {
  ltr: [...j6, "ArrowRight"],
  rtl: [...j6, "ArrowLeft"]
}, eA = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, Vr = "Menu", [lr, tA, nA] = Ii(Vr), [u3, ty] = o2(Vr, [
  nA,
  Bt,
  en
]), Hr = Bt(), ny = en(), [ry, R0] = u3(Vr), [rA, jr] = u3(Vr), oy = (e) => {
  const { __scopeMenu: t, open: n = !1, children: r, dir: o, onOpenChange: i, modal: a = !0 } = e, s = Hr(t), [l, c] = d.useState(null), f = d.useRef(!1), u = u2(i), h = l3(o);
  return d.useEffect(() => {
    const p = () => {
      f.current = !0, document.addEventListener("pointerdown", g, { capture: !0, once: !0 }), document.addEventListener("pointermove", g, { capture: !0, once: !0 });
    }, g = () => f.current = !1;
    return document.addEventListener("keydown", p, { capture: !0 }), () => {
      document.removeEventListener("keydown", p, { capture: !0 }), document.removeEventListener("pointerdown", g, { capture: !0 }), document.removeEventListener("pointermove", g, { capture: !0 });
    };
  }, []), /* @__PURE__ */ v(rn, { ...s, children: /* @__PURE__ */ v(
    ry,
    {
      scope: t,
      open: n,
      onOpenChange: u,
      content: l,
      onContentChange: c,
      children: /* @__PURE__ */ v(
        rA,
        {
          scope: t,
          onClose: d.useCallback(() => u(!1), [u]),
          isUsingKeyboardRef: f,
          dir: h,
          modal: a,
          children: r
        }
      )
    }
  ) });
};
oy.displayName = Vr;
var oA = "MenuAnchor", c5 = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = Hr(n);
    return /* @__PURE__ */ v(on, { ...o, ...r, ref: t });
  }
);
c5.displayName = oA;
var u5 = "MenuPortal", [iA, iy] = u3(u5, {
  forceMount: void 0
}), ay = (e) => {
  const { __scopeMenu: t, forceMount: n, children: r, container: o } = e, i = R0(u5, t);
  return /* @__PURE__ */ v(iA, { scope: t, forceMount: n, children: /* @__PURE__ */ v(i2, { present: n || i.open, children: /* @__PURE__ */ v(an, { asChild: !0, container: o, children: r }) }) });
};
ay.displayName = u5;
var J2 = "MenuContent", [aA, d5] = u3(J2), sy = d.forwardRef(
  (e, t) => {
    const n = iy(J2, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, i = R0(J2, e.__scopeMenu), a = jr(J2, e.__scopeMenu);
    return /* @__PURE__ */ v(lr.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ v(i2, { present: r || i.open, children: /* @__PURE__ */ v(lr.Slot, { scope: e.__scopeMenu, children: a.modal ? /* @__PURE__ */ v(sA, { ...o, ref: t }) : /* @__PURE__ */ v(lA, { ...o, ref: t }) }) }) });
  }
), sA = d.forwardRef(
  (e, t) => {
    const n = R0(J2, e.__scopeMenu), r = d.useRef(null), o = F1(t, r);
    return d.useEffect(() => {
      const i = r.current;
      if (i) return Wi(i);
    }, []), /* @__PURE__ */ v(
      f5,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: p1(
          e.onFocusOutside,
          (i) => i.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), lA = d.forwardRef((e, t) => {
  const n = R0(J2, e.__scopeMenu);
  return /* @__PURE__ */ v(
    f5,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), cA = /* @__PURE__ */ w0("MenuContent.ScrollLock"), f5 = d.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: r = !1,
      trapFocus: o,
      onOpenAutoFocus: i,
      onCloseAutoFocus: a,
      disableOutsidePointerEvents: s,
      onEntryFocus: l,
      onEscapeKeyDown: c,
      onPointerDownOutside: f,
      onFocusOutside: u,
      onInteractOutside: h,
      onDismiss: p,
      disableOutsideScroll: g,
      ...m
    } = e, b = R0(J2, n), y = jr(J2, n), C = Hr(n), _ = ny(n), M = tA(n), [S, k] = d.useState(null), L = d.useRef(null), P = F1(t, L, b.onContentChange), I = d.useRef(0), O = d.useRef(""), E = d.useRef(0), B = d.useRef(null), W = d.useRef("right"), F = d.useRef(0), z = g ? Wr : d.Fragment, D = g ? { as: cA, allowPinchZoom: !0 } : void 0, Z = ($) => {
      const q = O.current + $, K = M().filter((Y) => !Y.disabled), V = document.activeElement, n1 = K.find((Y) => Y.ref.current === V)?.textValue, o1 = K.map((Y) => Y.textValue), r1 = wA(o1, q, n1), X = K.find((Y) => Y.textValue === r1)?.ref.current;
      (function Y(Q) {
        O.current = Q, window.clearTimeout(I.current), Q !== "" && (I.current = window.setTimeout(() => Y(""), 1e3));
      })(q), X && setTimeout(() => X.focus());
    };
    d.useEffect(() => () => window.clearTimeout(I.current), []), Ni();
    const U = d.useCallback(($) => W.current === B.current?.side && xA($, B.current?.area), []);
    return /* @__PURE__ */ v(
      aA,
      {
        scope: n,
        searchRef: O,
        onItemEnter: d.useCallback(
          ($) => {
            U($) && $.preventDefault();
          },
          [U]
        ),
        onItemLeave: d.useCallback(
          ($) => {
            U($) || (L.current?.focus(), k(null));
          },
          [U]
        ),
        onTriggerLeave: d.useCallback(
          ($) => {
            U($) && $.preventDefault();
          },
          [U]
        ),
        pointerGraceTimerRef: E,
        onPointerGraceIntentChange: d.useCallback(($) => {
          B.current = $;
        }, []),
        children: /* @__PURE__ */ v(z, { ...D, children: /* @__PURE__ */ v(
          Dr,
          {
            asChild: !0,
            trapped: o,
            onMountAutoFocus: p1(i, ($) => {
              $.preventDefault(), L.current?.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: a,
            children: /* @__PURE__ */ v(
              c3,
              {
                asChild: !0,
                disableOutsidePointerEvents: s,
                onEscapeKeyDown: c,
                onPointerDownOutside: f,
                onFocusOutside: u,
                onInteractOutside: h,
                onDismiss: p,
                children: /* @__PURE__ */ v(
                  Xu,
                  {
                    asChild: !0,
                    ..._,
                    dir: y.dir,
                    orientation: "vertical",
                    loop: r,
                    currentTabStopId: S,
                    onCurrentTabStopIdChange: k,
                    onEntryFocus: p1(l, ($) => {
                      y.isUsingKeyboardRef.current || $.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ v(
                      Fr,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": Sy(b.open),
                        "data-radix-menu-content": "",
                        dir: y.dir,
                        ...C,
                        ...m,
                        ref: P,
                        style: { outline: "none", ...m.style },
                        onKeyDown: p1(m.onKeyDown, ($) => {
                          const K = $.target.closest("[data-radix-menu-content]") === $.currentTarget, V = $.ctrlKey || $.altKey || $.metaKey, n1 = $.key.length === 1;
                          K && ($.key === "Tab" && $.preventDefault(), !V && n1 && Z($.key));
                          const o1 = L.current;
                          if ($.target !== o1 || !QP.includes($.key)) return;
                          $.preventDefault();
                          const X = M().filter((Y) => !Y.disabled).map((Y) => Y.ref.current);
                          ey.includes($.key) && X.reverse(), yA(X);
                        }),
                        onBlur: p1(e.onBlur, ($) => {
                          $.currentTarget.contains($.target) || (window.clearTimeout(I.current), O.current = "");
                        }),
                        onPointerMove: p1(
                          e.onPointerMove,
                          cr(($) => {
                            const q = $.target, K = F.current !== $.clientX;
                            if ($.currentTarget.contains(q) && K) {
                              const V = $.clientX > F.current ? "right" : "left";
                              W.current = V, F.current = $.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
sy.displayName = J2;
var uA = "MenuGroup", h5 = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ v(y1.div, { role: "group", ...r, ref: t });
  }
);
h5.displayName = uA;
var dA = "MenuLabel", ly = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ v(y1.div, { ...r, ref: t });
  }
);
ly.displayName = dA;
var Xo = "MenuItem", vf = "menu.itemSelect", Hi = d.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: r, ...o } = e, i = d.useRef(null), a = jr(Xo, e.__scopeMenu), s = d5(Xo, e.__scopeMenu), l = F1(t, i), c = d.useRef(!1), f = () => {
      const u = i.current;
      if (!n && u) {
        const h = new CustomEvent(vf, { bubbles: !0, cancelable: !0 });
        u.addEventListener(vf, (p) => r?.(p), { once: !0 }), sb(u, h), h.defaultPrevented ? c.current = !1 : a.onClose();
      }
    };
    return /* @__PURE__ */ v(
      cy,
      {
        ...o,
        ref: l,
        disabled: n,
        onClick: p1(e.onClick, f),
        onPointerDown: (u) => {
          e.onPointerDown?.(u), c.current = !0;
        },
        onPointerUp: p1(e.onPointerUp, (u) => {
          c.current || u.currentTarget?.click();
        }),
        onKeyDown: p1(e.onKeyDown, (u) => {
          const h = s.searchRef.current !== "";
          n || h && u.key === " " || j6.includes(u.key) && (u.currentTarget.click(), u.preventDefault());
        })
      }
    );
  }
);
Hi.displayName = Xo;
var cy = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: r = !1, textValue: o, ...i } = e, a = d5(Xo, n), s = ny(n), l = d.useRef(null), c = F1(t, l), [f, u] = d.useState(!1), [h, p] = d.useState("");
    return d.useEffect(() => {
      const g = l.current;
      g && p((g.textContent ?? "").trim());
    }, [i.children]), /* @__PURE__ */ v(
      lr.ItemSlot,
      {
        scope: n,
        disabled: r,
        textValue: o ?? h,
        children: /* @__PURE__ */ v(Qu, { asChild: !0, ...s, focusable: !r, children: /* @__PURE__ */ v(
          y1.div,
          {
            role: "menuitem",
            "data-highlighted": f ? "" : void 0,
            "aria-disabled": r || void 0,
            "data-disabled": r ? "" : void 0,
            ...i,
            ref: c,
            onPointerMove: p1(
              e.onPointerMove,
              cr((g) => {
                r ? a.onItemLeave(g) : (a.onItemEnter(g), g.defaultPrevented || g.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: p1(
              e.onPointerLeave,
              cr((g) => a.onItemLeave(g))
            ),
            onFocus: p1(e.onFocus, () => u(!0)),
            onBlur: p1(e.onBlur, () => u(!1))
          }
        ) })
      }
    );
  }
), fA = "MenuCheckboxItem", uy = d.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: r, ...o } = e;
    return /* @__PURE__ */ v(my, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ v(
      Hi,
      {
        role: "menuitemcheckbox",
        "aria-checked": Qo(n) ? "mixed" : n,
        ...o,
        ref: t,
        "data-state": g5(n),
        onSelect: p1(
          o.onSelect,
          () => r?.(Qo(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
uy.displayName = fA;
var dy = "MenuRadioGroup", [hA, pA] = u3(
  dy,
  { value: void 0, onValueChange: () => {
  } }
), fy = d.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: r, ...o } = e, i = u2(r);
    return /* @__PURE__ */ v(hA, { scope: e.__scopeMenu, value: n, onValueChange: i, children: /* @__PURE__ */ v(h5, { ...o, ref: t }) });
  }
);
fy.displayName = dy;
var hy = "MenuRadioItem", py = d.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, o = pA(hy, e.__scopeMenu), i = n === o.value;
    return /* @__PURE__ */ v(my, { scope: e.__scopeMenu, checked: i, children: /* @__PURE__ */ v(
      Hi,
      {
        role: "menuitemradio",
        "aria-checked": i,
        ...r,
        ref: t,
        "data-state": g5(i),
        onSelect: p1(
          r.onSelect,
          () => o.onValueChange?.(n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
py.displayName = hy;
var p5 = "MenuItemIndicator", [my, mA] = u3(
  p5,
  { checked: !1 }
), gy = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: r, ...o } = e, i = mA(p5, n);
    return /* @__PURE__ */ v(
      i2,
      {
        present: r || Qo(i.checked) || i.checked === !0,
        children: /* @__PURE__ */ v(
          y1.span,
          {
            ...o,
            ref: t,
            "data-state": g5(i.checked)
          }
        )
      }
    );
  }
);
gy.displayName = p5;
var gA = "MenuSeparator", vy = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ v(
      y1.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...r,
        ref: t
      }
    );
  }
);
vy.displayName = gA;
var vA = "MenuArrow", by = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = Hr(n);
    return /* @__PURE__ */ v($r, { ...o, ...r, ref: t });
  }
);
by.displayName = vA;
var m5 = "MenuSub", [bA, yy] = u3(m5), Cy = (e) => {
  const { __scopeMenu: t, children: n, open: r = !1, onOpenChange: o } = e, i = R0(m5, t), a = Hr(t), [s, l] = d.useState(null), [c, f] = d.useState(null), u = u2(o);
  return d.useEffect(() => (i.open === !1 && u(!1), () => u(!1)), [i.open, u]), /* @__PURE__ */ v(rn, { ...a, children: /* @__PURE__ */ v(
    ry,
    {
      scope: t,
      open: r,
      onOpenChange: u,
      content: c,
      onContentChange: f,
      children: /* @__PURE__ */ v(
        bA,
        {
          scope: t,
          contentId: t2(),
          triggerId: t2(),
          trigger: s,
          onTriggerChange: l,
          children: n
        }
      )
    }
  ) });
};
Cy.displayName = m5;
var jn = "MenuSubTrigger", wy = d.forwardRef(
  (e, t) => {
    const n = R0(jn, e.__scopeMenu), r = jr(jn, e.__scopeMenu), o = yy(jn, e.__scopeMenu), i = d5(jn, e.__scopeMenu), a = d.useRef(null), { pointerGraceTimerRef: s, onPointerGraceIntentChange: l } = i, c = { __scopeMenu: e.__scopeMenu }, f = d.useCallback(() => {
      a.current && window.clearTimeout(a.current), a.current = null;
    }, []);
    return d.useEffect(() => f, [f]), d.useEffect(() => {
      const u = s.current;
      return () => {
        window.clearTimeout(u), l(null);
      };
    }, [s, l]), /* @__PURE__ */ v(c5, { asChild: !0, ...c, children: /* @__PURE__ */ v(
      cy,
      {
        id: o.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": o.contentId,
        "data-state": Sy(n.open),
        ...e,
        ref: e0(t, o.onTriggerChange),
        onClick: (u) => {
          e.onClick?.(u), !(e.disabled || u.defaultPrevented) && (u.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: p1(
          e.onPointerMove,
          cr((u) => {
            i.onItemEnter(u), !u.defaultPrevented && !e.disabled && !n.open && !a.current && (i.onPointerGraceIntentChange(null), a.current = window.setTimeout(() => {
              n.onOpenChange(!0), f();
            }, 100));
          })
        ),
        onPointerLeave: p1(
          e.onPointerLeave,
          cr((u) => {
            f();
            const h = n.content?.getBoundingClientRect();
            if (h) {
              const p = n.content?.dataset.side, g = p === "right", m = g ? -5 : 5, b = h[g ? "left" : "right"], y = h[g ? "right" : "left"];
              i.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: u.clientX + m, y: u.clientY },
                  { x: b, y: h.top },
                  { x: y, y: h.top },
                  { x: y, y: h.bottom },
                  { x: b, y: h.bottom }
                ],
                side: p
              }), window.clearTimeout(s.current), s.current = window.setTimeout(
                () => i.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (i.onTriggerLeave(u), u.defaultPrevented) return;
              i.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: p1(e.onKeyDown, (u) => {
          const h = i.searchRef.current !== "";
          e.disabled || h && u.key === " " || JP[r.dir].includes(u.key) && (n.onOpenChange(!0), n.content?.focus(), u.preventDefault());
        })
      }
    ) });
  }
);
wy.displayName = jn;
var _y = "MenuSubContent", xy = d.forwardRef(
  (e, t) => {
    const n = iy(J2, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, i = R0(J2, e.__scopeMenu), a = jr(J2, e.__scopeMenu), s = yy(_y, e.__scopeMenu), l = d.useRef(null), c = F1(t, l);
    return /* @__PURE__ */ v(lr.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ v(i2, { present: r || i.open, children: /* @__PURE__ */ v(lr.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ v(
      f5,
      {
        id: s.contentId,
        "aria-labelledby": s.triggerId,
        ...o,
        ref: c,
        align: "start",
        side: a.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (f) => {
          a.isUsingKeyboardRef.current && l.current?.focus(), f.preventDefault();
        },
        onCloseAutoFocus: (f) => f.preventDefault(),
        onFocusOutside: p1(e.onFocusOutside, (f) => {
          f.target !== s.trigger && i.onOpenChange(!1);
        }),
        onEscapeKeyDown: p1(e.onEscapeKeyDown, (f) => {
          a.onClose(), f.preventDefault();
        }),
        onKeyDown: p1(e.onKeyDown, (f) => {
          const u = f.currentTarget.contains(f.target), h = eA[a.dir].includes(f.key);
          u && h && (i.onOpenChange(!1), s.trigger?.focus(), f.preventDefault());
        })
      }
    ) }) }) });
  }
);
xy.displayName = _y;
function Sy(e) {
  return e ? "open" : "closed";
}
function Qo(e) {
  return e === "indeterminate";
}
function g5(e) {
  return Qo(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function yA(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t)) return;
}
function CA(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
function wA(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((c) => c === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let a = CA(e, Math.max(i, 0));
  o.length === 1 && (a = a.filter((c) => c !== n));
  const l = a.find(
    (c) => c.toLowerCase().startsWith(o.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function _A(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let i = 0, a = t.length - 1; i < t.length; a = i++) {
    const s = t[i], l = t[a], c = s.x, f = s.y, u = l.x, h = l.y;
    f > r != h > r && n < (u - c) * (r - f) / (h - f) + c && (o = !o);
  }
  return o;
}
function xA(e, t) {
  if (!t) return !1;
  const n = { x: e.clientX, y: e.clientY };
  return _A(n, t);
}
function cr(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var SA = oy, MA = c5, kA = ay, LA = sy, EA = h5, TA = ly, RA = Hi, PA = uy, AA = fy, IA = py, OA = gy, NA = vy, DA = by, BA = Cy, FA = wy, $A = xy, ji = "DropdownMenu", [WA, k01] = o2(
  ji,
  [ty]
), T2 = ty(), [VA, My] = WA(ji), ky = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: n,
    dir: r,
    open: o,
    defaultOpen: i,
    onOpenChange: a,
    modal: s = !0
  } = e, l = T2(t), c = d.useRef(null), [f, u] = E2({
    prop: o,
    defaultProp: i ?? !1,
    onChange: a,
    caller: ji
  });
  return /* @__PURE__ */ v(
    VA,
    {
      scope: t,
      triggerId: t2(),
      triggerRef: c,
      contentId: t2(),
      open: f,
      onOpenChange: u,
      onOpenToggle: d.useCallback(() => u((h) => !h), [u]),
      modal: s,
      children: /* @__PURE__ */ v(SA, { ...l, open: f, onOpenChange: u, dir: r, modal: s, children: n })
    }
  );
};
ky.displayName = ji;
var Ly = "DropdownMenuTrigger", Ey = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, disabled: r = !1, ...o } = e, i = My(Ly, n), a = T2(n);
    return /* @__PURE__ */ v(MA, { asChild: !0, ...a, children: /* @__PURE__ */ v(
      y1.button,
      {
        type: "button",
        id: i.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": i.open,
        "aria-controls": i.open ? i.contentId : void 0,
        "data-state": i.open ? "open" : "closed",
        "data-disabled": r ? "" : void 0,
        disabled: r,
        ...o,
        ref: e0(t, i.triggerRef),
        onPointerDown: p1(e.onPointerDown, (s) => {
          !r && s.button === 0 && s.ctrlKey === !1 && (i.onOpenToggle(), i.open || s.preventDefault());
        }),
        onKeyDown: p1(e.onKeyDown, (s) => {
          r || (["Enter", " "].includes(s.key) && i.onOpenToggle(), s.key === "ArrowDown" && i.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(s.key) && s.preventDefault());
        })
      }
    ) });
  }
);
Ey.displayName = Ly;
var HA = "DropdownMenuPortal", Ty = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, r = T2(t);
  return /* @__PURE__ */ v(kA, { ...r, ...n });
};
Ty.displayName = HA;
var Ry = "DropdownMenuContent", Py = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = My(Ry, n), i = T2(n), a = d.useRef(!1);
    return /* @__PURE__ */ v(
      LA,
      {
        id: o.contentId,
        "aria-labelledby": o.triggerId,
        ...i,
        ...r,
        ref: t,
        onCloseAutoFocus: p1(e.onCloseAutoFocus, (s) => {
          a.current || o.triggerRef.current?.focus(), a.current = !1, s.preventDefault();
        }),
        onInteractOutside: p1(e.onInteractOutside, (s) => {
          const l = s.detail.originalEvent, c = l.button === 0 && l.ctrlKey === !0, f = l.button === 2 || c;
          (!o.modal || f) && (a.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
Py.displayName = Ry;
var jA = "DropdownMenuGroup", Ay = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = T2(n);
    return /* @__PURE__ */ v(EA, { ...o, ...r, ref: t });
  }
);
Ay.displayName = jA;
var qA = "DropdownMenuLabel", Iy = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = T2(n);
    return /* @__PURE__ */ v(TA, { ...o, ...r, ref: t });
  }
);
Iy.displayName = qA;
var zA = "DropdownMenuItem", Oy = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = T2(n);
    return /* @__PURE__ */ v(RA, { ...o, ...r, ref: t });
  }
);
Oy.displayName = zA;
var UA = "DropdownMenuCheckboxItem", Ny = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = T2(n);
  return /* @__PURE__ */ v(PA, { ...o, ...r, ref: t });
});
Ny.displayName = UA;
var GA = "DropdownMenuRadioGroup", Dy = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = T2(n);
  return /* @__PURE__ */ v(AA, { ...o, ...r, ref: t });
});
Dy.displayName = GA;
var YA = "DropdownMenuRadioItem", By = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = T2(n);
  return /* @__PURE__ */ v(IA, { ...o, ...r, ref: t });
});
By.displayName = YA;
var ZA = "DropdownMenuItemIndicator", Fy = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = T2(n);
  return /* @__PURE__ */ v(OA, { ...o, ...r, ref: t });
});
Fy.displayName = ZA;
var KA = "DropdownMenuSeparator", $y = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = T2(n);
  return /* @__PURE__ */ v(NA, { ...o, ...r, ref: t });
});
$y.displayName = KA;
var XA = "DropdownMenuArrow", QA = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = T2(n);
    return /* @__PURE__ */ v(DA, { ...o, ...r, ref: t });
  }
);
QA.displayName = XA;
var JA = (e) => {
  const { __scopeDropdownMenu: t, children: n, open: r, onOpenChange: o, defaultOpen: i } = e, a = T2(t), [s, l] = E2({
    prop: r,
    defaultProp: i ?? !1,
    onChange: o,
    caller: "DropdownMenuSub"
  });
  return /* @__PURE__ */ v(BA, { ...a, open: s, onOpenChange: l, children: n });
}, eI = "DropdownMenuSubTrigger", Wy = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = T2(n);
  return /* @__PURE__ */ v(FA, { ...o, ...r, ref: t });
});
Wy.displayName = eI;
var tI = "DropdownMenuSubContent", Vy = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = T2(n);
  return /* @__PURE__ */ v(
    $A,
    {
      ...o,
      ...r,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Vy.displayName = tI;
var nI = ky, rI = Ey, Hy = Ty, oI = Py, iI = Ay, aI = Iy, sI = Oy, lI = Ny, cI = Dy, jy = By, v5 = Fy, uI = $y, dI = JA, fI = Wy, hI = Vy;
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pI = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), mI = (e) => e.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (t, n, r) => r ? r.toUpperCase() : n.toLowerCase()
), bf = (e) => {
  const t = mI(e);
  return t.charAt(0).toUpperCase() + t.slice(1);
}, qy = (...e) => e.filter((t, n, r) => !!t && t.trim() !== "" && r.indexOf(t) === n).join(" ").trim(), gI = (e) => {
  for (const t in e)
    if (t.startsWith("aria-") || t === "role" || t === "title")
      return !0;
};
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var vI = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bI = x1(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: r,
    className: o = "",
    children: i,
    iconNode: a,
    ...s
  }, l) => s2(
    "svg",
    {
      ref: l,
      ...vI,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: r ? Number(n) * 24 / Number(t) : n,
      className: qy("lucide", o),
      ...!i && !gI(s) && { "aria-hidden": "true" },
      ...s
    },
    [
      ...a.map(([c, f]) => s2(c, f)),
      ...Array.isArray(i) ? i : [i]
    ]
  )
);
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const b5 = (e, t) => {
  const n = x1(
    ({ className: r, ...o }, i) => s2(bI, {
      ref: i,
      iconNode: t,
      className: qy(
        `lucide-${pI(bf(e))}`,
        `lucide-${e}`,
        r
      ),
      ...o
    })
  );
  return n.displayName = bf(e), n;
};
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yI = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], CI = b5("chevron-right", yI);
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wI = [["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]], y5 = b5("circle", wI);
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _I = [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }]
], xI = b5("ellipsis", _I);
function SI(e) {
  return /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M10.296 1.510848C9.8016 1.577856 9.387096000000001 1.8774 9.152448 2.33724C8.988840000000001 2.657856 9.000864 1.90068 9.000408 11.91L9 21 8.256576 21L7.513176 21 7.506456 16.362000000000002C7.500024 11.931672 7.497744 11.718096000000001 7.455552000000001 11.592C7.284576 11.081136 6.896903999999999 10.697735999999999 6.396 10.54416C6.261792000000001 10.503 6.132936 10.5 4.5 10.5C2.867064 10.5 2.738208 10.503 2.604 10.54416C2.1030960000000003 10.697735999999999 1.715424 11.081136 1.544448 11.592C1.502256 11.718096000000001 1.4999760000000002 11.931624000000001 1.493544 16.360608L1.4868240000000001 20.997216 1.013424 21.004608C0.5691120000000001 21.011544 0.533088 21.015528000000003 0.427608 21.069456C-0.004416 21.290304 -0.13272 21.828984000000002 0.156504 22.207752C0.26748 22.35312 0.44325600000000004 22.456992 0.629328 22.487184C0.8386560000000001 22.521144 23.161344 22.521144 23.370672000000003 22.487184C23.632248 22.444728 23.879952000000003 22.242936 23.953632 22.012224C23.969112 21.963696 23.991288 21.913752 24.002904 21.9012C24.026664 21.87552 24.032496000000002 21.535512 24.008760000000002 21.559248C24.000384 21.567624 23.963856 21.512712 23.927616 21.437231999999998C23.846496000000002 21.268344000000003 23.71752 21.142056 23.544 21.061656C23.417424 21.002976 23.393520000000002 21.000456 22.96236 21.00024L22.512719999999998 21 22.505832 14.118C22.499256000000003 7.5504240000000005 22.496952 7.229424 22.455408000000002 7.0920000000000005C22.298976 6.5748240000000004 21.840792 6.140904 21.33876 6.0344880000000005C21.10596 5.985144 17.89404 5.985144 17.66124 6.0344880000000005C17.159232 6.140904 16.701 6.574871999999999 16.544591999999998 7.0920000000000005C16.503048 7.229424 16.500743999999997 7.5504240000000005 16.494168 14.118L16.487280000000002 21 15.743640000000001 21L15 21 14.999592 11.91C14.999136000000002 1.9012559999999998 15.011136000000002 2.658 14.847648000000001 2.33724C14.653056 1.955448 14.305968 1.6630559999999999 13.908 1.5456720000000002C13.777104000000001 1.50708 13.612128 1.502736 12.096 1.49808C11.1786 1.495272 10.368599999999999 1.5010080000000001 10.296 1.510848M10.512 12L10.512 21 12 21L13.488 21 13.488 12L13.488 3 12 3L10.512 3 10.512 12M18 14.256L18 21 19.5 21L21 21 21 14.256L21 7.5120000000000005 19.5 7.5120000000000005L18 7.5120000000000005 18 14.256M3 16.5L3 21 4.5 21L6 21 6 16.5L6 12 4.5 12L3 12 3 16.5M0.008064 21.744C0.008064 21.843 0.012312 21.883512 0.017472 21.834C0.022656 21.784512 0.022656 21.703512 0.017472 21.654C0.012312 21.604512 0.008064 21.645 0.008064 21.744", stroke: "none", fill: "currentColor", fillRule: "evenodd", strokeWidth: 0.024 }));
}
SI.displayName = "LBAnalyticsBarsIcon";
function MI(e) {
  return /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M13.1 3.37567L3.15625 13.3194", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M3.15625 3.94442V13.3194H12.5312", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }));
}
MI.displayName = "LBArrowCornerLeftDownIcon";
function kI(e) {
  return /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M13.1562 13.6319L3.2125 3.68817", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M12.5874 3.68817L3.2124 3.68817L3.2124 13.0632", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }));
}
kI.displayName = "LBArrowCornerLeftUpIcon";
function LI(e) {
  return /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M3 3.37567L12.9438 13.3194", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M3.56885 13.3194H12.9438V3.94442", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }));
}
LI.displayName = "LBArrowCornerRightDownIcon";
function EI(e) {
  return /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M2.84375 13.5319L12.7875 3.58817", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M12.7876 12.9632L12.7876 3.58817L3.4126 3.58817", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }));
}
EI.displayName = "LBArrowCornerRightUpIcon";
function q6(e) {
  return /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17404_192090)" }, /* @__PURE__ */ d.createElement("path", { d: "M8 1.50067V15.5632", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M1.4375 9.00067L8 15.5632L14.5625 9.00067", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17404_192090" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.531921)" }))));
}
q6.displayName = "LBArrowDownIcon";
function TI(e) {
  return /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M15.0312 8.53192H0.96875", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M7.53125 1.96942L0.96875 8.53192L7.53125 15.0944", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }));
}
TI.displayName = "LBArrowLeftIcon";
function RI(e) {
  return /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M0.96875 8.53192H15.0312", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M8.46875 15.0944L15.0312 8.53192L8.46875 1.96942", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }));
}
RI.displayName = "LBArrowRightIcon";
function z6(e) {
  return /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17404_192084)" }, /* @__PURE__ */ d.createElement("path", { d: "M8 15.5632V1.50067", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M14.5625 8.06317L8 1.50067L1.4375 8.06317", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17404_192084" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.531921)" }))));
}
z6.displayName = "LBArrowUpIcon";
function PI(e) {
  return /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M11.040000000000001 0.035904C8.6556 0.237768 6.436751999999999 1.1044559999999999 4.596 2.552928C0.097776 6.092592 -1.29048 12.297192 1.276704 17.388C3.326592 21.452952000000003 7.457352 24 12 24C13.890528000000002 24 15.702048 23.570591999999998 17.388 22.722792000000002C19.507656 21.656928 21.267984000000002 19.983552 22.444584000000003 17.916C23.304456000000002 16.404984000000002 23.866968 14.548704 23.966616000000002 12.89328C23.975592 12.744384 23.992176 12.616848000000001 24.003456 12.609863999999998C24.01476 12.60288 24.023832000000002 12.314304 24.02364 11.968584C24.023424000000002 11.622864 24.014256000000003 11.354208 24.00324 11.37156C23.99148 11.390136 23.976528000000002 11.286336 23.966952000000003 11.11956C23.882568 9.650112 23.434824000000003 8.027976 22.722792000000002 6.612C20.944128000000003 3.074832 17.531015999999997 0.6356160000000001 13.620000000000001 0.106584C12.849120000000001 0.002304 11.782104 -0.026928000000000004 11.040000000000001 0.035904M11.268 1.526496C10.389864000000001 1.6122960000000002 9.461688 1.77096 9.438936 1.8391680000000001C9.431592 1.8612 11.002080000000001 7.578072 11.02056 7.596576C11.024952 7.600944 11.102496 7.58904 11.192904 7.570080000000001C11.465496 7.5129600000000005 11.967096000000002 7.4873520000000005 12.319992 7.512576C12.802248 7.54704 13.219728 7.641552000000001 13.664952000000001 7.817088L13.877880000000001 7.90104 13.93164 7.84452C13.98636 7.786968 17.617056 3.2256 17.646144 3.177864C17.667144 3.143376 17.04048 2.779008 16.573608 2.5542480000000003C15.488664 2.03196 14.432687999999999 1.723872 13.200000000000001 1.570032C12.915888 1.53456 11.509704000000001 1.50288 11.268 1.526496M7.656000000000001 2.444856C6.823224 2.830848 6.149496 3.2434800000000004 5.482896 3.7758C3.2744400000000002 5.539272 1.913664 7.988544 1.567056 10.824C1.5064080000000002 11.320152 1.5064080000000002 12.679848 1.567056 13.176C1.913784 16.012368000000002 3.2695920000000003 18.452592 5.484 20.225808C6.989808000000001 21.431592 8.810256 22.183896 10.824 22.432512C11.321159999999999 22.493904 12.67884 22.493904 13.176 22.432512C13.533432000000001 22.3884 14.067816 22.299648 14.086488000000001 22.281336C14.097144 22.270848 14.01984 21.92436 13.227696 18.432000000000002C12.778584 16.452024 12.778584 16.452 12.719280000000001 16.456104C12.686688 16.458384 12.5088 16.471464 12.324 16.485167999999998C11.492448 16.54692 10.700664 16.386264 9.96 16.005528C9.092688 15.559655999999999 8.440344 14.907312000000001 7.994472 14.040000000000001C7.33392 12.755040000000001 7.33392 11.24496 7.994472 9.96C8.33772 9.29232 8.810952 8.743584 9.393096 8.33832C9.505536000000001 8.260056 9.598080000000001 8.182392 9.598752 8.16576C9.59964 8.144064 8.104152000000001 2.696352 8.00112 2.346C7.994327999999999 2.3228880000000003 7.981392 2.304408 7.972392 2.304912C7.963368000000001 2.305416 7.821 2.368392 7.656000000000001 2.444856M17.124 6.254952C16.1736 7.449864 15.338232 8.502072 15.2676 8.593224L15.139199999999999 8.758944000000001 15.334655999999999 8.981472C15.888696 9.61224 16.260096 10.345583999999999 16.414176 11.113007999999999C16.601424 12.045552 16.46748 13.124592 16.064952 13.926048L15.955704 14.143608 18.11184 16.300704L20.268 18.457824000000002 20.335224 18.378912C20.57436 18.098184 21.089184 17.282424 21.346776 16.776C21.920592 15.647976000000002 22.270584 14.48748 22.432512 13.176C22.493904 12.67884 22.493904 11.321159999999999 22.432512 10.824C22.151616 8.548872 21.264264 6.598704000000001 19.74948 4.927272C19.469256 4.618056 18.90924 4.078776 18.870912 4.0812C18.86052 4.081848 18.0744 5.06004 17.124 6.254952M11.642376 9.025152C10.508304 9.1674 9.523992000000002 9.967104 9.169032 11.034648C9.046968 11.401752 9.016632 11.593944 9.016632 12C9.016632 12.406056 9.046968 12.598248 9.169032 12.965352C9.312576 13.39704 9.548615999999999 13.774176 9.887232000000001 14.112768C10.318272 14.543807999999999 10.80972 14.806920000000002 11.436 14.941968000000001C11.700216000000001 14.998944000000002 12.299351999999999 14.998992 12.564 14.942064C13.172256 14.81124 13.675416 14.54568 14.086872 14.138328C14.54016 13.689576 14.804015999999999 13.203768000000002 14.941968000000001 12.564C14.998992 12.299496000000001 14.998992 11.700504 14.941968000000001 11.436C14.808456 10.816752 14.545224000000001 10.32156 14.12448 9.898128000000002C13.695528000000001 9.466416 13.170792 9.184008 12.570048 9.061512C12.336792 9.013944 11.875680000000001 8.995872 11.642376 9.025152M0.010488 12C0.010488 12.349800000000002 0.013848 12.492912 0.017928 12.318C0.022032000000000003 12.143088 0.022032000000000003 11.856912000000001 0.017928 11.682C0.013848 11.507088 0.010488 11.6502 0.010488 12M14.974295999999999 15.374592C14.926848 15.432528000000001 14.513256000000002 15.73812 14.345088 15.839496C14.214839999999999 15.918023999999999 14.207544 15.927287999999999 14.222351999999999 15.995496000000001C14.38884 16.762415999999998 15.550199999999998 21.846192000000002 15.56148 21.857471999999998C15.603216000000002 21.899208 16.704528 21.403272 17.196 21.121416C17.601696 20.888736 18.170832 20.502264 18.516000000000002 20.225088C18.811848 19.987488 19.229015999999998 19.621128000000002 19.242024 19.58748C19.245312000000002 19.578936 18.294168 18.618096 17.12832 17.45232C15.190824000000001 15.514920000000002 15.005664 15.336312000000001 14.974295999999999 15.374592", stroke: "none", fill: "currentColor", fillRule: "evenodd", strokeWidth: 0.024 }));
}
PI.displayName = "LBCdPartitionIcon";
function sn(e) {
  return /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M14.1169 6.63109L8.8311 11.9163C8.7876 11.9598 8.73597 11.9943 8.67916 12.0179C8.62229 12.0415 8.56135 12.0536 8.49985 12.0536C8.43835 12.0536 8.37741 12.0415 8.32054 12.0179C8.26372 11.9943 8.2121 11.9598 8.1686 11.9163L2.88281 6.63109", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
}
sn.displayName = "LBChevronDownIcon";
function qi(e) {
  return /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M9.44901 14.4717L4.16323 9.18587C4.11969 9.14239 4.08514 9.09075 4.06158 9.03391C4.03801 8.97707 4.02588 8.91615 4.02588 8.85462C4.02588 8.79309 4.03801 8.73216 4.06158 8.67532C4.08514 8.61848 4.11969 8.56684 4.16323 8.52337L9.44901 3.23758", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
}
qi.displayName = "LBChevronLeftIcon";
function qr(e) {
  return /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M5.14453 2.23758L10.4303 7.52337C10.4739 7.56684 10.5084 7.61848 10.532 7.67532C10.5555 7.73216 10.5677 7.79309 10.5677 7.85462C10.5677 7.91615 10.5555 7.97707 10.532 8.03391C10.5084 8.09075 10.4739 8.14239 10.4303 8.18587L5.14453 13.4717", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
}
qr.displayName = "LBChevronRightIcon";
function zy(e) {
  return /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M7.61687 13.8942L2.33171 8.60841C2.28815 8.56491 2.25365 8.51329 2.23009 8.45648C2.20646 8.3996 2.19434 8.33866 2.19434 8.27716C2.19434 8.21566 2.20646 8.15472 2.23009 8.09785C2.25365 8.04104 2.28815 7.98941 2.33171 7.94591L7.61687 2.66013M14.0394 13.8942L8.75426 8.60841C8.71069 8.56491 8.6762 8.51329 8.65263 8.45648C8.62901 8.3996 8.61688 8.33866 8.61688 8.27716C8.61688 8.21566 8.62901 8.15472 8.65263 8.09785C8.6762 8.04104 8.71069 7.98941 8.75426 7.94591L14.0394 2.66013", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
}
zy.displayName = "LBChevronDoubleLeftIcon";
function Uy(e) {
  return /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M8.61688 2.66013L13.902 7.94591C13.9456 7.98941 13.9801 8.04104 14.0037 8.09785C14.0273 8.15472 14.0394 8.21566 14.0394 8.27716C14.0394 8.33866 14.0273 8.3996 14.0037 8.45648C13.9801 8.51329 13.9456 8.56491 13.902 8.60841L8.61688 13.8942M2.19434 2.66013L7.4795 7.94591C7.52306 7.98941 7.55756 8.04104 7.58112 8.09785C7.60475 8.15472 7.61687 8.21566 7.61687 8.27716C7.61687 8.33866 7.60475 8.3996 7.58112 8.45648C7.55756 8.51329 7.52306 8.56491 7.4795 8.60841L2.19434 13.8942", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
}
Uy.displayName = "LBChevronDoubleRightIcon";
function Gy(e) {
  return /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M1.88281 10.3906L7.1686 5.10547C7.21208 5.06193 7.26371 5.02739 7.32055 5.00382C7.37739 4.98025 7.43832 4.96812 7.49985 4.96812C7.56138 4.96812 7.62231 4.98025 7.67915 5.00382C7.73599 5.02739 7.78762 5.06193 7.8311 5.10547L13.1169 10.3906", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
}
Gy.displayName = "LBChevronUpIcon";
function Yy(e) {
  return /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M2.84375 10.2296L7.66875 15.0546C7.75672 15.1422 7.87583 15.1914 8 15.1914C8.12417 15.1914 8.24328 15.1422 8.33125 15.0546L13.1562 10.2296", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M2.84375 6.47961L7.66875 1.65461C7.71223 1.61107 7.76386 1.57653 7.8207 1.55296C7.87754 1.5294 7.93847 1.51727 8 1.51727C8.06153 1.51727 8.12246 1.5294 8.1793 1.55296C8.23614 1.57653 8.28777 1.61107 8.33125 1.65461L13.1562 6.47961", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
}
Yy.displayName = "LBChevronUpDownIcon";
function AI(e) {
  return /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M19.740000000000002 5.256L16.26 5.268 16.152 5.332032C15.889704000000002 5.487528 15.75912 5.708880000000001 15.757944 6C15.75696 6.237288 15.823991999999999 6.390599999999999 15.998304000000001 6.549936C16.225656 6.757728 16.02048 6.744 18.898272 6.744048L21.444 6.744096000000001 18.072 10.113744C15.725136000000001 12.458952000000002 14.668872 13.498895999999998 14.597591999999999 13.534392C14.386655999999999 13.639439999999999 14.107488 13.642992 13.908479999999999 13.543152000000001C13.868616000000001 13.52316 13.069199999999999 12.743136000000002 12.132 11.809776000000001C11.032440000000001 10.714728000000001 10.377048 10.079616 10.28436 10.019352000000001C9.829392 9.723504 9.420936 9.60852 8.905752 9.631248000000001C8.342016000000001 9.656112 7.912656 9.831384 7.481256 10.21272C7.372776000000001 10.308648 5.6736 12.00012 3.705312 13.971552C0.810024 16.871496 0.11568 17.57892 0.069312 17.676000000000002C0.0228 17.773392 0.012 17.834448 0.012 18C0.012 18.240576 0.06336 18.36972 0.222264 18.528624C0.371472 18.677832000000002 0.48427200000000004 18.726552 0.709152 18.738888000000003C1.077648 18.759144 0.702936 19.10112 4.86 14.950728C7.4448240000000006 12.37008 8.588472000000001 11.24376 8.664 11.204400000000001C8.755176 11.156903999999999 8.807544 11.148144 9 11.148144C9.192864 11.148144 9.244632 11.156832 9.336 11.204640000000001C9.409176 11.242944000000001 9.993312 11.808336 11.148 12.958464000000001C12.173232 13.979664 12.904584000000002 14.689656 12.984 14.740824000000002C13.441512 15.035616000000001 13.811304 15.135384 14.364 15.11316C14.702280000000002 15.099576 14.90772 15.053208 15.183432000000002 14.928192000000001C15.561408000000002 14.756808 15.525912 14.790408000000001 19.085256 11.235432L22.486536 7.838352 22.493256000000002 10.381176L22.5 12.924 22.555152 13.044C22.662576 13.277736 22.881312 13.44924 23.120712 13.487400000000001C23.482704000000002 13.54512 23.825064 13.347912 23.954568 13.007040000000002C23.998392 12.89172 24 12.763032 24 9.372648C24 5.881896 23.999664 5.8568880000000005 23.950536 5.725608C23.858208 5.47884 23.587944 5.273544 23.328 5.252664C23.2686 5.247912 21.654 5.2494 19.740000000000002 5.256", stroke: "none", fill: "currentColor", fillRule: "evenodd", strokeWidth: 0.024 }));
}
AI.displayName = "LBGraphStatsAscendIcon";
function II(e) {
  return /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M8.589984 3.538872C8.133456 3.655416 7.790616 3.93228 7.577304 4.356648C7.531032000000001 4.448688 6.90732 5.903328 6.191280000000001 7.58916C4.758768000000001 10.961808000000001 4.84368 10.787232000000001 4.570584 10.921632L4.452 10.98 2.508 10.992C0.57168 11.003952 0.563544 11.004216000000001 0.45036000000000004 11.056488C0.38786400000000004 11.08536 0.284112 11.161584 0.219816 11.225904C-0.143568 11.589288 -0.037896 12.196416000000001 0.42859200000000003 12.42552L0.5640000000000001 12.492 2.58 12.492L4.596 12.492 4.8 12.437712000000001C5.4309840000000005 12.269832000000001 5.962079999999999 11.845368 6.248568000000001 11.28C6.305424 11.1678 6.928512 9.71808 7.6332 8.058432C8.337888 6.39876 8.921496 5.048760000000001 8.930112000000001 5.058432C8.938704000000001 5.06808 10.005528 8.3754 11.300808 12.408C12.985032 17.651496 13.683888000000001 19.796015999999998 13.754256000000002 19.936632C13.942775999999999 20.313336 14.290920000000002 20.590392 14.714808 20.701008C14.906400000000001 20.751024 15.250079999999999 20.750808 15.444 20.700576C15.87564 20.58876 16.231392 20.295552 16.422792 19.893864C16.481976 19.76964 17.106648 18.140784 17.810952 16.274184C19.036176 13.02708 19.09608 12.875304 19.197167999999998 12.762863999999999C19.255296 12.698231999999999 19.357992 12.616248 19.425408 12.580680000000001L19.548000000000002 12.516 21.492 12.504L23.436 12.492 23.573136 12.424655999999999C23.735712000000003 12.344832000000002 23.885256000000002 12.184344 23.942736 12.028008C23.965392 11.9664 23.992944 11.905728 24.00396 11.8932C24.030383999999998 11.863128000000001 24.03 11.561448 24.003552000000003 11.577792C23.99232 11.584752 23.970768000000003 11.549208 23.955672 11.498808C23.888328 11.274000000000001 23.642256000000003 11.064912 23.388 11.016432C23.284896 10.9968 22.698768 10.991496 21.324 10.997832C19.598376000000002 11.005776000000001 19.388208 11.010888 19.248 11.04816C18.805775999999998 11.165784 18.499752 11.33544 18.183312 11.638344C17.974872 11.837904 17.83188 12.037392 17.714928 12.291744C17.664288 12.40188 17.051616000000003 14.006447999999999 16.353432 15.857448C15.481008000000001 18.1704 15.078287999999999 19.209936 15.065688 19.181448C15.055632 19.158648000000003 13.989047999999999 15.846 12.695496000000002 11.82C11.29716 7.4678640000000005 10.308864 4.4290080000000005 10.257935999999999 4.324896C10.118928 4.040712 9.821808 3.7572000000000005 9.53412 3.6342239999999997C9.257760000000001 3.5160959999999997 8.843184 3.4742159999999997 8.589984 3.538872M0.007872 11.748000000000001C0.007992 11.8404 0.012312 11.875248000000001 0.01752 11.825472000000001C0.022704 11.775672 0.022632 11.700072 0.017328 11.657472C0.012024 11.614848 0.007776000000000001 11.6556 0.007872 11.748000000000001", stroke: "none", fill: "currentColor", fillRule: "evenodd", strokeWidth: 0.024 }));
}
II.displayName = "LBGraphStatsIcon";
function OI(e) {
  return /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M2.563824 0.79128C2.10852 0.887304 1.7771040000000002 1.060944 1.44384 1.378056C1.126584 1.679928 0.9269040000000001 2.026224 0.799272 2.496C0.7591680000000001 2.643624 0.7565040000000001 3.1470719999999996 0.749592 11.868C0.7443839999999999 18.451176 0.7498319999999999 21.141792000000002 0.7686240000000001 21.286272C0.886992 22.1964 1.535592 22.928544 2.4468 23.180592L2.676 23.244 12 23.244L21.324 23.244 21.5532 23.180592C22.449312000000003 22.93272 23.081352 22.234992 23.221344000000002 21.339024C23.25312 21.135744 23.256576 19.999512 23.250264 11.88C23.243496 3.147336 23.240832 2.643624 23.200728 2.496C22.985496 1.70388 22.460184 1.1196 21.744336 0.8761200000000001C21.3282 0.734568 22.022448 0.743856 11.97936 0.74568C3.153816 0.7473120000000001 2.76336 0.749208 2.563824 0.79128M2.751888 2.293104C2.54304 2.3698319999999997 2.351616 2.569872 2.2894560000000004 2.77644C2.2614 2.86968 2.2560000000000002 3.5627280000000003 2.2560000000000002 7.071768L2.2560000000000002 11.255904 12.000264000000001 11.255904L21.744528000000003 11.255904 21.738264 7.025952L21.732 2.7960000000000003 21.672312 2.679144C21.596256 2.5301760000000004 21.460296 2.3942400000000004 21.31668 2.323512L21.204 2.2680000000000002 12.024000000000001 2.263632C4.17744 2.259912 2.830632 2.264208 2.751888 2.293104M2.261736 16.973928L2.2680000000000002 21.204 2.331864 21.32496C2.417544 21.487296 2.578272 21.630432000000003 2.744856 21.69276L2.8818 21.744 7.068960000000001 21.744L11.25612 21.744 11.250072 17.25L11.244 12.756 6.7497359999999995 12.749927999999999L2.2554719999999997 12.74388 2.261736 16.973928M12.760008000000001 12.760008000000001C12.751199999999999 12.768792000000001 12.744 14.793792 12.744 17.260008000000003L12.744 21.744 16.931088 21.744L21.118199999999998 21.744 21.255144 21.69276C21.421728 21.630432000000003 21.582456 21.487296 21.668136 21.32496L21.732 21.204 21.738264 16.974L21.744528000000003 12.744 17.260272 12.744C14.793912 12.744 12.768792000000001 12.751199999999999 12.760008000000001 12.760008000000001", stroke: "none", fill: "currentColor", fillRule: "evenodd", strokeWidth: 0.024 }));
}
OI.displayName = "LBLayoutIcon";
function NI(e) {
  return /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M3.4859280000000004 0.026208000000000002C3.215112 0.058128000000000006 3.032568 0.11268 2.76828 0.240624C2.136816 0.5463600000000001 1.6919520000000001 1.1149440000000002 1.5424560000000003 1.807368C1.502232 1.993656 1.5 2.529624 1.5 12C1.5 20.130768 1.505856 22.02696 1.531392 22.161888C1.6856879999999999 22.9776 2.266776 23.637168 3.072 23.910576L3.3000000000000003 23.988 12 23.988L20.7 23.988 20.928 23.910576C21.709296 23.645304 22.258344 23.043216 22.457904 22.232856C22.495488 22.080312000000003 22.499088 21.5502 22.506072000000003 15.132C22.511064 10.527984 22.505376000000002 8.112792 22.489079999999998 7.948512C22.445976 7.513776 22.343136 7.219128 22.114776 6.876C21.932064 6.601512 15.865272000000001 0.53844 15.612 0.377232C15.397848 0.24091200000000002 15.154752 0.134856 14.90052 0.066816L14.700000000000001 0.013152 9.18 0.009408C6.144 0.007368 3.581664 0.014928 3.4859280000000004 0.026208000000000002M3.544224 1.54812C3.330168 1.6069440000000002 3.132 1.7882639999999999 3.050592 1.999776C3.015408 2.091144 3.0113760000000003 2.9676 3.004992 11.928C2.999904 19.055136 3.005304 21.795576 3.0246239999999998 21.900000000000002C3.057912 22.079856 3.1767600000000003 22.266696 3.3210480000000002 22.365984C3.5499359999999998 22.523448 2.8697280000000003 22.512 12 22.512C21.124248 22.512 20.450352 22.523256 20.677296 22.367112C20.814768 22.272528 20.928552 22.104288 20.967792 21.937608C20.993327999999998 21.8292 20.999328 20.59884 20.999616 15.415128000000001L21 9.026232 18.222 9.01764C15.722256000000002 9.009912 15.427272 9.005016 15.277104000000001 8.968752C14.398584000000001 8.75664 13.756272000000001 8.113776 13.54272 7.232856000000001C13.506888000000002 7.085016 13.501895999999999 6.781248000000001 13.49436 4.29L13.485936 1.512 8.572968 1.514136C4.572048000000001 1.515888 3.6384960000000004 1.5222 3.544224 1.54812M15.000383999999999 4.320048C15.000672000000002 6.2834639999999995 15.007344000000002 6.832007999999999 15.032208 6.937608C15.071496000000002 7.10448 15.185256 7.272552000000001 15.323160000000001 7.367424C15.539976000000001 7.516584 15.462384 7.512840000000001 18.187056 7.50612L20.664072 7.5 17.832048 4.668048000000001L15 1.8360720000000001 15.000383999999999 4.320048M9.489768 8.888856C9.344784 8.92512 9.231624 8.99148 9.129071999999999 9.100416000000001C9.087864 9.144192 8.581392 9.8118 8.003592000000001 10.584C7.425768 11.356200000000001 6.948864 11.992824 6.9437999999999995 11.998704C6.938736 12.004584 6.646007999999999 11.722392 6.293304 11.371608C5.700888 10.782408 5.641032 10.729728 5.508 10.680528C5.142024 10.54512 4.732272 10.719168 4.56696 11.080248000000001C4.520016 11.1828 4.506672 11.250936 4.506672 11.388C4.506672 11.706479999999999 4.534008 11.744688 5.323032 12.528C6.04908 13.248816 6.136488000000001 13.318512 6.459960000000001 13.434552C6.611928000000001 13.489056 6.675384 13.49784 6.924 13.498848C7.157184 13.499784 7.243968 13.489872 7.38 13.446768C7.590048 13.380216 7.808712 13.251456000000001 7.96524 13.102152C8.151192 12.924816 10.333656000000001 10.001088 10.378632 9.869088C10.420968 9.744864 10.427159999999999 9.533184 10.392168 9.40716C10.289280000000002 9.036864 9.867216 8.79444 9.489768 8.888856M12.576 12.032568000000001C12.242616 12.104712000000001 11.999688 12.417648000000002 12.00024 12.774263999999999C12.000648 13.042176 12.163968 13.299696 12.42 13.436064L12.540000000000001 13.5 15 13.5L17.46 13.5 17.580000000000002 13.436064C18.00744 13.208376000000001 18.13044 12.680015999999998 17.843496000000002 12.304248000000001C17.737896 12.165936 17.560488 12.057912 17.385912 12.025632C17.181288 11.987808000000001 12.753383999999999 11.994192 12.576 12.032568000000001M9.440760000000001 15.648743999999999C9.222432 15.716040000000001 9.173136 15.773328 8.057447999999999 17.256C7.466424 18.0414 6.972887999999999 18.7002 6.960696 18.72C6.943175999999999 18.748416 6.80568 18.623688 6.307248 18.1272C5.590896 17.413656 5.560992 17.392680000000002 5.256 17.390736C5.111016 17.3898 5.05032 17.401608 4.944 17.451504C4.664592 17.582568 4.506672 17.828304 4.506672 18.132C4.506672 18.450984000000002 4.532784 18.487368 5.33496 19.28556C5.980872000000001 19.928256 6.051312 19.990968 6.230735999999999 20.08308C6.337848 20.138064 6.494447999999999 20.199288 6.578735999999999 20.219160000000002C6.774888 20.265408 7.097112000000001 20.265408 7.293264000000001 20.219160000000002C7.4833680000000005 20.174352 7.774296 20.024544 7.928472 19.892112C8.059872 19.779216 10.239696 16.890768 10.341000000000001 16.695312C10.395528 16.590096 10.403952 16.544567999999998 10.403592 16.356863999999998C10.403112 16.10772 10.361136 16.001136000000002 10.200000000000001 15.84C10.05204 15.69204 9.930552 15.640848 9.708 15.63264C9.602400000000001 15.628752 9.482136 15.636000000000001 9.440760000000001 15.648743999999999M12.576 18.032568C12.242616 18.104712000000003 11.999688 18.417648 12.00024 18.774264C12.000648 19.042176 12.163968 19.299696 12.42 19.436064000000002L12.540000000000001 19.5 15 19.5L17.46 19.5 17.580000000000002 19.436064000000002C18.00744 19.208376 18.13044 18.680016 17.843496000000002 18.304248C17.737896 18.165936 17.560488 18.057912 17.385912 18.025632C17.181288 17.987808 12.753383999999999 17.994192 12.576 18.032568", stroke: "none", fill: "currentColor", fillRule: "evenodd", strokeWidth: 0.024 }));
}
NI.displayName = "LBListToDoIcon";
function DI(e) {
  return /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M6.96 3.026472C6.241848 3.1072080000000004 5.450232 3.3886559999999997 4.872 3.7688159999999997C4.53756 3.9887040000000002 4.38468 4.110768 4.107480000000001 4.3792800000000005C2.79096 5.654472 2.299344 7.551648 2.833776 9.294456C3.392664 11.116896 4.973376 12.461471999999999 6.845184000000001 12.706584000000001C7.141296 12.745368000000001 7.200311999999999 12.768 7.005288 12.768C6.830976000000001 12.768 6.352488 12.828287999999999 6.04476 12.889032C4.856663999999999 13.123536 3.717072 13.658856 2.760288 14.431920000000002C2.4869280000000002 14.652792 1.855008 15.292848000000001 1.6341119999999998 15.572591999999998C0.6130800000000001 16.865712000000002 0.026112000000000003 18.472392 0.01524 20.004C0.012048 20.454743999999998 0.012744 20.461392 0.075936 20.580000000000002C0.318264 21.034920000000003 0.9041279999999999 21.14064 1.26096 20.793816C1.4499360000000001 20.610144 1.487328 20.493288 1.51248 20.007504C1.524384 19.777608 1.5515280000000002 19.47756 1.572792 19.34076C1.9449600000000002 16.94592 3.7291440000000002 14.99928 6.077112 14.42628C6.6012 14.29836 6.8644799999999995 14.269344000000002 7.5 14.269344000000002C8.135520000000001 14.269344000000002 8.3988 14.29836 8.922888 14.42628C10.753776 14.873088 12.294599999999999 16.183272 13.017 17.907552000000003C13.310496 18.608040000000003 13.443096 19.203072000000002 13.487448 20.018616C13.506768000000001 20.373504 13.5174 20.443464000000002 13.569168 20.556576C13.832927999999999 21.13272 14.628264 21.146472 14.92248 20.580000000000002C15.001584000000001 20.427648 15.017520000000001 20.1624 14.977392 19.665143999999998C14.855784 18.158304 14.306904 16.76436 13.365888000000002 15.572591999999998C13.117439999999998 15.257952000000001 12.494591999999999 14.635128000000002 12.175152 14.381904C11.250048 13.648536 10.144728 13.13172 9.00672 12.900408000000002C8.666640000000001 12.831287999999999 8.182968 12.768 7.994712 12.768C7.799688000000001 12.768 7.858704 12.745368000000001 8.154816 12.706584000000001C11.045856 12.328008 12.96084 9.457992 12.213096 6.624384000000001C11.699615999999999 4.678536 10.025640000000001 3.244848 8.010936 3.025392C7.743672000000001 2.99628 7.223808000000001 2.996808 6.96 3.026472M16.080000000000002 3.013608C16.047 3.019248 15.922800000000002 3.035856 15.804 3.05052C15.249672 3.1189200000000006 14.552832000000002 3.362952 14.03124 3.6713280000000004C13.678416 3.879936 13.565184 4.0155840000000005 13.512648000000002 4.292568C13.455048 4.596312 13.623216000000001 4.9345680000000005 13.90584 5.083416C14.013504 5.140128 14.055144 5.147784000000001 14.256768000000001 5.14788L14.485536 5.148 14.700768000000002 5.024592C15.178536 4.75068 15.467256 4.64064 15.924 4.558416C16.171416 4.513872 16.2678 4.508424 16.608 4.519896C17.183256 4.539288 17.55984 4.63548 18.050352 4.888392C18.37872 5.057688 18.656760000000002 5.267784000000001 18.928296 5.551824C19.843439999999998 6.509064 20.113728000000002 7.874016 19.631928 9.105096000000001C19.095576 10.475592 17.72052 11.34156 16.255896 11.231208C15.70512 11.189712 15.234816 11.040887999999999 14.750712000000002 10.754952C14.490264 10.601136 14.40564 10.575744 14.198712000000002 10.589304C13.909104000000001 10.608312 13.67376 10.771152 13.551648000000002 11.037072C13.438775999999999 11.282856 13.5084 11.654352000000001 13.704047999999998 11.850264000000001C13.791048 11.93736 14.077656 12.115392 14.352 12.252696C14.763743999999999 12.458808 15.386351999999999 12.649464000000002 15.815496000000001 12.700872C16.065048 12.730775999999999 16.155192 12.768 15.978024 12.768C15.686088 12.768 14.876664 12.906287999999998 14.68152 12.989496C14.529936 13.054152 14.344655999999999 13.25748 14.291496 13.417536C14.234471999999998 13.589208 14.250504 13.846656 14.327736000000002 13.999608C14.398248 14.139216000000001 14.558112 14.291712000000002 14.699616 14.354304C14.867040000000001 14.428368 14.990496000000002 14.433888000000001 15.277488 14.380128000000001C15.822696 14.278056 15.921672000000001 14.269079999999999 16.5 14.2692C17.116704000000002 14.269319999999999 17.37168 14.296415999999999 17.861064 14.413824C19.72308 14.860512 21.236448 16.124856 21.995544 17.868000000000002C22.2996 18.566208 22.442472 19.191792 22.487688 20.022888000000002C22.506768 20.373456 22.517471999999998 20.443656 22.569167999999998 20.556576C22.832976000000002 21.132768000000002 23.627280000000003 21.146520000000002 23.922719999999998 20.580000000000002C23.975328 20.479128 23.98692 20.420424 23.995464000000002 20.211576C24.011856 19.810944 23.9376 19.140408 23.817312 18.602928C23.519280000000002 17.270976 22.842336 16.019976 21.888888 15.039167999999998C20.629632 13.743744 18.964416 12.940895999999999 17.215680000000003 12.786024C17.041704 12.770616 16.90464 12.749448 16.911096 12.739008C16.917552 12.728544 16.96332 12.72 17.012784 12.72C17.062272 12.72 17.215992 12.699192000000002 17.354400000000002 12.673775999999998C18.336312 12.493368 19.164047999999998 12.068760000000001 19.877448 11.379504C20.675328 10.608672 21.166608 9.647856 21.327288 8.544C21.371088 8.243136 21.376704 7.562112000000001 21.337752 7.272C21.073848 5.305848 19.699632 3.711648 17.811287999999998 3.18096C17.397384 3.064632 17.079984000000003 3.0204 16.596 3.011616C16.3452 3.007056 16.113 3.007968 16.080000000000002 3.013608M7.008 4.53972C6.454104 4.632096 5.952912 4.837776000000001 5.5171920000000005 5.15148C5.272368 5.3277600000000005 4.8697680000000005 5.744016 4.708104 5.988C4.453320000000001 6.372528 4.264872 6.834336 4.183752 7.272936C4.121616 7.608887999999999 4.127664 8.212776 4.1964 8.536512C4.450416 9.73296 5.2724400000000005 10.668096 6.418968 11.064912C7.08756 11.29632 7.91244 11.29632 8.581032 11.064912C10.421280000000001 10.428 11.344968 8.407416000000001 10.619568000000001 6.605568000000001C10.230408 5.638896 9.348840000000001 4.869048 8.331840000000001 4.607760000000001C7.982184 4.517904000000001 7.337400000000001 4.484784 7.008 4.53972", stroke: "none", fill: "currentColor", fillRule: "evenodd", strokeWidth: 0.024 }));
}
DI.displayName = "LBMultipleNeutralIcon";
function BI(e) {
  return /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M11.736 0.052176C11.628864 0.09249600000000001 11.556456 0.149904 11.351616 0.356928C10.940328 0.772632 10.476672 1.363992 10.130400000000002 1.914504C9.276576 3.2719679999999998 8.778576000000001 4.752312 8.6268 6.384C8.587728 6.804096 8.582304 7.638408 8.616192 8.014608C8.628624 8.15244 8.635704 8.268312 8.631912 8.27208C8.628143999999999 8.275848 8.54472 8.22888 8.446536 8.16768C8.1918 8.008944000000001 7.688184000000001 7.745280000000001 7.38 7.60932C6.299208 7.132536000000001 5.205528 6.8802 4.08 6.847944000000001C3.6430560000000005 6.83544 3.60312 6.837912 3.47832 6.885384C3.321096 6.945168000000001 3.1550160000000003 7.10016 3.07008 7.266336000000001C3.0144480000000002 7.375224 3.012072 7.399152 3.013728 7.836C3.020544 9.629136 3.67788 11.534736 4.809144 13.04088C5.682984 14.20428 6.807528 15.127199999999998 8.115936 15.754752C9.033936 16.195056 9.9192 16.456248000000002 10.92 16.582032L11.244 16.62276 11.256 18.169392L11.268 19.716 11.324016 19.824C11.465232 20.09628 11.699976000000001 20.241144 12 20.241144C12.23196 20.241144 12.389184 20.17476 12.540576 20.012904C12.743064 19.796424000000002 12.730488000000001 19.910448 12.744 18.169392L12.756 16.62276 13.08 16.582032C14.478288 16.406280000000002 15.751704 15.935784 16.945968 15.153672C19.006248 13.804416 20.449224 11.601216 20.866248000000002 9.168000000000001C20.959751999999998 8.622432 20.9844 8.351496 20.986272 7.848C20.987904 7.405536000000001 20.984976 7.373856000000001 20.932488 7.267320000000001C20.86584 7.13196 20.714376 6.975336 20.581224000000002 6.904056C20.490192 6.855312 20.452608 6.852096 19.992 6.853632C18.550968 6.858456 16.962623999999998 7.319592 15.639816 8.117208C15.509904 8.195544 15.3996 8.255592 15.394680000000001 8.250696C15.38976 8.245776000000001 15.395976000000001 8.118048 15.408479999999999 7.9668719999999995C15.461256000000002 7.328712 15.423816 6.431448 15.31488 5.724C15.021168 3.816552 14.206199999999999 2.087304 12.898752 0.597216C12.596952000000002 0.253296 12.432144 0.10848 12.275928 0.05004C12.105504 -0.013727999999999999 11.90904 -0.012936000000000001 11.736 0.052176M11.875368 2.053848C11.238648 2.8467360000000004 10.690536000000002 3.941664 10.402824 4.99536C10.201128 5.734032 10.128816 6.238128000000001 10.111032 7.028976000000001C10.092048 7.873463999999999 10.14624 8.426664 10.321752 9.18C10.448568000000002 9.724416000000002 10.523208 9.926568000000001 10.653408 10.078176C11.093664 10.590816 11.537112 11.284176 11.856 11.958432C11.9286 12.111936 11.993400000000001 12.237528 12 12.237528C12.006599999999999 12.237528 12.0714 12.111936 12.144 11.958432C12.468408000000002 11.272488000000001 12.918576 10.571544 13.362792 10.06068C13.511928 9.889175999999999 13.576775999999999 9.717384000000001 13.70424 9.156C13.877472 8.393184 13.932648000000002 7.826352000000001 13.9128 7.0134479999999995C13.877328 5.560248 13.486368 4.1901600000000006 12.752088 2.945544C12.571368000000001 2.639256 12.237792 2.151768 12.100848000000001 1.993848L12.008784 1.887696 11.875368 2.053848M4.5504 8.398007999999999C4.535880000000001 8.425104 4.63128 9.01524 4.69428 9.288C5.3505840000000005 12.129624 7.541112000000001 14.31324 10.386312 14.962104000000002C10.684992000000001 15.030216000000001 11.179488000000001 15.108504 11.197464 15.090528C11.21316 15.074832 11.147544 14.625167999999999 11.08632 14.328648000000001C10.870416 13.283304000000001 10.37532 12.190968 9.733152 11.343096000000001C8.694672 9.972024 7.25136 9.006864 5.600688 8.579664C5.2074240000000005 8.47788 4.566936 8.367096 4.5504 8.398007999999999M19.356 8.39292C17.524632 8.640312 15.881256000000002 9.497232 14.700000000000001 10.820664C13.632768 12.016392 13.027272 13.345752 12.804576 14.982000000000001C12.785736000000002 15.12048 12.760248 15.117144 13.228104000000002 15.03732C15.287136000000002 14.686008000000001 17.10012 13.503383999999999 18.252408000000003 11.76C18.8184 10.903632 19.225632 9.867672 19.389192 8.868C19.449408000000002 8.499984 19.463352 8.375112000000001 19.44372 8.3796C19.43508 8.381568000000001 19.395599999999998 8.387568000000002 19.356 8.39292M4.98 21.047304C4.9125119999999995 21.074136000000003 4.781208 21.164687999999998 4.68 21.254232C4.241064000000001 21.642504 3.933576 21.849024 3.4557840000000004 22.076472C2.74308 22.415712000000003 2.02332 22.561032 1.240344 22.523736C0.6416879999999999 22.495224 0.5887920000000001 22.499184 0.412968 22.585704C-0.134688 22.8552 -0.131496 23.633616 0.418488 23.923872L0.54 23.988 1.364592 23.99544C2.2302 24.003264 2.325816 23.996256000000002 2.8018080000000003 23.889936C3.645192 23.701584 4.404744 23.352576 5.192424 22.791552C5.211168 22.778208 5.298096 22.828896 5.442504 22.937328C7.200048000000001 24.257136000000003 9.584808 24.356712 11.448 23.188032C11.5206 23.142504 11.674224 23.035680000000003 11.7894 22.950648L11.998824 22.796064 12.2454 22.974888C14.155680000000002 24.36036 16.69644 24.341231999999998 18.5712 22.927248000000002C18.681504 22.844064 18.778008 22.776 18.785688 22.776C18.793368 22.776 18.854616 22.816944 18.921816 22.866984000000002C19.62516 23.390712 20.55324 23.78052 21.5022 23.9508C21.74244 23.993904 21.875088 24 22.573439999999998 24C23.53284 24 23.549927999999998 23.996760000000002 23.772000000000002 23.773056C23.877768 23.666520000000002 23.930328 23.589528 23.97 23.483064000000002C24.025152000000002 23.335008000000002 24.045768000000002 23.071704 24 23.1C23.986656 23.108232 23.975904 23.090208 23.975784 23.059416C23.975448 22.981224 23.849664 22.7712 23.755416 22.691496C23.631552000000003 22.586736000000002 23.445456 22.511448 23.300784 22.50756C23.22996 22.505664 22.986432 22.512936 22.759656 22.523736C21.535968 22.582008000000002 20.369208 22.165368 19.404 21.325464C19.082736 21.045912 18.960768 20.98992 18.708000000000002 21.00588C18.484944000000002 21.019992 18.344904 21.094392 18.132 21.311880000000002C17.583816 21.871920000000003 16.895064 22.252728 16.130784 22.418328C15.773328 22.495800000000003 15.147167999999999 22.50732 14.770800000000001 22.443384C14.232912 22.351992 13.671432000000001 22.128696 13.244904 21.836592C13.123584000000001 21.75348 12.891576 21.559464000000002 12.729312000000002 21.405456C12.3636 21.058296 12.2778 21.012 12 21.012C11.723784 21.012 11.642304000000001 21.055992 11.271984 21.405192000000003C10.833648 21.818496000000003 10.463184 22.05732 9.970824 22.244040000000002C8.97708 22.620912 7.887887999999999 22.565352 6.93168 22.088976000000002C6.537336000000001 21.892536 6.2506319999999995 21.683568 5.88 21.322464C5.621592000000001 21.070704000000003 5.521896 21.018168 5.282664 21.007632C5.14248 21.001464000000002 5.072088 21.01068 4.98 21.047304M0.00768 23.256C0.00768 23.341800000000003 0.012048 23.376912 0.017352 23.334C0.02268 23.291088 0.02268 23.220912000000002 0.017352 23.178C0.012048 23.135088 0.00768 23.170199999999998 0.00768 23.256", stroke: "none", fill: "currentColor", fillRule: "evenodd", strokeWidth: 0.024 }));
}
BI.displayName = "LBOrganicPlantGrowIcon";
function FI(e) {
  return /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M11.628 0.013488000000000002C11.5884 0.018840000000000003 11.4642 0.035232 11.352 0.049872C10.449504000000001 0.16776000000000002 9.564504000000001 0.600768 8.884824 1.2570000000000001C8.188368 1.929432 7.815767999999999 2.617464 7.574447999999999 3.6767999999999996L7.559688 3.7416240000000003 5.861832 3.7500959999999997C3.918816 3.7597919999999996 3.9840959999999996 3.753288 3.516 3.983376C2.931288 4.270776000000001 2.502288 4.784472 2.3228880000000003 5.412L2.2680000000000002 5.604 2.2680000000000002 13.884L2.2680000000000002 22.164 2.334216 22.375128C2.485728 22.858128 2.767608 23.26596 3.1390320000000003 23.53956C3.420528 23.746896 3.624168 23.844504 3.984 23.944608000000002C4.1330160000000005 23.986056 4.492032 23.988 12.012 23.988L19.884 23.988 20.1 23.921448C20.881128 23.680752 21.424608 23.14404 21.665784 22.375128L21.732 22.164 21.738576000000002 13.98C21.743184 8.2512 21.737448 5.745624 21.719448 5.62812C21.613152 4.933872 21.140544000000002 4.304544 20.484 3.982968C20.015064000000002 3.753264 20.08068 3.7597919999999996 18.138168 3.7500959999999997L16.440312000000002 3.7416240000000003 16.425552 3.6767999999999996C16.184496000000003 2.61864 15.810863999999999 1.928688 15.115176 1.2570000000000001C14.452056 0.616752 13.650336000000001 0.21516 12.72 0.057192C12.522456 0.02364 11.774184 -0.006288 11.628 0.013488000000000002M11.616 1.52628C11.176344 1.6045200000000002 10.814256 1.72956 10.500960000000001 1.911336C10.251048 2.056368 10.13148 2.147808 9.915336 2.3592C9.373464 2.889192 9.083856 3.509832 9.022776 4.272C9.008472000000001 4.450200000000001 8.980824 4.652496 8.961312 4.721568C8.893056 4.963032 8.665583999999999 5.177951999999999 8.423207999999999 5.2299359999999995C8.34132 5.24748 7.659719999999999 5.256 6.335088 5.256C4.452168 5.256 4.3633440000000006 5.257968 4.24692 5.3022C4.060944 5.3728560000000005 3.926256 5.497152 3.8352000000000004 5.68212L3.7560000000000002 5.842992 3.749184 13.775496C3.7443120000000003 19.426416 3.74988 21.752256000000003 3.768552 21.86184C3.782952 21.946464000000002 3.810936 22.047 3.8307360000000004 22.08528C3.8977440000000003 22.21488 4.043375999999999 22.3512 4.188 22.419719999999998L4.332 22.487952 12 22.487952L19.668 22.487952 19.812 22.419719999999998C19.957248 22.350912 20.102304 22.214807999999998 20.170056 22.083744C20.190288 22.044624 20.218176 21.938664 20.232 21.848304C20.249256000000003 21.735576000000002 20.255088 19.197623999999998 20.250576 13.763496000000002L20.244 5.842992 20.164800000000003 5.68212C20.073743999999998 5.497152 19.939056 5.3728560000000005 19.75308 5.3022C19.636656 5.257968 19.547832000000003 5.256 17.664912 5.256C16.34028 5.256 15.658680000000002 5.24748 15.576792000000001 5.2299359999999995C15.334416 5.177951999999999 15.106944 4.963032 15.038687999999999 4.721568C15.019176 4.652496 14.991528 4.450200000000001 14.977224000000001 4.272C14.916144 3.509832 14.626536 2.889192 14.084664 2.3592C13.781232 2.06244 13.472976000000001 1.8627360000000002 13.092 1.716096C12.712944 1.5702 12.513192000000002 1.5325199999999999 12.072000000000001 1.523592C11.8542 1.5191999999999999 11.649000000000001 1.5204 11.616 1.52628M11.786256 3.0271440000000003C11.49504 3.07548 11.15484 3.322584 11.010792 3.590376C10.780512 4.01844 10.840416000000001 4.5297600000000005 11.162064 4.881672C11.39292 5.134296 11.665392 5.256 12 5.256C12.334608000000001 5.256 12.60708 5.134296 12.837936 4.881672C13.066176 4.631952 13.161144 4.3157760000000005 13.111488000000001 3.9710640000000006C13.043040000000001 3.49584 12.659424 3.101424 12.192 3.025656C12.014568 2.99688 11.967504 2.997072 11.786256 3.0271440000000003M16.032 10.562688000000001C15.9096 10.609608 15.691199999999998 10.821888 13.03176 13.47864C11.45424 15.0546 10.152792 16.344 10.139664 16.344C10.126536000000002 16.344 9.668856000000002 15.896976 9.122615999999999 15.350616C8.428656 14.656488000000001 8.096088 14.340336 8.018735999999999 14.301143999999999C7.859640000000001 14.220576 7.594296 14.210424 7.41432 14.278008000000002C7.257096000000001 14.337048 7.0913520000000005 14.491464 7.006080000000001 14.658336C6.922248000000001 14.822376000000002 6.922584 15.128160000000001 7.0068 15.3C7.09512 15.480216 9.116832 17.496744 9.336 17.623248C9.838152000000001 17.913048 10.453608000000001 17.909424 10.961808000000001 17.613672C11.066544 17.552712000000003 11.806583999999999 16.827192 14.018808 14.616624C16.379640000000002 12.257544 16.948536 11.677056 16.994808 11.58C17.041392000000002 11.482248 17.051904 11.422152 17.051424 11.256C17.050944 11.082504 17.041368000000002 11.034048 16.987488 10.932C16.911168 10.787424 16.778280000000002 10.655904 16.632 10.580184000000001C16.479216 10.501104 16.212912 10.493352 16.032 10.562688000000001", stroke: "none", fill: "currentColor", fillRule: "evenodd", strokeWidth: 0.024 }));
}
FI.displayName = "LBTaskListCheckIcon";
function ln(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M3.3125 13.0421L12.6875 3.66711", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M3.3125 3.66711L12.6875 13.0421", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
}
ln.displayName = "LBXIcon";
function zr(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17349_742)" }, /* @__PURE__ */ d.createElement("path", { d: "M15.0312 1.32274L5.59875 14.7971C5.4743 14.9759 5.30913 15.1226 5.11686 15.2251C4.92459 15.3276 4.71072 15.3829 4.49288 15.3865C4.27503 15.3901 4.05945 15.3419 3.8639 15.2458C3.66835 15.1498 3.49842 15.0086 3.36812 14.834L0.96875 11.6352", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17349_742" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" }))));
}
zr.displayName = "LBCheckIcon";
function Zy(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17390_168)" }, /* @__PURE__ */ d.createElement("path", { d: "M14.3687 2.16317C14.1559 1.9512 13.9032 1.7835 13.6251 1.66977C13.3471 1.55603 13.0493 1.49852 12.7489 1.50056C12.4485 1.50259 12.1515 1.56413 11.875 1.68162C11.5985 1.7991 11.3481 1.97021 11.1381 2.18505L2.07562 11.2475L0.96875 15.5632L5.28438 14.4563L14.3469 5.3938C14.5617 5.18384 14.7328 4.93339 14.8503 4.65692C14.9678 4.38045 15.0293 4.08344 15.0314 3.78305C15.0334 3.48265 14.9759 3.18484 14.8622 2.9068C14.7484 2.62876 14.5807 2.37602 14.3687 2.16317Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M10.8789 2.44442L14.0877 5.65317", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M9.56982 3.75317L12.7786 6.96192", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M2.07568 11.2475L5.28756 14.4532", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17390_168" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.531921)" }))));
}
Zy.displayName = "LBEditIcon";
function $I(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M5.65625 3.35461H10.8125C11.3098 3.35461 11.7867 3.55216 12.1383 3.90379C12.49 4.25542 12.6875 4.73233 12.6875 5.22961V9.44836", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M10.3438 13.6671H5.1875C4.69022 13.6671 4.21331 13.4696 3.86167 13.1179C3.51004 12.7663 3.3125 12.2894 3.3125 11.7921V7.57336", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M10.3438 7.10274L12.6875 9.44649L15.0312 7.10274", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M5.65625 9.91524L3.3125 7.57149L0.96875 9.91524", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
}
$I.displayName = "LBReplaceSwitchIcon";
function WI(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17821_3680)" }, /* @__PURE__ */ d.createElement("path", { d: "M0.96875 8.35461H15.0312", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M8 1.32336V15.3859", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17821_3680" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" }))));
}
WI.displayName = "LBPlusIcon";
function Ky(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M6.76164 3.95908C6.57411 3.77155 6.46875 3.51719 6.46875 3.25198C6.46875 2.98676 6.57411 2.73241 6.76164 2.54487C6.94918 2.35733 7.20353 2.25198 7.46875 2.25198C7.73397 2.25198 7.98832 2.35733 8.17586 2.54487C8.36339 2.73241 8.46875 2.98676 8.46875 3.25198C8.46875 3.51719 8.36339 3.77155 8.17586 3.95908C7.98832 4.14662 7.73397 4.25198 7.46875 4.25198C7.20353 4.25198 6.94918 4.14662 6.76164 3.95908Z", fill: "#18181B", stroke: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M6.76164 9.06173C6.57411 8.87419 6.46875 8.61983 6.46875 8.35462C6.46875 8.0894 6.57411 7.83505 6.76164 7.64751C6.94918 7.45997 7.20353 7.35462 7.46875 7.35462C7.73397 7.35462 7.98832 7.45997 8.17586 7.64751C8.36339 7.83505 8.46875 8.0894 8.46875 8.35462C8.46875 8.61983 8.36339 8.87419 8.17586 9.06173C7.98832 9.24926 7.73397 9.35462 7.46875 9.35462C7.20353 9.35462 6.94918 9.24926 6.76164 9.06173Z", fill: "#18181B", stroke: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M6.76164 14.1644C6.57411 13.9768 6.46875 13.7225 6.46875 13.4573C6.46875 13.192 6.57411 12.9377 6.76164 12.7502C6.94918 12.5626 7.20353 12.4573 7.46875 12.4573C7.73397 12.4573 7.98832 12.5626 8.17586 12.7502C8.36339 12.9377 8.46875 13.192 8.46875 13.4573C8.46875 13.7225 8.36339 13.9768 8.17586 14.1644C7.98832 14.3519 7.73397 14.4573 7.46875 14.4573C7.20353 14.4573 6.94918 14.3519 6.76164 14.1644Z", fill: "#18181B", stroke: "currentColor" }));
}
Ky.displayName = "LBKebabIcon";
function VI(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17818_2400)" }, /* @__PURE__ */ d.createElement("path", { d: "M0.96875 11.2672L4.95192 15.386H11.0481L15.0312 11.2672V5.44211L11.0481 1.32336H4.95192L0.96875 5.44211V11.2672Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M8 11.5407C7.87056 11.5407 7.76562 11.4357 7.76562 11.3063C7.76562 11.1768 7.87056 11.0719 8 11.0719", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M8 11.5407C8.12944 11.5407 8.23438 11.4357 8.23438 11.3063C8.23438 11.1768 8.12944 11.0719 8 11.0719", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M8 9.19693V4.04065", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17818_2400" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" }))));
}
VI.displayName = "LBStopSignIcon";
function HI(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17902_126)" }, /* @__PURE__ */ d.createElement("path", { d: "M1.64941 2.99774C1.64941 3.35296 1.79053 3.69364 2.04171 3.94482C2.29289 4.196 2.63356 4.33711 2.98879 4.33711C3.34401 4.33711 3.68469 4.196 3.93587 3.94482C4.18705 3.69364 4.32816 3.35296 4.32816 2.99774C4.32816 2.64251 4.18705 2.30184 3.93587 2.05066C3.68469 1.79948 3.34401 1.65836 2.98879 1.65836C2.63356 1.65836 2.29289 1.79948 2.04171 2.05066C1.79053 2.30184 1.64941 2.64251 1.64941 2.99774Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M4.99992 7.18274C4.99992 6.64998 4.78829 6.13905 4.41157 5.76234C4.03486 5.38562 3.52393 5.17399 2.99117 5.17399C2.45842 5.17399 1.94748 5.38562 1.57077 5.76234C1.19406 6.13905 0.982422 6.64998 0.982422 7.18274", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M1.64941 10.5309C1.64941 10.8861 1.79053 11.2268 2.04171 11.4779C2.29289 11.7291 2.63356 11.8702 2.98879 11.8702C3.34401 11.8702 3.68469 11.7291 3.93587 11.4779C4.18705 11.2268 4.32816 10.8861 4.32816 10.5309C4.32816 10.1756 4.18705 9.83497 3.93587 9.58378C3.68469 9.3326 3.34401 9.19149 2.98879 9.19149C2.63356 9.19149 2.29289 9.3326 2.04171 9.58378C1.79053 9.83497 1.64941 10.1756 1.64941 10.5309Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M4.99992 14.7165C4.99992 14.1837 4.78829 13.6728 4.41157 13.2961C4.03486 12.9194 3.52393 12.7077 2.99117 12.7077C2.45842 12.7077 1.94748 12.9194 1.57077 13.2961C1.19406 13.6728 0.982422 14.1837 0.982422 14.7165", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M7.00684 3.35461H14.395C14.5607 3.35461 14.7197 3.42046 14.8369 3.53767C14.9541 3.65488 15.02 3.81385 15.02 3.97961V5.51961C15.02 5.68537 14.9541 5.84435 14.8369 5.96156C14.7197 6.07877 14.5607 6.14461 14.395 6.14461H7.00684V3.35461Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M7.00684 10.7427H10.7343C10.9001 10.7427 11.0591 10.8086 11.1763 10.9258C11.2935 11.043 11.3593 11.202 11.3593 11.3677V12.9077C11.3593 13.0735 11.2935 13.2325 11.1763 13.3497C11.0591 13.4669 10.9001 13.5327 10.7343 13.5327H7.00684V10.7427Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M7.00684 1.32336V15.3859", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17902_126" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" }))));
}
HI.displayName = "LBSurveyResultsIcon";
function jI(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17839_3671)" }, /* @__PURE__ */ d.createElement("path", { d: "M6.1249 12.8471C5.94909 13.0229 5.71068 13.1216 5.46209 13.1216C5.2135 13.1216 4.97508 13.0229 4.79927 12.8471L1.4374 9.48586C1.35028 9.3988 1.28117 9.29543 1.23402 9.18168C1.18687 9.06786 1.1626 8.94593 1.1626 8.82274C1.1626 8.69961 1.18687 8.57761 1.23402 8.46386C1.28117 8.35005 1.35028 8.24668 1.4374 8.15961L7.99991 1.59713C8.08697 1.51009 8.19041 1.44106 8.30416 1.39398C8.41797 1.3469 8.53991 1.3227 8.66304 1.32275H12.0243C12.2729 1.32275 12.5113 1.42153 12.6872 1.59734C12.863 1.77316 12.9618 2.01161 12.9618 2.26025V5.62213C12.9617 5.87059 12.863 6.10888 12.6874 6.28463", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M10.6182 3.90088C10.4887 3.90088 10.3838 3.79594 10.3838 3.6665C10.3838 3.53706 10.4887 3.43213 10.6182 3.43213", stroke: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M10.6182 3.90088C10.7476 3.90088 10.8525 3.79594 10.8525 3.6665C10.8525 3.53706 10.7476 3.43213 10.6182 3.43213", stroke: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M11.0869 10.229V13.0415", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M9.68066 11.6352H12.4932", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M11.0869 15.3852C13.158 15.3852 14.8369 13.7063 14.8369 11.6352C14.8369 9.56418 13.158 7.88524 11.0869 7.88524C9.01585 7.88524 7.33691 9.56418 7.33691 11.6352C7.33691 13.7063 9.01585 15.3852 11.0869 15.3852Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17839_3671" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" }))));
}
jI.displayName = "LBNameIcon";
function qI(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17842_9319)" }, /* @__PURE__ */ d.createElement("path", { d: "M5.65625 2.72961H15.0312", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M5.65625 8.35461H15.0312", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M5.65625 13.9796H15.0312", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M1.4375 1.32336H3.3125C3.3125 1.32336 3.78125 1.32336 3.78125 1.79211V3.66711C3.78125 3.66711 3.78125 4.13586 3.3125 4.13586H1.4375C1.4375 4.13586 0.96875 4.13586 0.96875 3.66711V1.79211C0.96875 1.79211 0.96875 1.32336 1.4375 1.32336Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M1.4375 6.94836H3.3125C3.3125 6.94836 3.78125 6.94836 3.78125 7.41711V9.29211C3.78125 9.29211 3.78125 9.76086 3.3125 9.76086H1.4375C1.4375 9.76086 0.96875 9.76086 0.96875 9.29211V7.41711C0.96875 7.41711 0.96875 6.94836 1.4375 6.94836Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M1.4375 12.5734H3.3125C3.3125 12.5734 3.78125 12.5734 3.78125 13.0421V14.9171C3.78125 14.9171 3.78125 15.3859 3.3125 15.3859H1.4375C1.4375 15.3859 0.96875 15.3859 0.96875 14.9171V13.0421C0.96875 13.0421 0.96875 12.5734 1.4375 12.5734Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17842_9319" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" }))));
}
qI.displayName = "LBListIcon";
function zI(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17868_3485)" }, /* @__PURE__ */ d.createElement("path", { d: "M13.1562 8.04211V11.6359C13.1562 11.8845 13.0575 12.123 12.8817 12.2988C12.7059 12.4746 12.4674 12.5734 12.2188 12.5734H5.65625L2.84375 15.3859V12.5734H1.90625C1.65761 12.5734 1.41915 12.4746 1.24334 12.2988C1.06752 12.123 0.96875 11.8845 0.96875 11.6359V4.13586C0.96875 3.88723 1.06752 3.64876 1.24334 3.47295C1.41915 3.29714 1.65761 3.19836 1.90625 3.19836H8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M15.0312 1.32336L9.67969 6.67493", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M15.0312 6.01086V1.32336H10.3438", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17868_3485" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" }))));
}
zI.displayName = "LBPublishSurveyIcon";
function UI(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17390_95)" }, /* @__PURE__ */ d.createElement("path", { d: "M14.0938 14.4552C14.0938 14.7039 13.995 14.9423 13.8192 15.1181C13.6433 15.294 13.4049 15.3927 13.1562 15.3927H2.84375C2.59511 15.3927 2.35665 15.294 2.18084 15.1181C2.00502 14.9423 1.90625 14.7039 1.90625 14.4552V2.26773C1.90625 2.01909 2.00502 1.78063 2.18084 1.60482C2.35665 1.429 2.59511 1.33023 2.84375 1.33023H9.48687C9.73534 1.33028 9.97363 1.42897 10.1494 1.60461L13.8194 5.27461C13.995 5.45035 14.0937 5.68864 14.0938 5.93711V14.4552Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M14.0938 6.01773H10.3438C10.0951 6.01773 9.85665 5.91896 9.68084 5.74314C9.50502 5.56733 9.40625 5.32887 9.40625 5.08023V1.33023", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M6.54313 6.86649L5.21063 8.64274C5.17031 8.69641 5.11894 8.74081 5.05999 8.77291C5.00103 8.80502 4.93587 8.82409 4.86891 8.82883C4.80194 8.83357 4.73474 8.82387 4.67185 8.80039C4.60896 8.77691 4.55185 8.7402 4.50437 8.69274L3.78125 7.97024", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M6.54313 11.0852L5.21063 12.8615C5.17031 12.9152 5.11894 12.9596 5.05999 12.9917C5.00103 13.0238 4.93587 13.0428 4.86891 13.0476C4.80194 13.0523 4.73474 13.0426 4.67185 13.0191C4.60896 12.9957 4.55185 12.9589 4.50437 12.9115L3.78125 12.1884", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M8.46875 8.83023H11.2812", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M8.46875 12.5802H11.2812", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17390_95" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" }))));
}
UI.displayName = "LBSurveysIcon";
function GI(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17820_2445)" }, /* @__PURE__ */ d.createElement("path", { d: "M15.0269 15.3859H0.96875V1.32336", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M0.96875 13.5695L6.125 10.4394L7.6875 11.5987L13 12.9898L14.875 9.97574", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M0.96875 8.12024L5.48047 3.12024L9.66019 9.68274L14.875 3.12024", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17820_2445" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" }))));
}
GI.displayName = "LBAreaChartIcon";
function YI(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17349_737)" }, /* @__PURE__ */ d.createElement("path", { d: "M7.53125 11.6359C7.53125 12.6304 7.92634 13.5843 8.6296 14.2875C9.33286 14.9908 10.2867 15.3859 11.2812 15.3859C12.2758 15.3859 13.2296 14.9908 13.9329 14.2875C14.6362 13.5843 15.0312 12.6304 15.0312 11.6359C15.0312 10.6413 14.6362 9.68748 13.9329 8.98421C13.2296 8.28095 12.2758 7.88586 11.2812 7.88586C10.2867 7.88586 9.33286 8.28095 8.6296 8.98421C7.92634 9.68748 7.53125 10.6413 7.53125 11.6359Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M11.2812 9.76086V13.5109", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M9.40625 11.6359H13.1562", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M0.96875 11.6359C0.969225 10.9384 1.14253 10.252 1.47316 9.63787C1.80379 9.02378 2.28145 8.5012 2.86343 8.11685C3.44541 7.7325 4.11356 7.49835 4.80815 7.43536C5.50274 7.37236 6.20212 7.48248 6.84375 7.75586", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M2.60938 3.90149C2.60938 4.58525 2.881 5.24101 3.36449 5.7245C3.84798 6.20799 4.50374 6.47961 5.1875 6.47961C5.87126 6.47961 6.52702 6.20799 7.01051 5.7245C7.494 5.24101 7.76563 4.58525 7.76562 3.90149C7.76563 3.21773 7.494 2.56197 7.01051 2.07848C6.52702 1.59499 5.87126 1.32336 5.1875 1.32336C4.50374 1.32336 3.84798 1.59499 3.36449 2.07848C2.881 2.56197 2.60938 3.21773 2.60938 3.90149Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17349_737" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" }))));
}
YI.displayName = "LBAddUserIcon";
function ZI(e) {
  return /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M11.544 0.024192C10.662431999999999 0.14541600000000002 9.898176 0.5306879999999999 9.3 1.155408C8.611224 1.87476 8.257728 2.753736 8.256432 3.750264C8.255112 4.757592 8.637936 5.685672 9.347904 6.396384C9.834456000000001 6.88344 10.411871999999999 7.2140640000000005 11.064 7.379016C11.260824000000001 7.4287920000000005 11.44224 7.4598960000000005 11.748000000000001 7.496256C11.7876 7.500960000000001 11.7444 7.506648 11.652000000000001 7.50888C10.973880000000001 7.525272 10.091496 7.758 9.370632 8.110584C7.481232 9.034656 6.233256 10.833168 6.024696 12.932544C6.010992 13.070352 6 13.783704 6 14.533632C6 15.840768 6.001656 15.890640000000001 6.049464 16.018392C6.112368 16.186512 6.270912 16.351368 6.45072 16.435655999999998L6.588 16.5 7.453463999999999 16.507800000000003L8.318928 16.515624 8.637648 19.7118C9.033144 23.677872 9.005712 23.437776 9.079896 23.582784C9.151463999999999 23.722728 9.28404 23.853984 9.432 23.931456L9.540000000000001 23.988 12 23.988L14.46 23.988 14.568 23.931456C14.812536 23.803416 14.953296 23.60076 14.995439999999999 23.316C15.00912 23.2236 15.168984000000002 21.655704 15.350688 19.8318L15.681072000000002 16.515624 16.546536 16.507800000000003L17.412 16.5 17.54928 16.435655999999998C17.73108 16.350456 17.88756 16.186728 17.95212 16.014143999999998C18.002592 15.87924 18.003072000000003 15.860544 17.993736000000002 14.37684C17.983584 12.764232 17.979864 12.708383999999999 17.84424 12.132C17.27148 9.698088 15.25944 7.8806400000000005 12.768 7.546704000000001C12.6294 7.528128000000001 12.4404 7.511112000000001 12.348 7.50888C12.2556 7.506648 12.2124 7.500960000000001 12.252 7.496256C13.123776 7.3926 13.669680000000001 7.186152 14.267952000000001 6.7338960000000005C15.200088000000001 6.0292319999999995 15.745104000000001 4.927248 15.743568 3.750264C15.742272 2.753736 15.388776 1.87476 14.700000000000001 1.155408C14.1636 0.5952000000000001 13.509792000000001 0.23532 12.732000000000001 0.07212C12.458808 0.014784 11.804376 -0.011616 11.544 0.024192M11.652000000000001 1.5276C10.797696 1.6640160000000002 10.074576 2.31072 9.839903999999999 3.1481760000000003C9.73992 3.5050320000000004 9.735936 3.962376 9.829656 4.328016C9.883464 4.5379439999999995 10.058736 4.897464 10.200552 5.088768C10.516752 5.515272 11.000208 5.827416 11.528544 5.946192C11.75676 5.99748 12.24324 5.99748 12.471456 5.946192C13.230552000000001 5.775552 13.843176 5.237376 14.110752 4.506072C14.304792 3.975744 14.278464000000001 3.342072 14.0406 2.8174799999999998C13.818336 2.3273040000000003 13.378104000000002 1.897272 12.886104000000001 1.689768C12.575040000000001 1.5585840000000002 12.451056 1.533408 12.072000000000001 1.524384C11.8806 1.519848 11.6916 1.521288 11.652000000000001 1.5276M4.152 3.01452C3.649416 3.106872 3.453288 3.167616 3.141 3.3276719999999997C2.20824 3.805704 1.603416 4.7034720000000005 1.5144 5.742C1.3845120000000002 7.257648 2.40948 8.634936 3.892992 8.938176C3.9947280000000003 8.958984000000001 4.10724 8.976 4.143 8.976C4.277496 8.976 4.1718 9.004056 3.9085680000000003 9.038232C2.928264 9.165456 2.032944 9.609408 1.321176 10.321176C0.741168 10.901184 0.347088 11.585280000000001 0.144432 12.363912000000001C0.013104000000000001 12.868488000000001 0 13.066392 0 14.544336000000001C0 15.840672000000001 0.0016800000000000003 15.890687999999999 0.049464 16.018392C0.112536 16.186992 0.271416 16.351872 0.45072 16.434816C0.5824320000000001 16.495752 0.6081840000000001 16.498728 1.085424 16.507872L1.582848 16.517424000000002 1.5957599999999998 16.592712000000002C1.602864 16.634112 1.75464 17.8398 1.933032 19.272000000000002C2.111424 20.7042 2.267136 21.911592 2.279064 21.955128000000002C2.336472 22.164576 2.556216 22.401432 2.755128 22.4682C2.8744560000000003 22.508256000000003 5.860152 22.526232 6.104304 22.488336C6.2927040000000005 22.459104 6.442512 22.381032 6.5541599999999995 22.253880000000002C6.886728000000001 21.875088 6.770136 21.290832 6.317495999999999 21.067895999999998L6.204 21.012 4.938312 21.005376000000002L3.6726 20.998776 3.6610080000000003 20.945376000000003C3.6546240000000005 20.916024 3.4994400000000003 19.687800000000003 3.316176 18.216C2.9469600000000002 15.251064000000001 2.9759520000000004 15.409991999999999 2.768064 15.212544C2.573928 15.028128 2.516856 15.012936 1.986 15.004199999999999L1.512 14.996400000000001 1.512072 14.104199999999999C1.512144 13.40424 1.520232 13.165464000000002 1.5496079999999999 12.996C1.7124 12.05736 2.318904 11.241048000000001 3.1621680000000003 10.82568C3.563976 10.627752 3.8792159999999996 10.545912000000001 4.378416 10.509888C4.62084 10.492392 4.715448 10.475112000000001 4.810416 10.431023999999999C5.296632000000001 10.205304 5.398008 9.543840000000001 5.000088 9.193584C4.940040000000001 9.140712 4.8360959999999995 9.077016 4.7691360000000005 9.052032L4.647384 9.006599999999999 4.78968 8.989536000000001C5.318256 8.926152 5.774736 8.759856000000001 6.1817519999999995 8.482416C6.93468 7.969200000000001 7.407552000000001 7.162392 7.48548 6.258C7.615896 4.744632 6.609096000000001 3.3882000000000003 5.112 3.060216C4.938048 3.022104 4.2809040000000005 2.990832 4.152 3.01452M19.152 3.01452C18.649416 3.106872 18.453288 3.167616 18.141000000000002 3.3276719999999997C17.20824 3.805704 16.603416 4.7034720000000005 16.514400000000002 5.742C16.411848 6.938688000000001 17.021928 8.070408 18.07596 8.638776C18.415944 8.822112 18.728184 8.922144 19.136496 8.978592L19.348968 9.007968 19.22904 9.052704C19.163088000000002 9.077304 19.05996 9.140712 18.999912000000002 9.193584C18.68136 9.473976 18.669719999999998 9.976296 18.974712 10.281288C19.129512000000002 10.436088 19.265616 10.484184 19.621584000000002 10.509888C20.120784 10.545912000000001 20.436024 10.627752 20.837832000000002 10.82568C21.548784 11.175864 22.085808 11.798712 22.34364 12.572111999999999C22.472160000000002 12.957696 22.487832 13.124112 22.487928 14.104199999999999L22.488 14.996400000000001 22.014 15.004199999999999C21.483144 15.012936 21.426072 15.028128 21.231936 15.212544C21.024048 15.409991999999999 21.053040000000003 15.251064000000001 20.683824 18.216C20.50056 19.687800000000003 20.345376 20.916024 20.338992 20.945376000000003L20.3274 20.998776 19.061688 21.005376000000002L17.796 21.012 17.68332 21.067512C17.621351999999998 21.098015999999998 17.525976 21.167664 17.471376000000003 21.222264C17.321687999999998 21.371976 17.273471999999998 21.48408 17.260968000000002 21.711552C17.251608 21.882264 17.257776 21.923544 17.309544 22.036656C17.430024 22.299816 17.618952 22.4454 17.895696 22.488336C18.139848 22.526232 21.125544 22.508256000000003 21.244872 22.4682C21.443784 22.401432 21.663528000000003 22.164576 21.720936000000002 21.955128000000002C21.732864 21.911592 21.888576 20.7042 22.066968 19.272000000000002C22.24536 17.8398 22.397136000000003 16.634112 22.40424 16.592712000000002L22.417152 16.517424000000002 22.914576 16.507872C23.391816 16.498728 23.417568 16.495752 23.54928 16.434816C23.7306 16.350936 23.887392000000002 16.187184000000002 23.952168 16.014072000000002C24.002688 15.879048 24.00312 15.861216 23.992752 14.412768000000002C23.984376 13.241015999999998 23.975016 12.9096 23.946 12.756C23.763047999999998 11.787312 23.348592 10.990944 22.678824000000002 10.321176C21.968064000000002 9.610392 21.070392000000002 9.165288 20.091432 9.038232C19.8282 9.004056 19.722504 8.976 19.857 8.976C19.89276 8.976 20.005272 8.958984000000001 20.107008 8.938176C21.399816 8.673912 22.371672 7.578768 22.48548 6.258C22.615896 4.744632 21.609096 3.3882000000000003 20.112000000000002 3.060216C19.938048 3.022104 19.280904 2.990832 19.152 3.01452M4.133208000000001 4.546776C3.7484880000000005 4.639944 3.3365039999999997 4.971576 3.162696 5.328C2.79456 6.0829439999999995 3.10356 6.986904 3.8517600000000005 7.343952C4.083912000000001 7.454712 4.233648 7.488 4.5 7.488C4.766352 7.488 4.916088 7.454712 5.1482399999999995 7.343952C5.506968 7.17276 5.795544 6.845544 5.920752 6.468C5.974824 6.304944000000001 5.984424 6.234384 5.984424 6C5.984424 5.7656160000000005 5.974824 5.695056 5.920752 5.532C5.839392 5.286648 5.703576 5.080512 5.501016 4.894896C5.323848 4.732584 5.039016 4.581408 4.828824 4.53816C4.661232 4.503696 4.292304000000001 4.508256 4.133208000000001 4.546776M19.133208 4.546776C18.748488000000002 4.639944 18.336503999999998 4.971576 18.162696 5.328C17.79456 6.0829439999999995 18.10356 6.986904 18.851760000000002 7.343952C19.083912 7.454712 19.233648000000002 7.488 19.5 7.488C19.766351999999998 7.488 19.916088 7.454712 20.14824 7.343952C20.506968 7.17276 20.795544 6.845544 20.920752 6.468C20.974824 6.304944000000001 20.984424 6.234384 20.984424 6C20.984424 5.7656160000000005 20.974824 5.695056 20.920752 5.532C20.839392 5.286648 20.703576 5.080512 20.501016 4.894896C20.323848 4.732584 20.039016 4.581408 19.828824 4.53816C19.661232 4.503696 19.292304 4.508256 19.133208 4.546776M11.544 9.027288C10.510968 9.133152 9.555648 9.592656 8.81076 10.341912C8.240568000000001 10.915464 7.852320000000001 11.596128 7.645968 12.384C7.529472 12.828768000000002 7.5120000000000005 13.047623999999999 7.5120000000000005 14.061072000000001L7.5120000000000005 15 8.312184 15C9.190824000000001 15 9.250464 15.007488 9.435936 15.140927999999999C9.563136 15.232439999999999 9.684576 15.407231999999999 9.721536 15.552C9.736704000000001 15.611400000000001 9.902112 17.1936 10.089096000000001 19.068L10.42908 22.476 12 22.476L13.570920000000001 22.476 13.910904 19.068C14.097888000000001 17.1936 14.263296 15.611400000000001 14.278464000000001 15.552C14.315424 15.407231999999999 14.436863999999998 15.232439999999999 14.564064 15.140927999999999C14.749535999999999 15.007488 14.809175999999999 15 15.687816 15L16.488 15 16.488 14.061072000000001C16.488 13.075464000000002 16.470432000000002 12.838680000000002 16.366848 12.429216C16.036752 11.124168000000001 15.113616 9.993024 13.930488 9.443904C13.147464000000001 9.080472 12.362328 8.943408 11.544 9.027288", stroke: "none", fill: "currentColor", fillRule: "evenodd", strokeWidth: 0.024 }));
}
ZI.displayName = "LBMultipleUsersIcon";
function KI(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17349_733)" }, /* @__PURE__ */ d.createElement("path", { d: "M0.96875 11.6359C0.969225 10.9384 1.14253 10.252 1.47316 9.63787C1.80379 9.02378 2.28145 8.5012 2.86343 8.11685C3.44541 7.7325 4.11356 7.49835 4.80815 7.43536C5.50274 7.37236 6.20212 7.48248 6.84375 7.75586", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M2.60938 3.90149C2.60938 4.58525 2.881 5.24101 3.36449 5.7245C3.84798 6.20799 4.50374 6.47961 5.1875 6.47961C5.87126 6.47961 6.52702 6.20799 7.01051 5.7245C7.494 5.24101 7.76563 4.58525 7.76562 3.90149C7.76563 3.21773 7.494 2.56197 7.01051 2.07848C6.52702 1.59499 5.87126 1.32336 5.1875 1.32336C4.50374 1.32336 3.84798 1.59499 3.36449 2.07848C2.881 2.56197 2.60938 3.21773 2.60938 3.90149Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M7.53125 11.6352C7.53125 12.6298 7.92634 13.5836 8.6296 14.2869C9.33286 14.9902 10.2867 15.3852 11.2812 15.3852C12.2758 15.3852 13.2296 14.9902 13.9329 14.2869C14.6362 13.5836 15.0312 12.6298 15.0312 11.6352C15.0312 10.6407 14.6362 9.68685 13.9329 8.98359C13.2296 8.28033 12.2758 7.88524 11.2812 7.88524C10.2867 7.88524 9.33286 8.28033 8.6296 8.98359C7.92634 9.68685 7.53125 10.6407 7.53125 11.6352Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M9.40625 11.6352H13.1562", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17349_733" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" }))));
}
KI.displayName = "LBRemoveUserIcon";
function XI(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17830_3731)" }, /* @__PURE__ */ d.createElement("path", { d: "M4.71875 4.60461C4.71875 5.47486 5.06445 6.30945 5.67981 6.92481C6.29516 7.54016 7.12976 7.88586 8 7.88586C8.87024 7.88586 9.70484 7.54016 10.3202 6.92481C10.9355 6.30945 11.2812 5.47486 11.2812 4.60461C11.2812 3.73437 10.9355 2.89977 10.3202 2.28442C9.70484 1.66907 8.87024 1.32336 8 1.32336C7.12976 1.32336 6.29516 1.66907 5.67981 2.28442C5.06445 2.89977 4.71875 3.73437 4.71875 4.60461Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M1.90625 15.3859C1.90625 13.7697 2.54827 12.2197 3.69107 11.0769C4.83387 9.93413 6.38384 9.29211 8 9.29211C9.61616 9.29211 11.1661 9.93413 12.3089 11.0769C13.4517 12.2197 14.0937 13.7697 14.0938 15.3859", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17830_3731" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" }))));
}
XI.displayName = "LBUserIcon";
function QI(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17687_480)" }, /* @__PURE__ */ d.createElement("path", { d: "M12.21 9.47961C13.9225 10.0777 15.0312 11.0321 15.0312 12.1077C15.0312 13.9202 11.8831 15.389 8 15.389C4.11687 15.389 0.96875 13.9171 0.96875 12.1046C0.96875 11.0327 2.06937 10.0815 3.77187 9.48274", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M6.35938 2.96399C6.35938 3.39911 6.53223 3.81641 6.8399 4.12409C7.14758 4.43176 7.56488 4.60461 8 4.60461C8.43512 4.60461 8.85242 4.43176 9.1601 4.12409C9.46777 3.81641 9.64062 3.39911 9.64062 2.96399C9.64062 2.52887 9.46777 2.11157 9.1601 1.80389C8.85242 1.49622 8.43512 1.32336 8 1.32336C7.56488 1.32336 7.14758 1.49622 6.8399 1.80389C6.53223 2.11157 6.35938 2.52887 6.35938 2.96399Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M10.3438 8.82024V7.41711C10.3437 6.79551 10.0968 6.19937 9.65728 5.75983C9.21774 5.32029 8.6216 5.07336 8 5.07336C7.3784 5.07336 6.78226 5.32029 6.34272 5.75983C5.90318 6.19937 5.65625 6.79551 5.65625 7.41711V8.82336H6.59375L7.0625 12.5734H8.9375L9.40625 8.82336L10.3438 8.82024Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17687_480" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" }))));
}
QI.displayName = "LBLonelyUserIcon";
function JI(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17349_730)" }, /* @__PURE__ */ d.createElement("path", { d: "M14.6438 10.1477L9.875 14.9171L7.53125 15.3859L8 13.0421L12.7688 8.27275C13.0168 8.02482 13.3531 7.88554 13.7037 7.88554C14.0544 7.88554 14.3907 8.02482 14.6388 8.27275L14.6438 8.27837C14.7666 8.40103 14.8641 8.54673 14.9307 8.70711C14.9972 8.8675 15.0314 9.03943 15.0314 9.21306C15.0314 9.38669 14.9972 9.55862 14.9307 9.71901C14.8641 9.87939 14.7666 10.0251 14.6438 10.1477Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M2.60938 3.90149C2.60938 4.58525 2.881 5.24101 3.36449 5.7245C3.84798 6.20799 4.50374 6.47961 5.1875 6.47961C5.87126 6.47961 6.52702 6.20799 7.01051 5.7245C7.494 5.24101 7.76563 4.58525 7.76562 3.90149C7.76563 3.21773 7.494 2.56197 7.01051 2.07848C6.52702 1.59499 5.87126 1.32336 5.1875 1.32336C4.50374 1.32336 3.84798 1.59499 3.36449 2.07848C2.881 2.56197 2.60938 3.21773 2.60938 3.90149Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M8.83627 9.55399C8.37873 8.7439 7.66548 8.1084 6.80818 7.74697C5.95088 7.38553 4.99794 7.31858 4.09852 7.55658C3.19911 7.79458 2.404 8.3241 1.83767 9.06225C1.27135 9.80039 0.965765 10.7055 0.968772 11.6359", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17349_730" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" }))));
}
JI.displayName = "LBEditProfileIcon";
function eO(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M8.00049 3.19836V10.6984", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M5.18799 7.88586L8.00049 10.6984L10.813 7.88586", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M15.0317 10.6984V11.6359C15.0317 12.1331 14.8342 12.6101 14.4826 12.9617C14.1309 13.3133 13.654 13.5109 13.1567 13.5109H2.84424C2.34696 13.5109 1.87004 13.3133 1.51841 12.9617C1.16678 12.6101 0.969238 12.1331 0.969238 11.6359V10.6984", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
}
eO.displayName = "LBImportIcon";
function tO(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17349_740)" }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip1_17349_740)" }, /* @__PURE__ */ d.createElement("path", { d: "M10.0622 11.5156V8L14.93 3.13221C15.2004 2.86178 15.2905 2.59134 15.2905 2.23077C15.2905 1.50961 14.7497 0.96875 14.0285 0.96875H2.49005C1.7689 0.96875 1.22803 1.50961 1.22803 2.23077C1.22803 2.59134 1.31818 2.86178 1.58861 3.13221L6.4564 8V15.0312L10.0622 11.5156Z", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }))), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17349_740" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" })), /* @__PURE__ */ d.createElement("clipPath", { id: "clip1_17349_740" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0.259277)" }))));
}
tO.displayName = "LBFilterIcon";
function nO(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17349_741)" }, /* @__PURE__ */ d.createElement("path", { d: "M1.94629 4.40428L6.36383 8.8218V15.2027L9.63608 12.0123V11.7451M9.63608 9.91124V8.8218L14.0536 4.40428C14.299 4.15886 14.3808 3.91345 14.3808 3.58622C14.3808 2.93177 13.89 2.44093 13.2356 2.44093H2.76435C2.60741 2.44093 2.45988 2.46916 2.32626 2.5211", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M0.96875 1.32336L15.0312 15.3859", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17349_741" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" }))));
}
nO.displayName = "LBFilterOffIcon";
function rO(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M7.99995 4.1365C5.48058 4.094 2.87495 5.85462 1.23683 7.65775C1.06488 7.84864 0.969727 8.09645 0.969727 8.35337C0.969727 8.61029 1.06488 8.8581 1.23683 9.049C2.83933 10.814 5.43745 12.6152 7.99995 12.5721C10.5625 12.6152 13.1612 10.814 14.765 9.049C14.9369 8.8581 15.0321 8.61029 15.0321 8.35337C15.0321 8.09645 14.9369 7.84864 14.765 7.65775C13.125 5.85462 10.5193 4.094 7.99995 4.1365Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M10.3438 8.35461C10.3436 8.81814 10.2061 9.27122 9.94845 9.65656C9.69084 10.0419 9.32476 10.3422 8.89648 10.5195C8.46821 10.6968 7.99698 10.7431 7.54237 10.6526C7.08777 10.5621 6.67022 10.3389 6.3425 10.011C6.01478 9.68325 5.79162 9.26563 5.70124 8.811C5.61086 8.35638 5.65731 7.88516 5.83472 7.45693C6.01213 7.0287 6.31253 6.6627 6.69795 6.40519C7.08336 6.14768 7.53648 6.01024 8 6.01024C8.30786 6.01016 8.61272 6.07074 8.89716 6.18854C9.18159 6.30633 9.44003 6.47903 9.65769 6.69674C9.87535 6.91446 10.048 7.17294 10.1657 7.45741C10.2834 7.74188 10.3439 8.04675 10.3438 8.35461Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
}
rO.displayName = "LBShowIcon";
function oO(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M1.09298 8.74024C1.0122 8.62788 0.96875 8.49299 0.96875 8.35461C0.96875 8.21623 1.0122 8.08135 1.09298 7.96899C1.84048 6.92774 4.19861 4.13586 7.99986 4.13586C11.8011 4.13586 14.1592 6.92774 14.9067 7.96899C14.9875 8.08135 15.031 8.21623 15.031 8.35461C15.031 8.49299 14.9875 8.62788 14.9067 8.74024C14.1592 9.78211 11.8011 12.5734 7.99986 12.5734C4.19861 12.5734 1.84048 9.78211 1.09298 8.74024Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M11.3169 4.89961L4.68311 11.8096", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M10.3438 8.35461C10.3437 8.97622 10.0968 9.57236 9.65728 10.0119C9.21774 10.4514 8.6216 10.6984 8 10.6984", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M5.65625 8.35461C5.65625 7.73301 5.90318 7.13687 6.34272 6.69733C6.78226 6.25779 7.3784 6.01086 8 6.01086", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
}
oO.displayName = "LBHideIcon";
function iO(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17390_169)" }, /* @__PURE__ */ d.createElement("path", { d: "M7.99998 9.69398C7.99998 11.2036 7.4003 12.6513 6.33287 13.7187C5.26544 14.7862 3.81768 15.3859 2.30811 15.3859", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M13.6919 15.3859C12.1823 15.3859 10.7345 14.7862 9.66711 13.7187C8.59968 12.6513 8 11.2036 8 9.69398", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M8 9.69399V1.32336", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M3.98193 5.34149L8.00006 1.32336L12.0182 5.34149", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17390_169" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" }))));
}
iO.displayName = "LBMergeAccountsIcon";
function aO(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17349_744)" }, /* @__PURE__ */ d.createElement("path", { d: "M8 10.8546C8 8.09143 5.49288 3.31514 1.125 1.47961", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M8 10.8546C8 8.09143 10.5071 3.31514 14.875 1.47961", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M8 10.8546V15.2296", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M1.125 6.47961V1.47961H6.125", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M14.875 6.47961V1.47961H9.875", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17349_744" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" }))));
}
aO.displayName = "LBUnmergeAccountsIcon";
function sO(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17870_3816)" }, /* @__PURE__ */ d.createElement("path", { d: "M12.6875 5.38586H14.4062C14.7514 5.38586 15.0312 5.66569 15.0312 6.01086V14.7609C15.0312 15.1061 14.7514 15.3859 14.4062 15.3859H5.65625C5.31107 15.3859 5.03125 15.1061 5.03125 14.7609V13.0421", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M0.96875 1.94836C0.96875 1.60318 1.24858 1.32336 1.59375 1.32336H10.3438C10.6889 1.32336 10.9688 1.60319 10.9688 1.94836V10.6984C10.9688 11.0436 10.6889 11.3234 10.3438 11.3234H1.59375C1.24857 11.3234 0.96875 11.0436 0.96875 10.6984V1.94836Z", stroke: "currentColor", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17870_3816" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" }))));
}
sO.displayName = "LBCopyIcon";
function lO(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17982_2694)" }, /* @__PURE__ */ d.createElement("path", { d: "M4.25 9.11899L5.78125 11.2921C5.83933 11.3789 5.9173 11.4505 6.00865 11.5011C6.10001 11.5516 6.20212 11.5796 6.30648 11.5827C6.41084 11.5858 6.51444 11.564 6.60865 11.519C6.70286 11.474 6.78497 11.4071 6.84812 11.324L11.75 5.12211", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M0.96875 8.35399C0.96875 10.2188 1.70954 12.0072 3.02816 13.3258C4.34677 14.6444 6.1352 15.3852 8 15.3852C9.8648 15.3852 11.6532 14.6444 12.9718 13.3258C14.2905 12.0072 15.0312 10.2188 15.0312 8.35399C15.0312 6.48919 14.2905 4.70076 12.9718 3.38214C11.6532 2.06353 9.8648 1.32274 8 1.32274C6.1352 1.32274 4.34677 2.06353 3.02816 3.38214C1.70954 4.70076 0.96875 6.48919 0.96875 8.35399Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17982_2694" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" }))));
}
lO.displayName = "LBCheckCircleIcon";
function cO(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17982_2695)" }, /* @__PURE__ */ d.createElement("path", { d: "M8 11.6359C7.87056 11.6359 7.76562 11.5309 7.76562 11.4015C7.76562 11.2721 7.87056 11.1671 8 11.1671", stroke: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M8 11.6359C8.12944 11.6359 8.23438 11.5309 8.23438 11.4015C8.23438 11.2721 8.12944 11.1671 8 11.1671", stroke: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M8 9.29211V4.13586", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M8 15.3859C11.8832 15.3859 15.0312 12.2379 15.0312 8.35461C15.0312 4.47136 11.8832 1.32336 8 1.32336C4.11675 1.32336 0.96875 4.47136 0.96875 8.35461C0.96875 12.2379 4.11675 15.3859 8 15.3859Z", stroke: "currentColor", strokeMiterlimit: 10 })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17982_2695" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" }))));
}
cO.displayName = "LBAlertCircleIcon";
function uO(e) {
  return /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_18077_259)" }, /* @__PURE__ */ d.createElement("path", { d: "M13.1562 12.5734V13.5109C13.1562 13.7595 13.0575 13.998 12.8817 14.1738C12.7059 14.3496 12.4674 14.4484 12.2188 14.4484H9.40625", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M9.40625 3.19836H12.2188C12.4674 3.19836 12.7059 3.29714 12.8817 3.47295C13.0575 3.64876 13.1562 3.88723 13.1562 4.13586V5.07336", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M6.99375 15.3796L1.36877 14.6046C1.25672 14.588 1.15446 14.5314 1.08093 14.4452C1.00739 14.359 0.967553 14.2491 0.968777 14.1359V3.17959C0.970574 3.07401 1.00796 2.97213 1.07489 2.89046C1.14182 2.80878 1.23436 2.7521 1.33752 2.72959L6.9625 1.34209C7.03081 1.32718 7.10156 1.32773 7.16962 1.3437C7.23769 1.35967 7.30131 1.39067 7.35588 1.43441C7.41038 1.47815 7.45444 1.53353 7.48481 1.5965C7.51513 1.65948 7.531 1.72844 7.53125 1.79834V14.9234C7.53125 14.9904 7.51663 15.0567 7.4885 15.1176C7.46031 15.1784 7.41919 15.2324 7.36806 15.2758C7.31694 15.3192 7.257 15.351 7.19238 15.3689C7.12769 15.3868 7.05994 15.3905 6.99375 15.3796Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M13.1562 6.94836L15.0312 8.82336H9.875", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M13.1562 10.6984L15.0312 8.82336", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M5.10938 8.56974C4.97993 8.56974 4.875 8.4648 4.875 8.33537C4.875 8.20593 4.97993 8.10099 5.10938 8.10099", stroke: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M5.10938 8.56974C5.23882 8.56974 5.34375 8.4648 5.34375 8.33537C5.34375 8.20593 5.23882 8.10099 5.10938 8.10099", stroke: "currentColor" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_18077_259" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" }))));
}
uO.displayName = "LBLogoutIcon";
function dO(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M5.05347 15.1012H10.7832", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M12.1558 7.46469C12.1558 9.79291 10.2932 11.6555 7.96498 11.6555C5.63675 11.6555 3.77417 9.79291 3.77417 7.46469V2.80824H12.1558V7.46469Z", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M7.96509 11.6555V15.1012", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M12.415 3.98359C13.7893 3.98359 14.8691 5.00801 14.8691 6.31181C14.8691 7.61562 13.7893 8.64003 12.415 8.64003", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M3.77685 3.98359C2.40256 3.98359 1.32275 5.00801 1.32275 6.31181C1.32275 7.61562 2.40256 8.64003 3.77685 8.64003", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }));
}
dO.displayName = "LBTrophyIcon";
function fO(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_18122_224)" }, /* @__PURE__ */ d.createElement("path", { d: "M15.0312 15.3951C14.4843 15.2574 13.9932 14.9542 13.625 14.527C13.4 14.8108 13.1155 15.0418 12.7915 15.2038C12.4676 15.3658 12.1121 15.4548 11.75 15.4645V15.4476C11.391 15.4311 11.0393 15.3408 10.7167 15.1824C10.3941 15.024 10.1076 14.8009 9.875 14.527C9.64999 14.8108 9.3655 15.0418 9.04154 15.2038C8.71759 15.3658 8.36206 15.4548 8 15.4645V15.4476C7.64101 15.4311 7.28927 15.3408 6.96669 15.1824C6.6441 15.024 6.35759 14.8009 6.125 14.527C5.89999 14.8108 5.6155 15.0418 5.29154 15.2038C4.96759 15.3658 4.61206 15.4548 4.25 15.4645V15.4476C3.89101 15.4311 3.53927 15.3408 3.21669 15.1824C2.8941 15.024 2.60759 14.8009 2.375 14.527C2.01875 14.9718 1.52359 15.2843 0.96875 15.4145", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M5.86742 13.1207V12.1326C5.54532 11.8911 5.28385 11.5779 5.10367 11.2179C4.9235 10.8578 4.82956 10.4608 4.82929 10.0582V8.8251C4.82887 8.49463 4.76523 8.16728 4.64179 7.86073L3.33992 4.6026C3.27169 4.43164 3.26426 4.24243 3.31888 4.06665C3.37349 3.89087 3.48683 3.73918 3.63992 3.63698C3.73463 3.57392 3.84165 3.53171 3.95391 3.51314C4.06616 3.49456 4.18108 3.50006 4.29105 3.52925C4.40103 3.55844 4.50354 3.61067 4.59181 3.68247C4.68007 3.75427 4.75207 3.844 4.80304 3.94573L6.12492 6.59448L5.42804 3.10073C5.38315 2.8761 5.42647 2.64281 5.54902 2.44928C5.67156 2.25575 5.86392 2.11683 6.08617 2.06135C6.20296 2.03219 6.32446 2.02699 6.44332 2.04606C6.56218 2.06514 6.67594 2.1081 6.77775 2.17235C6.87955 2.23659 6.96728 2.3208 7.03565 2.41988C7.10402 2.51897 7.15161 2.63087 7.17554 2.74885L7.85804 6.15948V2.2676C7.85804 2.03813 7.94916 1.81805 8.11136 1.65573C8.27356 1.49342 8.49357 1.40214 8.72304 1.40198C8.95262 1.40198 9.17279 1.49318 9.33513 1.65551C9.49747 1.81785 9.58867 2.03802 9.58867 2.2676V6.16198L10.2662 2.77573C10.2904 2.65432 10.339 2.53909 10.4091 2.43703C10.4792 2.33497 10.5692 2.24821 10.6738 2.182C10.7784 2.11578 10.8954 2.0715 11.0176 2.05184C11.1399 2.03218 11.2648 2.03754 11.3849 2.0676C11.6043 2.12253 11.7955 2.2568 11.9217 2.44449C12.0479 2.63218 12.1 2.85997 12.068 3.08385L11.318 8.3251L12.7443 7.46948C12.943 7.35025 13.18 7.31211 13.4061 7.36296C13.6323 7.41382 13.8301 7.54977 13.9587 7.7426C14.0698 7.90922 14.1223 8.10812 14.1078 8.30788C14.0933 8.50764 14.0127 8.69688 13.8787 8.84573L11.2262 11.7926V13.1207", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_18122_224" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.433228)" }))));
}
fO.displayName = "LBDrownHandIcon";
function hO(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_18122_223)" }, /* @__PURE__ */ d.createElement("path", { d: "M7.12492 7.27261C7.55437 7.78478 7.81639 8.41635 7.87562 9.08211C7.93486 9.74788 7.78845 10.4158 7.45617 10.9957C7.162 11.0185 6.87018 10.9286 6.63974 10.7444C6.4093 10.5601 6.25746 10.2952 6.21492 10.0032C5.77443 10.2439 5.41188 10.6055 5.16994 11.0453C4.92801 11.4851 4.81676 11.9848 4.84929 12.4857C4.84929 12.877 4.92636 13.2644 5.07609 13.6258C5.22583 13.9872 5.4453 14.3156 5.72197 14.5922C5.99864 14.8689 6.32708 15.0883 6.68855 15.2379C7.05003 15.3876 7.43744 15.4646 7.82867 15.4645C8.61536 15.4538 9.36683 15.1365 9.92316 14.5802C10.4795 14.0239 10.7967 13.2724 10.8074 12.4857C10.9174 9.54761 9.21117 7.95511 7.12492 7.27261Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M13.3857 5.15135H13.1563L11.5113 7.2076C10.8879 5.30779 10.9677 3.24722 11.7363 1.40135C10.3041 1.47394 8.91445 1.91309 7.70059 2.67673C6.48672 3.44038 5.48929 4.50293 4.80383 5.7626L3.31258 4.30823C2.44081 5.19794 1.84026 6.31738 1.58111 7.53574C1.32195 8.75411 1.41489 10.0211 1.84907 11.1886C2.28325 12.3561 3.04074 13.3759 4.03301 14.1288C5.02528 14.8818 6.21135 15.3368 7.45263 15.4407C8.69391 15.5446 9.93912 15.2931 11.0428 14.7156C12.1464 14.138 13.0629 13.2583 13.6851 12.1792C14.3073 11.1002 14.6096 9.86629 14.5566 8.6218C14.5035 7.37731 14.0974 6.1736 13.3857 5.15135Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_18122_223" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.433228)" }))));
}
hO.displayName = "LBFlameIcon";
function pO(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17349_735)" }, /* @__PURE__ */ d.createElement("path", { d: "M7.53125 13.5109L9.40625 15.3859L11.2812 13.5109", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M9.40625 15.3859V9.76086", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M11.2812 11.6359L13.1562 9.76086L15.0312 11.6359", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M13.1562 9.76086V15.3859", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M5.27169 14.2602L0.96875 15.3859L2.09126 11.0711M5.27169 14.2602L2.09126 11.0711M5.27169 14.2602L5.83294 13.6974M2.09126 11.0711L11.1337 2.00362C12.0068 1.12815 13.4411 1.06561 14.3764 2.00362C15.2495 2.8791 15.2495 4.31735 14.3764 5.25536L11.7207 7.91105M10.8842 2.25374L14.1315 5.50101M12.5075 7.12436L9.26281 3.87968", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17349_735" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" }))));
}
pO.displayName = "LBEditMergedAccountsIcon";
function mO(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M0.648926 8.72791C0.648926 10.3104 1.27757 11.8281 2.39656 12.9471C3.51555 14.0661 5.03323 14.6947 6.61572 14.6947C8.19822 14.6947 9.71589 14.0661 10.8349 12.9471C11.9539 11.8281 12.5825 10.3104 12.5825 8.72791C12.5825 7.14541 11.9539 5.62773 10.8349 4.50874C9.71589 3.38975 8.19822 2.76111 6.61572 2.76111C5.03323 2.76111 3.51555 3.38975 2.39656 4.50874C1.27757 5.62773 0.648926 7.14541 0.648926 8.72791Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M11.3574 3.17988C12.1085 3.47713 12.7986 3.92659 13.3808 4.5088C14.4998 5.6278 15.1284 7.14547 15.1284 8.72797C15.1284 10.3105 14.4998 11.8281 13.3808 12.9471C12.7986 13.5293 12.1085 13.9788 11.3574 14.2761", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M3.83105 7.53455C3.83105 8.27304 4.12442 8.98129 4.64662 9.50349C5.16881 10.0257 5.87706 10.3191 6.61556 10.3191C7.35406 10.3191 8.06231 10.0257 8.5845 9.50349C9.1067 8.98129 9.40007 8.27304 9.40007 7.53455C9.40007 6.79605 9.1067 6.0878 8.5845 5.5656C8.06231 5.04341 7.35406 4.75004 6.61556 4.75004C5.87706 4.75004 5.16881 5.04341 4.64662 5.5656C4.12442 6.0878 3.83105 6.79605 3.83105 7.53455Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M10.2823 13.4357C9.80187 12.9523 9.2306 12.5686 8.60135 12.3068C7.9721 12.045 7.29729 11.9102 6.61575 11.9102C5.93421 11.9102 5.2594 12.045 4.63015 12.3068C4.0009 12.5686 3.42963 12.9523 2.94922 13.4357", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
}
mO.displayName = "LBMultipleAccountsIcon";
function gO(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_18698_80)" }, /* @__PURE__ */ d.createElement("path", { d: "M8.00122 11.634V15.384", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M8.00122 1.32149V5.07149", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M4.71997 8.35274H0.969971", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M15.0325 8.35274H11.2825", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M2.84497 8.35336C2.84497 9.03049 2.97834 9.70099 3.23747 10.3266C3.49659 10.9522 3.8764 11.5206 4.3552 11.9994C4.834 12.4782 5.40242 12.858 6.02801 13.1171C6.65359 13.3762 7.32409 13.5096 8.00122 13.5096C8.67835 13.5096 9.34885 13.3762 9.97443 13.1171C10.6 12.858 11.1684 12.4782 11.6472 11.9994C12.126 11.5206 12.5058 10.9522 12.765 10.3266C13.0241 9.70099 13.1575 9.03049 13.1575 8.35336C13.1575 6.98584 12.6142 5.67433 11.6472 4.70735C10.6803 3.74036 9.36874 3.19711 8.00122 3.19711C6.6337 3.19711 5.32219 3.74036 4.3552 4.70735C3.38822 5.67433 2.84497 6.98584 2.84497 8.35336Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_18698_80" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" }))));
}
gO.displayName = "LBTargetIcon";
function vO(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_18144_258)" }, /* @__PURE__ */ d.createElement("path", { d: "M8.46875 1.32336C7.30187 1.32407 6.15631 1.6362 5.15035 2.22751C4.14439 2.81883 3.31447 3.66791 2.74627 4.68711C2.17806 5.70631 1.89217 6.85869 1.9181 8.02528C1.94402 9.19188 2.28083 10.3304 2.89375 11.3234L0.96875 15.3859L5.0125 13.4609C5.8754 13.9967 6.85092 14.325 7.86224 14.4197C8.87356 14.5145 9.89307 14.3732 10.8405 14.007C11.7879 13.6408 12.6374 13.0597 13.3221 12.3094C14.0068 11.5591 14.508 10.6601 14.7861 9.68314C15.0643 8.70622 15.1119 7.67807 14.9252 6.67963C14.7385 5.68118 14.3226 4.73971 13.7102 3.92933C13.0978 3.11894 12.3057 2.46178 11.3961 2.00958C10.4866 1.55737 9.4845 1.32247 8.46875 1.32336Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M9.875 7.41711C9.99932 7.41711 10.1185 7.36773 10.2065 7.27982C10.2944 7.19191 10.3438 7.07268 10.3438 6.94836C10.3438 6.82404 10.2944 6.70482 10.2065 6.61691C10.1185 6.529 9.99932 6.47961 9.875 6.47961C9.75068 6.47961 9.63145 6.529 9.54354 6.61691C9.45564 6.70482 9.40625 6.82404 9.40625 6.94836C9.40625 7.07268 9.45564 7.19191 9.54354 7.27982C9.63145 7.36773 9.75068 7.41711 9.875 7.41711Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M9.98145 9.45462C10.2695 9.32215 10.516 9.11365 10.6944 8.85155C10.8728 8.58946 10.9764 8.28368 10.9939 7.96712C10.9939 7.34212 10.6752 6.55461 9.9502 6.48586", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M6.6001 7.41711C6.72442 7.41711 6.84365 7.36773 6.93155 7.27982C7.01946 7.19191 7.06885 7.07268 7.06885 6.94836C7.06885 6.82404 7.01946 6.70482 6.93155 6.61691C6.84365 6.529 6.72442 6.47961 6.6001 6.47961C6.47578 6.47961 6.35655 6.529 6.26864 6.61691C6.18073 6.70482 6.13135 6.82404 6.13135 6.94836C6.13135 7.07268 6.18073 7.19191 6.26864 7.27982C6.35655 7.36773 6.47578 7.41711 6.6001 7.41711Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M6.7002 9.45462C6.98825 9.32215 7.23473 9.11365 7.41313 8.85155C7.59154 8.58946 7.6951 8.28368 7.7127 7.96712C7.7127 7.34212 7.39395 6.55461 6.66895 6.48586", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_18144_258" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" }))));
}
vO.displayName = "LBQuotesIcon";
function bO(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M8.00049 10.6984V3.19836", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M10.813 6.01086L8.00049 3.19836L5.18799 6.01086", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M15.0317 10.6984V11.6359C15.0317 12.1331 14.8342 12.6101 14.4826 12.9617C14.1309 13.3133 13.654 13.5109 13.1567 13.5109H2.84424C2.34696 13.5109 1.87004 13.3133 1.51841 12.9617C1.16678 12.6101 0.969238 12.1331 0.969238 11.6359V10.6984", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
}
bO.displayName = "LBExportFileIcon";
function Xy(e) {
  return /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17982_2708)" }, /* @__PURE__ */ d.createElement("path", { d: "M1.42001 9.20272C1.71096 9.88732 2.1339 10.5079 2.66468 11.0291C3.19546 11.5502 3.8237 11.9617 4.51351 12.2401C5.20332 12.5184 5.94121 12.6582 6.68504 12.6513C7.42886 12.6445 8.16406 12.4913 8.84866 12.2003C9.53326 11.9094 10.1538 11.4864 10.675 10.9557C11.1961 10.4249 11.6076 9.79664 11.886 9.10682C12.1643 8.41701 12.3041 7.67912 12.2973 6.9353C12.2905 6.19147 12.1372 5.45627 11.8462 4.77167C11.5553 4.08708 11.1324 3.46649 10.6016 2.94534C10.0708 2.42419 9.44257 2.0127 8.75275 1.73434C8.06294 1.45599 7.32505 1.31623 6.58123 1.32305C5.8374 1.32986 5.1022 1.48312 4.4176 1.77406C3.733 2.06501 3.11242 2.48795 2.59127 3.01874C2.07013 3.54952 1.65863 4.17775 1.38028 4.86757C1.10193 5.55738 0.96217 6.29527 0.968988 7.0391C0.975805 7.78292 1.12906 8.51812 1.42001 9.20272Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M10.6382 10.9921L15.0313 15.3859", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17982_2708" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" }))));
}
Xy.displayName = "LBSearchIcon";
function C5(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_19246_1589)" }, /* @__PURE__ */ d.createElement("path", { d: "M14.0938 3.19836H1.90625C1.38848 3.19836 0.96875 3.6181 0.96875 4.13586V14.4484C0.96875 14.9661 1.38848 15.3859 1.90625 15.3859H14.0938C14.6115 15.3859 15.0312 14.9661 15.0312 14.4484V4.13586C15.0312 3.6181 14.6115 3.19836 14.0938 3.19836Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M0.96875 6.94836H15.0312", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M4.71875 4.60461V1.32336", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M11.2812 4.60461V1.32336", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M4.01562 9.76086C3.88618 9.76086 3.78125 9.65593 3.78125 9.52649C3.78125 9.39705 3.88618 9.29211 4.01562 9.29211", stroke: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M4.01562 9.76086C4.14507 9.76086 4.25 9.65593 4.25 9.52649C4.25 9.39705 4.14507 9.29211 4.01562 9.29211", stroke: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M4.01562 13.0421C3.88618 13.0421 3.78125 12.9372 3.78125 12.8077C3.78125 12.6783 3.88618 12.5734 4.01562 12.5734", stroke: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M4.01562 13.0421C4.14507 13.0421 4.25 12.9372 4.25 12.8077C4.25 12.6783 4.14507 12.5734 4.01562 12.5734", stroke: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M8 9.76086C7.87056 9.76086 7.76562 9.65593 7.76562 9.52649C7.76562 9.39705 7.87056 9.29211 8 9.29211", stroke: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M8 9.76086C8.12944 9.76086 8.23438 9.65593 8.23438 9.52649C8.23438 9.39705 8.12944 9.29211 8 9.29211", stroke: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M8 13.0421C7.87056 13.0421 7.76562 12.9372 7.76562 12.8077C7.76562 12.6783 7.87056 12.5734 8 12.5734", stroke: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M8 13.0421C8.12944 13.0421 8.23438 12.9372 8.23438 12.8077C8.23438 12.6783 8.12944 12.5734 8 12.5734", stroke: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M11.9844 9.76086C11.8549 9.76086 11.75 9.65593 11.75 9.52649C11.75 9.39705 11.8549 9.29211 11.9844 9.29211", stroke: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M11.9844 9.76086C12.1138 9.76086 12.2188 9.65593 12.2188 9.52649C12.2188 9.39705 12.1138 9.29211 11.9844 9.29211", stroke: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M11.9844 13.0421C11.8549 13.0421 11.75 12.9372 11.75 12.8077C11.75 12.6783 11.8549 12.5734 11.9844 12.5734", stroke: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M11.9844 13.0421C12.1138 13.0421 12.2188 12.9372 12.2188 12.8077C12.2188 12.6783 12.1138 12.5734 11.9844 12.5734", stroke: "currentColor" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_19246_1589" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" }))));
}
C5.displayName = "LBCalendarIcon";
const zi = nI;
zi.displayName = "LBDropdownMenu";
const Ui = rI;
Ui.displayName = "LBDropdownMenuTrigger";
const yO = iI;
yO.displayName = "LBDropdownMenuGroup";
const CO = Hy;
CO.displayName = "LBDropdownMenuPortal";
const wO = dI;
wO.displayName = "LBDropdownMenuSub";
const Qy = cI;
Qy.displayName = "LBDropdownMenuRadioGroup";
const _O = d.forwardRef(({ children: e, className: t, ...n }, r) => /* @__PURE__ */ s1(
  fI,
  {
    ref: r,
    ...n,
    className: e1(
      "flex cursor-default select-none items-center gap-2 py-1 px-3 text-sm outline-none focus:bg-secondary data-[state=open]:bg-secondary [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      t
    ),
    style: void 0,
    children: [
      e,
      /* @__PURE__ */ v(qr, { className: "ml-auto" })
    ]
  }
));
_O.displayName = "LBDropdownMenuSubContent";
const xO = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  hI,
  {
    ref: n,
    ...t,
    className: e1(
      "rounded-md z-50 min-w-[8rem] overflow-hidden border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    style: void 0
  }
));
xO.displayName = "LBDropdownMenuSubContent";
const Gi = d.forwardRef(({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ v(Hy, { children: /* @__PURE__ */ v(
  oI,
  {
    ref: r,
    sideOffset: t,
    ...n,
    className: e1(
      "rounded-md z-50 min-w-[8rem] overflow-hidden border bg-popover p-1 text-popover-foreground shadow-md",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    style: void 0
  }
) }));
Gi.displayName = "LBDropdownMenuContent";
const U6 = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  sI,
  {
    ref: n,
    ...t,
    className: e1(
      "relative flex cursor-default select-none items-center gap-2 py-1 px-3 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&>svg]:size-4",
      e
    ),
    style: void 0
  }
));
U6.displayName = "LBDropdownMenuItem";
const Jy = d.forwardRef(({ children: e, checked: t, className: n, disabled: r, ...o }, i) => /* @__PURE__ */ s1(
  lI,
  {
    ref: i,
    ...o,
    className: e1(
      "group relative flex gap-2 cursor-default select-none items-center py-1 px-3 text-sm outline-none transition-colors focus:bg-indigo-50 focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      n
    ),
    disabled: r,
    checked: t,
    onSelect: (a) => a.preventDefault(),
    children: [
      /* @__PURE__ */ v(
        "span",
        {
          className: e1(
            "flex size-4 shrink-0 items-center justify-center rounded-sm border border-primary focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring group-hover:border-indigo-500 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:text-primary-foreground",
            {
              "bg-primary text-primary-foreground group-hover:bg-indigo-500": t
            }
          ),
          children: /* @__PURE__ */ v(v5, { children: /* @__PURE__ */ v(zr, { className: "size-3" }) })
        }
      ),
      e
    ]
  }
));
Jy.displayName = "LBDropdownMenuCheckboxItem";
const SO = d.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ s1(
  jy,
  {
    ref: r,
    ...n,
    className: e1(
      "group relative flex gap-2 cursor-default select-none items-center py-1 px-3 text-sm outline-none transition-colors focus:bg-indigo-50 focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    style: void 0,
    onSelect: (o) => o.preventDefault(),
    children: [
      /* @__PURE__ */ v("span", { className: "aspect-square size-5 rounded-full border border-primary text-primary focus:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 group-hover:border-indigo-500 group-focus:border-indigo-500", children: /* @__PURE__ */ v(v5, { className: "flex size-full items-center justify-center", children: /* @__PURE__ */ v(y5, { className: "size-4 fill-primary group-focus:fill-indigo-500 group-focus:text-indigo-500" }) }) }),
      t
    ]
  }
));
SO.displayName = "LBDropdownMenuRadioItem";
const eC = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  aI,
  {
    ref: n,
    ...t,
    className: e1("p-2 text-sm font-semibold", e),
    style: void 0
  }
));
eC.displayName = "LBDropdownMenuItem";
const tC = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  uI,
  {
    ref: n,
    ...t,
    className: e1("my-2 h-[1px] bg-secondary", e),
    style: void 0
  }
));
tC.displayName = "LBDropdownMenuSeparator";
function MO({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ v(
    "span",
    {
      ...t,
      className: e1("ml-auto text-xs tracking-widest opacity-60", e),
      style: void 0
    }
  );
}
MO.displayName = "LBDropdownMenuShortcut";
function Yi(e) {
  const t = d.useRef({ value: e, previous: e });
  return d.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var Zi = "Checkbox", [kO, L01] = o2(Zi), [LO, w5] = kO(Zi);
function EO(e) {
  const {
    __scopeCheckbox: t,
    checked: n,
    children: r,
    defaultChecked: o,
    disabled: i,
    form: a,
    name: s,
    onCheckedChange: l,
    required: c,
    value: f = "on",
    // @ts-expect-error
    internal_do_not_use_render: u
  } = e, [h, p] = E2({
    prop: n,
    defaultProp: o ?? !1,
    onChange: l,
    caller: Zi
  }), [g, m] = d.useState(null), [b, y] = d.useState(null), C = d.useRef(!1), _ = g ? !!a || !!g.closest("form") : (
    // We set this to true by default so that events bubble to forms without JS (SSR)
    !0
  ), M = {
    checked: h,
    disabled: i,
    setChecked: p,
    control: g,
    setControl: m,
    name: s,
    form: a,
    value: f,
    hasConsumerStoppedPropagationRef: C,
    required: c,
    defaultChecked: y0(o) ? !1 : o,
    isFormControl: _,
    bubbleInput: b,
    setBubbleInput: y
  };
  return /* @__PURE__ */ v(
    LO,
    {
      scope: t,
      ...M,
      children: TO(u) ? u(M) : r
    }
  );
}
var nC = "CheckboxTrigger", rC = d.forwardRef(
  ({ __scopeCheckbox: e, onKeyDown: t, onClick: n, ...r }, o) => {
    const {
      control: i,
      value: a,
      disabled: s,
      checked: l,
      required: c,
      setControl: f,
      setChecked: u,
      hasConsumerStoppedPropagationRef: h,
      isFormControl: p,
      bubbleInput: g
    } = w5(nC, e), m = F1(o, f), b = d.useRef(l);
    return d.useEffect(() => {
      const y = i?.form;
      if (y) {
        const C = () => u(b.current);
        return y.addEventListener("reset", C), () => y.removeEventListener("reset", C);
      }
    }, [i, u]), /* @__PURE__ */ v(
      y1.button,
      {
        type: "button",
        role: "checkbox",
        "aria-checked": y0(l) ? "mixed" : l,
        "aria-required": c,
        "data-state": sC(l),
        "data-disabled": s ? "" : void 0,
        disabled: s,
        value: a,
        ...r,
        ref: m,
        onKeyDown: p1(t, (y) => {
          y.key === "Enter" && y.preventDefault();
        }),
        onClick: p1(n, (y) => {
          u((C) => y0(C) ? !0 : !C), g && p && (h.current = y.isPropagationStopped(), h.current || y.stopPropagation());
        })
      }
    );
  }
);
rC.displayName = nC;
var _5 = d.forwardRef(
  (e, t) => {
    const {
      __scopeCheckbox: n,
      name: r,
      checked: o,
      defaultChecked: i,
      required: a,
      disabled: s,
      value: l,
      onCheckedChange: c,
      form: f,
      ...u
    } = e;
    return /* @__PURE__ */ v(
      EO,
      {
        __scopeCheckbox: n,
        checked: o,
        defaultChecked: i,
        disabled: s,
        required: a,
        onCheckedChange: c,
        name: r,
        form: f,
        value: l,
        internal_do_not_use_render: ({ isFormControl: h }) => /* @__PURE__ */ s1(ze, { children: [
          /* @__PURE__ */ v(
            rC,
            {
              ...u,
              ref: t,
              __scopeCheckbox: n
            }
          ),
          h && /* @__PURE__ */ v(
            aC,
            {
              __scopeCheckbox: n
            }
          )
        ] })
      }
    );
  }
);
_5.displayName = Zi;
var oC = "CheckboxIndicator", x5 = d.forwardRef(
  (e, t) => {
    const { __scopeCheckbox: n, forceMount: r, ...o } = e, i = w5(oC, n);
    return /* @__PURE__ */ v(
      i2,
      {
        present: r || y0(i.checked) || i.checked === !0,
        children: /* @__PURE__ */ v(
          y1.span,
          {
            "data-state": sC(i.checked),
            "data-disabled": i.disabled ? "" : void 0,
            ...o,
            ref: t,
            style: { pointerEvents: "none", ...e.style }
          }
        )
      }
    );
  }
);
x5.displayName = oC;
var iC = "CheckboxBubbleInput", aC = d.forwardRef(
  ({ __scopeCheckbox: e, ...t }, n) => {
    const {
      control: r,
      hasConsumerStoppedPropagationRef: o,
      checked: i,
      defaultChecked: a,
      required: s,
      disabled: l,
      name: c,
      value: f,
      form: u,
      bubbleInput: h,
      setBubbleInput: p
    } = w5(iC, e), g = F1(n, p), m = Yi(i), b = $i(r);
    d.useEffect(() => {
      const C = h;
      if (!C) return;
      const _ = window.HTMLInputElement.prototype, S = Object.getOwnPropertyDescriptor(
        _,
        "checked"
      ).set, k = !o.current;
      if (m !== i && S) {
        const L = new Event("click", { bubbles: k });
        C.indeterminate = y0(i), S.call(C, y0(i) ? !1 : i), C.dispatchEvent(L);
      }
    }, [h, m, i, o]);
    const y = d.useRef(y0(i) ? !1 : i);
    return /* @__PURE__ */ v(
      y1.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: a ?? y.current,
        required: s,
        disabled: l,
        name: c,
        value: f,
        form: u,
        ...t,
        tabIndex: -1,
        ref: g,
        style: {
          ...t.style,
          ...b,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0,
          // We transform because the input is absolutely positioned but we have
          // rendered it **after** the button. This pulls it back to sit on top
          // of the button.
          transform: "translateX(-100%)"
        }
      }
    );
  }
);
aC.displayName = iC;
function TO(e) {
  return typeof e == "function";
}
function y0(e) {
  return e === "indeterminate";
}
function sC(e) {
  return y0(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
const RO = x1(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  _5,
  {
    ref: n,
    ...t,
    style: void 0,
    className: e1(
      "peer size-4 shrink-0 rounded-sm border border-primary focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:enabled:hover:bg-indigo-500 data-[state=checked]:text-primary-foreground flex items-center justify-center enabled:hover:border-indigo-500",
      e
    ),
    children: /* @__PURE__ */ v(x5, { className: "flex items-center justify-center text-current", children: /* @__PURE__ */ v(zr, { className: "size-3" }) })
  }
));
RO.displayName = "LBCheckbox";
var Ki = "Switch", [PO, E01] = o2(Ki), [AO, IO] = PO(Ki), lC = d.forwardRef(
  (e, t) => {
    const {
      __scopeSwitch: n,
      name: r,
      checked: o,
      defaultChecked: i,
      required: a,
      disabled: s,
      value: l = "on",
      onCheckedChange: c,
      form: f,
      ...u
    } = e, [h, p] = d.useState(null), g = F1(t, (_) => p(_)), m = d.useRef(!1), b = h ? f || !!h.closest("form") : !0, [y, C] = E2({
      prop: o,
      defaultProp: i ?? !1,
      onChange: c,
      caller: Ki
    });
    return /* @__PURE__ */ s1(AO, { scope: n, checked: y, disabled: s, children: [
      /* @__PURE__ */ v(
        y1.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": y,
          "aria-required": a,
          "data-state": fC(y),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: l,
          ...u,
          ref: g,
          onClick: p1(e.onClick, (_) => {
            C((M) => !M), b && (m.current = _.isPropagationStopped(), m.current || _.stopPropagation());
          })
        }
      ),
      b && /* @__PURE__ */ v(
        dC,
        {
          control: h,
          bubbles: !m.current,
          name: r,
          value: l,
          checked: y,
          required: a,
          disabled: s,
          form: f,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
lC.displayName = Ki;
var cC = "SwitchThumb", uC = d.forwardRef(
  (e, t) => {
    const { __scopeSwitch: n, ...r } = e, o = IO(cC, n);
    return /* @__PURE__ */ v(
      y1.span,
      {
        "data-state": fC(o.checked),
        "data-disabled": o.disabled ? "" : void 0,
        ...r,
        ref: t
      }
    );
  }
);
uC.displayName = cC;
var OO = "SwitchBubbleInput", dC = d.forwardRef(
  ({
    __scopeSwitch: e,
    control: t,
    checked: n,
    bubbles: r = !0,
    ...o
  }, i) => {
    const a = d.useRef(null), s = F1(a, i), l = Yi(n), c = $i(t);
    return d.useEffect(() => {
      const f = a.current;
      if (!f) return;
      const u = window.HTMLInputElement.prototype, p = Object.getOwnPropertyDescriptor(
        u,
        "checked"
      ).set;
      if (l !== n && p) {
        const g = new Event("click", { bubbles: r });
        p.call(f, n), f.dispatchEvent(g);
      }
    }, [l, n, r]), /* @__PURE__ */ v(
      "input",
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: n,
        ...o,
        tabIndex: -1,
        ref: s,
        style: {
          ...o.style,
          ...c,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
dC.displayName = OO;
function fC(e) {
  return e ? "checked" : "unchecked";
}
var NO = lC, DO = uC;
const BO = x1((e, t) => /* @__PURE__ */ v(
  NO,
  {
    ...e,
    style: void 0,
    className: "peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input",
    ref: t,
    children: /* @__PURE__ */ v(DO, { className: "pointer-events-none block size-4 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0" })
  }
));
BO.displayName = "LBSwitch";
const FO = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  "div",
  {
    ref: n,
    ...t,
    style: void 0,
    className: e1(
      "size-full border bg-card text-card-foreground shadow",
      e
    )
  }
));
FO.displayName = "LBCard";
const $O = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  "div",
  {
    ref: n,
    ...t,
    style: void 0,
    className: e1("flex flex-col space-y-2 p-6", e)
  }
));
$O.displayName = "LBCardHeader";
const WO = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  "div",
  {
    ref: n,
    ...t,
    style: void 0,
    className: e1(
      "text-base font-semibold leading-none tracking-tight",
      e
    )
  }
));
WO.displayName = "LBCardTitle";
const VO = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  "div",
  {
    ref: n,
    ...t,
    style: void 0,
    className: e1("text-sm text-muted-foreground", e)
  }
));
VO.displayName = "LBCardDescription";
const HO = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  "div",
  {
    ref: n,
    ...t,
    style: void 0,
    className: e1("p-6 pt-0", e)
  }
));
HO.displayName = "LBCardContent";
const jO = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  "div",
  {
    ref: n,
    ...t,
    style: void 0,
    className: e1("flex items-center p-6 pt-0", e)
  }
));
jO.displayName = "LBCardFooter";
function G6(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
var hC = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), qO = "VisuallyHidden", pC = d.forwardRef(
  (e, t) => /* @__PURE__ */ v(
    y1.span,
    {
      ...e,
      ref: t,
      style: { ...hC, ...e.style }
    }
  )
);
pC.displayName = qO;
var zO = pC, UO = [" ", "Enter", "ArrowUp", "ArrowDown"], GO = [" ", "Enter"], X0 = "Select", [Xi, Qi, YO] = Ii(X0), [cn, T01] = o2(X0, [
  YO,
  Bt
]), Ji = Bt(), [ZO, P0] = cn(X0), [KO, XO] = cn(X0), mC = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    value: a,
    defaultValue: s,
    onValueChange: l,
    dir: c,
    name: f,
    autoComplete: u,
    disabled: h,
    required: p,
    form: g
  } = e, m = Ji(t), [b, y] = d.useState(null), [C, _] = d.useState(null), [M, S] = d.useState(!1), k = l3(c), [L, P] = E2({
    prop: r,
    defaultProp: o ?? !1,
    onChange: i,
    caller: X0
  }), [I, O] = E2({
    prop: a,
    defaultProp: s,
    onChange: l,
    caller: X0
  }), E = d.useRef(null), B = b ? g || !!b.closest("form") : !0, [W, F] = d.useState(/* @__PURE__ */ new Set()), z = Array.from(W).map((D) => D.props.value).join(";");
  return /* @__PURE__ */ v(rn, { ...m, children: /* @__PURE__ */ s1(
    ZO,
    {
      required: p,
      scope: t,
      trigger: b,
      onTriggerChange: y,
      valueNode: C,
      onValueNodeChange: _,
      valueNodeHasChildren: M,
      onValueNodeHasChildrenChange: S,
      contentId: t2(),
      value: I,
      onValueChange: O,
      open: L,
      onOpenChange: P,
      dir: k,
      triggerPointerDownPosRef: E,
      disabled: h,
      children: [
        /* @__PURE__ */ v(Xi.Provider, { scope: t, children: /* @__PURE__ */ v(
          KO,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: d.useCallback((D) => {
              F((Z) => new Set(Z).add(D));
            }, []),
            onNativeOptionRemove: d.useCallback((D) => {
              F((Z) => {
                const U = new Set(Z);
                return U.delete(D), U;
              });
            }, []),
            children: n
          }
        ) }),
        B ? /* @__PURE__ */ s1(
          WC,
          {
            "aria-hidden": !0,
            required: p,
            tabIndex: -1,
            name: f,
            autoComplete: u,
            value: I,
            onChange: (D) => O(D.target.value),
            disabled: h,
            form: g,
            children: [
              I === void 0 ? /* @__PURE__ */ v("option", { value: "" }) : null,
              Array.from(W)
            ]
          },
          z
        ) : null
      ]
    }
  ) });
};
mC.displayName = X0;
var gC = "SelectTrigger", vC = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: r = !1, ...o } = e, i = Ji(n), a = P0(gC, n), s = a.disabled || r, l = F1(t, a.onTriggerChange), c = Qi(n), f = d.useRef("touch"), [u, h, p] = HC((m) => {
      const b = c().filter((_) => !_.disabled), y = b.find((_) => _.value === a.value), C = jC(b, m, y);
      C !== void 0 && a.onValueChange(C.value);
    }), g = (m) => {
      s || (a.onOpenChange(!0), p()), m && (a.triggerPointerDownPosRef.current = {
        x: Math.round(m.pageX),
        y: Math.round(m.pageY)
      });
    };
    return /* @__PURE__ */ v(on, { asChild: !0, ...i, children: /* @__PURE__ */ v(
      y1.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": a.contentId,
        "aria-expanded": a.open,
        "aria-required": a.required,
        "aria-autocomplete": "none",
        dir: a.dir,
        "data-state": a.open ? "open" : "closed",
        disabled: s,
        "data-disabled": s ? "" : void 0,
        "data-placeholder": VC(a.value) ? "" : void 0,
        ...o,
        ref: l,
        onClick: p1(o.onClick, (m) => {
          m.currentTarget.focus(), f.current !== "mouse" && g(m);
        }),
        onPointerDown: p1(o.onPointerDown, (m) => {
          f.current = m.pointerType;
          const b = m.target;
          b.hasPointerCapture(m.pointerId) && b.releasePointerCapture(m.pointerId), m.button === 0 && m.ctrlKey === !1 && m.pointerType === "mouse" && (g(m), m.preventDefault());
        }),
        onKeyDown: p1(o.onKeyDown, (m) => {
          const b = u.current !== "";
          !(m.ctrlKey || m.altKey || m.metaKey) && m.key.length === 1 && h(m.key), !(b && m.key === " ") && UO.includes(m.key) && (g(), m.preventDefault());
        })
      }
    ) });
  }
);
vC.displayName = gC;
var bC = "SelectValue", yC = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: o, children: i, placeholder: a = "", ...s } = e, l = P0(bC, n), { onValueNodeHasChildrenChange: c } = l, f = i !== void 0, u = F1(t, l.onValueNodeChange);
    return r2(() => {
      c(f);
    }, [c, f]), /* @__PURE__ */ v(
      y1.span,
      {
        ...s,
        ref: u,
        style: { pointerEvents: "none" },
        children: VC(l.value) ? /* @__PURE__ */ v(ze, { children: a }) : i
      }
    );
  }
);
yC.displayName = bC;
var QO = "SelectIcon", CC = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: r, ...o } = e;
    return /* @__PURE__ */ v(y1.span, { "aria-hidden": !0, ...o, ref: t, children: r || "▼" });
  }
);
CC.displayName = QO;
var JO = "SelectPortal", wC = (e) => /* @__PURE__ */ v(an, { asChild: !0, ...e });
wC.displayName = JO;
var Q0 = "SelectContent", _C = d.forwardRef(
  (e, t) => {
    const n = P0(Q0, e.__scopeSelect), [r, o] = d.useState();
    if (r2(() => {
      o(new DocumentFragment());
    }, []), !n.open) {
      const i = r;
      return i ? Pi.createPortal(
        /* @__PURE__ */ v(xC, { scope: e.__scopeSelect, children: /* @__PURE__ */ v(Xi.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ v("div", { children: e.children }) }) }),
        i
      ) : null;
    }
    return /* @__PURE__ */ v(SC, { ...e, ref: t });
  }
);
_C.displayName = Q0;
var lt = 10, [xC, A0] = cn(Q0), eN = "SelectContentImpl", tN = /* @__PURE__ */ w0("SelectContent.RemoveScroll"), SC = d.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: r = "item-aligned",
      onCloseAutoFocus: o,
      onEscapeKeyDown: i,
      onPointerDownOutside: a,
      //
      // PopperContent props
      side: s,
      sideOffset: l,
      align: c,
      alignOffset: f,
      arrowPadding: u,
      collisionBoundary: h,
      collisionPadding: p,
      sticky: g,
      hideWhenDetached: m,
      avoidCollisions: b,
      //
      ...y
    } = e, C = P0(Q0, n), [_, M] = d.useState(null), [S, k] = d.useState(null), L = F1(t, (Y) => M(Y)), [P, I] = d.useState(null), [O, E] = d.useState(
      null
    ), B = Qi(n), [W, F] = d.useState(!1), z = d.useRef(!1);
    d.useEffect(() => {
      if (_) return Wi(_);
    }, [_]), Ni();
    const D = d.useCallback(
      (Y) => {
        const [Q, ...N] = B().map((T) => T.ref.current), [j] = N.slice(-1), t1 = document.activeElement;
        for (const T of Y)
          if (T === t1 || (T?.scrollIntoView({ block: "nearest" }), T === Q && S && (S.scrollTop = 0), T === j && S && (S.scrollTop = S.scrollHeight), T?.focus(), document.activeElement !== t1)) return;
      },
      [B, S]
    ), Z = d.useCallback(
      () => D([P, _]),
      [D, P, _]
    );
    d.useEffect(() => {
      W && Z();
    }, [W, Z]);
    const { onOpenChange: U, triggerPointerDownPosRef: $ } = C;
    d.useEffect(() => {
      if (_) {
        let Y = { x: 0, y: 0 };
        const Q = (j) => {
          Y = {
            x: Math.abs(Math.round(j.pageX) - ($.current?.x ?? 0)),
            y: Math.abs(Math.round(j.pageY) - ($.current?.y ?? 0))
          };
        }, N = (j) => {
          Y.x <= 10 && Y.y <= 10 ? j.preventDefault() : _.contains(j.target) || U(!1), document.removeEventListener("pointermove", Q), $.current = null;
        };
        return $.current !== null && (document.addEventListener("pointermove", Q), document.addEventListener("pointerup", N, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", Q), document.removeEventListener("pointerup", N, { capture: !0 });
        };
      }
    }, [_, U, $]), d.useEffect(() => {
      const Y = () => U(!1);
      return window.addEventListener("blur", Y), window.addEventListener("resize", Y), () => {
        window.removeEventListener("blur", Y), window.removeEventListener("resize", Y);
      };
    }, [U]);
    const [q, K] = HC((Y) => {
      const Q = B().filter((t1) => !t1.disabled), N = Q.find((t1) => t1.ref.current === document.activeElement), j = jC(Q, Y, N);
      j && setTimeout(() => j.ref.current.focus());
    }), V = d.useCallback(
      (Y, Q, N) => {
        const j = !z.current && !N;
        (C.value !== void 0 && C.value === Q || j) && (I(Y), j && (z.current = !0));
      },
      [C.value]
    ), n1 = d.useCallback(() => _?.focus(), [_]), o1 = d.useCallback(
      (Y, Q, N) => {
        const j = !z.current && !N;
        (C.value !== void 0 && C.value === Q || j) && E(Y);
      },
      [C.value]
    ), r1 = r === "popper" ? Y6 : MC, X = r1 === Y6 ? {
      side: s,
      sideOffset: l,
      align: c,
      alignOffset: f,
      arrowPadding: u,
      collisionBoundary: h,
      collisionPadding: p,
      sticky: g,
      hideWhenDetached: m,
      avoidCollisions: b
    } : {};
    return /* @__PURE__ */ v(
      xC,
      {
        scope: n,
        content: _,
        viewport: S,
        onViewportChange: k,
        itemRefCallback: V,
        selectedItem: P,
        onItemLeave: n1,
        itemTextRefCallback: o1,
        focusSelectedItem: Z,
        selectedItemText: O,
        position: r,
        isPositioned: W,
        searchRef: q,
        children: /* @__PURE__ */ v(Wr, { as: tN, allowPinchZoom: !0, children: /* @__PURE__ */ v(
          Dr,
          {
            asChild: !0,
            trapped: C.open,
            onMountAutoFocus: (Y) => {
              Y.preventDefault();
            },
            onUnmountAutoFocus: p1(o, (Y) => {
              C.trigger?.focus({ preventScroll: !0 }), Y.preventDefault();
            }),
            children: /* @__PURE__ */ v(
              c3,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: i,
                onPointerDownOutside: a,
                onFocusOutside: (Y) => Y.preventDefault(),
                onDismiss: () => C.onOpenChange(!1),
                children: /* @__PURE__ */ v(
                  r1,
                  {
                    role: "listbox",
                    id: C.contentId,
                    "data-state": C.open ? "open" : "closed",
                    dir: C.dir,
                    onContextMenu: (Y) => Y.preventDefault(),
                    ...y,
                    ...X,
                    onPlaced: () => F(!0),
                    ref: L,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...y.style
                    },
                    onKeyDown: p1(y.onKeyDown, (Y) => {
                      const Q = Y.ctrlKey || Y.altKey || Y.metaKey;
                      if (Y.key === "Tab" && Y.preventDefault(), !Q && Y.key.length === 1 && K(Y.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(Y.key)) {
                        let j = B().filter((t1) => !t1.disabled).map((t1) => t1.ref.current);
                        if (["ArrowUp", "End"].includes(Y.key) && (j = j.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(Y.key)) {
                          const t1 = Y.target, T = j.indexOf(t1);
                          j = j.slice(T + 1);
                        }
                        setTimeout(() => D(j)), Y.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
SC.displayName = eN;
var nN = "SelectItemAlignedPosition", MC = d.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: r, ...o } = e, i = P0(Q0, n), a = A0(Q0, n), [s, l] = d.useState(null), [c, f] = d.useState(null), u = F1(t, (L) => f(L)), h = Qi(n), p = d.useRef(!1), g = d.useRef(!0), { viewport: m, selectedItem: b, selectedItemText: y, focusSelectedItem: C } = a, _ = d.useCallback(() => {
    if (i.trigger && i.valueNode && s && c && m && b && y) {
      const L = i.trigger.getBoundingClientRect(), P = c.getBoundingClientRect(), I = i.valueNode.getBoundingClientRect(), O = y.getBoundingClientRect();
      if (i.dir !== "rtl") {
        const t1 = O.left - P.left, T = I.left - t1, u1 = L.left - T, l1 = L.width + u1, d1 = Math.max(l1, P.width), C1 = window.innerWidth - lt, g1 = G6(T, [
          lt,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(lt, C1 - d1)
        ]);
        s.style.minWidth = l1 + "px", s.style.left = g1 + "px";
      } else {
        const t1 = P.right - O.right, T = window.innerWidth - I.right - t1, u1 = window.innerWidth - L.right - T, l1 = L.width + u1, d1 = Math.max(l1, P.width), C1 = window.innerWidth - lt, g1 = G6(T, [
          lt,
          Math.max(lt, C1 - d1)
        ]);
        s.style.minWidth = l1 + "px", s.style.right = g1 + "px";
      }
      const E = h(), B = window.innerHeight - lt * 2, W = m.scrollHeight, F = window.getComputedStyle(c), z = parseInt(F.borderTopWidth, 10), D = parseInt(F.paddingTop, 10), Z = parseInt(F.borderBottomWidth, 10), U = parseInt(F.paddingBottom, 10), $ = z + D + W + U + Z, q = Math.min(b.offsetHeight * 5, $), K = window.getComputedStyle(m), V = parseInt(K.paddingTop, 10), n1 = parseInt(K.paddingBottom, 10), o1 = L.top + L.height / 2 - lt, r1 = B - o1, X = b.offsetHeight / 2, Y = b.offsetTop + X, Q = z + D + Y, N = $ - Q;
      if (Q <= o1) {
        const t1 = E.length > 0 && b === E[E.length - 1].ref.current;
        s.style.bottom = "0px";
        const T = c.clientHeight - m.offsetTop - m.offsetHeight, u1 = Math.max(
          r1,
          X + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (t1 ? n1 : 0) + T + Z
        ), l1 = Q + u1;
        s.style.height = l1 + "px";
      } else {
        const t1 = E.length > 0 && b === E[0].ref.current;
        s.style.top = "0px";
        const u1 = Math.max(
          o1,
          z + m.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (t1 ? V : 0) + X
        ) + N;
        s.style.height = u1 + "px", m.scrollTop = Q - o1 + m.offsetTop;
      }
      s.style.margin = `${lt}px 0`, s.style.minHeight = q + "px", s.style.maxHeight = B + "px", r?.(), requestAnimationFrame(() => p.current = !0);
    }
  }, [
    h,
    i.trigger,
    i.valueNode,
    s,
    c,
    m,
    b,
    y,
    i.dir,
    r
  ]);
  r2(() => _(), [_]);
  const [M, S] = d.useState();
  r2(() => {
    c && S(window.getComputedStyle(c).zIndex);
  }, [c]);
  const k = d.useCallback(
    (L) => {
      L && g.current === !0 && (_(), C?.(), g.current = !1);
    },
    [_, C]
  );
  return /* @__PURE__ */ v(
    oN,
    {
      scope: n,
      contentWrapper: s,
      shouldExpandOnScrollRef: p,
      onScrollButtonChange: k,
      children: /* @__PURE__ */ v(
        "div",
        {
          ref: l,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: M
          },
          children: /* @__PURE__ */ v(
            y1.div,
            {
              ...o,
              ref: u,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...o.style
              }
            }
          )
        }
      )
    }
  );
});
MC.displayName = nN;
var rN = "SelectPopperPosition", Y6 = d.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: r = "start",
    collisionPadding: o = lt,
    ...i
  } = e, a = Ji(n);
  return /* @__PURE__ */ v(
    Fr,
    {
      ...a,
      ...i,
      ref: t,
      align: r,
      collisionPadding: o,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...i.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Y6.displayName = rN;
var [oN, S5] = cn(Q0, {}), Z6 = "SelectViewport", kC = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: r, ...o } = e, i = A0(Z6, n), a = S5(Z6, n), s = F1(t, i.onViewportChange), l = d.useRef(0);
    return /* @__PURE__ */ s1(ze, { children: [
      /* @__PURE__ */ v(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ v(Xi.Slot, { scope: n, children: /* @__PURE__ */ v(
        y1.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...o,
          ref: s,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...o.style
          },
          onScroll: p1(o.onScroll, (c) => {
            const f = c.currentTarget, { contentWrapper: u, shouldExpandOnScrollRef: h } = a;
            if (h?.current && u) {
              const p = Math.abs(l.current - f.scrollTop);
              if (p > 0) {
                const g = window.innerHeight - lt * 2, m = parseFloat(u.style.minHeight), b = parseFloat(u.style.height), y = Math.max(m, b);
                if (y < g) {
                  const C = y + p, _ = Math.min(g, C), M = C - _;
                  u.style.height = _ + "px", u.style.bottom === "0px" && (f.scrollTop = M > 0 ? M : 0, u.style.justifyContent = "flex-end");
                }
              }
            }
            l.current = f.scrollTop;
          })
        }
      ) })
    ] });
  }
);
kC.displayName = Z6;
var LC = "SelectGroup", [iN, aN] = cn(LC), EC = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = t2();
    return /* @__PURE__ */ v(iN, { scope: n, id: o, children: /* @__PURE__ */ v(y1.div, { role: "group", "aria-labelledby": o, ...r, ref: t }) });
  }
);
EC.displayName = LC;
var TC = "SelectLabel", RC = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = aN(TC, n);
    return /* @__PURE__ */ v(y1.div, { id: o.id, ...r, ref: t });
  }
);
RC.displayName = TC;
var Jo = "SelectItem", [sN, PC] = cn(Jo), AC = d.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: r,
      disabled: o = !1,
      textValue: i,
      ...a
    } = e, s = P0(Jo, n), l = A0(Jo, n), c = s.value === r, [f, u] = d.useState(i ?? ""), [h, p] = d.useState(!1), g = F1(
      t,
      (C) => l.itemRefCallback?.(C, r, o)
    ), m = t2(), b = d.useRef("touch"), y = () => {
      o || (s.onValueChange(r), s.onOpenChange(!1));
    };
    if (r === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ v(
      sN,
      {
        scope: n,
        value: r,
        disabled: o,
        textId: m,
        isSelected: c,
        onItemTextChange: d.useCallback((C) => {
          u((_) => _ || (C?.textContent ?? "").trim());
        }, []),
        children: /* @__PURE__ */ v(
          Xi.ItemSlot,
          {
            scope: n,
            value: r,
            disabled: o,
            textValue: f,
            children: /* @__PURE__ */ v(
              y1.div,
              {
                role: "option",
                "aria-labelledby": m,
                "data-highlighted": h ? "" : void 0,
                "aria-selected": c && h,
                "data-state": c ? "checked" : "unchecked",
                "aria-disabled": o || void 0,
                "data-disabled": o ? "" : void 0,
                tabIndex: o ? void 0 : -1,
                ...a,
                ref: g,
                onFocus: p1(a.onFocus, () => p(!0)),
                onBlur: p1(a.onBlur, () => p(!1)),
                onClick: p1(a.onClick, () => {
                  b.current !== "mouse" && y();
                }),
                onPointerUp: p1(a.onPointerUp, () => {
                  b.current === "mouse" && y();
                }),
                onPointerDown: p1(a.onPointerDown, (C) => {
                  b.current = C.pointerType;
                }),
                onPointerMove: p1(a.onPointerMove, (C) => {
                  b.current = C.pointerType, o ? l.onItemLeave?.() : b.current === "mouse" && C.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: p1(a.onPointerLeave, (C) => {
                  C.currentTarget === document.activeElement && l.onItemLeave?.();
                }),
                onKeyDown: p1(a.onKeyDown, (C) => {
                  l.searchRef?.current !== "" && C.key === " " || (GO.includes(C.key) && y(), C.key === " " && C.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
AC.displayName = Jo;
var qn = "SelectItemText", IC = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: o, ...i } = e, a = P0(qn, n), s = A0(qn, n), l = PC(qn, n), c = XO(qn, n), [f, u] = d.useState(null), h = F1(
      t,
      (y) => u(y),
      l.onItemTextChange,
      (y) => s.itemTextRefCallback?.(y, l.value, l.disabled)
    ), p = f?.textContent, g = d.useMemo(
      () => /* @__PURE__ */ v("option", { value: l.value, disabled: l.disabled, children: p }, l.value),
      [l.disabled, l.value, p]
    ), { onNativeOptionAdd: m, onNativeOptionRemove: b } = c;
    return r2(() => (m(g), () => b(g)), [m, b, g]), /* @__PURE__ */ s1(ze, { children: [
      /* @__PURE__ */ v(y1.span, { id: l.textId, ...i, ref: h }),
      l.isSelected && a.valueNode && !a.valueNodeHasChildren ? Pi.createPortal(i.children, a.valueNode) : null
    ] });
  }
);
IC.displayName = qn;
var OC = "SelectItemIndicator", NC = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return PC(OC, n).isSelected ? /* @__PURE__ */ v(y1.span, { "aria-hidden": !0, ...r, ref: t }) : null;
  }
);
NC.displayName = OC;
var K6 = "SelectScrollUpButton", DC = d.forwardRef((e, t) => {
  const n = A0(K6, e.__scopeSelect), r = S5(K6, e.__scopeSelect), [o, i] = d.useState(!1), a = F1(t, r.onScrollButtonChange);
  return r2(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const c = l.scrollTop > 0;
        i(c);
      };
      const l = n.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ v(
    FC,
    {
      ...e,
      ref: a,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: l } = n;
        s && l && (s.scrollTop = s.scrollTop - l.offsetHeight);
      }
    }
  ) : null;
});
DC.displayName = K6;
var X6 = "SelectScrollDownButton", BC = d.forwardRef((e, t) => {
  const n = A0(X6, e.__scopeSelect), r = S5(X6, e.__scopeSelect), [o, i] = d.useState(!1), a = F1(t, r.onScrollButtonChange);
  return r2(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const c = l.scrollHeight - l.clientHeight, f = Math.ceil(l.scrollTop) < c;
        i(f);
      };
      const l = n.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ v(
    FC,
    {
      ...e,
      ref: a,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: l } = n;
        s && l && (s.scrollTop = s.scrollTop + l.offsetHeight);
      }
    }
  ) : null;
});
BC.displayName = X6;
var FC = d.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: r, ...o } = e, i = A0("SelectScrollButton", n), a = d.useRef(null), s = Qi(n), l = d.useCallback(() => {
    a.current !== null && (window.clearInterval(a.current), a.current = null);
  }, []);
  return d.useEffect(() => () => l(), [l]), r2(() => {
    s().find((f) => f.ref.current === document.activeElement)?.ref.current?.scrollIntoView({ block: "nearest" });
  }, [s]), /* @__PURE__ */ v(
    y1.div,
    {
      "aria-hidden": !0,
      ...o,
      ref: t,
      style: { flexShrink: 0, ...o.style },
      onPointerDown: p1(o.onPointerDown, () => {
        a.current === null && (a.current = window.setInterval(r, 50));
      }),
      onPointerMove: p1(o.onPointerMove, () => {
        i.onItemLeave?.(), a.current === null && (a.current = window.setInterval(r, 50));
      }),
      onPointerLeave: p1(o.onPointerLeave, () => {
        l();
      })
    }
  );
}), lN = "SelectSeparator", $C = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return /* @__PURE__ */ v(y1.div, { "aria-hidden": !0, ...r, ref: t });
  }
);
$C.displayName = lN;
var Q6 = "SelectArrow", cN = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = Ji(n), i = P0(Q6, n), a = A0(Q6, n);
    return i.open && a.position === "popper" ? /* @__PURE__ */ v($r, { ...o, ...r, ref: t }) : null;
  }
);
cN.displayName = Q6;
var uN = "SelectBubbleInput", WC = d.forwardRef(
  ({ __scopeSelect: e, value: t, ...n }, r) => {
    const o = d.useRef(null), i = F1(r, o), a = Yi(t);
    return d.useEffect(() => {
      const s = o.current;
      if (!s) return;
      const l = window.HTMLSelectElement.prototype, f = Object.getOwnPropertyDescriptor(
        l,
        "value"
      ).set;
      if (a !== t && f) {
        const u = new Event("change", { bubbles: !0 });
        f.call(s, t), s.dispatchEvent(u);
      }
    }, [a, t]), /* @__PURE__ */ v(
      y1.select,
      {
        ...n,
        style: { ...hC, ...n.style },
        ref: i,
        defaultValue: t
      }
    );
  }
);
WC.displayName = uN;
function VC(e) {
  return e === "" || e === void 0;
}
function HC(e) {
  const t = u2(e), n = d.useRef(""), r = d.useRef(0), o = d.useCallback(
    (a) => {
      const s = n.current + a;
      t(s), function l(c) {
        n.current = c, window.clearTimeout(r.current), c !== "" && (r.current = window.setTimeout(() => l(""), 1e3));
      }(s);
    },
    [t]
  ), i = d.useCallback(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return d.useEffect(() => () => window.clearTimeout(r.current), []), [n, o, i];
}
function jC(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((c) => c === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let a = dN(e, Math.max(i, 0));
  o.length === 1 && (a = a.filter((c) => c !== n));
  const l = a.find(
    (c) => c.textValue.toLowerCase().startsWith(o.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function dN(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var fN = mC, hN = vC, pN = yC, mN = CC, qC = wC, zC = _C, UC = kC, gN = EC, vN = RC, GC = AC, YC = IC, bN = NC, yN = DC, CN = BC, wN = $C;
const M5 = fN;
M5.displayName = "LBSelect";
const _N = gN;
_N.displayName = "LBSelectGroup";
const k5 = pN;
k5.displayName = "LBSelectValue";
const L5 = x1(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ s1(
  hN,
  {
    ref: r,
    ...n,
    style: void 0,
    className: e1(
      "flex h-9 items-center justify-between whitespace-nowrap rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-ring disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1",
      e
    ),
    children: [
      t,
      /* @__PURE__ */ v(mN, { asChild: !0, children: /* @__PURE__ */ v(sn, { className: "ml-1 size-4 opacity-50" }) })
    ]
  }
));
L5.displayName = "LBSelectTrigger";
const ZC = x1((e, t) => /* @__PURE__ */ v(
  yN,
  {
    ref: t,
    ...e,
    style: void 0,
    className: "flex cursor-default items-center justify-center py-1",
    children: /* @__PURE__ */ v(Gy, { className: "size-4" })
  }
));
ZC.displayName = "LBSelectScrollUpButton";
const KC = x1((e, t) => /* @__PURE__ */ v(
  CN,
  {
    ref: t,
    ...e,
    className: "flex cursor-default items-center justify-center py-1",
    children: /* @__PURE__ */ v(sn, { className: "size-4" })
  }
));
KC.displayName = "LBSelectScrollDownButton";
const XC = x1(({ className: e, children: t, position: n = "popper", ...r }, o) => /* @__PURE__ */ v(qC, { children: /* @__PURE__ */ s1(
  zC,
  {
    ref: o,
    className: e1(
      "relative z-50 max-h-96 min-w-[8rem] overflow-hidden rounded-md border bg-popover text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
      e
    ),
    position: n,
    ...r,
    children: [
      /* @__PURE__ */ v(ZC, {}),
      /* @__PURE__ */ v(
        UC,
        {
          className: e1(
            "p-1",
            n === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"
          ),
          children: t
        }
      ),
      /* @__PURE__ */ v(KC, {})
    ]
  }
) }));
XC.displayName = "LBSelectContent";
const xN = x1((e, t) => /* @__PURE__ */ v(
  vN,
  {
    ref: t,
    ...e,
    style: void 0,
    className: "p-2 text-sm font-semibold"
  }
));
xN.displayName = "LBSelectLabel";
const QC = x1(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ s1(
  GC,
  {
    ref: r,
    ...n,
    style: void 0,
    className: e1(
      "relative flex w-full cursor-default select-none items-center rounded-sm py-2 pl-2 pr-8 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    children: [
      /* @__PURE__ */ v("span", { className: "absolute right-2 flex size-4 items-center justify-center", children: /* @__PURE__ */ v(bN, { children: /* @__PURE__ */ v(zr, { className: "size-4" }) }) }),
      /* @__PURE__ */ v(YC, { children: t })
    ]
  }
));
QC.displayName = "LBSelectItem";
const SN = x1((e, t) => /* @__PURE__ */ v(
  wN,
  {
    ref: t,
    className: "m-1 h-[1px] bg-muted",
    ...e
  }
));
SN.displayName = "LBSelectSeparator";
var ea = "Popover", [JC, R01] = o2(ea, [
  Bt
]), Ur = Bt(), [MN, I0] = JC(ea), ew = (e) => {
  const {
    __scopePopover: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    modal: a = !1
  } = e, s = Ur(t), l = d.useRef(null), [c, f] = d.useState(!1), [u, h] = E2({
    prop: r,
    defaultProp: o ?? !1,
    onChange: i,
    caller: ea
  });
  return /* @__PURE__ */ v(rn, { ...s, children: /* @__PURE__ */ v(
    MN,
    {
      scope: t,
      contentId: t2(),
      triggerRef: l,
      open: u,
      onOpenChange: h,
      onOpenToggle: d.useCallback(() => h((p) => !p), [h]),
      hasCustomAnchor: c,
      onCustomAnchorAdd: d.useCallback(() => f(!0), []),
      onCustomAnchorRemove: d.useCallback(() => f(!1), []),
      modal: a,
      children: n
    }
  ) });
};
ew.displayName = ea;
var tw = "PopoverAnchor", nw = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = I0(tw, n), i = Ur(n), { onCustomAnchorAdd: a, onCustomAnchorRemove: s } = o;
    return d.useEffect(() => (a(), () => s()), [a, s]), /* @__PURE__ */ v(on, { ...i, ...r, ref: t });
  }
);
nw.displayName = tw;
var rw = "PopoverTrigger", ow = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = I0(rw, n), i = Ur(n), a = F1(t, o.triggerRef), s = /* @__PURE__ */ v(
      y1.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": cw(o.open),
        ...r,
        ref: a,
        onClick: p1(e.onClick, o.onOpenToggle)
      }
    );
    return o.hasCustomAnchor ? s : /* @__PURE__ */ v(on, { asChild: !0, ...i, children: s });
  }
);
ow.displayName = rw;
var E5 = "PopoverPortal", [kN, LN] = JC(E5, {
  forceMount: void 0
}), iw = (e) => {
  const { __scopePopover: t, forceMount: n, children: r, container: o } = e, i = I0(E5, t);
  return /* @__PURE__ */ v(kN, { scope: t, forceMount: n, children: /* @__PURE__ */ v(i2, { present: n || i.open, children: /* @__PURE__ */ v(an, { asChild: !0, container: o, children: r }) }) });
};
iw.displayName = E5;
var H3 = "PopoverContent", aw = d.forwardRef(
  (e, t) => {
    const n = LN(H3, e.__scopePopover), { forceMount: r = n.forceMount, ...o } = e, i = I0(H3, e.__scopePopover);
    return /* @__PURE__ */ v(i2, { present: r || i.open, children: i.modal ? /* @__PURE__ */ v(TN, { ...o, ref: t }) : /* @__PURE__ */ v(RN, { ...o, ref: t }) });
  }
);
aw.displayName = H3;
var EN = /* @__PURE__ */ w0("PopoverContent.RemoveScroll"), TN = d.forwardRef(
  (e, t) => {
    const n = I0(H3, e.__scopePopover), r = d.useRef(null), o = F1(t, r), i = d.useRef(!1);
    return d.useEffect(() => {
      const a = r.current;
      if (a) return Wi(a);
    }, []), /* @__PURE__ */ v(Wr, { as: EN, allowPinchZoom: !0, children: /* @__PURE__ */ v(
      sw,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: p1(e.onCloseAutoFocus, (a) => {
          a.preventDefault(), i.current || n.triggerRef.current?.focus();
        }),
        onPointerDownOutside: p1(
          e.onPointerDownOutside,
          (a) => {
            const s = a.detail.originalEvent, l = s.button === 0 && s.ctrlKey === !0, c = s.button === 2 || l;
            i.current = c;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: p1(
          e.onFocusOutside,
          (a) => a.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), RN = d.forwardRef(
  (e, t) => {
    const n = I0(H3, e.__scopePopover), r = d.useRef(!1), o = d.useRef(!1);
    return /* @__PURE__ */ v(
      sw,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          e.onCloseAutoFocus?.(i), i.defaultPrevented || (r.current || n.triggerRef.current?.focus(), i.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (i) => {
          e.onInteractOutside?.(i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const a = i.target;
          n.triggerRef.current?.contains(a) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
        }
      }
    );
  }
), sw = d.forwardRef(
  (e, t) => {
    const {
      __scopePopover: n,
      trapFocus: r,
      onOpenAutoFocus: o,
      onCloseAutoFocus: i,
      disableOutsidePointerEvents: a,
      onEscapeKeyDown: s,
      onPointerDownOutside: l,
      onFocusOutside: c,
      onInteractOutside: f,
      ...u
    } = e, h = I0(H3, n), p = Ur(n);
    return Ni(), /* @__PURE__ */ v(
      Dr,
      {
        asChild: !0,
        loop: !0,
        trapped: r,
        onMountAutoFocus: o,
        onUnmountAutoFocus: i,
        children: /* @__PURE__ */ v(
          c3,
          {
            asChild: !0,
            disableOutsidePointerEvents: a,
            onInteractOutside: f,
            onEscapeKeyDown: s,
            onPointerDownOutside: l,
            onFocusOutside: c,
            onDismiss: () => h.onOpenChange(!1),
            children: /* @__PURE__ */ v(
              Fr,
              {
                "data-state": cw(h.open),
                role: "dialog",
                id: h.contentId,
                ...p,
                ...u,
                ref: t,
                style: {
                  ...u.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), lw = "PopoverClose", PN = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = I0(lw, n);
    return /* @__PURE__ */ v(
      y1.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: p1(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
PN.displayName = lw;
var AN = "PopoverArrow", IN = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = Ur(n);
    return /* @__PURE__ */ v($r, { ...o, ...r, ref: t });
  }
);
IN.displayName = AN;
function cw(e) {
  return e ? "open" : "closed";
}
var ON = ew, NN = nw, DN = ow, BN = iw, FN = aw;
const ta = ON;
ta.displayName = "LBPopover";
const na = DN;
na.displayName = "LBPopoverTrigger";
const $N = NN;
$N.displayName = "LBPopoverAnchor";
const ra = x1(({ className: e, align: t = "center", sideOffset: n = 4, ...r }, o) => /* @__PURE__ */ v(BN, { children: /* @__PURE__ */ v(
  FN,
  {
    ref: o,
    align: t,
    sideOffset: n,
    ...r,
    style: void 0,
    className: e1(
      "z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    )
  }
) }));
ra.displayName = "LBPopoverContent";
var oa = "Dialog", [uw, dw] = o2(oa), [WN, bt] = uw(oa), fw = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    modal: a = !0
  } = e, s = d.useRef(null), l = d.useRef(null), [c, f] = E2({
    prop: r,
    defaultProp: o ?? !1,
    onChange: i,
    caller: oa
  });
  return /* @__PURE__ */ v(
    WN,
    {
      scope: t,
      triggerRef: s,
      contentRef: l,
      contentId: t2(),
      titleId: t2(),
      descriptionId: t2(),
      open: c,
      onOpenChange: f,
      onOpenToggle: d.useCallback(() => f((u) => !u), [f]),
      modal: a,
      children: n
    }
  );
};
fw.displayName = oa;
var hw = "DialogTrigger", pw = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = bt(hw, n), i = F1(t, o.triggerRef);
    return /* @__PURE__ */ v(
      y1.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": P5(o.open),
        ...r,
        ref: i,
        onClick: p1(e.onClick, o.onOpenToggle)
      }
    );
  }
);
pw.displayName = hw;
var T5 = "DialogPortal", [VN, mw] = uw(T5, {
  forceMount: void 0
}), gw = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, i = bt(T5, t);
  return /* @__PURE__ */ v(VN, { scope: t, forceMount: n, children: d.Children.map(r, (a) => /* @__PURE__ */ v(i2, { present: n || i.open, children: /* @__PURE__ */ v(an, { asChild: !0, container: o, children: a }) })) });
};
gw.displayName = T5;
var ei = "DialogOverlay", vw = d.forwardRef(
  (e, t) => {
    const n = mw(ei, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = bt(ei, e.__scopeDialog);
    return i.modal ? /* @__PURE__ */ v(i2, { present: r || i.open, children: /* @__PURE__ */ v(jN, { ...o, ref: t }) }) : null;
  }
);
vw.displayName = ei;
var HN = /* @__PURE__ */ w0("DialogOverlay.RemoveScroll"), jN = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = bt(ei, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ v(Wr, { as: HN, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ v(
        y1.div,
        {
          "data-state": P5(o.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), J0 = "DialogContent", bw = d.forwardRef(
  (e, t) => {
    const n = mw(J0, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = bt(J0, e.__scopeDialog);
    return /* @__PURE__ */ v(i2, { present: r || i.open, children: i.modal ? /* @__PURE__ */ v(qN, { ...o, ref: t }) : /* @__PURE__ */ v(zN, { ...o, ref: t }) });
  }
);
bw.displayName = J0;
var qN = d.forwardRef(
  (e, t) => {
    const n = bt(J0, e.__scopeDialog), r = d.useRef(null), o = F1(t, n.contentRef, r);
    return d.useEffect(() => {
      const i = r.current;
      if (i) return Wi(i);
    }, []), /* @__PURE__ */ v(
      yw,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: p1(e.onCloseAutoFocus, (i) => {
          i.preventDefault(), n.triggerRef.current?.focus();
        }),
        onPointerDownOutside: p1(e.onPointerDownOutside, (i) => {
          const a = i.detail.originalEvent, s = a.button === 0 && a.ctrlKey === !0;
          (a.button === 2 || s) && i.preventDefault();
        }),
        onFocusOutside: p1(
          e.onFocusOutside,
          (i) => i.preventDefault()
        )
      }
    );
  }
), zN = d.forwardRef(
  (e, t) => {
    const n = bt(J0, e.__scopeDialog), r = d.useRef(!1), o = d.useRef(!1);
    return /* @__PURE__ */ v(
      yw,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          e.onCloseAutoFocus?.(i), i.defaultPrevented || (r.current || n.triggerRef.current?.focus(), i.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (i) => {
          e.onInteractOutside?.(i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const a = i.target;
          n.triggerRef.current?.contains(a) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
        }
      }
    );
  }
), yw = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: i, ...a } = e, s = bt(J0, n), l = d.useRef(null), c = F1(t, l);
    return Ni(), /* @__PURE__ */ s1(ze, { children: [
      /* @__PURE__ */ v(
        Dr,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: o,
          onUnmountAutoFocus: i,
          children: /* @__PURE__ */ v(
            c3,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": P5(s.open),
              ...a,
              ref: c,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ s1(ze, { children: [
        /* @__PURE__ */ v(GN, { titleId: s.titleId }),
        /* @__PURE__ */ v(ZN, { contentRef: l, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), R5 = "DialogTitle", Cw = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = bt(R5, n);
    return /* @__PURE__ */ v(y1.h2, { id: o.titleId, ...r, ref: t });
  }
);
Cw.displayName = R5;
var ww = "DialogDescription", _w = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = bt(ww, n);
    return /* @__PURE__ */ v(y1.p, { id: o.descriptionId, ...r, ref: t });
  }
);
_w.displayName = ww;
var xw = "DialogClose", Sw = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = bt(xw, n);
    return /* @__PURE__ */ v(
      y1.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: p1(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
Sw.displayName = xw;
function P5(e) {
  return e ? "open" : "closed";
}
var Mw = "DialogTitleWarning", [UN, kw] = hT(Mw, {
  contentName: J0,
  titleName: R5,
  docsSlug: "dialog"
}), GN = ({ titleId: e }) => {
  const t = kw(Mw), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return d.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, YN = "DialogDescriptionWarning", ZN = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${kw(YN).contentName}}.`;
  return d.useEffect(() => {
    const o = e.current?.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, ia = fw, A5 = pw, aa = gw, Gr = vw, un = bw, sa = Cw, I5 = _w, Yr = Sw;
const Lw = ia;
Lw.displayName = "LBDialog";
const KN = A5;
KN.displayName = "LBDialogTrigger";
const O5 = aa;
O5.displayName = "LBDialogPortal";
const N5 = Yr;
N5.displayName = "LBDialogClose";
const D5 = x1(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  Gr,
  {
    ref: n,
    ...t,
    className: e1(
      "fixed inset-0 z-50 bg-black/25 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    )
  }
));
D5.displayName = "LBDialogOverlay";
const Ew = x1(({ className: e, children: t, overlayClassName: n, ...r }, o) => /* @__PURE__ */ s1(O5, { children: [
  /* @__PURE__ */ v(D5, { className: n }),
  /* @__PURE__ */ s1(
    un,
    {
      ref: o,
      ...r,
      className: e1(
        "fixed left-1/2 top-1/2 z-50 grid w-full max-w-lg -translate-x-1/2 -translate-y-1/2 gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg",
        e
      ),
      style: void 0,
      children: [
        t,
        /* @__PURE__ */ s1(N5, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground", children: [
          /* @__PURE__ */ v(ln, { className: "size-4" }),
          /* @__PURE__ */ v("span", { className: "sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }));
Ew.displayName = "LBDialogContent";
function XN({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ v(
    "div",
    {
      className: e1(
        "flex flex-col space-y-2 text-center sm:text-left",
        e
      ),
      ...t
    }
  );
}
XN.displayName = "LBDialogHeader";
function QN({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ v(
    "div",
    {
      className: e1(
        "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
        e
      ),
      ...t
    }
  );
}
QN.displayName = "LBDialogFooter";
const JN = x1(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  sa,
  {
    ref: n,
    ...t,
    className: e1(
      "text-lg font-semibold leading-none tracking-tight",
      e
    ),
    style: void 0
  }
));
JN.displayName = "LBDialogTitle";
const eD = x1(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  I5,
  {
    ref: n,
    ...t,
    style: void 0,
    className: e1("text-sm text-muted-foreground", e)
  }
));
eD.displayName = "LBDialogDescription";
var yf = 1, tD = 0.9, nD = 0.8, rD = 0.17, Ys = 0.1, Zs = 0.999, oD = 0.9999, iD = 0.99, aD = /[\\\/_+.#"@\[\(\{&]/, sD = /[\\\/_+.#"@\[\(\{&]/g, lD = /[\s-]/, Tw = /[\s-]/g;
function J6(e, t, n, r, o, i, a) {
  if (i === t.length) return o === e.length ? yf : iD;
  var s = `${o},${i}`;
  if (a[s] !== void 0) return a[s];
  for (var l = r.charAt(i), c = n.indexOf(l, o), f = 0, u, h, p, g; c >= 0; ) u = J6(e, t, n, r, c + 1, i + 1, a), u > f && (c === o ? u *= yf : aD.test(e.charAt(c - 1)) ? (u *= nD, p = e.slice(o, c - 1).match(sD), p && o > 0 && (u *= Math.pow(Zs, p.length))) : lD.test(e.charAt(c - 1)) ? (u *= tD, g = e.slice(o, c - 1).match(Tw), g && o > 0 && (u *= Math.pow(Zs, g.length))) : (u *= rD, o > 0 && (u *= Math.pow(Zs, c - o))), e.charAt(c) !== t.charAt(i) && (u *= oD)), (u < Ys && n.charAt(c - 1) === r.charAt(i + 1) || r.charAt(i + 1) === r.charAt(i) && n.charAt(c - 1) !== r.charAt(i)) && (h = J6(e, t, n, r, c + 1, i + 2, a), h * Ys > u && (u = h * Ys)), u > f && (f = u), c = n.indexOf(l, c + 1);
  return a[s] = f, f;
}
function Cf(e) {
  return e.toLowerCase().replace(Tw, " ");
}
function cD(e, t, n) {
  return e = n && n.length > 0 ? `${e + " " + n.join(" ")}` : e, J6(e, t, Cf(e), Cf(t), 0, 0, {});
}
var kn = '[cmdk-group=""]', Ks = '[cmdk-group-items=""]', uD = '[cmdk-group-heading=""]', Rw = '[cmdk-item=""]', wf = `${Rw}:not([aria-disabled="true"])`, eu = "cmdk-item-select", T3 = "data-value", dD = (e, t, n) => cD(e, t, n), Pw = d.createContext(void 0), Zr = () => d.useContext(Pw), Aw = d.createContext(void 0), B5 = () => d.useContext(Aw), Iw = d.createContext(void 0), Ow = d.forwardRef((e, t) => {
  let n = R3(() => {
    var V, n1;
    return { search: "", value: (n1 = (V = e.value) != null ? V : e.defaultValue) != null ? n1 : "", selectedItemId: void 0, filtered: { count: 0, items: /* @__PURE__ */ new Map(), groups: /* @__PURE__ */ new Set() } };
  }), r = R3(() => /* @__PURE__ */ new Set()), o = R3(() => /* @__PURE__ */ new Map()), i = R3(() => /* @__PURE__ */ new Map()), a = R3(() => /* @__PURE__ */ new Set()), s = Nw(e), { label: l, children: c, value: f, onValueChange: u, filter: h, shouldFilter: p, loop: g, disablePointerSelection: m = !1, vimBindings: b = !0, ...y } = e, C = t2(), _ = t2(), M = t2(), S = d.useRef(null), k = _D();
  e3(() => {
    if (f !== void 0) {
      let V = f.trim();
      n.current.value = V, L.emit();
    }
  }, [f]), e3(() => {
    k(6, W);
  }, []);
  let L = d.useMemo(() => ({ subscribe: (V) => (a.current.add(V), () => a.current.delete(V)), snapshot: () => n.current, setState: (V, n1, o1) => {
    var r1, X, Y, Q;
    if (!Object.is(n.current[V], n1)) {
      if (n.current[V] = n1, V === "search") B(), O(), k(1, E);
      else if (V === "value") {
        if (document.activeElement.hasAttribute("cmdk-input") || document.activeElement.hasAttribute("cmdk-root")) {
          let N = document.getElementById(M);
          N ? N.focus() : (r1 = document.getElementById(C)) == null || r1.focus();
        }
        if (k(7, () => {
          var N;
          n.current.selectedItemId = (N = F()) == null ? void 0 : N.id, L.emit();
        }), o1 || k(5, W), ((X = s.current) == null ? void 0 : X.value) !== void 0) {
          let N = n1 ?? "";
          (Q = (Y = s.current).onValueChange) == null || Q.call(Y, N);
          return;
        }
      }
      L.emit();
    }
  }, emit: () => {
    a.current.forEach((V) => V());
  } }), []), P = d.useMemo(() => ({ value: (V, n1, o1) => {
    var r1;
    n1 !== ((r1 = i.current.get(V)) == null ? void 0 : r1.value) && (i.current.set(V, { value: n1, keywords: o1 }), n.current.filtered.items.set(V, I(n1, o1)), k(2, () => {
      O(), L.emit();
    }));
  }, item: (V, n1) => (r.current.add(V), n1 && (o.current.has(n1) ? o.current.get(n1).add(V) : o.current.set(n1, /* @__PURE__ */ new Set([V]))), k(3, () => {
    B(), O(), n.current.value || E(), L.emit();
  }), () => {
    i.current.delete(V), r.current.delete(V), n.current.filtered.items.delete(V);
    let o1 = F();
    k(4, () => {
      B(), o1?.getAttribute("id") === V && E(), L.emit();
    });
  }), group: (V) => (o.current.has(V) || o.current.set(V, /* @__PURE__ */ new Set()), () => {
    i.current.delete(V), o.current.delete(V);
  }), filter: () => s.current.shouldFilter, label: l || e["aria-label"], getDisablePointerSelection: () => s.current.disablePointerSelection, listId: C, inputId: M, labelId: _, listInnerRef: S }), []);
  function I(V, n1) {
    var o1, r1;
    let X = (r1 = (o1 = s.current) == null ? void 0 : o1.filter) != null ? r1 : dD;
    return V ? X(V, n.current.search, n1) : 0;
  }
  function O() {
    if (!n.current.search || s.current.shouldFilter === !1) return;
    let V = n.current.filtered.items, n1 = [];
    n.current.filtered.groups.forEach((r1) => {
      let X = o.current.get(r1), Y = 0;
      X.forEach((Q) => {
        let N = V.get(Q);
        Y = Math.max(N, Y);
      }), n1.push([r1, Y]);
    });
    let o1 = S.current;
    z().sort((r1, X) => {
      var Y, Q;
      let N = r1.getAttribute("id"), j = X.getAttribute("id");
      return ((Y = V.get(j)) != null ? Y : 0) - ((Q = V.get(N)) != null ? Q : 0);
    }).forEach((r1) => {
      let X = r1.closest(Ks);
      X ? X.appendChild(r1.parentElement === X ? r1 : r1.closest(`${Ks} > *`)) : o1.appendChild(r1.parentElement === o1 ? r1 : r1.closest(`${Ks} > *`));
    }), n1.sort((r1, X) => X[1] - r1[1]).forEach((r1) => {
      var X;
      let Y = (X = S.current) == null ? void 0 : X.querySelector(`${kn}[${T3}="${encodeURIComponent(r1[0])}"]`);
      Y?.parentElement.appendChild(Y);
    });
  }
  function E() {
    let V = z().find((o1) => o1.getAttribute("aria-disabled") !== "true"), n1 = V?.getAttribute(T3);
    L.setState("value", n1 || void 0);
  }
  function B() {
    var V, n1, o1, r1;
    if (!n.current.search || s.current.shouldFilter === !1) {
      n.current.filtered.count = r.current.size;
      return;
    }
    n.current.filtered.groups = /* @__PURE__ */ new Set();
    let X = 0;
    for (let Y of r.current) {
      let Q = (n1 = (V = i.current.get(Y)) == null ? void 0 : V.value) != null ? n1 : "", N = (r1 = (o1 = i.current.get(Y)) == null ? void 0 : o1.keywords) != null ? r1 : [], j = I(Q, N);
      n.current.filtered.items.set(Y, j), j > 0 && X++;
    }
    for (let [Y, Q] of o.current) for (let N of Q) if (n.current.filtered.items.get(N) > 0) {
      n.current.filtered.groups.add(Y);
      break;
    }
    n.current.filtered.count = X;
  }
  function W() {
    var V, n1, o1;
    let r1 = F();
    r1 && (((V = r1.parentElement) == null ? void 0 : V.firstChild) === r1 && ((o1 = (n1 = r1.closest(kn)) == null ? void 0 : n1.querySelector(uD)) == null || o1.scrollIntoView({ block: "nearest" })), r1.scrollIntoView({ block: "nearest" }));
  }
  function F() {
    var V;
    return (V = S.current) == null ? void 0 : V.querySelector(`${Rw}[aria-selected="true"]`);
  }
  function z() {
    var V;
    return Array.from(((V = S.current) == null ? void 0 : V.querySelectorAll(wf)) || []);
  }
  function D(V) {
    let n1 = z()[V];
    n1 && L.setState("value", n1.getAttribute(T3));
  }
  function Z(V) {
    var n1;
    let o1 = F(), r1 = z(), X = r1.findIndex((Q) => Q === o1), Y = r1[X + V];
    (n1 = s.current) != null && n1.loop && (Y = X + V < 0 ? r1[r1.length - 1] : X + V === r1.length ? r1[0] : r1[X + V]), Y && L.setState("value", Y.getAttribute(T3));
  }
  function U(V) {
    let n1 = F(), o1 = n1?.closest(kn), r1;
    for (; o1 && !r1; ) o1 = V > 0 ? CD(o1, kn) : wD(o1, kn), r1 = o1?.querySelector(wf);
    r1 ? L.setState("value", r1.getAttribute(T3)) : Z(V);
  }
  let $ = () => D(z().length - 1), q = (V) => {
    V.preventDefault(), V.metaKey ? $() : V.altKey ? U(1) : Z(1);
  }, K = (V) => {
    V.preventDefault(), V.metaKey ? D(0) : V.altKey ? U(-1) : Z(-1);
  };
  return d.createElement(y1.div, { ref: t, tabIndex: -1, ...y, "cmdk-root": "", onKeyDown: (V) => {
    var n1;
    (n1 = y.onKeyDown) == null || n1.call(y, V);
    let o1 = V.nativeEvent.isComposing || V.keyCode === 229;
    if (!(V.defaultPrevented || o1)) switch (V.key) {
      case "n":
      case "j": {
        b && V.ctrlKey && q(V);
        break;
      }
      case "ArrowDown": {
        q(V);
        break;
      }
      case "p":
      case "k": {
        b && V.ctrlKey && K(V);
        break;
      }
      case "ArrowUp": {
        K(V);
        break;
      }
      case "Home": {
        V.preventDefault(), D(0);
        break;
      }
      case "End": {
        V.preventDefault(), $();
        break;
      }
      case "Enter": {
        V.preventDefault();
        let r1 = F();
        if (r1) {
          let X = new Event(eu);
          r1.dispatchEvent(X);
        }
      }
    }
  } }, d.createElement("label", { "cmdk-label": "", htmlFor: P.inputId, id: P.labelId, style: SD }, l), la(e, (V) => d.createElement(Aw.Provider, { value: L }, d.createElement(Pw.Provider, { value: P }, V))));
}), fD = d.forwardRef((e, t) => {
  var n, r;
  let o = t2(), i = d.useRef(null), a = d.useContext(Iw), s = Zr(), l = Nw(e), c = (r = (n = l.current) == null ? void 0 : n.forceMount) != null ? r : a?.forceMount;
  e3(() => {
    if (!c) return s.item(o, a?.id);
  }, [c]);
  let f = Dw(o, i, [e.value, e.children, i], e.keywords), u = B5(), h = M0((k) => k.value && k.value === f.current), p = M0((k) => c || s.filter() === !1 ? !0 : k.search ? k.filtered.items.get(o) > 0 : !0);
  d.useEffect(() => {
    let k = i.current;
    if (!(!k || e.disabled)) return k.addEventListener(eu, g), () => k.removeEventListener(eu, g);
  }, [p, e.onSelect, e.disabled]);
  function g() {
    var k, L;
    m(), (L = (k = l.current).onSelect) == null || L.call(k, f.current);
  }
  function m() {
    u.setState("value", f.current, !0);
  }
  if (!p) return null;
  let { disabled: b, value: y, onSelect: C, forceMount: _, keywords: M, ...S } = e;
  return d.createElement(y1.div, { ref: e0(i, t), ...S, id: o, "cmdk-item": "", role: "option", "aria-disabled": !!b, "aria-selected": !!h, "data-disabled": !!b, "data-selected": !!h, onPointerMove: b || s.getDisablePointerSelection() ? void 0 : m, onClick: b ? void 0 : g }, e.children);
}), hD = d.forwardRef((e, t) => {
  let { heading: n, children: r, forceMount: o, ...i } = e, a = t2(), s = d.useRef(null), l = d.useRef(null), c = t2(), f = Zr(), u = M0((p) => o || f.filter() === !1 ? !0 : p.search ? p.filtered.groups.has(a) : !0);
  e3(() => f.group(a), []), Dw(a, s, [e.value, e.heading, l]);
  let h = d.useMemo(() => ({ id: a, forceMount: o }), [o]);
  return d.createElement(y1.div, { ref: e0(s, t), ...i, "cmdk-group": "", role: "presentation", hidden: u ? void 0 : !0 }, n && d.createElement("div", { ref: l, "cmdk-group-heading": "", "aria-hidden": !0, id: c }, n), la(e, (p) => d.createElement("div", { "cmdk-group-items": "", role: "group", "aria-labelledby": n ? c : void 0 }, d.createElement(Iw.Provider, { value: h }, p))));
}), pD = d.forwardRef((e, t) => {
  let { alwaysRender: n, ...r } = e, o = d.useRef(null), i = M0((a) => !a.search);
  return !n && !i ? null : d.createElement(y1.div, { ref: e0(o, t), ...r, "cmdk-separator": "", role: "separator" });
}), mD = d.forwardRef((e, t) => {
  let { onValueChange: n, ...r } = e, o = e.value != null, i = B5(), a = M0((c) => c.search), s = M0((c) => c.selectedItemId), l = Zr();
  return d.useEffect(() => {
    e.value != null && i.setState("search", e.value);
  }, [e.value]), d.createElement(y1.input, { ref: t, ...r, "cmdk-input": "", autoComplete: "off", autoCorrect: "off", spellCheck: !1, "aria-autocomplete": "list", role: "combobox", "aria-expanded": !0, "aria-controls": l.listId, "aria-labelledby": l.labelId, "aria-activedescendant": s, id: l.inputId, type: "text", value: o ? e.value : a, onChange: (c) => {
    o || i.setState("search", c.target.value), n?.(c.target.value);
  } });
}), gD = d.forwardRef((e, t) => {
  let { children: n, label: r = "Suggestions", ...o } = e, i = d.useRef(null), a = d.useRef(null), s = M0((c) => c.selectedItemId), l = Zr();
  return d.useEffect(() => {
    if (a.current && i.current) {
      let c = a.current, f = i.current, u, h = new ResizeObserver(() => {
        u = requestAnimationFrame(() => {
          let p = c.offsetHeight;
          f.style.setProperty("--cmdk-list-height", p.toFixed(1) + "px");
        });
      });
      return h.observe(c), () => {
        cancelAnimationFrame(u), h.unobserve(c);
      };
    }
  }, []), d.createElement(y1.div, { ref: e0(i, t), ...o, "cmdk-list": "", role: "listbox", tabIndex: -1, "aria-activedescendant": s, "aria-label": r, id: l.listId }, la(e, (c) => d.createElement("div", { ref: e0(a, l.listInnerRef), "cmdk-list-sizer": "" }, c)));
}), vD = d.forwardRef((e, t) => {
  let { open: n, onOpenChange: r, overlayClassName: o, contentClassName: i, container: a, ...s } = e;
  return d.createElement(ia, { open: n, onOpenChange: r }, d.createElement(aa, { container: a }, d.createElement(Gr, { "cmdk-overlay": "", className: o }), d.createElement(un, { "aria-label": e.label, "cmdk-dialog": "", className: i }, d.createElement(Ow, { ref: t, ...s }))));
}), bD = d.forwardRef((e, t) => M0((n) => n.filtered.count === 0) ? d.createElement(y1.div, { ref: t, ...e, "cmdk-empty": "", role: "presentation" }) : null), yD = d.forwardRef((e, t) => {
  let { progress: n, children: r, label: o = "Loading...", ...i } = e;
  return d.createElement(y1.div, { ref: t, ...i, "cmdk-loading": "", role: "progressbar", "aria-valuenow": n, "aria-valuemin": 0, "aria-valuemax": 100, "aria-label": o }, la(e, (a) => d.createElement("div", { "aria-hidden": !0 }, a)));
}), O0 = Object.assign(Ow, { List: gD, Item: fD, Input: mD, Group: hD, Separator: pD, Dialog: vD, Empty: bD, Loading: yD });
function CD(e, t) {
  let n = e.nextElementSibling;
  for (; n; ) {
    if (n.matches(t)) return n;
    n = n.nextElementSibling;
  }
}
function wD(e, t) {
  let n = e.previousElementSibling;
  for (; n; ) {
    if (n.matches(t)) return n;
    n = n.previousElementSibling;
  }
}
function Nw(e) {
  let t = d.useRef(e);
  return e3(() => {
    t.current = e;
  }), t;
}
var e3 = typeof window > "u" ? d.useEffect : d.useLayoutEffect;
function R3(e) {
  let t = d.useRef();
  return t.current === void 0 && (t.current = e()), t;
}
function M0(e) {
  let t = B5(), n = () => e(t.snapshot());
  return d.useSyncExternalStore(t.subscribe, n, n);
}
function Dw(e, t, n, r = []) {
  let o = d.useRef(), i = Zr();
  return e3(() => {
    var a;
    let s = (() => {
      var c;
      for (let f of n) {
        if (typeof f == "string") return f.trim();
        if (typeof f == "object" && "current" in f) return f.current ? (c = f.current.textContent) == null ? void 0 : c.trim() : o.current;
      }
    })(), l = r.map((c) => c.trim());
    i.value(e, s, l), (a = t.current) == null || a.setAttribute(T3, s), o.current = s;
  }), o;
}
var _D = () => {
  let [e, t] = d.useState(), n = R3(() => /* @__PURE__ */ new Map());
  return e3(() => {
    n.current.forEach((r) => r()), n.current = /* @__PURE__ */ new Map();
  }, [e]), (r, o) => {
    n.current.set(r, o), t({});
  };
};
function xD(e) {
  let t = e.type;
  return typeof t == "function" ? t(e.props) : "render" in t ? t.render(e.props) : e;
}
function la({ asChild: e, children: t }, n) {
  return e && d.isValidElement(t) ? d.cloneElement(xD(t), { ref: t.ref }, n(t.props.children)) : n(t);
}
var SD = { position: "absolute", width: "1px", height: "1px", padding: "0", margin: "-1px", overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0" };
const F5 = x1(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  O0,
  {
    ref: n,
    className: e1(
      "flex h-full w-full flex-col overflow-hidden rounded-md bg-popover text-popover-foreground",
      e
    ),
    ...t
  }
));
F5.displayName = "LBCommand";
function MD({ children: e, ...t }) {
  return /* @__PURE__ */ v(Lw, { ...t, children: /* @__PURE__ */ v(Ew, { className: "overflow-hidden p-0", children: /* @__PURE__ */ v(F5, { className: "[&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-group]]:px-2 [&_[cmdk-input-wrapper]_svg]:size-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:size-5", children: e }) }) });
}
MD.displayName = "LBCommandDialog";
const Bw = x1(({ className: e, ...t }, n) => (
  // eslint-disable-next-line react/no-unknown-property
  /* @__PURE__ */ s1("div", { className: "flex items-center border-b px-3", "cmdk-input-wrapper": "", children: [
    /* @__PURE__ */ v(Xy, { className: "mr-2 size-4 shrink-0 opacity-50" }),
    /* @__PURE__ */ v(
      O0.Input,
      {
        ref: n,
        className: e1(
          "flex h-11 w-full rounded-md bg-transparent py-3 text-sm outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
          e
        ),
        ...t
      }
    )
  ] })
));
Bw.displayName = "LBCommandInput";
const Fw = x1(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  O0.List,
  {
    ref: n,
    className: e1("max-h-[300px] overflow-y-auto overflow-x-hidden", e),
    ...t
  }
));
Fw.displayName = "LBCommandList";
const $w = x1((e, t) => /* @__PURE__ */ v(
  O0.Empty,
  {
    ref: t,
    className: "py-6 text-center text-sm",
    ...e
  }
));
$w.displayName = "LBCommandEmpty";
const Ww = x1(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  O0.Group,
  {
    ref: n,
    className: e1(
      "overflow-hidden p-1 text-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-2 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground",
      e
    ),
    ...t
  }
));
Ww.displayName = "LBCommandGroup";
const kD = x1(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  O0.Separator,
  {
    ref: n,
    className: e1("-mx-1 h-[1px] bg-border", e),
    ...t
  }
));
kD.displayName = "LBCommandSeparator";
const Vw = x1(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  O0.Item,
  {
    ref: n,
    className: e1(
      "relative flex cursor-default gap-2 select-none items-center rounded-sm px-2 py-2 text-sm outline-none data-[disabled=true]:pointer-events-none data-[selected='true']:bg-accent data-[selected=true]:text-accent-foreground data-[disabled=true]:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      e
    ),
    ...t
  }
));
Vw.displayName = "LBCommandItem";
function LD({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ v(
    "span",
    {
      className: e1(
        "ml-auto text-xs tracking-widest text-muted-foreground",
        e
      ),
      ...t
    }
  );
}
LD.displayName = "LBCommandShortcut";
const Hw = x1((e, t) => /* @__PURE__ */ v(
  O0.Loading,
  {
    className: "relative flex animate-pulse cursor-default select-none items-center gap-2 rounded-sm p-2 text-sm outline-none [&_svg]:pointer-events-none  [&_svg]:size-4 [&_svg]:shrink-0",
    ref: t,
    ...e
  }
));
Hw.displayName = "LBCommandLoading";
var [ca, P01] = o2("Tooltip", [
  Bt
]), ua = Bt(), jw = "TooltipProvider", ED = 700, tu = "tooltip.open", [TD, $5] = ca(jw), qw = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: n = ED,
    skipDelayDuration: r = 300,
    disableHoverableContent: o = !1,
    children: i
  } = e, a = d.useRef(!0), s = d.useRef(!1), l = d.useRef(0);
  return d.useEffect(() => {
    const c = l.current;
    return () => window.clearTimeout(c);
  }, []), /* @__PURE__ */ v(
    TD,
    {
      scope: t,
      isOpenDelayedRef: a,
      delayDuration: n,
      onOpen: d.useCallback(() => {
        window.clearTimeout(l.current), a.current = !1;
      }, []),
      onClose: d.useCallback(() => {
        window.clearTimeout(l.current), l.current = window.setTimeout(
          () => a.current = !0,
          r
        );
      }, [r]),
      isPointerInTransitRef: s,
      onPointerInTransitChange: d.useCallback((c) => {
        s.current = c;
      }, []),
      disableHoverableContent: o,
      children: i
    }
  );
};
qw.displayName = jw;
var ur = "Tooltip", [RD, Kr] = ca(ur), zw = (e) => {
  const {
    __scopeTooltip: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    disableHoverableContent: a,
    delayDuration: s
  } = e, l = $5(ur, e.__scopeTooltip), c = ua(t), [f, u] = d.useState(null), h = t2(), p = d.useRef(0), g = a ?? l.disableHoverableContent, m = s ?? l.delayDuration, b = d.useRef(!1), [y, C] = E2({
    prop: r,
    defaultProp: o ?? !1,
    onChange: (L) => {
      L ? (l.onOpen(), document.dispatchEvent(new CustomEvent(tu))) : l.onClose(), i?.(L);
    },
    caller: ur
  }), _ = d.useMemo(() => y ? b.current ? "delayed-open" : "instant-open" : "closed", [y]), M = d.useCallback(() => {
    window.clearTimeout(p.current), p.current = 0, b.current = !1, C(!0);
  }, [C]), S = d.useCallback(() => {
    window.clearTimeout(p.current), p.current = 0, C(!1);
  }, [C]), k = d.useCallback(() => {
    window.clearTimeout(p.current), p.current = window.setTimeout(() => {
      b.current = !0, C(!0), p.current = 0;
    }, m);
  }, [m, C]);
  return d.useEffect(() => () => {
    p.current && (window.clearTimeout(p.current), p.current = 0);
  }, []), /* @__PURE__ */ v(rn, { ...c, children: /* @__PURE__ */ v(
    RD,
    {
      scope: t,
      contentId: h,
      open: y,
      stateAttribute: _,
      trigger: f,
      onTriggerChange: u,
      onTriggerEnter: d.useCallback(() => {
        l.isOpenDelayedRef.current ? k() : M();
      }, [l.isOpenDelayedRef, k, M]),
      onTriggerLeave: d.useCallback(() => {
        g ? S() : (window.clearTimeout(p.current), p.current = 0);
      }, [S, g]),
      onOpen: M,
      onClose: S,
      disableHoverableContent: g,
      children: n
    }
  ) });
};
zw.displayName = ur;
var nu = "TooltipTrigger", Uw = d.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, o = Kr(nu, n), i = $5(nu, n), a = ua(n), s = d.useRef(null), l = F1(t, s, o.onTriggerChange), c = d.useRef(!1), f = d.useRef(!1), u = d.useCallback(() => c.current = !1, []);
    return d.useEffect(() => () => document.removeEventListener("pointerup", u), [u]), /* @__PURE__ */ v(on, { asChild: !0, ...a, children: /* @__PURE__ */ v(
      y1.button,
      {
        "aria-describedby": o.open ? o.contentId : void 0,
        "data-state": o.stateAttribute,
        ...r,
        ref: l,
        onPointerMove: p1(e.onPointerMove, (h) => {
          h.pointerType !== "touch" && !f.current && !i.isPointerInTransitRef.current && (o.onTriggerEnter(), f.current = !0);
        }),
        onPointerLeave: p1(e.onPointerLeave, () => {
          o.onTriggerLeave(), f.current = !1;
        }),
        onPointerDown: p1(e.onPointerDown, () => {
          o.open && o.onClose(), c.current = !0, document.addEventListener("pointerup", u, { once: !0 });
        }),
        onFocus: p1(e.onFocus, () => {
          c.current || o.onOpen();
        }),
        onBlur: p1(e.onBlur, o.onClose),
        onClick: p1(e.onClick, o.onClose)
      }
    ) });
  }
);
Uw.displayName = nu;
var W5 = "TooltipPortal", [PD, AD] = ca(W5, {
  forceMount: void 0
}), Gw = (e) => {
  const { __scopeTooltip: t, forceMount: n, children: r, container: o } = e, i = Kr(W5, t);
  return /* @__PURE__ */ v(PD, { scope: t, forceMount: n, children: /* @__PURE__ */ v(i2, { present: n || i.open, children: /* @__PURE__ */ v(an, { asChild: !0, container: o, children: r }) }) });
};
Gw.displayName = W5;
var j3 = "TooltipContent", Yw = d.forwardRef(
  (e, t) => {
    const n = AD(j3, e.__scopeTooltip), { forceMount: r = n.forceMount, side: o = "top", ...i } = e, a = Kr(j3, e.__scopeTooltip);
    return /* @__PURE__ */ v(i2, { present: r || a.open, children: a.disableHoverableContent ? /* @__PURE__ */ v(Zw, { side: o, ...i, ref: t }) : /* @__PURE__ */ v(ID, { side: o, ...i, ref: t }) });
  }
), ID = d.forwardRef((e, t) => {
  const n = Kr(j3, e.__scopeTooltip), r = $5(j3, e.__scopeTooltip), o = d.useRef(null), i = F1(t, o), [a, s] = d.useState(null), { trigger: l, onClose: c } = n, f = o.current, { onPointerInTransitChange: u } = r, h = d.useCallback(() => {
    s(null), u(!1);
  }, [u]), p = d.useCallback(
    (g, m) => {
      const b = g.currentTarget, y = { x: g.clientX, y: g.clientY }, C = FD(y, b.getBoundingClientRect()), _ = $D(y, C), M = WD(m.getBoundingClientRect()), S = HD([..._, ...M]);
      s(S), u(!0);
    },
    [u]
  );
  return d.useEffect(() => () => h(), [h]), d.useEffect(() => {
    if (l && f) {
      const g = (b) => p(b, f), m = (b) => p(b, l);
      return l.addEventListener("pointerleave", g), f.addEventListener("pointerleave", m), () => {
        l.removeEventListener("pointerleave", g), f.removeEventListener("pointerleave", m);
      };
    }
  }, [l, f, p, h]), d.useEffect(() => {
    if (a) {
      const g = (m) => {
        const b = m.target, y = { x: m.clientX, y: m.clientY }, C = l?.contains(b) || f?.contains(b), _ = !VD(y, a);
        C ? h() : _ && (h(), c());
      };
      return document.addEventListener("pointermove", g), () => document.removeEventListener("pointermove", g);
    }
  }, [l, f, a, c, h]), /* @__PURE__ */ v(Zw, { ...e, ref: i });
}), [OD, ND] = ca(ur, { isInside: !1 }), DD = /* @__PURE__ */ Jv("TooltipContent"), Zw = d.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: n,
      children: r,
      "aria-label": o,
      onEscapeKeyDown: i,
      onPointerDownOutside: a,
      ...s
    } = e, l = Kr(j3, n), c = ua(n), { onClose: f } = l;
    return d.useEffect(() => (document.addEventListener(tu, f), () => document.removeEventListener(tu, f)), [f]), d.useEffect(() => {
      if (l.trigger) {
        const u = (h) => {
          h.target?.contains(l.trigger) && f();
        };
        return window.addEventListener("scroll", u, { capture: !0 }), () => window.removeEventListener("scroll", u, { capture: !0 });
      }
    }, [l.trigger, f]), /* @__PURE__ */ v(
      c3,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: i,
        onPointerDownOutside: a,
        onFocusOutside: (u) => u.preventDefault(),
        onDismiss: f,
        children: /* @__PURE__ */ s1(
          Fr,
          {
            "data-state": l.stateAttribute,
            ...c,
            ...s,
            ref: t,
            style: {
              ...s.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ v(DD, { children: r }),
              /* @__PURE__ */ v(OD, { scope: n, isInside: !0, children: /* @__PURE__ */ v(zO, { id: l.contentId, role: "tooltip", children: o || r }) })
            ]
          }
        )
      }
    );
  }
);
Yw.displayName = j3;
var Kw = "TooltipArrow", BD = d.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, o = ua(n);
    return ND(
      Kw,
      n
    ).isInside ? null : /* @__PURE__ */ v($r, { ...o, ...r, ref: t });
  }
);
BD.displayName = Kw;
function FD(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), o = Math.abs(t.right - e.x), i = Math.abs(t.left - e.x);
  switch (Math.min(n, r, o, i)) {
    case i:
      return "left";
    case o:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function $D(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push(
        { x: e.x - n, y: e.y + n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "bottom":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x + n, y: e.y - n }
      );
      break;
    case "left":
      r.push(
        { x: e.x + n, y: e.y - n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "right":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x - n, y: e.y + n }
      );
      break;
  }
  return r;
}
function WD(e) {
  const { top: t, right: n, bottom: r, left: o } = e;
  return [
    { x: o, y: t },
    { x: n, y: t },
    { x: n, y: r },
    { x: o, y: r }
  ];
}
function VD(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let i = 0, a = t.length - 1; i < t.length; a = i++) {
    const s = t[i], l = t[a], c = s.x, f = s.y, u = l.x, h = l.y;
    f > r != h > r && n < (u - c) * (r - f) / (h - f) + c && (o = !o);
  }
  return o;
}
function HD(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), jD(t);
}
function jD(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const o = e[r];
    for (; t.length >= 2; ) {
      const i = t[t.length - 1], a = t[t.length - 2];
      if ((i.x - a.x) * (o.y - a.y) >= (i.y - a.y) * (o.x - a.x)) t.pop();
      else break;
    }
    t.push(o);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const o = e[r];
    for (; n.length >= 2; ) {
      const i = n[n.length - 1], a = n[n.length - 2];
      if ((i.x - a.x) * (o.y - a.y) >= (i.y - a.y) * (o.x - a.x)) n.pop();
      else break;
    }
    n.push(o);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
var qD = qw, zD = zw, UD = Uw, GD = Gw, YD = Yw;
const A01 = qD, I01 = zD, O01 = UD, ZD = x1(({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ v(GD, { children: /* @__PURE__ */ v(
  YD,
  {
    ref: r,
    sideOffset: t,
    ...n,
    style: void 0,
    className: e1(
      "z-50 overflow-hidden rounded-md bg-card px-3 py-2 text-xs text-primary shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 dark:bg-accent",
      e
    )
  }
) }));
ZD.displayName = "LBTooltipContent";
function q2({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ v(
    "div",
    {
      className: e1("animate-pulse rounded-md bg-muted", e),
      ...t
    }
  );
}
q2.displayName = "LBSkeleton";
const V5 = Z2(
  "inline-flex h-6 flex-row items-center gap-1 rounded-sm px-2 py-1 text-xs font-normal uppercase",
  {
    variants: {
      variant: {
        default: "bg-gray-100 focus-visible:bg-gray-600 focus-visible:text-white",
        blue: "bg-blue-100 text-blue-800 focus-visible:bg-blue-600 focus-visible:text-white",
        green: "bg-green-100 text-green-800 focus-visible:bg-green-600 focus-visible:text-white"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), Xw = x1(
  ({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ v(
    "div",
    {
      className: e1(V5({ variant: t }), e),
      ...n,
      ref: r
    }
  )
);
Xw.displayName = "LBJiraStatusBadge";
var _o = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function h2(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var xo = { exports: {} }, Xs = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _f;
function KD() {
  if (_f) return Xs;
  _f = 1;
  var e = G;
  function t(u, h) {
    return u === h && (u !== 0 || 1 / u === 1 / h) || u !== u && h !== h;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, o = e.useEffect, i = e.useLayoutEffect, a = e.useDebugValue;
  function s(u, h) {
    var p = h(), g = r({ inst: { value: p, getSnapshot: h } }), m = g[0].inst, b = g[1];
    return i(
      function() {
        m.value = p, m.getSnapshot = h, l(m) && b({ inst: m });
      },
      [u, p, h]
    ), o(
      function() {
        return l(m) && b({ inst: m }), u(function() {
          l(m) && b({ inst: m });
        });
      },
      [u]
    ), a(p), p;
  }
  function l(u) {
    var h = u.getSnapshot;
    u = u.value;
    try {
      var p = h();
      return !n(u, p);
    } catch {
      return !0;
    }
  }
  function c(u, h) {
    return h();
  }
  var f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : s;
  return Xs.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : f, Xs;
}
var Qs = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xf;
function XD() {
  return xf || (xf = 1, process.env.NODE_ENV !== "production" && function() {
    function e(p, g) {
      return p === g && (p !== 0 || 1 / p === 1 / g) || p !== p && g !== g;
    }
    function t(p, g) {
      f || o.startTransition === void 0 || (f = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var m = g();
      if (!u) {
        var b = g();
        i(m, b) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), u = !0);
      }
      b = a({
        inst: { value: m, getSnapshot: g }
      });
      var y = b[0].inst, C = b[1];
      return l(
        function() {
          y.value = m, y.getSnapshot = g, n(y) && C({ inst: y });
        },
        [p, m, g]
      ), s(
        function() {
          return n(y) && C({ inst: y }), p(function() {
            n(y) && C({ inst: y });
          });
        },
        [p]
      ), c(m), m;
    }
    function n(p) {
      var g = p.getSnapshot;
      p = p.value;
      try {
        var m = g();
        return !i(p, m);
      } catch {
        return !0;
      }
    }
    function r(p, g) {
      return g();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var o = G, i = typeof Object.is == "function" ? Object.is : e, a = o.useState, s = o.useEffect, l = o.useLayoutEffect, c = o.useDebugValue, f = !1, u = !1, h = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? r : t;
    Qs.useSyncExternalStore = o.useSyncExternalStore !== void 0 ? o.useSyncExternalStore : h, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), Qs;
}
var Sf;
function QD() {
  return Sf || (Sf = 1, process.env.NODE_ENV === "production" ? xo.exports = KD() : xo.exports = XD()), xo.exports;
}
var JD = QD();
function eB() {
  return JD.useSyncExternalStore(
    tB,
    () => !0,
    () => !1
  );
}
function tB() {
  return () => {
  };
}
var H5 = "Avatar", [nB, N01] = o2(H5), [rB, Qw] = nB(H5), Jw = d.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, ...r } = e, [o, i] = d.useState("idle");
    return /* @__PURE__ */ v(
      rB,
      {
        scope: n,
        imageLoadingStatus: o,
        onImageLoadingStatusChange: i,
        children: /* @__PURE__ */ v(y1.span, { ...r, ref: t })
      }
    );
  }
);
Jw.displayName = H5;
var e_ = "AvatarImage", t_ = d.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, src: r, onLoadingStatusChange: o = () => {
    }, ...i } = e, a = Qw(e_, n), s = oB(r, i), l = u2((c) => {
      o(c), a.onImageLoadingStatusChange(c);
    });
    return r2(() => {
      s !== "idle" && l(s);
    }, [s, l]), s === "loaded" ? /* @__PURE__ */ v(y1.img, { ...i, ref: t, src: r }) : null;
  }
);
t_.displayName = e_;
var n_ = "AvatarFallback", r_ = d.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, delayMs: r, ...o } = e, i = Qw(n_, n), [a, s] = d.useState(r === void 0);
    return d.useEffect(() => {
      if (r !== void 0) {
        const l = window.setTimeout(() => s(!0), r);
        return () => window.clearTimeout(l);
      }
    }, [r]), a && i.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ v(y1.span, { ...o, ref: t }) : null;
  }
);
r_.displayName = n_;
function Mf(e, t) {
  return e ? t ? (e.src !== t && (e.src = t), e.complete && e.naturalWidth > 0 ? "loaded" : "loading") : "error" : "idle";
}
function oB(e, { referrerPolicy: t, crossOrigin: n }) {
  const r = eB(), o = d.useRef(null), i = r ? (o.current || (o.current = new window.Image()), o.current) : null, [a, s] = d.useState(
    () => Mf(i, e)
  );
  return r2(() => {
    s(Mf(i, e));
  }, [i, e]), r2(() => {
    const l = (u) => () => {
      s(u);
    };
    if (!i) return;
    const c = l("loaded"), f = l("error");
    return i.addEventListener("load", c), i.addEventListener("error", f), t && (i.referrerPolicy = t), typeof n == "string" && (i.crossOrigin = n), () => {
      i.removeEventListener("load", c), i.removeEventListener("error", f);
    };
  }, [i, n, t]), a;
}
var iB = Jw, aB = t_, sB = r_;
const o_ = x1(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  iB,
  {
    ref: n,
    className: e1(
      "relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full",
      e
    ),
    ...t
  }
));
o_.displayName = "LBAvatar";
const i_ = x1(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  aB,
  {
    ref: n,
    className: e1("aspect-square h-full w-full", e),
    ...t
  }
));
i_.displayName = "LBAvatarImage";
const a_ = x1(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  sB,
  {
    ref: n,
    className: e1(
      "flex h-full w-full items-center justify-center rounded-full bg-muted",
      e
    ),
    ...t
  }
));
a_.displayName = "LBAvatarFallback";
const lB = d.forwardRef(({ className: e, type: t, ...n }, r) => /* @__PURE__ */ v(
  "input",
  {
    type: t,
    className: e1(
      "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
      e
    ),
    ref: r,
    ...n
  }
));
lB.displayName = "LBInput";
var cB = "Label", s_ = d.forwardRef((e, t) => /* @__PURE__ */ v(
  y1.label,
  {
    ...e,
    ref: t,
    onMouseDown: (n) => {
      n.target.closest("button, input, select, textarea") || (e.onMouseDown?.(n), !n.defaultPrevented && n.detail > 1 && n.preventDefault());
    }
  }
));
s_.displayName = cB;
var uB = s_;
const dB = Z2(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
), j5 = x1(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  uB,
  {
    ref: n,
    className: e1(dB(), e),
    ...t
  }
));
j5.displayName = "LBLabel";
const fB = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  "textarea",
  {
    className: e1(
      "flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
      e
    ),
    ref: n,
    ...t
  }
));
fB.displayName = "LBTextarea";
var hB = (e) => e.type === "checkbox", pB = (e) => e instanceof Date, l_ = (e) => e == null;
const mB = (e) => typeof e == "object";
var Xr = (e) => !l_(e) && !Array.isArray(e) && mB(e) && !pB(e), gB = (e) => Xr(e) && e.target ? hB(e.target) ? e.target.checked : e.target.value : e, vB = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, bB = (e, t) => e.has(vB(t)), yB = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return Xr(t) && t.hasOwnProperty("isPrototypeOf");
}, CB = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function c_(e) {
  let t;
  const n = Array.isArray(e), r = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    t = new Date(e);
  else if (!(CB && (e instanceof Blob || r)) && (n || Xr(e)))
    if (t = n ? [] : {}, !n && !yB(e))
      t = e;
    else
      for (const o in e)
        e.hasOwnProperty(o) && (t[o] = c_(e[o]));
  else
    return e;
  return t;
}
var u_ = (e) => /^\w*$/.test(e), ru = (e) => e === void 0, wB = (e) => Array.isArray(e) ? e.filter(Boolean) : [], d_ = (e) => wB(e.replace(/["|']|\]/g, "").split(/\.|\[/)), N2 = (e, t, n) => {
  if (!t || !Xr(e))
    return n;
  const r = (u_(t) ? [t] : d_(t)).reduce((o, i) => l_(o) ? o : o[i], e);
  return ru(r) || r === e ? ru(e[t]) ? n : e[t] : r;
}, Js = (e) => typeof e == "boolean", kf = (e, t, n) => {
  let r = -1;
  const o = u_(t) ? [t] : d_(t), i = o.length, a = i - 1;
  for (; ++r < i; ) {
    const s = o[r];
    let l = n;
    if (r !== a) {
      const c = e[s];
      l = Xr(c) || Array.isArray(c) ? c : isNaN(+o[r + 1]) ? {} : [];
    }
    if (s === "__proto__" || s === "constructor" || s === "prototype")
      return;
    e[s] = l, e = e[s];
  }
};
const Lf = {
  BLUR: "blur",
  CHANGE: "change"
}, Ef = {
  all: "all"
}, q5 = G.createContext(null);
q5.displayName = "HookFormContext";
const da = () => G.useContext(q5), _B = (e) => {
  const { children: t, ...n } = e;
  return G.createElement(q5.Provider, { value: n }, t);
};
var xB = (e, t, n, r = !0) => {
  const o = {
    defaultValues: t._defaultValues
  };
  for (const i in e)
    Object.defineProperty(o, i, {
      get: () => {
        const a = i;
        return t._proxyFormState[a] !== Ef.all && (t._proxyFormState[a] = !r || Ef.all), n && (n[a] = !0), e[a];
      }
    });
  return o;
};
const f_ = typeof window < "u" ? d.useLayoutEffect : d.useEffect;
function SB(e) {
  const t = da(), { control: n = t.control, disabled: r, name: o, exact: i } = e || {}, [a, s] = G.useState(n._formState), l = G.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  });
  return f_(() => n._subscribe({
    name: o,
    formState: l.current,
    exact: i,
    callback: (c) => {
      !r && s({
        ...n._formState,
        ...c
      });
    }
  }), [o, r, i]), G.useEffect(() => {
    l.current.isValid && n._setValid(!0);
  }, [n]), G.useMemo(() => xB(a, n, l.current, !1), [a, n]);
}
var MB = (e) => typeof e == "string", kB = (e, t, n, r, o) => MB(e) ? N2(n, e, o) : Array.isArray(e) ? e.map((i) => N2(n, i)) : n;
function LB(e) {
  const t = da(), { control: n = t.control, name: r, defaultValue: o, disabled: i, exact: a } = e || {}, s = G.useRef(o), [l, c] = G.useState(n._getWatch(r, s.current));
  return f_(() => n._subscribe({
    name: r,
    formState: {
      values: !0
    },
    exact: a,
    callback: (f) => !i && c(kB(r, n._names, f.values || n._formValues, !1, s.current))
  }), [r, n, i, a]), G.useEffect(() => n._removeUnmounted()), l;
}
function EB(e) {
  const t = da(), { name: n, disabled: r, control: o = t.control, shouldUnregister: i } = e, a = bB(o._names.array, n), s = LB({
    control: o,
    name: n,
    defaultValue: N2(o._formValues, n, N2(o._defaultValues, n, e.defaultValue)),
    exact: !0
  }), l = SB({
    control: o,
    name: n,
    exact: !0
  }), c = G.useRef(e), f = G.useRef(o.register(n, {
    ...e.rules,
    value: s,
    ...Js(e.disabled) ? { disabled: e.disabled } : {}
  })), u = G.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!N2(l.errors, n)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!N2(l.dirtyFields, n)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!N2(l.touchedFields, n)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!N2(l.validatingFields, n)
    },
    error: {
      enumerable: !0,
      get: () => N2(l.errors, n)
    }
  }), [l, n]), h = G.useCallback((b) => f.current.onChange({
    target: {
      value: gB(b),
      name: n
    },
    type: Lf.CHANGE
  }), [n]), p = G.useCallback(() => f.current.onBlur({
    target: {
      value: N2(o._formValues, n),
      name: n
    },
    type: Lf.BLUR
  }), [n, o._formValues]), g = G.useCallback((b) => {
    const y = N2(o._fields, n);
    y && b && (y._f.ref = {
      focus: () => b.focus && b.focus(),
      select: () => b.select && b.select(),
      setCustomValidity: (C) => b.setCustomValidity(C),
      reportValidity: () => b.reportValidity()
    });
  }, [o._fields, n]), m = G.useMemo(() => ({
    name: n,
    value: s,
    ...Js(r) || l.disabled ? { disabled: l.disabled || r } : {},
    onChange: h,
    onBlur: p,
    ref: g
  }), [n, r, l.disabled, h, p, g, s]);
  return G.useEffect(() => {
    const b = o._options.shouldUnregister || i;
    o.register(n, {
      ...c.current.rules,
      ...Js(c.current.disabled) ? { disabled: c.current.disabled } : {}
    });
    const y = (C, _) => {
      const M = N2(o._fields, C);
      M && M._f && (M._f.mount = _);
    };
    if (y(n, !0), b) {
      const C = c_(N2(o._options.defaultValues, n));
      kf(o._defaultValues, n, C), ru(N2(o._formValues, n)) && kf(o._formValues, n, C);
    }
    return !a && o.register(n), () => {
      (a ? b && !o._state.action : b) ? o.unregister(n) : y(n, !1);
    };
  }, [n, o, a, i]), G.useEffect(() => {
    o._setDisabledField({
      disabled: r,
      name: n
    });
  }, [r, n, o]), G.useMemo(() => ({
    field: m,
    formState: l,
    fieldState: u
  }), [m, l, u]);
}
const TB = (e) => e.render(EB(e)), D01 = _B, h_ = s3(
  {}
);
function B01({ ...e }) {
  return /* @__PURE__ */ v(h_.Provider, { value: { name: e.name }, children: /* @__PURE__ */ v(TB, { ...e }) });
}
function fa() {
  const e = Rt(h_), t = Rt(p_), { getFieldState: n, formState: r } = da(), o = n(e.name, r);
  if (!e)
    throw new Error("useFormField should be used within <FormField>");
  const { id: i } = t;
  return {
    id: i,
    name: e.name,
    formItemId: `${i}-form-item`,
    formDescriptionId: `${i}-form-item-description`,
    formMessageId: `${i}-form-item-message`,
    ...o
  };
}
const p_ = s3(
  {}
), RB = x1(({ className: e, ...t }, n) => {
  const r = kE();
  return /* @__PURE__ */ v(p_.Provider, { value: { id: r }, children: /* @__PURE__ */ v("div", { ref: n, className: e1("space-y-2", e), ...t }) });
});
RB.displayName = "LBFormItem";
const PB = x1(({ className: e, ...t }, n) => {
  const { error: r, formItemId: o } = fa();
  return /* @__PURE__ */ v(
    j5,
    {
      ref: n,
      className: e1(r && "text-destructive", e),
      htmlFor: o,
      ...t
    }
  );
});
PB.displayName = "LBFormLabel";
const AB = x1(({ ...e }, t) => {
  const { error: n, formItemId: r, formDescriptionId: o, formMessageId: i } = fa();
  return /* @__PURE__ */ v(
    Ai,
    {
      ref: t,
      id: r,
      "aria-describedby": n ? `${o} ${i}` : `${o}`,
      "aria-invalid": !!n,
      ...e
    }
  );
});
AB.displayName = "LBFormControl";
const IB = x1(({ className: e, ...t }, n) => {
  const { formDescriptionId: r } = fa();
  return /* @__PURE__ */ v(
    "p",
    {
      ref: n,
      id: r,
      className: e1("text-[0.8rem] text-muted-foreground", e),
      ...t
    }
  );
});
IB.displayName = "LBFormDescription";
const OB = x1(({ className: e, children: t, ...n }, r) => {
  const { error: o, formMessageId: i } = fa(), a = o ? String(o?.message) : t;
  return a ? /* @__PURE__ */ v(
    "p",
    {
      ref: r,
      id: i,
      className: e1("text-[0.8rem] font-medium text-destructive", e),
      ...n,
      children: a
    }
  ) : null;
});
OB.displayName = "LBFormMessage";
var e4, ha = "HoverCard", [m_, F01] = o2(ha, [
  Bt
]), pa = Bt(), [NB, z5] = m_(ha), g_ = (e) => {
  const {
    __scopeHoverCard: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    openDelay: a = 700,
    closeDelay: s = 300
  } = e, l = pa(t), c = d.useRef(0), f = d.useRef(0), u = d.useRef(!1), h = d.useRef(!1), [p, g] = E2({
    prop: r,
    defaultProp: o ?? !1,
    onChange: i,
    caller: ha
  }), m = d.useCallback(() => {
    clearTimeout(f.current), c.current = window.setTimeout(() => g(!0), a);
  }, [a, g]), b = d.useCallback(() => {
    clearTimeout(c.current), !u.current && !h.current && (f.current = window.setTimeout(() => g(!1), s));
  }, [s, g]), y = d.useCallback(() => g(!1), [g]);
  return d.useEffect(() => () => {
    clearTimeout(c.current), clearTimeout(f.current);
  }, []), /* @__PURE__ */ v(
    NB,
    {
      scope: t,
      open: p,
      onOpenChange: g,
      onOpen: m,
      onClose: b,
      onDismiss: y,
      hasSelectionRef: u,
      isPointerDownOnContentRef: h,
      children: /* @__PURE__ */ v(rn, { ...l, children: n })
    }
  );
};
g_.displayName = ha;
var v_ = "HoverCardTrigger", b_ = d.forwardRef(
  (e, t) => {
    const { __scopeHoverCard: n, ...r } = e, o = z5(v_, n), i = pa(n);
    return /* @__PURE__ */ v(on, { asChild: !0, ...i, children: /* @__PURE__ */ v(
      y1.a,
      {
        "data-state": o.open ? "open" : "closed",
        ...r,
        ref: t,
        onPointerEnter: p1(e.onPointerEnter, ni(o.onOpen)),
        onPointerLeave: p1(e.onPointerLeave, ni(o.onClose)),
        onFocus: p1(e.onFocus, o.onOpen),
        onBlur: p1(e.onBlur, o.onClose),
        onTouchStart: p1(e.onTouchStart, (a) => a.preventDefault())
      }
    ) });
  }
);
b_.displayName = v_;
var DB = "HoverCardPortal", [$01, BB] = m_(DB, {
  forceMount: void 0
}), ti = "HoverCardContent", y_ = d.forwardRef(
  (e, t) => {
    const n = BB(ti, e.__scopeHoverCard), { forceMount: r = n.forceMount, ...o } = e, i = z5(ti, e.__scopeHoverCard);
    return /* @__PURE__ */ v(i2, { present: r || i.open, children: /* @__PURE__ */ v(
      FB,
      {
        "data-state": i.open ? "open" : "closed",
        ...o,
        onPointerEnter: p1(e.onPointerEnter, ni(i.onOpen)),
        onPointerLeave: p1(e.onPointerLeave, ni(i.onClose)),
        ref: t
      }
    ) });
  }
);
y_.displayName = ti;
var FB = d.forwardRef((e, t) => {
  const {
    __scopeHoverCard: n,
    onEscapeKeyDown: r,
    onPointerDownOutside: o,
    onFocusOutside: i,
    onInteractOutside: a,
    ...s
  } = e, l = z5(ti, n), c = pa(n), f = d.useRef(null), u = F1(t, f), [h, p] = d.useState(!1);
  return d.useEffect(() => {
    if (h) {
      const g = document.body;
      return e4 = g.style.userSelect || g.style.webkitUserSelect, g.style.userSelect = "none", g.style.webkitUserSelect = "none", () => {
        g.style.userSelect = e4, g.style.webkitUserSelect = e4;
      };
    }
  }, [h]), d.useEffect(() => {
    if (f.current) {
      const g = () => {
        p(!1), l.isPointerDownOnContentRef.current = !1, setTimeout(() => {
          document.getSelection()?.toString() !== "" && (l.hasSelectionRef.current = !0);
        });
      };
      return document.addEventListener("pointerup", g), () => {
        document.removeEventListener("pointerup", g), l.hasSelectionRef.current = !1, l.isPointerDownOnContentRef.current = !1;
      };
    }
  }, [l.isPointerDownOnContentRef, l.hasSelectionRef]), d.useEffect(() => {
    f.current && VB(f.current).forEach((m) => m.setAttribute("tabindex", "-1"));
  }), /* @__PURE__ */ v(
    c3,
    {
      asChild: !0,
      disableOutsidePointerEvents: !1,
      onInteractOutside: a,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: p1(i, (g) => {
        g.preventDefault();
      }),
      onDismiss: l.onDismiss,
      children: /* @__PURE__ */ v(
        Fr,
        {
          ...c,
          ...s,
          onPointerDown: p1(s.onPointerDown, (g) => {
            g.currentTarget.contains(g.target) && p(!0), l.hasSelectionRef.current = !1, l.isPointerDownOnContentRef.current = !0;
          }),
          ref: u,
          style: {
            ...s.style,
            userSelect: h ? "text" : void 0,
            // Safari requires prefix
            WebkitUserSelect: h ? "text" : void 0,
            "--radix-hover-card-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-hover-card-content-available-width": "var(--radix-popper-available-width)",
            "--radix-hover-card-content-available-height": "var(--radix-popper-available-height)",
            "--radix-hover-card-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-hover-card-trigger-height": "var(--radix-popper-anchor-height)"
          }
        }
      )
    }
  );
}), $B = "HoverCardArrow", WB = d.forwardRef(
  (e, t) => {
    const { __scopeHoverCard: n, ...r } = e, o = pa(n);
    return /* @__PURE__ */ v($r, { ...o, ...r, ref: t });
  }
);
WB.displayName = $B;
function ni(e) {
  return (t) => t.pointerType === "touch" ? void 0 : e();
}
function VB(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
var HB = g_, jB = b_, qB = y_;
const W01 = HB, V01 = jB, zB = x1(({ className: e, align: t = "center", sideOffset: n = 4, ...r }, o) => /* @__PURE__ */ v(
  qB,
  {
    ref: o,
    align: t,
    sideOffset: n,
    className: e1(
      "z-50 w-64 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...r
  }
));
zB.displayName = "LBHoverCardContent";
var U5 = "Radio", [UB, C_] = o2(U5), [GB, YB] = UB(U5), w_ = d.forwardRef(
  (e, t) => {
    const {
      __scopeRadio: n,
      name: r,
      checked: o = !1,
      required: i,
      disabled: a,
      value: s = "on",
      onCheck: l,
      form: c,
      ...f
    } = e, [u, h] = d.useState(null), p = F1(t, (b) => h(b)), g = d.useRef(!1), m = u ? c || !!u.closest("form") : !0;
    return /* @__PURE__ */ s1(GB, { scope: n, checked: o, disabled: a, children: [
      /* @__PURE__ */ v(
        y1.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": o,
          "data-state": M_(o),
          "data-disabled": a ? "" : void 0,
          disabled: a,
          value: s,
          ...f,
          ref: p,
          onClick: p1(e.onClick, (b) => {
            o || l?.(), m && (g.current = b.isPropagationStopped(), g.current || b.stopPropagation());
          })
        }
      ),
      m && /* @__PURE__ */ v(
        S_,
        {
          control: u,
          bubbles: !g.current,
          name: r,
          value: s,
          checked: o,
          required: i,
          disabled: a,
          form: c,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
w_.displayName = U5;
var __ = "RadioIndicator", x_ = d.forwardRef(
  (e, t) => {
    const { __scopeRadio: n, forceMount: r, ...o } = e, i = YB(__, n);
    return /* @__PURE__ */ v(i2, { present: r || i.checked, children: /* @__PURE__ */ v(
      y1.span,
      {
        "data-state": M_(i.checked),
        "data-disabled": i.disabled ? "" : void 0,
        ...o,
        ref: t
      }
    ) });
  }
);
x_.displayName = __;
var ZB = "RadioBubbleInput", S_ = d.forwardRef(
  ({
    __scopeRadio: e,
    control: t,
    checked: n,
    bubbles: r = !0,
    ...o
  }, i) => {
    const a = d.useRef(null), s = F1(a, i), l = Yi(n), c = $i(t);
    return d.useEffect(() => {
      const f = a.current;
      if (!f) return;
      const u = window.HTMLInputElement.prototype, p = Object.getOwnPropertyDescriptor(
        u,
        "checked"
      ).set;
      if (l !== n && p) {
        const g = new Event("click", { bubbles: r });
        p.call(f, n), f.dispatchEvent(g);
      }
    }, [l, n, r]), /* @__PURE__ */ v(
      y1.input,
      {
        type: "radio",
        "aria-hidden": !0,
        defaultChecked: n,
        ...o,
        tabIndex: -1,
        ref: s,
        style: {
          ...o.style,
          ...c,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
S_.displayName = ZB;
function M_(e) {
  return e ? "checked" : "unchecked";
}
var KB = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], ma = "RadioGroup", [XB, H01] = o2(ma, [
  en,
  C_
]), k_ = en(), L_ = C_(), [QB, JB] = XB(ma), E_ = d.forwardRef(
  (e, t) => {
    const {
      __scopeRadioGroup: n,
      name: r,
      defaultValue: o,
      value: i,
      required: a = !1,
      disabled: s = !1,
      orientation: l,
      dir: c,
      loop: f = !0,
      onValueChange: u,
      ...h
    } = e, p = k_(n), g = l3(c), [m, b] = E2({
      prop: i,
      defaultProp: o ?? null,
      onChange: u,
      caller: ma
    });
    return /* @__PURE__ */ v(
      QB,
      {
        scope: n,
        name: r,
        required: a,
        disabled: s,
        value: m,
        onValueChange: b,
        children: /* @__PURE__ */ v(
          Xu,
          {
            asChild: !0,
            ...p,
            orientation: l,
            dir: g,
            loop: f,
            children: /* @__PURE__ */ v(
              y1.div,
              {
                role: "radiogroup",
                "aria-required": a,
                "aria-orientation": l,
                "data-disabled": s ? "" : void 0,
                dir: g,
                ...h,
                ref: t
              }
            )
          }
        )
      }
    );
  }
);
E_.displayName = ma;
var T_ = "RadioGroupItem", R_ = d.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: n, disabled: r, ...o } = e, i = JB(T_, n), a = i.disabled || r, s = k_(n), l = L_(n), c = d.useRef(null), f = F1(t, c), u = i.value === o.value, h = d.useRef(!1);
    return d.useEffect(() => {
      const p = (m) => {
        KB.includes(m.key) && (h.current = !0);
      }, g = () => h.current = !1;
      return document.addEventListener("keydown", p), document.addEventListener("keyup", g), () => {
        document.removeEventListener("keydown", p), document.removeEventListener("keyup", g);
      };
    }, []), /* @__PURE__ */ v(
      Qu,
      {
        asChild: !0,
        ...s,
        focusable: !a,
        active: u,
        children: /* @__PURE__ */ v(
          w_,
          {
            disabled: a,
            required: i.required,
            checked: u,
            ...l,
            ...o,
            name: i.name,
            ref: f,
            onCheck: () => i.onValueChange(o.value),
            onKeyDown: p1((p) => {
              p.key === "Enter" && p.preventDefault();
            }),
            onFocus: p1(o.onFocus, () => {
              h.current && c.current?.click();
            })
          }
        )
      }
    );
  }
);
R_.displayName = T_;
var eF = "RadioGroupIndicator", P_ = d.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: n, ...r } = e, o = L_(n);
    return /* @__PURE__ */ v(x_, { ...o, ...r, ref: t });
  }
);
P_.displayName = eF;
var tF = E_, nF = R_, rF = P_;
const oF = x1(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  tF,
  {
    className: e1("grid gap-6", e),
    ...t,
    ref: n
  }
));
oF.displayName = "LBRadioGroup";
const iF = x1(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  nF,
  {
    ref: n,
    className: e1(
      "peer group aspect-square size-5 rounded-full border border-primary text-primary focus:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 enabled:hover:border-indigo-500",
      e
    ),
    ...t,
    children: /* @__PURE__ */ v(rF, { className: "flex items-center justify-center", children: /* @__PURE__ */ v(y5, { className: "size-4 fill-primary group-hover:fill-indigo-500 group-hover:text-indigo-500" }) })
  }
));
iF.displayName = "LBRadioGroupItem";
const A_ = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ v("div", { className: "relative w-full overflow-auto", children: /* @__PURE__ */ v(
  "table",
  {
    ref: n,
    className: e1("w-full caption-bottom text-sm", e),
    ...t
  }
) }));
A_.displayName = "LBTable";
const I_ = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ v("thead", { ref: n, className: e1("[&_tr]:border-b", e), ...t }));
I_.displayName = "LBTableHeader";
const ou = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  "tbody",
  {
    ref: n,
    className: e1("[&_tr:last-child]:border-0", e),
    ...t
  }
));
ou.displayName = "LBTableBody";
const aF = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  "tfoot",
  {
    ref: n,
    className: e1(
      "border-t bg-muted/50 font-medium [&>tr]:last:border-b-0",
      e
    ),
    ...t
  }
));
aF.displayName = "LBTableFooter";
const zn = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  "tr",
  {
    ref: n,
    className: e1(
      "border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted",
      e
    ),
    ...t
  }
));
zn.displayName = "LBTableRow";
const O_ = d.forwardRef(({ className: e, width: t, ...n }, r) => {
  const o = typeof t < "u", i = o ? { "--lb-header-width": `${t}px` } : void 0;
  return /* @__PURE__ */ v(
    "th",
    {
      style: i,
      ref: r,
      className: e1(
        "h-10 px-2 text-left align-middle font-medium text-muted-foreground [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]",
        { "max-w-[var(--lb-header-width)]": o },
        e
      ),
      ...n
    }
  );
});
O_.displayName = "LBTableHead";
const jo = d.forwardRef(({ className: e, width: t, ...n }, r) => {
  const o = typeof t < "u", i = o ? { "--lb-cell-width": `${t}px` } : void 0;
  return /* @__PURE__ */ v(
    "td",
    {
      style: i,
      ref: r,
      className: e1(
        "p-2 align-middle [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]",
        { "max-w-[var(--lb-cell-width)]": o },
        e
      ),
      ...n
    }
  );
});
jo.displayName = "LBTableCell";
const sF = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  "caption",
  {
    ref: n,
    className: e1("mt-4 text-sm text-muted-foreground", e),
    ...t
  }
));
sF.displayName = "LBTableCaption";
function lF({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ v(
    "nav",
    {
      role: "navigation",
      "aria-label": "pagination",
      className: e1("mx-auto flex w-full justify-center", e),
      ...t
    }
  );
}
lF.displayName = "LBPagination";
const cF = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  "ul",
  {
    ref: n,
    className: e1("flex flex-row items-center gap-1", e),
    ...t
  }
));
cF.displayName = "LBPaginationContent";
const uF = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ v("li", { ref: n, className: e1("", e), ...t }));
uF.displayName = "LBPaginationItem";
function G5({
  className: e,
  isActive: t,
  size: n = "icon",
  ...r
}) {
  return /* @__PURE__ */ v(
    dt,
    {
      "aria-current": t ? "page" : void 0,
      variant: t ? "outline" : "ghost",
      size: n,
      className: e,
      ...r
    }
  );
}
G5.displayName = "LBPaginationLink";
function dF({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ s1(
    G5,
    {
      "aria-label": "Go to previous page",
      size: "default",
      className: e1("gap-1 pl-3", e),
      ...t,
      children: [
        /* @__PURE__ */ v(qi, { className: "size-4" }),
        /* @__PURE__ */ v("span", { children: "Previous" })
      ]
    }
  );
}
dF.displayName = "LBPaginationPrevious";
function fF({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ s1(
    G5,
    {
      "aria-label": "Go to next page",
      size: "default",
      className: e1("gap-1 pr-3", e),
      ...t,
      children: [
        /* @__PURE__ */ v("span", { children: "Next" }),
        /* @__PURE__ */ v(qr, { className: "size-4" })
      ]
    }
  );
}
fF.displayName = "LBPaginationNext";
function hF({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ s1(
    "span",
    {
      "aria-hidden": !0,
      className: e1("flex h-9 w-9 items-center justify-center", e),
      ...t,
      children: [
        /* @__PURE__ */ v(Ky, { className: "size-4 rotate-90" }),
        /* @__PURE__ */ v("span", { className: "sr-only", children: "More pages" })
      ]
    }
  );
}
hF.displayName = "LBPaginationEllipsis";
const pF = ia;
pF.displayName = "LBSheet";
const mF = A5;
mF.displayName = "LBSheetTrigger";
const j01 = Yr, gF = aa, N_ = x1(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  Gr,
  {
    className: e1(
      "fixed inset-0 z-50 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t,
    ref: n
  }
));
N_.displayName = Gr.displayName;
const vF = Z2(
  "fixed z-50 gap-4 bg-background p-6 shadow-lg transition ease-in-out data-[state=closed]:duration-300 data-[state=open]:duration-500 data-[state=open]:animate-in data-[state=closed]:animate-out",
  {
    variants: {
      side: {
        top: "inset-x-0 top-0 border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
        bottom: "inset-x-0 bottom-0 border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
        left: "inset-y-0 left-0 h-full w-3/4 border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm",
        right: "inset-y-0 right-0 h-full w-3/4 border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm"
      }
    },
    defaultVariants: {
      side: "right"
    }
  }
), bF = x1(({ side: e = "right", className: t, children: n, ...r }, o) => /* @__PURE__ */ s1(gF, { children: [
  /* @__PURE__ */ v(N_, {}),
  /* @__PURE__ */ s1(
    un,
    {
      ref: o,
      className: e1(vF({ side: e }), t),
      ...r,
      children: [
        /* @__PURE__ */ s1(Yr, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-secondary", children: [
          /* @__PURE__ */ v(ln, { className: "size-4" }),
          /* @__PURE__ */ v("span", { className: "sr-only", children: "Close" })
        ] }),
        n
      ]
    }
  )
] }));
bF.displayName = un.displayName;
function yF({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ v(
    "div",
    {
      className: e1(
        "flex flex-col space-y-2 text-center sm:text-left",
        e
      ),
      ...t
    }
  );
}
yF.displayName = "LBSheetHeader";
const CF = x1(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  sa,
  {
    ref: n,
    className: e1("text-lg font-semibold text-foreground", e),
    ...t
  }
));
CF.displayName = "LBSheetTitle";
const wF = x1(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  I5,
  {
    ref: n,
    className: e1("text-sm text-muted-foreground", e),
    ...t
  }
));
wF.displayName = "LBSheetDescription";
function _F(e) {
  if (typeof document > "u") return;
  let t = document.head || document.getElementsByTagName("head")[0], n = document.createElement("style");
  n.type = "text/css", t.appendChild(n), n.styleSheet ? n.styleSheet.cssText = e : n.appendChild(document.createTextNode(e));
}
const xF = (e) => {
  switch (e) {
    case "success":
      return kF;
    case "info":
      return EF;
    case "warning":
      return LF;
    case "error":
      return TF;
    default:
      return null;
  }
}, SF = Array(12).fill(0), MF = ({ visible: e, className: t }) => /* @__PURE__ */ G.createElement("div", {
  className: [
    "sonner-loading-wrapper",
    t
  ].filter(Boolean).join(" "),
  "data-visible": e
}, /* @__PURE__ */ G.createElement("div", {
  className: "sonner-spinner"
}, SF.map((n, r) => /* @__PURE__ */ G.createElement("div", {
  className: "sonner-loading-bar",
  key: `spinner-bar-${r}`
})))), kF = /* @__PURE__ */ G.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ G.createElement("path", {
  fillRule: "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z",
  clipRule: "evenodd"
})), LF = /* @__PURE__ */ G.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ G.createElement("path", {
  fillRule: "evenodd",
  d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z",
  clipRule: "evenodd"
})), EF = /* @__PURE__ */ G.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ G.createElement("path", {
  fillRule: "evenodd",
  d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z",
  clipRule: "evenodd"
})), TF = /* @__PURE__ */ G.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ G.createElement("path", {
  fillRule: "evenodd",
  d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z",
  clipRule: "evenodd"
})), RF = /* @__PURE__ */ G.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /* @__PURE__ */ G.createElement("line", {
  x1: "18",
  y1: "6",
  x2: "6",
  y2: "18"
}), /* @__PURE__ */ G.createElement("line", {
  x1: "6",
  y1: "6",
  x2: "18",
  y2: "18"
})), PF = () => {
  const [e, t] = G.useState(document.hidden);
  return G.useEffect(() => {
    const n = () => {
      t(document.hidden);
    };
    return document.addEventListener("visibilitychange", n), () => window.removeEventListener("visibilitychange", n);
  }, []), e;
};
let iu = 1;
class AF {
  constructor() {
    this.subscribe = (t) => (this.subscribers.push(t), () => {
      const n = this.subscribers.indexOf(t);
      this.subscribers.splice(n, 1);
    }), this.publish = (t) => {
      this.subscribers.forEach((n) => n(t));
    }, this.addToast = (t) => {
      this.publish(t), this.toasts = [
        ...this.toasts,
        t
      ];
    }, this.create = (t) => {
      var n;
      const { message: r, ...o } = t, i = typeof t?.id == "number" || ((n = t.id) == null ? void 0 : n.length) > 0 ? t.id : iu++, a = this.toasts.find((l) => l.id === i), s = t.dismissible === void 0 ? !0 : t.dismissible;
      return this.dismissedToasts.has(i) && this.dismissedToasts.delete(i), a ? this.toasts = this.toasts.map((l) => l.id === i ? (this.publish({
        ...l,
        ...t,
        id: i,
        title: r
      }), {
        ...l,
        ...t,
        id: i,
        dismissible: s,
        title: r
      }) : l) : this.addToast({
        title: r,
        ...o,
        dismissible: s,
        id: i
      }), i;
    }, this.dismiss = (t) => (t ? (this.dismissedToasts.add(t), requestAnimationFrame(() => this.subscribers.forEach((n) => n({
      id: t,
      dismiss: !0
    })))) : this.toasts.forEach((n) => {
      this.subscribers.forEach((r) => r({
        id: n.id,
        dismiss: !0
      }));
    }), t), this.message = (t, n) => this.create({
      ...n,
      message: t
    }), this.error = (t, n) => this.create({
      ...n,
      message: t,
      type: "error"
    }), this.success = (t, n) => this.create({
      ...n,
      type: "success",
      message: t
    }), this.info = (t, n) => this.create({
      ...n,
      type: "info",
      message: t
    }), this.warning = (t, n) => this.create({
      ...n,
      type: "warning",
      message: t
    }), this.loading = (t, n) => this.create({
      ...n,
      type: "loading",
      message: t
    }), this.promise = (t, n) => {
      if (!n)
        return;
      let r;
      n.loading !== void 0 && (r = this.create({
        ...n,
        promise: t,
        type: "loading",
        message: n.loading,
        description: typeof n.description != "function" ? n.description : void 0
      }));
      const o = Promise.resolve(t instanceof Function ? t() : t);
      let i = r !== void 0, a;
      const s = o.then(async (c) => {
        if (a = [
          "resolve",
          c
        ], G.isValidElement(c))
          i = !1, this.create({
            id: r,
            type: "default",
            message: c
          });
        else if (OF(c) && !c.ok) {
          i = !1;
          const u = typeof n.error == "function" ? await n.error(`HTTP error! status: ${c.status}`) : n.error, h = typeof n.description == "function" ? await n.description(`HTTP error! status: ${c.status}`) : n.description, g = typeof u == "object" && !G.isValidElement(u) ? u : {
            message: u
          };
          this.create({
            id: r,
            type: "error",
            description: h,
            ...g
          });
        } else if (c instanceof Error) {
          i = !1;
          const u = typeof n.error == "function" ? await n.error(c) : n.error, h = typeof n.description == "function" ? await n.description(c) : n.description, g = typeof u == "object" && !G.isValidElement(u) ? u : {
            message: u
          };
          this.create({
            id: r,
            type: "error",
            description: h,
            ...g
          });
        } else if (n.success !== void 0) {
          i = !1;
          const u = typeof n.success == "function" ? await n.success(c) : n.success, h = typeof n.description == "function" ? await n.description(c) : n.description, g = typeof u == "object" && !G.isValidElement(u) ? u : {
            message: u
          };
          this.create({
            id: r,
            type: "success",
            description: h,
            ...g
          });
        }
      }).catch(async (c) => {
        if (a = [
          "reject",
          c
        ], n.error !== void 0) {
          i = !1;
          const f = typeof n.error == "function" ? await n.error(c) : n.error, u = typeof n.description == "function" ? await n.description(c) : n.description, p = typeof f == "object" && !G.isValidElement(f) ? f : {
            message: f
          };
          this.create({
            id: r,
            type: "error",
            description: u,
            ...p
          });
        }
      }).finally(() => {
        i && (this.dismiss(r), r = void 0), n.finally == null || n.finally.call(n);
      }), l = () => new Promise((c, f) => s.then(() => a[0] === "reject" ? f(a[1]) : c(a[1])).catch(f));
      return typeof r != "string" && typeof r != "number" ? {
        unwrap: l
      } : Object.assign(r, {
        unwrap: l
      });
    }, this.custom = (t, n) => {
      const r = n?.id || iu++;
      return this.create({
        jsx: t(r),
        id: r,
        ...n
      }), r;
    }, this.getActiveToasts = () => this.toasts.filter((t) => !this.dismissedToasts.has(t.id)), this.subscribers = [], this.toasts = [], this.dismissedToasts = /* @__PURE__ */ new Set();
  }
}
const D2 = new AF(), IF = (e, t) => {
  const n = t?.id || iu++;
  return D2.addToast({
    title: e,
    ...t,
    id: n
  }), n;
}, OF = (e) => e && typeof e == "object" && "ok" in e && typeof e.ok == "boolean" && "status" in e && typeof e.status == "number", NF = IF, DF = () => D2.toasts, BF = () => D2.getActiveToasts(), au = Object.assign(NF, {
  success: D2.success,
  info: D2.info,
  warning: D2.warning,
  error: D2.error,
  custom: D2.custom,
  message: D2.message,
  promise: D2.promise,
  dismiss: D2.dismiss,
  loading: D2.loading
}, {
  getHistory: DF,
  getToasts: BF
});
_F("[data-sonner-toaster][dir=ltr],html[dir=ltr]{--toast-icon-margin-start:-3px;--toast-icon-margin-end:4px;--toast-svg-margin-start:-1px;--toast-svg-margin-end:0px;--toast-button-margin-start:auto;--toast-button-margin-end:0;--toast-close-button-start:0;--toast-close-button-end:unset;--toast-close-button-transform:translate(-35%, -35%)}[data-sonner-toaster][dir=rtl],html[dir=rtl]{--toast-icon-margin-start:4px;--toast-icon-margin-end:-3px;--toast-svg-margin-start:0px;--toast-svg-margin-end:-1px;--toast-button-margin-start:0;--toast-button-margin-end:auto;--toast-close-button-start:unset;--toast-close-button-end:0;--toast-close-button-transform:translate(35%, -35%)}[data-sonner-toaster]{position:fixed;width:var(--width);font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;--gray1:hsl(0, 0%, 99%);--gray2:hsl(0, 0%, 97.3%);--gray3:hsl(0, 0%, 95.1%);--gray4:hsl(0, 0%, 93%);--gray5:hsl(0, 0%, 90.9%);--gray6:hsl(0, 0%, 88.7%);--gray7:hsl(0, 0%, 85.8%);--gray8:hsl(0, 0%, 78%);--gray9:hsl(0, 0%, 56.1%);--gray10:hsl(0, 0%, 52.3%);--gray11:hsl(0, 0%, 43.5%);--gray12:hsl(0, 0%, 9%);--border-radius:8px;box-sizing:border-box;padding:0;margin:0;list-style:none;outline:0;z-index:999999999;transition:transform .4s ease}@media (hover:none) and (pointer:coarse){[data-sonner-toaster][data-lifted=true]{transform:none}}[data-sonner-toaster][data-x-position=right]{right:var(--offset-right)}[data-sonner-toaster][data-x-position=left]{left:var(--offset-left)}[data-sonner-toaster][data-x-position=center]{left:50%;transform:translateX(-50%)}[data-sonner-toaster][data-y-position=top]{top:var(--offset-top)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--offset-bottom)}[data-sonner-toast]{--y:translateY(100%);--lift-amount:calc(var(--lift) * var(--gap));z-index:var(--z-index);position:absolute;opacity:0;transform:var(--y);touch-action:none;transition:transform .4s,opacity .4s,height .4s,box-shadow .2s;box-sizing:border-box;outline:0;overflow-wrap:anywhere}[data-sonner-toast][data-styled=true]{padding:16px;background:var(--normal-bg);border:1px solid var(--normal-border);color:var(--normal-text);border-radius:var(--border-radius);box-shadow:0 4px 12px rgba(0,0,0,.1);width:var(--width);font-size:13px;display:flex;align-items:center;gap:6px}[data-sonner-toast]:focus-visible{box-shadow:0 4px 12px rgba(0,0,0,.1),0 0 0 2px rgba(0,0,0,.2)}[data-sonner-toast][data-y-position=top]{top:0;--y:translateY(-100%);--lift:1;--lift-amount:calc(1 * var(--gap))}[data-sonner-toast][data-y-position=bottom]{bottom:0;--y:translateY(100%);--lift:-1;--lift-amount:calc(var(--lift) * var(--gap))}[data-sonner-toast][data-styled=true] [data-description]{font-weight:400;line-height:1.4;color:#3f3f3f}[data-rich-colors=true][data-sonner-toast][data-styled=true] [data-description]{color:inherit}[data-sonner-toaster][data-sonner-theme=dark] [data-description]{color:#e8e8e8}[data-sonner-toast][data-styled=true] [data-title]{font-weight:500;line-height:1.5;color:inherit}[data-sonner-toast][data-styled=true] [data-icon]{display:flex;height:16px;width:16px;position:relative;justify-content:flex-start;align-items:center;flex-shrink:0;margin-left:var(--toast-icon-margin-start);margin-right:var(--toast-icon-margin-end)}[data-sonner-toast][data-promise=true] [data-icon]>svg{opacity:0;transform:scale(.8);transform-origin:center;animation:sonner-fade-in .3s ease forwards}[data-sonner-toast][data-styled=true] [data-icon]>*{flex-shrink:0}[data-sonner-toast][data-styled=true] [data-icon] svg{margin-left:var(--toast-svg-margin-start);margin-right:var(--toast-svg-margin-end)}[data-sonner-toast][data-styled=true] [data-content]{display:flex;flex-direction:column;gap:2px}[data-sonner-toast][data-styled=true] [data-button]{border-radius:4px;padding-left:8px;padding-right:8px;height:24px;font-size:12px;color:var(--normal-bg);background:var(--normal-text);margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end);border:none;font-weight:500;cursor:pointer;outline:0;display:flex;align-items:center;flex-shrink:0;transition:opacity .4s,box-shadow .2s}[data-sonner-toast][data-styled=true] [data-button]:focus-visible{box-shadow:0 0 0 2px rgba(0,0,0,.4)}[data-sonner-toast][data-styled=true] [data-button]:first-of-type{margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end)}[data-sonner-toast][data-styled=true] [data-cancel]{color:var(--normal-text);background:rgba(0,0,0,.08)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast][data-styled=true] [data-cancel]{background:rgba(255,255,255,.3)}[data-sonner-toast][data-styled=true] [data-close-button]{position:absolute;left:var(--toast-close-button-start);right:var(--toast-close-button-end);top:0;height:20px;width:20px;display:flex;justify-content:center;align-items:center;padding:0;color:var(--gray12);background:var(--normal-bg);border:1px solid var(--gray4);transform:var(--toast-close-button-transform);border-radius:50%;cursor:pointer;z-index:1;transition:opacity .1s,background .2s,border-color .2s}[data-sonner-toast][data-styled=true] [data-close-button]:focus-visible{box-shadow:0 4px 12px rgba(0,0,0,.1),0 0 0 2px rgba(0,0,0,.2)}[data-sonner-toast][data-styled=true] [data-disabled=true]{cursor:not-allowed}[data-sonner-toast][data-styled=true]:hover [data-close-button]:hover{background:var(--gray2);border-color:var(--gray5)}[data-sonner-toast][data-swiping=true]::before{content:'';position:absolute;left:-100%;right:-100%;height:100%;z-index:-1}[data-sonner-toast][data-y-position=top][data-swiping=true]::before{bottom:50%;transform:scaleY(3) translateY(50%)}[data-sonner-toast][data-y-position=bottom][data-swiping=true]::before{top:50%;transform:scaleY(3) translateY(-50%)}[data-sonner-toast][data-swiping=false][data-removed=true]::before{content:'';position:absolute;inset:0;transform:scaleY(2)}[data-sonner-toast][data-expanded=true]::after{content:'';position:absolute;left:0;height:calc(var(--gap) + 1px);bottom:100%;width:100%}[data-sonner-toast][data-mounted=true]{--y:translateY(0);opacity:1}[data-sonner-toast][data-expanded=false][data-front=false]{--scale:var(--toasts-before) * 0.05 + 1;--y:translateY(calc(var(--lift-amount) * var(--toasts-before))) scale(calc(-1 * var(--scale)));height:var(--front-toast-height)}[data-sonner-toast]>*{transition:opacity .4s}[data-sonner-toast][data-x-position=right]{right:0}[data-sonner-toast][data-x-position=left]{left:0}[data-sonner-toast][data-expanded=false][data-front=false][data-styled=true]>*{opacity:0}[data-sonner-toast][data-visible=false]{opacity:0;pointer-events:none}[data-sonner-toast][data-mounted=true][data-expanded=true]{--y:translateY(calc(var(--lift) * var(--offset)));height:var(--initial-height)}[data-sonner-toast][data-removed=true][data-front=true][data-swipe-out=false]{--y:translateY(calc(var(--lift) * -100%));opacity:0}[data-sonner-toast][data-removed=true][data-front=false][data-swipe-out=false][data-expanded=true]{--y:translateY(calc(var(--lift) * var(--offset) + var(--lift) * -100%));opacity:0}[data-sonner-toast][data-removed=true][data-front=false][data-swipe-out=false][data-expanded=false]{--y:translateY(40%);opacity:0;transition:transform .5s,opacity .2s}[data-sonner-toast][data-removed=true][data-front=false]::before{height:calc(var(--initial-height) + 20%)}[data-sonner-toast][data-swiping=true]{transform:var(--y) translateY(var(--swipe-amount-y,0)) translateX(var(--swipe-amount-x,0));transition:none}[data-sonner-toast][data-swiped=true]{user-select:none}[data-sonner-toast][data-swipe-out=true][data-y-position=bottom],[data-sonner-toast][data-swipe-out=true][data-y-position=top]{animation-duration:.2s;animation-timing-function:ease-out;animation-fill-mode:forwards}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=left]{animation-name:swipe-out-left}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=right]{animation-name:swipe-out-right}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=up]{animation-name:swipe-out-up}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=down]{animation-name:swipe-out-down}@keyframes swipe-out-left{from{transform:var(--y) translateX(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translateX(calc(var(--swipe-amount-x) - 100%));opacity:0}}@keyframes swipe-out-right{from{transform:var(--y) translateX(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translateX(calc(var(--swipe-amount-x) + 100%));opacity:0}}@keyframes swipe-out-up{from{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) - 100%));opacity:0}}@keyframes swipe-out-down{from{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) + 100%));opacity:0}}@media (max-width:600px){[data-sonner-toaster]{position:fixed;right:var(--mobile-offset-right);left:var(--mobile-offset-left);width:100%}[data-sonner-toaster][dir=rtl]{left:calc(var(--mobile-offset-left) * -1)}[data-sonner-toaster] [data-sonner-toast]{left:0;right:0;width:calc(100% - var(--mobile-offset-left) * 2)}[data-sonner-toaster][data-x-position=left]{left:var(--mobile-offset-left)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--mobile-offset-bottom)}[data-sonner-toaster][data-y-position=top]{top:var(--mobile-offset-top)}[data-sonner-toaster][data-x-position=center]{left:var(--mobile-offset-left);right:var(--mobile-offset-right);transform:none}}[data-sonner-toaster][data-sonner-theme=light]{--normal-bg:#fff;--normal-border:var(--gray4);--normal-text:var(--gray12);--success-bg:hsl(143, 85%, 96%);--success-border:hsl(145, 92%, 87%);--success-text:hsl(140, 100%, 27%);--info-bg:hsl(208, 100%, 97%);--info-border:hsl(221, 91%, 93%);--info-text:hsl(210, 92%, 45%);--warning-bg:hsl(49, 100%, 97%);--warning-border:hsl(49, 91%, 84%);--warning-text:hsl(31, 92%, 45%);--error-bg:hsl(359, 100%, 97%);--error-border:hsl(359, 100%, 94%);--error-text:hsl(360, 100%, 45%)}[data-sonner-toaster][data-sonner-theme=light] [data-sonner-toast][data-invert=true]{--normal-bg:#000;--normal-border:hsl(0, 0%, 20%);--normal-text:var(--gray1)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast][data-invert=true]{--normal-bg:#fff;--normal-border:var(--gray3);--normal-text:var(--gray12)}[data-sonner-toaster][data-sonner-theme=dark]{--normal-bg:#000;--normal-bg-hover:hsl(0, 0%, 12%);--normal-border:hsl(0, 0%, 20%);--normal-border-hover:hsl(0, 0%, 25%);--normal-text:var(--gray1);--success-bg:hsl(150, 100%, 6%);--success-border:hsl(147, 100%, 12%);--success-text:hsl(150, 86%, 65%);--info-bg:hsl(215, 100%, 6%);--info-border:hsl(223, 43%, 17%);--info-text:hsl(216, 87%, 65%);--warning-bg:hsl(64, 100%, 6%);--warning-border:hsl(60, 100%, 9%);--warning-text:hsl(46, 87%, 65%);--error-bg:hsl(358, 76%, 10%);--error-border:hsl(357, 89%, 16%);--error-text:hsl(358, 100%, 81%)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast] [data-close-button]{background:var(--normal-bg);border-color:var(--normal-border);color:var(--normal-text)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast] [data-close-button]:hover{background:var(--normal-bg-hover);border-color:var(--normal-border-hover)}[data-rich-colors=true][data-sonner-toast][data-type=success]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=success] [data-close-button]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=info]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=info] [data-close-button]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning] [data-close-button]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=error]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}[data-rich-colors=true][data-sonner-toast][data-type=error] [data-close-button]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}.sonner-loading-wrapper{--size:16px;height:var(--size);width:var(--size);position:absolute;inset:0;z-index:10}.sonner-loading-wrapper[data-visible=false]{transform-origin:center;animation:sonner-fade-out .2s ease forwards}.sonner-spinner{position:relative;top:50%;left:50%;height:var(--size);width:var(--size)}.sonner-loading-bar{animation:sonner-spin 1.2s linear infinite;background:var(--gray11);border-radius:6px;height:8%;left:-10%;position:absolute;top:-3.9%;width:24%}.sonner-loading-bar:first-child{animation-delay:-1.2s;transform:rotate(.0001deg) translate(146%)}.sonner-loading-bar:nth-child(2){animation-delay:-1.1s;transform:rotate(30deg) translate(146%)}.sonner-loading-bar:nth-child(3){animation-delay:-1s;transform:rotate(60deg) translate(146%)}.sonner-loading-bar:nth-child(4){animation-delay:-.9s;transform:rotate(90deg) translate(146%)}.sonner-loading-bar:nth-child(5){animation-delay:-.8s;transform:rotate(120deg) translate(146%)}.sonner-loading-bar:nth-child(6){animation-delay:-.7s;transform:rotate(150deg) translate(146%)}.sonner-loading-bar:nth-child(7){animation-delay:-.6s;transform:rotate(180deg) translate(146%)}.sonner-loading-bar:nth-child(8){animation-delay:-.5s;transform:rotate(210deg) translate(146%)}.sonner-loading-bar:nth-child(9){animation-delay:-.4s;transform:rotate(240deg) translate(146%)}.sonner-loading-bar:nth-child(10){animation-delay:-.3s;transform:rotate(270deg) translate(146%)}.sonner-loading-bar:nth-child(11){animation-delay:-.2s;transform:rotate(300deg) translate(146%)}.sonner-loading-bar:nth-child(12){animation-delay:-.1s;transform:rotate(330deg) translate(146%)}@keyframes sonner-fade-in{0%{opacity:0;transform:scale(.8)}100%{opacity:1;transform:scale(1)}}@keyframes sonner-fade-out{0%{opacity:1;transform:scale(1)}100%{opacity:0;transform:scale(.8)}}@keyframes sonner-spin{0%{opacity:1}100%{opacity:.15}}@media (prefers-reduced-motion){.sonner-loading-bar,[data-sonner-toast],[data-sonner-toast]>*{transition:none!important;animation:none!important}}.sonner-loader{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);transform-origin:center;transition:opacity .2s,transform .2s}.sonner-loader[data-visible=false]{opacity:0;transform:scale(.8) translate(-50%,-50%)}");
function So(e) {
  return e.label !== void 0;
}
const FF = 3, $F = "24px", WF = "16px", Tf = 4e3, VF = 356, HF = 14, jF = 45, qF = 200;
function wt(...e) {
  return e.filter(Boolean).join(" ");
}
function zF(e) {
  const [t, n] = e.split("-"), r = [];
  return t && r.push(t), n && r.push(n), r;
}
const UF = (e) => {
  var t, n, r, o, i, a, s, l, c;
  const { invert: f, toast: u, unstyled: h, interacting: p, setHeights: g, visibleToasts: m, heights: b, index: y, toasts: C, expanded: _, removeToast: M, defaultRichColors: S, closeButton: k, style: L, cancelButtonStyle: P, actionButtonStyle: I, className: O = "", descriptionClassName: E = "", duration: B, position: W, gap: F, expandByDefault: z, classNames: D, icons: Z, closeButtonAriaLabel: U = "Close toast" } = e, [$, q] = G.useState(null), [K, V] = G.useState(null), [n1, o1] = G.useState(!1), [r1, X] = G.useState(!1), [Y, Q] = G.useState(!1), [N, j] = G.useState(!1), [t1, T] = G.useState(!1), [u1, l1] = G.useState(0), [d1, C1] = G.useState(0), g1 = G.useRef(u.duration || B || Tf), D1 = G.useRef(null), re = G.useRef(null), q1 = y === 0, w1 = y + 1 <= m, $1 = u.type, I1 = u.dismissible !== !1, me = u.className || "", Se = u.descriptionClassName || "", fe = G.useMemo(() => b.findIndex((m1) => m1.toastId === u.id) || 0, [
    b,
    u.id
  ]), Re = G.useMemo(() => {
    var m1;
    return (m1 = u.closeButton) != null ? m1 : k;
  }, [
    u.closeButton,
    k
  ]), se = G.useMemo(() => u.duration || B || Tf, [
    u.duration,
    B
  ]), le = G.useRef(0), G1 = G.useRef(0), ge = G.useRef(0), ce = G.useRef(null), [he, ve] = W.split("-"), pe = G.useMemo(() => b.reduce((m1, M1, k1) => k1 >= fe ? m1 : m1 + M1.height, 0), [
    b,
    fe
  ]), Ce = PF(), Xe = u.invert || f, f1 = $1 === "loading";
  G1.current = G.useMemo(() => fe * F + pe, [
    fe,
    pe
  ]), G.useEffect(() => {
    g1.current = se;
  }, [
    se
  ]), G.useEffect(() => {
    o1(!0);
  }, []), G.useEffect(() => {
    const m1 = re.current;
    if (m1) {
      const M1 = m1.getBoundingClientRect().height;
      return C1(M1), g((k1) => [
        {
          toastId: u.id,
          height: M1,
          position: u.position
        },
        ...k1
      ]), () => g((k1) => k1.filter((ue) => ue.toastId !== u.id));
    }
  }, [
    g,
    u.id
  ]), G.useLayoutEffect(() => {
    if (!n1) return;
    const m1 = re.current, M1 = m1.style.height;
    m1.style.height = "auto";
    const k1 = m1.getBoundingClientRect().height;
    m1.style.height = M1, C1(k1), g((ue) => ue.find((ie) => ie.toastId === u.id) ? ue.map((ie) => ie.toastId === u.id ? {
      ...ie,
      height: k1
    } : ie) : [
      {
        toastId: u.id,
        height: k1,
        position: u.position
      },
      ...ue
    ]);
  }, [
    n1,
    u.title,
    u.description,
    g,
    u.id,
    u.jsx,
    u.action,
    u.cancel
  ]);
  const b1 = G.useCallback(() => {
    X(!0), l1(G1.current), g((m1) => m1.filter((M1) => M1.toastId !== u.id)), setTimeout(() => {
      M(u);
    }, qF);
  }, [
    u,
    M,
    g,
    G1
  ]);
  G.useEffect(() => {
    if (u.promise && $1 === "loading" || u.duration === 1 / 0 || u.type === "loading") return;
    let m1;
    return _ || p || Ce ? (() => {
      if (ge.current < le.current) {
        const ue = (/* @__PURE__ */ new Date()).getTime() - le.current;
        g1.current = g1.current - ue;
      }
      ge.current = (/* @__PURE__ */ new Date()).getTime();
    })() : (() => {
      g1.current !== 1 / 0 && (le.current = (/* @__PURE__ */ new Date()).getTime(), m1 = setTimeout(() => {
        u.onAutoClose == null || u.onAutoClose.call(u, u), b1();
      }, g1.current));
    })(), () => clearTimeout(m1);
  }, [
    _,
    p,
    u,
    $1,
    Ce,
    b1
  ]), G.useEffect(() => {
    u.delete && (b1(), u.onDismiss == null || u.onDismiss.call(u, u));
  }, [
    b1,
    u.delete
  ]);
  function S1() {
    var m1;
    if (Z?.loading) {
      var M1;
      return /* @__PURE__ */ G.createElement("div", {
        className: wt(D?.loader, u == null || (M1 = u.classNames) == null ? void 0 : M1.loader, "sonner-loader"),
        "data-visible": $1 === "loading"
      }, Z.loading);
    }
    return /* @__PURE__ */ G.createElement(MF, {
      className: wt(D?.loader, u == null || (m1 = u.classNames) == null ? void 0 : m1.loader),
      visible: $1 === "loading"
    });
  }
  const J1 = u.icon || Z?.[$1] || xF($1);
  var ee, X1;
  return /* @__PURE__ */ G.createElement("li", {
    tabIndex: 0,
    ref: re,
    className: wt(O, me, D?.toast, u == null || (t = u.classNames) == null ? void 0 : t.toast, D?.default, D?.[$1], u == null || (n = u.classNames) == null ? void 0 : n[$1]),
    "data-sonner-toast": "",
    "data-rich-colors": (ee = u.richColors) != null ? ee : S,
    "data-styled": !(u.jsx || u.unstyled || h),
    "data-mounted": n1,
    "data-promise": !!u.promise,
    "data-swiped": t1,
    "data-removed": r1,
    "data-visible": w1,
    "data-y-position": he,
    "data-x-position": ve,
    "data-index": y,
    "data-front": q1,
    "data-swiping": Y,
    "data-dismissible": I1,
    "data-type": $1,
    "data-invert": Xe,
    "data-swipe-out": N,
    "data-swipe-direction": K,
    "data-expanded": !!(_ || z && n1),
    style: {
      "--index": y,
      "--toasts-before": y,
      "--z-index": C.length - y,
      "--offset": `${r1 ? u1 : G1.current}px`,
      "--initial-height": z ? "auto" : `${d1}px`,
      ...L,
      ...u.style
    },
    onDragEnd: () => {
      Q(!1), q(null), ce.current = null;
    },
    onPointerDown: (m1) => {
      m1.button !== 2 && (f1 || !I1 || (D1.current = /* @__PURE__ */ new Date(), l1(G1.current), m1.target.setPointerCapture(m1.pointerId), m1.target.tagName !== "BUTTON" && (Q(!0), ce.current = {
        x: m1.clientX,
        y: m1.clientY
      })));
    },
    onPointerUp: () => {
      var m1, M1, k1;
      if (N || !I1) return;
      ce.current = null;
      const ue = Number(((m1 = re.current) == null ? void 0 : m1.style.getPropertyValue("--swipe-amount-x").replace("px", "")) || 0), oe = Number(((M1 = re.current) == null ? void 0 : M1.style.getPropertyValue("--swipe-amount-y").replace("px", "")) || 0), ie = (/* @__PURE__ */ new Date()).getTime() - ((k1 = D1.current) == null ? void 0 : k1.getTime()), Me = $ === "x" ? ue : oe, $e = Math.abs(Me) / ie;
      if (Math.abs(Me) >= jF || $e > 0.11) {
        l1(G1.current), u.onDismiss == null || u.onDismiss.call(u, u), V($ === "x" ? ue > 0 ? "right" : "left" : oe > 0 ? "down" : "up"), b1(), j(!0);
        return;
      } else {
        var v1, E1;
        (v1 = re.current) == null || v1.style.setProperty("--swipe-amount-x", "0px"), (E1 = re.current) == null || E1.style.setProperty("--swipe-amount-y", "0px");
      }
      T(!1), Q(!1), q(null);
    },
    onPointerMove: (m1) => {
      var M1, k1, ue;
      if (!ce.current || !I1 || ((M1 = window.getSelection()) == null ? void 0 : M1.toString().length) > 0) return;
      const ie = m1.clientY - ce.current.y, Me = m1.clientX - ce.current.x;
      var $e;
      const v1 = ($e = e.swipeDirections) != null ? $e : zF(W);
      !$ && (Math.abs(Me) > 1 || Math.abs(ie) > 1) && q(Math.abs(Me) > Math.abs(ie) ? "x" : "y");
      let E1 = {
        x: 0,
        y: 0
      };
      const U1 = (te) => 1 / (1.5 + Math.abs(te) / 20);
      if ($ === "y") {
        if (v1.includes("top") || v1.includes("bottom"))
          if (v1.includes("top") && ie < 0 || v1.includes("bottom") && ie > 0)
            E1.y = ie;
          else {
            const te = ie * U1(ie);
            E1.y = Math.abs(te) < Math.abs(ie) ? te : ie;
          }
      } else if ($ === "x" && (v1.includes("left") || v1.includes("right")))
        if (v1.includes("left") && Me < 0 || v1.includes("right") && Me > 0)
          E1.x = Me;
        else {
          const te = Me * U1(Me);
          E1.x = Math.abs(te) < Math.abs(Me) ? te : Me;
        }
      (Math.abs(E1.x) > 0 || Math.abs(E1.y) > 0) && T(!0), (k1 = re.current) == null || k1.style.setProperty("--swipe-amount-x", `${E1.x}px`), (ue = re.current) == null || ue.style.setProperty("--swipe-amount-y", `${E1.y}px`);
    }
  }, Re && !u.jsx && $1 !== "loading" ? /* @__PURE__ */ G.createElement("button", {
    "aria-label": U,
    "data-disabled": f1,
    "data-close-button": !0,
    onClick: f1 || !I1 ? () => {
    } : () => {
      b1(), u.onDismiss == null || u.onDismiss.call(u, u);
    },
    className: wt(D?.closeButton, u == null || (r = u.classNames) == null ? void 0 : r.closeButton)
  }, (X1 = Z?.close) != null ? X1 : RF) : null, ($1 || u.icon || u.promise) && u.icon !== null && (Z?.[$1] !== null || u.icon) ? /* @__PURE__ */ G.createElement("div", {
    "data-icon": "",
    className: wt(D?.icon, u == null || (o = u.classNames) == null ? void 0 : o.icon)
  }, u.promise || u.type === "loading" && !u.icon ? u.icon || S1() : null, u.type !== "loading" ? J1 : null) : null, /* @__PURE__ */ G.createElement("div", {
    "data-content": "",
    className: wt(D?.content, u == null || (i = u.classNames) == null ? void 0 : i.content)
  }, /* @__PURE__ */ G.createElement("div", {
    "data-title": "",
    className: wt(D?.title, u == null || (a = u.classNames) == null ? void 0 : a.title)
  }, u.jsx ? u.jsx : typeof u.title == "function" ? u.title() : u.title), u.description ? /* @__PURE__ */ G.createElement("div", {
    "data-description": "",
    className: wt(E, Se, D?.description, u == null || (s = u.classNames) == null ? void 0 : s.description)
  }, typeof u.description == "function" ? u.description() : u.description) : null), /* @__PURE__ */ G.isValidElement(u.cancel) ? u.cancel : u.cancel && So(u.cancel) ? /* @__PURE__ */ G.createElement("button", {
    "data-button": !0,
    "data-cancel": !0,
    style: u.cancelButtonStyle || P,
    onClick: (m1) => {
      So(u.cancel) && I1 && (u.cancel.onClick == null || u.cancel.onClick.call(u.cancel, m1), b1());
    },
    className: wt(D?.cancelButton, u == null || (l = u.classNames) == null ? void 0 : l.cancelButton)
  }, u.cancel.label) : null, /* @__PURE__ */ G.isValidElement(u.action) ? u.action : u.action && So(u.action) ? /* @__PURE__ */ G.createElement("button", {
    "data-button": !0,
    "data-action": !0,
    style: u.actionButtonStyle || I,
    onClick: (m1) => {
      So(u.action) && (u.action.onClick == null || u.action.onClick.call(u.action, m1), !m1.defaultPrevented && b1());
    },
    className: wt(D?.actionButton, u == null || (c = u.classNames) == null ? void 0 : c.actionButton)
  }, u.action.label) : null);
};
function Rf() {
  if (typeof window > "u" || typeof document > "u") return "ltr";
  const e = document.documentElement.getAttribute("dir");
  return e === "auto" || !e ? window.getComputedStyle(document.documentElement).direction : e;
}
function GF(e, t) {
  const n = {};
  return [
    e,
    t
  ].forEach((r, o) => {
    const i = o === 1, a = i ? "--mobile-offset" : "--offset", s = i ? WF : $F;
    function l(c) {
      [
        "top",
        "right",
        "bottom",
        "left"
      ].forEach((f) => {
        n[`${a}-${f}`] = typeof c == "number" ? `${c}px` : c;
      });
    }
    typeof r == "number" || typeof r == "string" ? l(r) : typeof r == "object" ? [
      "top",
      "right",
      "bottom",
      "left"
    ].forEach((c) => {
      r[c] === void 0 ? n[`${a}-${c}`] = s : n[`${a}-${c}`] = typeof r[c] == "number" ? `${r[c]}px` : r[c];
    }) : l(s);
  }), n;
}
const YF = /* @__PURE__ */ G.forwardRef(function(t, n) {
  const { invert: r, position: o = "bottom-right", hotkey: i = [
    "altKey",
    "KeyT"
  ], expand: a, closeButton: s, className: l, offset: c, mobileOffset: f, theme: u = "light", richColors: h, duration: p, style: g, visibleToasts: m = FF, toastOptions: b, dir: y = Rf(), gap: C = HF, icons: _, containerAriaLabel: M = "Notifications" } = t, [S, k] = G.useState([]), L = G.useMemo(() => Array.from(new Set([
    o
  ].concat(S.filter((K) => K.position).map((K) => K.position)))), [
    S,
    o
  ]), [P, I] = G.useState([]), [O, E] = G.useState(!1), [B, W] = G.useState(!1), [F, z] = G.useState(u !== "system" ? u : typeof window < "u" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"), D = G.useRef(null), Z = i.join("+").replace(/Key/g, "").replace(/Digit/g, ""), U = G.useRef(null), $ = G.useRef(!1), q = G.useCallback((K) => {
    k((V) => {
      var n1;
      return (n1 = V.find((o1) => o1.id === K.id)) != null && n1.delete || D2.dismiss(K.id), V.filter(({ id: o1 }) => o1 !== K.id);
    });
  }, []);
  return G.useEffect(() => D2.subscribe((K) => {
    if (K.dismiss) {
      requestAnimationFrame(() => {
        k((V) => V.map((n1) => n1.id === K.id ? {
          ...n1,
          delete: !0
        } : n1));
      });
      return;
    }
    setTimeout(() => {
      Xv.flushSync(() => {
        k((V) => {
          const n1 = V.findIndex((o1) => o1.id === K.id);
          return n1 !== -1 ? [
            ...V.slice(0, n1),
            {
              ...V[n1],
              ...K
            },
            ...V.slice(n1 + 1)
          ] : [
            K,
            ...V
          ];
        });
      });
    });
  }), [
    S
  ]), G.useEffect(() => {
    if (u !== "system") {
      z(u);
      return;
    }
    if (u === "system" && (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? z("dark") : z("light")), typeof window > "u") return;
    const K = window.matchMedia("(prefers-color-scheme: dark)");
    try {
      K.addEventListener("change", ({ matches: V }) => {
        z(V ? "dark" : "light");
      });
    } catch {
      K.addListener(({ matches: n1 }) => {
        try {
          z(n1 ? "dark" : "light");
        } catch (o1) {
          console.error(o1);
        }
      });
    }
  }, [
    u
  ]), G.useEffect(() => {
    S.length <= 1 && E(!1);
  }, [
    S
  ]), G.useEffect(() => {
    const K = (V) => {
      var n1;
      if (i.every((X) => V[X] || V.code === X)) {
        var r1;
        E(!0), (r1 = D.current) == null || r1.focus();
      }
      V.code === "Escape" && (document.activeElement === D.current || (n1 = D.current) != null && n1.contains(document.activeElement)) && E(!1);
    };
    return document.addEventListener("keydown", K), () => document.removeEventListener("keydown", K);
  }, [
    i
  ]), G.useEffect(() => {
    if (D.current)
      return () => {
        U.current && (U.current.focus({
          preventScroll: !0
        }), U.current = null, $.current = !1);
      };
  }, [
    D.current
  ]), // Remove item from normal navigation flow, only available via hotkey
  /* @__PURE__ */ G.createElement("section", {
    ref: n,
    "aria-label": `${M} ${Z}`,
    tabIndex: -1,
    "aria-live": "polite",
    "aria-relevant": "additions text",
    "aria-atomic": "false",
    suppressHydrationWarning: !0
  }, L.map((K, V) => {
    var n1;
    const [o1, r1] = K.split("-");
    return S.length ? /* @__PURE__ */ G.createElement("ol", {
      key: K,
      dir: y === "auto" ? Rf() : y,
      tabIndex: -1,
      ref: D,
      className: l,
      "data-sonner-toaster": !0,
      "data-sonner-theme": F,
      "data-y-position": o1,
      "data-x-position": r1,
      style: {
        "--front-toast-height": `${((n1 = P[0]) == null ? void 0 : n1.height) || 0}px`,
        "--width": `${VF}px`,
        "--gap": `${C}px`,
        ...g,
        ...GF(c, f)
      },
      onBlur: (X) => {
        $.current && !X.currentTarget.contains(X.relatedTarget) && ($.current = !1, U.current && (U.current.focus({
          preventScroll: !0
        }), U.current = null));
      },
      onFocus: (X) => {
        X.target instanceof HTMLElement && X.target.dataset.dismissible === "false" || $.current || ($.current = !0, U.current = X.relatedTarget);
      },
      onMouseEnter: () => E(!0),
      onMouseMove: () => E(!0),
      onMouseLeave: () => {
        B || E(!1);
      },
      onDragEnd: () => E(!1),
      onPointerDown: (X) => {
        X.target instanceof HTMLElement && X.target.dataset.dismissible === "false" || W(!0);
      },
      onPointerUp: () => W(!1)
    }, S.filter((X) => !X.position && V === 0 || X.position === K).map((X, Y) => {
      var Q, N;
      return /* @__PURE__ */ G.createElement(UF, {
        key: X.id,
        icons: _,
        index: Y,
        toast: X,
        defaultRichColors: h,
        duration: (Q = b?.duration) != null ? Q : p,
        className: b?.className,
        descriptionClassName: b?.descriptionClassName,
        invert: r,
        visibleToasts: m,
        closeButton: (N = b?.closeButton) != null ? N : s,
        interacting: B,
        position: K,
        style: b?.style,
        unstyled: b?.unstyled,
        classNames: b?.classNames,
        cancelButtonStyle: b?.cancelButtonStyle,
        actionButtonStyle: b?.actionButtonStyle,
        closeButtonAriaLabel: b?.closeButtonAriaLabel,
        removeToast: q,
        toasts: S.filter((j) => j.position == X.position),
        heights: P.filter((j) => j.position == X.position),
        setHeights: I,
        expandByDefault: a,
        gap: C,
        expanded: O,
        swipeDirections: t.swipeDirections
      });
    })) : null;
  }));
}), ZF = YF;
ZF.displayName = "LBToaster";
const KF = Z2(
  "flex min-w-[388px] items-center gap-2 rounded-md border p-4 pr-6 shadow-lg",
  {
    variants: {
      variant: {
        default: "bg-card",
        destructive: "bg-destructive text-destructive-foreground",
        success: "bg-success text-success-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), XF = Z2(
  "flex h-9 items-center justify-center whitespace-nowrap rounded-full border px-4 py-2 text-sm",
  {
    variants: {
      variant: {
        default: "hover:divide-indigo-500 hover:border-indigo-500 hover:text-indigo-500",
        destructive: "border-destructive-foreground text-destructive-foreground hover:bg-destructive/10",
        success: "border-success-foreground text-success-foreground hover:bg-success/10"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), QF = Z2("rounded-md p-1", {
  variants: {
    variant: {
      default: "opacity-50 hover:opacity-100",
      destructive: "text-red-300 opacity-50 hover:opacity-100",
      success: "text-green-300 opacity-50 hover:opacity-100"
    }
  },
  defaultVariants: {
    variant: "default"
  }
});
function JF(e) {
  const {
    title: t,
    description: n,
    button: r,
    id: o,
    variant: i,
    closeButton: a
  } = e;
  return /* @__PURE__ */ s1("div", { className: e1(KF({ variant: i }), "relative"), children: [
    /* @__PURE__ */ s1("div", { className: "flex w-full flex-row items-center", children: [
      /* @__PURE__ */ s1("div", { className: "flex w-full flex-col items-start", children: [
        /* @__PURE__ */ v("h3", { className: "text-sm font-semibold leading-5", children: t }),
        /* @__PURE__ */ v("p", { className: "text-sm leading-5", children: n })
      ] }),
      r && /* @__PURE__ */ v("div", { className: "flex w-fit items-center justify-end", children: /* @__PURE__ */ v(
        "button",
        {
          className: XF({
            variant: i
          }),
          onClick: () => {
            r?.onClick?.(), au.dismiss(o);
          },
          children: r.label
        }
      ) })
    ] }),
    a && /* @__PURE__ */ s1(
      "button",
      {
        className: e1(
          QF({ variant: i }),
          "absolute top-1 right-1"
        ),
        onClick: () => au.dismiss(o),
        children: [
          /* @__PURE__ */ v(ln, { className: "size-4" }),
          /* @__PURE__ */ v("span", { className: "sr-only", children: "Close" })
        ]
      }
    )
  ] });
}
function q01(e, t) {
  return au.custom((n) => /* @__PURE__ */ v(JF, { id: n, ...e }), t);
}
function e$(...e) {
  return { getAll: () => e, get: (t) => e.find((n) => n.id === t), getIndex: (t) => e.findIndex((n) => n.id === t), getByIndex: (t) => e[t], getFirst: () => e[0], getLast: () => e[e.length - 1], getNext: (t) => e[e.findIndex((n) => n.id === t) + 1], getPrev: (t) => e[e.findIndex((n) => n.id === t) - 1], getNeighbors(t) {
    const n = e.findIndex((r) => r.id === t);
    return { prev: n > 0 ? e[n - 1] : null, next: n < e.length - 1 ? e[n + 1] : null };
  } };
}
function Pf(e, t) {
  return Math.max(e.findIndex((n) => n.id === t), 0);
}
function Af(e, t) {
  return e.reduce((n, r) => (n[r.id] = t?.[r.id] ?? null, n), {});
}
function t$(e, t, n) {
  return { switch(r) {
    const o = r[t.id];
    return o?.(t);
  }, when(r, o, i) {
    const a = e[n];
    return (Array.isArray(r) ? a.id === r[0] && r.slice(1).every(Boolean) : a.id === r) ? o?.(a) : i?.(a);
  }, match(r, o) {
    const i = e.find((s) => s.id === r);
    if (!i) return null;
    const a = o[r];
    return a?.(i) ?? null;
  } };
}
async function If(e, t) {
  const n = await e();
  return !t || n === !0;
}
var w3 = async ({ stepper: e, direction: t, callback: n, before: r, targetId: o }) => {
  (!r || await If(n, !0)) && (t === "next" ? e.next() : t === "prev" ? e.prev() : t === "goTo" && o && e.goTo(o), r || await If(n, !1));
}, Mo = (e, t, n) => {
  t < 0 && Of({ steps: e, newIndex: t, direction: "next", reason: "it is the first step" }), t >= e.length && Of({ steps: e, newIndex: t, direction: "prev", reason: "it is the last step" }), n(t);
}, Of = ({ steps: e, newIndex: t, direction: n, reason: r }) => {
  throw new Error(`Cannot navigate ${n} from step "${e[t].id}": ${r}`);
}, z01 = (...e) => {
  const t = d.createContext(null), n = e$(...e), r = (o) => {
    const { initialStep: i, initialMetadata: a } = o ?? {}, s = d.useMemo(() => Pf(e, i), [i]), [l, c] = d.useState(s), [f, u] = d.useState(() => Af(e, a)), h = d.useMemo(() => {
      const p = e[l], g = l === e.length - 1;
      return { all: e, current: p, isLast: g, isFirst: l === 0, metadata: f, setMetadata(m, b) {
        u((y) => y[m] === b ? y : { ...y, [m]: b });
      }, getMetadata: (m) => f[m], resetMetadata(m) {
        u(Af(e, m ? a : void 0));
      }, next() {
        Mo(e, l + 1, (m) => {
          c(m);
        });
      }, prev() {
        Mo(e, l - 1, (m) => {
          c(m);
        });
      }, get: (m) => e.find((b) => b.id === m), goTo(m) {
        const b = e.findIndex((y) => y.id === m);
        if (b === -1) throw new Error(`Step with id "${m}" not found.`);
        Mo(e, b, (y) => {
          c(y);
        });
      }, reset() {
        Mo(e, Pf(e, i), (m) => {
          c(m);
        });
      }, async beforeNext(m) {
        await w3({ stepper: h, direction: "next", callback: m, before: !0 });
      }, async afterNext(m) {
        this.next(), await w3({ stepper: h, direction: "next", callback: m, before: !1 });
      }, async beforePrev(m) {
        await w3({ stepper: h, direction: "prev", callback: m, before: !0 });
      }, async afterPrev(m) {
        this.prev(), await w3({ stepper: h, direction: "prev", callback: m, before: !1 });
      }, async beforeGoTo(m, b) {
        await w3({ stepper: h, direction: "goTo", callback: b, before: !0, targetId: m });
      }, async afterGoTo(m, b) {
        this.goTo(m), await w3({ stepper: h, direction: "goTo", callback: b, before: !1, targetId: m });
      }, ...t$(e, p, l) };
    }, [l, f]);
    return h;
  };
  return { steps: e, utils: n, Scoped: ({ initialStep: o, initialMetadata: i, children: a }) => d.createElement(t.Provider, { value: r({ initialStep: o, initialMetadata: i }) }, a), useStepper: (o = {}) => d.useContext(t) ?? r(o) };
};
const n$ = Z2(
  "peer flex size-9 items-center justify-center gap-2 rounded-full p-2 focus-visible:ring-1 disabled:cursor-not-allowed disabled:border disabled:border-slate-200 disabled:text-slate-800 disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "cursor-default border border-slate-200 bg-white text-slate-700",
        complete: "bg-slate-700 text-white shadow hover:bg-indigo-500"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), r$ = x1(
  ({ className: e, variant: t, title: n, ...r }, o) => /* @__PURE__ */ s1("div", { className: "flex shrink-0 flex-row items-center gap-5", ref: o, children: [
    /* @__PURE__ */ v(
      "button",
      {
        ...r,
        type: "button",
        className: e1(n$({ variant: t }), e),
        style: void 0
      }
    ),
    /* @__PURE__ */ v("span", { className: "text-base peer-disabled:text-slate-800 peer-disabled:opacity-40", children: n })
  ] })
);
r$.displayName = "LBStep";
const o$ = x1(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ v(
  "nav",
  {
    "aria-label": "Checkout Steps",
    className: e1("my-4 flex flex-col", e),
    ref: r,
    ...n,
    children: t
  }
));
o$.displayName = "LBStepper";
function U01() {
  return /* @__PURE__ */ v("div", { className: "ml-[17.5px] h-20 w-[1px] divide-dotted border border-dashed border-slate-500" });
}
var ga = "Collapsible", [i$, D_] = o2(ga), [a$, Y5] = i$(ga), B_ = d.forwardRef(
  (e, t) => {
    const {
      __scopeCollapsible: n,
      open: r,
      defaultOpen: o,
      disabled: i,
      onOpenChange: a,
      ...s
    } = e, [l, c] = E2({
      prop: r,
      defaultProp: o ?? !1,
      onChange: a,
      caller: ga
    });
    return /* @__PURE__ */ v(
      a$,
      {
        scope: n,
        disabled: i,
        contentId: t2(),
        open: l,
        onOpenToggle: d.useCallback(() => c((f) => !f), [c]),
        children: /* @__PURE__ */ v(
          y1.div,
          {
            "data-state": Q5(l),
            "data-disabled": i ? "" : void 0,
            ...s,
            ref: t
          }
        )
      }
    );
  }
);
B_.displayName = ga;
var F_ = "CollapsibleTrigger", Z5 = d.forwardRef(
  (e, t) => {
    const { __scopeCollapsible: n, ...r } = e, o = Y5(F_, n);
    return /* @__PURE__ */ v(
      y1.button,
      {
        type: "button",
        "aria-controls": o.contentId,
        "aria-expanded": o.open || !1,
        "data-state": Q5(o.open),
        "data-disabled": o.disabled ? "" : void 0,
        disabled: o.disabled,
        ...r,
        ref: t,
        onClick: p1(e.onClick, o.onOpenToggle)
      }
    );
  }
);
Z5.displayName = F_;
var K5 = "CollapsibleContent", X5 = d.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, o = Y5(K5, e.__scopeCollapsible);
    return /* @__PURE__ */ v(i2, { present: n || o.open, children: ({ present: i }) => /* @__PURE__ */ v(s$, { ...r, ref: t, present: i }) });
  }
);
X5.displayName = K5;
var s$ = d.forwardRef((e, t) => {
  const { __scopeCollapsible: n, present: r, children: o, ...i } = e, a = Y5(K5, n), [s, l] = d.useState(r), c = d.useRef(null), f = F1(t, c), u = d.useRef(0), h = u.current, p = d.useRef(0), g = p.current, m = a.open || s, b = d.useRef(m), y = d.useRef(void 0);
  return d.useEffect(() => {
    const C = requestAnimationFrame(() => b.current = !1);
    return () => cancelAnimationFrame(C);
  }, []), r2(() => {
    const C = c.current;
    if (C) {
      y.current = y.current || {
        transitionDuration: C.style.transitionDuration,
        animationName: C.style.animationName
      }, C.style.transitionDuration = "0s", C.style.animationName = "none";
      const _ = C.getBoundingClientRect();
      u.current = _.height, p.current = _.width, b.current || (C.style.transitionDuration = y.current.transitionDuration, C.style.animationName = y.current.animationName), l(r);
    }
  }, [a.open, r]), /* @__PURE__ */ v(
    y1.div,
    {
      "data-state": Q5(a.open),
      "data-disabled": a.disabled ? "" : void 0,
      id: a.contentId,
      hidden: !m,
      ...i,
      ref: f,
      style: {
        "--radix-collapsible-content-height": h ? `${h}px` : void 0,
        "--radix-collapsible-content-width": g ? `${g}px` : void 0,
        ...e.style
      },
      children: m && o
    }
  );
});
function Q5(e) {
  return e ? "open" : "closed";
}
var $_ = B_, l$ = Z5, c$ = X5, yt = "Accordion", u$ = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [J5, d$, f$] = Ii(yt), [va, G01] = o2(yt, [
  f$,
  D_
]), ed = D_(), W_ = G.forwardRef(
  (e, t) => {
    const { type: n, ...r } = e, o = r, i = r;
    return /* @__PURE__ */ v(J5.Provider, { scope: e.__scopeAccordion, children: n === "multiple" ? /* @__PURE__ */ v(g$, { ...i, ref: t }) : /* @__PURE__ */ v(m$, { ...o, ref: t }) });
  }
);
W_.displayName = yt;
var [V_, h$] = va(yt), [H_, p$] = va(
  yt,
  { collapsible: !1 }
), m$ = G.forwardRef(
  (e, t) => {
    const {
      value: n,
      defaultValue: r,
      onValueChange: o = () => {
      },
      collapsible: i = !1,
      ...a
    } = e, [s, l] = E2({
      prop: n,
      defaultProp: r ?? "",
      onChange: o,
      caller: yt
    });
    return /* @__PURE__ */ v(
      V_,
      {
        scope: e.__scopeAccordion,
        value: G.useMemo(() => s ? [s] : [], [s]),
        onItemOpen: l,
        onItemClose: G.useCallback(() => i && l(""), [i, l]),
        children: /* @__PURE__ */ v(H_, { scope: e.__scopeAccordion, collapsible: i, children: /* @__PURE__ */ v(j_, { ...a, ref: t }) })
      }
    );
  }
), g$ = G.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: r,
    onValueChange: o = () => {
    },
    ...i
  } = e, [a, s] = E2({
    prop: n,
    defaultProp: r ?? [],
    onChange: o,
    caller: yt
  }), l = G.useCallback(
    (f) => s((u = []) => [...u, f]),
    [s]
  ), c = G.useCallback(
    (f) => s((u = []) => u.filter((h) => h !== f)),
    [s]
  );
  return /* @__PURE__ */ v(
    V_,
    {
      scope: e.__scopeAccordion,
      value: a,
      onItemOpen: l,
      onItemClose: c,
      children: /* @__PURE__ */ v(H_, { scope: e.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ v(j_, { ...i, ref: t }) })
    }
  );
}), [v$, ba] = va(yt), j_ = G.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, disabled: r, dir: o, orientation: i = "vertical", ...a } = e, s = G.useRef(null), l = F1(s, t), c = d$(n), u = l3(o) === "ltr", h = p1(e.onKeyDown, (p) => {
      if (!u$.includes(p.key)) return;
      const g = p.target, m = c().filter((P) => !P.ref.current?.disabled), b = m.findIndex((P) => P.ref.current === g), y = m.length;
      if (b === -1) return;
      p.preventDefault();
      let C = b;
      const _ = 0, M = y - 1, S = () => {
        C = b + 1, C > M && (C = _);
      }, k = () => {
        C = b - 1, C < _ && (C = M);
      };
      switch (p.key) {
        case "Home":
          C = _;
          break;
        case "End":
          C = M;
          break;
        case "ArrowRight":
          i === "horizontal" && (u ? S() : k());
          break;
        case "ArrowDown":
          i === "vertical" && S();
          break;
        case "ArrowLeft":
          i === "horizontal" && (u ? k() : S());
          break;
        case "ArrowUp":
          i === "vertical" && k();
          break;
      }
      const L = C % y;
      m[L].ref.current?.focus();
    });
    return /* @__PURE__ */ v(
      v$,
      {
        scope: n,
        disabled: r,
        direction: o,
        orientation: i,
        children: /* @__PURE__ */ v(J5.Slot, { scope: n, children: /* @__PURE__ */ v(
          y1.div,
          {
            ...a,
            "data-orientation": i,
            ref: l,
            onKeyDown: r ? void 0 : h
          }
        ) })
      }
    );
  }
), ri = "AccordionItem", [b$, td] = va(ri), q_ = G.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, value: r, ...o } = e, i = ba(ri, n), a = h$(ri, n), s = ed(n), l = t2(), c = r && a.value.includes(r) || !1, f = i.disabled || e.disabled;
    return /* @__PURE__ */ v(
      b$,
      {
        scope: n,
        open: c,
        disabled: f,
        triggerId: l,
        children: /* @__PURE__ */ v(
          $_,
          {
            "data-orientation": i.orientation,
            "data-state": K_(c),
            ...s,
            ...o,
            ref: t,
            disabled: f,
            open: c,
            onOpenChange: (u) => {
              u ? a.onItemOpen(r) : a.onItemClose(r);
            }
          }
        )
      }
    );
  }
);
q_.displayName = ri;
var z_ = "AccordionHeader", U_ = G.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, o = ba(yt, n), i = td(z_, n);
    return /* @__PURE__ */ v(
      y1.h3,
      {
        "data-orientation": o.orientation,
        "data-state": K_(i.open),
        "data-disabled": i.disabled ? "" : void 0,
        ...r,
        ref: t
      }
    );
  }
);
U_.displayName = z_;
var su = "AccordionTrigger", G_ = G.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, o = ba(yt, n), i = td(su, n), a = p$(su, n), s = ed(n);
    return /* @__PURE__ */ v(J5.ItemSlot, { scope: n, children: /* @__PURE__ */ v(
      l$,
      {
        "aria-disabled": i.open && !a.collapsible || void 0,
        "data-orientation": o.orientation,
        id: i.triggerId,
        ...s,
        ...r,
        ref: t
      }
    ) });
  }
);
G_.displayName = su;
var Y_ = "AccordionContent", Z_ = G.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, o = ba(yt, n), i = td(Y_, n), a = ed(n);
    return /* @__PURE__ */ v(
      c$,
      {
        role: "region",
        "aria-labelledby": i.triggerId,
        "data-orientation": o.orientation,
        ...a,
        ...r,
        ref: t,
        style: {
          "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
          "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
          ...e.style
        }
      }
    );
  }
);
Z_.displayName = Y_;
function K_(e) {
  return e ? "open" : "closed";
}
var y$ = W_, C$ = q_, w$ = U_, _$ = G_, x$ = Z_;
const S$ = y$;
S$.displayName = "LBAccordion";
const M$ = x1(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  C$,
  {
    ref: n,
    className: e1("border-b", e),
    ...t
  }
));
M$.displayName = "LBAccordionItem";
const k$ = x1(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ v(w$, { className: "flex", children: /* @__PURE__ */ s1(
  _$,
  {
    ref: r,
    className: e1(
      "flex flex-1 items-center justify-between py-4 text-sm font-medium transition-all hover:underline text-left [&[data-state=open]>svg]:rotate-180",
      e
    ),
    ...n,
    children: [
      t,
      /* @__PURE__ */ v(sn, { className: "size-4 shrink-0 text-muted-foreground transition-transform duration-200" })
    ]
  }
) }));
k$.displayName = "LBAccordionTrigger";
const L$ = x1(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ v(
  x$,
  {
    ref: r,
    className: "overflow-hidden text-sm data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down",
    ...n,
    children: /* @__PURE__ */ v("div", { className: e1("pb-4 pt-0", e), children: t })
  }
));
L$.displayName = "LBAccordionContent";
var ko = { exports: {} }, Lo = { exports: {} }, Ae = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Nf;
function E$() {
  if (Nf) return Ae;
  Nf = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, u = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, b = e ? Symbol.for("react.fundamental") : 60117, y = e ? Symbol.for("react.responder") : 60118, C = e ? Symbol.for("react.scope") : 60119;
  function _(S) {
    if (typeof S == "object" && S !== null) {
      var k = S.$$typeof;
      switch (k) {
        case t:
          switch (S = S.type, S) {
            case l:
            case c:
            case r:
            case i:
            case o:
            case u:
              return S;
            default:
              switch (S = S && S.$$typeof, S) {
                case s:
                case f:
                case g:
                case p:
                case a:
                  return S;
                default:
                  return k;
              }
          }
        case n:
          return k;
      }
    }
  }
  function M(S) {
    return _(S) === c;
  }
  return Ae.AsyncMode = l, Ae.ConcurrentMode = c, Ae.ContextConsumer = s, Ae.ContextProvider = a, Ae.Element = t, Ae.ForwardRef = f, Ae.Fragment = r, Ae.Lazy = g, Ae.Memo = p, Ae.Portal = n, Ae.Profiler = i, Ae.StrictMode = o, Ae.Suspense = u, Ae.isAsyncMode = function(S) {
    return M(S) || _(S) === l;
  }, Ae.isConcurrentMode = M, Ae.isContextConsumer = function(S) {
    return _(S) === s;
  }, Ae.isContextProvider = function(S) {
    return _(S) === a;
  }, Ae.isElement = function(S) {
    return typeof S == "object" && S !== null && S.$$typeof === t;
  }, Ae.isForwardRef = function(S) {
    return _(S) === f;
  }, Ae.isFragment = function(S) {
    return _(S) === r;
  }, Ae.isLazy = function(S) {
    return _(S) === g;
  }, Ae.isMemo = function(S) {
    return _(S) === p;
  }, Ae.isPortal = function(S) {
    return _(S) === n;
  }, Ae.isProfiler = function(S) {
    return _(S) === i;
  }, Ae.isStrictMode = function(S) {
    return _(S) === o;
  }, Ae.isSuspense = function(S) {
    return _(S) === u;
  }, Ae.isValidElementType = function(S) {
    return typeof S == "string" || typeof S == "function" || S === r || S === c || S === i || S === o || S === u || S === h || typeof S == "object" && S !== null && (S.$$typeof === g || S.$$typeof === p || S.$$typeof === a || S.$$typeof === s || S.$$typeof === f || S.$$typeof === b || S.$$typeof === y || S.$$typeof === C || S.$$typeof === m);
  }, Ae.typeOf = _, Ae;
}
var Ie = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Df;
function T$() {
  return Df || (Df = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, u = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, b = e ? Symbol.for("react.fundamental") : 60117, y = e ? Symbol.for("react.responder") : 60118, C = e ? Symbol.for("react.scope") : 60119;
    function _(T) {
      return typeof T == "string" || typeof T == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      T === r || T === c || T === i || T === o || T === u || T === h || typeof T == "object" && T !== null && (T.$$typeof === g || T.$$typeof === p || T.$$typeof === a || T.$$typeof === s || T.$$typeof === f || T.$$typeof === b || T.$$typeof === y || T.$$typeof === C || T.$$typeof === m);
    }
    function M(T) {
      if (typeof T == "object" && T !== null) {
        var u1 = T.$$typeof;
        switch (u1) {
          case t:
            var l1 = T.type;
            switch (l1) {
              case l:
              case c:
              case r:
              case i:
              case o:
              case u:
                return l1;
              default:
                var d1 = l1 && l1.$$typeof;
                switch (d1) {
                  case s:
                  case f:
                  case g:
                  case p:
                  case a:
                    return d1;
                  default:
                    return u1;
                }
            }
          case n:
            return u1;
        }
      }
    }
    var S = l, k = c, L = s, P = a, I = t, O = f, E = r, B = g, W = p, F = n, z = i, D = o, Z = u, U = !1;
    function $(T) {
      return U || (U = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), q(T) || M(T) === l;
    }
    function q(T) {
      return M(T) === c;
    }
    function K(T) {
      return M(T) === s;
    }
    function V(T) {
      return M(T) === a;
    }
    function n1(T) {
      return typeof T == "object" && T !== null && T.$$typeof === t;
    }
    function o1(T) {
      return M(T) === f;
    }
    function r1(T) {
      return M(T) === r;
    }
    function X(T) {
      return M(T) === g;
    }
    function Y(T) {
      return M(T) === p;
    }
    function Q(T) {
      return M(T) === n;
    }
    function N(T) {
      return M(T) === i;
    }
    function j(T) {
      return M(T) === o;
    }
    function t1(T) {
      return M(T) === u;
    }
    Ie.AsyncMode = S, Ie.ConcurrentMode = k, Ie.ContextConsumer = L, Ie.ContextProvider = P, Ie.Element = I, Ie.ForwardRef = O, Ie.Fragment = E, Ie.Lazy = B, Ie.Memo = W, Ie.Portal = F, Ie.Profiler = z, Ie.StrictMode = D, Ie.Suspense = Z, Ie.isAsyncMode = $, Ie.isConcurrentMode = q, Ie.isContextConsumer = K, Ie.isContextProvider = V, Ie.isElement = n1, Ie.isForwardRef = o1, Ie.isFragment = r1, Ie.isLazy = X, Ie.isMemo = Y, Ie.isPortal = Q, Ie.isProfiler = N, Ie.isStrictMode = j, Ie.isSuspense = t1, Ie.isValidElementType = _, Ie.typeOf = M;
  }()), Ie;
}
var Bf;
function X_() {
  return Bf || (Bf = 1, process.env.NODE_ENV === "production" ? Lo.exports = E$() : Lo.exports = T$()), Lo.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var t4, Ff;
function R$() {
  if (Ff) return t4;
  Ff = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var a = {}, s = 0; s < 10; s++)
        a["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(a).map(function(f) {
        return a[f];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(f) {
        c[f] = f;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return t4 = o() ? Object.assign : function(i, a) {
    for (var s, l = r(i), c, f = 1; f < arguments.length; f++) {
      s = Object(arguments[f]);
      for (var u in s)
        t.call(s, u) && (l[u] = s[u]);
      if (e) {
        c = e(s);
        for (var h = 0; h < c.length; h++)
          n.call(s, c[h]) && (l[c[h]] = s[c[h]]);
      }
    }
    return l;
  }, t4;
}
var n4, $f;
function nd() {
  if ($f) return n4;
  $f = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return n4 = e, n4;
}
var r4, Wf;
function Q_() {
  return Wf || (Wf = 1, r4 = Function.call.bind(Object.prototype.hasOwnProperty)), r4;
}
var o4, Vf;
function P$() {
  if (Vf) return o4;
  Vf = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ nd(), n = {}, r = /* @__PURE__ */ Q_();
    e = function(i) {
      var a = "Warning: " + i;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function o(i, a, s, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var f in i)
        if (r(i, f)) {
          var u;
          try {
            if (typeof i[f] != "function") {
              var h = Error(
                (l || "React class") + ": " + s + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw h.name = "Invariant Violation", h;
            }
            u = i[f](a, f, l, s, null, t);
          } catch (g) {
            u = g;
          }
          if (u && !(u instanceof Error) && e(
            (l || "React class") + ": type specification of " + s + " `" + f + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof u + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), u instanceof Error && !(u.message in n)) {
            n[u.message] = !0;
            var p = c ? c() : "";
            e(
              "Failed " + s + " type: " + u.message + (p ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, o4 = o, o4;
}
var i4, Hf;
function A$() {
  if (Hf) return i4;
  Hf = 1;
  var e = X_(), t = R$(), n = /* @__PURE__ */ nd(), r = /* @__PURE__ */ Q_(), o = /* @__PURE__ */ P$(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return i4 = function(s, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, f = "@@iterator";
    function u(q) {
      var K = q && (c && q[c] || q[f]);
      if (typeof K == "function")
        return K;
    }
    var h = "<<anonymous>>", p = {
      array: y("array"),
      bigint: y("bigint"),
      bool: y("boolean"),
      func: y("function"),
      number: y("number"),
      object: y("object"),
      string: y("string"),
      symbol: y("symbol"),
      any: C(),
      arrayOf: _,
      element: M(),
      elementType: S(),
      instanceOf: k,
      node: O(),
      objectOf: P,
      oneOf: L,
      oneOfType: I,
      shape: B,
      exact: W
    };
    function g(q, K) {
      return q === K ? q !== 0 || 1 / q === 1 / K : q !== q && K !== K;
    }
    function m(q, K) {
      this.message = q, this.data = K && typeof K == "object" ? K : {}, this.stack = "";
    }
    m.prototype = Error.prototype;
    function b(q) {
      if (process.env.NODE_ENV !== "production")
        var K = {}, V = 0;
      function n1(r1, X, Y, Q, N, j, t1) {
        if (Q = Q || h, j = j || Y, t1 !== n) {
          if (l) {
            var T = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw T.name = "Invariant Violation", T;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var u1 = Q + ":" + Y;
            !K[u1] && // Avoid spamming the console because they are often not actionable except for lib authors
            V < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + j + "` prop on `" + Q + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), K[u1] = !0, V++);
          }
        }
        return X[Y] == null ? r1 ? X[Y] === null ? new m("The " + N + " `" + j + "` is marked as required " + ("in `" + Q + "`, but its value is `null`.")) : new m("The " + N + " `" + j + "` is marked as required in " + ("`" + Q + "`, but its value is `undefined`.")) : null : q(X, Y, Q, N, j);
      }
      var o1 = n1.bind(null, !1);
      return o1.isRequired = n1.bind(null, !0), o1;
    }
    function y(q) {
      function K(V, n1, o1, r1, X, Y) {
        var Q = V[n1], N = D(Q);
        if (N !== q) {
          var j = Z(Q);
          return new m(
            "Invalid " + r1 + " `" + X + "` of type " + ("`" + j + "` supplied to `" + o1 + "`, expected ") + ("`" + q + "`."),
            { expectedType: q }
          );
        }
        return null;
      }
      return b(K);
    }
    function C() {
      return b(a);
    }
    function _(q) {
      function K(V, n1, o1, r1, X) {
        if (typeof q != "function")
          return new m("Property `" + X + "` of component `" + o1 + "` has invalid PropType notation inside arrayOf.");
        var Y = V[n1];
        if (!Array.isArray(Y)) {
          var Q = D(Y);
          return new m("Invalid " + r1 + " `" + X + "` of type " + ("`" + Q + "` supplied to `" + o1 + "`, expected an array."));
        }
        for (var N = 0; N < Y.length; N++) {
          var j = q(Y, N, o1, r1, X + "[" + N + "]", n);
          if (j instanceof Error)
            return j;
        }
        return null;
      }
      return b(K);
    }
    function M() {
      function q(K, V, n1, o1, r1) {
        var X = K[V];
        if (!s(X)) {
          var Y = D(X);
          return new m("Invalid " + o1 + " `" + r1 + "` of type " + ("`" + Y + "` supplied to `" + n1 + "`, expected a single ReactElement."));
        }
        return null;
      }
      return b(q);
    }
    function S() {
      function q(K, V, n1, o1, r1) {
        var X = K[V];
        if (!e.isValidElementType(X)) {
          var Y = D(X);
          return new m("Invalid " + o1 + " `" + r1 + "` of type " + ("`" + Y + "` supplied to `" + n1 + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return b(q);
    }
    function k(q) {
      function K(V, n1, o1, r1, X) {
        if (!(V[n1] instanceof q)) {
          var Y = q.name || h, Q = $(V[n1]);
          return new m("Invalid " + r1 + " `" + X + "` of type " + ("`" + Q + "` supplied to `" + o1 + "`, expected ") + ("instance of `" + Y + "`."));
        }
        return null;
      }
      return b(K);
    }
    function L(q) {
      if (!Array.isArray(q))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), a;
      function K(V, n1, o1, r1, X) {
        for (var Y = V[n1], Q = 0; Q < q.length; Q++)
          if (g(Y, q[Q]))
            return null;
        var N = JSON.stringify(q, function(t1, T) {
          var u1 = Z(T);
          return u1 === "symbol" ? String(T) : T;
        });
        return new m("Invalid " + r1 + " `" + X + "` of value `" + String(Y) + "` " + ("supplied to `" + o1 + "`, expected one of " + N + "."));
      }
      return b(K);
    }
    function P(q) {
      function K(V, n1, o1, r1, X) {
        if (typeof q != "function")
          return new m("Property `" + X + "` of component `" + o1 + "` has invalid PropType notation inside objectOf.");
        var Y = V[n1], Q = D(Y);
        if (Q !== "object")
          return new m("Invalid " + r1 + " `" + X + "` of type " + ("`" + Q + "` supplied to `" + o1 + "`, expected an object."));
        for (var N in Y)
          if (r(Y, N)) {
            var j = q(Y, N, o1, r1, X + "." + N, n);
            if (j instanceof Error)
              return j;
          }
        return null;
      }
      return b(K);
    }
    function I(q) {
      if (!Array.isArray(q))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var K = 0; K < q.length; K++) {
        var V = q[K];
        if (typeof V != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + U(V) + " at index " + K + "."
          ), a;
      }
      function n1(o1, r1, X, Y, Q) {
        for (var N = [], j = 0; j < q.length; j++) {
          var t1 = q[j], T = t1(o1, r1, X, Y, Q, n);
          if (T == null)
            return null;
          T.data && r(T.data, "expectedType") && N.push(T.data.expectedType);
        }
        var u1 = N.length > 0 ? ", expected one of type [" + N.join(", ") + "]" : "";
        return new m("Invalid " + Y + " `" + Q + "` supplied to " + ("`" + X + "`" + u1 + "."));
      }
      return b(n1);
    }
    function O() {
      function q(K, V, n1, o1, r1) {
        return F(K[V]) ? null : new m("Invalid " + o1 + " `" + r1 + "` supplied to " + ("`" + n1 + "`, expected a ReactNode."));
      }
      return b(q);
    }
    function E(q, K, V, n1, o1) {
      return new m(
        (q || "React class") + ": " + K + " type `" + V + "." + n1 + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + o1 + "`."
      );
    }
    function B(q) {
      function K(V, n1, o1, r1, X) {
        var Y = V[n1], Q = D(Y);
        if (Q !== "object")
          return new m("Invalid " + r1 + " `" + X + "` of type `" + Q + "` " + ("supplied to `" + o1 + "`, expected `object`."));
        for (var N in q) {
          var j = q[N];
          if (typeof j != "function")
            return E(o1, r1, X, N, Z(j));
          var t1 = j(Y, N, o1, r1, X + "." + N, n);
          if (t1)
            return t1;
        }
        return null;
      }
      return b(K);
    }
    function W(q) {
      function K(V, n1, o1, r1, X) {
        var Y = V[n1], Q = D(Y);
        if (Q !== "object")
          return new m("Invalid " + r1 + " `" + X + "` of type `" + Q + "` " + ("supplied to `" + o1 + "`, expected `object`."));
        var N = t({}, V[n1], q);
        for (var j in N) {
          var t1 = q[j];
          if (r(q, j) && typeof t1 != "function")
            return E(o1, r1, X, j, Z(t1));
          if (!t1)
            return new m(
              "Invalid " + r1 + " `" + X + "` key `" + j + "` supplied to `" + o1 + "`.\nBad object: " + JSON.stringify(V[n1], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(q), null, "  ")
            );
          var T = t1(Y, j, o1, r1, X + "." + j, n);
          if (T)
            return T;
        }
        return null;
      }
      return b(K);
    }
    function F(q) {
      switch (typeof q) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !q;
        case "object":
          if (Array.isArray(q))
            return q.every(F);
          if (q === null || s(q))
            return !0;
          var K = u(q);
          if (K) {
            var V = K.call(q), n1;
            if (K !== q.entries) {
              for (; !(n1 = V.next()).done; )
                if (!F(n1.value))
                  return !1;
            } else
              for (; !(n1 = V.next()).done; ) {
                var o1 = n1.value;
                if (o1 && !F(o1[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function z(q, K) {
      return q === "symbol" ? !0 : K ? K["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && K instanceof Symbol : !1;
    }
    function D(q) {
      var K = typeof q;
      return Array.isArray(q) ? "array" : q instanceof RegExp ? "object" : z(K, q) ? "symbol" : K;
    }
    function Z(q) {
      if (typeof q > "u" || q === null)
        return "" + q;
      var K = D(q);
      if (K === "object") {
        if (q instanceof Date)
          return "date";
        if (q instanceof RegExp)
          return "regexp";
      }
      return K;
    }
    function U(q) {
      var K = Z(q);
      switch (K) {
        case "array":
        case "object":
          return "an " + K;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + K;
        default:
          return K;
      }
    }
    function $(q) {
      return !q.constructor || !q.constructor.name ? h : q.constructor.name;
    }
    return p.checkPropTypes = o, p.resetWarningCache = o.resetWarningCache, p.PropTypes = p, p;
  }, i4;
}
var a4, jf;
function I$() {
  if (jf) return a4;
  jf = 1;
  var e = /* @__PURE__ */ nd();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, a4 = function() {
    function r(a, s, l, c, f, u) {
      if (u !== e) {
        var h = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw h.name = "Invariant Violation", h;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, a4;
}
var qf;
function O$() {
  if (qf) return ko.exports;
  if (qf = 1, process.env.NODE_ENV !== "production") {
    var e = X_(), t = !0;
    ko.exports = /* @__PURE__ */ A$()(e.isElement, t);
  } else
    ko.exports = /* @__PURE__ */ I$()();
  return ko.exports;
}
var N$ = /* @__PURE__ */ O$();
const i1 = /* @__PURE__ */ h2(N$);
var rd = Jr(), z1 = (e) => Qr(e, rd), od = Jr();
z1.write = (e) => Qr(e, od);
var ya = Jr();
z1.onStart = (e) => Qr(e, ya);
var id = Jr();
z1.onFrame = (e) => Qr(e, id);
var ad = Jr();
z1.onFinish = (e) => Qr(e, ad);
var D3 = [];
z1.setTimeout = (e, t) => {
  const n = z1.now() + t, r = () => {
    const i = D3.findIndex((a) => a.cancel == r);
    ~i && D3.splice(i, 1), v0 -= ~i ? 1 : 0;
  }, o = { time: n, handler: e, cancel: r };
  return D3.splice(J_(n), 0, o), v0 += 1, ex(), o;
};
var J_ = (e) => ~(~D3.findIndex((t) => t.time > e) || ~D3.length);
z1.cancel = (e) => {
  ya.delete(e), id.delete(e), ad.delete(e), rd.delete(e), od.delete(e);
};
z1.sync = (e) => {
  lu = !0, z1.batchedUpdates(e), lu = !1;
};
z1.throttle = (e) => {
  let t;
  function n() {
    try {
      e(...t);
    } finally {
      t = null;
    }
  }
  function r(...o) {
    t = o, z1.onStart(n);
  }
  return r.handler = e, r.cancel = () => {
    ya.delete(n), t = null;
  }, r;
};
var sd = typeof window < "u" ? window.requestAnimationFrame : (
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  () => {
  }
);
z1.use = (e) => sd = e;
z1.now = typeof performance < "u" ? () => performance.now() : Date.now;
z1.batchedUpdates = (e) => e();
z1.catch = console.error;
z1.frameLoop = "always";
z1.advance = () => {
  z1.frameLoop !== "demand" ? console.warn(
    "Cannot call the manual advancement of rafz whilst frameLoop is not set as demand"
  ) : nx();
};
var g0 = -1, v0 = 0, lu = !1;
function Qr(e, t) {
  lu ? (t.delete(e), e(0)) : (t.add(e), ex());
}
function ex() {
  g0 < 0 && (g0 = 0, z1.frameLoop !== "demand" && sd(tx));
}
function D$() {
  g0 = -1;
}
function tx() {
  ~g0 && (sd(tx), z1.batchedUpdates(nx));
}
function nx() {
  const e = g0;
  g0 = z1.now();
  const t = J_(g0);
  if (t && (rx(D3.splice(0, t), (n) => n.handler()), v0 -= t), !v0) {
    D$();
    return;
  }
  ya.flush(), rd.flush(e ? Math.min(64, g0 - e) : 16.667), id.flush(), od.flush(), ad.flush();
}
function Jr() {
  let e = /* @__PURE__ */ new Set(), t = e;
  return {
    add(n) {
      v0 += t == e && !e.has(n) ? 1 : 0, e.add(n);
    },
    delete(n) {
      return v0 -= t == e && e.has(n) ? 1 : 0, e.delete(n);
    },
    flush(n) {
      t.size && (e = /* @__PURE__ */ new Set(), v0 -= t.size, rx(t, (r) => r(n) && e.add(r)), v0 += e.size, t = e);
    }
  };
}
function rx(e, t) {
  e.forEach((n) => {
    try {
      t(n);
    } catch (r) {
      z1.catch(r);
    }
  });
}
var B$ = Object.defineProperty, F$ = (e, t) => {
  for (var n in t)
    B$(e, n, { get: t[n], enumerable: !0 });
}, vt = {};
F$(vt, {
  assign: () => W$,
  colors: () => C0,
  createStringInterpolator: () => cd,
  skipAnimation: () => ix,
  to: () => ox,
  willAdvance: () => ud
});
function cu() {
}
var $$ = (e, t, n) => Object.defineProperty(e, t, { value: n, writable: !0, configurable: !0 }), h1 = {
  arr: Array.isArray,
  obj: (e) => !!e && e.constructor.name === "Object",
  fun: (e) => typeof e == "function",
  str: (e) => typeof e == "string",
  num: (e) => typeof e == "number",
  und: (e) => e === void 0
};
function Gt(e, t) {
  if (h1.arr(e)) {
    if (!h1.arr(t) || e.length !== t.length)
      return !1;
    for (let n = 0; n < e.length; n++)
      if (e[n] !== t[n])
        return !1;
    return !0;
  }
  return e === t;
}
var H1 = (e, t) => e.forEach(t);
function At(e, t, n) {
  if (h1.arr(e)) {
    for (let r = 0; r < e.length; r++)
      t.call(n, e[r], `${r}`);
    return;
  }
  for (const r in e)
    e.hasOwnProperty(r) && t.call(n, e[r], r);
}
var P2 = (e) => h1.und(e) ? [] : h1.arr(e) ? e : [e];
function Qn(e, t) {
  if (e.size) {
    const n = Array.from(e);
    e.clear(), H1(n, t);
  }
}
var Un = (e, ...t) => Qn(e, (n) => n(...t)), ld = () => typeof window > "u" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent), cd, ox, C0 = null, ix = !1, ud = cu, W$ = (e) => {
  e.to && (ox = e.to), e.now && (z1.now = e.now), e.colors !== void 0 && (C0 = e.colors), e.skipAnimation != null && (ix = e.skipAnimation), e.createStringInterpolator && (cd = e.createStringInterpolator), e.requestAnimationFrame && z1.use(e.requestAnimationFrame), e.batchedUpdates && (z1.batchedUpdates = e.batchedUpdates), e.willAdvance && (ud = e.willAdvance), e.frameLoop && (z1.frameLoop = e.frameLoop);
}, Jn = /* @__PURE__ */ new Set(), X2 = [], s4 = [], oi = 0, Ca = {
  get idle() {
    return !Jn.size && !X2.length;
  },
  /** Advance the given animation on every frame until idle. */
  start(e) {
    oi > e.priority ? (Jn.add(e), z1.onStart(V$)) : (ax(e), z1(uu));
  },
  /** Advance all animations by the given time. */
  advance: uu,
  /** Call this when an animation's priority changes. */
  sort(e) {
    if (oi)
      z1.onFrame(() => Ca.sort(e));
    else {
      const t = X2.indexOf(e);
      ~t && (X2.splice(t, 1), sx(e));
    }
  },
  /**
   * Clear all animations. For testing purposes.
   *
   * ☠️ Never call this from within the frameloop.
   */
  clear() {
    X2 = [], Jn.clear();
  }
};
function V$() {
  Jn.forEach(ax), Jn.clear(), z1(uu);
}
function ax(e) {
  X2.includes(e) || sx(e);
}
function sx(e) {
  X2.splice(
    H$(X2, (t) => t.priority > e.priority),
    0,
    e
  );
}
function uu(e) {
  const t = s4;
  for (let n = 0; n < X2.length; n++) {
    const r = X2[n];
    oi = r.priority, r.idle || (ud(r), r.advance(e), r.idle || t.push(r));
  }
  return oi = 0, s4 = X2, s4.length = 0, X2 = t, X2.length > 0;
}
function H$(e, t) {
  const n = e.findIndex(t);
  return n < 0 ? e.length : n;
}
var j$ = {
  transparent: 0,
  aliceblue: 4042850303,
  antiquewhite: 4209760255,
  aqua: 16777215,
  aquamarine: 2147472639,
  azure: 4043309055,
  beige: 4126530815,
  bisque: 4293182719,
  black: 255,
  blanchedalmond: 4293643775,
  blue: 65535,
  blueviolet: 2318131967,
  brown: 2771004159,
  burlywood: 3736635391,
  burntsienna: 3934150143,
  cadetblue: 1604231423,
  chartreuse: 2147418367,
  chocolate: 3530104575,
  coral: 4286533887,
  cornflowerblue: 1687547391,
  cornsilk: 4294499583,
  crimson: 3692313855,
  cyan: 16777215,
  darkblue: 35839,
  darkcyan: 9145343,
  darkgoldenrod: 3095792639,
  darkgray: 2846468607,
  darkgreen: 6553855,
  darkgrey: 2846468607,
  darkkhaki: 3182914559,
  darkmagenta: 2332068863,
  darkolivegreen: 1433087999,
  darkorange: 4287365375,
  darkorchid: 2570243327,
  darkred: 2332033279,
  darksalmon: 3918953215,
  darkseagreen: 2411499519,
  darkslateblue: 1211993087,
  darkslategray: 793726975,
  darkslategrey: 793726975,
  darkturquoise: 13554175,
  darkviolet: 2483082239,
  deeppink: 4279538687,
  deepskyblue: 12582911,
  dimgray: 1768516095,
  dimgrey: 1768516095,
  dodgerblue: 512819199,
  firebrick: 2988581631,
  floralwhite: 4294635775,
  forestgreen: 579543807,
  fuchsia: 4278255615,
  gainsboro: 3705462015,
  ghostwhite: 4177068031,
  gold: 4292280575,
  goldenrod: 3668254975,
  gray: 2155905279,
  green: 8388863,
  greenyellow: 2919182335,
  grey: 2155905279,
  honeydew: 4043305215,
  hotpink: 4285117695,
  indianred: 3445382399,
  indigo: 1258324735,
  ivory: 4294963455,
  khaki: 4041641215,
  lavender: 3873897215,
  lavenderblush: 4293981695,
  lawngreen: 2096890111,
  lemonchiffon: 4294626815,
  lightblue: 2916673279,
  lightcoral: 4034953471,
  lightcyan: 3774873599,
  lightgoldenrodyellow: 4210742015,
  lightgray: 3553874943,
  lightgreen: 2431553791,
  lightgrey: 3553874943,
  lightpink: 4290167295,
  lightsalmon: 4288707327,
  lightseagreen: 548580095,
  lightskyblue: 2278488831,
  lightslategray: 2005441023,
  lightslategrey: 2005441023,
  lightsteelblue: 2965692159,
  lightyellow: 4294959359,
  lime: 16711935,
  limegreen: 852308735,
  linen: 4210091775,
  magenta: 4278255615,
  maroon: 2147483903,
  mediumaquamarine: 1724754687,
  mediumblue: 52735,
  mediumorchid: 3126187007,
  mediumpurple: 2473647103,
  mediumseagreen: 1018393087,
  mediumslateblue: 2070474495,
  mediumspringgreen: 16423679,
  mediumturquoise: 1221709055,
  mediumvioletred: 3340076543,
  midnightblue: 421097727,
  mintcream: 4127193855,
  mistyrose: 4293190143,
  moccasin: 4293178879,
  navajowhite: 4292783615,
  navy: 33023,
  oldlace: 4260751103,
  olive: 2155872511,
  olivedrab: 1804477439,
  orange: 4289003775,
  orangered: 4282712319,
  orchid: 3664828159,
  palegoldenrod: 4008225535,
  palegreen: 2566625535,
  paleturquoise: 2951671551,
  palevioletred: 3681588223,
  papayawhip: 4293907967,
  peachpuff: 4292524543,
  peru: 3448061951,
  pink: 4290825215,
  plum: 3718307327,
  powderblue: 2967529215,
  purple: 2147516671,
  rebeccapurple: 1714657791,
  red: 4278190335,
  rosybrown: 3163525119,
  royalblue: 1097458175,
  saddlebrown: 2336560127,
  salmon: 4202722047,
  sandybrown: 4104413439,
  seagreen: 780883967,
  seashell: 4294307583,
  sienna: 2689740287,
  silver: 3233857791,
  skyblue: 2278484991,
  slateblue: 1784335871,
  slategray: 1887473919,
  slategrey: 1887473919,
  snow: 4294638335,
  springgreen: 16744447,
  steelblue: 1182971135,
  tan: 3535047935,
  teal: 8421631,
  thistle: 3636451583,
  tomato: 4284696575,
  turquoise: 1088475391,
  violet: 4001558271,
  wheat: 4125012991,
  white: 4294967295,
  whitesmoke: 4126537215,
  yellow: 4294902015,
  yellowgreen: 2597139199
}, ft = "[-+]?\\d*\\.?\\d+", ii = ft + "%";
function wa(...e) {
  return "\\(\\s*(" + e.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var q$ = new RegExp("rgb" + wa(ft, ft, ft)), z$ = new RegExp("rgba" + wa(ft, ft, ft, ft)), U$ = new RegExp("hsl" + wa(ft, ii, ii)), G$ = new RegExp(
  "hsla" + wa(ft, ii, ii, ft)
), Y$ = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/, Z$ = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/, K$ = /^#([0-9a-fA-F]{6})$/, X$ = /^#([0-9a-fA-F]{8})$/;
function Q$(e) {
  let t;
  return typeof e == "number" ? e >>> 0 === e && e >= 0 && e <= 4294967295 ? e : null : (t = K$.exec(e)) ? parseInt(t[1] + "ff", 16) >>> 0 : C0 && C0[e] !== void 0 ? C0[e] : (t = q$.exec(e)) ? (_3(t[1]) << 24 | // r
  _3(t[2]) << 16 | // g
  _3(t[3]) << 8 | // b
  255) >>> // a
  0 : (t = z$.exec(e)) ? (_3(t[1]) << 24 | // r
  _3(t[2]) << 16 | // g
  _3(t[3]) << 8 | // b
  Gf(t[4])) >>> // a
  0 : (t = Y$.exec(e)) ? parseInt(
    t[1] + t[1] + // r
    t[2] + t[2] + // g
    t[3] + t[3] + // b
    "ff",
    // a
    16
  ) >>> 0 : (t = X$.exec(e)) ? parseInt(t[1], 16) >>> 0 : (t = Z$.exec(e)) ? parseInt(
    t[1] + t[1] + // r
    t[2] + t[2] + // g
    t[3] + t[3] + // b
    t[4] + t[4],
    // a
    16
  ) >>> 0 : (t = U$.exec(e)) ? (zf(
    Uf(t[1]),
    // h
    Eo(t[2]),
    // s
    Eo(t[3])
    // l
  ) | 255) >>> // a
  0 : (t = G$.exec(e)) ? (zf(
    Uf(t[1]),
    // h
    Eo(t[2]),
    // s
    Eo(t[3])
    // l
  ) | Gf(t[4])) >>> // a
  0 : null;
}
function l4(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function zf(e, t, n) {
  const r = n < 0.5 ? n * (1 + t) : n + t - n * t, o = 2 * n - r, i = l4(o, r, e + 1 / 3), a = l4(o, r, e), s = l4(o, r, e - 1 / 3);
  return Math.round(i * 255) << 24 | Math.round(a * 255) << 16 | Math.round(s * 255) << 8;
}
function _3(e) {
  const t = parseInt(e, 10);
  return t < 0 ? 0 : t > 255 ? 255 : t;
}
function Uf(e) {
  return (parseFloat(e) % 360 + 360) % 360 / 360;
}
function Gf(e) {
  const t = parseFloat(e);
  return t < 0 ? 0 : t > 1 ? 255 : Math.round(t * 255);
}
function Eo(e) {
  const t = parseFloat(e);
  return t < 0 ? 0 : t > 100 ? 1 : t / 100;
}
function Yf(e) {
  let t = Q$(e);
  if (t === null)
    return e;
  t = t || 0;
  const n = (t & 4278190080) >>> 24, r = (t & 16711680) >>> 16, o = (t & 65280) >>> 8, i = (t & 255) / 255;
  return `rgba(${n}, ${r}, ${o}, ${i})`;
}
var dr = (e, t, n) => {
  if (h1.fun(e))
    return e;
  if (h1.arr(e))
    return dr({
      range: e,
      output: t,
      extrapolate: n
    });
  if (h1.str(e.output[0]))
    return cd(e);
  const r = e, o = r.output, i = r.range || [0, 1], a = r.extrapolateLeft || r.extrapolate || "extend", s = r.extrapolateRight || r.extrapolate || "extend", l = r.easing || ((c) => c);
  return (c) => {
    const f = eW(c, i);
    return J$(
      c,
      i[f],
      i[f + 1],
      o[f],
      o[f + 1],
      l,
      a,
      s,
      r.map
    );
  };
};
function J$(e, t, n, r, o, i, a, s, l) {
  let c = l ? l(e) : e;
  if (c < t) {
    if (a === "identity")
      return c;
    a === "clamp" && (c = t);
  }
  if (c > n) {
    if (s === "identity")
      return c;
    s === "clamp" && (c = n);
  }
  return r === o ? r : t === n ? e <= t ? r : o : (t === -1 / 0 ? c = -c : n === 1 / 0 ? c = c - t : c = (c - t) / (n - t), c = i(c), r === -1 / 0 ? c = -c : o === 1 / 0 ? c = c + r : c = c * (o - r) + r, c);
}
function eW(e, t) {
  for (var n = 1; n < t.length - 1 && !(t[n] >= e); ++n)
    ;
  return n - 1;
}
var tW = {
  linear: (e) => e
}, fr = Symbol.for("FluidValue.get"), q3 = Symbol.for("FluidValue.observers"), K2 = (e) => !!(e && e[fr]), B2 = (e) => e && e[fr] ? e[fr]() : e, Zf = (e) => e[q3] || null;
function nW(e, t) {
  e.eventObserved ? e.eventObserved(t) : e(t);
}
function hr(e, t) {
  const n = e[q3];
  n && n.forEach((r) => {
    nW(r, t);
  });
}
var lx = class {
  constructor(e) {
    if (!e && !(e = this.get))
      throw Error("Unknown getter");
    rW(this, e);
  }
}, rW = (e, t) => cx(e, fr, t);
function dn(e, t) {
  if (e[fr]) {
    let n = e[q3];
    n || cx(e, q3, n = /* @__PURE__ */ new Set()), n.has(t) || (n.add(t), e.observerAdded && e.observerAdded(n.size, t));
  }
  return t;
}
function pr(e, t) {
  const n = e[q3];
  if (n && n.has(t)) {
    const r = n.size - 1;
    r ? n.delete(t) : e[q3] = null, e.observerRemoved && e.observerRemoved(r, t);
  }
}
var cx = (e, t, n) => Object.defineProperty(e, t, {
  value: n,
  writable: !0,
  configurable: !0
}), qo = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, oW = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi, Kf = new RegExp(`(${qo.source})(%|[a-z]+)`, "i"), iW = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi, _a = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/, ux = (e) => {
  const [t, n] = aW(e);
  if (!t || ld())
    return e;
  const r = window.getComputedStyle(document.documentElement).getPropertyValue(t);
  if (r)
    return r.trim();
  if (n && n.startsWith("--")) {
    const o = window.getComputedStyle(document.documentElement).getPropertyValue(n);
    return o || e;
  } else {
    if (n && _a.test(n))
      return ux(n);
    if (n)
      return n;
  }
  return e;
}, aW = (e) => {
  const t = _a.exec(e);
  if (!t)
    return [,];
  const [, n, r] = t;
  return [n, r];
}, c4, sW = (e, t, n, r, o) => `rgba(${Math.round(t)}, ${Math.round(n)}, ${Math.round(r)}, ${o})`, dx = (e) => {
  c4 || (c4 = C0 ? (
    // match color names, ignore partial matches
    new RegExp(`(${Object.keys(C0).join("|")})(?!\\w)`, "g")
  ) : (
    // never match
    /^\b$/
  ));
  const t = e.output.map((i) => B2(i).replace(_a, ux).replace(oW, Yf).replace(c4, Yf)), n = t.map((i) => i.match(qo).map(Number)), o = n[0].map(
    (i, a) => n.map((s) => {
      if (!(a in s))
        throw Error('The arity of each "output" value must be equal');
      return s[a];
    })
  ).map(
    (i) => dr({ ...e, output: i })
  );
  return (i) => {
    const a = !Kf.test(t[0]) && t.find((l) => Kf.test(l))?.replace(qo, "");
    let s = 0;
    return t[0].replace(
      qo,
      () => `${o[s++](i)}${a || ""}`
    ).replace(iW, sW);
  };
}, dd = "react-spring: ", fx = (e) => {
  const t = e;
  let n = !1;
  if (typeof t != "function")
    throw new TypeError(`${dd}once requires a function parameter`);
  return (...r) => {
    n || (t(...r), n = !0);
  };
}, lW = fx(console.warn);
function cW() {
  lW(
    `${dd}The "interpolate" function is deprecated in v9 (use "to" instead)`
  );
}
var uW = fx(console.warn);
function dW() {
  uW(
    `${dd}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`
  );
}
function xa(e) {
  return h1.str(e) && (e[0] == "#" || /\d/.test(e) || // Do not identify a CSS variable as an AnimatedString if its SSR
  !ld() && _a.test(e) || e in (C0 || {}));
}
var H0 = ld() ? Te : Zu, fW = () => {
  const e = Be(!1);
  return H0(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
};
function fd() {
  const e = d2()[1], t = fW();
  return () => {
    t.current && e(Math.random());
  };
}
function hW(e, t) {
  const [n] = d2(
    () => ({
      inputs: t,
      result: e()
    })
  ), r = Be(), o = r.current;
  let i = o;
  return i ? t && i.inputs && pW(t, i.inputs) || (i = {
    inputs: t,
    result: e()
  }) : i = n, Te(() => {
    r.current = i, o == n && (n.inputs = n.result = void 0);
  }, [i]), i.result;
}
function pW(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
var hd = (e) => Te(e, mW), mW = [];
function du(e) {
  const t = Be();
  return Te(() => {
    t.current = e;
  }), t.current;
}
var mr = Symbol.for("Animated:node"), gW = (e) => !!e && e[mr] === e, xt = (e) => e && e[mr], pd = (e, t) => $$(e, mr, t), Sa = (e) => e && e[mr] && e[mr].getPayload(), hx = class {
  constructor() {
    pd(this, this);
  }
  /** Get every `AnimatedValue` used by this node. */
  getPayload() {
    return this.payload || [];
  }
}, eo = class extends hx {
  constructor(e) {
    super(), this._value = e, this.done = !0, this.durationProgress = 0, h1.num(this._value) && (this.lastPosition = this._value);
  }
  /** @internal */
  static create(e) {
    return new eo(e);
  }
  getPayload() {
    return [this];
  }
  getValue() {
    return this._value;
  }
  setValue(e, t) {
    return h1.num(e) && (this.lastPosition = e, t && (e = Math.round(e / t) * t, this.done && (this.lastPosition = e))), this._value === e ? !1 : (this._value = e, !0);
  }
  reset() {
    const { done: e } = this;
    this.done = !1, h1.num(this._value) && (this.elapsedTime = 0, this.durationProgress = 0, this.lastPosition = this._value, e && (this.lastVelocity = null), this.v0 = null);
  }
}, gr = class extends eo {
  constructor(e) {
    super(0), this._string = null, this._toString = dr({
      output: [e, e]
    });
  }
  /** @internal */
  static create(e) {
    return new gr(e);
  }
  getValue() {
    const e = this._string;
    return e ?? (this._string = this._toString(this._value));
  }
  setValue(e) {
    if (h1.str(e)) {
      if (e == this._string)
        return !1;
      this._string = e, this._value = 1;
    } else if (super.setValue(e))
      this._string = null;
    else
      return !1;
    return !0;
  }
  reset(e) {
    e && (this._toString = dr({
      output: [this.getValue(), e]
    })), this._value = 0, super.reset();
  }
}, ai = { dependencies: null }, Ma = class extends hx {
  constructor(e) {
    super(), this.source = e, this.setValue(e);
  }
  getValue(e) {
    const t = {};
    return At(this.source, (n, r) => {
      gW(n) ? t[r] = n.getValue(e) : K2(n) ? t[r] = B2(n) : e || (t[r] = n);
    }), t;
  }
  /** Replace the raw object data */
  setValue(e) {
    this.source = e, this.payload = this._makePayload(e);
  }
  reset() {
    this.payload && H1(this.payload, (e) => e.reset());
  }
  /** Create a payload set. */
  _makePayload(e) {
    if (e) {
      const t = /* @__PURE__ */ new Set();
      return At(e, this._addToPayload, t), Array.from(t);
    }
  }
  /** Add to a payload set. */
  _addToPayload(e) {
    ai.dependencies && K2(e) && ai.dependencies.add(e);
    const t = Sa(e);
    t && H1(t, (n) => this.add(n));
  }
}, px = class extends Ma {
  constructor(e) {
    super(e);
  }
  /** @internal */
  static create(e) {
    return new px(e);
  }
  getValue() {
    return this.source.map((e) => e.getValue());
  }
  setValue(e) {
    const t = this.getPayload();
    return e.length == t.length ? t.map((n, r) => n.setValue(e[r])).some(Boolean) : (super.setValue(e.map(vW)), !0);
  }
};
function vW(e) {
  return (xa(e) ? gr : eo).create(e);
}
function fu(e) {
  const t = xt(e);
  return t ? t.constructor : h1.arr(e) ? px : xa(e) ? gr : eo;
}
var Xf = (e, t) => {
  const n = (
    // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !h1.fun(e) || e.prototype && e.prototype.isReactComponent
  );
  return x1((r, o) => {
    const i = Be(null), a = n && // eslint-disable-next-line react-hooks/rules-of-hooks
    R1(
      (g) => {
        i.current = CW(o, g);
      },
      [o]
    ), [s, l] = yW(r, t), c = fd(), f = () => {
      const g = i.current;
      if (n && !g)
        return;
      (g ? t.applyAnimatedValues(g, s.getValue(!0)) : !1) === !1 && c();
    }, u = new bW(f, l), h = Be();
    H0(() => (h.current = u, H1(l, (g) => dn(g, u)), () => {
      h.current && (H1(
        h.current.deps,
        (g) => pr(g, h.current)
      ), z1.cancel(h.current.update));
    })), Te(f, []), hd(() => () => {
      const g = h.current;
      H1(g.deps, (m) => pr(m, g));
    });
    const p = t.getComponentProps(s.getValue());
    return /* @__PURE__ */ d.createElement(e, { ...p, ref: a });
  });
}, bW = class {
  constructor(e, t) {
    this.update = e, this.deps = t;
  }
  eventObserved(e) {
    e.type == "change" && z1.write(this.update);
  }
};
function yW(e, t) {
  const n = /* @__PURE__ */ new Set();
  return ai.dependencies = n, e.style && (e = {
    ...e,
    style: t.createAnimatedStyle(e.style)
  }), e = new Ma(e), ai.dependencies = null, [e, n];
}
function CW(e, t) {
  return e && (h1.fun(e) ? e(t) : e.current = t), t;
}
var Qf = Symbol.for("AnimatedComponent"), wW = (e, {
  applyAnimatedValues: t = () => !1,
  createAnimatedStyle: n = (o) => new Ma(o),
  getComponentProps: r = (o) => o
} = {}) => {
  const o = {
    applyAnimatedValues: t,
    createAnimatedStyle: n,
    getComponentProps: r
  }, i = (a) => {
    const s = Jf(a) || "Anonymous";
    return h1.str(a) ? a = i[a] || (i[a] = Xf(a, o)) : a = a[Qf] || (a[Qf] = Xf(a, o)), a.displayName = `Animated(${s})`, a;
  };
  return At(e, (a, s) => {
    h1.arr(e) && (s = Jf(a)), i[s] = i(a);
  }), {
    animated: i
  };
}, Jf = (e) => h1.str(e) ? e : e && h1.str(e.displayName) ? e.displayName : h1.fun(e) && e.name || null;
function F2(e, ...t) {
  return h1.fun(e) ? e(...t) : e;
}
var er = (e, t) => e === !0 || !!(t && e && (h1.fun(e) ? e(t) : P2(e).includes(t))), mx = (e, t) => h1.obj(e) ? t && e[t] : e, gx = (e, t) => e.default === !0 ? e[t] : e.default ? e.default[t] : void 0, _W = (e) => e, ka = (e, t = _W) => {
  let n = xW;
  e.default && e.default !== !0 && (e = e.default, n = Object.keys(e));
  const r = {};
  for (const o of n) {
    const i = t(e[o], o);
    h1.und(i) || (r[o] = i);
  }
  return r;
}, xW = [
  "config",
  "onProps",
  "onStart",
  "onChange",
  "onPause",
  "onResume",
  "onRest"
], SW = {
  config: 1,
  from: 1,
  to: 1,
  ref: 1,
  loop: 1,
  reset: 1,
  pause: 1,
  cancel: 1,
  reverse: 1,
  immediate: 1,
  default: 1,
  delay: 1,
  onProps: 1,
  onStart: 1,
  onChange: 1,
  onPause: 1,
  onResume: 1,
  onRest: 1,
  onResolve: 1,
  // Transition props
  items: 1,
  trail: 1,
  sort: 1,
  expires: 1,
  initial: 1,
  enter: 1,
  update: 1,
  leave: 1,
  children: 1,
  onDestroyed: 1,
  // Internal props
  keys: 1,
  callId: 1,
  parentId: 1
};
function MW(e) {
  const t = {};
  let n = 0;
  if (At(e, (r, o) => {
    SW[o] || (t[o] = r, n++);
  }), n)
    return t;
}
function md(e) {
  const t = MW(e);
  if (t) {
    const n = { to: t };
    return At(e, (r, o) => o in t || (n[o] = r)), n;
  }
  return { ...e };
}
function vr(e) {
  return e = B2(e), h1.arr(e) ? e.map(vr) : xa(e) ? vt.createStringInterpolator({
    range: [0, 1],
    output: [e, e]
  })(1) : e;
}
function vx(e) {
  for (const t in e)
    return !0;
  return !1;
}
function hu(e) {
  return h1.fun(e) || h1.arr(e) && h1.obj(e[0]);
}
function pu(e, t) {
  e.ref?.delete(e), t?.delete(e);
}
function bx(e, t) {
  t && e.ref !== t && (e.ref?.delete(e), t.add(e), e.ref = t);
}
var gd = {
  default: { tension: 170, friction: 26 },
  gentle: { tension: 120, friction: 14 },
  wobbly: { tension: 180, friction: 12 },
  stiff: { tension: 210, friction: 20 },
  slow: { tension: 280, friction: 60 },
  molasses: { tension: 280, friction: 120 }
}, mu = {
  ...gd.default,
  mass: 1,
  damping: 1,
  easing: tW.linear,
  clamp: !1
}, kW = class {
  constructor() {
    this.velocity = 0, Object.assign(this, mu);
  }
};
function LW(e, t, n) {
  n && (n = { ...n }, e8(n, t), t = { ...n, ...t }), e8(e, t), Object.assign(e, t);
  for (const a in mu)
    e[a] == null && (e[a] = mu[a]);
  let { frequency: r, damping: o } = e;
  const { mass: i } = e;
  return h1.und(r) || (r < 0.01 && (r = 0.01), o < 0 && (o = 0), e.tension = Math.pow(2 * Math.PI / r, 2) * i, e.friction = 4 * Math.PI * o * i / r), e;
}
function e8(e, t) {
  if (!h1.und(t.decay))
    e.duration = void 0;
  else {
    const n = !h1.und(t.tension) || !h1.und(t.friction);
    (n || !h1.und(t.frequency) || !h1.und(t.damping) || !h1.und(t.mass)) && (e.duration = void 0, e.decay = void 0), n && (e.frequency = void 0);
  }
}
var t8 = [], EW = class {
  constructor() {
    this.changed = !1, this.values = t8, this.toValues = null, this.fromValues = t8, this.config = new kW(), this.immediate = !1;
  }
};
function yx(e, { key: t, props: n, defaultProps: r, state: o, actions: i }) {
  return new Promise((a, s) => {
    let l, c, f = er(n.cancel ?? r?.cancel, t);
    if (f)
      p();
    else {
      h1.und(n.pause) || (o.paused = er(n.pause, t));
      let g = r?.pause;
      g !== !0 && (g = o.paused || er(g, t)), l = F2(n.delay || 0, t), g ? (o.resumeQueue.add(h), i.pause()) : (i.resume(), h());
    }
    function u() {
      o.resumeQueue.add(h), o.timeouts.delete(c), c.cancel(), l = c.time - z1.now();
    }
    function h() {
      l > 0 && !vt.skipAnimation ? (o.delayed = !0, c = z1.setTimeout(p, l), o.pauseQueue.add(u), o.timeouts.add(c)) : p();
    }
    function p() {
      o.delayed && (o.delayed = !1), o.pauseQueue.delete(u), o.timeouts.delete(c), e <= (o.cancelId || 0) && (f = !0);
      try {
        i.start({ ...n, callId: e, cancel: f }, a);
      } catch (g) {
        s(g);
      }
    }
  });
}
var vd = (e, t) => t.length == 1 ? t[0] : t.some((n) => n.cancelled) ? B3(e.get()) : t.every((n) => n.noop) ? Cx(e.get()) : ct(
  e.get(),
  t.every((n) => n.finished)
), Cx = (e) => ({
  value: e,
  noop: !0,
  finished: !0,
  cancelled: !1
}), ct = (e, t, n = !1) => ({
  value: e,
  finished: t,
  cancelled: n
}), B3 = (e) => ({
  value: e,
  cancelled: !0,
  finished: !1
});
function wx(e, t, n, r) {
  const { callId: o, parentId: i, onRest: a } = t, { asyncTo: s, promise: l } = n;
  return !i && e === s && !t.reset ? l : n.promise = (async () => {
    n.asyncId = o, n.asyncTo = e;
    const c = ka(
      t,
      (b, y) => (
        // The `onRest` prop is only called when the `runAsync` promise is resolved.
        y === "onRest" ? void 0 : b
      )
    );
    let f, u;
    const h = new Promise(
      (b, y) => (f = b, u = y)
    ), p = (b) => {
      const y = (
        // The `cancel` prop or `stop` method was used.
        o <= (n.cancelId || 0) && B3(r) || // The async `to` prop was replaced.
        o !== n.asyncId && ct(r, !1)
      );
      if (y)
        throw b.result = y, u(b), b;
    }, g = (b, y) => {
      const C = new n8(), _ = new r8();
      return (async () => {
        if (vt.skipAnimation)
          throw br(n), _.result = ct(r, !1), u(_), _;
        p(C);
        const M = h1.obj(b) ? { ...b } : { ...y, to: b };
        M.parentId = o, At(c, (k, L) => {
          h1.und(M[L]) && (M[L] = k);
        });
        const S = await r.start(M);
        return p(C), n.paused && await new Promise((k) => {
          n.resumeQueue.add(k);
        }), S;
      })();
    };
    let m;
    if (vt.skipAnimation)
      return br(n), ct(r, !1);
    try {
      let b;
      h1.arr(e) ? b = (async (y) => {
        for (const C of y)
          await g(C);
      })(e) : b = Promise.resolve(e(g, r.stop.bind(r))), await Promise.all([b.then(f), h]), m = ct(r.get(), !0, !1);
    } catch (b) {
      if (b instanceof n8)
        m = b.result;
      else if (b instanceof r8)
        m = b.result;
      else
        throw b;
    } finally {
      o == n.asyncId && (n.asyncId = i, n.asyncTo = i ? s : void 0, n.promise = i ? l : void 0);
    }
    return h1.fun(a) && z1.batchedUpdates(() => {
      a(m, r, r.item);
    }), m;
  })();
}
function br(e, t) {
  Qn(e.timeouts, (n) => n.cancel()), e.pauseQueue.clear(), e.resumeQueue.clear(), e.asyncId = e.asyncTo = e.promise = void 0, t && (e.cancelId = t);
}
var n8 = class extends Error {
  constructor() {
    super(
      "An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise."
    );
  }
}, r8 = class extends Error {
  constructor() {
    super("SkipAnimationSignal");
  }
}, gu = (e) => e instanceof bd, TW = 1, bd = class extends lx {
  constructor() {
    super(...arguments), this.id = TW++, this._priority = 0;
  }
  get priority() {
    return this._priority;
  }
  set priority(e) {
    this._priority != e && (this._priority = e, this._onPriorityChange(e));
  }
  /** Get the current value */
  get() {
    const e = xt(this);
    return e && e.getValue();
  }
  /** Create a spring that maps our value to another value */
  to(...e) {
    return vt.to(this, e);
  }
  /** @deprecated Use the `to` method instead. */
  interpolate(...e) {
    return cW(), vt.to(this, e);
  }
  toJSON() {
    return this.get();
  }
  observerAdded(e) {
    e == 1 && this._attach();
  }
  observerRemoved(e) {
    e == 0 && this._detach();
  }
  /** Called when the first child is added. */
  _attach() {
  }
  /** Called when the last child is removed. */
  _detach() {
  }
  /** Tell our children about our new value */
  _onChange(e, t = !1) {
    hr(this, {
      type: "change",
      parent: this,
      value: e,
      idle: t
    });
  }
  /** Tell our children about our new priority */
  _onPriorityChange(e) {
    this.idle || Ca.sort(this), hr(this, {
      type: "priority",
      parent: this,
      priority: e
    });
  }
}, t3 = Symbol.for("SpringPhase"), _x = 1, xx = 2, Sx = 4, u4 = (e) => (e[t3] & _x) > 0, h0 = (e) => (e[t3] & xx) > 0, Ln = (e) => (e[t3] & Sx) > 0, o8 = (e, t) => t ? e[t3] |= xx | _x : e[t3] &= -3, i8 = (e, t) => t ? e[t3] |= Sx : e[t3] &= -5, RW = class extends bd {
  constructor(e, t) {
    if (super(), this.animation = new EW(), this.defaultProps = {}, this._state = {
      paused: !1,
      delayed: !1,
      pauseQueue: /* @__PURE__ */ new Set(),
      resumeQueue: /* @__PURE__ */ new Set(),
      timeouts: /* @__PURE__ */ new Set()
    }, this._pendingCalls = /* @__PURE__ */ new Set(), this._lastCallId = 0, this._lastToId = 0, this._memoizedDuration = 0, !h1.und(e) || !h1.und(t)) {
      const n = h1.obj(e) ? { ...e } : { ...t, from: e };
      h1.und(n.default) && (n.default = !0), this.start(n);
    }
  }
  /** Equals true when not advancing on each frame. */
  get idle() {
    return !(h0(this) || this._state.asyncTo) || Ln(this);
  }
  get goal() {
    return B2(this.animation.to);
  }
  get velocity() {
    const e = xt(this);
    return e instanceof eo ? e.lastVelocity || 0 : e.getPayload().map((t) => t.lastVelocity || 0);
  }
  /**
   * When true, this value has been animated at least once.
   */
  get hasAnimated() {
    return u4(this);
  }
  /**
   * When true, this value has an unfinished animation,
   * which is either active or paused.
   */
  get isAnimating() {
    return h0(this);
  }
  /**
   * When true, all current and future animations are paused.
   */
  get isPaused() {
    return Ln(this);
  }
  /**
   *
   *
   */
  get isDelayed() {
    return this._state.delayed;
  }
  /** Advance the current animation by a number of milliseconds */
  advance(e) {
    let t = !0, n = !1;
    const r = this.animation;
    let { toValues: o } = r;
    const { config: i } = r, a = Sa(r.to);
    !a && K2(r.to) && (o = P2(B2(r.to))), r.values.forEach((c, f) => {
      if (c.done)
        return;
      const u = (
        // Animated strings always go from 0 to 1.
        c.constructor == gr ? 1 : a ? a[f].lastPosition : o[f]
      );
      let h = r.immediate, p = u;
      if (!h) {
        if (p = c.lastPosition, i.tension <= 0) {
          c.done = !0;
          return;
        }
        let g = c.elapsedTime += e;
        const m = r.fromValues[f], b = c.v0 != null ? c.v0 : c.v0 = h1.arr(i.velocity) ? i.velocity[f] : i.velocity;
        let y;
        const C = i.precision || (m == u ? 5e-3 : Math.min(1, Math.abs(u - m) * 1e-3));
        if (h1.und(i.duration))
          if (i.decay) {
            const _ = i.decay === !0 ? 0.998 : i.decay, M = Math.exp(-(1 - _) * g);
            p = m + b / (1 - _) * (1 - M), h = Math.abs(c.lastPosition - p) <= C, y = b * M;
          } else {
            y = c.lastVelocity == null ? b : c.lastVelocity;
            const _ = i.restVelocity || C / 10, M = i.clamp ? 0 : i.bounce, S = !h1.und(M), k = m == u ? c.v0 > 0 : m < u;
            let L, P = !1;
            const I = 1, O = Math.ceil(e / I);
            for (let E = 0; E < O && (L = Math.abs(y) > _, !(!L && (h = Math.abs(u - p) <= C, h))); ++E) {
              S && (P = p == u || p > u == k, P && (y = -y * M, p = u));
              const B = -i.tension * 1e-6 * (p - u), W = -i.friction * 1e-3 * y, F = (B + W) / i.mass;
              y = y + F * I, p = p + y * I;
            }
          }
        else {
          let _ = 1;
          i.duration > 0 && (this._memoizedDuration !== i.duration && (this._memoizedDuration = i.duration, c.durationProgress > 0 && (c.elapsedTime = i.duration * c.durationProgress, g = c.elapsedTime += e)), _ = (i.progress || 0) + g / this._memoizedDuration, _ = _ > 1 ? 1 : _ < 0 ? 0 : _, c.durationProgress = _), p = m + i.easing(_) * (u - m), y = (p - c.lastPosition) / e, h = _ == 1;
        }
        c.lastVelocity = y, Number.isNaN(p) && (console.warn("Got NaN while animating:", this), h = !0);
      }
      a && !a[f].done && (h = !1), h ? c.done = !0 : t = !1, c.setValue(p, i.round) && (n = !0);
    });
    const s = xt(this), l = s.getValue();
    if (t) {
      const c = B2(r.to);
      (l !== c || n) && !i.decay ? (s.setValue(c), this._onChange(c)) : n && i.decay && this._onChange(l), this._stop();
    } else n && this._onChange(l);
  }
  /** Set the current value, while stopping the current animation */
  set(e) {
    return z1.batchedUpdates(() => {
      this._stop(), this._focus(e), this._set(e);
    }), this;
  }
  /**
   * Freeze the active animation in time, as well as any updates merged
   * before `resume` is called.
   */
  pause() {
    this._update({ pause: !0 });
  }
  /** Resume the animation if paused. */
  resume() {
    this._update({ pause: !1 });
  }
  /** Skip to the end of the current animation. */
  finish() {
    if (h0(this)) {
      const { to: e, config: t } = this.animation;
      z1.batchedUpdates(() => {
        this._onStart(), t.decay || this._set(e, !1), this._stop();
      });
    }
    return this;
  }
  /** Push props into the pending queue. */
  update(e) {
    return (this.queue || (this.queue = [])).push(e), this;
  }
  start(e, t) {
    let n;
    return h1.und(e) ? (n = this.queue || [], this.queue = []) : n = [h1.obj(e) ? e : { ...t, to: e }], Promise.all(
      n.map((r) => this._update(r))
    ).then((r) => vd(this, r));
  }
  /**
   * Stop the current animation, and cancel any delayed updates.
   *
   * Pass `true` to call `onRest` with `cancelled: true`.
   */
  stop(e) {
    const { to: t } = this.animation;
    return this._focus(this.get()), br(this._state, e && this._lastCallId), z1.batchedUpdates(() => this._stop(t, e)), this;
  }
  /** Restart the animation. */
  reset() {
    this._update({ reset: !0 });
  }
  /** @internal */
  eventObserved(e) {
    e.type == "change" ? this._start() : e.type == "priority" && (this.priority = e.priority + 1);
  }
  /**
   * Parse the `to` and `from` range from the given `props` object.
   *
   * This also ensures the initial value is available to animated components
   * during the render phase.
   */
  _prepareNode(e) {
    const t = this.key || "";
    let { to: n, from: r } = e;
    n = h1.obj(n) ? n[t] : n, (n == null || hu(n)) && (n = void 0), r = h1.obj(r) ? r[t] : r, r == null && (r = void 0);
    const o = { to: n, from: r };
    return u4(this) || (e.reverse && ([n, r] = [r, n]), r = B2(r), h1.und(r) ? xt(this) || this._set(n) : this._set(r)), o;
  }
  /** Every update is processed by this method before merging. */
  _update({ ...e }, t) {
    const { key: n, defaultProps: r } = this;
    e.default && Object.assign(
      r,
      ka(
        e,
        (a, s) => /^on/.test(s) ? mx(a, n) : a
      )
    ), s8(this, e, "onProps"), Tn(this, "onProps", e, this);
    const o = this._prepareNode(e);
    if (Object.isFrozen(this))
      throw Error(
        "Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?"
      );
    const i = this._state;
    return yx(++this._lastCallId, {
      key: n,
      props: e,
      defaultProps: r,
      state: i,
      actions: {
        pause: () => {
          Ln(this) || (i8(this, !0), Un(i.pauseQueue), Tn(
            this,
            "onPause",
            ct(this, En(this, this.animation.to)),
            this
          ));
        },
        resume: () => {
          Ln(this) && (i8(this, !1), h0(this) && this._resume(), Un(i.resumeQueue), Tn(
            this,
            "onResume",
            ct(this, En(this, this.animation.to)),
            this
          ));
        },
        start: this._merge.bind(this, o)
      }
    }).then((a) => {
      if (e.loop && a.finished && !(t && a.noop)) {
        const s = Mx(e);
        if (s)
          return this._update(s, !0);
      }
      return a;
    });
  }
  /** Merge props into the current animation */
  _merge(e, t, n) {
    if (t.cancel)
      return this.stop(!0), n(B3(this));
    const r = !h1.und(e.to), o = !h1.und(e.from);
    if (r || o)
      if (t.callId > this._lastToId)
        this._lastToId = t.callId;
      else
        return n(B3(this));
    const { key: i, defaultProps: a, animation: s } = this, { to: l, from: c } = s;
    let { to: f = l, from: u = c } = e;
    o && !r && (!t.default || h1.und(f)) && (f = u), t.reverse && ([f, u] = [u, f]);
    const h = !Gt(u, c);
    h && (s.from = u), u = B2(u);
    const p = !Gt(f, l);
    p && this._focus(f);
    const g = hu(t.to), { config: m } = s, { decay: b, velocity: y } = m;
    (r || o) && (m.velocity = 0), t.config && !g && LW(
      m,
      F2(t.config, i),
      // Avoid calling the same "config" prop twice.
      t.config !== a.config ? F2(a.config, i) : void 0
    );
    let C = xt(this);
    if (!C || h1.und(f))
      return n(ct(this, !0));
    const _ = (
      // When `reset` is undefined, the `from` prop implies `reset: true`,
      // except for declarative updates. When `reset` is defined, there
      // must exist a value to animate from.
      h1.und(t.reset) ? o && !t.default : !h1.und(u) && er(t.reset, i)
    ), M = _ ? u : this.get(), S = vr(f), k = h1.num(S) || h1.arr(S) || xa(S), L = !g && (!k || er(a.immediate || t.immediate, i));
    if (p) {
      const E = fu(f);
      if (E !== C.constructor)
        if (L)
          C = this._set(S);
        else
          throw Error(
            `Cannot animate between ${C.constructor.name} and ${E.name}, as the "to" prop suggests`
          );
    }
    const P = C.constructor;
    let I = K2(f), O = !1;
    if (!I) {
      const E = _ || !u4(this) && h;
      (p || E) && (O = Gt(vr(M), S), I = !O), (!Gt(s.immediate, L) && !L || !Gt(m.decay, b) || !Gt(m.velocity, y)) && (I = !0);
    }
    if (O && h0(this) && (s.changed && !_ ? I = !0 : I || this._stop(l)), !g && ((I || K2(l)) && (s.values = C.getPayload(), s.toValues = K2(f) ? null : P == gr ? [1] : P2(S)), s.immediate != L && (s.immediate = L, !L && !_ && this._set(l)), I)) {
      const { onRest: E } = s;
      H1(AW, (W) => s8(this, t, W));
      const B = ct(this, En(this, l));
      Un(this._pendingCalls, B), this._pendingCalls.add(n), s.changed && z1.batchedUpdates(() => {
        s.changed = !_, E?.(B, this), _ ? F2(a.onRest, B) : s.onStart?.(B, this);
      });
    }
    _ && this._set(M), g ? n(wx(t.to, t, this._state, this)) : I ? this._start() : h0(this) && !p ? this._pendingCalls.add(n) : n(Cx(M));
  }
  /** Update the `animation.to` value, which might be a `FluidValue` */
  _focus(e) {
    const t = this.animation;
    e !== t.to && (Zf(this) && this._detach(), t.to = e, Zf(this) && this._attach());
  }
  _attach() {
    let e = 0;
    const { to: t } = this.animation;
    K2(t) && (dn(t, this), gu(t) && (e = t.priority + 1)), this.priority = e;
  }
  _detach() {
    const { to: e } = this.animation;
    K2(e) && pr(e, this);
  }
  /**
   * Update the current value from outside the frameloop,
   * and return the `Animated` node.
   */
  _set(e, t = !0) {
    const n = B2(e);
    if (!h1.und(n)) {
      const r = xt(this);
      if (!r || !Gt(n, r.getValue())) {
        const o = fu(n);
        !r || r.constructor != o ? pd(this, o.create(n)) : r.setValue(n), r && z1.batchedUpdates(() => {
          this._onChange(n, t);
        });
      }
    }
    return xt(this);
  }
  _onStart() {
    const e = this.animation;
    e.changed || (e.changed = !0, Tn(
      this,
      "onStart",
      ct(this, En(this, e.to)),
      this
    ));
  }
  _onChange(e, t) {
    t || (this._onStart(), F2(this.animation.onChange, e, this)), F2(this.defaultProps.onChange, e, this), super._onChange(e, t);
  }
  // This method resets the animation state (even if already animating) to
  // ensure the latest from/to range is used, and it also ensures this spring
  // is added to the frameloop.
  _start() {
    const e = this.animation;
    xt(this).reset(B2(e.to)), e.immediate || (e.fromValues = e.values.map((t) => t.lastPosition)), h0(this) || (o8(this, !0), Ln(this) || this._resume());
  }
  _resume() {
    vt.skipAnimation ? this.finish() : Ca.start(this);
  }
  /**
   * Exit the frameloop and notify `onRest` listeners.
   *
   * Always wrap `_stop` calls with `batchedUpdates`.
   */
  _stop(e, t) {
    if (h0(this)) {
      o8(this, !1);
      const n = this.animation;
      H1(n.values, (o) => {
        o.done = !0;
      }), n.toValues && (n.onChange = n.onPause = n.onResume = void 0), hr(this, {
        type: "idle",
        parent: this
      });
      const r = t ? B3(this.get()) : ct(this.get(), En(this, e ?? n.to));
      Un(this._pendingCalls, r), n.changed && (n.changed = !1, Tn(this, "onRest", r, this));
    }
  }
};
function En(e, t) {
  const n = vr(t), r = vr(e.get());
  return Gt(r, n);
}
function Mx(e, t = e.loop, n = e.to) {
  const r = F2(t);
  if (r) {
    const o = r !== !0 && md(r), i = (o || e).reverse, a = !o || o.reset;
    return yr({
      ...e,
      loop: t,
      // Avoid updating default props when looping.
      default: !1,
      // Never loop the `pause` prop.
      pause: void 0,
      // For the "reverse" prop to loop as expected, the "to" prop
      // must be undefined. The "reverse" prop is ignored when the
      // "to" prop is an array or function.
      to: !i || hu(n) ? n : void 0,
      // Ignore the "from" prop except on reset.
      from: a ? e.from : void 0,
      reset: a,
      // The "loop" prop can return a "useSpring" props object to
      // override any of the original props.
      ...o
    });
  }
}
function yr(e) {
  const { to: t, from: n } = e = md(e), r = /* @__PURE__ */ new Set();
  return h1.obj(t) && a8(t, r), h1.obj(n) && a8(n, r), e.keys = r.size ? Array.from(r) : null, e;
}
function PW(e) {
  const t = yr(e);
  return h1.und(t.default) && (t.default = ka(t)), t;
}
function a8(e, t) {
  At(e, (n, r) => n != null && t.add(r));
}
var AW = [
  "onStart",
  "onRest",
  "onChange",
  "onPause",
  "onResume"
];
function s8(e, t, n) {
  e.animation[n] = t[n] !== gx(t, n) ? mx(t[n], e.key) : void 0;
}
function Tn(e, t, ...n) {
  e.animation[t]?.(...n), e.defaultProps[t]?.(...n);
}
var IW = ["onStart", "onChange", "onRest"], OW = 1, kx = class {
  constructor(e, t) {
    this.id = OW++, this.springs = {}, this.queue = [], this._lastAsyncId = 0, this._active = /* @__PURE__ */ new Set(), this._changed = /* @__PURE__ */ new Set(), this._started = !1, this._state = {
      paused: !1,
      pauseQueue: /* @__PURE__ */ new Set(),
      resumeQueue: /* @__PURE__ */ new Set(),
      timeouts: /* @__PURE__ */ new Set()
    }, this._events = {
      onStart: /* @__PURE__ */ new Map(),
      onChange: /* @__PURE__ */ new Map(),
      onRest: /* @__PURE__ */ new Map()
    }, this._onFrame = this._onFrame.bind(this), t && (this._flush = t), e && this.start({ default: !0, ...e });
  }
  /**
   * Equals `true` when no spring values are in the frameloop, and
   * no async animation is currently active.
   */
  get idle() {
    return !this._state.asyncTo && Object.values(this.springs).every((e) => e.idle && !e.isDelayed && !e.isPaused);
  }
  get item() {
    return this._item;
  }
  set item(e) {
    this._item = e;
  }
  /** Get the current values of our springs */
  get() {
    const e = {};
    return this.each((t, n) => e[n] = t.get()), e;
  }
  /** Set the current values without animating. */
  set(e) {
    for (const t in e) {
      const n = e[t];
      h1.und(n) || this.springs[t].set(n);
    }
  }
  /** Push an update onto the queue of each value. */
  update(e) {
    return e && this.queue.push(yr(e)), this;
  }
  /**
   * Start the queued animations for every spring, and resolve the returned
   * promise once all queued animations have finished or been cancelled.
   *
   * When you pass a queue (instead of nothing), that queue is used instead of
   * the queued animations added with the `update` method, which are left alone.
   */
  start(e) {
    let { queue: t } = this;
    return e ? t = P2(e).map(yr) : this.queue = [], this._flush ? this._flush(this, t) : (Px(this, t), vu(this, t));
  }
  /** @internal */
  stop(e, t) {
    if (e !== !!e && (t = e), t) {
      const n = this.springs;
      H1(P2(t), (r) => n[r].stop(!!e));
    } else
      br(this._state, this._lastAsyncId), this.each((n) => n.stop(!!e));
    return this;
  }
  /** Freeze the active animation in time */
  pause(e) {
    if (h1.und(e))
      this.start({ pause: !0 });
    else {
      const t = this.springs;
      H1(P2(e), (n) => t[n].pause());
    }
    return this;
  }
  /** Resume the animation if paused. */
  resume(e) {
    if (h1.und(e))
      this.start({ pause: !1 });
    else {
      const t = this.springs;
      H1(P2(e), (n) => t[n].resume());
    }
    return this;
  }
  /** Call a function once per spring value */
  each(e) {
    At(this.springs, e);
  }
  /** @internal Called at the end of every animation frame */
  _onFrame() {
    const { onStart: e, onChange: t, onRest: n } = this._events, r = this._active.size > 0, o = this._changed.size > 0;
    (r && !this._started || o && !this._started) && (this._started = !0, Qn(e, ([s, l]) => {
      l.value = this.get(), s(l, this, this._item);
    }));
    const i = !r && this._started, a = o || i && n.size ? this.get() : null;
    o && t.size && Qn(t, ([s, l]) => {
      l.value = a, s(l, this, this._item);
    }), i && (this._started = !1, Qn(n, ([s, l]) => {
      l.value = a, s(l, this, this._item);
    }));
  }
  /** @internal */
  eventObserved(e) {
    if (e.type == "change")
      this._changed.add(e.parent), e.idle || this._active.add(e.parent);
    else if (e.type == "idle")
      this._active.delete(e.parent);
    else
      return;
    z1.onFrame(this._onFrame);
  }
};
function vu(e, t) {
  return Promise.all(t.map((n) => Lx(e, n))).then(
    (n) => vd(e, n)
  );
}
async function Lx(e, t, n) {
  const { keys: r, to: o, from: i, loop: a, onRest: s, onResolve: l } = t, c = h1.obj(t.default) && t.default;
  a && (t.loop = !1), o === !1 && (t.to = null), i === !1 && (t.from = null);
  const f = h1.arr(o) || h1.fun(o) ? o : void 0;
  f ? (t.to = void 0, t.onRest = void 0, c && (c.onRest = void 0)) : H1(IW, (m) => {
    const b = t[m];
    if (h1.fun(b)) {
      const y = e._events[m];
      t[m] = ({ finished: C, cancelled: _ }) => {
        const M = y.get(b);
        M ? (C || (M.finished = !1), _ && (M.cancelled = !0)) : y.set(b, {
          value: null,
          finished: C || !1,
          cancelled: _ || !1
        });
      }, c && (c[m] = t[m]);
    }
  });
  const u = e._state;
  t.pause === !u.paused ? (u.paused = t.pause, Un(t.pause ? u.pauseQueue : u.resumeQueue)) : u.paused && (t.pause = !0);
  const h = (r || Object.keys(e.springs)).map(
    (m) => e.springs[m].start(t)
  ), p = t.cancel === !0 || gx(t, "cancel") === !0;
  (f || p && u.asyncId) && h.push(
    yx(++e._lastAsyncId, {
      props: t,
      state: u,
      actions: {
        pause: cu,
        resume: cu,
        start(m, b) {
          p ? (br(u, e._lastAsyncId), b(B3(e))) : (m.onRest = s, b(
            wx(
              f,
              m,
              u,
              e
            )
          ));
        }
      }
    })
  ), u.paused && await new Promise((m) => {
    u.resumeQueue.add(m);
  });
  const g = vd(e, await Promise.all(h));
  if (a && g.finished && !(n && g.noop)) {
    const m = Mx(t, a, o);
    if (m)
      return Px(e, [m]), Lx(e, m, !0);
  }
  return l && z1.batchedUpdates(() => l(g, e, e.item)), g;
}
function bu(e, t) {
  const n = { ...e.springs };
  return t && H1(P2(t), (r) => {
    h1.und(r.keys) && (r = yr(r)), h1.obj(r.to) || (r = { ...r, to: void 0 }), Rx(n, r, (o) => Tx(o));
  }), Ex(e, n), n;
}
function Ex(e, t) {
  At(t, (n, r) => {
    e.springs[r] || (e.springs[r] = n, dn(n, e));
  });
}
function Tx(e, t) {
  const n = new RW();
  return n.key = e, t && dn(n, t), n;
}
function Rx(e, t, n) {
  t.keys && H1(t.keys, (r) => {
    (e[r] || (e[r] = n(r)))._prepareNode(t);
  });
}
function Px(e, t) {
  H1(t, (n) => {
    Rx(e.springs, n, (r) => Tx(r, e));
  });
}
var to = ({
  children: e,
  ...t
}) => {
  const n = Rt(si), r = t.pause || !!n.pause, o = t.immediate || !!n.immediate;
  t = hW(() => ({ pause: r, immediate: o }), [r, o]);
  const { Provider: i } = si;
  return /* @__PURE__ */ d.createElement(i, { value: t }, e);
}, si = NW(to, {});
to.Provider = si.Provider;
to.Consumer = si.Consumer;
function NW(e, t) {
  return Object.assign(e, d.createContext(t)), e.Provider._context = e, e.Consumer._context = e, e;
}
var Ax = () => {
  const e = [], t = function(r) {
    dW();
    const o = [];
    return H1(e, (i, a) => {
      if (h1.und(r))
        o.push(i.start());
      else {
        const s = n(r, i, a);
        s && o.push(i.start(s));
      }
    }), o;
  };
  t.current = e, t.add = function(r) {
    e.includes(r) || e.push(r);
  }, t.delete = function(r) {
    const o = e.indexOf(r);
    ~o && e.splice(o, 1);
  }, t.pause = function() {
    return H1(e, (r) => r.pause(...arguments)), this;
  }, t.resume = function() {
    return H1(e, (r) => r.resume(...arguments)), this;
  }, t.set = function(r) {
    H1(e, (o, i) => {
      const a = h1.fun(r) ? r(i, o) : r;
      a && o.set(a);
    });
  }, t.start = function(r) {
    const o = [];
    return H1(e, (i, a) => {
      if (h1.und(r))
        o.push(i.start());
      else {
        const s = this._getProps(r, i, a);
        s && o.push(i.start(s));
      }
    }), o;
  }, t.stop = function() {
    return H1(e, (r) => r.stop(...arguments)), this;
  }, t.update = function(r) {
    return H1(e, (o, i) => o.update(this._getProps(r, o, i))), this;
  };
  const n = function(r, o, i) {
    return h1.fun(r) ? r(i, o) : r;
  };
  return t._getProps = n, t;
};
function DW(e, t, n) {
  const r = h1.fun(t) && t;
  r && !n && (n = []);
  const o = j1(
    () => r || arguments.length == 3 ? Ax() : void 0,
    []
  ), i = Be(0), a = fd(), s = j1(
    () => ({
      ctrls: [],
      queue: [],
      flush(y, C) {
        const _ = bu(y, C);
        return i.current > 0 && !s.queue.length && !Object.keys(_).some((S) => !y.springs[S]) ? vu(y, C) : new Promise((S) => {
          Ex(y, _), s.queue.push(() => {
            S(vu(y, C));
          }), a();
        });
      }
    }),
    []
  ), l = Be([...s.ctrls]), c = [], f = du(e) || 0;
  j1(() => {
    H1(l.current.slice(e, f), (y) => {
      pu(y, o), y.stop(!0);
    }), l.current.length = e, u(f, e);
  }, [e]), j1(() => {
    u(0, Math.min(f, e));
  }, n);
  function u(y, C) {
    for (let _ = y; _ < C; _++) {
      const M = l.current[_] || (l.current[_] = new kx(null, s.flush)), S = r ? r(_, M) : t[_];
      S && (c[_] = PW(S));
    }
  }
  const h = l.current.map((y, C) => bu(y, c[C])), p = Rt(to), g = du(p), m = p !== g && vx(p);
  H0(() => {
    i.current++, s.ctrls = l.current;
    const { queue: y } = s;
    y.length && (s.queue = [], H1(y, (C) => C())), H1(l.current, (C, _) => {
      o?.add(C), m && C.start({ default: p });
      const M = c[_];
      M && (bx(C, M.ref), C.ref ? C.queue.push(M) : C.start(M));
    });
  }), hd(() => () => {
    H1(s.ctrls, (y) => y.stop(!0));
  });
  const b = h.map((y) => ({ ...y }));
  return o ? [b, o] : b;
}
function Ft(e, t) {
  const n = h1.fun(e), [[r], o] = DW(
    1,
    n ? e : [e],
    n ? [] : t
  );
  return n || arguments.length == 2 ? [r, o] : r;
}
function La(e, t, n) {
  const r = h1.fun(t) && t, {
    reset: o,
    sort: i,
    trail: a = 0,
    expires: s = !0,
    exitBeforeEnter: l = !1,
    onDestroyed: c,
    ref: f,
    config: u
  } = r ? r() : t, h = j1(
    () => r || arguments.length == 3 ? Ax() : void 0,
    []
  ), p = P2(e), g = [], m = Be(null), b = o ? null : m.current;
  H0(() => {
    m.current = g;
  }), hd(() => (H1(g, (F) => {
    h?.add(F.ctrl), F.ctrl.ref = h;
  }), () => {
    H1(m.current, (F) => {
      F.expired && clearTimeout(F.expirationId), pu(F.ctrl, h), F.ctrl.stop(!0);
    });
  }));
  const y = FW(p, r ? r() : t, b), C = o && m.current || [];
  H0(
    () => H1(C, ({ ctrl: F, item: z, key: D }) => {
      pu(F, h), F2(c, z, D);
    })
  );
  const _ = [];
  if (b && H1(b, (F, z) => {
    F.expired ? (clearTimeout(F.expirationId), C.push(F)) : (z = _[z] = y.indexOf(F.key), ~z && (g[z] = F));
  }), H1(p, (F, z) => {
    g[z] || (g[z] = {
      key: y[z],
      item: F,
      phase: "mount",
      ctrl: new kx()
    }, g[z].ctrl.item = F);
  }), _.length) {
    let F = -1;
    const { leave: z } = r ? r() : t;
    H1(_, (D, Z) => {
      const U = b[Z];
      ~D ? (F = g.indexOf(U), g[F] = { ...U, item: p[D] }) : z && g.splice(++F, 0, U);
    });
  }
  h1.fun(i) && g.sort((F, z) => i(F.item, z.item));
  let M = -a;
  const S = fd(), k = ka(t), L = /* @__PURE__ */ new Map(), P = Be(/* @__PURE__ */ new Map()), I = Be(!1);
  H1(g, (F, z) => {
    const D = F.key, Z = F.phase, U = r ? r() : t;
    let $, q;
    const K = F2(U.delay || 0, D);
    if (Z == "mount")
      $ = U.enter, q = "enter";
    else {
      const r1 = y.indexOf(D) < 0;
      if (Z != "leave")
        if (r1)
          $ = U.leave, q = "leave";
        else if ($ = U.update)
          q = "update";
        else
          return;
      else if (!r1)
        $ = U.enter, q = "enter";
      else
        return;
    }
    if ($ = F2($, F.item, z), $ = h1.obj($) ? md($) : { to: $ }, !$.config) {
      const r1 = u || k.config;
      $.config = F2(r1, F.item, z, q);
    }
    M += a;
    const V = {
      ...k,
      // we need to add our props.delay value you here.
      delay: K + M,
      ref: f,
      immediate: U.immediate,
      // This prevents implied resets.
      reset: !1,
      // Merge any phase-specific props.
      ...$
    };
    if (q == "enter" && h1.und(V.from)) {
      const r1 = r ? r() : t, X = h1.und(r1.initial) || b ? r1.from : r1.initial;
      V.from = F2(X, F.item, z);
    }
    const { onResolve: n1 } = V;
    V.onResolve = (r1) => {
      F2(n1, r1);
      const X = m.current, Y = X.find((Q) => Q.key === D);
      if (Y && !(r1.cancelled && Y.phase != "update") && Y.ctrl.idle) {
        const Q = X.every((N) => N.ctrl.idle);
        if (Y.phase == "leave") {
          const N = F2(s, Y.item);
          if (N !== !1) {
            const j = N === !0 ? 0 : N;
            if (Y.expired = !0, !Q && j > 0) {
              j <= 2147483647 && (Y.expirationId = setTimeout(S, j));
              return;
            }
          }
        }
        Q && X.some((N) => N.expired) && (P.current.delete(Y), l && (I.current = !0), S());
      }
    };
    const o1 = bu(F.ctrl, V);
    q === "leave" && l ? P.current.set(F, { phase: q, springs: o1, payload: V }) : L.set(F, { phase: q, springs: o1, payload: V });
  });
  const O = Rt(to), E = du(O), B = O !== E && vx(O);
  H0(() => {
    B && H1(g, (F) => {
      F.ctrl.start({ default: O });
    });
  }, [O]), H1(L, (F, z) => {
    if (P.current.size) {
      const D = g.findIndex((Z) => Z.key === z.key);
      g.splice(D, 1);
    }
  }), H0(
    () => {
      H1(
        P.current.size ? P.current : L,
        ({ phase: F, payload: z }, D) => {
          const { ctrl: Z } = D;
          D.phase = F, h?.add(Z), B && F == "enter" && Z.start({ default: O }), z && (bx(Z, z.ref), (Z.ref || h) && !I.current ? Z.update(z) : (Z.start(z), I.current && (I.current = !1)));
        }
      );
    },
    o ? void 0 : n
  );
  const W = (F) => /* @__PURE__ */ d.createElement(d.Fragment, null, g.map((z, D) => {
    const { springs: Z } = L.get(z) || z.ctrl, U = F({ ...Z }, z.item, z, D);
    return U && U.type ? /* @__PURE__ */ d.createElement(
      U.type,
      {
        ...U.props,
        key: h1.str(z.key) || h1.num(z.key) ? z.key : z.ctrl.id,
        ref: U.ref
      }
    ) : U;
  }));
  return h ? [W, h] : W;
}
var BW = 1;
function FW(e, { key: t, keys: n = t }, r) {
  if (n === null) {
    const o = /* @__PURE__ */ new Set();
    return e.map((i) => {
      const a = r && r.find(
        (s) => s.item === i && s.phase !== "leave" && !o.has(s)
      );
      return a ? (o.add(a), a.key) : BW++;
    });
  }
  return h1.und(n) ? e : h1.fun(n) ? e.map(n) : P2(n);
}
var Ix = class extends bd {
  constructor(e, t) {
    super(), this.source = e, this.idle = !0, this._active = /* @__PURE__ */ new Set(), this.calc = dr(...t);
    const n = this._get(), r = fu(n);
    pd(this, r.create(n));
  }
  advance(e) {
    const t = this._get(), n = this.get();
    Gt(t, n) || (xt(this).setValue(t), this._onChange(t, this.idle)), !this.idle && l8(this._active) && d4(this);
  }
  _get() {
    const e = h1.arr(this.source) ? this.source.map(B2) : P2(B2(this.source));
    return this.calc(...e);
  }
  _start() {
    this.idle && !l8(this._active) && (this.idle = !1, H1(Sa(this), (e) => {
      e.done = !1;
    }), vt.skipAnimation ? (z1.batchedUpdates(() => this.advance()), d4(this)) : Ca.start(this));
  }
  // Observe our sources only when we're observed.
  _attach() {
    let e = 1;
    H1(P2(this.source), (t) => {
      K2(t) && dn(t, this), gu(t) && (t.idle || this._active.add(t), e = Math.max(e, t.priority + 1));
    }), this.priority = e, this._start();
  }
  // Stop observing our sources once we have no observers.
  _detach() {
    H1(P2(this.source), (e) => {
      K2(e) && pr(e, this);
    }), this._active.clear(), d4(this);
  }
  /** @internal */
  eventObserved(e) {
    e.type == "change" ? e.idle ? this.advance() : (this._active.add(e.parent), this._start()) : e.type == "idle" ? this._active.delete(e.parent) : e.type == "priority" && (this.priority = P2(this.source).reduce(
      (t, n) => Math.max(t, (gu(n) ? n.priority : 0) + 1),
      0
    ));
  }
};
function $W(e) {
  return e.idle !== !1;
}
function l8(e) {
  return !e.size || Array.from(e).every($W);
}
function d4(e) {
  e.idle || (e.idle = !0, H1(Sa(e), (t) => {
    t.done = !0;
  }), hr(e, {
    type: "idle",
    parent: e
  }));
}
var yu = (e, ...t) => new Ix(e, t);
vt.assign({
  createStringInterpolator: dx,
  to: (e, t) => new Ix(e, t)
});
var Ox = /^--/;
function WW(e, t) {
  return t == null || typeof t == "boolean" || t === "" ? "" : typeof t == "number" && t !== 0 && !Ox.test(e) && !(tr.hasOwnProperty(e) && tr[e]) ? t + "px" : ("" + t).trim();
}
var c8 = {};
function VW(e, t) {
  if (!e.nodeType || !e.setAttribute)
    return !1;
  const n = e.nodeName === "filter" || e.parentNode && e.parentNode.nodeName === "filter", {
    className: r,
    style: o,
    children: i,
    scrollTop: a,
    scrollLeft: s,
    viewBox: l,
    ...c
  } = t, f = Object.values(c), u = Object.keys(c).map(
    (h) => n || e.hasAttribute(h) ? h : c8[h] || (c8[h] = h.replace(
      /([A-Z])/g,
      // Attributes are written in dash case
      (p) => "-" + p.toLowerCase()
    ))
  );
  i !== void 0 && (e.textContent = i);
  for (const h in o)
    if (o.hasOwnProperty(h)) {
      const p = WW(h, o[h]);
      Ox.test(h) ? e.style.setProperty(h, p) : e.style[h] = p;
    }
  u.forEach((h, p) => {
    e.setAttribute(h, f[p]);
  }), r !== void 0 && (e.className = r), a !== void 0 && (e.scrollTop = a), s !== void 0 && (e.scrollLeft = s), l !== void 0 && e.setAttribute("viewBox", l);
}
var tr = {
  animationIterationCount: !0,
  borderImageOutset: !0,
  borderImageSlice: !0,
  borderImageWidth: !0,
  boxFlex: !0,
  boxFlexGroup: !0,
  boxOrdinalGroup: !0,
  columnCount: !0,
  columns: !0,
  flex: !0,
  flexGrow: !0,
  flexPositive: !0,
  flexShrink: !0,
  flexNegative: !0,
  flexOrder: !0,
  gridRow: !0,
  gridRowEnd: !0,
  gridRowSpan: !0,
  gridRowStart: !0,
  gridColumn: !0,
  gridColumnEnd: !0,
  gridColumnSpan: !0,
  gridColumnStart: !0,
  fontWeight: !0,
  lineClamp: !0,
  lineHeight: !0,
  opacity: !0,
  order: !0,
  orphans: !0,
  tabSize: !0,
  widows: !0,
  zIndex: !0,
  zoom: !0,
  // SVG-related properties
  fillOpacity: !0,
  floodOpacity: !0,
  stopOpacity: !0,
  strokeDasharray: !0,
  strokeDashoffset: !0,
  strokeMiterlimit: !0,
  strokeOpacity: !0,
  strokeWidth: !0
}, HW = (e, t) => e + t.charAt(0).toUpperCase() + t.substring(1), jW = ["Webkit", "Ms", "Moz", "O"];
tr = Object.keys(tr).reduce((e, t) => (jW.forEach((n) => e[HW(n, t)] = e[t]), e), tr);
var qW = /^(matrix|translate|scale|rotate|skew)/, zW = /^(translate)/, UW = /^(rotate|skew)/, f4 = (e, t) => h1.num(e) && e !== 0 ? e + t : e, zo = (e, t) => h1.arr(e) ? e.every((n) => zo(n, t)) : h1.num(e) ? e === t : parseFloat(e) === t, GW = class extends Ma {
  constructor({ x: e, y: t, z: n, ...r }) {
    const o = [], i = [];
    (e || t || n) && (o.push([e || 0, t || 0, n || 0]), i.push((a) => [
      `translate3d(${a.map((s) => f4(s, "px")).join(",")})`,
      // prettier-ignore
      zo(a, 0)
    ])), At(r, (a, s) => {
      if (s === "transform")
        o.push([a || ""]), i.push((l) => [l, l === ""]);
      else if (qW.test(s)) {
        if (delete r[s], h1.und(a))
          return;
        const l = zW.test(s) ? "px" : UW.test(s) ? "deg" : "";
        o.push(P2(a)), i.push(
          s === "rotate3d" ? ([c, f, u, h]) => [
            `rotate3d(${c},${f},${u},${f4(h, l)})`,
            zo(h, 0)
          ] : (c) => [
            `${s}(${c.map((f) => f4(f, l)).join(",")})`,
            zo(c, s.startsWith("scale") ? 1 : 0)
          ]
        );
      }
    }), o.length && (r.transform = new YW(o, i)), super(r);
  }
}, YW = class extends lx {
  constructor(e, t) {
    super(), this.inputs = e, this.transforms = t, this._value = null;
  }
  get() {
    return this._value || (this._value = this._get());
  }
  _get() {
    let e = "", t = !0;
    return H1(this.inputs, (n, r) => {
      const o = B2(n[0]), [i, a] = this.transforms[r](
        h1.arr(o) ? o : n.map(B2)
      );
      e += " " + i, t = t && a;
    }), t ? "none" : e;
  }
  // Start observing our inputs once we have an observer.
  observerAdded(e) {
    e == 1 && H1(
      this.inputs,
      (t) => H1(
        t,
        (n) => K2(n) && dn(n, this)
      )
    );
  }
  // Stop observing our inputs once we have no observers.
  observerRemoved(e) {
    e == 0 && H1(
      this.inputs,
      (t) => H1(
        t,
        (n) => K2(n) && pr(n, this)
      )
    );
  }
  eventObserved(e) {
    e.type == "change" && (this._value = null), hr(this, e);
  }
}, ZW = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
];
vt.assign({
  batchedUpdates: RE,
  createStringInterpolator: dx,
  colors: j$
});
var KW = wW(ZW, {
  applyAnimatedValues: VW,
  createAnimatedStyle: (e) => new GW(e),
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getComponentProps: ({ scrollTop: e, scrollLeft: t, ...n }) => n
}), Ye = KW.animated;
function n3() {
  return n3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, n3.apply(this, arguments);
}
var XW = { pointerEvents: "none", position: "absolute", zIndex: 10, top: 0, left: 0 }, u8 = function(e, t) {
  return "translate(" + e + "px, " + t + "px)";
}, Nx = Ne(function(e) {
  var t, n = e.position, r = e.anchor, o = e.children, i = Ue(), a = rt(), s = a.animate, l = a.config, c = AM(), f = c[0], u = c[1], h = Be(!1), p = void 0, g = !1, m = u.width > 0 && u.height > 0, b = Math.round(n[0]), y = Math.round(n[1]);
  m && (r === "top" ? (b -= u.width / 2, y -= u.height + 14) : r === "right" ? (b += 14, y -= u.height / 2) : r === "bottom" ? (b -= u.width / 2, y += 14) : r === "left" ? (b -= u.width + 14, y -= u.height / 2) : r === "center" && (b -= u.width / 2, y -= u.height / 2), p = { transform: u8(b, y) }, h.current || (g = !0), h.current = [b, y]);
  var C = Ft({ to: p, config: l, immediate: !s || g }), _ = n3({}, XW, i.tooltip.wrapper, { transform: (t = C.transform) != null ? t : u8(b, y), opacity: C.transform ? 1 : 0 });
  return v(Ye.div, { ref: f, style: _, children: o });
});
Nx.displayName = "TooltipWrapper";
var Dx = Ne(function(e) {
  var t = e.size, n = t === void 0 ? 12 : t, r = e.color, o = e.style;
  return v("span", { style: n3({ display: "block", width: n, height: n, background: r }, o === void 0 ? {} : o) });
}), yd = Ne(function(e) {
  var t, n = e.id, r = e.value, o = e.format, i = e.enableChip, a = i !== void 0 && i, s = e.color, l = e.renderContent, c = Ue(), f = Lr(o);
  if (typeof l == "function") t = l();
  else {
    var u = r;
    f !== void 0 && u !== void 0 && (u = f(u)), t = s1("div", { style: c.tooltip.basic, children: [a && v(Dx, { color: s, style: c.tooltip.chip }), u !== void 0 ? s1("span", { children: [n, ": ", v("strong", { children: "" + u })] }) : n] });
  }
  return v("div", { style: c.tooltip.container, children: t });
}), QW = { width: "100%", borderCollapse: "collapse" }, Bx = Ne(function(e) {
  var t, n = e.title, r = e.rows, o = r === void 0 ? [] : r, i = e.renderContent, a = Ue();
  return o.length ? (t = typeof i == "function" ? i() : s1("div", { children: [n && n, v("table", { style: n3({}, QW, a.tooltip.table), children: v("tbody", { children: o.map(function(s, l) {
    return v("tr", { children: s.map(function(c, f) {
      return v("td", { style: a.tooltip.tableCell, children: c }, f);
    }) }, l);
  }) }) })] }), v("div", { style: a.tooltip.container, children: t })) : null;
});
Bx.displayName = "TableTooltip";
var Cu = Ne(function(e) {
  var t = e.x0, n = e.x1, r = e.y0, o = e.y1, i = Ue(), a = rt(), s = a.animate, l = a.config, c = j1(function() {
    return n3({}, i.crosshair.line, { pointerEvents: "none" });
  }, [i.crosshair.line]), f = Ft({ x1: t, x2: n, y1: r, y2: o, config: l, immediate: !s });
  return v(Ye.line, n3({}, f, { fill: "none", style: c }));
});
Cu.displayName = "CrosshairLine";
var wu = Ne(function(e) {
  var t, n, r = e.width, o = e.height, i = e.type, a = e.x, s = e.y;
  return i === "cross" ? (t = { x0: a, x1: a, y0: 0, y1: o }, n = { x0: 0, x1: r, y0: s, y1: s }) : i === "top-left" ? (t = { x0: a, x1: a, y0: 0, y1: s }, n = { x0: 0, x1: a, y0: s, y1: s }) : i === "top" ? t = { x0: a, x1: a, y0: 0, y1: s } : i === "top-right" ? (t = { x0: a, x1: a, y0: 0, y1: s }, n = { x0: a, x1: r, y0: s, y1: s }) : i === "right" ? n = { x0: a, x1: r, y0: s, y1: s } : i === "bottom-right" ? (t = { x0: a, x1: a, y0: s, y1: o }, n = { x0: a, x1: r, y0: s, y1: s }) : i === "bottom" ? t = { x0: a, x1: a, y0: s, y1: o } : i === "bottom-left" ? (t = { x0: a, x1: a, y0: s, y1: o }, n = { x0: 0, x1: a, y0: s, y1: s }) : i === "left" ? n = { x0: 0, x1: a, y0: s, y1: s } : i === "x" ? t = { x0: a, x1: a, y0: 0, y1: o } : i === "y" && (n = { x0: 0, x1: r, y0: s, y1: s }), s1(ze, { children: [t && v(Cu, { x0: t.x0, x1: t.x1, y0: t.y0, y1: t.y1 }), n && v(Cu, { x0: n.x0, x1: n.x1, y0: n.y0, y1: n.y1 })] });
});
wu.displayName = "Crosshair";
var Fx = s3({ showTooltipAt: function() {
}, showTooltipFromEvent: function() {
}, hideTooltip: function() {
} }), _u = { isVisible: !1, position: [null, null], content: null, anchor: null }, $x = s3(_u), JW = function(e) {
  var t = d2(_u), n = t[0], r = t[1], o = R1(function(s, l, c) {
    var f = l[0], u = l[1];
    c === void 0 && (c = "top"), r({ isVisible: !0, position: [f, u], anchor: c, content: s });
  }, [r]), i = R1(function(s, l, c) {
    c === void 0 && (c = "top");
    var f = e.current.getBoundingClientRect(), u = e.current.offsetWidth, h = u === f.width ? 1 : u / f.width, p = "touches" in l ? l.touches[0] : l, g = p.clientX, m = p.clientY, b = (g - f.left) * h, y = (m - f.top) * h;
    c !== "left" && c !== "right" || (c = b < f.width / 2 ? "right" : "left"), r({ isVisible: !0, position: [b, y], anchor: c, content: s });
  }, [e, r]), a = R1(function() {
    r(_u);
  }, [r]);
  return { actions: j1(function() {
    return { showTooltipAt: o, showTooltipFromEvent: i, hideTooltip: a };
  }, [o, i, a]), state: n };
}, d3 = function() {
  var e = Rt(Fx);
  if (e === void 0) throw new Error("useTooltip must be used within a TooltipProvider");
  return e;
}, eV = function() {
  var e = Rt($x);
  if (e === void 0) throw new Error("useTooltipState must be used within a TooltipProvider");
  return e;
}, tV = function(e) {
  return e.isVisible;
}, nV = function() {
  var e = eV();
  return tV(e) ? v(Nx, { position: e.position, anchor: e.anchor, children: e.content }) : null;
}, rV = function(e) {
  var t = e.container, n = e.children, r = JW(t), o = r.actions, i = r.state;
  return v(Fx.Provider, { value: o, children: v($x.Provider, { value: i, children: n }) });
}, h4, d8;
function oV() {
  if (d8) return h4;
  d8 = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return h4 = e, h4;
}
var p4, f8;
function no() {
  if (f8) return p4;
  f8 = 1;
  function e(t, n) {
    return t === n || t !== t && n !== n;
  }
  return p4 = e, p4;
}
var m4, h8;
function Ea() {
  if (h8) return m4;
  h8 = 1;
  var e = no();
  function t(n, r) {
    for (var o = n.length; o--; )
      if (e(n[o][0], r))
        return o;
    return -1;
  }
  return m4 = t, m4;
}
var g4, p8;
function iV() {
  if (p8) return g4;
  p8 = 1;
  var e = Ea(), t = Array.prototype, n = t.splice;
  function r(o) {
    var i = this.__data__, a = e(i, o);
    if (a < 0)
      return !1;
    var s = i.length - 1;
    return a == s ? i.pop() : n.call(i, a, 1), --this.size, !0;
  }
  return g4 = r, g4;
}
var v4, m8;
function aV() {
  if (m8) return v4;
  m8 = 1;
  var e = Ea();
  function t(n) {
    var r = this.__data__, o = e(r, n);
    return o < 0 ? void 0 : r[o][1];
  }
  return v4 = t, v4;
}
var b4, g8;
function sV() {
  if (g8) return b4;
  g8 = 1;
  var e = Ea();
  function t(n) {
    return e(this.__data__, n) > -1;
  }
  return b4 = t, b4;
}
var y4, v8;
function lV() {
  if (v8) return y4;
  v8 = 1;
  var e = Ea();
  function t(n, r) {
    var o = this.__data__, i = e(o, n);
    return i < 0 ? (++this.size, o.push([n, r])) : o[i][1] = r, this;
  }
  return y4 = t, y4;
}
var C4, b8;
function Ta() {
  if (b8) return C4;
  b8 = 1;
  var e = oV(), t = iV(), n = aV(), r = sV(), o = lV();
  function i(a) {
    var s = -1, l = a == null ? 0 : a.length;
    for (this.clear(); ++s < l; ) {
      var c = a[s];
      this.set(c[0], c[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = n, i.prototype.has = r, i.prototype.set = o, C4 = i, C4;
}
var w4, y8;
function cV() {
  if (y8) return w4;
  y8 = 1;
  var e = Ta();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return w4 = t, w4;
}
var _4, C8;
function uV() {
  if (C8) return _4;
  C8 = 1;
  function e(t) {
    var n = this.__data__, r = n.delete(t);
    return this.size = n.size, r;
  }
  return _4 = e, _4;
}
var x4, w8;
function dV() {
  if (w8) return x4;
  w8 = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return x4 = e, x4;
}
var S4, _8;
function fV() {
  if (_8) return S4;
  _8 = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return S4 = e, S4;
}
var M4, x8;
function Wx() {
  if (x8) return M4;
  x8 = 1;
  var e = typeof _o == "object" && _o && _o.Object === Object && _o;
  return M4 = e, M4;
}
var k4, S8;
function $t() {
  if (S8) return k4;
  S8 = 1;
  var e = Wx(), t = typeof self == "object" && self && self.Object === Object && self, n = e || t || Function("return this")();
  return k4 = n, k4;
}
var L4, M8;
function fn() {
  if (M8) return L4;
  M8 = 1;
  var e = $t(), t = e.Symbol;
  return L4 = t, L4;
}
var E4, k8;
function hV() {
  if (k8) return E4;
  k8 = 1;
  var e = fn(), t = Object.prototype, n = t.hasOwnProperty, r = t.toString, o = e ? e.toStringTag : void 0;
  function i(a) {
    var s = n.call(a, o), l = a[o];
    try {
      a[o] = void 0;
      var c = !0;
    } catch {
    }
    var f = r.call(a);
    return c && (s ? a[o] = l : delete a[o]), f;
  }
  return E4 = i, E4;
}
var T4, L8;
function pV() {
  if (L8) return T4;
  L8 = 1;
  var e = Object.prototype, t = e.toString;
  function n(r) {
    return t.call(r);
  }
  return T4 = n, T4;
}
var R4, E8;
function a0() {
  if (E8) return R4;
  E8 = 1;
  var e = fn(), t = hV(), n = pV(), r = "[object Null]", o = "[object Undefined]", i = e ? e.toStringTag : void 0;
  function a(s) {
    return s == null ? s === void 0 ? o : r : i && i in Object(s) ? t(s) : n(s);
  }
  return R4 = a, R4;
}
var P4, T8;
function Wt() {
  if (T8) return P4;
  T8 = 1;
  function e(t) {
    var n = typeof t;
    return t != null && (n == "object" || n == "function");
  }
  return P4 = e, P4;
}
var A4, R8;
function Ra() {
  if (R8) return A4;
  R8 = 1;
  var e = a0(), t = Wt(), n = "[object AsyncFunction]", r = "[object Function]", o = "[object GeneratorFunction]", i = "[object Proxy]";
  function a(s) {
    if (!t(s))
      return !1;
    var l = e(s);
    return l == r || l == o || l == n || l == i;
  }
  return A4 = a, A4;
}
var I4, P8;
function mV() {
  if (P8) return I4;
  P8 = 1;
  var e = $t(), t = e["__core-js_shared__"];
  return I4 = t, I4;
}
var O4, A8;
function gV() {
  if (A8) return O4;
  A8 = 1;
  var e = mV(), t = function() {
    var r = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return r ? "Symbol(src)_1." + r : "";
  }();
  function n(r) {
    return !!t && t in r;
  }
  return O4 = n, O4;
}
var N4, I8;
function Vx() {
  if (I8) return N4;
  I8 = 1;
  var e = Function.prototype, t = e.toString;
  function n(r) {
    if (r != null) {
      try {
        return t.call(r);
      } catch {
      }
      try {
        return r + "";
      } catch {
      }
    }
    return "";
  }
  return N4 = n, N4;
}
var D4, O8;
function vV() {
  if (O8) return D4;
  O8 = 1;
  var e = Ra(), t = gV(), n = Wt(), r = Vx(), o = /[\\^$.*+?()[\]{}|]/g, i = /^\[object .+?Constructor\]$/, a = Function.prototype, s = Object.prototype, l = a.toString, c = s.hasOwnProperty, f = RegExp(
    "^" + l.call(c).replace(o, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function u(h) {
    if (!n(h) || t(h))
      return !1;
    var p = e(h) ? f : i;
    return p.test(r(h));
  }
  return D4 = u, D4;
}
var B4, N8;
function bV() {
  if (N8) return B4;
  N8 = 1;
  function e(t, n) {
    return t?.[n];
  }
  return B4 = e, B4;
}
var F4, D8;
function f3() {
  if (D8) return F4;
  D8 = 1;
  var e = vV(), t = bV();
  function n(r, o) {
    var i = t(r, o);
    return e(i) ? i : void 0;
  }
  return F4 = n, F4;
}
var $4, B8;
function Cd() {
  if (B8) return $4;
  B8 = 1;
  var e = f3(), t = $t(), n = e(t, "Map");
  return $4 = n, $4;
}
var W4, F8;
function Pa() {
  if (F8) return W4;
  F8 = 1;
  var e = f3(), t = e(Object, "create");
  return W4 = t, W4;
}
var V4, $8;
function yV() {
  if ($8) return V4;
  $8 = 1;
  var e = Pa();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return V4 = t, V4;
}
var H4, W8;
function CV() {
  if (W8) return H4;
  W8 = 1;
  function e(t) {
    var n = this.has(t) && delete this.__data__[t];
    return this.size -= n ? 1 : 0, n;
  }
  return H4 = e, H4;
}
var j4, V8;
function wV() {
  if (V8) return j4;
  V8 = 1;
  var e = Pa(), t = "__lodash_hash_undefined__", n = Object.prototype, r = n.hasOwnProperty;
  function o(i) {
    var a = this.__data__;
    if (e) {
      var s = a[i];
      return s === t ? void 0 : s;
    }
    return r.call(a, i) ? a[i] : void 0;
  }
  return j4 = o, j4;
}
var q4, H8;
function _V() {
  if (H8) return q4;
  H8 = 1;
  var e = Pa(), t = Object.prototype, n = t.hasOwnProperty;
  function r(o) {
    var i = this.__data__;
    return e ? i[o] !== void 0 : n.call(i, o);
  }
  return q4 = r, q4;
}
var z4, j8;
function xV() {
  if (j8) return z4;
  j8 = 1;
  var e = Pa(), t = "__lodash_hash_undefined__";
  function n(r, o) {
    var i = this.__data__;
    return this.size += this.has(r) ? 0 : 1, i[r] = e && o === void 0 ? t : o, this;
  }
  return z4 = n, z4;
}
var U4, q8;
function SV() {
  if (q8) return U4;
  q8 = 1;
  var e = yV(), t = CV(), n = wV(), r = _V(), o = xV();
  function i(a) {
    var s = -1, l = a == null ? 0 : a.length;
    for (this.clear(); ++s < l; ) {
      var c = a[s];
      this.set(c[0], c[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = n, i.prototype.has = r, i.prototype.set = o, U4 = i, U4;
}
var G4, z8;
function MV() {
  if (z8) return G4;
  z8 = 1;
  var e = SV(), t = Ta(), n = Cd();
  function r() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (n || t)(),
      string: new e()
    };
  }
  return G4 = r, G4;
}
var Y4, U8;
function kV() {
  if (U8) return Y4;
  U8 = 1;
  function e(t) {
    var n = typeof t;
    return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? t !== "__proto__" : t === null;
  }
  return Y4 = e, Y4;
}
var Z4, G8;
function Aa() {
  if (G8) return Z4;
  G8 = 1;
  var e = kV();
  function t(n, r) {
    var o = n.__data__;
    return e(r) ? o[typeof r == "string" ? "string" : "hash"] : o.map;
  }
  return Z4 = t, Z4;
}
var K4, Y8;
function LV() {
  if (Y8) return K4;
  Y8 = 1;
  var e = Aa();
  function t(n) {
    var r = e(this, n).delete(n);
    return this.size -= r ? 1 : 0, r;
  }
  return K4 = t, K4;
}
var X4, Z8;
function EV() {
  if (Z8) return X4;
  Z8 = 1;
  var e = Aa();
  function t(n) {
    return e(this, n).get(n);
  }
  return X4 = t, X4;
}
var Q4, K8;
function TV() {
  if (K8) return Q4;
  K8 = 1;
  var e = Aa();
  function t(n) {
    return e(this, n).has(n);
  }
  return Q4 = t, Q4;
}
var J4, X8;
function RV() {
  if (X8) return J4;
  X8 = 1;
  var e = Aa();
  function t(n, r) {
    var o = e(this, n), i = o.size;
    return o.set(n, r), this.size += o.size == i ? 0 : 1, this;
  }
  return J4 = t, J4;
}
var e9, Q8;
function wd() {
  if (Q8) return e9;
  Q8 = 1;
  var e = MV(), t = LV(), n = EV(), r = TV(), o = RV();
  function i(a) {
    var s = -1, l = a == null ? 0 : a.length;
    for (this.clear(); ++s < l; ) {
      var c = a[s];
      this.set(c[0], c[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = n, i.prototype.has = r, i.prototype.set = o, e9 = i, e9;
}
var t9, J8;
function PV() {
  if (J8) return t9;
  J8 = 1;
  var e = Ta(), t = Cd(), n = wd(), r = 200;
  function o(i, a) {
    var s = this.__data__;
    if (s instanceof e) {
      var l = s.__data__;
      if (!t || l.length < r - 1)
        return l.push([i, a]), this.size = ++s.size, this;
      s = this.__data__ = new n(l);
    }
    return s.set(i, a), this.size = s.size, this;
  }
  return t9 = o, t9;
}
var n9, eh;
function Ia() {
  if (eh) return n9;
  eh = 1;
  var e = Ta(), t = cV(), n = uV(), r = dV(), o = fV(), i = PV();
  function a(s) {
    var l = this.__data__ = new e(s);
    this.size = l.size;
  }
  return a.prototype.clear = t, a.prototype.delete = n, a.prototype.get = r, a.prototype.has = o, a.prototype.set = i, n9 = a, n9;
}
var r9, th;
function Hx() {
  if (th) return r9;
  th = 1;
  var e = f3(), t = function() {
    try {
      var n = e(Object, "defineProperty");
      return n({}, "", {}), n;
    } catch {
    }
  }();
  return r9 = t, r9;
}
var o9, nh;
function _d() {
  if (nh) return o9;
  nh = 1;
  var e = Hx();
  function t(n, r, o) {
    r == "__proto__" && e ? e(n, r, {
      configurable: !0,
      enumerable: !0,
      value: o,
      writable: !0
    }) : n[r] = o;
  }
  return o9 = t, o9;
}
var i9, rh;
function jx() {
  if (rh) return i9;
  rh = 1;
  var e = _d(), t = no();
  function n(r, o, i) {
    (i !== void 0 && !t(r[o], i) || i === void 0 && !(o in r)) && e(r, o, i);
  }
  return i9 = n, i9;
}
var a9, oh;
function AV() {
  if (oh) return a9;
  oh = 1;
  function e(t) {
    return function(n, r, o) {
      for (var i = -1, a = Object(n), s = o(n), l = s.length; l--; ) {
        var c = s[t ? l : ++i];
        if (r(a[c], c, a) === !1)
          break;
      }
      return n;
    };
  }
  return a9 = e, a9;
}
var s9, ih;
function qx() {
  if (ih) return s9;
  ih = 1;
  var e = AV(), t = e();
  return s9 = t, s9;
}
var Gn = { exports: {} };
Gn.exports;
var ah;
function zx() {
  return ah || (ah = 1, function(e, t) {
    var n = $t(), r = t && !t.nodeType && t, o = r && !0 && e && !e.nodeType && e, i = o && o.exports === r, a = i ? n.Buffer : void 0, s = a ? a.allocUnsafe : void 0;
    function l(c, f) {
      if (f)
        return c.slice();
      var u = c.length, h = s ? s(u) : new c.constructor(u);
      return c.copy(h), h;
    }
    e.exports = l;
  }(Gn, Gn.exports)), Gn.exports;
}
var l9, sh;
function Ux() {
  if (sh) return l9;
  sh = 1;
  var e = $t(), t = e.Uint8Array;
  return l9 = t, l9;
}
var c9, lh;
function xd() {
  if (lh) return c9;
  lh = 1;
  var e = Ux();
  function t(n) {
    var r = new n.constructor(n.byteLength);
    return new e(r).set(new e(n)), r;
  }
  return c9 = t, c9;
}
var u9, ch;
function Gx() {
  if (ch) return u9;
  ch = 1;
  var e = xd();
  function t(n, r) {
    var o = r ? e(n.buffer) : n.buffer;
    return new n.constructor(o, n.byteOffset, n.length);
  }
  return u9 = t, u9;
}
var d9, uh;
function Yx() {
  if (uh) return d9;
  uh = 1;
  function e(t, n) {
    var r = -1, o = t.length;
    for (n || (n = Array(o)); ++r < o; )
      n[r] = t[r];
    return n;
  }
  return d9 = e, d9;
}
var f9, dh;
function IV() {
  if (dh) return f9;
  dh = 1;
  var e = Wt(), t = Object.create, n = /* @__PURE__ */ function() {
    function r() {
    }
    return function(o) {
      if (!e(o))
        return {};
      if (t)
        return t(o);
      r.prototype = o;
      var i = new r();
      return r.prototype = void 0, i;
    };
  }();
  return f9 = n, f9;
}
var h9, fh;
function Zx() {
  if (fh) return h9;
  fh = 1;
  function e(t, n) {
    return function(r) {
      return t(n(r));
    };
  }
  return h9 = e, h9;
}
var p9, hh;
function Sd() {
  if (hh) return p9;
  hh = 1;
  var e = Zx(), t = e(Object.getPrototypeOf, Object);
  return p9 = t, p9;
}
var m9, ph;
function Md() {
  if (ph) return m9;
  ph = 1;
  var e = Object.prototype;
  function t(n) {
    var r = n && n.constructor, o = typeof r == "function" && r.prototype || e;
    return n === o;
  }
  return m9 = t, m9;
}
var g9, mh;
function Kx() {
  if (mh) return g9;
  mh = 1;
  var e = IV(), t = Sd(), n = Md();
  function r(o) {
    return typeof o.constructor == "function" && !n(o) ? e(t(o)) : {};
  }
  return g9 = r, g9;
}
var v9, gh;
function nt() {
  if (gh) return v9;
  gh = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return v9 = e, v9;
}
var b9, vh;
function OV() {
  if (vh) return b9;
  vh = 1;
  var e = a0(), t = nt(), n = "[object Arguments]";
  function r(o) {
    return t(o) && e(o) == n;
  }
  return b9 = r, b9;
}
var y9, bh;
function Oa() {
  if (bh) return y9;
  bh = 1;
  var e = OV(), t = nt(), n = Object.prototype, r = n.hasOwnProperty, o = n.propertyIsEnumerable, i = e(/* @__PURE__ */ function() {
    return arguments;
  }()) ? e : function(a) {
    return t(a) && r.call(a, "callee") && !o.call(a, "callee");
  };
  return y9 = i, y9;
}
var C9, yh;
function I2() {
  if (yh) return C9;
  yh = 1;
  var e = Array.isArray;
  return C9 = e, C9;
}
var w9, Ch;
function kd() {
  if (Ch) return w9;
  Ch = 1;
  var e = 9007199254740991;
  function t(n) {
    return typeof n == "number" && n > -1 && n % 1 == 0 && n <= e;
  }
  return w9 = t, w9;
}
var _9, wh;
function hn() {
  if (wh) return _9;
  wh = 1;
  var e = Ra(), t = kd();
  function n(r) {
    return r != null && t(r.length) && !e(r);
  }
  return _9 = n, _9;
}
var x9, _h;
function Xx() {
  if (_h) return x9;
  _h = 1;
  var e = hn(), t = nt();
  function n(r) {
    return t(r) && e(r);
  }
  return x9 = n, x9;
}
var Yn = { exports: {} }, S9, xh;
function NV() {
  if (xh) return S9;
  xh = 1;
  function e() {
    return !1;
  }
  return S9 = e, S9;
}
Yn.exports;
var Sh;
function Na() {
  return Sh || (Sh = 1, function(e, t) {
    var n = $t(), r = NV(), o = t && !t.nodeType && t, i = o && !0 && e && !e.nodeType && e, a = i && i.exports === o, s = a ? n.Buffer : void 0, l = s ? s.isBuffer : void 0, c = l || r;
    e.exports = c;
  }(Yn, Yn.exports)), Yn.exports;
}
var M9, Mh;
function Ld() {
  if (Mh) return M9;
  Mh = 1;
  var e = a0(), t = Sd(), n = nt(), r = "[object Object]", o = Function.prototype, i = Object.prototype, a = o.toString, s = i.hasOwnProperty, l = a.call(Object);
  function c(f) {
    if (!n(f) || e(f) != r)
      return !1;
    var u = t(f);
    if (u === null)
      return !0;
    var h = s.call(u, "constructor") && u.constructor;
    return typeof h == "function" && h instanceof h && a.call(h) == l;
  }
  return M9 = c, M9;
}
var k9, kh;
function DV() {
  if (kh) return k9;
  kh = 1;
  var e = a0(), t = kd(), n = nt(), r = "[object Arguments]", o = "[object Array]", i = "[object Boolean]", a = "[object Date]", s = "[object Error]", l = "[object Function]", c = "[object Map]", f = "[object Number]", u = "[object Object]", h = "[object RegExp]", p = "[object Set]", g = "[object String]", m = "[object WeakMap]", b = "[object ArrayBuffer]", y = "[object DataView]", C = "[object Float32Array]", _ = "[object Float64Array]", M = "[object Int8Array]", S = "[object Int16Array]", k = "[object Int32Array]", L = "[object Uint8Array]", P = "[object Uint8ClampedArray]", I = "[object Uint16Array]", O = "[object Uint32Array]", E = {};
  E[C] = E[_] = E[M] = E[S] = E[k] = E[L] = E[P] = E[I] = E[O] = !0, E[r] = E[o] = E[b] = E[i] = E[y] = E[a] = E[s] = E[l] = E[c] = E[f] = E[u] = E[h] = E[p] = E[g] = E[m] = !1;
  function B(W) {
    return n(W) && t(W.length) && !!E[e(W)];
  }
  return k9 = B, k9;
}
var L9, Lh;
function pn() {
  if (Lh) return L9;
  Lh = 1;
  function e(t) {
    return function(n) {
      return t(n);
    };
  }
  return L9 = e, L9;
}
var Zn = { exports: {} };
Zn.exports;
var Eh;
function Da() {
  return Eh || (Eh = 1, function(e, t) {
    var n = Wx(), r = t && !t.nodeType && t, o = r && !0 && e && !e.nodeType && e, i = o && o.exports === r, a = i && n.process, s = function() {
      try {
        var l = o && o.require && o.require("util").types;
        return l || a && a.binding && a.binding("util");
      } catch {
      }
    }();
    e.exports = s;
  }(Zn, Zn.exports)), Zn.exports;
}
var E9, Th;
function Ed() {
  if (Th) return E9;
  Th = 1;
  var e = DV(), t = pn(), n = Da(), r = n && n.isTypedArray, o = r ? t(r) : e;
  return E9 = o, E9;
}
var T9, Rh;
function Qx() {
  if (Rh) return T9;
  Rh = 1;
  function e(t, n) {
    if (!(n === "constructor" && typeof t[n] == "function") && n != "__proto__")
      return t[n];
  }
  return T9 = e, T9;
}
var R9, Ph;
function Td() {
  if (Ph) return R9;
  Ph = 1;
  var e = _d(), t = no(), n = Object.prototype, r = n.hasOwnProperty;
  function o(i, a, s) {
    var l = i[a];
    (!(r.call(i, a) && t(l, s)) || s === void 0 && !(a in i)) && e(i, a, s);
  }
  return R9 = o, R9;
}
var P9, Ah;
function mn() {
  if (Ah) return P9;
  Ah = 1;
  var e = Td(), t = _d();
  function n(r, o, i, a) {
    var s = !i;
    i || (i = {});
    for (var l = -1, c = o.length; ++l < c; ) {
      var f = o[l], u = a ? a(i[f], r[f], f, i, r) : void 0;
      u === void 0 && (u = r[f]), s ? t(i, f, u) : e(i, f, u);
    }
    return i;
  }
  return P9 = n, P9;
}
var A9, Ih;
function BV() {
  if (Ih) return A9;
  Ih = 1;
  function e(t, n) {
    for (var r = -1, o = Array(t); ++r < t; )
      o[r] = n(r);
    return o;
  }
  return A9 = e, A9;
}
var I9, Oh;
function Ba() {
  if (Oh) return I9;
  Oh = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function n(r, o) {
    var i = typeof r;
    return o = o ?? e, !!o && (i == "number" || i != "symbol" && t.test(r)) && r > -1 && r % 1 == 0 && r < o;
  }
  return I9 = n, I9;
}
var O9, Nh;
function Jx() {
  if (Nh) return O9;
  Nh = 1;
  var e = BV(), t = Oa(), n = I2(), r = Na(), o = Ba(), i = Ed(), a = Object.prototype, s = a.hasOwnProperty;
  function l(c, f) {
    var u = n(c), h = !u && t(c), p = !u && !h && r(c), g = !u && !h && !p && i(c), m = u || h || p || g, b = m ? e(c.length, String) : [], y = b.length;
    for (var C in c)
      (f || s.call(c, C)) && !(m && // Safari 9 has enumerable `arguments.length` in strict mode.
      (C == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      p && (C == "offset" || C == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      g && (C == "buffer" || C == "byteLength" || C == "byteOffset") || // Skip index properties.
      o(C, y))) && b.push(C);
    return b;
  }
  return O9 = l, O9;
}
var N9, Dh;
function FV() {
  if (Dh) return N9;
  Dh = 1;
  function e(t) {
    var n = [];
    if (t != null)
      for (var r in Object(t))
        n.push(r);
    return n;
  }
  return N9 = e, N9;
}
var D9, Bh;
function $V() {
  if (Bh) return D9;
  Bh = 1;
  var e = Wt(), t = Md(), n = FV(), r = Object.prototype, o = r.hasOwnProperty;
  function i(a) {
    if (!e(a))
      return n(a);
    var s = t(a), l = [];
    for (var c in a)
      c == "constructor" && (s || !o.call(a, c)) || l.push(c);
    return l;
  }
  return D9 = i, D9;
}
var B9, Fh;
function ro() {
  if (Fh) return B9;
  Fh = 1;
  var e = Jx(), t = $V(), n = hn();
  function r(o) {
    return n(o) ? e(o, !0) : t(o);
  }
  return B9 = r, B9;
}
var F9, $h;
function WV() {
  if ($h) return F9;
  $h = 1;
  var e = mn(), t = ro();
  function n(r) {
    return e(r, t(r));
  }
  return F9 = n, F9;
}
var $9, Wh;
function VV() {
  if (Wh) return $9;
  Wh = 1;
  var e = jx(), t = zx(), n = Gx(), r = Yx(), o = Kx(), i = Oa(), a = I2(), s = Xx(), l = Na(), c = Ra(), f = Wt(), u = Ld(), h = Ed(), p = Qx(), g = WV();
  function m(b, y, C, _, M, S, k) {
    var L = p(b, C), P = p(y, C), I = k.get(P);
    if (I) {
      e(b, C, I);
      return;
    }
    var O = S ? S(L, P, C + "", b, y, k) : void 0, E = O === void 0;
    if (E) {
      var B = a(P), W = !B && l(P), F = !B && !W && h(P);
      O = P, B || W || F ? a(L) ? O = L : s(L) ? O = r(L) : W ? (E = !1, O = t(P, !0)) : F ? (E = !1, O = n(P, !0)) : O = [] : u(P) || i(P) ? (O = L, i(L) ? O = g(L) : (!f(L) || c(L)) && (O = o(P))) : E = !1;
    }
    E && (k.set(P, O), M(O, P, _, S, k), k.delete(P)), e(b, C, O);
  }
  return $9 = m, $9;
}
var W9, Vh;
function HV() {
  if (Vh) return W9;
  Vh = 1;
  var e = Ia(), t = jx(), n = qx(), r = VV(), o = Wt(), i = ro(), a = Qx();
  function s(l, c, f, u, h) {
    l !== c && n(c, function(p, g) {
      if (h || (h = new e()), o(p))
        r(l, c, g, f, s, u, h);
      else {
        var m = u ? u(a(l, g), p, g + "", l, c, h) : void 0;
        m === void 0 && (m = p), t(l, g, m);
      }
    }, i);
  }
  return W9 = s, W9;
}
var V9, Hh;
function Fa() {
  if (Hh) return V9;
  Hh = 1;
  function e(t) {
    return t;
  }
  return V9 = e, V9;
}
var H9, jh;
function jV() {
  if (jh) return H9;
  jh = 1;
  function e(t, n, r) {
    switch (r.length) {
      case 0:
        return t.call(n);
      case 1:
        return t.call(n, r[0]);
      case 2:
        return t.call(n, r[0], r[1]);
      case 3:
        return t.call(n, r[0], r[1], r[2]);
    }
    return t.apply(n, r);
  }
  return H9 = e, H9;
}
var j9, qh;
function eS() {
  if (qh) return j9;
  qh = 1;
  var e = jV(), t = Math.max;
  function n(r, o, i) {
    return o = t(o === void 0 ? r.length - 1 : o, 0), function() {
      for (var a = arguments, s = -1, l = t(a.length - o, 0), c = Array(l); ++s < l; )
        c[s] = a[o + s];
      s = -1;
      for (var f = Array(o + 1); ++s < o; )
        f[s] = a[s];
      return f[o] = i(c), e(r, this, f);
    };
  }
  return j9 = n, j9;
}
var q9, zh;
function qV() {
  if (zh) return q9;
  zh = 1;
  function e(t) {
    return function() {
      return t;
    };
  }
  return q9 = e, q9;
}
var z9, Uh;
function zV() {
  if (Uh) return z9;
  Uh = 1;
  var e = qV(), t = Hx(), n = Fa(), r = t ? function(o, i) {
    return t(o, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(i),
      writable: !0
    });
  } : n;
  return z9 = r, z9;
}
var U9, Gh;
function UV() {
  if (Gh) return U9;
  Gh = 1;
  var e = 800, t = 16, n = Date.now;
  function r(o) {
    var i = 0, a = 0;
    return function() {
      var s = n(), l = t - (s - a);
      if (a = s, l > 0) {
        if (++i >= e)
          return arguments[0];
      } else
        i = 0;
      return o.apply(void 0, arguments);
    };
  }
  return U9 = r, U9;
}
var G9, Yh;
function tS() {
  if (Yh) return G9;
  Yh = 1;
  var e = zV(), t = UV(), n = t(e);
  return G9 = n, G9;
}
var Y9, Zh;
function Rd() {
  if (Zh) return Y9;
  Zh = 1;
  var e = Fa(), t = eS(), n = tS();
  function r(o, i) {
    return n(t(o, i, e), o + "");
  }
  return Y9 = r, Y9;
}
var Z9, Kh;
function nS() {
  if (Kh) return Z9;
  Kh = 1;
  var e = no(), t = hn(), n = Ba(), r = Wt();
  function o(i, a, s) {
    if (!r(s))
      return !1;
    var l = typeof a;
    return (l == "number" ? t(s) && n(a, s.length) : l == "string" && a in s) ? e(s[a], i) : !1;
  }
  return Z9 = o, Z9;
}
var K9, Xh;
function GV() {
  if (Xh) return K9;
  Xh = 1;
  var e = Rd(), t = nS();
  function n(r) {
    return e(function(o, i) {
      var a = -1, s = i.length, l = s > 1 ? i[s - 1] : void 0, c = s > 2 ? i[2] : void 0;
      for (l = r.length > 3 && typeof l == "function" ? (s--, l) : void 0, c && t(i[0], i[1], c) && (l = s < 3 ? void 0 : l, s = 1), o = Object(o); ++a < s; ) {
        var f = i[a];
        f && r(o, f, a, l);
      }
      return o;
    });
  }
  return K9 = n, K9;
}
var X9, Qh;
function YV() {
  if (Qh) return X9;
  Qh = 1;
  var e = HV(), t = GV(), n = t(function(r, o, i) {
    e(r, o, i);
  });
  return X9 = n, X9;
}
var ZV = YV();
const KV = /* @__PURE__ */ h2(ZV);
var Q9, Jh;
function $a() {
  if (Jh) return Q9;
  Jh = 1;
  var e = a0(), t = nt(), n = "[object Symbol]";
  function r(o) {
    return typeof o == "symbol" || t(o) && e(o) == n;
  }
  return Q9 = r, Q9;
}
var J9, ep;
function Pd() {
  if (ep) return J9;
  ep = 1;
  var e = I2(), t = $a(), n = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, r = /^\w*$/;
  function o(i, a) {
    if (e(i))
      return !1;
    var s = typeof i;
    return s == "number" || s == "symbol" || s == "boolean" || i == null || t(i) ? !0 : r.test(i) || !n.test(i) || a != null && i in Object(a);
  }
  return J9 = o, J9;
}
var el, tp;
function XV() {
  if (tp) return el;
  tp = 1;
  var e = wd(), t = "Expected a function";
  function n(r, o) {
    if (typeof r != "function" || o != null && typeof o != "function")
      throw new TypeError(t);
    var i = function() {
      var a = arguments, s = o ? o.apply(this, a) : a[0], l = i.cache;
      if (l.has(s))
        return l.get(s);
      var c = r.apply(this, a);
      return i.cache = l.set(s, c) || l, c;
    };
    return i.cache = new (n.Cache || e)(), i;
  }
  return n.Cache = e, el = n, el;
}
var tl, np;
function QV() {
  if (np) return tl;
  np = 1;
  var e = XV(), t = 500;
  function n(r) {
    var o = e(r, function(a) {
      return i.size === t && i.clear(), a;
    }), i = o.cache;
    return o;
  }
  return tl = n, tl;
}
var nl, rp;
function JV() {
  if (rp) return nl;
  rp = 1;
  var e = QV(), t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, n = /\\(\\)?/g, r = e(function(o) {
    var i = [];
    return o.charCodeAt(0) === 46 && i.push(""), o.replace(t, function(a, s, l, c) {
      i.push(l ? c.replace(n, "$1") : s || a);
    }), i;
  });
  return nl = r, nl;
}
var rl, op;
function Wa() {
  if (op) return rl;
  op = 1;
  function e(t, n) {
    for (var r = -1, o = t == null ? 0 : t.length, i = Array(o); ++r < o; )
      i[r] = n(t[r], r, t);
    return i;
  }
  return rl = e, rl;
}
var ol, ip;
function eH() {
  if (ip) return ol;
  ip = 1;
  var e = fn(), t = Wa(), n = I2(), r = $a(), o = e ? e.prototype : void 0, i = o ? o.toString : void 0;
  function a(s) {
    if (typeof s == "string")
      return s;
    if (n(s))
      return t(s, a) + "";
    if (r(s))
      return i ? i.call(s) : "";
    var l = s + "";
    return l == "0" && 1 / s == -1 / 0 ? "-0" : l;
  }
  return ol = a, ol;
}
var il, ap;
function rS() {
  if (ap) return il;
  ap = 1;
  var e = eH();
  function t(n) {
    return n == null ? "" : e(n);
  }
  return il = t, il;
}
var al, sp;
function gn() {
  if (sp) return al;
  sp = 1;
  var e = I2(), t = Pd(), n = JV(), r = rS();
  function o(i, a) {
    return e(i) ? i : t(i, a) ? [i] : n(r(i));
  }
  return al = o, al;
}
var sl, lp;
function vn() {
  if (lp) return sl;
  lp = 1;
  var e = $a();
  function t(n) {
    if (typeof n == "string" || e(n))
      return n;
    var r = n + "";
    return r == "0" && 1 / n == -1 / 0 ? "-0" : r;
  }
  return sl = t, sl;
}
var ll, cp;
function oo() {
  if (cp) return ll;
  cp = 1;
  var e = gn(), t = vn();
  function n(r, o) {
    o = e(o, r);
    for (var i = 0, a = o.length; r != null && i < a; )
      r = r[t(o[i++])];
    return i && i == a ? r : void 0;
  }
  return ll = n, ll;
}
var cl, up;
function oS() {
  if (up) return cl;
  up = 1;
  var e = oo();
  function t(n, r, o) {
    var i = n == null ? void 0 : e(n, r);
    return i === void 0 ? o : i;
  }
  return cl = t, cl;
}
var tH = oS();
const It = /* @__PURE__ */ h2(tH);
var ul, dp;
function iS() {
  if (dp) return ul;
  dp = 1;
  var e = Td(), t = gn(), n = Ba(), r = Wt(), o = vn();
  function i(a, s, l, c) {
    if (!r(a))
      return a;
    s = t(s, a);
    for (var f = -1, u = s.length, h = u - 1, p = a; p != null && ++f < u; ) {
      var g = o(s[f]), m = l;
      if (g === "__proto__" || g === "constructor" || g === "prototype")
        return a;
      if (f != h) {
        var b = p[g];
        m = c ? c(b, g, p) : void 0, m === void 0 && (m = r(b) ? b : n(s[f + 1]) ? [] : {});
      }
      e(p, g, m), p = p[g];
    }
    return a;
  }
  return ul = i, ul;
}
var dl, fp;
function nH() {
  if (fp) return dl;
  fp = 1;
  var e = iS();
  function t(n, r, o) {
    return n == null ? n : e(n, r, o);
  }
  return dl = t, dl;
}
var rH = nH();
const Kn = /* @__PURE__ */ h2(rH);
function Va(e, t, n) {
  e.prototype = t.prototype = n, n.constructor = e;
}
function Ad(e, t) {
  var n = Object.create(e.prototype);
  for (var r in t) n[r] = t[r];
  return n;
}
function bn() {
}
var r3 = 0.7, z3 = 1 / r3, F3 = "\\s*([+-]?\\d+)\\s*", Cr = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", Tt = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", oH = /^#([0-9a-f]{3,8})$/, iH = new RegExp(`^rgb\\(${F3},${F3},${F3}\\)$`), aH = new RegExp(`^rgb\\(${Tt},${Tt},${Tt}\\)$`), sH = new RegExp(`^rgba\\(${F3},${F3},${F3},${Cr}\\)$`), lH = new RegExp(`^rgba\\(${Tt},${Tt},${Tt},${Cr}\\)$`), cH = new RegExp(`^hsl\\(${Cr},${Tt},${Tt}\\)$`), uH = new RegExp(`^hsla\\(${Cr},${Tt},${Tt},${Cr}\\)$`), hp = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
Va(bn, wr, {
  copy(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: pp,
  // Deprecated! Use color.formatHex.
  formatHex: pp,
  formatHex8: dH,
  formatHsl: fH,
  formatRgb: mp,
  toString: mp
});
function pp() {
  return this.rgb().formatHex();
}
function dH() {
  return this.rgb().formatHex8();
}
function fH() {
  return sS(this).formatHsl();
}
function mp() {
  return this.rgb().formatRgb();
}
function wr(e) {
  var t, n;
  return e = (e + "").trim().toLowerCase(), (t = oH.exec(e)) ? (n = t[1].length, t = parseInt(t[1], 16), n === 6 ? gp(t) : n === 3 ? new L2(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : n === 8 ? To(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : n === 4 ? To(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = iH.exec(e)) ? new L2(t[1], t[2], t[3], 1) : (t = aH.exec(e)) ? new L2(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = sH.exec(e)) ? To(t[1], t[2], t[3], t[4]) : (t = lH.exec(e)) ? To(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = cH.exec(e)) ? yp(t[1], t[2] / 100, t[3] / 100, 1) : (t = uH.exec(e)) ? yp(t[1], t[2] / 100, t[3] / 100, t[4]) : hp.hasOwnProperty(e) ? gp(hp[e]) : e === "transparent" ? new L2(NaN, NaN, NaN, 0) : null;
}
function gp(e) {
  return new L2(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function To(e, t, n, r) {
  return r <= 0 && (e = t = n = NaN), new L2(e, t, n, r);
}
function aS(e) {
  return e instanceof bn || (e = wr(e)), e ? (e = e.rgb(), new L2(e.r, e.g, e.b, e.opacity)) : new L2();
}
function U3(e, t, n, r) {
  return arguments.length === 1 ? aS(e) : new L2(e, t, n, r ?? 1);
}
function L2(e, t, n, r) {
  this.r = +e, this.g = +t, this.b = +n, this.opacity = +r;
}
Va(L2, U3, Ad(bn, {
  brighter(e) {
    return e = e == null ? z3 : Math.pow(z3, e), new L2(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? r3 : Math.pow(r3, e), new L2(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new L2(Y0(this.r), Y0(this.g), Y0(this.b), li(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: vp,
  // Deprecated! Use color.formatHex.
  formatHex: vp,
  formatHex8: hH,
  formatRgb: bp,
  toString: bp
}));
function vp() {
  return `#${j0(this.r)}${j0(this.g)}${j0(this.b)}`;
}
function hH() {
  return `#${j0(this.r)}${j0(this.g)}${j0(this.b)}${j0((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function bp() {
  const e = li(this.opacity);
  return `${e === 1 ? "rgb(" : "rgba("}${Y0(this.r)}, ${Y0(this.g)}, ${Y0(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function li(e) {
  return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function Y0(e) {
  return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function j0(e) {
  return e = Y0(e), (e < 16 ? "0" : "") + e.toString(16);
}
function yp(e, t, n, r) {
  return r <= 0 ? e = t = n = NaN : n <= 0 || n >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new ut(e, t, n, r);
}
function sS(e) {
  if (e instanceof ut) return new ut(e.h, e.s, e.l, e.opacity);
  if (e instanceof bn || (e = wr(e)), !e) return new ut();
  if (e instanceof ut) return e;
  e = e.rgb();
  var t = e.r / 255, n = e.g / 255, r = e.b / 255, o = Math.min(t, n, r), i = Math.max(t, n, r), a = NaN, s = i - o, l = (i + o) / 2;
  return s ? (t === i ? a = (n - r) / s + (n < r) * 6 : n === i ? a = (r - t) / s + 2 : a = (t - n) / s + 4, s /= l < 0.5 ? i + o : 2 - i - o, a *= 60) : s = l > 0 && l < 1 ? 0 : a, new ut(a, s, l, e.opacity);
}
function pH(e, t, n, r) {
  return arguments.length === 1 ? sS(e) : new ut(e, t, n, r ?? 1);
}
function ut(e, t, n, r) {
  this.h = +e, this.s = +t, this.l = +n, this.opacity = +r;
}
Va(ut, pH, Ad(bn, {
  brighter(e) {
    return e = e == null ? z3 : Math.pow(z3, e), new ut(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? r3 : Math.pow(r3, e), new ut(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, n = this.l, r = n + (n < 0.5 ? n : 1 - n) * t, o = 2 * n - r;
    return new L2(
      fl(e >= 240 ? e - 240 : e + 120, o, r),
      fl(e, o, r),
      fl(e < 120 ? e + 240 : e - 120, o, r),
      this.opacity
    );
  },
  clamp() {
    return new ut(Cp(this.h), Ro(this.s), Ro(this.l), li(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const e = li(this.opacity);
    return `${e === 1 ? "hsl(" : "hsla("}${Cp(this.h)}, ${Ro(this.s) * 100}%, ${Ro(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
  }
}));
function Cp(e) {
  return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function Ro(e) {
  return Math.max(0, Math.min(1, e || 0));
}
function fl(e, t, n) {
  return (e < 60 ? t + (n - t) * e / 60 : e < 180 ? n : e < 240 ? t + (n - t) * (240 - e) / 60 : t) * 255;
}
const mH = Math.PI / 180, gH = 180 / Math.PI;
var lS = -0.14861, Id = 1.78277, Od = -0.29227, Ha = -0.90649, _r = 1.97294, wp = _r * Ha, _p = _r * Id, xp = Id * Od - Ha * lS;
function vH(e) {
  if (e instanceof Z0) return new Z0(e.h, e.s, e.l, e.opacity);
  e instanceof L2 || (e = aS(e));
  var t = e.r / 255, n = e.g / 255, r = e.b / 255, o = (xp * r + wp * t - _p * n) / (xp + wp - _p), i = r - o, a = (_r * (n - o) - Od * i) / Ha, s = Math.sqrt(a * a + i * i) / (_r * o * (1 - o)), l = s ? Math.atan2(a, i) * gH - 120 : NaN;
  return new Z0(l < 0 ? l + 360 : l, s, o, e.opacity);
}
function Ot(e, t, n, r) {
  return arguments.length === 1 ? vH(e) : new Z0(e, t, n, r ?? 1);
}
function Z0(e, t, n, r) {
  this.h = +e, this.s = +t, this.l = +n, this.opacity = +r;
}
Va(Z0, Ot, Ad(bn, {
  brighter(e) {
    return e = e == null ? z3 : Math.pow(z3, e), new Z0(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? r3 : Math.pow(r3, e), new Z0(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = isNaN(this.h) ? 0 : (this.h + 120) * mH, t = +this.l, n = isNaN(this.s) ? 0 : this.s * t * (1 - t), r = Math.cos(e), o = Math.sin(e);
    return new L2(
      255 * (t + n * (lS * r + Id * o)),
      255 * (t + n * (Od * r + Ha * o)),
      255 * (t + n * (_r * r)),
      this.opacity
    );
  }
}));
function bH(e, t, n, r, o) {
  var i = e * e, a = i * e;
  return ((1 - 3 * e + 3 * i - a) * t + (4 - 6 * i + 3 * a) * n + (1 + 3 * e + 3 * i - 3 * a) * r + a * o) / 6;
}
function yH(e) {
  var t = e.length - 1;
  return function(n) {
    var r = n <= 0 ? n = 0 : n >= 1 ? (n = 1, t - 1) : Math.floor(n * t), o = e[r], i = e[r + 1], a = r > 0 ? e[r - 1] : 2 * o - i, s = r < t - 1 ? e[r + 2] : 2 * i - o;
    return bH((n - r / t) * t, a, o, i, s);
  };
}
const ja = (e) => () => e;
function cS(e, t) {
  return function(n) {
    return e + n * t;
  };
}
function CH(e, t, n) {
  return e = Math.pow(e, n), t = Math.pow(t, n) - e, n = 1 / n, function(r) {
    return Math.pow(e + r * t, n);
  };
}
function wH(e, t) {
  var n = t - e;
  return n ? cS(e, n > 180 || n < -180 ? n - 360 * Math.round(n / 360) : n) : ja(isNaN(e) ? t : e);
}
function _H(e) {
  return (e = +e) == 1 ? $3 : function(t, n) {
    return n - t ? CH(t, n, e) : ja(isNaN(t) ? n : t);
  };
}
function $3(e, t) {
  var n = t - e;
  return n ? cS(e, n) : ja(isNaN(e) ? t : e);
}
const Sp = function e(t) {
  var n = _H(t);
  function r(o, i) {
    var a = n((o = U3(o)).r, (i = U3(i)).r), s = n(o.g, i.g), l = n(o.b, i.b), c = $3(o.opacity, i.opacity);
    return function(f) {
      return o.r = a(f), o.g = s(f), o.b = l(f), o.opacity = c(f), o + "";
    };
  }
  return r.gamma = e, r;
}(1);
function xH(e) {
  return function(t) {
    var n = t.length, r = new Array(n), o = new Array(n), i = new Array(n), a, s;
    for (a = 0; a < n; ++a)
      s = U3(t[a]), r[a] = s.r || 0, o[a] = s.g || 0, i[a] = s.b || 0;
    return r = e(r), o = e(o), i = e(i), s.opacity = 1, function(l) {
      return s.r = r(l), s.g = o(l), s.b = i(l), s + "";
    };
  };
}
var SH = xH(yH);
function MH(e, t) {
  t || (t = []);
  var n = e ? Math.min(t.length, e.length) : 0, r = t.slice(), o;
  return function(i) {
    for (o = 0; o < n; ++o) r[o] = e[o] * (1 - i) + t[o] * i;
    return r;
  };
}
function kH(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function LH(e, t) {
  var n = t ? t.length : 0, r = e ? Math.min(n, e.length) : 0, o = new Array(r), i = new Array(n), a;
  for (a = 0; a < r; ++a) o[a] = Nd(e[a], t[a]);
  for (; a < n; ++a) i[a] = t[a];
  return function(s) {
    for (a = 0; a < r; ++a) i[a] = o[a](s);
    return i;
  };
}
function EH(e, t) {
  var n = /* @__PURE__ */ new Date();
  return e = +e, t = +t, function(r) {
    return n.setTime(e * (1 - r) + t * r), n;
  };
}
function ci(e, t) {
  return e = +e, t = +t, function(n) {
    return e * (1 - n) + t * n;
  };
}
function TH(e, t) {
  var n = {}, r = {}, o;
  (e === null || typeof e != "object") && (e = {}), (t === null || typeof t != "object") && (t = {});
  for (o in t)
    o in e ? n[o] = Nd(e[o], t[o]) : r[o] = t[o];
  return function(i) {
    for (o in n) r[o] = n[o](i);
    return r;
  };
}
var xu = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, hl = new RegExp(xu.source, "g");
function RH(e) {
  return function() {
    return e;
  };
}
function PH(e) {
  return function(t) {
    return e(t) + "";
  };
}
function uS(e, t) {
  var n = xu.lastIndex = hl.lastIndex = 0, r, o, i, a = -1, s = [], l = [];
  for (e = e + "", t = t + ""; (r = xu.exec(e)) && (o = hl.exec(t)); )
    (i = o.index) > n && (i = t.slice(n, i), s[a] ? s[a] += i : s[++a] = i), (r = r[0]) === (o = o[0]) ? s[a] ? s[a] += o : s[++a] = o : (s[++a] = null, l.push({ i: a, x: ci(r, o) })), n = hl.lastIndex;
  return n < t.length && (i = t.slice(n), s[a] ? s[a] += i : s[++a] = i), s.length < 2 ? l[0] ? PH(l[0].x) : RH(t) : (t = l.length, function(c) {
    for (var f = 0, u; f < t; ++f) s[(u = l[f]).i] = u.x(c);
    return s.join("");
  });
}
function Nd(e, t) {
  var n = typeof t, r;
  return t == null || n === "boolean" ? ja(t) : (n === "number" ? ci : n === "string" ? (r = wr(t)) ? (t = r, Sp) : uS : t instanceof wr ? Sp : t instanceof Date ? EH : kH(t) ? MH : Array.isArray(t) ? LH : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? TH : ci)(e, t);
}
function AH(e, t) {
  return e = +e, t = +t, function(n) {
    return Math.round(e * (1 - n) + t * n);
  };
}
function dS(e) {
  return function t(n) {
    n = +n;
    function r(o, i) {
      var a = e((o = Ot(o)).h, (i = Ot(i)).h), s = $3(o.s, i.s), l = $3(o.l, i.l), c = $3(o.opacity, i.opacity);
      return function(f) {
        return o.h = a(f), o.s = s(f), o.l = l(Math.pow(f, n)), o.opacity = c(f), o + "";
      };
    }
    return r.gamma = t, r;
  }(1);
}
dS(wH);
var Dd = dS($3), pl, Mp;
function IH() {
  if (Mp) return pl;
  Mp = 1;
  var e = a0(), t = I2(), n = nt(), r = "[object String]";
  function o(i) {
    return typeof i == "string" || !t(i) && n(i) && e(i) == r;
  }
  return pl = o, pl;
}
var OH = IH();
const NH = /* @__PURE__ */ h2(OH);
var ml, kp;
function fS() {
  if (kp) return ml;
  kp = 1;
  function e(t) {
    var n = t == null ? 0 : t.length;
    return n ? t[n - 1] : void 0;
  }
  return ml = e, ml;
}
var DH = fS();
const A1 = /* @__PURE__ */ h2(DH);
I2();
function Uo(e, t) {
  return e == null || t == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function BH(e, t) {
  return e == null || t == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function Bd(e) {
  let t, n, r;
  e.length !== 2 ? (t = Uo, n = (s, l) => Uo(e(s), l), r = (s, l) => e(s) - l) : (t = e === Uo || e === BH ? e : FH, n = e, r = e);
  function o(s, l, c = 0, f = s.length) {
    if (c < f) {
      if (t(l, l) !== 0) return f;
      do {
        const u = c + f >>> 1;
        n(s[u], l) < 0 ? c = u + 1 : f = u;
      } while (c < f);
    }
    return c;
  }
  function i(s, l, c = 0, f = s.length) {
    if (c < f) {
      if (t(l, l) !== 0) return f;
      do {
        const u = c + f >>> 1;
        n(s[u], l) <= 0 ? c = u + 1 : f = u;
      } while (c < f);
    }
    return c;
  }
  function a(s, l, c = 0, f = s.length) {
    const u = o(s, l, c, f - 1);
    return u > c && r(s[u - 1], l) > -r(s[u], l) ? u - 1 : u;
  }
  return { left: o, center: a, right: i };
}
function FH() {
  return 0;
}
function $H(e) {
  return e === null ? NaN : +e;
}
const WH = Bd(Uo), VH = WH.right;
Bd($H).center;
class Lp extends Map {
  constructor(t, n = qH) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: n } }), t != null) for (const [r, o] of t) this.set(r, o);
  }
  get(t) {
    return super.get(Ep(this, t));
  }
  has(t) {
    return super.has(Ep(this, t));
  }
  set(t, n) {
    return super.set(HH(this, t), n);
  }
  delete(t) {
    return super.delete(jH(this, t));
  }
}
function Ep({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) ? e.get(r) : n;
}
function HH({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) ? e.get(r) : (e.set(r, n), n);
}
function jH({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) && (n = e.get(r), e.delete(r)), n;
}
function qH(e) {
  return e !== null && typeof e == "object" ? e.valueOf() : e;
}
const zH = Math.sqrt(50), UH = Math.sqrt(10), GH = Math.sqrt(2);
function ui(e, t, n) {
  const r = (t - e) / Math.max(0, n), o = Math.floor(Math.log10(r)), i = r / Math.pow(10, o), a = i >= zH ? 10 : i >= UH ? 5 : i >= GH ? 2 : 1;
  let s, l, c;
  return o < 0 ? (c = Math.pow(10, -o) / a, s = Math.round(e * c), l = Math.round(t * c), s / c < e && ++s, l / c > t && --l, c = -c) : (c = Math.pow(10, o) * a, s = Math.round(e / c), l = Math.round(t / c), s * c < e && ++s, l * c > t && --l), l < s && 0.5 <= n && n < 2 ? ui(e, t, n * 2) : [s, l, c];
}
function Su(e, t, n) {
  if (t = +t, e = +e, n = +n, !(n > 0)) return [];
  if (e === t) return [e];
  const r = t < e, [o, i, a] = r ? ui(t, e, n) : ui(e, t, n);
  if (!(i >= o)) return [];
  const s = i - o + 1, l = new Array(s);
  if (r)
    if (a < 0) for (let c = 0; c < s; ++c) l[c] = (i - c) / -a;
    else for (let c = 0; c < s; ++c) l[c] = (i - c) * a;
  else if (a < 0) for (let c = 0; c < s; ++c) l[c] = (o + c) / -a;
  else for (let c = 0; c < s; ++c) l[c] = (o + c) * a;
  return l;
}
function Mu(e, t, n) {
  return t = +t, e = +e, n = +n, ui(e, t, n)[2];
}
function ku(e, t, n) {
  t = +t, e = +e, n = +n;
  const r = t < e, o = r ? Mu(t, e, n) : Mu(e, t, n);
  return (r ? -1 : 1) * (o < 0 ? 1 / -o : o);
}
function YH(e, t, n) {
  e = +e, t = +t, n = (o = arguments.length) < 2 ? (t = e, e = 0, 1) : o < 3 ? 1 : +n;
  for (var r = -1, o = Math.max(0, Math.ceil((t - e) / n)) | 0, i = new Array(o); ++r < o; )
    i[r] = e + r * n;
  return i;
}
function h3(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(e);
      break;
    default:
      this.range(t).domain(e);
      break;
  }
  return this;
}
const Tp = Symbol("implicit");
function q0() {
  var e = new Lp(), t = [], n = [], r = Tp;
  function o(i) {
    let a = e.get(i);
    if (a === void 0) {
      if (r !== Tp) return r;
      e.set(i, a = t.push(i) - 1);
    }
    return n[a % n.length];
  }
  return o.domain = function(i) {
    if (!arguments.length) return t.slice();
    t = [], e = new Lp();
    for (const a of i)
      e.has(a) || e.set(a, t.push(a) - 1);
    return o;
  }, o.range = function(i) {
    return arguments.length ? (n = Array.from(i), o) : n.slice();
  }, o.unknown = function(i) {
    return arguments.length ? (r = i, o) : r;
  }, o.copy = function() {
    return q0(t, n).unknown(r);
  }, h3.apply(o, arguments), o;
}
function Fd() {
  var e = q0().unknown(void 0), t = e.domain, n = e.range, r = 0, o = 1, i, a, s = !1, l = 0, c = 0, f = 0.5;
  delete e.unknown;
  function u() {
    var h = t().length, p = o < r, g = p ? o : r, m = p ? r : o;
    i = (m - g) / Math.max(1, h - l + c * 2), s && (i = Math.floor(i)), g += (m - g - i * (h - l)) * f, a = i * (1 - l), s && (g = Math.round(g), a = Math.round(a));
    var b = YH(h).map(function(y) {
      return g + i * y;
    });
    return n(p ? b.reverse() : b);
  }
  return e.domain = function(h) {
    return arguments.length ? (t(h), u()) : t();
  }, e.range = function(h) {
    return arguments.length ? ([r, o] = h, r = +r, o = +o, u()) : [r, o];
  }, e.rangeRound = function(h) {
    return [r, o] = h, r = +r, o = +o, s = !0, u();
  }, e.bandwidth = function() {
    return a;
  }, e.step = function() {
    return i;
  }, e.round = function(h) {
    return arguments.length ? (s = !!h, u()) : s;
  }, e.padding = function(h) {
    return arguments.length ? (l = Math.min(1, c = +h), u()) : l;
  }, e.paddingInner = function(h) {
    return arguments.length ? (l = Math.min(1, h), u()) : l;
  }, e.paddingOuter = function(h) {
    return arguments.length ? (c = +h, u()) : c;
  }, e.align = function(h) {
    return arguments.length ? (f = Math.max(0, Math.min(1, h)), u()) : f;
  }, e.copy = function() {
    return Fd(t(), [r, o]).round(s).paddingInner(l).paddingOuter(c).align(f);
  }, h3.apply(u(), arguments);
}
function hS(e) {
  var t = e.copy;
  return e.padding = e.paddingOuter, delete e.paddingInner, delete e.paddingOuter, e.copy = function() {
    return hS(t());
  }, e;
}
function ZH() {
  return hS(Fd.apply(null, arguments).paddingInner(1));
}
function KH(e) {
  return function() {
    return e;
  };
}
function XH(e) {
  return +e;
}
var Rp = [0, 1];
function P3(e) {
  return e;
}
function Lu(e, t) {
  return (t -= e = +e) ? function(n) {
    return (n - e) / t;
  } : KH(isNaN(t) ? NaN : 0.5);
}
function QH(e, t) {
  var n;
  return e > t && (n = e, e = t, t = n), function(r) {
    return Math.max(e, Math.min(t, r));
  };
}
function JH(e, t, n) {
  var r = e[0], o = e[1], i = t[0], a = t[1];
  return o < r ? (r = Lu(o, r), i = n(a, i)) : (r = Lu(r, o), i = n(i, a)), function(s) {
    return i(r(s));
  };
}
function ej(e, t, n) {
  var r = Math.min(e.length, t.length) - 1, o = new Array(r), i = new Array(r), a = -1;
  for (e[r] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++a < r; )
    o[a] = Lu(e[a], e[a + 1]), i[a] = n(t[a], t[a + 1]);
  return function(s) {
    var l = VH(e, s, 1, r) - 1;
    return i[l](o[l](s));
  };
}
function qa(e, t) {
  return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
}
function $d() {
  var e = Rp, t = Rp, n = Nd, r, o, i, a = P3, s, l, c;
  function f() {
    var h = Math.min(e.length, t.length);
    return a !== P3 && (a = QH(e[0], e[h - 1])), s = h > 2 ? ej : JH, l = c = null, u;
  }
  function u(h) {
    return h == null || isNaN(h = +h) ? i : (l || (l = s(e.map(r), t, n)))(r(a(h)));
  }
  return u.invert = function(h) {
    return a(o((c || (c = s(t, e.map(r), ci)))(h)));
  }, u.domain = function(h) {
    return arguments.length ? (e = Array.from(h, XH), f()) : e.slice();
  }, u.range = function(h) {
    return arguments.length ? (t = Array.from(h), f()) : t.slice();
  }, u.rangeRound = function(h) {
    return t = Array.from(h), n = AH, f();
  }, u.clamp = function(h) {
    return arguments.length ? (a = h ? !0 : P3, f()) : a !== P3;
  }, u.interpolate = function(h) {
    return arguments.length ? (n = h, f()) : n;
  }, u.unknown = function(h) {
    return arguments.length ? (i = h, u) : i;
  }, function(h, p) {
    return r = h, o = p, f();
  };
}
function pS() {
  return $d()(P3, P3);
}
function tj(e) {
  return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
}
function di(e, t) {
  if ((n = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0) return null;
  var n, r = e.slice(0, n);
  return [
    r.length > 1 ? r[0] + r.slice(2) : r,
    +e.slice(n + 1)
  ];
}
function G3(e) {
  return e = di(Math.abs(e)), e ? e[1] : NaN;
}
function nj(e, t) {
  return function(n, r) {
    for (var o = n.length, i = [], a = 0, s = e[0], l = 0; o > 0 && s > 0 && (l + s + 1 > r && (s = Math.max(1, r - l)), i.push(n.substring(o -= s, o + s)), !((l += s + 1) > r)); )
      s = e[a = (a + 1) % e.length];
    return i.reverse().join(t);
  };
}
function rj(e) {
  return function(t) {
    return t.replace(/[0-9]/g, function(n) {
      return e[+n];
    });
  };
}
var oj = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function xr(e) {
  if (!(t = oj.exec(e))) throw new Error("invalid format: " + e);
  var t;
  return new Wd({
    fill: t[1],
    align: t[2],
    sign: t[3],
    symbol: t[4],
    zero: t[5],
    width: t[6],
    comma: t[7],
    precision: t[8] && t[8].slice(1),
    trim: t[9],
    type: t[10]
  });
}
xr.prototype = Wd.prototype;
function Wd(e) {
  this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
}
Wd.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function ij(e) {
  e: for (var t = e.length, n = 1, r = -1, o; n < t; ++n)
    switch (e[n]) {
      case ".":
        r = o = n;
        break;
      case "0":
        r === 0 && (r = n), o = n;
        break;
      default:
        if (!+e[n]) break e;
        r > 0 && (r = 0);
        break;
    }
  return r > 0 ? e.slice(0, r) + e.slice(o + 1) : e;
}
var mS;
function aj(e, t) {
  var n = di(e, t);
  if (!n) return e + "";
  var r = n[0], o = n[1], i = o - (mS = Math.max(-8, Math.min(8, Math.floor(o / 3))) * 3) + 1, a = r.length;
  return i === a ? r : i > a ? r + new Array(i - a + 1).join("0") : i > 0 ? r.slice(0, i) + "." + r.slice(i) : "0." + new Array(1 - i).join("0") + di(e, Math.max(0, t + i - 1))[0];
}
function Pp(e, t) {
  var n = di(e, t);
  if (!n) return e + "";
  var r = n[0], o = n[1];
  return o < 0 ? "0." + new Array(-o).join("0") + r : r.length > o + 1 ? r.slice(0, o + 1) + "." + r.slice(o + 1) : r + new Array(o - r.length + 2).join("0");
}
const Ap = {
  "%": (e, t) => (e * 100).toFixed(t),
  b: (e) => Math.round(e).toString(2),
  c: (e) => e + "",
  d: tj,
  e: (e, t) => e.toExponential(t),
  f: (e, t) => e.toFixed(t),
  g: (e, t) => e.toPrecision(t),
  o: (e) => Math.round(e).toString(8),
  p: (e, t) => Pp(e * 100, t),
  r: Pp,
  s: aj,
  X: (e) => Math.round(e).toString(16).toUpperCase(),
  x: (e) => Math.round(e).toString(16)
};
function Ip(e) {
  return e;
}
var Op = Array.prototype.map, Np = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function sj(e) {
  var t = e.grouping === void 0 || e.thousands === void 0 ? Ip : nj(Op.call(e.grouping, Number), e.thousands + ""), n = e.currency === void 0 ? "" : e.currency[0] + "", r = e.currency === void 0 ? "" : e.currency[1] + "", o = e.decimal === void 0 ? "." : e.decimal + "", i = e.numerals === void 0 ? Ip : rj(Op.call(e.numerals, String)), a = e.percent === void 0 ? "%" : e.percent + "", s = e.minus === void 0 ? "−" : e.minus + "", l = e.nan === void 0 ? "NaN" : e.nan + "";
  function c(u) {
    u = xr(u);
    var h = u.fill, p = u.align, g = u.sign, m = u.symbol, b = u.zero, y = u.width, C = u.comma, _ = u.precision, M = u.trim, S = u.type;
    S === "n" ? (C = !0, S = "g") : Ap[S] || (_ === void 0 && (_ = 12), M = !0, S = "g"), (b || h === "0" && p === "=") && (b = !0, h = "0", p = "=");
    var k = m === "$" ? n : m === "#" && /[boxX]/.test(S) ? "0" + S.toLowerCase() : "", L = m === "$" ? r : /[%p]/.test(S) ? a : "", P = Ap[S], I = /[defgprs%]/.test(S);
    _ = _ === void 0 ? 6 : /[gprs]/.test(S) ? Math.max(1, Math.min(21, _)) : Math.max(0, Math.min(20, _));
    function O(E) {
      var B = k, W = L, F, z, D;
      if (S === "c")
        W = P(E) + W, E = "";
      else {
        E = +E;
        var Z = E < 0 || 1 / E < 0;
        if (E = isNaN(E) ? l : P(Math.abs(E), _), M && (E = ij(E)), Z && +E == 0 && g !== "+" && (Z = !1), B = (Z ? g === "(" ? g : s : g === "-" || g === "(" ? "" : g) + B, W = (S === "s" ? Np[8 + mS / 3] : "") + W + (Z && g === "(" ? ")" : ""), I) {
          for (F = -1, z = E.length; ++F < z; )
            if (D = E.charCodeAt(F), 48 > D || D > 57) {
              W = (D === 46 ? o + E.slice(F + 1) : E.slice(F)) + W, E = E.slice(0, F);
              break;
            }
        }
      }
      C && !b && (E = t(E, 1 / 0));
      var U = B.length + E.length + W.length, $ = U < y ? new Array(y - U + 1).join(h) : "";
      switch (C && b && (E = t($ + E, $.length ? y - W.length : 1 / 0), $ = ""), p) {
        case "<":
          E = B + E + W + $;
          break;
        case "=":
          E = B + $ + E + W;
          break;
        case "^":
          E = $.slice(0, U = $.length >> 1) + B + E + W + $.slice(U);
          break;
        default:
          E = $ + B + E + W;
          break;
      }
      return i(E);
    }
    return O.toString = function() {
      return u + "";
    }, O;
  }
  function f(u, h) {
    var p = c((u = xr(u), u.type = "f", u)), g = Math.max(-8, Math.min(8, Math.floor(G3(h) / 3))) * 3, m = Math.pow(10, -g), b = Np[8 + g / 3];
    return function(y) {
      return p(m * y) + b;
    };
  }
  return {
    format: c,
    formatPrefix: f
  };
}
var Po, Vd, gS;
lj({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function lj(e) {
  return Po = sj(e), Vd = Po.format, gS = Po.formatPrefix, Po;
}
function cj(e) {
  return Math.max(0, -G3(Math.abs(e)));
}
function uj(e, t) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(G3(t) / 3))) * 3 - G3(Math.abs(e)));
}
function dj(e, t) {
  return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, G3(t) - G3(e)) + 1;
}
function fj(e, t, n, r) {
  var o = ku(e, t, n), i;
  switch (r = xr(r ?? ",f"), r.type) {
    case "s": {
      var a = Math.max(Math.abs(e), Math.abs(t));
      return r.precision == null && !isNaN(i = uj(o, a)) && (r.precision = i), gS(r, a);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      r.precision == null && !isNaN(i = dj(o, Math.max(Math.abs(e), Math.abs(t)))) && (r.precision = i - (r.type === "e"));
      break;
    }
    case "f":
    case "%": {
      r.precision == null && !isNaN(i = cj(o)) && (r.precision = i - (r.type === "%") * 2);
      break;
    }
  }
  return Vd(r);
}
function vS(e) {
  var t = e.domain;
  return e.ticks = function(n) {
    var r = t();
    return Su(r[0], r[r.length - 1], n ?? 10);
  }, e.tickFormat = function(n, r) {
    var o = t();
    return fj(o[0], o[o.length - 1], n ?? 10, r);
  }, e.nice = function(n) {
    n == null && (n = 10);
    var r = t(), o = 0, i = r.length - 1, a = r[o], s = r[i], l, c, f = 10;
    for (s < a && (c = a, a = s, s = c, c = o, o = i, i = c); f-- > 0; ) {
      if (c = Mu(a, s, n), c === l)
        return r[o] = a, r[i] = s, t(r);
      if (c > 0)
        a = Math.floor(a / c) * c, s = Math.ceil(s / c) * c;
      else if (c < 0)
        a = Math.ceil(a * c) / c, s = Math.floor(s * c) / c;
      else
        break;
      l = c;
    }
    return e;
  }, e;
}
function bS() {
  var e = pS();
  return e.copy = function() {
    return qa(e, bS());
  }, h3.apply(e, arguments), vS(e);
}
function yS(e, t) {
  e = e.slice();
  var n = 0, r = e.length - 1, o = e[n], i = e[r], a;
  return i < o && (a = n, n = r, r = a, a = o, o = i, i = a), e[n] = t.floor(o), e[r] = t.ceil(i), e;
}
function Dp(e) {
  return Math.log(e);
}
function Bp(e) {
  return Math.exp(e);
}
function hj(e) {
  return -Math.log(-e);
}
function pj(e) {
  return -Math.exp(-e);
}
function mj(e) {
  return isFinite(e) ? +("1e" + e) : e < 0 ? 0 : e;
}
function gj(e) {
  return e === 10 ? mj : e === Math.E ? Math.exp : (t) => Math.pow(e, t);
}
function vj(e) {
  return e === Math.E ? Math.log : e === 10 && Math.log10 || e === 2 && Math.log2 || (e = Math.log(e), (t) => Math.log(t) / e);
}
function Fp(e) {
  return (t, n) => -e(-t, n);
}
function bj(e) {
  const t = e(Dp, Bp), n = t.domain;
  let r = 10, o, i;
  function a() {
    return o = vj(r), i = gj(r), n()[0] < 0 ? (o = Fp(o), i = Fp(i), e(hj, pj)) : e(Dp, Bp), t;
  }
  return t.base = function(s) {
    return arguments.length ? (r = +s, a()) : r;
  }, t.domain = function(s) {
    return arguments.length ? (n(s), a()) : n();
  }, t.ticks = (s) => {
    const l = n();
    let c = l[0], f = l[l.length - 1];
    const u = f < c;
    u && ([c, f] = [f, c]);
    let h = o(c), p = o(f), g, m;
    const b = s == null ? 10 : +s;
    let y = [];
    if (!(r % 1) && p - h < b) {
      if (h = Math.floor(h), p = Math.ceil(p), c > 0) {
        for (; h <= p; ++h)
          for (g = 1; g < r; ++g)
            if (m = h < 0 ? g / i(-h) : g * i(h), !(m < c)) {
              if (m > f) break;
              y.push(m);
            }
      } else for (; h <= p; ++h)
        for (g = r - 1; g >= 1; --g)
          if (m = h > 0 ? g / i(-h) : g * i(h), !(m < c)) {
            if (m > f) break;
            y.push(m);
          }
      y.length * 2 < b && (y = Su(c, f, b));
    } else
      y = Su(h, p, Math.min(p - h, b)).map(i);
    return u ? y.reverse() : y;
  }, t.tickFormat = (s, l) => {
    if (s == null && (s = 10), l == null && (l = r === 10 ? "s" : ","), typeof l != "function" && (!(r % 1) && (l = xr(l)).precision == null && (l.trim = !0), l = Vd(l)), s === 1 / 0) return l;
    const c = Math.max(1, r * s / t.ticks().length);
    return (f) => {
      let u = f / i(Math.round(o(f)));
      return u * r < r - 0.5 && (u *= r), u <= c ? l(f) : "";
    };
  }, t.nice = () => n(yS(n(), {
    floor: (s) => i(Math.floor(o(s))),
    ceil: (s) => i(Math.ceil(o(s)))
  })), t;
}
function CS() {
  const e = bj($d()).domain([1, 10]);
  return e.copy = () => qa(e, CS()).base(e.base()), h3.apply(e, arguments), e;
}
function $p(e) {
  return function(t) {
    return Math.sign(t) * Math.log1p(Math.abs(t / e));
  };
}
function Wp(e) {
  return function(t) {
    return Math.sign(t) * Math.expm1(Math.abs(t)) * e;
  };
}
function yj(e) {
  var t = 1, n = e($p(t), Wp(t));
  return n.constant = function(r) {
    return arguments.length ? e($p(t = +r), Wp(t)) : t;
  }, vS(n);
}
function wS() {
  var e = yj($d());
  return e.copy = function() {
    return qa(e, wS()).constant(e.constant());
  }, h3.apply(e, arguments);
}
const gl = /* @__PURE__ */ new Date(), vl = /* @__PURE__ */ new Date();
function p2(e, t, n, r) {
  function o(i) {
    return e(i = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+i)), i;
  }
  return o.floor = (i) => (e(i = /* @__PURE__ */ new Date(+i)), i), o.ceil = (i) => (e(i = new Date(i - 1)), t(i, 1), e(i), i), o.round = (i) => {
    const a = o(i), s = o.ceil(i);
    return i - a < s - i ? a : s;
  }, o.offset = (i, a) => (t(i = /* @__PURE__ */ new Date(+i), a == null ? 1 : Math.floor(a)), i), o.range = (i, a, s) => {
    const l = [];
    if (i = o.ceil(i), s = s == null ? 1 : Math.floor(s), !(i < a) || !(s > 0)) return l;
    let c;
    do
      l.push(c = /* @__PURE__ */ new Date(+i)), t(i, s), e(i);
    while (c < i && i < a);
    return l;
  }, o.filter = (i) => p2((a) => {
    if (a >= a) for (; e(a), !i(a); ) a.setTime(a - 1);
  }, (a, s) => {
    if (a >= a)
      if (s < 0) for (; ++s <= 0; )
        for (; t(a, -1), !i(a); )
          ;
      else for (; --s >= 0; )
        for (; t(a, 1), !i(a); )
          ;
  }), n && (o.count = (i, a) => (gl.setTime(+i), vl.setTime(+a), e(gl), e(vl), Math.floor(n(gl, vl))), o.every = (i) => (i = Math.floor(i), !isFinite(i) || !(i > 0) ? null : i > 1 ? o.filter(r ? (a) => r(a) % i === 0 : (a) => o.count(0, a) % i === 0) : o)), o;
}
const fi = p2(() => {
}, (e, t) => {
  e.setTime(+e + t);
}, (e, t) => t - e);
fi.every = (e) => (e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? p2((t) => {
  t.setTime(Math.floor(t / e) * e);
}, (t, n) => {
  t.setTime(+t + n * e);
}, (t, n) => (n - t) / e) : fi);
fi.range;
const Zt = 1e3, Q2 = Zt * 60, Kt = Q2 * 60, r0 = Kt * 24, Hd = r0 * 7, Vp = r0 * 30, bl = r0 * 365, z0 = p2((e) => {
  e.setTime(e - e.getMilliseconds());
}, (e, t) => {
  e.setTime(+e + t * Zt);
}, (e, t) => (t - e) / Zt, (e) => e.getUTCSeconds());
z0.range;
const jd = p2((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * Zt);
}, (e, t) => {
  e.setTime(+e + t * Q2);
}, (e, t) => (t - e) / Q2, (e) => e.getMinutes());
jd.range;
const qd = p2((e) => {
  e.setUTCSeconds(0, 0);
}, (e, t) => {
  e.setTime(+e + t * Q2);
}, (e, t) => (t - e) / Q2, (e) => e.getUTCMinutes());
qd.range;
const zd = p2((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * Zt - e.getMinutes() * Q2);
}, (e, t) => {
  e.setTime(+e + t * Kt);
}, (e, t) => (t - e) / Kt, (e) => e.getHours());
zd.range;
const Ud = p2((e) => {
  e.setUTCMinutes(0, 0, 0);
}, (e, t) => {
  e.setTime(+e + t * Kt);
}, (e, t) => (t - e) / Kt, (e) => e.getUTCHours());
Ud.range;
const io = p2(
  (e) => e.setHours(0, 0, 0, 0),
  (e, t) => e.setDate(e.getDate() + t),
  (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * Q2) / r0,
  (e) => e.getDate() - 1
);
io.range;
const za = p2((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / r0, (e) => e.getUTCDate() - 1);
za.range;
const _S = p2((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / r0, (e) => Math.floor(e / r0));
_S.range;
function p3(e) {
  return p2((t) => {
    t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
  }, (t, n) => {
    t.setDate(t.getDate() + n * 7);
  }, (t, n) => (n - t - (n.getTimezoneOffset() - t.getTimezoneOffset()) * Q2) / Hd);
}
const Ua = p3(0), hi = p3(1), Cj = p3(2), wj = p3(3), Y3 = p3(4), _j = p3(5), xj = p3(6);
Ua.range;
hi.range;
Cj.range;
wj.range;
Y3.range;
_j.range;
xj.range;
function m3(e) {
  return p2((t) => {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
  }, (t, n) => {
    t.setUTCDate(t.getUTCDate() + n * 7);
  }, (t, n) => (n - t) / Hd);
}
const Ga = m3(0), pi = m3(1), Sj = m3(2), Mj = m3(3), Z3 = m3(4), kj = m3(5), Lj = m3(6);
Ga.range;
pi.range;
Sj.range;
Mj.range;
Z3.range;
kj.range;
Lj.range;
const Gd = p2((e) => {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setMonth(e.getMonth() + t);
}, (e, t) => t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12, (e) => e.getMonth());
Gd.range;
const Yd = p2((e) => {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCMonth(e.getUTCMonth() + t);
}, (e, t) => t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12, (e) => e.getUTCMonth());
Yd.range;
const o0 = p2((e) => {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setFullYear(e.getFullYear() + t);
}, (e, t) => t.getFullYear() - e.getFullYear(), (e) => e.getFullYear());
o0.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : p2((t) => {
  t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, (t, n) => {
  t.setFullYear(t.getFullYear() + n * e);
});
o0.range;
const i0 = p2((e) => {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, (e, t) => t.getUTCFullYear() - e.getUTCFullYear(), (e) => e.getUTCFullYear());
i0.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : p2((t) => {
  t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, (t, n) => {
  t.setUTCFullYear(t.getUTCFullYear() + n * e);
});
i0.range;
function xS(e, t, n, r, o, i) {
  const a = [
    [z0, 1, Zt],
    [z0, 5, 5 * Zt],
    [z0, 15, 15 * Zt],
    [z0, 30, 30 * Zt],
    [i, 1, Q2],
    [i, 5, 5 * Q2],
    [i, 15, 15 * Q2],
    [i, 30, 30 * Q2],
    [o, 1, Kt],
    [o, 3, 3 * Kt],
    [o, 6, 6 * Kt],
    [o, 12, 12 * Kt],
    [r, 1, r0],
    [r, 2, 2 * r0],
    [n, 1, Hd],
    [t, 1, Vp],
    [t, 3, 3 * Vp],
    [e, 1, bl]
  ];
  function s(c, f, u) {
    const h = f < c;
    h && ([c, f] = [f, c]);
    const p = u && typeof u.range == "function" ? u : l(c, f, u), g = p ? p.range(c, +f + 1) : [];
    return h ? g.reverse() : g;
  }
  function l(c, f, u) {
    const h = Math.abs(f - c) / u, p = Bd(([, , b]) => b).right(a, h);
    if (p === a.length) return e.every(ku(c / bl, f / bl, u));
    if (p === 0) return fi.every(Math.max(ku(c, f, u), 1));
    const [g, m] = a[h / a[p - 1][2] < a[p][2] / h ? p - 1 : p];
    return g.every(m);
  }
  return [s, l];
}
const [Ej, Tj] = xS(i0, Yd, Ga, _S, Ud, qd), [Rj, Pj] = xS(o0, Gd, Ua, io, zd, jd);
function yl(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
    return t.setFullYear(e.y), t;
  }
  return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
}
function Cl(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
    return t.setUTCFullYear(e.y), t;
  }
  return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
}
function Rn(e, t, n) {
  return { y: e, m: t, d: n, H: 0, M: 0, S: 0, L: 0 };
}
function Aj(e) {
  var t = e.dateTime, n = e.date, r = e.time, o = e.periods, i = e.days, a = e.shortDays, s = e.months, l = e.shortMonths, c = Pn(o), f = An(o), u = Pn(i), h = An(i), p = Pn(a), g = An(a), m = Pn(s), b = An(s), y = Pn(l), C = An(l), _ = {
    a: Z,
    A: U,
    b: $,
    B: q,
    c: null,
    d: Gp,
    e: Gp,
    f: tq,
    g: dq,
    G: hq,
    H: Qj,
    I: Jj,
    j: eq,
    L: SS,
    m: nq,
    M: rq,
    p: K,
    q: V,
    Q: Kp,
    s: Xp,
    S: oq,
    u: iq,
    U: aq,
    V: sq,
    w: lq,
    W: cq,
    x: null,
    X: null,
    y: uq,
    Y: fq,
    Z: pq,
    "%": Zp
  }, M = {
    a: n1,
    A: o1,
    b: r1,
    B: X,
    c: null,
    d: Yp,
    e: Yp,
    f: bq,
    g: Eq,
    G: Rq,
    H: mq,
    I: gq,
    j: vq,
    L: kS,
    m: yq,
    M: Cq,
    p: Y,
    q: Q,
    Q: Kp,
    s: Xp,
    S: wq,
    u: _q,
    U: xq,
    V: Sq,
    w: Mq,
    W: kq,
    x: null,
    X: null,
    y: Lq,
    Y: Tq,
    Z: Pq,
    "%": Zp
  }, S = {
    a: O,
    A: E,
    b: B,
    B: W,
    c: F,
    d: zp,
    e: zp,
    f: Yj,
    g: qp,
    G: jp,
    H: Up,
    I: Up,
    j: qj,
    L: Gj,
    m: jj,
    M: zj,
    p: I,
    q: Hj,
    Q: Kj,
    s: Xj,
    S: Uj,
    u: Bj,
    U: Fj,
    V: $j,
    w: Dj,
    W: Wj,
    x: z,
    X: D,
    y: qp,
    Y: jp,
    Z: Vj,
    "%": Zj
  };
  _.x = k(n, _), _.X = k(r, _), _.c = k(t, _), M.x = k(n, M), M.X = k(r, M), M.c = k(t, M);
  function k(N, j) {
    return function(t1) {
      var T = [], u1 = -1, l1 = 0, d1 = N.length, C1, g1, D1;
      for (t1 instanceof Date || (t1 = /* @__PURE__ */ new Date(+t1)); ++u1 < d1; )
        N.charCodeAt(u1) === 37 && (T.push(N.slice(l1, u1)), (g1 = Hp[C1 = N.charAt(++u1)]) != null ? C1 = N.charAt(++u1) : g1 = C1 === "e" ? " " : "0", (D1 = j[C1]) && (C1 = D1(t1, g1)), T.push(C1), l1 = u1 + 1);
      return T.push(N.slice(l1, u1)), T.join("");
    };
  }
  function L(N, j) {
    return function(t1) {
      var T = Rn(1900, void 0, 1), u1 = P(T, N, t1 += "", 0), l1, d1;
      if (u1 != t1.length) return null;
      if ("Q" in T) return new Date(T.Q);
      if ("s" in T) return new Date(T.s * 1e3 + ("L" in T ? T.L : 0));
      if (j && !("Z" in T) && (T.Z = 0), "p" in T && (T.H = T.H % 12 + T.p * 12), T.m === void 0 && (T.m = "q" in T ? T.q : 0), "V" in T) {
        if (T.V < 1 || T.V > 53) return null;
        "w" in T || (T.w = 1), "Z" in T ? (l1 = Cl(Rn(T.y, 0, 1)), d1 = l1.getUTCDay(), l1 = d1 > 4 || d1 === 0 ? pi.ceil(l1) : pi(l1), l1 = za.offset(l1, (T.V - 1) * 7), T.y = l1.getUTCFullYear(), T.m = l1.getUTCMonth(), T.d = l1.getUTCDate() + (T.w + 6) % 7) : (l1 = yl(Rn(T.y, 0, 1)), d1 = l1.getDay(), l1 = d1 > 4 || d1 === 0 ? hi.ceil(l1) : hi(l1), l1 = io.offset(l1, (T.V - 1) * 7), T.y = l1.getFullYear(), T.m = l1.getMonth(), T.d = l1.getDate() + (T.w + 6) % 7);
      } else ("W" in T || "U" in T) && ("w" in T || (T.w = "u" in T ? T.u % 7 : "W" in T ? 1 : 0), d1 = "Z" in T ? Cl(Rn(T.y, 0, 1)).getUTCDay() : yl(Rn(T.y, 0, 1)).getDay(), T.m = 0, T.d = "W" in T ? (T.w + 6) % 7 + T.W * 7 - (d1 + 5) % 7 : T.w + T.U * 7 - (d1 + 6) % 7);
      return "Z" in T ? (T.H += T.Z / 100 | 0, T.M += T.Z % 100, Cl(T)) : yl(T);
    };
  }
  function P(N, j, t1, T) {
    for (var u1 = 0, l1 = j.length, d1 = t1.length, C1, g1; u1 < l1; ) {
      if (T >= d1) return -1;
      if (C1 = j.charCodeAt(u1++), C1 === 37) {
        if (C1 = j.charAt(u1++), g1 = S[C1 in Hp ? j.charAt(u1++) : C1], !g1 || (T = g1(N, t1, T)) < 0) return -1;
      } else if (C1 != t1.charCodeAt(T++))
        return -1;
    }
    return T;
  }
  function I(N, j, t1) {
    var T = c.exec(j.slice(t1));
    return T ? (N.p = f.get(T[0].toLowerCase()), t1 + T[0].length) : -1;
  }
  function O(N, j, t1) {
    var T = p.exec(j.slice(t1));
    return T ? (N.w = g.get(T[0].toLowerCase()), t1 + T[0].length) : -1;
  }
  function E(N, j, t1) {
    var T = u.exec(j.slice(t1));
    return T ? (N.w = h.get(T[0].toLowerCase()), t1 + T[0].length) : -1;
  }
  function B(N, j, t1) {
    var T = y.exec(j.slice(t1));
    return T ? (N.m = C.get(T[0].toLowerCase()), t1 + T[0].length) : -1;
  }
  function W(N, j, t1) {
    var T = m.exec(j.slice(t1));
    return T ? (N.m = b.get(T[0].toLowerCase()), t1 + T[0].length) : -1;
  }
  function F(N, j, t1) {
    return P(N, t, j, t1);
  }
  function z(N, j, t1) {
    return P(N, n, j, t1);
  }
  function D(N, j, t1) {
    return P(N, r, j, t1);
  }
  function Z(N) {
    return a[N.getDay()];
  }
  function U(N) {
    return i[N.getDay()];
  }
  function $(N) {
    return l[N.getMonth()];
  }
  function q(N) {
    return s[N.getMonth()];
  }
  function K(N) {
    return o[+(N.getHours() >= 12)];
  }
  function V(N) {
    return 1 + ~~(N.getMonth() / 3);
  }
  function n1(N) {
    return a[N.getUTCDay()];
  }
  function o1(N) {
    return i[N.getUTCDay()];
  }
  function r1(N) {
    return l[N.getUTCMonth()];
  }
  function X(N) {
    return s[N.getUTCMonth()];
  }
  function Y(N) {
    return o[+(N.getUTCHours() >= 12)];
  }
  function Q(N) {
    return 1 + ~~(N.getUTCMonth() / 3);
  }
  return {
    format: function(N) {
      var j = k(N += "", _);
      return j.toString = function() {
        return N;
      }, j;
    },
    parse: function(N) {
      var j = L(N += "", !1);
      return j.toString = function() {
        return N;
      }, j;
    },
    utcFormat: function(N) {
      var j = k(N += "", M);
      return j.toString = function() {
        return N;
      }, j;
    },
    utcParse: function(N) {
      var j = L(N += "", !0);
      return j.toString = function() {
        return N;
      }, j;
    }
  };
}
var Hp = { "-": "", _: " ", 0: "0" }, m2 = /^\s*\d+/, Ij = /^%/, Oj = /[\\^$*+?|[\]().{}]/g;
function _e(e, t, n) {
  var r = e < 0 ? "-" : "", o = (r ? -e : e) + "", i = o.length;
  return r + (i < n ? new Array(n - i + 1).join(t) + o : o);
}
function Nj(e) {
  return e.replace(Oj, "\\$&");
}
function Pn(e) {
  return new RegExp("^(?:" + e.map(Nj).join("|") + ")", "i");
}
function An(e) {
  return new Map(e.map((t, n) => [t.toLowerCase(), n]));
}
function Dj(e, t, n) {
  var r = m2.exec(t.slice(n, n + 1));
  return r ? (e.w = +r[0], n + r[0].length) : -1;
}
function Bj(e, t, n) {
  var r = m2.exec(t.slice(n, n + 1));
  return r ? (e.u = +r[0], n + r[0].length) : -1;
}
function Fj(e, t, n) {
  var r = m2.exec(t.slice(n, n + 2));
  return r ? (e.U = +r[0], n + r[0].length) : -1;
}
function $j(e, t, n) {
  var r = m2.exec(t.slice(n, n + 2));
  return r ? (e.V = +r[0], n + r[0].length) : -1;
}
function Wj(e, t, n) {
  var r = m2.exec(t.slice(n, n + 2));
  return r ? (e.W = +r[0], n + r[0].length) : -1;
}
function jp(e, t, n) {
  var r = m2.exec(t.slice(n, n + 4));
  return r ? (e.y = +r[0], n + r[0].length) : -1;
}
function qp(e, t, n) {
  var r = m2.exec(t.slice(n, n + 2));
  return r ? (e.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
}
function Vj(e, t, n) {
  var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(n, n + 6));
  return r ? (e.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
}
function Hj(e, t, n) {
  var r = m2.exec(t.slice(n, n + 1));
  return r ? (e.q = r[0] * 3 - 3, n + r[0].length) : -1;
}
function jj(e, t, n) {
  var r = m2.exec(t.slice(n, n + 2));
  return r ? (e.m = r[0] - 1, n + r[0].length) : -1;
}
function zp(e, t, n) {
  var r = m2.exec(t.slice(n, n + 2));
  return r ? (e.d = +r[0], n + r[0].length) : -1;
}
function qj(e, t, n) {
  var r = m2.exec(t.slice(n, n + 3));
  return r ? (e.m = 0, e.d = +r[0], n + r[0].length) : -1;
}
function Up(e, t, n) {
  var r = m2.exec(t.slice(n, n + 2));
  return r ? (e.H = +r[0], n + r[0].length) : -1;
}
function zj(e, t, n) {
  var r = m2.exec(t.slice(n, n + 2));
  return r ? (e.M = +r[0], n + r[0].length) : -1;
}
function Uj(e, t, n) {
  var r = m2.exec(t.slice(n, n + 2));
  return r ? (e.S = +r[0], n + r[0].length) : -1;
}
function Gj(e, t, n) {
  var r = m2.exec(t.slice(n, n + 3));
  return r ? (e.L = +r[0], n + r[0].length) : -1;
}
function Yj(e, t, n) {
  var r = m2.exec(t.slice(n, n + 6));
  return r ? (e.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
}
function Zj(e, t, n) {
  var r = Ij.exec(t.slice(n, n + 1));
  return r ? n + r[0].length : -1;
}
function Kj(e, t, n) {
  var r = m2.exec(t.slice(n));
  return r ? (e.Q = +r[0], n + r[0].length) : -1;
}
function Xj(e, t, n) {
  var r = m2.exec(t.slice(n));
  return r ? (e.s = +r[0], n + r[0].length) : -1;
}
function Gp(e, t) {
  return _e(e.getDate(), t, 2);
}
function Qj(e, t) {
  return _e(e.getHours(), t, 2);
}
function Jj(e, t) {
  return _e(e.getHours() % 12 || 12, t, 2);
}
function eq(e, t) {
  return _e(1 + io.count(o0(e), e), t, 3);
}
function SS(e, t) {
  return _e(e.getMilliseconds(), t, 3);
}
function tq(e, t) {
  return SS(e, t) + "000";
}
function nq(e, t) {
  return _e(e.getMonth() + 1, t, 2);
}
function rq(e, t) {
  return _e(e.getMinutes(), t, 2);
}
function oq(e, t) {
  return _e(e.getSeconds(), t, 2);
}
function iq(e) {
  var t = e.getDay();
  return t === 0 ? 7 : t;
}
function aq(e, t) {
  return _e(Ua.count(o0(e) - 1, e), t, 2);
}
function MS(e) {
  var t = e.getDay();
  return t >= 4 || t === 0 ? Y3(e) : Y3.ceil(e);
}
function sq(e, t) {
  return e = MS(e), _e(Y3.count(o0(e), e) + (o0(e).getDay() === 4), t, 2);
}
function lq(e) {
  return e.getDay();
}
function cq(e, t) {
  return _e(hi.count(o0(e) - 1, e), t, 2);
}
function uq(e, t) {
  return _e(e.getFullYear() % 100, t, 2);
}
function dq(e, t) {
  return e = MS(e), _e(e.getFullYear() % 100, t, 2);
}
function fq(e, t) {
  return _e(e.getFullYear() % 1e4, t, 4);
}
function hq(e, t) {
  var n = e.getDay();
  return e = n >= 4 || n === 0 ? Y3(e) : Y3.ceil(e), _e(e.getFullYear() % 1e4, t, 4);
}
function pq(e) {
  var t = e.getTimezoneOffset();
  return (t > 0 ? "-" : (t *= -1, "+")) + _e(t / 60 | 0, "0", 2) + _e(t % 60, "0", 2);
}
function Yp(e, t) {
  return _e(e.getUTCDate(), t, 2);
}
function mq(e, t) {
  return _e(e.getUTCHours(), t, 2);
}
function gq(e, t) {
  return _e(e.getUTCHours() % 12 || 12, t, 2);
}
function vq(e, t) {
  return _e(1 + za.count(i0(e), e), t, 3);
}
function kS(e, t) {
  return _e(e.getUTCMilliseconds(), t, 3);
}
function bq(e, t) {
  return kS(e, t) + "000";
}
function yq(e, t) {
  return _e(e.getUTCMonth() + 1, t, 2);
}
function Cq(e, t) {
  return _e(e.getUTCMinutes(), t, 2);
}
function wq(e, t) {
  return _e(e.getUTCSeconds(), t, 2);
}
function _q(e) {
  var t = e.getUTCDay();
  return t === 0 ? 7 : t;
}
function xq(e, t) {
  return _e(Ga.count(i0(e) - 1, e), t, 2);
}
function LS(e) {
  var t = e.getUTCDay();
  return t >= 4 || t === 0 ? Z3(e) : Z3.ceil(e);
}
function Sq(e, t) {
  return e = LS(e), _e(Z3.count(i0(e), e) + (i0(e).getUTCDay() === 4), t, 2);
}
function Mq(e) {
  return e.getUTCDay();
}
function kq(e, t) {
  return _e(pi.count(i0(e) - 1, e), t, 2);
}
function Lq(e, t) {
  return _e(e.getUTCFullYear() % 100, t, 2);
}
function Eq(e, t) {
  return e = LS(e), _e(e.getUTCFullYear() % 100, t, 2);
}
function Tq(e, t) {
  return _e(e.getUTCFullYear() % 1e4, t, 4);
}
function Rq(e, t) {
  var n = e.getUTCDay();
  return e = n >= 4 || n === 0 ? Z3(e) : Z3.ceil(e), _e(e.getUTCFullYear() % 1e4, t, 4);
}
function Pq() {
  return "+0000";
}
function Zp() {
  return "%";
}
function Kp(e) {
  return +e;
}
function Xp(e) {
  return Math.floor(+e / 1e3);
}
var x3, ES, TS;
Aq({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function Aq(e) {
  return x3 = Aj(e), ES = x3.format, x3.parse, TS = x3.utcFormat, x3.utcParse, x3;
}
function Iq(e) {
  return new Date(e);
}
function Oq(e) {
  return e instanceof Date ? +e : +/* @__PURE__ */ new Date(+e);
}
function Zd(e, t, n, r, o, i, a, s, l, c) {
  var f = pS(), u = f.invert, h = f.domain, p = c(".%L"), g = c(":%S"), m = c("%I:%M"), b = c("%I %p"), y = c("%a %d"), C = c("%b %d"), _ = c("%B"), M = c("%Y");
  function S(k) {
    return (l(k) < k ? p : s(k) < k ? g : a(k) < k ? m : i(k) < k ? b : r(k) < k ? o(k) < k ? y : C : n(k) < k ? _ : M)(k);
  }
  return f.invert = function(k) {
    return new Date(u(k));
  }, f.domain = function(k) {
    return arguments.length ? h(Array.from(k, Oq)) : h().map(Iq);
  }, f.ticks = function(k) {
    var L = h();
    return e(L[0], L[L.length - 1], k ?? 10);
  }, f.tickFormat = function(k, L) {
    return L == null ? S : c(L);
  }, f.nice = function(k) {
    var L = h();
    return (!k || typeof k.range != "function") && (k = t(L[0], L[L.length - 1], k ?? 10)), k ? h(yS(L, k)) : f;
  }, f.copy = function() {
    return qa(f, Zd(e, t, n, r, o, i, a, s, l, c));
  }, f;
}
function Nq() {
  return h3.apply(Zd(Rj, Pj, o0, Gd, Ua, io, zd, jd, z0, ES).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function Dq() {
  return h3.apply(Zd(Ej, Tj, i0, Yd, Ga, za, Ud, qd, z0, TS).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function K1(e) {
  for (var t = e.length / 6 | 0, n = new Array(t), r = 0; r < t; ) n[r] = "#" + e.slice(r * 6, ++r * 6);
  return n;
}
const Bq = K1("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"), Fq = K1("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666"), $q = K1("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666"), Wq = K1("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928"), Vq = K1("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2"), Hq = K1("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc"), jq = K1("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999"), qq = K1("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3"), RS = K1("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f"), zq = K1("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab"), He = (e) => SH(e[e.length - 1]);
var Ya = new Array(3).concat(
  "d8b365f5f5f55ab4ac",
  "a6611adfc27d80cdc1018571",
  "a6611adfc27df5f5f580cdc1018571",
  "8c510ad8b365f6e8c3c7eae55ab4ac01665e",
  "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e",
  "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e",
  "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e",
  "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30",
  "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30"
).map(K1);
const Uq = He(Ya);
var Za = new Array(3).concat(
  "af8dc3f7f7f77fbf7b",
  "7b3294c2a5cfa6dba0008837",
  "7b3294c2a5cff7f7f7a6dba0008837",
  "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837",
  "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837",
  "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837",
  "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837",
  "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b",
  "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b"
).map(K1);
const Gq = He(Za);
var Ka = new Array(3).concat(
  "e9a3c9f7f7f7a1d76a",
  "d01c8bf1b6dab8e1864dac26",
  "d01c8bf1b6daf7f7f7b8e1864dac26",
  "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221",
  "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221",
  "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221",
  "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221",
  "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419",
  "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419"
).map(K1);
const Yq = He(Ka);
var Xa = new Array(3).concat(
  "998ec3f7f7f7f1a340",
  "5e3c99b2abd2fdb863e66101",
  "5e3c99b2abd2f7f7f7fdb863e66101",
  "542788998ec3d8daebfee0b6f1a340b35806",
  "542788998ec3d8daebf7f7f7fee0b6f1a340b35806",
  "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806",
  "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806",
  "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08",
  "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08"
).map(K1);
const Zq = He(Xa);
var Qa = new Array(3).concat(
  "ef8a62f7f7f767a9cf",
  "ca0020f4a58292c5de0571b0",
  "ca0020f4a582f7f7f792c5de0571b0",
  "b2182bef8a62fddbc7d1e5f067a9cf2166ac",
  "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac",
  "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac",
  "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac",
  "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061",
  "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061"
).map(K1);
const Kq = He(Qa);
var Ja = new Array(3).concat(
  "ef8a62ffffff999999",
  "ca0020f4a582bababa404040",
  "ca0020f4a582ffffffbababa404040",
  "b2182bef8a62fddbc7e0e0e09999994d4d4d",
  "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d",
  "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d",
  "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d",
  "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a",
  "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a"
).map(K1);
const Xq = He(Ja);
var es = new Array(3).concat(
  "fc8d59ffffbf91bfdb",
  "d7191cfdae61abd9e92c7bb6",
  "d7191cfdae61ffffbfabd9e92c7bb6",
  "d73027fc8d59fee090e0f3f891bfdb4575b4",
  "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4",
  "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4",
  "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4",
  "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695",
  "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695"
).map(K1);
const Qq = He(es);
var ts = new Array(3).concat(
  "fc8d59ffffbf91cf60",
  "d7191cfdae61a6d96a1a9641",
  "d7191cfdae61ffffbfa6d96a1a9641",
  "d73027fc8d59fee08bd9ef8b91cf601a9850",
  "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850",
  "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850",
  "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850",
  "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837",
  "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837"
).map(K1);
const Jq = He(ts);
var ns = new Array(3).concat(
  "fc8d59ffffbf99d594",
  "d7191cfdae61abdda42b83ba",
  "d7191cfdae61ffffbfabdda42b83ba",
  "d53e4ffc8d59fee08be6f59899d5943288bd",
  "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd",
  "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd",
  "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd",
  "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2",
  "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2"
).map(K1);
const ez = He(ns);
var rs = new Array(3).concat(
  "e5f5f999d8c92ca25f",
  "edf8fbb2e2e266c2a4238b45",
  "edf8fbb2e2e266c2a42ca25f006d2c",
  "edf8fbccece699d8c966c2a42ca25f006d2c",
  "edf8fbccece699d8c966c2a441ae76238b45005824",
  "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824",
  "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b"
).map(K1);
const tz = He(rs);
var os = new Array(3).concat(
  "e0ecf49ebcda8856a7",
  "edf8fbb3cde38c96c688419d",
  "edf8fbb3cde38c96c68856a7810f7c",
  "edf8fbbfd3e69ebcda8c96c68856a7810f7c",
  "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b",
  "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b",
  "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b"
).map(K1);
const nz = He(os);
var is = new Array(3).concat(
  "e0f3dba8ddb543a2ca",
  "f0f9e8bae4bc7bccc42b8cbe",
  "f0f9e8bae4bc7bccc443a2ca0868ac",
  "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac",
  "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e",
  "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e",
  "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081"
).map(K1);
const rz = He(is);
var as = new Array(3).concat(
  "fee8c8fdbb84e34a33",
  "fef0d9fdcc8afc8d59d7301f",
  "fef0d9fdcc8afc8d59e34a33b30000",
  "fef0d9fdd49efdbb84fc8d59e34a33b30000",
  "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000",
  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000",
  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000"
).map(K1);
const oz = He(as);
var ss = new Array(3).concat(
  "ece2f0a6bddb1c9099",
  "f6eff7bdc9e167a9cf02818a",
  "f6eff7bdc9e167a9cf1c9099016c59",
  "f6eff7d0d1e6a6bddb67a9cf1c9099016c59",
  "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450",
  "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450",
  "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636"
).map(K1);
const iz = He(ss);
var ls = new Array(3).concat(
  "ece7f2a6bddb2b8cbe",
  "f1eef6bdc9e174a9cf0570b0",
  "f1eef6bdc9e174a9cf2b8cbe045a8d",
  "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d",
  "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b",
  "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b",
  "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858"
).map(K1);
const az = He(ls);
var cs = new Array(3).concat(
  "e7e1efc994c7dd1c77",
  "f1eef6d7b5d8df65b0ce1256",
  "f1eef6d7b5d8df65b0dd1c77980043",
  "f1eef6d4b9dac994c7df65b0dd1c77980043",
  "f1eef6d4b9dac994c7df65b0e7298ace125691003f",
  "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f",
  "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f"
).map(K1);
const sz = He(cs);
var us = new Array(3).concat(
  "fde0ddfa9fb5c51b8a",
  "feebe2fbb4b9f768a1ae017e",
  "feebe2fbb4b9f768a1c51b8a7a0177",
  "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177",
  "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177",
  "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177",
  "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a"
).map(K1);
const lz = He(us);
var ds = new Array(3).concat(
  "edf8b17fcdbb2c7fb8",
  "ffffcca1dab441b6c4225ea8",
  "ffffcca1dab441b6c42c7fb8253494",
  "ffffccc7e9b47fcdbb41b6c42c7fb8253494",
  "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84",
  "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84",
  "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58"
).map(K1);
const cz = He(ds);
var fs = new Array(3).concat(
  "f7fcb9addd8e31a354",
  "ffffccc2e69978c679238443",
  "ffffccc2e69978c67931a354006837",
  "ffffccd9f0a3addd8e78c67931a354006837",
  "ffffccd9f0a3addd8e78c67941ab5d238443005a32",
  "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32",
  "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529"
).map(K1);
const uz = He(fs);
var hs = new Array(3).concat(
  "fff7bcfec44fd95f0e",
  "ffffd4fed98efe9929cc4c02",
  "ffffd4fed98efe9929d95f0e993404",
  "ffffd4fee391fec44ffe9929d95f0e993404",
  "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04",
  "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04",
  "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506"
).map(K1);
const dz = He(hs);
var ps = new Array(3).concat(
  "ffeda0feb24cf03b20",
  "ffffb2fecc5cfd8d3ce31a1c",
  "ffffb2fecc5cfd8d3cf03b20bd0026",
  "ffffb2fed976feb24cfd8d3cf03b20bd0026",
  "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026",
  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026",
  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026"
).map(K1);
const fz = He(ps);
var ms = new Array(3).concat(
  "deebf79ecae13182bd",
  "eff3ffbdd7e76baed62171b5",
  "eff3ffbdd7e76baed63182bd08519c",
  "eff3ffc6dbef9ecae16baed63182bd08519c",
  "eff3ffc6dbef9ecae16baed64292c62171b5084594",
  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594",
  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b"
).map(K1);
const hz = He(ms);
var gs = new Array(3).concat(
  "e5f5e0a1d99b31a354",
  "edf8e9bae4b374c476238b45",
  "edf8e9bae4b374c47631a354006d2c",
  "edf8e9c7e9c0a1d99b74c47631a354006d2c",
  "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32",
  "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32",
  "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b"
).map(K1);
const pz = He(gs);
var vs = new Array(3).concat(
  "f0f0f0bdbdbd636363",
  "f7f7f7cccccc969696525252",
  "f7f7f7cccccc969696636363252525",
  "f7f7f7d9d9d9bdbdbd969696636363252525",
  "f7f7f7d9d9d9bdbdbd969696737373525252252525",
  "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525",
  "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000"
).map(K1);
const mz = He(vs);
var bs = new Array(3).concat(
  "efedf5bcbddc756bb1",
  "f2f0f7cbc9e29e9ac86a51a3",
  "f2f0f7cbc9e29e9ac8756bb154278f",
  "f2f0f7dadaebbcbddc9e9ac8756bb154278f",
  "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486",
  "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486",
  "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d"
).map(K1);
const gz = He(bs);
var ys = new Array(3).concat(
  "fee0d2fc9272de2d26",
  "fee5d9fcae91fb6a4acb181d",
  "fee5d9fcae91fb6a4ade2d26a50f15",
  "fee5d9fcbba1fc9272fb6a4ade2d26a50f15",
  "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d",
  "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d",
  "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d"
).map(K1);
const vz = He(ys);
var Cs = new Array(3).concat(
  "fee6cefdae6be6550d",
  "feeddefdbe85fd8d3cd94701",
  "feeddefdbe85fd8d3ce6550da63603",
  "feeddefdd0a2fdae6bfd8d3ce6550da63603",
  "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04",
  "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04",
  "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704"
).map(K1);
const bz = He(Cs);
function yz(e) {
  return e = Math.max(0, Math.min(1, e)), "rgb(" + Math.max(0, Math.min(255, Math.round(-4.54 - e * (35.34 - e * (2381.73 - e * (6402.7 - e * (7024.72 - e * 2710.57))))))) + ", " + Math.max(0, Math.min(255, Math.round(32.49 + e * (170.73 + e * (52.82 - e * (131.46 - e * (176.58 - e * 67.37))))))) + ", " + Math.max(0, Math.min(255, Math.round(81.24 + e * (442.36 - e * (2482.43 - e * (6167.24 - e * (6614.94 - e * 2475.67))))))) + ")";
}
const Cz = Dd(Ot(300, 0.5, 0), Ot(-240, 0.5, 1));
var wz = Dd(Ot(-100, 0.75, 0.35), Ot(80, 1.5, 0.8)), _z = Dd(Ot(260, 0.75, 0.35), Ot(80, 1.5, 0.8)), Ao = Ot();
function xz(e) {
  (e < 0 || e > 1) && (e -= Math.floor(e));
  var t = Math.abs(e - 0.5);
  return Ao.h = 360 * e - 100, Ao.s = 1.5 - 1.5 * t, Ao.l = 0.8 - 0.9 * t, Ao + "";
}
var Io = U3(), Sz = Math.PI / 3, Mz = Math.PI * 2 / 3;
function kz(e) {
  var t;
  return e = (0.5 - e) * Math.PI, Io.r = 255 * (t = Math.sin(e)) * t, Io.g = 255 * (t = Math.sin(e + Sz)) * t, Io.b = 255 * (t = Math.sin(e + Mz)) * t, Io + "";
}
function Lz(e) {
  return e = Math.max(0, Math.min(1, e)), "rgb(" + Math.max(0, Math.min(255, Math.round(34.61 + e * (1172.33 - e * (10793.56 - e * (33300.12 - e * (38394.49 - e * 14825.05))))))) + ", " + Math.max(0, Math.min(255, Math.round(23.31 + e * (557.33 + e * (1225.33 - e * (3574.96 - e * (1073.77 + e * 707.56))))))) + ", " + Math.max(0, Math.min(255, Math.round(27.2 + e * (3211.1 - e * (15327.97 - e * (27814 - e * (22569.18 - e * 6838.66))))))) + ")";
}
function ws(e) {
  var t = e.length;
  return function(n) {
    return e[Math.max(0, Math.min(t - 1, Math.floor(n * t)))];
  };
}
const Ez = ws(K1("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var Tz = ws(K1("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf")), Rz = ws(K1("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4")), Pz = ws(K1("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921")), Az = Ra();
const Kd = /* @__PURE__ */ h2(Az);
var wl, Qp;
function Iz() {
  if (Qp) return wl;
  Qp = 1;
  var e = "__lodash_hash_undefined__";
  function t(n) {
    return this.__data__.set(n, e), this;
  }
  return wl = t, wl;
}
var _l, Jp;
function Oz() {
  if (Jp) return _l;
  Jp = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return _l = e, _l;
}
var xl, em;
function Xd() {
  if (em) return xl;
  em = 1;
  var e = wd(), t = Iz(), n = Oz();
  function r(o) {
    var i = -1, a = o == null ? 0 : o.length;
    for (this.__data__ = new e(); ++i < a; )
      this.add(o[i]);
  }
  return r.prototype.add = r.prototype.push = t, r.prototype.has = n, xl = r, xl;
}
var Sl, tm;
function Nz() {
  if (tm) return Sl;
  tm = 1;
  function e(t, n, r, o) {
    for (var i = t.length, a = r + (o ? 1 : -1); o ? a-- : ++a < i; )
      if (n(t[a], a, t))
        return a;
    return -1;
  }
  return Sl = e, Sl;
}
var Ml, nm;
function Dz() {
  if (nm) return Ml;
  nm = 1;
  function e(t) {
    return t !== t;
  }
  return Ml = e, Ml;
}
var kl, rm;
function Bz() {
  if (rm) return kl;
  rm = 1;
  function e(t, n, r) {
    for (var o = r - 1, i = t.length; ++o < i; )
      if (t[o] === n)
        return o;
    return -1;
  }
  return kl = e, kl;
}
var Ll, om;
function Fz() {
  if (om) return Ll;
  om = 1;
  var e = Nz(), t = Dz(), n = Bz();
  function r(o, i, a) {
    return i === i ? n(o, i, a) : e(o, t, a);
  }
  return Ll = r, Ll;
}
var El, im;
function PS() {
  if (im) return El;
  im = 1;
  var e = Fz();
  function t(n, r) {
    var o = n == null ? 0 : n.length;
    return !!o && e(n, r, 0) > -1;
  }
  return El = t, El;
}
var Tl, am;
function AS() {
  if (am) return Tl;
  am = 1;
  function e(t, n, r) {
    for (var o = -1, i = t == null ? 0 : t.length; ++o < i; )
      if (r(n, t[o]))
        return !0;
    return !1;
  }
  return Tl = e, Tl;
}
var Rl, sm;
function Qd() {
  if (sm) return Rl;
  sm = 1;
  function e(t, n) {
    return t.has(n);
  }
  return Rl = e, Rl;
}
var Pl, lm;
function $z() {
  if (lm) return Pl;
  lm = 1;
  var e = Xd(), t = PS(), n = AS(), r = Wa(), o = pn(), i = Qd(), a = 200;
  function s(l, c, f, u) {
    var h = -1, p = t, g = !0, m = l.length, b = [], y = c.length;
    if (!m)
      return b;
    f && (c = r(c, o(f))), u ? (p = n, g = !1) : c.length >= a && (p = i, g = !1, c = new e(c));
    e:
      for (; ++h < m; ) {
        var C = l[h], _ = f == null ? C : f(C);
        if (C = u || C !== 0 ? C : 0, g && _ === _) {
          for (var M = y; M--; )
            if (c[M] === _)
              continue e;
          b.push(C);
        } else p(c, _, u) || b.push(C);
      }
    return b;
  }
  return Pl = s, Pl;
}
var Al, cm;
function Wz() {
  if (cm) return Al;
  cm = 1;
  var e = $z(), t = Rd(), n = Xx(), r = t(function(o, i) {
    return n(o) ? e(o, i) : [];
  });
  return Al = r, Al;
}
var Vz = Wz();
const IS = /* @__PURE__ */ h2(Vz);
function e2(e) {
  return function() {
    return e;
  };
}
const um = 1e-12, Eu = Math.PI, Tu = 2 * Eu, B0 = 1e-6, Hz = Tu - B0;
function OS(e) {
  this._ += e[0];
  for (let t = 1, n = e.length; t < n; ++t)
    this._ += arguments[t] + e[t];
}
function jz(e) {
  let t = Math.floor(e);
  if (!(t >= 0)) throw new Error(`invalid digits: ${e}`);
  if (t > 15) return OS;
  const n = 10 ** t;
  return function(r) {
    this._ += r[0];
    for (let o = 1, i = r.length; o < i; ++o)
      this._ += Math.round(arguments[o] * n) / n + r[o];
  };
}
let qz = class {
  constructor(t) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = t == null ? OS : jz(t);
  }
  moveTo(t, n) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +n}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(t, n) {
    this._append`L${this._x1 = +t},${this._y1 = +n}`;
  }
  quadraticCurveTo(t, n, r, o) {
    this._append`Q${+t},${+n},${this._x1 = +r},${this._y1 = +o}`;
  }
  bezierCurveTo(t, n, r, o, i, a) {
    this._append`C${+t},${+n},${+r},${+o},${this._x1 = +i},${this._y1 = +a}`;
  }
  arcTo(t, n, r, o, i) {
    if (t = +t, n = +n, r = +r, o = +o, i = +i, i < 0) throw new Error(`negative radius: ${i}`);
    let a = this._x1, s = this._y1, l = r - t, c = o - n, f = a - t, u = s - n, h = f * f + u * u;
    if (this._x1 === null)
      this._append`M${this._x1 = t},${this._y1 = n}`;
    else if (h > B0) if (!(Math.abs(u * l - c * f) > B0) || !i)
      this._append`L${this._x1 = t},${this._y1 = n}`;
    else {
      let p = r - a, g = o - s, m = l * l + c * c, b = p * p + g * g, y = Math.sqrt(m), C = Math.sqrt(h), _ = i * Math.tan((Eu - Math.acos((m + h - b) / (2 * y * C))) / 2), M = _ / C, S = _ / y;
      Math.abs(M - 1) > B0 && this._append`L${t + M * f},${n + M * u}`, this._append`A${i},${i},0,0,${+(u * p > f * g)},${this._x1 = t + S * l},${this._y1 = n + S * c}`;
    }
  }
  arc(t, n, r, o, i, a) {
    if (t = +t, n = +n, r = +r, a = !!a, r < 0) throw new Error(`negative radius: ${r}`);
    let s = r * Math.cos(o), l = r * Math.sin(o), c = t + s, f = n + l, u = 1 ^ a, h = a ? o - i : i - o;
    this._x1 === null ? this._append`M${c},${f}` : (Math.abs(this._x1 - c) > B0 || Math.abs(this._y1 - f) > B0) && this._append`L${c},${f}`, r && (h < 0 && (h = h % Tu + Tu), h > Hz ? this._append`A${r},${r},0,1,${u},${t - s},${n - l}A${r},${r},0,1,${u},${this._x1 = c},${this._y1 = f}` : h > B0 && this._append`A${r},${r},0,${+(h >= Eu)},${u},${this._x1 = t + r * Math.cos(i)},${this._y1 = n + r * Math.sin(i)}`);
  }
  rect(t, n, r, o) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +n}h${r = +r}v${+o}h${-r}Z`;
  }
  toString() {
    return this._;
  }
};
function NS(e) {
  let t = 3;
  return e.digits = function(n) {
    if (!arguments.length) return t;
    if (n == null)
      t = null;
    else {
      const r = Math.floor(n);
      if (!(r >= 0)) throw new RangeError(`invalid digits: ${n}`);
      t = r;
    }
    return e;
  }, () => new qz(t);
}
function Jd(e) {
  return typeof e == "object" && "length" in e ? e : Array.from(e);
}
function DS(e) {
  this._context = e;
}
DS.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      // falls through
      default:
        this._context.lineTo(e, t);
        break;
    }
  }
};
function e7(e) {
  return new DS(e);
}
function BS(e) {
  return e[0];
}
function FS(e) {
  return e[1];
}
function $S(e, t) {
  var n = e2(!0), r = null, o = e7, i = null, a = NS(s);
  e = typeof e == "function" ? e : e === void 0 ? BS : e2(e), t = typeof t == "function" ? t : t === void 0 ? FS : e2(t);
  function s(l) {
    var c, f = (l = Jd(l)).length, u, h = !1, p;
    for (r == null && (i = o(p = a())), c = 0; c <= f; ++c)
      !(c < f && n(u = l[c], c, l)) === h && ((h = !h) ? i.lineStart() : i.lineEnd()), h && i.point(+e(u, c, l), +t(u, c, l));
    if (p) return i = null, p + "" || null;
  }
  return s.x = function(l) {
    return arguments.length ? (e = typeof l == "function" ? l : e2(+l), s) : e;
  }, s.y = function(l) {
    return arguments.length ? (t = typeof l == "function" ? l : e2(+l), s) : t;
  }, s.defined = function(l) {
    return arguments.length ? (n = typeof l == "function" ? l : e2(!!l), s) : n;
  }, s.curve = function(l) {
    return arguments.length ? (o = l, r != null && (i = o(r)), s) : o;
  }, s.context = function(l) {
    return arguments.length ? (l == null ? r = i = null : i = o(r = l), s) : r;
  }, s;
}
function zz(e, t, n) {
  var r = null, o = e2(!0), i = null, a = e7, s = null, l = NS(c);
  e = typeof e == "function" ? e : e === void 0 ? BS : e2(+e), t = typeof t == "function" ? t : e2(t === void 0 ? 0 : +t), n = typeof n == "function" ? n : n === void 0 ? FS : e2(+n);
  function c(u) {
    var h, p, g, m = (u = Jd(u)).length, b, y = !1, C, _ = new Array(m), M = new Array(m);
    for (i == null && (s = a(C = l())), h = 0; h <= m; ++h) {
      if (!(h < m && o(b = u[h], h, u)) === y)
        if (y = !y)
          p = h, s.areaStart(), s.lineStart();
        else {
          for (s.lineEnd(), s.lineStart(), g = h - 1; g >= p; --g)
            s.point(_[g], M[g]);
          s.lineEnd(), s.areaEnd();
        }
      y && (_[h] = +e(b, h, u), M[h] = +t(b, h, u), s.point(r ? +r(b, h, u) : _[h], n ? +n(b, h, u) : M[h]));
    }
    if (C) return s = null, C + "" || null;
  }
  function f() {
    return $S().defined(o).curve(a).context(i);
  }
  return c.x = function(u) {
    return arguments.length ? (e = typeof u == "function" ? u : e2(+u), r = null, c) : e;
  }, c.x0 = function(u) {
    return arguments.length ? (e = typeof u == "function" ? u : e2(+u), c) : e;
  }, c.x1 = function(u) {
    return arguments.length ? (r = u == null ? null : typeof u == "function" ? u : e2(+u), c) : r;
  }, c.y = function(u) {
    return arguments.length ? (t = typeof u == "function" ? u : e2(+u), n = null, c) : t;
  }, c.y0 = function(u) {
    return arguments.length ? (t = typeof u == "function" ? u : e2(+u), c) : t;
  }, c.y1 = function(u) {
    return arguments.length ? (n = u == null ? null : typeof u == "function" ? u : e2(+u), c) : n;
  }, c.lineX0 = c.lineY0 = function() {
    return f().x(e).y(t);
  }, c.lineY1 = function() {
    return f().x(e).y(n);
  }, c.lineX1 = function() {
    return f().x(r).y(t);
  }, c.defined = function(u) {
    return arguments.length ? (o = typeof u == "function" ? u : e2(!!u), c) : o;
  }, c.curve = function(u) {
    return arguments.length ? (a = u, i != null && (s = a(i)), c) : a;
  }, c.context = function(u) {
    return arguments.length ? (u == null ? i = s = null : s = a(i = u), c) : i;
  }, c;
}
function k0() {
}
function mi(e, t, n) {
  e._context.bezierCurveTo(
    (2 * e._x0 + e._x1) / 3,
    (2 * e._y0 + e._y1) / 3,
    (e._x0 + 2 * e._x1) / 3,
    (e._y0 + 2 * e._y1) / 3,
    (e._x0 + 4 * e._x1 + t) / 6,
    (e._y0 + 4 * e._y1 + n) / 6
  );
}
function _s(e) {
  this._context = e;
}
_s.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        mi(this, this._x1, this._y1);
      // falls through
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      // falls through
      default:
        mi(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function Uz(e) {
  return new _s(e);
}
function WS(e) {
  this._context = e;
}
WS.prototype = {
  areaStart: k0,
  areaEnd: k0,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._x2 = e, this._y2 = t;
        break;
      case 1:
        this._point = 2, this._x3 = e, this._y3 = t;
        break;
      case 2:
        this._point = 3, this._x4 = e, this._y4 = t, this._context.moveTo((this._x0 + 4 * this._x1 + e) / 6, (this._y0 + 4 * this._y1 + t) / 6);
        break;
      default:
        mi(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function Gz(e) {
  return new WS(e);
}
function VS(e) {
  this._context = e;
}
VS.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var n = (this._x0 + 4 * this._x1 + e) / 6, r = (this._y0 + 4 * this._y1 + t) / 6;
        this._line ? this._context.lineTo(n, r) : this._context.moveTo(n, r);
        break;
      case 3:
        this._point = 4;
      // falls through
      default:
        mi(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function Yz(e) {
  return new VS(e);
}
function HS(e, t) {
  this._basis = new _s(e), this._beta = t;
}
HS.prototype = {
  lineStart: function() {
    this._x = [], this._y = [], this._basis.lineStart();
  },
  lineEnd: function() {
    var e = this._x, t = this._y, n = e.length - 1;
    if (n > 0)
      for (var r = e[0], o = t[0], i = e[n] - r, a = t[n] - o, s = -1, l; ++s <= n; )
        l = s / n, this._basis.point(
          this._beta * e[s] + (1 - this._beta) * (r + l * i),
          this._beta * t[s] + (1 - this._beta) * (o + l * a)
        );
    this._x = this._y = null, this._basis.lineEnd();
  },
  point: function(e, t) {
    this._x.push(+e), this._y.push(+t);
  }
};
const Zz = function e(t) {
  function n(r) {
    return t === 1 ? new _s(r) : new HS(r, t);
  }
  return n.beta = function(r) {
    return e(+r);
  }, n;
}(0.85);
function gi(e, t, n) {
  e._context.bezierCurveTo(
    e._x1 + e._k * (e._x2 - e._x0),
    e._y1 + e._k * (e._y2 - e._y0),
    e._x2 + e._k * (e._x1 - t),
    e._y2 + e._k * (e._y1 - n),
    e._x2,
    e._y2
  );
}
function t7(e, t) {
  this._context = e, this._k = (1 - t) / 6;
}
t7.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        gi(this, this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2, this._x1 = e, this._y1 = t;
        break;
      case 2:
        this._point = 3;
      // falls through
      default:
        gi(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const Kz = function e(t) {
  function n(r) {
    return new t7(r, t);
  }
  return n.tension = function(r) {
    return e(+r);
  }, n;
}(0);
function n7(e, t) {
  this._context = e, this._k = (1 - t) / 6;
}
n7.prototype = {
  areaStart: k0,
  areaEnd: k0,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._x3 = e, this._y3 = t;
        break;
      case 1:
        this._point = 2, this._context.moveTo(this._x4 = e, this._y4 = t);
        break;
      case 2:
        this._point = 3, this._x5 = e, this._y5 = t;
        break;
      default:
        gi(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const Xz = function e(t) {
  function n(r) {
    return new n7(r, t);
  }
  return n.tension = function(r) {
    return e(+r);
  }, n;
}(0);
function r7(e, t) {
  this._context = e, this._k = (1 - t) / 6;
}
r7.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      // falls through
      default:
        gi(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const Qz = function e(t) {
  function n(r) {
    return new r7(r, t);
  }
  return n.tension = function(r) {
    return e(+r);
  }, n;
}(0);
function o7(e, t, n) {
  var r = e._x1, o = e._y1, i = e._x2, a = e._y2;
  if (e._l01_a > um) {
    var s = 2 * e._l01_2a + 3 * e._l01_a * e._l12_a + e._l12_2a, l = 3 * e._l01_a * (e._l01_a + e._l12_a);
    r = (r * s - e._x0 * e._l12_2a + e._x2 * e._l01_2a) / l, o = (o * s - e._y0 * e._l12_2a + e._y2 * e._l01_2a) / l;
  }
  if (e._l23_a > um) {
    var c = 2 * e._l23_2a + 3 * e._l23_a * e._l12_a + e._l12_2a, f = 3 * e._l23_a * (e._l23_a + e._l12_a);
    i = (i * c + e._x1 * e._l23_2a - t * e._l12_2a) / f, a = (a * c + e._y1 * e._l23_2a - n * e._l12_2a) / f;
  }
  e._context.bezierCurveTo(r, o, i, a, e._x2, e._y2);
}
function jS(e, t) {
  this._context = e, this._alpha = t;
}
jS.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        this.point(this._x2, this._y2);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    if (e = +e, t = +t, this._point) {
      var n = this._x2 - e, r = this._y2 - t;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
      // falls through
      default:
        o7(this, e, t);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const Jz = function e(t) {
  function n(r) {
    return t ? new jS(r, t) : new t7(r, 0);
  }
  return n.alpha = function(r) {
    return e(+r);
  }, n;
}(0.5);
function qS(e, t) {
  this._context = e, this._alpha = t;
}
qS.prototype = {
  areaStart: k0,
  areaEnd: k0,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(e, t) {
    if (e = +e, t = +t, this._point) {
      var n = this._x2 - e, r = this._y2 - t;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1, this._x3 = e, this._y3 = t;
        break;
      case 1:
        this._point = 2, this._context.moveTo(this._x4 = e, this._y4 = t);
        break;
      case 2:
        this._point = 3, this._x5 = e, this._y5 = t;
        break;
      default:
        o7(this, e, t);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const eU = function e(t) {
  function n(r) {
    return t ? new qS(r, t) : new n7(r, 0);
  }
  return n.alpha = function(r) {
    return e(+r);
  }, n;
}(0.5);
function zS(e, t) {
  this._context = e, this._alpha = t;
}
zS.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    if (e = +e, t = +t, this._point) {
      var n = this._x2 - e, r = this._y2 - t;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      // falls through
      default:
        o7(this, e, t);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const tU = function e(t) {
  function n(r) {
    return t ? new zS(r, t) : new r7(r, 0);
  }
  return n.alpha = function(r) {
    return e(+r);
  }, n;
}(0.5);
function US(e) {
  this._context = e;
}
US.prototype = {
  areaStart: k0,
  areaEnd: k0,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(e, t) {
    e = +e, t = +t, this._point ? this._context.lineTo(e, t) : (this._point = 1, this._context.moveTo(e, t));
  }
};
function nU(e) {
  return new US(e);
}
function dm(e) {
  return e < 0 ? -1 : 1;
}
function fm(e, t, n) {
  var r = e._x1 - e._x0, o = t - e._x1, i = (e._y1 - e._y0) / (r || o < 0 && -0), a = (n - e._y1) / (o || r < 0 && -0), s = (i * o + a * r) / (r + o);
  return (dm(i) + dm(a)) * Math.min(Math.abs(i), Math.abs(a), 0.5 * Math.abs(s)) || 0;
}
function hm(e, t) {
  var n = e._x1 - e._x0;
  return n ? (3 * (e._y1 - e._y0) / n - t) / 2 : t;
}
function Il(e, t, n) {
  var r = e._x0, o = e._y0, i = e._x1, a = e._y1, s = (i - r) / 3;
  e._context.bezierCurveTo(r + s, o + s * t, i - s, a - s * n, i, a);
}
function vi(e) {
  this._context = e;
}
vi.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        Il(this, this._t0, hm(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    var n = NaN;
    if (e = +e, t = +t, !(e === this._x1 && t === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, Il(this, hm(this, n = fm(this, e, t)), n);
          break;
        default:
          Il(this, this._t0, n = fm(this, e, t));
          break;
      }
      this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t, this._t0 = n;
    }
  }
};
function GS(e) {
  this._context = new YS(e);
}
(GS.prototype = Object.create(vi.prototype)).point = function(e, t) {
  vi.prototype.point.call(this, t, e);
};
function YS(e) {
  this._context = e;
}
YS.prototype = {
  moveTo: function(e, t) {
    this._context.moveTo(t, e);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(e, t) {
    this._context.lineTo(t, e);
  },
  bezierCurveTo: function(e, t, n, r, o, i) {
    this._context.bezierCurveTo(t, e, r, n, i, o);
  }
};
function rU(e) {
  return new vi(e);
}
function oU(e) {
  return new GS(e);
}
function ZS(e) {
  this._context = e;
}
ZS.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var e = this._x, t = this._y, n = e.length;
    if (n)
      if (this._line ? this._context.lineTo(e[0], t[0]) : this._context.moveTo(e[0], t[0]), n === 2)
        this._context.lineTo(e[1], t[1]);
      else
        for (var r = pm(e), o = pm(t), i = 0, a = 1; a < n; ++i, ++a)
          this._context.bezierCurveTo(r[0][i], o[0][i], r[1][i], o[1][i], e[a], t[a]);
    (this._line || this._line !== 0 && n === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(e, t) {
    this._x.push(+e), this._y.push(+t);
  }
};
function pm(e) {
  var t, n = e.length - 1, r, o = new Array(n), i = new Array(n), a = new Array(n);
  for (o[0] = 0, i[0] = 2, a[0] = e[0] + 2 * e[1], t = 1; t < n - 1; ++t) o[t] = 1, i[t] = 4, a[t] = 4 * e[t] + 2 * e[t + 1];
  for (o[n - 1] = 2, i[n - 1] = 7, a[n - 1] = 8 * e[n - 1] + e[n], t = 1; t < n; ++t) r = o[t] / i[t - 1], i[t] -= r, a[t] -= r * a[t - 1];
  for (o[n - 1] = a[n - 1] / i[n - 1], t = n - 2; t >= 0; --t) o[t] = (a[t] - o[t + 1]) / i[t];
  for (i[n - 1] = (e[n] + o[n - 1]) / 2, t = 0; t < n - 1; ++t) i[t] = 2 * e[t + 1] - o[t + 1];
  return [o, i];
}
function iU(e) {
  return new ZS(e);
}
function xs(e, t) {
  this._context = e, this._t = t;
}
xs.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      // falls through
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, t), this._context.lineTo(e, t);
        else {
          var n = this._x * (1 - this._t) + e * this._t;
          this._context.lineTo(n, this._y), this._context.lineTo(n, t);
        }
        break;
      }
    }
    this._x = e, this._y = t;
  }
};
function aU(e) {
  return new xs(e, 0.5);
}
function sU(e) {
  return new xs(e, 0);
}
function lU(e) {
  return new xs(e, 1);
}
function mm(e, t) {
  if ((a = e.length) > 1)
    for (var n = 1, r, o, i = e[t[0]], a, s = i.length; n < a; ++n)
      for (o = i, i = e[t[n]], r = 0; r < s; ++r)
        i[r][1] += i[r][0] = isNaN(o[r][1]) ? o[r][0] : o[r][1];
}
function gm(e) {
  for (var t = e.length, n = new Array(t); --t >= 0; ) n[t] = t;
  return n;
}
function cU(e, t) {
  return e[t];
}
function uU(e) {
  const t = [];
  return t.key = e, t;
}
function dU() {
  var e = e2([]), t = gm, n = mm, r = cU;
  function o(i) {
    var a = Array.from(e.apply(this, arguments), uU), s, l = a.length, c = -1, f;
    for (const u of i)
      for (s = 0, ++c; s < l; ++s)
        (a[s][c] = [0, +r(u, a[s].key, c, i)]).data = u;
    for (s = 0, f = Jd(t(a)); s < l; ++s)
      a[f[s]].index = s;
    return n(a, f), a;
  }
  return o.keys = function(i) {
    return arguments.length ? (e = typeof i == "function" ? i : e2(Array.from(i)), o) : e;
  }, o.value = function(i) {
    return arguments.length ? (r = typeof i == "function" ? i : e2(+i), o) : r;
  }, o.order = function(i) {
    return arguments.length ? (t = i == null ? gm : typeof i == "function" ? i : e2(Array.from(i)), o) : t;
  }, o.offset = function(i) {
    return arguments.length ? (n = i ?? mm, o) : n;
  }, o;
}
function fU(e, t) {
  if ((l = e.length) > 0)
    for (var n, r = 0, o, i, a, s, l, c = e[t[0]].length; r < c; ++r)
      for (a = s = 0, n = 0; n < l; ++n)
        (i = (o = e[t[n]][r])[1] - o[0]) > 0 ? (o[0] = a, o[1] = a += i) : i < 0 ? (o[1] = s, o[0] = s += i) : (o[0] = 0, o[1] = i);
}
function hU(e) {
  return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
}
function bi(e, t) {
  if ((n = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0) return null;
  var n, r = e.slice(0, n);
  return [
    r.length > 1 ? r[0] + r.slice(2) : r,
    +e.slice(n + 1)
  ];
}
function pU(e) {
  return e = bi(Math.abs(e)), e ? e[1] : NaN;
}
function mU(e, t) {
  return function(n, r) {
    for (var o = n.length, i = [], a = 0, s = e[0], l = 0; o > 0 && s > 0 && (l + s + 1 > r && (s = Math.max(1, r - l)), i.push(n.substring(o -= s, o + s)), !((l += s + 1) > r)); )
      s = e[a = (a + 1) % e.length];
    return i.reverse().join(t);
  };
}
function gU(e) {
  return function(t) {
    return t.replace(/[0-9]/g, function(n) {
      return e[+n];
    });
  };
}
var vU = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function Ru(e) {
  if (!(t = vU.exec(e))) throw new Error("invalid format: " + e);
  var t;
  return new i7({
    fill: t[1],
    align: t[2],
    sign: t[3],
    symbol: t[4],
    zero: t[5],
    width: t[6],
    comma: t[7],
    precision: t[8] && t[8].slice(1),
    trim: t[9],
    type: t[10]
  });
}
Ru.prototype = i7.prototype;
function i7(e) {
  this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
}
i7.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function bU(e) {
  e: for (var t = e.length, n = 1, r = -1, o; n < t; ++n)
    switch (e[n]) {
      case ".":
        r = o = n;
        break;
      case "0":
        r === 0 && (r = n), o = n;
        break;
      default:
        if (!+e[n]) break e;
        r > 0 && (r = 0);
        break;
    }
  return r > 0 ? e.slice(0, r) + e.slice(o + 1) : e;
}
var KS;
function yU(e, t) {
  var n = bi(e, t);
  if (!n) return e + "";
  var r = n[0], o = n[1], i = o - (KS = Math.max(-8, Math.min(8, Math.floor(o / 3))) * 3) + 1, a = r.length;
  return i === a ? r : i > a ? r + new Array(i - a + 1).join("0") : i > 0 ? r.slice(0, i) + "." + r.slice(i) : "0." + new Array(1 - i).join("0") + bi(e, Math.max(0, t + i - 1))[0];
}
function vm(e, t) {
  var n = bi(e, t);
  if (!n) return e + "";
  var r = n[0], o = n[1];
  return o < 0 ? "0." + new Array(-o).join("0") + r : r.length > o + 1 ? r.slice(0, o + 1) + "." + r.slice(o + 1) : r + new Array(o - r.length + 2).join("0");
}
const bm = {
  "%": function(e, t) {
    return (e * 100).toFixed(t);
  },
  b: function(e) {
    return Math.round(e).toString(2);
  },
  c: function(e) {
    return e + "";
  },
  d: hU,
  e: function(e, t) {
    return e.toExponential(t);
  },
  f: function(e, t) {
    return e.toFixed(t);
  },
  g: function(e, t) {
    return e.toPrecision(t);
  },
  o: function(e) {
    return Math.round(e).toString(8);
  },
  p: function(e, t) {
    return vm(e * 100, t);
  },
  r: vm,
  s: yU,
  X: function(e) {
    return Math.round(e).toString(16).toUpperCase();
  },
  x: function(e) {
    return Math.round(e).toString(16);
  }
};
function ym(e) {
  return e;
}
var Cm = Array.prototype.map, wm = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function CU(e) {
  var t = e.grouping === void 0 || e.thousands === void 0 ? ym : mU(Cm.call(e.grouping, Number), e.thousands + ""), n = e.currency === void 0 ? "" : e.currency[0] + "", r = e.currency === void 0 ? "" : e.currency[1] + "", o = e.decimal + "", i = e.numerals === void 0 ? ym : gU(Cm.call(e.numerals, String)), a = e.percent === void 0 ? "%" : e.percent + "", s = e.minus + "", l = e.nan === void 0 ? "NaN" : e.nan + "";
  function c(u) {
    u = Ru(u);
    var h = u.fill, p = u.align, g = u.sign, m = u.symbol, b = u.zero, y = u.width, C = u.comma, _ = u.precision, M = u.trim, S = u.type;
    S === "n" ? (C = !0, S = "g") : bm[S] || (_ === void 0 && (_ = 12), M = !0, S = "g"), (b || h === "0" && p === "=") && (b = !0, h = "0", p = "=");
    var k = m === "$" ? n : m === "#" && /[boxX]/.test(S) ? "0" + S.toLowerCase() : "", L = m === "$" ? r : /[%p]/.test(S) ? a : "", P = bm[S], I = /[defgprs%]/.test(S);
    _ = _ === void 0 ? 6 : /[gprs]/.test(S) ? Math.max(1, Math.min(21, _)) : Math.max(0, Math.min(20, _));
    function O(E) {
      var B = k, W = L, F, z, D;
      if (S === "c")
        W = P(E) + W, E = "";
      else {
        E = +E;
        var Z = E < 0 || 1 / E < 0;
        if (E = isNaN(E) ? l : P(Math.abs(E), _), M && (E = bU(E)), Z && +E == 0 && g !== "+" && (Z = !1), B = (Z ? g === "(" ? g : s : g === "-" || g === "(" ? "" : g) + B, W = (S === "s" ? wm[8 + KS / 3] : "") + W + (Z && g === "(" ? ")" : ""), I) {
          for (F = -1, z = E.length; ++F < z; )
            if (D = E.charCodeAt(F), 48 > D || D > 57) {
              W = (D === 46 ? o + E.slice(F + 1) : E.slice(F)) + W, E = E.slice(0, F);
              break;
            }
        }
      }
      C && !b && (E = t(E, 1 / 0));
      var U = B.length + E.length + W.length, $ = U < y ? new Array(y - U + 1).join(h) : "";
      switch (C && b && (E = t($ + E, $.length ? y - W.length : 1 / 0), $ = ""), p) {
        case "<":
          E = B + E + W + $;
          break;
        case "=":
          E = B + $ + E + W;
          break;
        case "^":
          E = $.slice(0, U = $.length >> 1) + B + E + W + $.slice(U);
          break;
        default:
          E = $ + B + E + W;
          break;
      }
      return i(E);
    }
    return O.toString = function() {
      return u + "";
    }, O;
  }
  function f(u, h) {
    var p = c((u = Ru(u), u.type = "f", u)), g = Math.max(-8, Math.min(8, Math.floor(pU(h) / 3))) * 3, m = Math.pow(10, -g), b = wm[8 + g / 3];
    return function(y) {
      return p(m * y) + b;
    };
  }
  return {
    format: c,
    formatPrefix: f
  };
}
var Oo, a7;
wU({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""],
  minus: "-"
});
function wU(e) {
  return Oo = CU(e), a7 = Oo.format, Oo.formatPrefix, Oo;
}
var Ol = /* @__PURE__ */ new Date(), Nl = /* @__PURE__ */ new Date();
function l2(e, t, n, r) {
  function o(i) {
    return e(i = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+i)), i;
  }
  return o.floor = function(i) {
    return e(i = /* @__PURE__ */ new Date(+i)), i;
  }, o.ceil = function(i) {
    return e(i = new Date(i - 1)), t(i, 1), e(i), i;
  }, o.round = function(i) {
    var a = o(i), s = o.ceil(i);
    return i - a < s - i ? a : s;
  }, o.offset = function(i, a) {
    return t(i = /* @__PURE__ */ new Date(+i), a == null ? 1 : Math.floor(a)), i;
  }, o.range = function(i, a, s) {
    var l = [], c;
    if (i = o.ceil(i), s = s == null ? 1 : Math.floor(s), !(i < a) || !(s > 0)) return l;
    do
      l.push(c = /* @__PURE__ */ new Date(+i)), t(i, s), e(i);
    while (c < i && i < a);
    return l;
  }, o.filter = function(i) {
    return l2(function(a) {
      if (a >= a) for (; e(a), !i(a); ) a.setTime(a - 1);
    }, function(a, s) {
      if (a >= a)
        if (s < 0) for (; ++s <= 0; )
          for (; t(a, -1), !i(a); )
            ;
        else for (; --s >= 0; )
          for (; t(a, 1), !i(a); )
            ;
    });
  }, n && (o.count = function(i, a) {
    return Ol.setTime(+i), Nl.setTime(+a), e(Ol), e(Nl), Math.floor(n(Ol, Nl));
  }, o.every = function(i) {
    return i = Math.floor(i), !isFinite(i) || !(i > 0) ? null : i > 1 ? o.filter(r ? function(a) {
      return r(a) % i === 0;
    } : function(a) {
      return o.count(0, a) % i === 0;
    }) : o;
  }), o;
}
var Sr = l2(function() {
}, function(e, t) {
  e.setTime(+e + t);
}, function(e, t) {
  return t - e;
});
Sr.every = function(e) {
  return e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? l2(function(t) {
    t.setTime(Math.floor(t / e) * e);
  }, function(t, n) {
    t.setTime(+t + n * e);
  }, function(t, n) {
    return (n - t) / e;
  }) : Sr;
};
Sr.range;
var yi = 1e3, o3 = 6e4, Ci = 36e5, XS = 864e5, QS = 6048e5, Pu = l2(function(e) {
  e.setTime(e - e.getMilliseconds());
}, function(e, t) {
  e.setTime(+e + t * yi);
}, function(e, t) {
  return (t - e) / yi;
}, function(e) {
  return e.getUTCSeconds();
});
Pu.range;
var JS = l2(function(e) {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * yi);
}, function(e, t) {
  e.setTime(+e + t * o3);
}, function(e, t) {
  return (t - e) / o3;
}, function(e) {
  return e.getMinutes();
});
JS.range;
var eM = l2(function(e) {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * yi - e.getMinutes() * o3);
}, function(e, t) {
  e.setTime(+e + t * Ci);
}, function(e, t) {
  return (t - e) / Ci;
}, function(e) {
  return e.getHours();
});
eM.range;
var s7 = l2(function(e) {
  e.setHours(0, 0, 0, 0);
}, function(e, t) {
  e.setDate(e.getDate() + t);
}, function(e, t) {
  return (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * o3) / XS;
}, function(e) {
  return e.getDate() - 1;
});
s7.range;
function g3(e) {
  return l2(function(t) {
    t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
  }, function(t, n) {
    t.setDate(t.getDate() + n * 7);
  }, function(t, n) {
    return (n - t - (n.getTimezoneOffset() - t.getTimezoneOffset()) * o3) / QS;
  });
}
var wi = g3(0), Mr = g3(1), tM = g3(2), nM = g3(3), i3 = g3(4), rM = g3(5), oM = g3(6);
wi.range;
Mr.range;
tM.range;
nM.range;
i3.range;
rM.range;
oM.range;
var iM = l2(function(e) {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, function(e, t) {
  e.setMonth(e.getMonth() + t);
}, function(e, t) {
  return t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12;
}, function(e) {
  return e.getMonth();
});
iM.range;
var L0 = l2(function(e) {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, function(e, t) {
  e.setFullYear(e.getFullYear() + t);
}, function(e, t) {
  return t.getFullYear() - e.getFullYear();
}, function(e) {
  return e.getFullYear();
});
L0.every = function(e) {
  return !isFinite(e = Math.floor(e)) || !(e > 0) ? null : l2(function(t) {
    t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
  }, function(t, n) {
    t.setFullYear(t.getFullYear() + n * e);
  });
};
L0.range;
var aM = l2(function(e) {
  e.setUTCSeconds(0, 0);
}, function(e, t) {
  e.setTime(+e + t * o3);
}, function(e, t) {
  return (t - e) / o3;
}, function(e) {
  return e.getUTCMinutes();
});
aM.range;
var sM = l2(function(e) {
  e.setUTCMinutes(0, 0, 0);
}, function(e, t) {
  e.setTime(+e + t * Ci);
}, function(e, t) {
  return (t - e) / Ci;
}, function(e) {
  return e.getUTCHours();
});
sM.range;
var l7 = l2(function(e) {
  e.setUTCHours(0, 0, 0, 0);
}, function(e, t) {
  e.setUTCDate(e.getUTCDate() + t);
}, function(e, t) {
  return (t - e) / XS;
}, function(e) {
  return e.getUTCDate() - 1;
});
l7.range;
function v3(e) {
  return l2(function(t) {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
  }, function(t, n) {
    t.setUTCDate(t.getUTCDate() + n * 7);
  }, function(t, n) {
    return (n - t) / QS;
  });
}
var _i = v3(0), kr = v3(1), lM = v3(2), cM = v3(3), a3 = v3(4), uM = v3(5), dM = v3(6);
_i.range;
kr.range;
lM.range;
cM.range;
a3.range;
uM.range;
dM.range;
var fM = l2(function(e) {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, function(e, t) {
  e.setUTCMonth(e.getUTCMonth() + t);
}, function(e, t) {
  return t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12;
}, function(e) {
  return e.getUTCMonth();
});
fM.range;
var E0 = l2(function(e) {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, function(e, t) {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, function(e, t) {
  return t.getUTCFullYear() - e.getUTCFullYear();
}, function(e) {
  return e.getUTCFullYear();
});
E0.every = function(e) {
  return !isFinite(e = Math.floor(e)) || !(e > 0) ? null : l2(function(t) {
    t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  }, function(t, n) {
    t.setUTCFullYear(t.getUTCFullYear() + n * e);
  });
};
E0.range;
function Dl(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
    return t.setFullYear(e.y), t;
  }
  return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
}
function Bl(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
    return t.setUTCFullYear(e.y), t;
  }
  return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
}
function In(e, t, n) {
  return { y: e, m: t, d: n, H: 0, M: 0, S: 0, L: 0 };
}
function _U(e) {
  var t = e.dateTime, n = e.date, r = e.time, o = e.periods, i = e.days, a = e.shortDays, s = e.months, l = e.shortMonths, c = On(o), f = Nn(o), u = On(i), h = Nn(i), p = On(a), g = Nn(a), m = On(s), b = Nn(s), y = On(l), C = Nn(l), _ = {
    a: Z,
    A: U,
    b: $,
    B: q,
    c: null,
    d: Lm,
    e: Lm,
    f: zU,
    g: tG,
    G: rG,
    H: HU,
    I: jU,
    j: qU,
    L: hM,
    m: UU,
    M: GU,
    p: K,
    q: V,
    Q: Rm,
    s: Pm,
    S: YU,
    u: ZU,
    U: KU,
    V: XU,
    w: QU,
    W: JU,
    x: null,
    X: null,
    y: eG,
    Y: nG,
    Z: oG,
    "%": Tm
  }, M = {
    a: n1,
    A: o1,
    b: r1,
    B: X,
    c: null,
    d: Em,
    e: Em,
    f: lG,
    g: bG,
    G: CG,
    H: iG,
    I: aG,
    j: sG,
    L: mM,
    m: cG,
    M: uG,
    p: Y,
    q: Q,
    Q: Rm,
    s: Pm,
    S: dG,
    u: fG,
    U: hG,
    V: pG,
    w: mG,
    W: gG,
    x: null,
    X: null,
    y: vG,
    Y: yG,
    Z: wG,
    "%": Tm
  }, S = {
    a: O,
    A: E,
    b: B,
    B: W,
    c: F,
    d: Mm,
    e: Mm,
    f: FU,
    g: Sm,
    G: xm,
    H: km,
    I: km,
    j: OU,
    L: BU,
    m: IU,
    M: NU,
    p: I,
    q: AU,
    Q: WU,
    s: VU,
    S: DU,
    u: LU,
    U: EU,
    V: TU,
    w: kU,
    W: RU,
    x: z,
    X: D,
    y: Sm,
    Y: xm,
    Z: PU,
    "%": $U
  };
  _.x = k(n, _), _.X = k(r, _), _.c = k(t, _), M.x = k(n, M), M.X = k(r, M), M.c = k(t, M);
  function k(N, j) {
    return function(t1) {
      var T = [], u1 = -1, l1 = 0, d1 = N.length, C1, g1, D1;
      for (t1 instanceof Date || (t1 = /* @__PURE__ */ new Date(+t1)); ++u1 < d1; )
        N.charCodeAt(u1) === 37 && (T.push(N.slice(l1, u1)), (g1 = _m[C1 = N.charAt(++u1)]) != null ? C1 = N.charAt(++u1) : g1 = C1 === "e" ? " " : "0", (D1 = j[C1]) && (C1 = D1(t1, g1)), T.push(C1), l1 = u1 + 1);
      return T.push(N.slice(l1, u1)), T.join("");
    };
  }
  function L(N, j) {
    return function(t1) {
      var T = In(1900, void 0, 1), u1 = P(T, N, t1 += "", 0), l1, d1;
      if (u1 != t1.length) return null;
      if ("Q" in T) return new Date(T.Q);
      if ("s" in T) return new Date(T.s * 1e3 + ("L" in T ? T.L : 0));
      if (j && !("Z" in T) && (T.Z = 0), "p" in T && (T.H = T.H % 12 + T.p * 12), T.m === void 0 && (T.m = "q" in T ? T.q : 0), "V" in T) {
        if (T.V < 1 || T.V > 53) return null;
        "w" in T || (T.w = 1), "Z" in T ? (l1 = Bl(In(T.y, 0, 1)), d1 = l1.getUTCDay(), l1 = d1 > 4 || d1 === 0 ? kr.ceil(l1) : kr(l1), l1 = l7.offset(l1, (T.V - 1) * 7), T.y = l1.getUTCFullYear(), T.m = l1.getUTCMonth(), T.d = l1.getUTCDate() + (T.w + 6) % 7) : (l1 = Dl(In(T.y, 0, 1)), d1 = l1.getDay(), l1 = d1 > 4 || d1 === 0 ? Mr.ceil(l1) : Mr(l1), l1 = s7.offset(l1, (T.V - 1) * 7), T.y = l1.getFullYear(), T.m = l1.getMonth(), T.d = l1.getDate() + (T.w + 6) % 7);
      } else ("W" in T || "U" in T) && ("w" in T || (T.w = "u" in T ? T.u % 7 : "W" in T ? 1 : 0), d1 = "Z" in T ? Bl(In(T.y, 0, 1)).getUTCDay() : Dl(In(T.y, 0, 1)).getDay(), T.m = 0, T.d = "W" in T ? (T.w + 6) % 7 + T.W * 7 - (d1 + 5) % 7 : T.w + T.U * 7 - (d1 + 6) % 7);
      return "Z" in T ? (T.H += T.Z / 100 | 0, T.M += T.Z % 100, Bl(T)) : Dl(T);
    };
  }
  function P(N, j, t1, T) {
    for (var u1 = 0, l1 = j.length, d1 = t1.length, C1, g1; u1 < l1; ) {
      if (T >= d1) return -1;
      if (C1 = j.charCodeAt(u1++), C1 === 37) {
        if (C1 = j.charAt(u1++), g1 = S[C1 in _m ? j.charAt(u1++) : C1], !g1 || (T = g1(N, t1, T)) < 0) return -1;
      } else if (C1 != t1.charCodeAt(T++))
        return -1;
    }
    return T;
  }
  function I(N, j, t1) {
    var T = c.exec(j.slice(t1));
    return T ? (N.p = f.get(T[0].toLowerCase()), t1 + T[0].length) : -1;
  }
  function O(N, j, t1) {
    var T = p.exec(j.slice(t1));
    return T ? (N.w = g.get(T[0].toLowerCase()), t1 + T[0].length) : -1;
  }
  function E(N, j, t1) {
    var T = u.exec(j.slice(t1));
    return T ? (N.w = h.get(T[0].toLowerCase()), t1 + T[0].length) : -1;
  }
  function B(N, j, t1) {
    var T = y.exec(j.slice(t1));
    return T ? (N.m = C.get(T[0].toLowerCase()), t1 + T[0].length) : -1;
  }
  function W(N, j, t1) {
    var T = m.exec(j.slice(t1));
    return T ? (N.m = b.get(T[0].toLowerCase()), t1 + T[0].length) : -1;
  }
  function F(N, j, t1) {
    return P(N, t, j, t1);
  }
  function z(N, j, t1) {
    return P(N, n, j, t1);
  }
  function D(N, j, t1) {
    return P(N, r, j, t1);
  }
  function Z(N) {
    return a[N.getDay()];
  }
  function U(N) {
    return i[N.getDay()];
  }
  function $(N) {
    return l[N.getMonth()];
  }
  function q(N) {
    return s[N.getMonth()];
  }
  function K(N) {
    return o[+(N.getHours() >= 12)];
  }
  function V(N) {
    return 1 + ~~(N.getMonth() / 3);
  }
  function n1(N) {
    return a[N.getUTCDay()];
  }
  function o1(N) {
    return i[N.getUTCDay()];
  }
  function r1(N) {
    return l[N.getUTCMonth()];
  }
  function X(N) {
    return s[N.getUTCMonth()];
  }
  function Y(N) {
    return o[+(N.getUTCHours() >= 12)];
  }
  function Q(N) {
    return 1 + ~~(N.getUTCMonth() / 3);
  }
  return {
    format: function(N) {
      var j = k(N += "", _);
      return j.toString = function() {
        return N;
      }, j;
    },
    parse: function(N) {
      var j = L(N += "", !1);
      return j.toString = function() {
        return N;
      }, j;
    },
    utcFormat: function(N) {
      var j = k(N += "", M);
      return j.toString = function() {
        return N;
      }, j;
    },
    utcParse: function(N) {
      var j = L(N += "", !0);
      return j.toString = function() {
        return N;
      }, j;
    }
  };
}
var _m = { "-": "", _: " ", 0: "0" }, g2 = /^\s*\d+/, xU = /^%/, SU = /[\\^$*+?|[\]().{}]/g;
function xe(e, t, n) {
  var r = e < 0 ? "-" : "", o = (r ? -e : e) + "", i = o.length;
  return r + (i < n ? new Array(n - i + 1).join(t) + o : o);
}
function MU(e) {
  return e.replace(SU, "\\$&");
}
function On(e) {
  return new RegExp("^(?:" + e.map(MU).join("|") + ")", "i");
}
function Nn(e) {
  return new Map(e.map((t, n) => [t.toLowerCase(), n]));
}
function kU(e, t, n) {
  var r = g2.exec(t.slice(n, n + 1));
  return r ? (e.w = +r[0], n + r[0].length) : -1;
}
function LU(e, t, n) {
  var r = g2.exec(t.slice(n, n + 1));
  return r ? (e.u = +r[0], n + r[0].length) : -1;
}
function EU(e, t, n) {
  var r = g2.exec(t.slice(n, n + 2));
  return r ? (e.U = +r[0], n + r[0].length) : -1;
}
function TU(e, t, n) {
  var r = g2.exec(t.slice(n, n + 2));
  return r ? (e.V = +r[0], n + r[0].length) : -1;
}
function RU(e, t, n) {
  var r = g2.exec(t.slice(n, n + 2));
  return r ? (e.W = +r[0], n + r[0].length) : -1;
}
function xm(e, t, n) {
  var r = g2.exec(t.slice(n, n + 4));
  return r ? (e.y = +r[0], n + r[0].length) : -1;
}
function Sm(e, t, n) {
  var r = g2.exec(t.slice(n, n + 2));
  return r ? (e.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
}
function PU(e, t, n) {
  var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(n, n + 6));
  return r ? (e.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
}
function AU(e, t, n) {
  var r = g2.exec(t.slice(n, n + 1));
  return r ? (e.q = r[0] * 3 - 3, n + r[0].length) : -1;
}
function IU(e, t, n) {
  var r = g2.exec(t.slice(n, n + 2));
  return r ? (e.m = r[0] - 1, n + r[0].length) : -1;
}
function Mm(e, t, n) {
  var r = g2.exec(t.slice(n, n + 2));
  return r ? (e.d = +r[0], n + r[0].length) : -1;
}
function OU(e, t, n) {
  var r = g2.exec(t.slice(n, n + 3));
  return r ? (e.m = 0, e.d = +r[0], n + r[0].length) : -1;
}
function km(e, t, n) {
  var r = g2.exec(t.slice(n, n + 2));
  return r ? (e.H = +r[0], n + r[0].length) : -1;
}
function NU(e, t, n) {
  var r = g2.exec(t.slice(n, n + 2));
  return r ? (e.M = +r[0], n + r[0].length) : -1;
}
function DU(e, t, n) {
  var r = g2.exec(t.slice(n, n + 2));
  return r ? (e.S = +r[0], n + r[0].length) : -1;
}
function BU(e, t, n) {
  var r = g2.exec(t.slice(n, n + 3));
  return r ? (e.L = +r[0], n + r[0].length) : -1;
}
function FU(e, t, n) {
  var r = g2.exec(t.slice(n, n + 6));
  return r ? (e.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
}
function $U(e, t, n) {
  var r = xU.exec(t.slice(n, n + 1));
  return r ? n + r[0].length : -1;
}
function WU(e, t, n) {
  var r = g2.exec(t.slice(n));
  return r ? (e.Q = +r[0], n + r[0].length) : -1;
}
function VU(e, t, n) {
  var r = g2.exec(t.slice(n));
  return r ? (e.s = +r[0], n + r[0].length) : -1;
}
function Lm(e, t) {
  return xe(e.getDate(), t, 2);
}
function HU(e, t) {
  return xe(e.getHours(), t, 2);
}
function jU(e, t) {
  return xe(e.getHours() % 12 || 12, t, 2);
}
function qU(e, t) {
  return xe(1 + s7.count(L0(e), e), t, 3);
}
function hM(e, t) {
  return xe(e.getMilliseconds(), t, 3);
}
function zU(e, t) {
  return hM(e, t) + "000";
}
function UU(e, t) {
  return xe(e.getMonth() + 1, t, 2);
}
function GU(e, t) {
  return xe(e.getMinutes(), t, 2);
}
function YU(e, t) {
  return xe(e.getSeconds(), t, 2);
}
function ZU(e) {
  var t = e.getDay();
  return t === 0 ? 7 : t;
}
function KU(e, t) {
  return xe(wi.count(L0(e) - 1, e), t, 2);
}
function pM(e) {
  var t = e.getDay();
  return t >= 4 || t === 0 ? i3(e) : i3.ceil(e);
}
function XU(e, t) {
  return e = pM(e), xe(i3.count(L0(e), e) + (L0(e).getDay() === 4), t, 2);
}
function QU(e) {
  return e.getDay();
}
function JU(e, t) {
  return xe(Mr.count(L0(e) - 1, e), t, 2);
}
function eG(e, t) {
  return xe(e.getFullYear() % 100, t, 2);
}
function tG(e, t) {
  return e = pM(e), xe(e.getFullYear() % 100, t, 2);
}
function nG(e, t) {
  return xe(e.getFullYear() % 1e4, t, 4);
}
function rG(e, t) {
  var n = e.getDay();
  return e = n >= 4 || n === 0 ? i3(e) : i3.ceil(e), xe(e.getFullYear() % 1e4, t, 4);
}
function oG(e) {
  var t = e.getTimezoneOffset();
  return (t > 0 ? "-" : (t *= -1, "+")) + xe(t / 60 | 0, "0", 2) + xe(t % 60, "0", 2);
}
function Em(e, t) {
  return xe(e.getUTCDate(), t, 2);
}
function iG(e, t) {
  return xe(e.getUTCHours(), t, 2);
}
function aG(e, t) {
  return xe(e.getUTCHours() % 12 || 12, t, 2);
}
function sG(e, t) {
  return xe(1 + l7.count(E0(e), e), t, 3);
}
function mM(e, t) {
  return xe(e.getUTCMilliseconds(), t, 3);
}
function lG(e, t) {
  return mM(e, t) + "000";
}
function cG(e, t) {
  return xe(e.getUTCMonth() + 1, t, 2);
}
function uG(e, t) {
  return xe(e.getUTCMinutes(), t, 2);
}
function dG(e, t) {
  return xe(e.getUTCSeconds(), t, 2);
}
function fG(e) {
  var t = e.getUTCDay();
  return t === 0 ? 7 : t;
}
function hG(e, t) {
  return xe(_i.count(E0(e) - 1, e), t, 2);
}
function gM(e) {
  var t = e.getUTCDay();
  return t >= 4 || t === 0 ? a3(e) : a3.ceil(e);
}
function pG(e, t) {
  return e = gM(e), xe(a3.count(E0(e), e) + (E0(e).getUTCDay() === 4), t, 2);
}
function mG(e) {
  return e.getUTCDay();
}
function gG(e, t) {
  return xe(kr.count(E0(e) - 1, e), t, 2);
}
function vG(e, t) {
  return xe(e.getUTCFullYear() % 100, t, 2);
}
function bG(e, t) {
  return e = gM(e), xe(e.getUTCFullYear() % 100, t, 2);
}
function yG(e, t) {
  return xe(e.getUTCFullYear() % 1e4, t, 4);
}
function CG(e, t) {
  var n = e.getUTCDay();
  return e = n >= 4 || n === 0 ? a3(e) : a3.ceil(e), xe(e.getUTCFullYear() % 1e4, t, 4);
}
function wG() {
  return "+0000";
}
function Tm() {
  return "%";
}
function Rm(e) {
  return +e;
}
function Pm(e) {
  return Math.floor(+e / 1e3);
}
var S3, c7, vM, bM;
_G({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function _G(e) {
  return S3 = _U(e), c7 = S3.format, vM = S3.parse, S3.utcFormat, bM = S3.utcParse, S3;
}
var xG = Ld();
const u7 = /* @__PURE__ */ h2(xG);
var Fl, Am;
function SG() {
  if (Am) return Fl;
  Am = 1;
  var e = oo(), t = iS(), n = gn();
  function r(o, i, a) {
    for (var s = -1, l = i.length, c = {}; ++s < l; ) {
      var f = i[s], u = e(o, f);
      a(u, f) && t(c, n(f, o), u);
    }
    return c;
  }
  return Fl = r, Fl;
}
var $l, Im;
function MG() {
  if (Im) return $l;
  Im = 1;
  function e(t, n) {
    return t != null && n in Object(t);
  }
  return $l = e, $l;
}
var Wl, Om;
function kG() {
  if (Om) return Wl;
  Om = 1;
  var e = gn(), t = Oa(), n = I2(), r = Ba(), o = kd(), i = vn();
  function a(s, l, c) {
    l = e(l, s);
    for (var f = -1, u = l.length, h = !1; ++f < u; ) {
      var p = i(l[f]);
      if (!(h = s != null && c(s, p)))
        break;
      s = s[p];
    }
    return h || ++f != u ? h : (u = s == null ? 0 : s.length, !!u && o(u) && r(p, u) && (n(s) || t(s)));
  }
  return Wl = a, Wl;
}
var Vl, Nm;
function yM() {
  if (Nm) return Vl;
  Nm = 1;
  var e = MG(), t = kG();
  function n(r, o) {
    return r != null && t(r, o, e);
  }
  return Vl = n, Vl;
}
var Hl, Dm;
function LG() {
  if (Dm) return Hl;
  Dm = 1;
  var e = SG(), t = yM();
  function n(r, o) {
    return e(r, o, function(i, a) {
      return t(r, a);
    });
  }
  return Hl = n, Hl;
}
var jl, Bm;
function d7() {
  if (Bm) return jl;
  Bm = 1;
  function e(t, n) {
    for (var r = -1, o = n.length, i = t.length; ++r < o; )
      t[i + r] = n[r];
    return t;
  }
  return jl = e, jl;
}
var ql, Fm;
function EG() {
  if (Fm) return ql;
  Fm = 1;
  var e = fn(), t = Oa(), n = I2(), r = e ? e.isConcatSpreadable : void 0;
  function o(i) {
    return n(i) || t(i) || !!(r && i && i[r]);
  }
  return ql = o, ql;
}
var zl, $m;
function CM() {
  if ($m) return zl;
  $m = 1;
  var e = d7(), t = EG();
  function n(r, o, i, a, s) {
    var l = -1, c = r.length;
    for (i || (i = t), s || (s = []); ++l < c; ) {
      var f = r[l];
      o > 0 && i(f) ? o > 1 ? n(f, o - 1, i, a, s) : e(s, f) : a || (s[s.length] = f);
    }
    return s;
  }
  return zl = n, zl;
}
var Ul, Wm;
function TG() {
  if (Wm) return Ul;
  Wm = 1;
  var e = CM();
  function t(n) {
    var r = n == null ? 0 : n.length;
    return r ? e(n, 1) : [];
  }
  return Ul = t, Ul;
}
var Gl, Vm;
function wM() {
  if (Vm) return Gl;
  Vm = 1;
  var e = TG(), t = eS(), n = tS();
  function r(o) {
    return n(t(o, void 0, e), o + "");
  }
  return Gl = r, Gl;
}
var Yl, Hm;
function RG() {
  if (Hm) return Yl;
  Hm = 1;
  var e = LG(), t = wM(), n = t(function(r, o) {
    return r == null ? {} : e(r, o);
  });
  return Yl = n, Yl;
}
var PG = RG();
const AG = /* @__PURE__ */ h2(PG);
var Zl, jm;
function IG() {
  if (jm) return Zl;
  jm = 1;
  function e(t, n) {
    for (var r = -1, o = t == null ? 0 : t.length; ++r < o; )
      if (n(t[r], r, t))
        return !0;
    return !1;
  }
  return Zl = e, Zl;
}
var Kl, qm;
function _M() {
  if (qm) return Kl;
  qm = 1;
  var e = Xd(), t = IG(), n = Qd(), r = 1, o = 2;
  function i(a, s, l, c, f, u) {
    var h = l & r, p = a.length, g = s.length;
    if (p != g && !(h && g > p))
      return !1;
    var m = u.get(a), b = u.get(s);
    if (m && b)
      return m == s && b == a;
    var y = -1, C = !0, _ = l & o ? new e() : void 0;
    for (u.set(a, s), u.set(s, a); ++y < p; ) {
      var M = a[y], S = s[y];
      if (c)
        var k = h ? c(S, M, y, s, a, u) : c(M, S, y, a, s, u);
      if (k !== void 0) {
        if (k)
          continue;
        C = !1;
        break;
      }
      if (_) {
        if (!t(s, function(L, P) {
          if (!n(_, P) && (M === L || f(M, L, l, c, u)))
            return _.push(P);
        })) {
          C = !1;
          break;
        }
      } else if (!(M === S || f(M, S, l, c, u))) {
        C = !1;
        break;
      }
    }
    return u.delete(a), u.delete(s), C;
  }
  return Kl = i, Kl;
}
var Xl, zm;
function OG() {
  if (zm) return Xl;
  zm = 1;
  function e(t) {
    var n = -1, r = Array(t.size);
    return t.forEach(function(o, i) {
      r[++n] = [i, o];
    }), r;
  }
  return Xl = e, Xl;
}
var Ql, Um;
function f7() {
  if (Um) return Ql;
  Um = 1;
  function e(t) {
    var n = -1, r = Array(t.size);
    return t.forEach(function(o) {
      r[++n] = o;
    }), r;
  }
  return Ql = e, Ql;
}
var Jl, Gm;
function NG() {
  if (Gm) return Jl;
  Gm = 1;
  var e = fn(), t = Ux(), n = no(), r = _M(), o = OG(), i = f7(), a = 1, s = 2, l = "[object Boolean]", c = "[object Date]", f = "[object Error]", u = "[object Map]", h = "[object Number]", p = "[object RegExp]", g = "[object Set]", m = "[object String]", b = "[object Symbol]", y = "[object ArrayBuffer]", C = "[object DataView]", _ = e ? e.prototype : void 0, M = _ ? _.valueOf : void 0;
  function S(k, L, P, I, O, E, B) {
    switch (P) {
      case C:
        if (k.byteLength != L.byteLength || k.byteOffset != L.byteOffset)
          return !1;
        k = k.buffer, L = L.buffer;
      case y:
        return !(k.byteLength != L.byteLength || !E(new t(k), new t(L)));
      case l:
      case c:
      case h:
        return n(+k, +L);
      case f:
        return k.name == L.name && k.message == L.message;
      case p:
      case m:
        return k == L + "";
      case u:
        var W = o;
      case g:
        var F = I & a;
        if (W || (W = i), k.size != L.size && !F)
          return !1;
        var z = B.get(k);
        if (z)
          return z == L;
        I |= s, B.set(k, L);
        var D = r(W(k), W(L), I, O, E, B);
        return B.delete(k), D;
      case b:
        if (M)
          return M.call(k) == M.call(L);
    }
    return !1;
  }
  return Jl = S, Jl;
}
var ec, Ym;
function xM() {
  if (Ym) return ec;
  Ym = 1;
  var e = d7(), t = I2();
  function n(r, o, i) {
    var a = o(r);
    return t(r) ? a : e(a, i(r));
  }
  return ec = n, ec;
}
var tc, Zm;
function SM() {
  if (Zm) return tc;
  Zm = 1;
  function e(t, n) {
    for (var r = -1, o = t == null ? 0 : t.length, i = 0, a = []; ++r < o; ) {
      var s = t[r];
      n(s, r, t) && (a[i++] = s);
    }
    return a;
  }
  return tc = e, tc;
}
var nc, Km;
function MM() {
  if (Km) return nc;
  Km = 1;
  function e() {
    return [];
  }
  return nc = e, nc;
}
var rc, Xm;
function h7() {
  if (Xm) return rc;
  Xm = 1;
  var e = SM(), t = MM(), n = Object.prototype, r = n.propertyIsEnumerable, o = Object.getOwnPropertySymbols, i = o ? function(a) {
    return a == null ? [] : (a = Object(a), e(o(a), function(s) {
      return r.call(a, s);
    }));
  } : t;
  return rc = i, rc;
}
var oc, Qm;
function DG() {
  if (Qm) return oc;
  Qm = 1;
  var e = Zx(), t = e(Object.keys, Object);
  return oc = t, oc;
}
var ic, Jm;
function BG() {
  if (Jm) return ic;
  Jm = 1;
  var e = Md(), t = DG(), n = Object.prototype, r = n.hasOwnProperty;
  function o(i) {
    if (!e(i))
      return t(i);
    var a = [];
    for (var s in Object(i))
      r.call(i, s) && s != "constructor" && a.push(s);
    return a;
  }
  return ic = o, ic;
}
var ac, eg;
function ao() {
  if (eg) return ac;
  eg = 1;
  var e = Jx(), t = BG(), n = hn();
  function r(o) {
    return n(o) ? e(o) : t(o);
  }
  return ac = r, ac;
}
var sc, tg;
function kM() {
  if (tg) return sc;
  tg = 1;
  var e = xM(), t = h7(), n = ao();
  function r(o) {
    return e(o, n, t);
  }
  return sc = r, sc;
}
var lc, ng;
function FG() {
  if (ng) return lc;
  ng = 1;
  var e = kM(), t = 1, n = Object.prototype, r = n.hasOwnProperty;
  function o(i, a, s, l, c, f) {
    var u = s & t, h = e(i), p = h.length, g = e(a), m = g.length;
    if (p != m && !u)
      return !1;
    for (var b = p; b--; ) {
      var y = h[b];
      if (!(u ? y in a : r.call(a, y)))
        return !1;
    }
    var C = f.get(i), _ = f.get(a);
    if (C && _)
      return C == a && _ == i;
    var M = !0;
    f.set(i, a), f.set(a, i);
    for (var S = u; ++b < p; ) {
      y = h[b];
      var k = i[y], L = a[y];
      if (l)
        var P = u ? l(L, k, y, a, i, f) : l(k, L, y, i, a, f);
      if (!(P === void 0 ? k === L || c(k, L, s, l, f) : P)) {
        M = !1;
        break;
      }
      S || (S = y == "constructor");
    }
    if (M && !S) {
      var I = i.constructor, O = a.constructor;
      I != O && "constructor" in i && "constructor" in a && !(typeof I == "function" && I instanceof I && typeof O == "function" && O instanceof O) && (M = !1);
    }
    return f.delete(i), f.delete(a), M;
  }
  return lc = o, lc;
}
var cc, rg;
function $G() {
  if (rg) return cc;
  rg = 1;
  var e = f3(), t = $t(), n = e(t, "DataView");
  return cc = n, cc;
}
var uc, og;
function WG() {
  if (og) return uc;
  og = 1;
  var e = f3(), t = $t(), n = e(t, "Promise");
  return uc = n, uc;
}
var dc, ig;
function LM() {
  if (ig) return dc;
  ig = 1;
  var e = f3(), t = $t(), n = e(t, "Set");
  return dc = n, dc;
}
var fc, ag;
function VG() {
  if (ag) return fc;
  ag = 1;
  var e = f3(), t = $t(), n = e(t, "WeakMap");
  return fc = n, fc;
}
var hc, sg;
function Ss() {
  if (sg) return hc;
  sg = 1;
  var e = $G(), t = Cd(), n = WG(), r = LM(), o = VG(), i = a0(), a = Vx(), s = "[object Map]", l = "[object Object]", c = "[object Promise]", f = "[object Set]", u = "[object WeakMap]", h = "[object DataView]", p = a(e), g = a(t), m = a(n), b = a(r), y = a(o), C = i;
  return (e && C(new e(new ArrayBuffer(1))) != h || t && C(new t()) != s || n && C(n.resolve()) != c || r && C(new r()) != f || o && C(new o()) != u) && (C = function(_) {
    var M = i(_), S = M == l ? _.constructor : void 0, k = S ? a(S) : "";
    if (k)
      switch (k) {
        case p:
          return h;
        case g:
          return s;
        case m:
          return c;
        case b:
          return f;
        case y:
          return u;
      }
    return M;
  }), hc = C, hc;
}
var pc, lg;
function HG() {
  if (lg) return pc;
  lg = 1;
  var e = Ia(), t = _M(), n = NG(), r = FG(), o = Ss(), i = I2(), a = Na(), s = Ed(), l = 1, c = "[object Arguments]", f = "[object Array]", u = "[object Object]", h = Object.prototype, p = h.hasOwnProperty;
  function g(m, b, y, C, _, M) {
    var S = i(m), k = i(b), L = S ? f : o(m), P = k ? f : o(b);
    L = L == c ? u : L, P = P == c ? u : P;
    var I = L == u, O = P == u, E = L == P;
    if (E && a(m)) {
      if (!a(b))
        return !1;
      S = !0, I = !1;
    }
    if (E && !I)
      return M || (M = new e()), S || s(m) ? t(m, b, y, C, _, M) : n(m, b, L, y, C, _, M);
    if (!(y & l)) {
      var B = I && p.call(m, "__wrapped__"), W = O && p.call(b, "__wrapped__");
      if (B || W) {
        var F = B ? m.value() : m, z = W ? b.value() : b;
        return M || (M = new e()), _(F, z, y, C, M);
      }
    }
    return E ? (M || (M = new e()), r(m, b, y, C, _, M)) : !1;
  }
  return pc = g, pc;
}
var mc, cg;
function p7() {
  if (cg) return mc;
  cg = 1;
  var e = HG(), t = nt();
  function n(r, o, i, a, s) {
    return r === o ? !0 : r == null || o == null || !t(r) && !t(o) ? r !== r && o !== o : e(r, o, i, a, n, s);
  }
  return mc = n, mc;
}
var gc, ug;
function jG() {
  if (ug) return gc;
  ug = 1;
  var e = p7();
  function t(n, r) {
    return e(n, r);
  }
  return gc = t, gc;
}
var qG = jG();
const zG = /* @__PURE__ */ h2(qG);
var UG = { background: "transparent", text: { fontFamily: "sans-serif", fontSize: 11, fill: "#333333", outlineWidth: 0, outlineColor: "transparent", outlineOpacity: 1 }, axis: { domain: { line: { stroke: "transparent", strokeWidth: 1 } }, ticks: { line: { stroke: "#777777", strokeWidth: 1 }, text: {} }, legend: { text: { fontSize: 12 } } }, grid: { line: { stroke: "#dddddd", strokeWidth: 1 } }, legends: { hidden: { symbol: { fill: "#333333", opacity: 0.6 }, text: { fill: "#333333", opacity: 0.6 } }, text: {}, ticks: { line: { stroke: "#777777", strokeWidth: 1 }, text: { fontSize: 10 } }, title: { text: {} } }, labels: { text: {} }, markers: { lineColor: "#000000", lineStrokeWidth: 1, text: {} }, dots: { text: {} }, tooltip: { container: { background: "white", color: "inherit", fontSize: "inherit", borderRadius: "2px", boxShadow: "0 1px 2px rgba(0, 0, 0, 0.25)", padding: "5px 9px" }, basic: { whiteSpace: "pre", display: "flex", alignItems: "center" }, chip: { marginRight: 7 }, table: {}, tableCell: { padding: "3px 5px" }, tableCellValue: { fontWeight: "bold" } }, crosshair: { line: { stroke: "#000000", strokeWidth: 1, strokeOpacity: 0.75, strokeDasharray: "6 6" } }, annotations: { text: { fontSize: 13, outlineWidth: 2, outlineColor: "#ffffff", outlineOpacity: 1 }, link: { stroke: "#000000", strokeWidth: 1, outlineWidth: 2, outlineColor: "#ffffff", outlineOpacity: 1 }, outline: { fill: "none", stroke: "#000000", strokeWidth: 2, outlineWidth: 2, outlineColor: "#ffffff", outlineOpacity: 1 }, symbol: { fill: "#000000", outlineWidth: 2, outlineColor: "#ffffff", outlineOpacity: 1 } } };
function et() {
  return et = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, et.apply(this, arguments);
}
function Au(e, t) {
  return Au = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, Au(e, t);
}
function Ms(e, t) {
  if (e == null) return {};
  var n, r, o = {}, i = Object.keys(e);
  for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
  return o;
}
var GG = ["axis.ticks.text", "axis.legend.text", "legends.title.text", "legends.text", "legends.ticks.text", "legends.title.text", "labels.text", "dots.text", "markers.text", "annotations.text"], YG = function(e, t) {
  return et({}, t, e);
}, ZG = function(e, t) {
  var n = KV({}, e, t);
  return GG.forEach(function(r) {
    Kn(n, r, YG(It(n, r), n.text));
  }), n;
}, EM = s3(), TM = function(e) {
  var t = e.children, n = e.animate, r = n === void 0 || n, o = e.config, i = o === void 0 ? "default" : o, a = j1(function() {
    var s = NH(i) ? gd[i] : i;
    return { animate: r, config: s };
  }, [r, i]);
  return v(EM.Provider, { value: a, children: t });
}, xi = { animate: i1.bool, motionConfig: i1.oneOfType([i1.oneOf(Object.keys(gd)), i1.shape({ mass: i1.number, tension: i1.number, friction: i1.number, clamp: i1.bool, precision: i1.number, velocity: i1.number, duration: i1.number, easing: i1.func })]) };
TM.propTypes = { children: i1.node.isRequired, animate: xi.animate, config: xi.motionConfig };
var rt = function() {
  return Rt(EM);
}, m7 = function(e) {
  var t = rt(), n = t.animate, r = t.config, o = function(s) {
    var l = Be();
    return Te(function() {
      l.current = s;
    }, [s]), l.current;
  }(e), i = j1(function() {
    return uS(o, e);
  }, [o, e]), a = Ft({ from: { value: 0 }, to: { value: 1 }, reset: !0, config: r, immediate: !n }).value;
  return yu(a, i);
}, KG = { nivo: ["#d76445", "#f47560", "#e8c1a0", "#97e3d5", "#61cdbb", "#00b0a7"], BrBG: A1(Ya), PRGn: A1(Za), PiYG: A1(Ka), PuOr: A1(Xa), RdBu: A1(Qa), RdGy: A1(Ja), RdYlBu: A1(es), RdYlGn: A1(ts), spectral: A1(ns), blues: A1(ms), greens: A1(gs), greys: A1(vs), oranges: A1(Cs), purples: A1(bs), reds: A1(ys), BuGn: A1(rs), BuPu: A1(os), GnBu: A1(is), OrRd: A1(as), PuBuGn: A1(ss), PuBu: A1(ls), PuRd: A1(cs), RdPu: A1(us), YlGnBu: A1(ds), YlGn: A1(fs), YlOrBr: A1(hs), YlOrRd: A1(ps) }, XG = Object.keys(KG);
A1(Ya), A1(Za), A1(Ka), A1(Xa), A1(Qa), A1(Ja), A1(es), A1(ts), A1(ns), A1(ms), A1(gs), A1(vs), A1(Cs), A1(bs), A1(ys), A1(rs), A1(os), A1(is), A1(as), A1(ss), A1(ls), A1(cs), A1(us), A1(ds), A1(fs), A1(hs), A1(ps);
i1.oneOfType([i1.oneOf(XG), i1.func, i1.arrayOf(i1.string)]);
var Iu = { basis: Uz, basisClosed: Gz, basisOpen: Yz, bundle: Zz, cardinal: Kz, cardinalClosed: Xz, cardinalOpen: Qz, catmullRom: Jz, catmullRomClosed: eU, catmullRomOpen: tU, linear: e7, linearClosed: nU, monotoneX: rU, monotoneY: oU, natural: iU, step: aU, stepAfter: lU, stepBefore: sU }, g7 = Object.keys(Iu);
g7.filter(function(e) {
  return e.endsWith("Closed");
});
IS(g7, "bundle", "basisClosed", "basisOpen", "cardinalClosed", "cardinalOpen", "catmullRomClosed", "catmullRomOpen", "linearClosed");
IS(g7, "bundle", "basisClosed", "basisOpen", "cardinalClosed", "cardinalOpen", "catmullRomClosed", "catmullRomOpen", "linearClosed");
var RM = function(e) {
  if (!Iu[e]) throw new TypeError("'" + e + "', is not a valid curve interpolator identifier.");
  return Iu[e];
};
i1.shape({ top: i1.number, right: i1.number, bottom: i1.number, left: i1.number }).isRequired;
var QG = ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"];
i1.oneOf(QG);
q0(RS);
var PM = { top: 0, right: 0, bottom: 0, left: 0 }, ks = function(e, t, n) {
  return n === void 0 && (n = {}), j1(function() {
    var r = et({}, PM, n);
    return { margin: r, innerWidth: e - r.left - r.right, innerHeight: t - r.top - r.bottom, outerWidth: e, outerHeight: t };
  }, [e, t, n.top, n.right, n.bottom, n.left]);
}, AM = function() {
  var e = Be(null), t = d2({ left: 0, top: 0, width: 0, height: 0 }), n = t[0], r = t[1], o = d2(function() {
    return typeof ResizeObserver > "u" ? null : new ResizeObserver(function(i) {
      var a = i[0];
      return r(a.contentRect);
    });
  })[0];
  return Te(function() {
    return e.current && o !== null && o.observe(e.current), function() {
      o !== null && o.disconnect();
    };
  }, []), [e, n];
}, JG = function(e) {
  return j1(function() {
    return ZG(UG, e);
  }, [e]);
}, eY = function(e) {
  return typeof e == "function" ? e : typeof e == "string" ? e.indexOf("time:") === 0 ? c7(e.slice("5")) : a7(e) : function(t) {
    return "" + t;
  };
}, Lr = function(e) {
  return j1(function() {
    return eY(e);
  }, [e]);
}, IM = s3(), tY = {}, OM = function(e) {
  var t = e.theme, n = t === void 0 ? tY : t, r = e.children, o = JG(n);
  return v(IM.Provider, { value: o, children: r });
};
OM.propTypes = { children: i1.node.isRequired, theme: i1.object };
var Ue = function() {
  return Rt(IM);
}, nY = ["outlineWidth", "outlineColor", "outlineOpacity"], v7 = function(e) {
  return e.outlineWidth, e.outlineColor, e.outlineOpacity, Ms(e, nY);
}, NM = function(e) {
  var t = e.children, n = e.condition, r = e.wrapper;
  return n ? LE(r, {}, t) : t;
};
NM.propTypes = { children: i1.node.isRequired, condition: i1.bool.isRequired, wrapper: i1.element.isRequired };
var rY = { position: "relative" }, Ls = function(e) {
  var t = e.children, n = e.theme, r = e.renderWrapper, o = r === void 0 || r, i = e.isInteractive, a = i === void 0 || i, s = e.animate, l = e.motionConfig, c = Be(null);
  return v(OM, { theme: n, children: v(TM, { animate: s, config: l, children: v(rV, { container: c, children: s1(NM, { condition: o, wrapper: v("div", { style: rY, ref: c }), children: [t, a && v(nV, {})] }) }) }) });
};
Ls.propTypes = { children: i1.element.isRequired, isInteractive: i1.bool, renderWrapper: i1.bool, theme: i1.object, animate: i1.bool, motionConfig: i1.oneOfType([i1.string, xi.motionConfig]) };
i1.func.isRequired, i1.bool, i1.bool, i1.object.isRequired, i1.bool.isRequired, i1.oneOfType([i1.string, xi.motionConfig]);
var so = function(e) {
  var t = e.children, n = AM(), r = n[0], o = n[1], i = o.width > 0 && o.height > 0;
  return v("div", { ref: r, style: { width: "100%", height: "100%" }, children: i && t({ width: o.width, height: o.height }) });
};
so.propTypes = { children: i1.func.isRequired };
var oY = ["id", "colors"], DM = function(e) {
  var t = e.id, n = e.colors, r = Ms(e, oY);
  return v("linearGradient", et({ id: t, x1: 0, x2: 0, y1: 0, y2: 1 }, r, { children: n.map(function(o) {
    var i = o.offset, a = o.color, s = o.opacity;
    return v("stop", { offset: i + "%", stopColor: a, stopOpacity: s !== void 0 ? s : 1 }, i);
  }) }));
};
DM.propTypes = { id: i1.string.isRequired, colors: i1.arrayOf(i1.shape({ offset: i1.number.isRequired, color: i1.string.isRequired, opacity: i1.number })).isRequired, gradientTransform: i1.string };
var BM = { linearGradient: DM }, Dn = { color: "#000000", background: "#ffffff", size: 4, padding: 4, stagger: !1 }, Ou = Ne(function(e) {
  var t = e.id, n = e.background, r = n === void 0 ? Dn.background : n, o = e.color, i = o === void 0 ? Dn.color : o, a = e.size, s = a === void 0 ? Dn.size : a, l = e.padding, c = l === void 0 ? Dn.padding : l, f = e.stagger, u = f === void 0 ? Dn.stagger : f, h = s + c, p = s / 2, g = c / 2;
  return u === !0 && (h = 2 * s + 2 * c), s1("pattern", { id: t, width: h, height: h, patternUnits: "userSpaceOnUse", children: [v("rect", { width: h, height: h, fill: r }), v("circle", { cx: g + p, cy: g + p, r: p, fill: i }), u && v("circle", { cx: 1.5 * c + s + p, cy: 1.5 * c + s + p, r: p, fill: i })] });
});
Ou.displayName = "PatternDots", Ou.propTypes = { id: i1.string.isRequired, color: i1.string.isRequired, background: i1.string.isRequired, size: i1.number.isRequired, padding: i1.number.isRequired, stagger: i1.bool.isRequired };
var Er = function(e) {
  return e * Math.PI / 180;
}, iY = function(e) {
  return 180 * e / Math.PI;
}, aY = function(e, t) {
  return { x: Math.cos(e) * t, y: Math.sin(e) * t };
}, sY = function(e) {
  var t = e % 360;
  return t < 0 && (t += 360), t;
}, lY = { svg: { align: { left: "start", center: "middle", right: "end", start: "start", middle: "middle", end: "end" }, baseline: { top: "text-before-edge", center: "central", bottom: "alphabetic" } }, canvas: { align: { left: "left", center: "center", right: "right", start: "left", middle: "center", end: "right" }, baseline: { top: "top", center: "middle", bottom: "bottom" } } }, Bn = { spacing: 5, rotation: 0, background: "#000000", color: "#ffffff", lineWidth: 2 }, Nu = Ne(function(e) {
  var t = e.id, n = e.spacing, r = n === void 0 ? Bn.spacing : n, o = e.rotation, i = o === void 0 ? Bn.rotation : o, a = e.background, s = a === void 0 ? Bn.background : a, l = e.color, c = l === void 0 ? Bn.color : l, f = e.lineWidth, u = f === void 0 ? Bn.lineWidth : f, h = Math.round(i) % 360, p = Math.abs(r);
  h > 180 ? h -= 360 : h > 90 ? h -= 180 : h < -180 ? h += 360 : h < -90 && (h += 180);
  var g, m = p, b = p;
  return h === 0 ? g = `
                M 0 0 L ` + m + ` 0
                M 0 ` + b + " L " + m + " " + b + `
            ` : h === 90 ? g = `
                M 0 0 L 0 ` + b + `
                M ` + m + " 0 L " + m + " " + b + `
            ` : (m = Math.abs(p / Math.sin(Er(h))), b = p / Math.sin(Er(90 - h)), g = h > 0 ? `
                    M 0 ` + -b + " L " + 2 * m + " " + b + `
                    M ` + -m + " " + -b + " L " + m + " " + b + `
                    M ` + -m + " 0 L " + m + " " + 2 * b + `
                ` : `
                    M ` + -m + " " + b + " L " + m + " " + -b + `
                    M ` + -m + " " + 2 * b + " L " + 2 * m + " " + -b + `
                    M 0 ` + 2 * b + " L " + 2 * m + ` 0
                `), s1("pattern", { id: t, width: m, height: b, patternUnits: "userSpaceOnUse", children: [v("rect", { width: m, height: b, fill: s, stroke: "rgba(255, 0, 0, 0.1)", strokeWidth: 0 }), v("path", { d: g, strokeWidth: u, stroke: c, strokeLinecap: "square" })] });
});
Nu.displayName = "PatternLines", Nu.propTypes = { id: i1.string.isRequired, spacing: i1.number.isRequired, rotation: i1.number.isRequired, background: i1.string.isRequired, color: i1.string.isRequired, lineWidth: i1.number.isRequired };
var Fn = { color: "#000000", background: "#ffffff", size: 4, padding: 4, stagger: !1 }, Du = Ne(function(e) {
  var t = e.id, n = e.color, r = n === void 0 ? Fn.color : n, o = e.background, i = o === void 0 ? Fn.background : o, a = e.size, s = a === void 0 ? Fn.size : a, l = e.padding, c = l === void 0 ? Fn.padding : l, f = e.stagger, u = f === void 0 ? Fn.stagger : f, h = s + c, p = c / 2;
  return u === !0 && (h = 2 * s + 2 * c), s1("pattern", { id: t, width: h, height: h, patternUnits: "userSpaceOnUse", children: [v("rect", { width: h, height: h, fill: i }), v("rect", { x: p, y: p, width: s, height: s, fill: r }), u && v("rect", { x: 1.5 * c + s, y: 1.5 * c + s, width: s, height: s, fill: r })] });
});
Du.displayName = "PatternSquares", Du.propTypes = { id: i1.string.isRequired, color: i1.string.isRequired, background: i1.string.isRequired, size: i1.number.isRequired, padding: i1.number.isRequired, stagger: i1.bool.isRequired };
var FM = { patternDots: Ou, patternLines: Nu, patternSquares: Du }, cY = ["type"], Bu = et({}, BM, FM), $M = function(e) {
  var t = e.defs;
  return !t || t.length < 1 ? null : v("defs", { "aria-hidden": !0, children: t.map(function(n) {
    var r = n.type, o = Ms(n, cY);
    return Bu[r] ? s2(Bu[r], et({ key: o.id }, o)) : null;
  }) });
};
$M.propTypes = { defs: i1.arrayOf(i1.shape({ type: i1.oneOf(Object.keys(Bu)).isRequired, id: i1.string.isRequired })) };
var uY = Ne($M), b7 = function(e) {
  var t = e.width, n = e.height, r = e.margin, o = e.defs, i = e.children, a = e.role, s = e.ariaLabel, l = e.ariaLabelledBy, c = e.ariaDescribedBy, f = e.isFocusable, u = Ue();
  return s1("svg", { xmlns: "http://www.w3.org/2000/svg", width: t, height: n, role: a, "aria-label": s, "aria-labelledby": l, "aria-describedby": c, focusable: f, tabIndex: f ? 0 : void 0, children: [v(uY, { defs: o }), v("rect", { width: t, height: n, fill: u.background }), v("g", { transform: "translate(" + r.left + "," + r.top + ")", children: i })] });
};
b7.propTypes = { width: i1.number.isRequired, height: i1.number.isRequired, margin: i1.shape({ top: i1.number.isRequired, left: i1.number.isRequired }).isRequired, defs: i1.array, children: i1.oneOfType([i1.arrayOf(i1.node), i1.node]).isRequired, role: i1.string, isFocusable: i1.bool, ariaLabel: i1.string, ariaLabelledBy: i1.string, ariaDescribedBy: i1.string };
var WM = function(e) {
  var t = e.size, n = e.color, r = e.borderWidth, o = e.borderColor;
  return v("circle", { r: t / 2, fill: n, stroke: o, strokeWidth: r, style: { pointerEvents: "none" } });
};
WM.propTypes = { size: i1.number.isRequired, color: i1.string.isRequired, borderWidth: i1.number.isRequired, borderColor: i1.string.isRequired };
var dY = Ne(WM), VM = function(e) {
  var t = e.x, n = e.y, r = e.symbol, o = r === void 0 ? dY : r, i = e.size, a = e.datum, s = e.color, l = e.borderWidth, c = e.borderColor, f = e.label, u = e.labelTextAnchor, h = u === void 0 ? "middle" : u, p = e.labelYOffset, g = p === void 0 ? -12 : p, m = Ue(), b = rt(), y = b.animate, C = b.config, _ = Ft({ transform: "translate(" + t + ", " + n + ")", config: C, immediate: !y });
  return s1(Ye.g, { transform: _.transform, style: { pointerEvents: "none" }, children: [s2(o, { size: i, color: s, datum: a, borderWidth: l, borderColor: c }), f && v("text", { textAnchor: h, y: g, style: v7(m.dots.text), children: f })] });
};
VM.propTypes = { x: i1.number.isRequired, y: i1.number.isRequired, datum: i1.object.isRequired, size: i1.number.isRequired, color: i1.string.isRequired, borderWidth: i1.number.isRequired, borderColor: i1.string.isRequired, symbol: i1.oneOfType([i1.func, i1.object]), label: i1.oneOfType([i1.string, i1.number]), labelTextAnchor: i1.oneOf(["start", "middle", "end"]), labelYOffset: i1.number };
var fY = Ne(VM), HM = function(e) {
  var t = e.width, n = e.height, r = e.axis, o = e.scale, i = e.value, a = e.lineStyle, s = e.textStyle, l = e.legend, c = e.legendNode, f = e.legendPosition, u = f === void 0 ? "top-right" : f, h = e.legendOffsetX, p = h === void 0 ? 14 : h, g = e.legendOffsetY, m = g === void 0 ? 14 : g, b = e.legendOrientation, y = b === void 0 ? "horizontal" : b, C = Ue(), _ = 0, M = 0, S = 0, k = 0;
  if (r === "y" ? (S = o(i), M = t) : (_ = o(i), k = n), l && !c) {
    var L = function(P) {
      var I = P.axis, O = P.width, E = P.height, B = P.position, W = P.offsetX, F = P.offsetY, z = P.orientation, D = 0, Z = 0, U = z === "vertical" ? -90 : 0, $ = "start";
      if (I === "x") switch (B) {
        case "top-left":
          D = -W, Z = F, $ = "end";
          break;
        case "top":
          Z = -F, $ = z === "horizontal" ? "middle" : "start";
          break;
        case "top-right":
          D = W, Z = F, $ = z === "horizontal" ? "start" : "end";
          break;
        case "right":
          D = W, Z = E / 2, $ = z === "horizontal" ? "start" : "middle";
          break;
        case "bottom-right":
          D = W, Z = E - F, $ = "start";
          break;
        case "bottom":
          Z = E + F, $ = z === "horizontal" ? "middle" : "end";
          break;
        case "bottom-left":
          Z = E - F, D = -W, $ = z === "horizontal" ? "end" : "start";
          break;
        case "left":
          D = -W, Z = E / 2, $ = z === "horizontal" ? "end" : "middle";
      }
      else switch (B) {
        case "top-left":
          D = W, Z = -F, $ = "start";
          break;
        case "top":
          D = O / 2, Z = -F, $ = z === "horizontal" ? "middle" : "start";
          break;
        case "top-right":
          D = O - W, Z = -F, $ = z === "horizontal" ? "end" : "start";
          break;
        case "right":
          D = O + W, $ = z === "horizontal" ? "start" : "middle";
          break;
        case "bottom-right":
          D = O - W, Z = F, $ = "end";
          break;
        case "bottom":
          D = O / 2, Z = F, $ = z === "horizontal" ? "middle" : "end";
          break;
        case "bottom-left":
          D = W, Z = F, $ = z === "horizontal" ? "start" : "end";
          break;
        case "left":
          D = -W, $ = z === "horizontal" ? "end" : "middle";
      }
      return { x: D, y: Z, rotation: U, textAnchor: $ };
    }({ axis: r, width: t, height: n, position: u, offsetX: p, offsetY: m, orientation: y });
    c = v("text", { transform: "translate(" + L.x + ", " + L.y + ") rotate(" + L.rotation + ")", textAnchor: L.textAnchor, dominantBaseline: "central", style: s, children: l });
  }
  return s1("g", { transform: "translate(" + _ + ", " + S + ")", children: [v("line", { x1: 0, x2: M, y1: 0, y2: k, stroke: C.markers.lineColor, strokeWidth: C.markers.lineStrokeWidth, style: a }), c] });
};
HM.propTypes = { width: i1.number.isRequired, height: i1.number.isRequired, axis: i1.oneOf(["x", "y"]).isRequired, scale: i1.func.isRequired, value: i1.oneOfType([i1.number, i1.string, i1.instanceOf(Date)]).isRequired, lineStyle: i1.object, textStyle: i1.object, legend: i1.string, legendPosition: i1.oneOf(["top-left", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left"]), legendOffsetX: i1.number.isRequired, legendOffsetY: i1.number.isRequired, legendOrientation: i1.oneOf(["horizontal", "vertical"]).isRequired };
var hY = Ne(HM), jM = function(e) {
  var t = e.markers, n = e.width, r = e.height, o = e.xScale, i = e.yScale;
  return t && t.length !== 0 ? t.map(function(a, s) {
    return v(hY, et({}, a, { width: n, height: r, scale: a.axis === "y" ? i : o }), s);
  }) : null;
};
jM.propTypes = { width: i1.number.isRequired, height: i1.number.isRequired, xScale: i1.func.isRequired, yScale: i1.func.isRequired, markers: i1.arrayOf(i1.shape({ axis: i1.oneOf(["x", "y"]).isRequired, value: i1.oneOfType([i1.number, i1.string, i1.instanceOf(Date)]).isRequired, lineStyle: i1.object, textStyle: i1.object })) };
var qM = Ne(jM), pY = ["theme", "renderWrapper", "animate", "motionConfig"], zM = function(e) {
  return function(t) {
    var n, r;
    function o() {
      return t.apply(this, arguments) || this;
    }
    return r = t, (n = o).prototype = Object.create(r.prototype), n.prototype.constructor = n, Au(n, r), o.prototype.render = function() {
      var i = this.props, a = i.theme, s = i.renderWrapper, l = i.animate, c = i.motionConfig, f = Ms(i, pY);
      return v(Ls, { theme: a, renderWrapper: s, isInteractive: f.isInteractive, animate: l, motionConfig: c, children: v(e, et({}, f)) });
    }, o;
  }(EE);
}, mY = function(e, t) {
  var n = Kd(e) ? e : function(r) {
    return It(r, e);
  };
  return n;
}, UM = function(e) {
  return Kd(e) ? e : function(t) {
    return It(t, e);
  };
}, vc = function(e) {
  return j1(function() {
    return UM(e);
  }, [e]);
}, gY = function(e, t, n, r) {
  var o = n - e, i = r - t;
  return o *= o, i *= i, Math.sqrt(o + i);
}, GM = function(e, t, n, r, o, i) {
  return e <= o && o <= e + n && t <= i && i <= t + r;
}, nr = function(e, t) {
  var n, r = "touches" in t ? t.touches[0] : t, o = r.clientX, i = r.clientY, a = e.getBoundingClientRect(), s = (n = e.getBBox !== void 0 ? e.getBBox() : { width: e.offsetWidth || 0, height: e.offsetHeight || 0 }).width === a.width ? 1 : n.width / a.width;
  return [(o - a.left) * s, (i - a.top) * s];
}, vY = Object.keys(BM), bY = Object.keys(FM), yY = function(e, t, n) {
  if (e === "*") return !0;
  if (Kd(e)) return e(t);
  if (u7(e)) {
    var r = n ? It(t, n) : t;
    return zG(AG(r, Object.keys(e)), e);
  }
  return !1;
}, YM = function(e, t, n, r) {
  var o = r === void 0 ? {} : r, i = o.dataKey, a = o.colorKey, s = a === void 0 ? "color" : a, l = o.targetKey, c = l === void 0 ? "fill" : l, f = [], u = {};
  return e.length && t.length && (f = [].concat(e), t.forEach(function(h) {
    for (var p = function() {
      var m = n[g], b = m.id, y = m.match;
      if (yY(y, h, i)) {
        var C = e.find(function(O) {
          return O.id === b;
        });
        if (C) {
          if (bY.includes(C.type)) if (C.background === "inherit" || C.color === "inherit") {
            var _ = It(h, s), M = C.background, S = C.color, k = b;
            C.background === "inherit" && (k = k + ".bg." + _, M = _), C.color === "inherit" && (k = k + ".fg." + _, S = _), Kn(h, c, "url(#" + k + ")"), u[k] || (f.push(et({}, C, { id: k, background: M, color: S })), u[k] = 1);
          } else Kn(h, c, "url(#" + b + ")");
          else if (vY.includes(C.type))
            if (C.colors.map(function(O) {
              return O.color;
            }).includes("inherit")) {
              var L = It(h, s), P = b, I = et({}, C, { colors: C.colors.map(function(O, E) {
                return O.color !== "inherit" ? O : (P = P + "." + E + "." + L, et({}, O, { color: O.color === "inherit" ? L : O.color }));
              }) });
              I.id = P, Kn(h, c, "url(#" + P + ")"), u[P] || (f.push(I), u[P] = 1);
            } else Kn(h, c, "url(#" + b + ")");
        }
        return "break";
      }
    }, g = 0; g < n.length && p() !== "break"; g++)
      ;
  })), f;
}, bc, dg;
function CY() {
  if (dg) return bc;
  dg = 1;
  function e() {
  }
  return bc = e, bc;
}
var yc, fg;
function wY() {
  if (fg) return yc;
  fg = 1;
  var e = LM(), t = CY(), n = f7(), r = 1 / 0, o = e && 1 / n(new e([, -0]))[1] == r ? function(i) {
    return new e(i);
  } : t;
  return yc = o, yc;
}
var Cc, hg;
function ZM() {
  if (hg) return Cc;
  hg = 1;
  var e = Xd(), t = PS(), n = AS(), r = Qd(), o = wY(), i = f7(), a = 200;
  function s(l, c, f) {
    var u = -1, h = t, p = l.length, g = !0, m = [], b = m;
    if (f)
      g = !1, h = n;
    else if (p >= a) {
      var y = c ? null : o(l);
      if (y)
        return i(y);
      g = !1, h = r, b = new e();
    } else
      b = c ? [] : m;
    e:
      for (; ++u < p; ) {
        var C = l[u], _ = c ? c(C) : C;
        if (C = f || C !== 0 ? C : 0, g && _ === _) {
          for (var M = b.length; M--; )
            if (b[M] === _)
              continue e;
          c && b.push(_), m.push(C);
        } else h(b, _, f) || (b !== m && b.push(_), m.push(C));
      }
    return m;
  }
  return Cc = s, Cc;
}
var wc, pg;
function _Y() {
  if (pg) return wc;
  pg = 1;
  var e = ZM();
  function t(n) {
    return n && n.length ? e(n) : [];
  }
  return wc = t, wc;
}
var xY = _Y();
const mg = /* @__PURE__ */ h2(xY);
var _c, gg;
function SY() {
  if (gg) return _c;
  gg = 1;
  var e = Ia(), t = p7(), n = 1, r = 2;
  function o(i, a, s, l) {
    var c = s.length, f = c, u = !l;
    if (i == null)
      return !f;
    for (i = Object(i); c--; ) {
      var h = s[c];
      if (u && h[2] ? h[1] !== i[h[0]] : !(h[0] in i))
        return !1;
    }
    for (; ++c < f; ) {
      h = s[c];
      var p = h[0], g = i[p], m = h[1];
      if (u && h[2]) {
        if (g === void 0 && !(p in i))
          return !1;
      } else {
        var b = new e();
        if (l)
          var y = l(g, m, p, i, a, b);
        if (!(y === void 0 ? t(m, g, n | r, l, b) : y))
          return !1;
      }
    }
    return !0;
  }
  return _c = o, _c;
}
var xc, vg;
function KM() {
  if (vg) return xc;
  vg = 1;
  var e = Wt();
  function t(n) {
    return n === n && !e(n);
  }
  return xc = t, xc;
}
var Sc, bg;
function MY() {
  if (bg) return Sc;
  bg = 1;
  var e = KM(), t = ao();
  function n(r) {
    for (var o = t(r), i = o.length; i--; ) {
      var a = o[i], s = r[a];
      o[i] = [a, s, e(s)];
    }
    return o;
  }
  return Sc = n, Sc;
}
var Mc, yg;
function XM() {
  if (yg) return Mc;
  yg = 1;
  function e(t, n) {
    return function(r) {
      return r == null ? !1 : r[t] === n && (n !== void 0 || t in Object(r));
    };
  }
  return Mc = e, Mc;
}
var kc, Cg;
function kY() {
  if (Cg) return kc;
  Cg = 1;
  var e = SY(), t = MY(), n = XM();
  function r(o) {
    var i = t(o);
    return i.length == 1 && i[0][2] ? n(i[0][0], i[0][1]) : function(a) {
      return a === o || e(a, o, i);
    };
  }
  return kc = r, kc;
}
var Lc, wg;
function LY() {
  if (wg) return Lc;
  wg = 1;
  var e = p7(), t = oS(), n = yM(), r = Pd(), o = KM(), i = XM(), a = vn(), s = 1, l = 2;
  function c(f, u) {
    return r(f) && o(u) ? i(a(f), u) : function(h) {
      var p = t(h, f);
      return p === void 0 && p === u ? n(h, f) : e(u, p, s | l);
    };
  }
  return Lc = c, Lc;
}
var Ec, _g;
function EY() {
  if (_g) return Ec;
  _g = 1;
  function e(t) {
    return function(n) {
      return n?.[t];
    };
  }
  return Ec = e, Ec;
}
var Tc, xg;
function TY() {
  if (xg) return Tc;
  xg = 1;
  var e = oo();
  function t(n) {
    return function(r) {
      return e(r, n);
    };
  }
  return Tc = t, Tc;
}
var Rc, Sg;
function RY() {
  if (Sg) return Rc;
  Sg = 1;
  var e = EY(), t = TY(), n = Pd(), r = vn();
  function o(i) {
    return n(i) ? e(r(i)) : t(i);
  }
  return Rc = o, Rc;
}
var Pc, Mg;
function y7() {
  if (Mg) return Pc;
  Mg = 1;
  var e = kY(), t = LY(), n = Fa(), r = I2(), o = RY();
  function i(a) {
    return typeof a == "function" ? a : a == null ? n : typeof a == "object" ? r(a) ? t(a[0], a[1]) : e(a) : o(a);
  }
  return Pc = i, Pc;
}
var Ac, kg;
function PY() {
  if (kg) return Ac;
  kg = 1;
  var e = y7(), t = ZM();
  function n(r, o) {
    return r && r.length ? t(r, e(o, 2)) : [];
  }
  return Ac = n, Ac;
}
var AY = PY();
const Fu = /* @__PURE__ */ h2(AY);
var Ic, Lg;
function IY() {
  if (Lg) return Ic;
  Lg = 1;
  var e = qx(), t = ao();
  function n(r, o) {
    return r && e(r, o, t);
  }
  return Ic = n, Ic;
}
var Oc, Eg;
function OY() {
  if (Eg) return Oc;
  Eg = 1;
  var e = hn();
  function t(n, r) {
    return function(o, i) {
      if (o == null)
        return o;
      if (!e(o))
        return n(o, i);
      for (var a = o.length, s = r ? a : -1, l = Object(o); (r ? s-- : ++s < a) && i(l[s], s, l) !== !1; )
        ;
      return o;
    };
  }
  return Oc = t, Oc;
}
var Nc, Tg;
function QM() {
  if (Tg) return Nc;
  Tg = 1;
  var e = IY(), t = OY(), n = t(e);
  return Nc = n, Nc;
}
var Dc, Rg;
function NY() {
  if (Rg) return Dc;
  Rg = 1;
  var e = QM(), t = hn();
  function n(r, o) {
    var i = -1, a = t(r) ? Array(r.length) : [];
    return e(r, function(s, l, c) {
      a[++i] = o(s, l, c);
    }), a;
  }
  return Dc = n, Dc;
}
var Bc, Pg;
function DY() {
  if (Pg) return Bc;
  Pg = 1;
  function e(t, n) {
    var r = t.length;
    for (t.sort(n); r--; )
      t[r] = t[r].value;
    return t;
  }
  return Bc = e, Bc;
}
var Fc, Ag;
function BY() {
  if (Ag) return Fc;
  Ag = 1;
  var e = $a();
  function t(n, r) {
    if (n !== r) {
      var o = n !== void 0, i = n === null, a = n === n, s = e(n), l = r !== void 0, c = r === null, f = r === r, u = e(r);
      if (!c && !u && !s && n > r || s && l && f && !c && !u || i && l && f || !o && f || !a)
        return 1;
      if (!i && !s && !u && n < r || u && o && a && !i && !s || c && o && a || !l && a || !f)
        return -1;
    }
    return 0;
  }
  return Fc = t, Fc;
}
var $c, Ig;
function FY() {
  if (Ig) return $c;
  Ig = 1;
  var e = BY();
  function t(n, r, o) {
    for (var i = -1, a = n.criteria, s = r.criteria, l = a.length, c = o.length; ++i < l; ) {
      var f = e(a[i], s[i]);
      if (f) {
        if (i >= c)
          return f;
        var u = o[i];
        return f * (u == "desc" ? -1 : 1);
      }
    }
    return n.index - r.index;
  }
  return $c = t, $c;
}
var Wc, Og;
function $Y() {
  if (Og) return Wc;
  Og = 1;
  var e = Wa(), t = oo(), n = y7(), r = NY(), o = DY(), i = pn(), a = FY(), s = Fa(), l = I2();
  function c(f, u, h) {
    u.length ? u = e(u, function(m) {
      return l(m) ? function(b) {
        return t(b, m.length === 1 ? m[0] : m);
      } : m;
    }) : u = [s];
    var p = -1;
    u = e(u, i(n));
    var g = r(f, function(m, b, y) {
      var C = e(u, function(_) {
        return _(m);
      });
      return { criteria: C, index: ++p, value: m };
    });
    return o(g, function(m, b) {
      return a(m, b, h);
    });
  }
  return Wc = c, Wc;
}
var Vc, Ng;
function WY() {
  if (Ng) return Vc;
  Ng = 1;
  var e = CM(), t = $Y(), n = Rd(), r = nS(), o = n(function(i, a) {
    if (i == null)
      return [];
    var s = a.length;
    return s > 1 && r(i, a[0], a[1]) ? a = [] : s > 2 && r(a[0], a[1], a[2]) && (a = [a[0]]), t(i, e(a, 1), []);
  });
  return Vc = o, Vc;
}
var VY = WY();
const HY = /* @__PURE__ */ h2(VY);
var Hc, Dg;
function jY() {
  if (Dg) return Hc;
  Dg = 1;
  var e = a0(), t = nt(), n = "[object Date]";
  function r(o) {
    return t(o) && e(o) == n;
  }
  return Hc = r, Hc;
}
var jc, Bg;
function qY() {
  if (Bg) return jc;
  Bg = 1;
  var e = jY(), t = pn(), n = Da(), r = n && n.isDate, o = r ? t(r) : e;
  return jc = o, jc;
}
var zY = qY();
const UY = /* @__PURE__ */ h2(zY);
function W0() {
  return W0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, W0.apply(this, arguments);
}
var M3 = [function(e) {
  return e.setMilliseconds(0);
}, function(e) {
  return e.setSeconds(0);
}, function(e) {
  return e.setMinutes(0);
}, function(e) {
  return e.setHours(0);
}, function(e) {
  return e.setDate(1);
}, function(e) {
  return e.setMonth(0);
}], GY = { millisecond: [], second: M3.slice(0, 1), minute: M3.slice(0, 2), hour: M3.slice(0, 3), day: M3.slice(0, 4), month: M3.slice(0, 5), year: M3.slice(0, 6) }, YY = function(e) {
  return function(t) {
    return GY[e].forEach(function(n) {
      n(t);
    }), t;
  };
}, JM = function(e) {
  var t = e.format, n = t === void 0 ? "native" : t, r = e.precision, o = r === void 0 ? "millisecond" : r, i = e.useUTC, a = i === void 0 || i, s = YY(o);
  return function(l) {
    if (l === void 0) return l;
    if (n === "native" || l instanceof Date) return s(l);
    var c = a ? bM(n) : vM(n);
    return s(c(l));
  };
}, ZY = function(e, t, n, r) {
  var o, i, a, s, l = e.min, c = l === void 0 ? 0 : l, f = e.max, u = f === void 0 ? "auto" : f, h = e.stacked, p = h !== void 0 && h, g = e.reverse, m = g !== void 0 && g, b = e.clamp, y = b !== void 0 && b, C = e.nice, _ = C !== void 0 && C;
  c === "auto" ? o = p === !0 ? (i = t.minStacked) != null ? i : 0 : t.min : o = c, u === "auto" ? a = p === !0 ? (s = t.maxStacked) != null ? s : 0 : t.max : a = u;
  var M = bS().rangeRound(r === "x" ? [0, n] : [n, 0]).domain(m ? [a, o] : [o, a]).clamp(y);
  return _ === !0 ? M.nice() : typeof _ == "number" && M.nice(_), KY(M, p);
}, KY = function(e, t) {
  t === void 0 && (t = !1);
  var n = e;
  return n.type = "linear", n.stacked = t, n;
}, XY = function(e, t, n) {
  var r = ZH().range([0, n]).domain(t.all);
  return r.type = "point", r;
}, QY = function(e, t, n, r) {
  var o = e.round, i = o === void 0 || o, a = Fd().range(r === "x" ? [0, n] : [n, 0]).domain(t.all).round(i);
  return JY(a);
}, JY = function(e) {
  var t = e;
  return t.type = "band", t;
}, eZ = function(e, t, n) {
  var r, o, i = e.format, a = i === void 0 ? "native" : i, s = e.precision, l = s === void 0 ? "millisecond" : s, c = e.min, f = c === void 0 ? "auto" : c, u = e.max, h = u === void 0 ? "auto" : u, p = e.useUTC, g = p === void 0 || p, m = e.nice, b = m !== void 0 && m, y = JM({ format: a, precision: l, useUTC: g });
  r = f === "auto" ? y(t.min) : a !== "native" ? y(f) : f, o = h === "auto" ? y(t.max) : a !== "native" ? y(h) : h;
  var C = g ? Dq() : Nq();
  C.range([0, n]), r && o && C.domain([r, o]), b === !0 ? C.nice() : typeof b != "object" && typeof b != "number" || C.nice(b);
  var _ = C;
  return _.type = "time", _.useUTC = g, _;
}, tZ = function(e, t, n, r) {
  var o, i = e.base, a = i === void 0 ? 10 : i, s = e.min, l = s === void 0 ? "auto" : s, c = e.max, f = c === void 0 ? "auto" : c;
  if (t.all.some(function(m) {
    return m === 0;
  })) throw new Error("a log scale domain must not include or cross zero");
  var u, h, p = !1;
  if (t.all.filter(function(m) {
    return m != null;
  }).forEach(function(m) {
    p || (o === void 0 ? o = Math.sign(m) : Math.sign(m) !== o && (p = !0));
  }), p) throw new Error("a log scale domain must be strictly-positive or strictly-negative");
  u = l === "auto" ? t.min : l, h = f === "auto" ? t.max : f;
  var g = CS().domain([u, h]).rangeRound(r === "x" ? [0, n] : [n, 0]).base(a).nice();
  return g.type = "log", g;
}, nZ = function(e, t, n, r) {
  var o, i, a = e.constant, s = a === void 0 ? 1 : a, l = e.min, c = l === void 0 ? "auto" : l, f = e.max, u = f === void 0 ? "auto" : f, h = e.reverse, p = h !== void 0 && h;
  o = c === "auto" ? t.min : c, i = u === "auto" ? t.max : u;
  var g = wS().constant(s).rangeRound(r === "x" ? [0, n] : [n, 0]).nice();
  p === !0 ? g.domain([i, o]) : g.domain([o, i]);
  var m = g;
  return m.type = "symlog", m;
}, rZ = function(e) {
  return e === "x" ? "y" : "x";
}, oZ = function(e, t) {
  return e === t;
}, iZ = function(e, t) {
  return e.getTime() === t.getTime();
};
function Tr(e, t, n, r) {
  switch (e.type) {
    case "linear":
      return ZY(e, t, n, r);
    case "point":
      return XY(e, t, n);
    case "band":
      return QY(e, t, n, r);
    case "time":
      return eZ(e, t, n);
    case "log":
      return tZ(e, t, n, r);
    case "symlog":
      return nZ(e, t, n, r);
    default:
      throw new Error("invalid scale spec");
  }
}
var Fg = function(e, t, n) {
  var r;
  if ("stacked" in n && n.stacked) {
    var o = e.data[t === "x" ? "xStacked" : "yStacked"];
    return o == null ? null : n(o);
  }
  return (r = n(e.data[t])) != null ? r : null;
}, aZ = function(e, t, n, r, o) {
  var i = e.map(function(f) {
    return function(u) {
      return W0({}, u, { data: u.data.map(function(h) {
        return { data: W0({}, h) };
      }) });
    }(f);
  }), a = sZ(i, t, n);
  "stacked" in t && t.stacked === !0 && lZ(a, i), "stacked" in n && n.stacked === !0 && cZ(a, i);
  var s = Tr(t, a.x, r, "x"), l = Tr(n, a.y, o, "y"), c = i.map(function(f) {
    return W0({}, f, { data: f.data.map(function(u) {
      return W0({}, u, { position: { x: Fg(u, "x", s), y: Fg(u, "y", l) } });
    }) });
  });
  return W0({}, a, { series: c, xScale: s, yScale: l });
}, sZ = function(e, t, n) {
  return { x: $g(e, "x", t), y: $g(e, "y", n) };
}, $g = function(e, t, n, r) {
  var o = {}, i = o.getValue, a = i === void 0 ? function(g) {
    return g.data[t];
  } : i, s = o.setValue, l = s === void 0 ? function(g, m) {
    g.data[t] = m;
  } : s;
  if (n.type === "linear") e.forEach(function(g) {
    g.data.forEach(function(m) {
      var b = a(m);
      b && l(m, parseFloat(String(b)));
    });
  });
  else if (n.type === "time" && n.format !== "native") {
    var c = JM(n);
    e.forEach(function(g) {
      g.data.forEach(function(m) {
        var b = a(m);
        b && l(m, c(b));
      });
    });
  }
  var f = [];
  switch (e.forEach(function(g) {
    g.data.forEach(function(m) {
      f.push(a(m));
    });
  }), n.type) {
    case "linear":
      var u = HY(mg(f).filter(function(g) {
        return g !== null;
      }), function(g) {
        return g;
      });
      return { all: u, min: Math.min.apply(Math, u), max: Math.max.apply(Math, u) };
    case "time":
      var h = Fu(f, function(g) {
        return g.getTime();
      }).slice(0).sort(function(g, m) {
        return m.getTime() - g.getTime();
      }).reverse();
      return { all: h, min: h[0], max: A1(h) };
    default:
      var p = mg(f);
      return { all: p, min: p[0], max: A1(p) };
  }
}, ek = function(e, t, n) {
  var r = rZ(e), o = [];
  t[r].all.forEach(function(i) {
    var a = UY(i) ? iZ : oZ, s = [];
    n.forEach(function(l) {
      var c = l.data.find(function(p) {
        return a(p.data[r], i);
      }), f = null, u = null;
      if (c !== void 0) {
        if ((f = c.data[e]) !== null) {
          var h = A1(s);
          h === void 0 ? u = f : h !== null && (u = h + f);
        }
        c.data[e === "x" ? "xStacked" : "yStacked"] = u;
      }
      s.push(u), u !== null && o.push(u);
    });
  }), t[e].minStacked = Math.min.apply(Math, o), t[e].maxStacked = Math.max.apply(Math, o);
}, lZ = function(e, t) {
  return ek("x", e, t);
}, cZ = function(e, t) {
  return ek("y", e, t);
}, tk = function(e) {
  var t = e.bandwidth();
  if (t === 0) return e;
  var n = t / 2;
  return e.round() && (n = Math.round(n)), function(r) {
    var o;
    return ((o = e(r)) != null ? o : 0) + n;
  };
}, nk = { millisecond: [Sr, Sr], second: [Pu, Pu], minute: [JS, aM], hour: [eM, sM], day: [l2(function(e) {
  return e.setHours(0, 0, 0, 0);
}, function(e, t) {
  return e.setDate(e.getDate() + t);
}, function(e, t) {
  return (t.getTime() - e.getTime()) / 864e5;
}, function(e) {
  return Math.floor(e.getTime() / 864e5);
}), l2(function(e) {
  return e.setUTCHours(0, 0, 0, 0);
}, function(e, t) {
  return e.setUTCDate(e.getUTCDate() + t);
}, function(e, t) {
  return (t.getTime() - e.getTime()) / 864e5;
}, function(e) {
  return Math.floor(e.getTime() / 864e5);
})], week: [wi, _i], sunday: [wi, _i], monday: [Mr, kr], tuesday: [tM, lM], wednesday: [nM, cM], thursday: [i3, a3], friday: [rM, uM], saturday: [oM, dM], month: [iM, fM], year: [L0, E0] }, uZ = Object.keys(nk), dZ = new RegExp("^every\\s*(\\d+)?\\s*(" + uZ.join("|") + ")s?$", "i"), rk = function(e, t) {
  if (Array.isArray(t)) return t;
  if (typeof t == "string" && "useUTC" in e) {
    var n = t.match(dZ);
    if (n) {
      var r = n[1], o = n[2], i = nk[o][e.useUTC ? 1 : 0];
      if (o === "day") {
        var a, s, l = e.domain(), c = l[0], f = l[1], u = new Date(f);
        return u.setDate(u.getDate() + 1), (a = (s = i.every(Number(r ?? 1))) == null ? void 0 : s.range(c, u)) != null ? a : [];
      }
      if (r === void 0) return e.ticks(i);
      var h = i.every(Number(r));
      if (h) return e.ticks(h);
    }
    throw new Error("Invalid tickValues: " + t);
  }
  if ("ticks" in e) {
    if (t === void 0) return e.ticks();
    if (typeof (p = t) == "number" && isFinite(p) && Math.floor(p) === p) return e.ticks(t);
  }
  var p;
  return e.domain();
};
function tt() {
  return tt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, tt.apply(this, arguments);
}
var ok = function(e) {
  var t, n = e.axis, r = e.scale, o = e.ticksPosition, i = e.tickValues, a = e.tickSize, s = e.tickPadding, l = e.tickRotation, c = e.truncateTickAt, f = e.engine, u = f === void 0 ? "svg" : f, h = rk(r, i), p = lY[u], g = "bandwidth" in r ? tk(r) : r, m = { lineX: 0, lineY: 0 }, b = { textX: 0, textY: 0 }, y = typeof document == "object" && document.dir === "rtl", C = p.align.center, _ = p.baseline.center;
  return n === "x" ? (t = function(M) {
    var S;
    return { x: (S = g(M)) != null ? S : 0, y: 0 };
  }, m.lineY = a * (o === "after" ? 1 : -1), b.textY = (a + s) * (o === "after" ? 1 : -1), _ = o === "after" ? p.baseline.top : p.baseline.bottom, l === 0 ? C = p.align.center : o === "after" && l < 0 || o === "before" && l > 0 ? (C = p.align[y ? "left" : "right"], _ = p.baseline.center) : (o === "after" && l > 0 || o === "before" && l < 0) && (C = p.align[y ? "right" : "left"], _ = p.baseline.center)) : (t = function(M) {
    var S;
    return { x: 0, y: (S = g(M)) != null ? S : 0 };
  }, m.lineX = a * (o === "after" ? 1 : -1), b.textX = (a + s) * (o === "after" ? 1 : -1), C = o === "after" ? p.align.left : p.align.right), { ticks: h.map(function(M) {
    var S = typeof M == "string" ? function(k) {
      var L = String(k).length;
      return c && c > 0 && L > c ? "" + String(k).slice(0, c).concat("...") : "" + k;
    }(M) : M;
    return tt({ key: M instanceof Date ? "" + M.valueOf() : "" + M, value: S }, t(M), m, b);
  }), textAlign: C, textBaseline: _ };
}, ik = function(e, t) {
  if (e === void 0 || typeof e == "function") return e;
  if (t.type === "time") {
    var n = c7(e);
    return function(r) {
      return n(r instanceof Date ? r : new Date(r));
    };
  }
  return a7(e);
}, $u = function(e) {
  var t, n = e.width, r = e.height, o = e.scale, i = e.axis, a = e.values, s = (t = a, (Array.isArray(t) ? a : void 0) || rk(o, a)), l = "bandwidth" in o ? tk(o) : o, c = i === "x" ? s.map(function(f) {
    var u, h;
    return { key: f instanceof Date ? "" + f.valueOf() : "" + f, x1: (u = l(f)) != null ? u : 0, x2: (h = l(f)) != null ? h : 0, y1: 0, y2: r };
  }) : s.map(function(f) {
    var u, h;
    return { key: f instanceof Date ? "" + f.valueOf() : "" + f, x1: 0, x2: n, y1: (u = l(f)) != null ? u : 0, y2: (h = l(f)) != null ? h : 0 };
  });
  return c;
}, fZ = Ne(function(e) {
  var t, n = e.value, r = e.format, o = e.lineX, i = e.lineY, a = e.onClick, s = e.textBaseline, l = e.textAnchor, c = e.animatedProps, f = Ue(), u = f.axis.ticks.line, h = f.axis.ticks.text, p = (t = r?.(n)) != null ? t : n, g = j1(function() {
    var m = { opacity: c.opacity };
    return a ? { style: tt({}, m, { cursor: "pointer" }), onClick: function(b) {
      return a(b, p);
    } } : { style: m };
  }, [c.opacity, a, p]);
  return s1(Ye.g, tt({ transform: c.transform }, g, { children: [v("line", { x1: 0, x2: o, y1: 0, y2: i, style: u }), h.outlineWidth > 0 && v(Ye.text, { dominantBaseline: s, textAnchor: l, transform: c.textTransform, style: h, strokeWidth: 2 * h.outlineWidth, stroke: h.outlineColor, strokeLinejoin: "round", children: "" + p }), v(Ye.text, { dominantBaseline: s, textAnchor: l, transform: c.textTransform, style: v7(h), children: "" + p })] }));
}), hZ = function(e) {
  var t = e.axis, n = e.scale, r = e.x, o = r === void 0 ? 0 : r, i = e.y, a = i === void 0 ? 0 : i, s = e.length, l = e.ticksPosition, c = e.tickValues, f = e.tickSize, u = f === void 0 ? 5 : f, h = e.tickPadding, p = h === void 0 ? 5 : h, g = e.tickRotation, m = g === void 0 ? 0 : g, b = e.format, y = e.renderTick, C = y === void 0 ? fZ : y, _ = e.truncateTickAt, M = e.legend, S = e.legendPosition, k = S === void 0 ? "end" : S, L = e.legendOffset, P = L === void 0 ? 0 : L, I = e.onClick, O = e.ariaHidden, E = Ue(), B = E.axis.legend.text, W = j1(function() {
    return ik(b, n);
  }, [b, n]), F = ok({ axis: t, scale: n, ticksPosition: l, tickValues: c, tickSize: u, tickPadding: p, tickRotation: m, truncateTickAt: _ }), z = F.ticks, D = F.textAlign, Z = F.textBaseline, U = null;
  if (M !== void 0) {
    var $, q = 0, K = 0, V = 0;
    t === "y" ? (V = -90, q = P, k === "start" ? ($ = "start", K = s) : k === "middle" ? ($ = "middle", K = s / 2) : k === "end" && ($ = "end")) : (K = P, k === "start" ? $ = "start" : k === "middle" ? ($ = "middle", q = s / 2) : k === "end" && ($ = "end", q = s)), U = s1(ze, { children: [B.outlineWidth > 0 && v("text", { transform: "translate(" + q + ", " + K + ") rotate(" + V + ")", textAnchor: $, style: tt({ dominantBaseline: "central" }, B), strokeWidth: 2 * B.outlineWidth, stroke: B.outlineColor, strokeLinejoin: "round", children: M }), v("text", { transform: "translate(" + q + ", " + K + ") rotate(" + V + ")", textAnchor: $, style: tt({ dominantBaseline: "central" }, B), children: M })] });
  }
  var n1 = rt(), o1 = n1.animate, r1 = n1.config, X = Ft({ transform: "translate(" + o + "," + a + ")", lineX2: t === "x" ? s : 0, lineY2: t === "x" ? 0 : s, config: r1, immediate: !o1 }), Y = R1(function(j) {
    return { opacity: 1, transform: "translate(" + j.x + "," + j.y + ")", textTransform: "translate(" + j.textX + "," + j.textY + ") rotate(" + m + ")" };
  }, [m]), Q = R1(function(j) {
    return { opacity: 0, transform: "translate(" + j.x + "," + j.y + ")", textTransform: "translate(" + j.textX + "," + j.textY + ") rotate(" + m + ")" };
  }, [m]), N = La(z, { keys: function(j) {
    return j.key;
  }, initial: Y, from: Q, enter: Y, update: Y, leave: { opacity: 0 }, config: r1, immediate: !o1 });
  return s1(Ye.g, { transform: X.transform, "aria-hidden": O, children: [N(function(j, t1, T, u1) {
    return d.createElement(C, tt({ tickIndex: u1, format: W, rotate: m, textBaseline: Z, textAnchor: D, truncateTickAt: _, animatedProps: j }, t1, I ? { onClick: I } : {}));
  }), v(Ye.line, { style: E.axis.domain.line, x1: 0, x2: X.lineX2, y1: 0, y2: X.lineY2 }), U] });
}, pZ = Ne(hZ), ak = ["top", "right", "bottom", "left"], sk = Ne(function(e) {
  var t = e.xScale, n = e.yScale, r = e.width, o = e.height, i = { top: e.top, right: e.right, bottom: e.bottom, left: e.left };
  return v(ze, { children: ak.map(function(a) {
    var s = i[a];
    if (!s) return null;
    var l = a === "top" || a === "bottom";
    return v(pZ, tt({}, s, { axis: l ? "x" : "y", x: a === "right" ? r : 0, y: a === "bottom" ? o : 0, scale: l ? t : n, length: l ? r : o, ticksPosition: a === "top" || a === "left" ? "before" : "after", truncateTickAt: s.truncateTickAt }), a);
  }) });
}), mZ = Ne(function(e) {
  var t = e.animatedProps, n = Ue();
  return v(Ye.line, tt({}, t, n.grid.line));
}), Wg = Ne(function(e) {
  var t = e.lines, n = rt(), r = n.animate, o = n.config, i = La(t, { keys: function(a) {
    return a.key;
  }, initial: function(a) {
    return { opacity: 1, x1: a.x1, x2: a.x2, y1: a.y1, y2: a.y2 };
  }, from: function(a) {
    return { opacity: 0, x1: a.x1, x2: a.x2, y1: a.y1, y2: a.y2 };
  }, enter: function(a) {
    return { opacity: 1, x1: a.x1, x2: a.x2, y1: a.y1, y2: a.y2 };
  }, update: function(a) {
    return { opacity: 1, x1: a.x1, x2: a.x2, y1: a.y1, y2: a.y2 };
  }, leave: { opacity: 0 }, config: o, immediate: !r });
  return v("g", { children: i(function(a, s) {
    return s2(mZ, tt({}, s, { key: s.key, animatedProps: a }));
  }) });
}), lk = Ne(function(e) {
  var t = e.width, n = e.height, r = e.xScale, o = e.yScale, i = e.xValues, a = e.yValues, s = j1(function() {
    return !!r && $u({ width: t, height: n, scale: r, axis: "x", values: i });
  }, [r, i, t, n]), l = j1(function() {
    return !!o && $u({ width: t, height: n, scale: o, axis: "y", values: a });
  }, [n, t, o, a]);
  return s1(ze, { children: [s && v(Wg, { lines: s }), l && v(Wg, { lines: l })] });
}), gZ = function(e, t) {
  var n, r = t.axis, o = t.scale, i = t.x, a = i === void 0 ? 0 : i, s = t.y, l = s === void 0 ? 0 : s, c = t.length, f = t.ticksPosition, u = t.tickValues, h = t.tickSize, p = h === void 0 ? 5 : h, g = t.tickPadding, m = g === void 0 ? 5 : g, b = t.tickRotation, y = b === void 0 ? 0 : b, C = t.format, _ = t.legend, M = t.legendPosition, S = M === void 0 ? "end" : M, k = t.legendOffset, L = k === void 0 ? 0 : k, P = t.theme, I = ok({ axis: r, scale: o, ticksPosition: f, tickValues: u, tickSize: p, tickPadding: m, tickRotation: y, engine: "canvas" }), O = I.ticks, E = I.textAlign, B = I.textBaseline;
  e.save(), e.translate(a, l), e.textAlign = E, e.textBaseline = B;
  var W = P.axis.ticks.text;
  e.font = (W.fontWeight ? W.fontWeight + " " : "") + W.fontSize + "px " + W.fontFamily, ((n = P.axis.domain.line.strokeWidth) != null ? n : 0) > 0 && (e.lineWidth = Number(P.axis.domain.line.strokeWidth), e.lineCap = "square", P.axis.domain.line.stroke && (e.strokeStyle = P.axis.domain.line.stroke), e.beginPath(), e.moveTo(0, 0), e.lineTo(r === "x" ? c : 0, r === "x" ? 0 : c), e.stroke());
  var F = typeof C == "function" ? C : function($) {
    return "" + $;
  };
  if (O.forEach(function($) {
    var q;
    ((q = P.axis.ticks.line.strokeWidth) != null ? q : 0) > 0 && (e.lineWidth = Number(P.axis.ticks.line.strokeWidth), e.lineCap = "square", P.axis.ticks.line.stroke && (e.strokeStyle = P.axis.ticks.line.stroke), e.beginPath(), e.moveTo($.x, $.y), e.lineTo($.x + $.lineX, $.y + $.lineY), e.stroke());
    var K = F($.value);
    e.save(), e.translate($.x + $.textX, $.y + $.textY), e.rotate(Er(y)), W.outlineWidth > 0 && (e.strokeStyle = W.outlineColor, e.lineWidth = 2 * W.outlineWidth, e.lineJoin = "round", e.strokeText("" + K, 0, 0)), P.axis.ticks.text.fill && (e.fillStyle = W.fill), e.fillText("" + K, 0, 0), e.restore();
  }), _ !== void 0) {
    var z = 0, D = 0, Z = 0, U = "center";
    r === "y" ? (Z = -90, z = L, S === "start" ? (U = "start", D = c) : S === "middle" ? (U = "center", D = c / 2) : S === "end" && (U = "end")) : (D = L, S === "start" ? U = "start" : S === "middle" ? (U = "center", z = c / 2) : S === "end" && (U = "end", z = c)), e.translate(z, D), e.rotate(Er(Z)), e.font = (P.axis.legend.text.fontWeight ? P.axis.legend.text.fontWeight + " " : "") + P.axis.legend.text.fontSize + "px " + P.axis.legend.text.fontFamily, P.axis.legend.text.fill && (e.fillStyle = P.axis.legend.text.fill), e.textAlign = U, e.textBaseline = "middle", e.fillText(_, 0, 0);
  }
  e.restore();
}, ck = function(e, t) {
  var n = t.xScale, r = t.yScale, o = t.width, i = t.height, a = t.top, s = t.right, l = t.bottom, c = t.left, f = t.theme, u = { top: a, right: s, bottom: l, left: c };
  ak.forEach(function(h) {
    var p = u[h];
    if (!p) return null;
    var g = h === "top" || h === "bottom", m = h === "top" || h === "left" ? "before" : "after", b = g ? n : r, y = ik(p.format, b);
    gZ(e, tt({}, p, { axis: g ? "x" : "y", x: h === "right" ? o : 0, y: h === "bottom" ? i : 0, scale: b, format: y, length: g ? o : i, ticksPosition: m, theme: f }));
  });
}, Si = function(e, t) {
  var n = t.width, r = t.height, o = t.scale, i = t.axis, a = t.values;
  $u({ width: n, height: r, scale: o, axis: i, values: a }).forEach(function(s) {
    e.beginPath(), e.moveTo(s.x1, s.y1), e.lineTo(s.x2, s.y2), e.stroke();
  });
}, qc, Vg;
function vZ() {
  if (Vg) return qc;
  Vg = 1;
  var e = QM();
  function t(n, r) {
    var o = [];
    return e(n, function(i, a, s) {
      r(i, a, s) && o.push(i);
    }), o;
  }
  return qc = t, qc;
}
var zc, Hg;
function bZ() {
  if (Hg) return zc;
  Hg = 1;
  var e = SM(), t = vZ(), n = y7(), r = I2();
  function o(i, a) {
    var s = r(i) ? e : t;
    return s(i, n(a, 3));
  }
  return zc = o, zc;
}
var yZ = bZ();
const CZ = /* @__PURE__ */ h2(yZ);
var Uc, jg;
function wZ() {
  if (jg) return Uc;
  jg = 1;
  var e = a0(), t = nt(), n = "[object Number]";
  function r(o) {
    return typeof o == "number" || t(o) && e(o) == n;
  }
  return Uc = r, Uc;
}
var _Z = wZ();
const qg = /* @__PURE__ */ h2(_Z);
var Gc, zg;
function xZ() {
  if (zg) return Gc;
  zg = 1;
  function e(t, n) {
    for (var r = -1, o = t == null ? 0 : t.length; ++r < o && n(t[r], r, t) !== !1; )
      ;
    return t;
  }
  return Gc = e, Gc;
}
var Yc, Ug;
function SZ() {
  if (Ug) return Yc;
  Ug = 1;
  var e = mn(), t = ao();
  function n(r, o) {
    return r && e(o, t(o), r);
  }
  return Yc = n, Yc;
}
var Zc, Gg;
function MZ() {
  if (Gg) return Zc;
  Gg = 1;
  var e = mn(), t = ro();
  function n(r, o) {
    return r && e(o, t(o), r);
  }
  return Zc = n, Zc;
}
var Kc, Yg;
function kZ() {
  if (Yg) return Kc;
  Yg = 1;
  var e = mn(), t = h7();
  function n(r, o) {
    return e(r, t(r), o);
  }
  return Kc = n, Kc;
}
var Xc, Zg;
function uk() {
  if (Zg) return Xc;
  Zg = 1;
  var e = d7(), t = Sd(), n = h7(), r = MM(), o = Object.getOwnPropertySymbols, i = o ? function(a) {
    for (var s = []; a; )
      e(s, n(a)), a = t(a);
    return s;
  } : r;
  return Xc = i, Xc;
}
var Qc, Kg;
function LZ() {
  if (Kg) return Qc;
  Kg = 1;
  var e = mn(), t = uk();
  function n(r, o) {
    return e(r, t(r), o);
  }
  return Qc = n, Qc;
}
var Jc, Xg;
function dk() {
  if (Xg) return Jc;
  Xg = 1;
  var e = xM(), t = uk(), n = ro();
  function r(o) {
    return e(o, n, t);
  }
  return Jc = r, Jc;
}
var e6, Qg;
function EZ() {
  if (Qg) return e6;
  Qg = 1;
  var e = Object.prototype, t = e.hasOwnProperty;
  function n(r) {
    var o = r.length, i = new r.constructor(o);
    return o && typeof r[0] == "string" && t.call(r, "index") && (i.index = r.index, i.input = r.input), i;
  }
  return e6 = n, e6;
}
var t6, Jg;
function TZ() {
  if (Jg) return t6;
  Jg = 1;
  var e = xd();
  function t(n, r) {
    var o = r ? e(n.buffer) : n.buffer;
    return new n.constructor(o, n.byteOffset, n.byteLength);
  }
  return t6 = t, t6;
}
var n6, ev;
function RZ() {
  if (ev) return n6;
  ev = 1;
  var e = /\w*$/;
  function t(n) {
    var r = new n.constructor(n.source, e.exec(n));
    return r.lastIndex = n.lastIndex, r;
  }
  return n6 = t, n6;
}
var r6, tv;
function PZ() {
  if (tv) return r6;
  tv = 1;
  var e = fn(), t = e ? e.prototype : void 0, n = t ? t.valueOf : void 0;
  function r(o) {
    return n ? Object(n.call(o)) : {};
  }
  return r6 = r, r6;
}
var o6, nv;
function AZ() {
  if (nv) return o6;
  nv = 1;
  var e = xd(), t = TZ(), n = RZ(), r = PZ(), o = Gx(), i = "[object Boolean]", a = "[object Date]", s = "[object Map]", l = "[object Number]", c = "[object RegExp]", f = "[object Set]", u = "[object String]", h = "[object Symbol]", p = "[object ArrayBuffer]", g = "[object DataView]", m = "[object Float32Array]", b = "[object Float64Array]", y = "[object Int8Array]", C = "[object Int16Array]", _ = "[object Int32Array]", M = "[object Uint8Array]", S = "[object Uint8ClampedArray]", k = "[object Uint16Array]", L = "[object Uint32Array]";
  function P(I, O, E) {
    var B = I.constructor;
    switch (O) {
      case p:
        return e(I);
      case i:
      case a:
        return new B(+I);
      case g:
        return t(I, E);
      case m:
      case b:
      case y:
      case C:
      case _:
      case M:
      case S:
      case k:
      case L:
        return o(I, E);
      case s:
        return new B();
      case l:
      case u:
        return new B(I);
      case c:
        return n(I);
      case f:
        return new B();
      case h:
        return r(I);
    }
  }
  return o6 = P, o6;
}
var i6, rv;
function IZ() {
  if (rv) return i6;
  rv = 1;
  var e = Ss(), t = nt(), n = "[object Map]";
  function r(o) {
    return t(o) && e(o) == n;
  }
  return i6 = r, i6;
}
var a6, ov;
function OZ() {
  if (ov) return a6;
  ov = 1;
  var e = IZ(), t = pn(), n = Da(), r = n && n.isMap, o = r ? t(r) : e;
  return a6 = o, a6;
}
var s6, iv;
function NZ() {
  if (iv) return s6;
  iv = 1;
  var e = Ss(), t = nt(), n = "[object Set]";
  function r(o) {
    return t(o) && e(o) == n;
  }
  return s6 = r, s6;
}
var l6, av;
function DZ() {
  if (av) return l6;
  av = 1;
  var e = NZ(), t = pn(), n = Da(), r = n && n.isSet, o = r ? t(r) : e;
  return l6 = o, l6;
}
var c6, sv;
function BZ() {
  if (sv) return c6;
  sv = 1;
  var e = Ia(), t = xZ(), n = Td(), r = SZ(), o = MZ(), i = zx(), a = Yx(), s = kZ(), l = LZ(), c = kM(), f = dk(), u = Ss(), h = EZ(), p = AZ(), g = Kx(), m = I2(), b = Na(), y = OZ(), C = Wt(), _ = DZ(), M = ao(), S = ro(), k = 1, L = 2, P = 4, I = "[object Arguments]", O = "[object Array]", E = "[object Boolean]", B = "[object Date]", W = "[object Error]", F = "[object Function]", z = "[object GeneratorFunction]", D = "[object Map]", Z = "[object Number]", U = "[object Object]", $ = "[object RegExp]", q = "[object Set]", K = "[object String]", V = "[object Symbol]", n1 = "[object WeakMap]", o1 = "[object ArrayBuffer]", r1 = "[object DataView]", X = "[object Float32Array]", Y = "[object Float64Array]", Q = "[object Int8Array]", N = "[object Int16Array]", j = "[object Int32Array]", t1 = "[object Uint8Array]", T = "[object Uint8ClampedArray]", u1 = "[object Uint16Array]", l1 = "[object Uint32Array]", d1 = {};
  d1[I] = d1[O] = d1[o1] = d1[r1] = d1[E] = d1[B] = d1[X] = d1[Y] = d1[Q] = d1[N] = d1[j] = d1[D] = d1[Z] = d1[U] = d1[$] = d1[q] = d1[K] = d1[V] = d1[t1] = d1[T] = d1[u1] = d1[l1] = !0, d1[W] = d1[F] = d1[n1] = !1;
  function C1(g1, D1, re, q1, w1, $1) {
    var I1, me = D1 & k, Se = D1 & L, fe = D1 & P;
    if (re && (I1 = w1 ? re(g1, q1, w1, $1) : re(g1)), I1 !== void 0)
      return I1;
    if (!C(g1))
      return g1;
    var Re = m(g1);
    if (Re) {
      if (I1 = h(g1), !me)
        return a(g1, I1);
    } else {
      var se = u(g1), le = se == F || se == z;
      if (b(g1))
        return i(g1, me);
      if (se == U || se == I || le && !w1) {
        if (I1 = Se || le ? {} : g(g1), !me)
          return Se ? l(g1, o(I1, g1)) : s(g1, r(I1, g1));
      } else {
        if (!d1[se])
          return w1 ? g1 : {};
        I1 = p(g1, se, me);
      }
    }
    $1 || ($1 = new e());
    var G1 = $1.get(g1);
    if (G1)
      return G1;
    $1.set(g1, I1), _(g1) ? g1.forEach(function(he) {
      I1.add(C1(he, D1, re, he, g1, $1));
    }) : y(g1) && g1.forEach(function(he, ve) {
      I1.set(ve, C1(he, D1, re, ve, g1, $1));
    });
    var ge = fe ? Se ? f : c : Se ? S : M, ce = Re ? void 0 : ge(g1);
    return t(ce || g1, function(he, ve) {
      ce && (ve = he, he = g1[ve]), n(I1, ve, C1(he, D1, re, ve, g1, $1));
    }), I1;
  }
  return c6 = C1, c6;
}
var u6, lv;
function FZ() {
  if (lv) return u6;
  lv = 1;
  function e(t, n, r) {
    var o = -1, i = t.length;
    n < 0 && (n = -n > i ? 0 : i + n), r = r > i ? i : r, r < 0 && (r += i), i = n > r ? 0 : r - n >>> 0, n >>>= 0;
    for (var a = Array(i); ++o < i; )
      a[o] = t[o + n];
    return a;
  }
  return u6 = e, u6;
}
var d6, cv;
function $Z() {
  if (cv) return d6;
  cv = 1;
  var e = oo(), t = FZ();
  function n(r, o) {
    return o.length < 2 ? r : e(r, t(o, 0, -1));
  }
  return d6 = n, d6;
}
var f6, uv;
function WZ() {
  if (uv) return f6;
  uv = 1;
  var e = gn(), t = fS(), n = $Z(), r = vn();
  function o(i, a) {
    return a = e(a, i), i = n(i, a), i == null || delete i[r(t(a))];
  }
  return f6 = o, f6;
}
var h6, dv;
function VZ() {
  if (dv) return h6;
  dv = 1;
  var e = Ld();
  function t(n) {
    return e(n) ? void 0 : n;
  }
  return h6 = t, h6;
}
var p6, fv;
function HZ() {
  if (fv) return p6;
  fv = 1;
  var e = Wa(), t = BZ(), n = WZ(), r = gn(), o = mn(), i = VZ(), a = wM(), s = dk(), l = 1, c = 2, f = 4, u = a(function(h, p) {
    var g = {};
    if (h == null)
      return g;
    var m = !1;
    p = e(p, function(y) {
      return y = r(y, h), m || (m = y.length > 1), y;
    }), o(h, s(h), g), m && (g = t(g, l | c | f, i));
    for (var b = p.length; b--; )
      n(g, p[b]);
    return g;
  });
  return p6 = u, p6;
}
var jZ = HZ();
const fk = /* @__PURE__ */ h2(jZ);
function Nt() {
  return Nt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Nt.apply(this, arguments);
}
var Wu = { dotSize: 4, noteWidth: 120, noteTextOffset: 8 }, qZ = function(e) {
  var t = typeof e;
  return TE(e) || t === "string" || t === "function" || t === "object";
}, zZ = function(e) {
  var t = typeof e;
  return t === "string" || t === "function";
}, Rr = function(e) {
  return e.type === "circle";
}, Vu = function(e) {
  return e.type === "dot";
}, Pr = function(e) {
  return e.type === "rect";
}, UZ = function(e) {
  var t = e.data, n = e.annotations, r = e.getPosition, o = e.getDimensions;
  return n.reduce(function(i, a) {
    var s = a.offset || 0;
    return [].concat(i, CZ(t, a.match).map(function(l) {
      var c = r(l), f = o(l);
      return (Rr(a) || Pr(a)) && (f.size = f.size + 2 * s, f.width = f.width + 2 * s, f.height = f.height + 2 * s), Nt({}, fk(a, ["match", "offset"]), c, f, { size: a.size || f.size, datum: l });
    }));
  }, []);
}, GZ = function(e, t, n, r) {
  var o = Math.atan2(r - t, n - e);
  return sY(iY(o));
}, hk = function(e) {
  var t, n, r = e.x, o = e.y, i = e.noteX, a = e.noteY, s = e.noteWidth, l = s === void 0 ? Wu.noteWidth : s, c = e.noteTextOffset, f = c === void 0 ? Wu.noteTextOffset : c;
  if (qg(i)) t = r + i;
  else {
    if (i.abs === void 0) throw new Error("noteX should be either a number or an object containing an 'abs' property");
    t = i.abs;
  }
  if (qg(a)) n = o + a;
  else {
    if (a.abs === void 0) throw new Error("noteY should be either a number or an object containing an 'abs' property");
    n = a.abs;
  }
  var u = r, h = o, p = GZ(r, o, t, n);
  if (Rr(e)) {
    var g = aY(Er(p), e.size / 2);
    u += g.x, h += g.y;
  }
  if (Pr(e)) {
    var m = Math.round((p + 90) / 45) % 8;
    m === 0 && (h -= e.height / 2), m === 1 && (u += e.width / 2, h -= e.height / 2), m === 2 && (u += e.width / 2), m === 3 && (u += e.width / 2, h += e.height / 2), m === 4 && (h += e.height / 2), m === 5 && (u -= e.width / 2, h += e.height / 2), m === 6 && (u -= e.width / 2), m === 7 && (u -= e.width / 2, h -= e.height / 2);
  }
  var b = t, y = t;
  return (p + 90) % 360 > 180 ? (b -= l, y -= l) : y += l, { points: [[u, h], [t, n], [y, n]], text: [b, n - f], angle: p + 90 };
}, pk = function(e) {
  var t = e.data, n = e.annotations, r = e.getPosition, o = e.getDimensions;
  return j1(function() {
    return UZ({ data: t, annotations: n, getPosition: r, getDimensions: o });
  }, [t, n, r, o]);
}, YZ = function(e) {
  var t = e.annotations;
  return j1(function() {
    return t.map(function(n) {
      return Nt({}, n, { computed: hk(Nt({}, n)) });
    });
  }, [t]);
}, ZZ = function(e) {
  return j1(function() {
    return hk(e);
  }, [e]);
}, KZ = function(e) {
  var t = e.datum, n = e.x, r = e.y, o = e.note, i = Ue(), a = rt(), s = a.animate, l = a.config, c = Ft({ x: n, y: r, config: l, immediate: !s });
  return typeof o == "function" ? s2(o, { x: n, y: r, datum: t }) : s1(ze, { children: [i.annotations.text.outlineWidth > 0 && v(Ye.text, { x: c.x, y: c.y, style: Nt({}, i.annotations.text, { strokeLinejoin: "round", strokeWidth: 2 * i.annotations.text.outlineWidth, stroke: i.annotations.text.outlineColor }), children: o }), v(Ye.text, { x: c.x, y: c.y, style: fk(i.annotations.text, ["outlineWidth", "outlineColor"]), children: o })] });
}, hv = function(e) {
  var t = e.points, n = e.isOutline, r = n !== void 0 && n, o = Ue(), i = j1(function() {
    var l = t[0];
    return t.slice(1).reduce(function(c, f) {
      return c + " L" + f[0] + "," + f[1];
    }, "M" + l[0] + "," + l[1]);
  }, [t]), a = m7(i);
  if (r && o.annotations.link.outlineWidth <= 0) return null;
  var s = Nt({}, o.annotations.link);
  return r && (s.strokeLinecap = "square", s.strokeWidth = o.annotations.link.strokeWidth + 2 * o.annotations.link.outlineWidth, s.stroke = o.annotations.link.outlineColor, s.opacity = o.annotations.link.outlineOpacity), v(Ye.path, { fill: "none", d: a, style: s });
}, XZ = function(e) {
  var t = e.x, n = e.y, r = e.size, o = Ue(), i = rt(), a = i.animate, s = i.config, l = Ft({ x: t, y: n, radius: r / 2, config: s, immediate: !a });
  return s1(ze, { children: [o.annotations.outline.outlineWidth > 0 && v(Ye.circle, { cx: l.x, cy: l.y, r: l.radius, style: Nt({}, o.annotations.outline, { fill: "none", strokeWidth: o.annotations.outline.strokeWidth + 2 * o.annotations.outline.outlineWidth, stroke: o.annotations.outline.outlineColor, opacity: o.annotations.outline.outlineOpacity }) }), v(Ye.circle, { cx: l.x, cy: l.y, r: l.radius, style: o.annotations.outline })] });
}, QZ = function(e) {
  var t = e.x, n = e.y, r = e.size, o = r === void 0 ? Wu.dotSize : r, i = Ue(), a = rt(), s = a.animate, l = a.config, c = Ft({ x: t, y: n, radius: o / 2, config: l, immediate: !s });
  return s1(ze, { children: [i.annotations.outline.outlineWidth > 0 && v(Ye.circle, { cx: c.x, cy: c.y, r: c.radius, style: Nt({}, i.annotations.outline, { fill: "none", strokeWidth: 2 * i.annotations.outline.outlineWidth, stroke: i.annotations.outline.outlineColor, opacity: i.annotations.outline.outlineOpacity }) }), v(Ye.circle, { cx: c.x, cy: c.y, r: c.radius, style: i.annotations.symbol })] });
}, JZ = function(e) {
  var t = e.x, n = e.y, r = e.width, o = e.height, i = e.borderRadius, a = i === void 0 ? 6 : i, s = Ue(), l = rt(), c = l.animate, f = l.config, u = Ft({ x: t - r / 2, y: n - o / 2, width: r, height: o, config: f, immediate: !c });
  return s1(ze, { children: [s.annotations.outline.outlineWidth > 0 && v(Ye.rect, { x: u.x, y: u.y, rx: a, ry: a, width: u.width, height: u.height, style: Nt({}, s.annotations.outline, { fill: "none", strokeWidth: s.annotations.outline.strokeWidth + 2 * s.annotations.outline.outlineWidth, stroke: s.annotations.outline.outlineColor, opacity: s.annotations.outline.outlineOpacity }) }), v(Ye.rect, { x: u.x, y: u.y, rx: a, ry: a, width: u.width, height: u.height, style: s.annotations.outline })] });
}, eK = function(e) {
  var t = e.datum, n = e.x, r = e.y, o = e.note, i = ZZ(e);
  if (!qZ(o)) throw new Error("note should be a valid react element");
  return s1(ze, { children: [v(hv, { points: i.points, isOutline: !0 }), Rr(e) && v(XZ, { x: n, y: r, size: e.size }), Vu(e) && v(QZ, { x: n, y: r, size: e.size }), Pr(e) && v(JZ, { x: n, y: r, width: e.width, height: e.height, borderRadius: e.borderRadius }), v(hv, { points: i.points }), v(KZ, { datum: t, x: i.text[0], y: i.text[1], note: o })] });
}, pv = function(e, t) {
  t.forEach(function(n, r) {
    var o = n[0], i = n[1];
    r === 0 ? e.moveTo(o, i) : e.lineTo(o, i);
  });
}, tK = function(e, t) {
  var n = t.annotations, r = t.theme;
  n.length !== 0 && (e.save(), n.forEach(function(o) {
    if (!zZ(o.note)) throw new Error("note is invalid for canvas implementation");
    r.annotations.link.outlineWidth > 0 && (e.lineCap = "square", e.strokeStyle = r.annotations.link.outlineColor, e.lineWidth = r.annotations.link.strokeWidth + 2 * r.annotations.link.outlineWidth, e.beginPath(), pv(e, o.computed.points), e.stroke(), e.lineCap = "butt"), Rr(o) && r.annotations.outline.outlineWidth > 0 && (e.strokeStyle = r.annotations.outline.outlineColor, e.lineWidth = r.annotations.outline.strokeWidth + 2 * r.annotations.outline.outlineWidth, e.beginPath(), e.arc(o.x, o.y, o.size / 2, 0, 2 * Math.PI), e.stroke()), Vu(o) && r.annotations.symbol.outlineWidth > 0 && (e.strokeStyle = r.annotations.symbol.outlineColor, e.lineWidth = 2 * r.annotations.symbol.outlineWidth, e.beginPath(), e.arc(o.x, o.y, o.size / 2, 0, 2 * Math.PI), e.stroke()), Pr(o) && r.annotations.outline.outlineWidth > 0 && (e.strokeStyle = r.annotations.outline.outlineColor, e.lineWidth = r.annotations.outline.strokeWidth + 2 * r.annotations.outline.outlineWidth, e.beginPath(), e.rect(o.x - o.width / 2, o.y - o.height / 2, o.width, o.height), e.stroke()), e.strokeStyle = r.annotations.link.stroke, e.lineWidth = r.annotations.link.strokeWidth, e.beginPath(), pv(e, o.computed.points), e.stroke(), Rr(o) && (e.strokeStyle = r.annotations.outline.stroke, e.lineWidth = r.annotations.outline.strokeWidth, e.beginPath(), e.arc(o.x, o.y, o.size / 2, 0, 2 * Math.PI), e.stroke()), Vu(o) && (e.fillStyle = r.annotations.symbol.fill, e.beginPath(), e.arc(o.x, o.y, o.size / 2, 0, 2 * Math.PI), e.fill()), Pr(o) && (e.strokeStyle = r.annotations.outline.stroke, e.lineWidth = r.annotations.outline.strokeWidth, e.beginPath(), e.rect(o.x - o.width / 2, o.y - o.height / 2, o.width, o.height), e.stroke()), typeof o.note == "function" ? o.note(e, { datum: o.datum, x: o.computed.text[0], y: o.computed.text[1], theme: r }) : (e.font = r.annotations.text.fontSize + "px " + r.annotations.text.fontFamily, e.textAlign = "left", e.textBaseline = "alphabetic", e.fillStyle = r.annotations.text.fill, e.strokeStyle = r.annotations.text.outlineColor, e.lineWidth = 2 * r.annotations.text.outlineWidth, r.annotations.text.outlineWidth > 0 && (e.lineJoin = "round", e.strokeText(o.note, o.computed.text[0], o.computed.text[1]), e.lineJoin = "miter"), e.fillText(o.note, o.computed.text[0], o.computed.text[1]));
  }), e.restore());
};
function Mi() {
  return Mi = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Mi.apply(this, arguments);
}
function mv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function nK(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = function(o, i) {
    if (o) {
      if (typeof o == "string") return mv(o, i);
      var a = Object.prototype.toString.call(o).slice(8, -1);
      return a === "Object" && o.constructor && (a = o.constructor.name), a === "Map" || a === "Set" ? Array.from(o) : a === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? mv(o, i) : void 0;
    }
  }(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var mk = { nivo: ["#e8c1a0", "#f47560", "#f1e15b", "#e8a838", "#61cdbb", "#97e3d5"], category10: Bq, accent: Fq, dark2: $q, paired: Wq, pastel1: Vq, pastel2: Hq, set1: jq, set2: qq, set3: RS, tableau10: zq }, rK = Object.keys(mk), gk = { brown_blueGreen: Ya, purpleRed_green: Za, pink_yellowGreen: Ka, purple_orange: Xa, red_blue: Qa, red_grey: Ja, red_yellow_blue: es, red_yellow_green: ts, spectral: ns }, oK = Object.keys(gk), iK = { brown_blueGreen: Uq, purpleRed_green: Gq, pink_yellowGreen: Yq, purple_orange: Zq, red_blue: Kq, red_grey: Xq, red_yellow_blue: Qq, red_yellow_green: Jq, spectral: ez }, vk = { blues: ms, greens: gs, greys: vs, oranges: Cs, purples: bs, reds: ys, blue_green: rs, blue_purple: os, green_blue: is, orange_red: as, purple_blue_green: ss, purple_blue: ls, purple_red: cs, red_purple: us, yellow_green_blue: ds, yellow_green: fs, yellow_orange_brown: hs, yellow_orange_red: ps }, aK = Object.keys(vk), sK = { blues: hz, greens: pz, greys: mz, oranges: bz, purples: gz, reds: vz, turbo: Lz, viridis: Ez, inferno: Rz, magma: Tz, plasma: Pz, cividis: yz, warm: wz, cool: _z, cubehelixDefault: Cz, blue_green: tz, blue_purple: nz, green_blue: rz, orange_red: oz, purple_blue_green: iz, purple_blue: az, purple_red: sz, red_purple: lz, yellow_green_blue: cz, yellow_green: uz, yellow_orange_brown: dz, yellow_orange_red: fz }, m6 = Mi({}, mk, gk, vk), lK = function(e) {
  return rK.includes(e);
}, cK = function(e) {
  return oK.includes(e);
}, uK = function(e) {
  return aK.includes(e);
}, dK = { rainbow: xz, sinebow: kz };
Mi({}, iK, sK, dK);
var fK = function(e, t) {
  if (typeof e == "function") return e;
  if (u7(e)) {
    if (function(l) {
      return l.theme !== void 0;
    }(e)) {
      if (t === void 0) throw new Error("Unable to use color from theme as no theme was provided");
      var n = It(t, e.theme);
      if (n === void 0) throw new Error("Color from theme is undefined at path: '" + e.theme + "'");
      return function() {
        return n;
      };
    }
    if (function(l) {
      return l.from !== void 0;
    }(e)) {
      var r = function(l) {
        return It(l, e.from);
      };
      if (Array.isArray(e.modifiers)) {
        for (var o, i = [], a = function() {
          var l = o.value, c = l[0], f = l[1];
          if (c === "brighter") i.push(function(u) {
            return u.brighter(f);
          });
          else if (c === "darker") i.push(function(u) {
            return u.darker(f);
          });
          else {
            if (c !== "opacity") throw new Error("Invalid color modifier: '" + c + "', must be one of: 'brighter', 'darker', 'opacity'");
            i.push(function(u) {
              return u.opacity = f, u;
            });
          }
        }, s = nK(e.modifiers); !(o = s()).done; ) a();
        return i.length === 0 ? r : function(l) {
          return i.reduce(function(c, f) {
            return f(c);
          }, U3(r(l))).toString();
        };
      }
      return r;
    }
    throw new Error("Invalid color spec, you should either specify 'theme' or 'from' when using a config object");
  }
  return function() {
    return e;
  };
}, K3 = function(e, t) {
  return j1(function() {
    return fK(e, t);
  }, [e, t]);
};
i1.oneOfType([i1.string, i1.func, i1.shape({ theme: i1.string.isRequired }), i1.shape({ from: i1.string.isRequired, modifiers: i1.arrayOf(i1.array) })]);
var hK = function(e, t) {
  if (typeof e == "function") return e;
  var n = typeof t == "function" ? t : function(u) {
    return It(u, t);
  };
  if (Array.isArray(e)) {
    var r = q0(e), o = function(u) {
      return r(n(u));
    };
    return o.scale = r, o;
  }
  if (u7(e)) {
    if (function(u) {
      return u.datum !== void 0;
    }(e)) return function(u) {
      return It(u, e.datum);
    };
    if (function(u) {
      return u.scheme !== void 0;
    }(e)) {
      if (lK(e.scheme)) {
        var i = q0(m6[e.scheme]), a = function(u) {
          return i(n(u));
        };
        return a.scale = i, a;
      }
      if (cK(e.scheme)) {
        if (e.size !== void 0 && (e.size < 3 || e.size > 11)) throw new Error("Invalid size '" + e.size + "' for diverging color scheme '" + e.scheme + "', must be between 3~11");
        var s = q0(m6[e.scheme][e.size || 11]), l = function(u) {
          return s(n(u));
        };
        return l.scale = s, l;
      }
      if (uK(e.scheme)) {
        if (e.size !== void 0 && (e.size < 3 || e.size > 9)) throw new Error("Invalid size '" + e.size + "' for sequential color scheme '" + e.scheme + "', must be between 3~9");
        var c = q0(m6[e.scheme][e.size || 9]), f = function(u) {
          return c(n(u));
        };
        return f.scale = c, f;
      }
    }
    throw new Error("Invalid colors, when using an object, you should either pass a 'datum' or a 'scheme' property");
  }
  return function() {
    return e;
  };
}, bk = function(e, t) {
  return j1(function() {
    return hK(e, t);
  }, [e, t]);
}, pK = function(e) {
  var t = e.x, n = e.y, r = e.size, o = e.fill, i = e.opacity, a = i === void 0 ? 1 : i, s = e.borderWidth, l = s === void 0 ? 0 : s, c = e.borderColor;
  return v("circle", { r: r / 2, cx: t + r / 2, cy: n + r / 2, fill: o, opacity: a, strokeWidth: l, stroke: c === void 0 ? "transparent" : c, style: { pointerEvents: "none" } });
}, mK = function(e) {
  var t = e.x, n = e.y, r = e.size, o = e.fill, i = e.opacity, a = i === void 0 ? 1 : i, s = e.borderWidth, l = s === void 0 ? 0 : s, c = e.borderColor;
  return v("g", { transform: "translate(" + t + "," + n + ")", children: v("path", { d: `
                    M` + r / 2 + ` 0
                    L` + 0.8 * r + " " + r / 2 + `
                    L` + r / 2 + " " + r + `
                    L` + 0.2 * r + " " + r / 2 + `
                    L` + r / 2 + ` 0
                `, fill: o, opacity: a, strokeWidth: l, stroke: c === void 0 ? "transparent" : c, style: { pointerEvents: "none" } }) });
}, gK = function(e) {
  var t = e.x, n = e.y, r = e.size, o = e.fill, i = e.opacity, a = i === void 0 ? 1 : i, s = e.borderWidth, l = s === void 0 ? 0 : s, c = e.borderColor;
  return v("rect", { x: t, y: n, fill: o, opacity: a, strokeWidth: l, stroke: c === void 0 ? "transparent" : c, width: r, height: r, style: { pointerEvents: "none" } });
}, vK = function(e) {
  var t = e.x, n = e.y, r = e.size, o = e.fill, i = e.opacity, a = i === void 0 ? 1 : i, s = e.borderWidth, l = s === void 0 ? 0 : s, c = e.borderColor;
  return v("g", { transform: "translate(" + t + "," + n + ")", children: v("path", { d: `
                M` + r / 2 + ` 0
                L` + r + " " + r + `
                L0 ` + r + `
                L` + r / 2 + ` 0
            `, fill: o, opacity: a, strokeWidth: l, stroke: c === void 0 ? "transparent" : c, style: { pointerEvents: "none" } }) });
};
function U0() {
  return U0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, U0.apply(this, arguments);
}
var bK = { top: 0, right: 0, bottom: 0, left: 0 }, C7 = function(e) {
  var t, n = e.direction, r = e.itemsSpacing, o = e.padding, i = e.itemCount, a = e.itemWidth, s = e.itemHeight;
  if (typeof o != "number" && (typeof (t = o) != "object" || Array.isArray(t) || t === null)) throw new Error("Invalid property padding, must be one of: number, object");
  var l = typeof o == "number" ? { top: o, right: o, bottom: o, left: o } : U0({}, bK, o), c = l.left + l.right, f = l.top + l.bottom, u = a + c, h = s + f, p = (i - 1) * r;
  return n === "row" ? u = a * i + p + c : n === "column" && (h = s * i + p + f), { width: u, height: h, padding: l };
}, yk = function(e) {
  var t = e.anchor, n = e.translateX, r = e.translateY, o = e.containerWidth, i = e.containerHeight, a = e.width, s = e.height, l = n, c = r;
  switch (t) {
    case "top":
      l += (o - a) / 2;
      break;
    case "top-right":
      l += o - a;
      break;
    case "right":
      l += o - a, c += (i - s) / 2;
      break;
    case "bottom-right":
      l += o - a, c += i - s;
      break;
    case "bottom":
      l += (o - a) / 2, c += i - s;
      break;
    case "bottom-left":
      c += i - s;
      break;
    case "left":
      c += (i - s) / 2;
      break;
    case "center":
      l += (o - a) / 2, c += (i - s) / 2;
  }
  return { x: l, y: c };
}, Ck = function(e) {
  var t, n, r, o, i, a, s = e.direction, l = e.justify, c = e.symbolSize, f = e.symbolSpacing, u = e.width, h = e.height;
  switch (s) {
    case "left-to-right":
      t = 0, n = (h - c) / 2, o = h / 2, a = "central", l ? (r = u, i = "end") : (r = c + f, i = "start");
      break;
    case "right-to-left":
      t = u - c, n = (h - c) / 2, o = h / 2, a = "central", l ? (r = 0, i = "start") : (r = u - c - f, i = "end");
      break;
    case "top-to-bottom":
      t = (u - c) / 2, n = 0, r = u / 2, i = "middle", l ? (o = h, a = "alphabetic") : (o = c + f, a = "text-before-edge");
      break;
    case "bottom-to-top":
      t = (u - c) / 2, n = h - c, r = u / 2, i = "middle", l ? (o = 0, a = "text-before-edge") : (o = h - c - f, a = "alphabetic");
  }
  return { symbolX: t, symbolY: n, labelX: r, labelY: o, labelAnchor: i, labelAlignment: a };
}, yK = { circle: pK, diamond: mK, square: gK, triangle: vK }, CK = function(e) {
  var t, n, r, o, i, a, s, l, c, f, u, h = e.x, p = e.y, g = e.width, m = e.height, b = e.data, y = e.direction, C = y === void 0 ? "left-to-right" : y, _ = e.justify, M = _ !== void 0 && _, S = e.textColor, k = e.background, L = k === void 0 ? "transparent" : k, P = e.opacity, I = P === void 0 ? 1 : P, O = e.symbolShape, E = O === void 0 ? "square" : O, B = e.symbolSize, W = B === void 0 ? 16 : B, F = e.symbolSpacing, z = F === void 0 ? 8 : F, D = e.symbolBorderWidth, Z = D === void 0 ? 0 : D, U = e.symbolBorderColor, $ = U === void 0 ? "transparent" : U, q = e.onClick, K = e.onMouseEnter, V = e.onMouseLeave, n1 = e.toggleSerie, o1 = e.effects, r1 = d2({}), X = r1[0], Y = r1[1], Q = Ue(), N = R1(function(q1) {
    if (o1) {
      var w1 = o1.filter(function($1) {
        return $1.on === "hover";
      }).reduce(function($1, I1) {
        return U0({}, $1, I1.style);
      }, {});
      Y(w1);
    }
    K?.(b, q1);
  }, [K, b, o1]), j = R1(function(q1) {
    if (o1) {
      var w1 = o1.filter(function($1) {
        return $1.on !== "hover";
      }).reduce(function($1, I1) {
        return U0({}, $1, I1.style);
      }, {});
      Y(w1);
    }
    V?.(b, q1);
  }, [V, b, o1]), t1 = Ck({ direction: C, justify: M, symbolSize: (t = X.symbolSize) != null ? t : W, symbolSpacing: z, width: g, height: m }), T = t1.symbolX, u1 = t1.symbolY, l1 = t1.labelX, d1 = t1.labelY, C1 = t1.labelAnchor, g1 = t1.labelAlignment, D1 = [q, K, V, n1].some(function(q1) {
    return q1 !== void 0;
  }), re = typeof E == "function" ? E : yK[E];
  return s1("g", { transform: "translate(" + h + "," + p + ")", style: { opacity: (n = X.itemOpacity) != null ? n : I }, children: [v("rect", { width: g, height: m, fill: (r = X.itemBackground) != null ? r : L, style: { cursor: D1 ? "pointer" : "auto" }, onClick: function(q1) {
    q?.(b, q1), n1?.(b.id);
  }, onMouseEnter: N, onMouseLeave: j }), d.createElement(re, U0({ id: b.id, x: T, y: u1, size: (o = X.symbolSize) != null ? o : W, fill: (i = (a = b.fill) != null ? a : b.color) != null ? i : "black", borderWidth: (s = X.symbolBorderWidth) != null ? s : Z, borderColor: (l = X.symbolBorderColor) != null ? l : $ }, b.hidden ? Q.legends.hidden.symbol : void 0)), v("text", { textAnchor: C1, style: U0({}, v7(Q.legends.text), { fill: (c = (f = (u = X.itemTextColor) != null ? u : S) != null ? f : Q.legends.text.fill) != null ? c : "black", dominantBaseline: g1, pointerEvents: "none", userSelect: "none" }, b.hidden ? Q.legends.hidden.text : void 0), x: l1, y: d1, children: b.label })] });
}, wK = function(e) {
  var t = e.data, n = e.x, r = e.y, o = e.direction, i = e.padding, a = i === void 0 ? 0 : i, s = e.justify, l = e.effects, c = e.itemWidth, f = e.itemHeight, u = e.itemDirection, h = u === void 0 ? "left-to-right" : u, p = e.itemsSpacing, g = p === void 0 ? 0 : p, m = e.itemTextColor, b = e.itemBackground, y = b === void 0 ? "transparent" : b, C = e.itemOpacity, _ = C === void 0 ? 1 : C, M = e.symbolShape, S = e.symbolSize, k = e.symbolSpacing, L = e.symbolBorderWidth, P = e.symbolBorderColor, I = e.onClick, O = e.onMouseEnter, E = e.onMouseLeave, B = e.toggleSerie, W = C7({ itemCount: t.length, itemWidth: c, itemHeight: f, itemsSpacing: g, direction: o, padding: a }).padding, F = o === "row" ? c + g : 0, z = o === "column" ? f + g : 0;
  return v("g", { transform: "translate(" + n + "," + r + ")", children: t.map(function(D, Z) {
    return v(CK, { data: D, x: Z * F + W.left, y: Z * z + W.top, width: c, height: f, direction: h, justify: s, effects: l, textColor: m, background: y, opacity: _, symbolShape: M, symbolSize: S, symbolSpacing: k, symbolBorderWidth: L, symbolBorderColor: P, onClick: I, onMouseEnter: O, onMouseLeave: E, toggleSerie: B }, Z);
  }) });
}, wk = function(e) {
  var t = e.data, n = e.containerWidth, r = e.containerHeight, o = e.translateX, i = o === void 0 ? 0 : o, a = e.translateY, s = a === void 0 ? 0 : a, l = e.anchor, c = e.direction, f = e.padding, u = f === void 0 ? 0 : f, h = e.justify, p = e.itemsSpacing, g = p === void 0 ? 0 : p, m = e.itemWidth, b = e.itemHeight, y = e.itemDirection, C = e.itemTextColor, _ = e.itemBackground, M = e.itemOpacity, S = e.symbolShape, k = e.symbolSize, L = e.symbolSpacing, P = e.symbolBorderWidth, I = e.symbolBorderColor, O = e.onClick, E = e.onMouseEnter, B = e.onMouseLeave, W = e.toggleSerie, F = e.effects, z = C7({ itemCount: t.length, itemsSpacing: g, itemWidth: m, itemHeight: b, direction: c, padding: u }), D = z.width, Z = z.height, U = yk({ anchor: l, translateX: i, translateY: s, containerWidth: n, containerHeight: r, width: D, height: Z }), $ = U.x, q = U.y;
  return v(wK, { data: t, x: $, y: q, direction: c, padding: u, justify: h, effects: F, itemsSpacing: g, itemWidth: m, itemHeight: b, itemDirection: y, itemTextColor: C, itemBackground: _, itemOpacity: M, symbolShape: S, symbolSize: k, symbolSpacing: L, symbolBorderWidth: P, symbolBorderColor: I, onClick: O, onMouseEnter: E, onMouseLeave: B, toggleSerie: typeof W == "boolean" ? void 0 : W });
}, _K = { start: "left", middle: "center", end: "right" }, _k = function(e, t) {
  var n = t.data, r = t.containerWidth, o = t.containerHeight, i = t.translateX, a = i === void 0 ? 0 : i, s = t.translateY, l = s === void 0 ? 0 : s, c = t.anchor, f = t.direction, u = t.padding, h = u === void 0 ? 0 : u, p = t.justify, g = p !== void 0 && p, m = t.itemsSpacing, b = m === void 0 ? 0 : m, y = t.itemWidth, C = t.itemHeight, _ = t.itemDirection, M = _ === void 0 ? "left-to-right" : _, S = t.itemTextColor, k = t.symbolSize, L = k === void 0 ? 16 : k, P = t.symbolSpacing, I = P === void 0 ? 8 : P, O = t.theme, E = C7({ itemCount: n.length, itemWidth: y, itemHeight: C, itemsSpacing: b, direction: f, padding: h }), B = E.width, W = E.height, F = E.padding, z = yk({ anchor: c, translateX: a, translateY: l, containerWidth: r, containerHeight: o, width: B, height: W }), D = z.x, Z = z.y, U = f === "row" ? y + b : 0, $ = f === "column" ? C + b : 0;
  e.save(), e.translate(D, Z), e.font = O.legends.text.fontSize + "px " + (O.legends.text.fontFamily || "sans-serif"), n.forEach(function(q, K) {
    var V, n1, o1 = K * U + F.left, r1 = K * $ + F.top, X = Ck({ direction: M, justify: g, symbolSize: L, symbolSpacing: I, width: y, height: C }), Y = X.symbolX, Q = X.symbolY, N = X.labelX, j = X.labelY, t1 = X.labelAnchor, T = X.labelAlignment;
    e.fillStyle = (V = q.color) != null ? V : "black", e.fillRect(o1 + Y, r1 + Q, L, L), e.textAlign = _K[t1], T === "central" && (e.textBaseline = "middle"), e.fillStyle = (n1 = S ?? O.legends.text.fill) != null ? n1 : "black", e.fillText(String(q.label), o1 + N, r1 + j);
  }), e.restore();
};
function ye() {
  return ye = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ye.apply(this, arguments);
}
function yn(e, t) {
  if (e == null) return {};
  var n, r, o = {}, i = Object.keys(e);
  for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
  return o;
}
var gv, xK = function(e) {
  var t = e.bars, n = e.annotations, r = pk({ data: t, annotations: n, getPosition: function(o) {
    return { x: o.x + o.width / 2, y: o.y + o.height / 2 };
  }, getDimensions: function(o) {
    var i = o.height, a = o.width;
    return { width: a, height: i, size: Math.max(a, i) };
  } });
  return v(ze, { children: r.map(function(o, i) {
    return v(eK, ye({}, o), i);
  }) });
}, SK = function(e) {
  var t = e.width, n = e.height, r = e.legends, o = e.toggleSerie;
  return v(ze, { children: r.map(function(i, a) {
    var s, l = i[0], c = i[1];
    return v(wk, ye({}, l, { containerWidth: t, containerHeight: n, data: (s = l.data) != null ? s : c, toggleSerie: l.toggleSerie && l.dataFrom === "keys" ? o : void 0 }), a);
  }) });
}, MK = ["data"], kK = function(e) {
  var t, n = e.bar, r = n.data, o = yn(n, MK), i = e.style, a = i.borderColor, s = i.color, l = i.height, c = i.labelColor, f = i.labelOpacity, u = i.labelX, h = i.labelY, p = i.transform, g = i.width, m = i.textAnchor, b = e.borderRadius, y = e.borderWidth, C = e.label, _ = e.shouldRenderLabel, M = e.isInteractive, S = e.onClick, k = e.onMouseEnter, L = e.onMouseLeave, P = e.tooltip, I = e.isFocusable, O = e.ariaLabel, E = e.ariaLabelledBy, B = e.ariaDescribedBy, W = e.ariaDisabled, F = e.ariaHidden, z = Ue(), D = d3(), Z = D.showTooltipFromEvent, U = D.showTooltipAt, $ = D.hideTooltip, q = j1(function() {
    return function() {
      return s2(P, ye({}, o, r));
    };
  }, [P, o, r]), K = R1(function(Y) {
    S?.(ye({ color: o.color }, r), Y);
  }, [o, r, S]), V = R1(function(Y) {
    return Z(q(), Y);
  }, [Z, q]), n1 = R1(function(Y) {
    k?.(r, Y), Z(q(), Y);
  }, [r, k, Z, q]), o1 = R1(function(Y) {
    L?.(r, Y), $();
  }, [r, $, L]), r1 = R1(function() {
    U(q(), [o.absX + o.width / 2, o.absY]);
  }, [U, q, o]), X = R1(function() {
    $();
  }, [$]);
  return s1(Ye.g, { transform: p, children: [v(Ye.rect, { width: yu(g, function(Y) {
    return Math.max(Y, 0);
  }), height: yu(l, function(Y) {
    return Math.max(Y, 0);
  }), rx: b, ry: b, fill: (t = r.fill) != null ? t : s, strokeWidth: y, stroke: a, focusable: I, tabIndex: I ? 0 : void 0, "aria-label": O ? O(r) : void 0, "aria-labelledby": E ? E(r) : void 0, "aria-describedby": B ? B(r) : void 0, "aria-disabled": W ? W(r) : void 0, "aria-hidden": F ? F(r) : void 0, onMouseEnter: M ? n1 : void 0, onMouseMove: M ? V : void 0, onMouseLeave: M ? o1 : void 0, onClick: M ? K : void 0, onFocus: M && I ? r1 : void 0, onBlur: M && I ? X : void 0 }), _ && v(Ye.text, { x: u, y: h, textAnchor: m, dominantBaseline: "central", fillOpacity: f, style: ye({}, z.labels.text, { pointerEvents: "none", fill: c }), children: C })] });
}, LK = ["color", "label"], EK = function(e) {
  var t = e.color, n = e.label, r = yn(e, LK);
  return v(yd, { id: n, value: r.formattedValue, enableChip: !0, color: t });
}, Ee = { indexBy: "id", keys: ["value"], groupMode: "stacked", layout: "vertical", reverse: !1, minValue: "auto", maxValue: "auto", valueScale: { type: "linear" }, indexScale: { type: "band", round: !0 }, padding: 0.1, innerPadding: 0, axisBottom: {}, axisLeft: {}, enableGridX: !1, enableGridY: !0, enableLabel: !0, label: "formattedValue", labelPosition: "middle", labelOffset: 0, labelSkipWidth: 0, labelSkipHeight: 0, labelTextColor: { from: "theme", theme: "labels.text.fill" }, colorBy: "id", colors: { scheme: "nivo" }, borderRadius: 0, borderWidth: 0, borderColor: { from: "color" }, isInteractive: !0, tooltip: EK, tooltipLabel: function(e) {
  return e.id + " - " + e.indexValue;
}, legends: [], initialHiddenIds: [], annotations: [], markers: [], enableTotals: !1, totalsOffset: 10 }, Ve = ye({}, Ee, { layers: ["grid", "axes", "bars", "totals", "markers", "legends", "annotations"], barComponent: kK, defs: [], fill: [], animate: !0, motionConfig: "default", role: "img", isFocusable: !1 }), c2 = ye({}, Ee, { layers: ["grid", "axes", "bars", "totals", "legends", "annotations"], pixelRatio: typeof window < "u" && (gv = window.devicePixelRatio) != null ? gv : 1 }), xk = function(e, t, n, r, o, i) {
  return Tr(r, { all: e.map(t), min: 0, max: 0 }, o, i).padding(n);
}, Sk = function(e, t) {
  return e.map(function(n) {
    return ye({}, t.reduce(function(r, o) {
      return r[o] = null, r;
    }, {}), n);
  });
}, Es = function(e) {
  return Object.keys(e).reduce(function(t, n) {
    return e[n] && (t[n] = e[n]), t;
  }, {});
}, Ts = function(e) {
  return [e, Number(e)];
};
function Mk(e, t, n, r) {
  return e === void 0 && (e = Ee.layout), t === void 0 && (t = Ee.reverse), n === void 0 && (n = Ee.labelPosition), r === void 0 && (r = Ee.labelOffset), function(o, i) {
    var a = r * (t ? -1 : 1);
    if (e === "horizontal") {
      var s = o / 2;
      return n === "start" ? s = t ? o : 0 : n === "end" && (s = t ? 0 : o), { labelX: s + a, labelY: i / 2, textAnchor: n === "middle" ? "middle" : t ? "end" : "start" };
    }
    var l = i / 2;
    return n === "start" ? l = t ? 0 : i : n === "end" && (l = t ? i : 0), { labelX: o / 2, labelY: l - a, textAnchor: "middle" };
  };
}
var TK = ["layout", "minValue", "maxValue", "reverse", "width", "height", "padding", "innerPadding", "valueScale", "indexScale", "hiddenIds"], w7 = function(e, t) {
  return e > t;
}, kk = function(e, t) {
  return e < t;
}, Lk = function(e, t) {
  return Array.from(" ".repeat(t - e), function(n, r) {
    return e + r;
  });
}, RK = function(e) {
  return w7(e, 0) ? 0 : e;
}, PK = function(e, t, n, r) {
  var o = e.data, i = e.formatValue, a = e.getColor, s = e.getIndex, l = e.getTooltipLabel, c = e.innerPadding, f = c === void 0 ? 0 : c, u = e.keys, h = e.xScale, p = e.yScale, g = e.margin, m = n ? kk : w7, b = o.map(Es), y = [];
  return u.forEach(function(C, _) {
    return Lk(0, h.domain().length).forEach(function(M) {
      var S, k, L, P = Ts(o[M][C]), I = P[0], O = P[1], E = s(o[M]), B = ((S = h(E)) != null ? S : 0) + t * _ + f * _, W = m(k = O, 0) ? (L = p(k)) != null ? L : 0 : r, F = function(D, Z) {
        var U;
        return m(D, 0) ? r - Z : ((U = p(D)) != null ? U : 0) - r;
      }(O, W), z = { id: C, value: I === null ? I : O, formattedValue: i(O), hidden: !1, index: M, indexValue: E, data: b[M] };
      y.push({ key: C + "." + z.indexValue, index: y.length, data: z, x: B, y: W, absX: g.left + B, absY: g.top + W, width: t, height: F, color: a(z), label: l(z) });
    });
  }), y;
}, AK = function(e, t, n, r) {
  var o = e.data, i = e.formatValue, a = e.getIndex, s = e.getColor, l = e.getTooltipLabel, c = e.keys, f = e.innerPadding, u = f === void 0 ? 0 : f, h = e.xScale, p = e.yScale, g = e.margin, m = n ? kk : w7, b = o.map(Es), y = [];
  return c.forEach(function(C, _) {
    return Lk(0, p.domain().length).forEach(function(M) {
      var S, k, L, P = Ts(o[M][C]), I = P[0], O = P[1], E = a(o[M]), B = m(k = O, 0) ? r : (L = h(k)) != null ? L : 0, W = ((S = p(E)) != null ? S : 0) + t * _ + u * _, F = function(D, Z) {
        var U;
        return m(D, 0) ? ((U = h(D)) != null ? U : 0) - r : r - Z;
      }(O, B), z = { id: C, value: I === null ? I : O, formattedValue: i(O), hidden: !1, index: M, indexValue: E, data: b[M] };
      y.push({ key: C + "." + z.indexValue, index: y.length, data: z, x: B, y: W, absX: g.left + B, absY: g.top + W, width: F, height: t, color: s(z), label: l(z) });
    });
  }), y;
}, IK = function(e) {
  var t, n, r = e.layout, o = e.minValue, i = e.maxValue, a = e.reverse, s = e.width, l = e.height, c = e.padding, f = c === void 0 ? 0 : c, u = e.innerPadding, h = u === void 0 ? 0 : u, p = e.valueScale, g = e.indexScale, m = e.hiddenIds, b = m === void 0 ? [] : m, y = yn(e, TK), C = y.keys.filter(function(q) {
    return !b.includes(q);
  }), _ = Sk(y.data, C), M = r === "vertical" ? ["y", "x", s] : ["x", "y", l], S = M[0], k = M[1], L = M[2], P = xk(_, y.getIndex, f, g, L, k), I = ye({ max: i, min: o, reverse: a }, p), O = I.min === "auto" ? RK : function(q) {
    return q;
  }, E = _.reduce(function(q, K) {
    return [].concat(q, C.map(function(V) {
      return K[V];
    }));
  }, []).filter(Boolean), B = O(Math.min.apply(Math, E)), W = (n = Math.max.apply(Math, E), isFinite(n) ? n : 0), F = Tr(I, { all: E, min: B, max: W }, S === "x" ? s : l, S), z = r === "vertical" ? [P, F] : [F, P], D = z[0], Z = z[1], U = (P.bandwidth() - h * (C.length - 1)) / C.length, $ = [ye({}, y, { data: _, keys: C, innerPadding: h, xScale: D, yScale: Z }), U, I.reverse, (t = F(0)) != null ? t : 0];
  return { xScale: D, yScale: Z, bars: U > 0 ? r === "vertical" ? PK.apply(void 0, $) : AK.apply(void 0, $) : [] };
}, OK = ["data", "layout", "minValue", "maxValue", "reverse", "width", "height", "padding", "valueScale", "indexScale", "hiddenIds"], NK = function e(t) {
  var n;
  return t.some(Array.isArray) ? e((n = []).concat.apply(n, t)) : t;
}, DK = function(e, t, n) {
  var r = e.formatValue, o = e.getColor, i = e.getIndex, a = e.getTooltipLabel, s = e.innerPadding, l = e.stackedData, c = e.xScale, f = e.yScale, u = e.margin, h = [];
  return l.forEach(function(p) {
    return c.domain().forEach(function(g, m) {
      var b, y, C = p[m], _ = (b = c(i(C.data))) != null ? b : 0, M = ((y = function(O) {
        return f(O[n ? 0 : 1]);
      }(C)) != null ? y : 0) + 0.5 * s, S = function(O, E) {
        var B;
        return ((B = f(O[n ? 1 : 0])) != null ? B : 0) - E;
      }(C, M) - s, k = Ts(C.data[p.key]), L = k[0], P = k[1], I = { id: p.key, value: L === null ? L : P, formattedValue: r(P), hidden: !1, index: m, indexValue: g, data: Es(C.data) };
      h.push({ key: p.key + "." + g, index: h.length, data: I, x: _, y: M, absX: u.left + _, absY: u.top + M, width: t, height: S, color: o(I), label: a(I) });
    });
  }), h;
}, BK = function(e, t, n) {
  var r = e.formatValue, o = e.getColor, i = e.getIndex, a = e.getTooltipLabel, s = e.innerPadding, l = e.stackedData, c = e.xScale, f = e.yScale, u = e.margin, h = [];
  return l.forEach(function(p) {
    return f.domain().forEach(function(g, m) {
      var b, y, C = p[m], _ = (b = f(i(C.data))) != null ? b : 0, M = ((y = function(O) {
        return c(O[n ? 1 : 0]);
      }(C)) != null ? y : 0) + 0.5 * s, S = function(O, E) {
        var B;
        return ((B = c(O[n ? 0 : 1])) != null ? B : 0) - E;
      }(C, M) - s, k = Ts(C.data[p.key]), L = k[0], P = k[1], I = { id: p.key, value: L === null ? L : P, formattedValue: r(P), hidden: !1, index: m, indexValue: g, data: Es(C.data) };
      h.push({ key: p.key + "." + g, index: h.length, data: I, x: M, y: _, absX: u.left + M, absY: u.top + _, width: S, height: t, color: o(I), label: a(I) });
    });
  }), h;
}, FK = function(e) {
  var t, n = e.data, r = e.layout, o = e.minValue, i = e.maxValue, a = e.reverse, s = e.width, l = e.height, c = e.padding, f = c === void 0 ? 0 : c, u = e.valueScale, h = e.indexScale, p = e.hiddenIds, g = p === void 0 ? [] : p, m = yn(e, OK), b = m.keys.filter(function(U) {
    return !g.includes(U);
  }), y = dU().keys(b).offset(fU)(Sk(n, b)), C = r === "vertical" ? ["y", "x", s] : ["x", "y", l], _ = C[0], M = C[1], S = C[2], k = xk(n, m.getIndex, f, h, S, M), L = ye({ max: i, min: o, reverse: a }, u), P = (t = NK(y), u.type === "log" ? t.filter(function(U) {
    return U !== 0;
  }) : t), I = Math.min.apply(Math, P), O = Math.max.apply(Math, P), E = Tr(L, { all: P, min: I, max: O }, _ === "x" ? s : l, _), B = r === "vertical" ? [k, E] : [E, k], W = B[0], F = B[1], z = m.innerPadding > 0 ? m.innerPadding : 0, D = k.bandwidth(), Z = [ye({}, m, { innerPadding: z, stackedData: y, xScale: W, yScale: F }), D, L.reverse];
  return { xScale: W, yScale: F, bars: D > 0 ? r === "vertical" ? DK.apply(void 0, Z) : BK.apply(void 0, Z) : [] };
}, $K = function(e) {
  var t = e.bars, n = e.direction, r = e.from, o = e.groupMode, i = e.layout, a = e.legendLabel, s = e.reverse, l = UM(a ?? (r === "indexes" ? "indexValue" : "id"));
  return r === "indexes" ? function(c, f, u) {
    var h = Fu(c.map(function(p) {
      var g, m;
      return { id: (g = p.data.indexValue) != null ? g : "", label: u(p.data), hidden: p.data.hidden, color: (m = p.color) != null ? m : "#000" };
    }), function(p) {
      return p.id;
    });
    return f === "horizontal" && h.reverse(), h;
  }(t, i, l) : function(c, f, u, h, p, g) {
    var m = Fu(c.map(function(b) {
      var y;
      return { id: b.data.id, label: g(b.data), hidden: b.data.hidden, color: (y = b.color) != null ? y : "#000" };
    }), function(b) {
      return b.id;
    });
    return (f === "vertical" && h === "stacked" && u === "column" && p !== !0 || f === "horizontal" && h === "stacked" && p === !0) && m.reverse(), m;
  }(t, i, n, o, s, l);
}, vv = function(e, t, n) {
  var r = e.get(t) || 0;
  e.set(t, r + n);
}, WK = function(e, t, n) {
  var r = e.get(t) || 0;
  e.set(t, r + (n > 0 ? n : 0));
}, VK = function(e, t, n) {
  var r = e.get(t) || 0;
  e.set(t, Math.max(r, Number(n)));
}, HK = function(e, t) {
  var n = e.get(t) || 0;
  e.set(t, n + 1);
}, Ek = function(e) {
  var t = e.indexBy, n = t === void 0 ? Ee.indexBy : t, r = e.keys, o = r === void 0 ? Ee.keys : r, i = e.label, a = i === void 0 ? Ee.label : i, s = e.tooltipLabel, l = s === void 0 ? Ee.tooltipLabel : s, c = e.valueFormat, f = e.colors, u = f === void 0 ? Ee.colors : f, h = e.colorBy, p = h === void 0 ? Ee.colorBy : h, g = e.borderColor, m = g === void 0 ? Ee.borderColor : g, b = e.labelTextColor, y = b === void 0 ? Ee.labelTextColor : b, C = e.groupMode, _ = C === void 0 ? Ee.groupMode : C, M = e.layout, S = M === void 0 ? Ee.layout : M, k = e.reverse, L = k === void 0 ? Ee.reverse : k, P = e.data, I = e.minValue, O = I === void 0 ? Ee.minValue : I, E = e.maxValue, B = E === void 0 ? Ee.maxValue : E, W = e.margin, F = e.width, z = e.height, D = e.padding, Z = D === void 0 ? Ee.padding : D, U = e.innerPadding, $ = U === void 0 ? Ee.innerPadding : U, q = e.valueScale, K = q === void 0 ? Ee.valueScale : q, V = e.indexScale, n1 = V === void 0 ? Ee.indexScale : V, o1 = e.initialHiddenIds, r1 = o1 === void 0 ? Ee.initialHiddenIds : o1, X = e.enableLabel, Y = X === void 0 ? Ee.enableLabel : X, Q = e.labelSkipWidth, N = Q === void 0 ? Ee.labelSkipWidth : Q, j = e.labelSkipHeight, t1 = j === void 0 ? Ee.labelSkipHeight : j, T = e.legends, u1 = T === void 0 ? Ee.legends : T, l1 = e.legendLabel, d1 = e.totalsOffset, C1 = d1 === void 0 ? Ee.totalsOffset : d1, g1 = d2(r1 ?? []), D1 = g1[0], re = g1[1], q1 = R1(function(f1) {
    re(function(b1) {
      return b1.indexOf(f1) > -1 ? b1.filter(function(S1) {
        return S1 !== f1;
      }) : [].concat(b1, [f1]);
    });
  }, []), w1 = vc(n), $1 = vc(a), I1 = vc(l), me = Lr(c), Se = Ue(), fe = bk(u, p), Re = K3(m, Se), se = K3(y, Se), le = (_ === "grouped" ? IK : FK)({ layout: S, reverse: L, data: P, getIndex: w1, keys: o, minValue: O, maxValue: B, width: F, height: z, getColor: fe, padding: Z, innerPadding: $, valueScale: K, indexScale: n1, hiddenIds: D1, formatValue: me, getTooltipLabel: I1, margin: W }), G1 = le.bars, ge = le.xScale, ce = le.yScale, he = j1(function() {
    return G1.filter(function(f1) {
      return f1.data.value !== null;
    }).map(function(f1, b1) {
      return ye({}, f1, { index: b1 });
    });
  }, [G1]), ve = R1(function(f1) {
    var b1 = f1.width, S1 = f1.height;
    return !!Y && !(N > 0 && b1 < N) && !(t1 > 0 && S1 < t1);
  }, [Y, N, t1]), pe = j1(function() {
    return o.map(function(f1) {
      var b1 = G1.find(function(S1) {
        return S1.data.id === f1;
      });
      return ye({}, b1, { data: ye({ id: f1 }, b1?.data, { hidden: D1.includes(f1) }) });
    });
  }, [D1, o, G1]), Ce = j1(function() {
    return u1.map(function(f1) {
      return [f1, $K({ bars: f1.dataFrom === "keys" ? pe : G1, direction: f1.direction, from: f1.dataFrom, groupMode: _, layout: S, legendLabel: l1, reverse: L })];
    });
  }, [u1, pe, G1, _, S, l1, L]), Xe = j1(function() {
    return function(f1, b1, S1, J1, ee, X1, m1) {
      J1 === void 0 && (J1 = Ee.layout), ee === void 0 && (ee = Ee.groupMode);
      var M1 = [];
      if (f1.length === 0) return M1;
      var k1 = /* @__PURE__ */ new Map(), ue = f1[0].width, oe = f1[0].height;
      if (ee === "stacked") {
        var ie = /* @__PURE__ */ new Map();
        f1.forEach(function(v1) {
          var E1 = v1.data, U1 = E1.indexValue, te = E1.value;
          vv(k1, U1, Number(te)), WK(ie, U1, Number(te));
        }), ie.forEach(function(v1, E1) {
          var U1, te, ne, ke = k1.get(E1) || 0;
          J1 === "vertical" ? (U1 = b1(E1), te = S1(v1), ne = S1(v1 / 2)) : (U1 = b1(v1), te = S1(E1), ne = b1(v1 / 2)), U1 += J1 === "vertical" ? ue / 2 : X1, te += J1 === "vertical" ? -X1 : oe / 2, M1.push({ key: "total_" + E1, x: U1, y: te, value: ke, formattedValue: m1(ke), animationOffset: ne });
        });
      } else if (ee === "grouped") {
        var Me = /* @__PURE__ */ new Map(), $e = /* @__PURE__ */ new Map();
        f1.forEach(function(v1) {
          var E1 = v1.data, U1 = E1.indexValue, te = E1.value;
          vv(k1, U1, Number(te)), VK(Me, U1, Number(te)), HK($e, U1);
        }), Me.forEach(function(v1, E1) {
          var U1, te, ne, ke = k1.get(E1) || 0, Qe = $e.get(E1);
          J1 === "vertical" ? (U1 = b1(E1), te = S1(v1), ne = S1(v1 / 2)) : (U1 = b1(v1), te = S1(E1), ne = b1(v1 / 2)), U1 += J1 === "vertical" ? Qe * ue / 2 : X1, te += J1 === "vertical" ? -X1 : Qe * oe / 2, M1.push({ key: "total_" + E1, x: U1, y: te, value: ke, formattedValue: m1(ke), animationOffset: ne });
        });
      }
      return M1;
    }(G1, ge, ce, S, _, C1, me);
  }, [G1, ge, ce, S, _, C1, me]);
  return { bars: G1, barsWithValue: he, xScale: ge, yScale: ce, getIndex: w1, getLabel: $1, getTooltipLabel: I1, formatValue: me, getColor: fe, getBorderColor: Re, getLabelColor: se, shouldRenderBarLabel: ve, hiddenIds: D1, toggleSerie: q1, legendsWithData: Ce, barTotals: Xe };
}, jK = function(e) {
  var t = e.data, n = e.springConfig, r = e.animate, o = e.layout, i = o === void 0 ? Ve.layout : o, a = Ue();
  return La(t, { keys: function(s) {
    return s.key;
  }, from: function(s) {
    return { x: i === "vertical" ? s.x : s.animationOffset, y: i === "vertical" ? s.animationOffset : s.y, labelOpacity: 0 };
  }, enter: function(s) {
    return { x: s.x, y: s.y, labelOpacity: 1 };
  }, update: function(s) {
    return { x: s.x, y: s.y, labelOpacity: 1 };
  }, leave: function(s) {
    return { x: i === "vertical" ? s.x : s.animationOffset, y: i === "vertical" ? s.animationOffset : s.y, labelOpacity: 0 };
  }, config: n, immediate: !r, initial: r ? void 0 : null })(function(s, l) {
    return v(Ye.text, { x: s.x, y: s.y, fillOpacity: s.labelOpacity, style: ye({}, a.labels.text, { pointerEvents: "none", fill: a.text.fill }), fontWeight: "bold", fontSize: a.labels.text.fontSize, fontFamily: a.labels.text.fontFamily, textAnchor: i === "vertical" ? "middle" : "start", alignmentBaseline: i === "vertical" ? "alphabetic" : "middle", children: l.formattedValue }, l.key);
  });
}, qK = ["isInteractive", "animate", "motionConfig", "theme", "renderWrapper"], zK = function(e) {
  var t = e.data, n = e.indexBy, r = e.keys, o = e.margin, i = e.width, a = e.height, s = e.groupMode, l = e.layout, c = e.reverse, f = e.minValue, u = e.maxValue, h = e.valueScale, p = e.indexScale, g = e.padding, m = e.innerPadding, b = e.axisTop, y = e.axisRight, C = e.axisBottom, _ = C === void 0 ? Ve.axisBottom : C, M = e.axisLeft, S = M === void 0 ? Ve.axisLeft : M, k = e.enableGridX, L = k === void 0 ? Ve.enableGridX : k, P = e.enableGridY, I = P === void 0 ? Ve.enableGridY : P, O = e.gridXValues, E = e.gridYValues, B = e.layers, W = B === void 0 ? Ve.layers : B, F = e.barComponent, z = F === void 0 ? Ve.barComponent : F, D = e.enableLabel, Z = D === void 0 ? Ve.enableLabel : D, U = e.label, $ = e.labelSkipWidth, q = $ === void 0 ? Ve.labelSkipWidth : $, K = e.labelSkipHeight, V = K === void 0 ? Ve.labelSkipHeight : K, n1 = e.labelTextColor, o1 = e.labelPosition, r1 = o1 === void 0 ? Ve.labelPosition : o1, X = e.labelOffset, Y = X === void 0 ? Ve.labelOffset : X, Q = e.markers, N = Q === void 0 ? Ve.markers : Q, j = e.colorBy, t1 = e.colors, T = e.defs, u1 = T === void 0 ? Ve.defs : T, l1 = e.fill, d1 = l1 === void 0 ? Ve.fill : l1, C1 = e.borderRadius, g1 = C1 === void 0 ? Ve.borderRadius : C1, D1 = e.borderWidth, re = D1 === void 0 ? Ve.borderWidth : D1, q1 = e.borderColor, w1 = e.annotations, $1 = w1 === void 0 ? Ve.annotations : w1, I1 = e.legendLabel, me = e.tooltipLabel, Se = e.valueFormat, fe = e.isInteractive, Re = fe === void 0 ? Ve.isInteractive : fe, se = e.tooltip, le = se === void 0 ? Ve.tooltip : se, G1 = e.onClick, ge = e.onMouseEnter, ce = e.onMouseLeave, he = e.legends, ve = e.role, pe = ve === void 0 ? Ve.role : ve, Ce = e.ariaLabel, Xe = e.ariaLabelledBy, f1 = e.ariaDescribedBy, b1 = e.isFocusable, S1 = b1 === void 0 ? Ve.isFocusable : b1, J1 = e.barAriaLabel, ee = e.barAriaLabelledBy, X1 = e.barAriaDescribedBy, m1 = e.barAriaHidden, M1 = e.barAriaDisabled, k1 = e.initialHiddenIds, ue = e.enableTotals, oe = ue === void 0 ? Ve.enableTotals : ue, ie = e.totalsOffset, Me = ie === void 0 ? Ve.totalsOffset : ie, $e = rt(), v1 = $e.animate, E1 = $e.config, U1 = ks(i, a, o), te = U1.outerWidth, ne = U1.outerHeight, ke = U1.margin, Qe = U1.innerWidth, je = U1.innerHeight, we = Ek({ indexBy: n, label: U, tooltipLabel: me, valueFormat: Se, colors: t1, colorBy: j, borderColor: q1, labelTextColor: n1, groupMode: s, layout: l, reverse: c, data: t, keys: r, minValue: f, maxValue: u, margin: ke, width: Qe, height: je, padding: g, innerPadding: m, valueScale: h, indexScale: p, enableLabel: Z, labelSkipWidth: q, labelSkipHeight: V, legends: he, legendLabel: I1, initialHiddenIds: k1, totalsOffset: Me }), it = we.bars, c0 = we.barsWithValue, Ze = we.xScale, $2 = we.yScale, N0 = we.getLabel, N1 = we.getTooltipLabel, B1 = we.getBorderColor, ae = we.getLabelColor, be = we.shouldRenderBarLabel, de = we.toggleSerie, Je = we.legendsWithData, De = we.barTotals, Le = we.getColor, at = Mk(l, c, r1, Y), Ct = La(c0, { keys: function(L1) {
    return L1.key;
  }, from: function(L1) {
    return ye({ borderColor: B1(L1), color: L1.color, height: 0, labelColor: ae(L1), labelOpacity: 0 }, at(L1.width, L1.height), { transform: "translate(" + L1.x + ", " + (L1.y + L1.height) + ")", width: L1.width }, l === "vertical" ? {} : { height: L1.height, transform: "translate(" + L1.x + ", " + L1.y + ")", width: 0 });
  }, enter: function(L1) {
    return ye({ borderColor: B1(L1), color: L1.color, height: L1.height, labelColor: ae(L1), labelOpacity: 1 }, at(L1.width, L1.height), { transform: "translate(" + L1.x + ", " + L1.y + ")", width: L1.width });
  }, update: function(L1) {
    return ye({ borderColor: B1(L1), color: L1.color, height: L1.height, labelColor: ae(L1), labelOpacity: 1 }, at(L1.width, L1.height), { transform: "translate(" + L1.x + ", " + L1.y + ")", width: L1.width });
  }, leave: function(L1) {
    return ye({ borderColor: B1(L1), color: L1.color, height: 0, labelColor: ae(L1), labelOpacity: 0 }, at(L1.width, L1.height), { labelY: 0, transform: "translate(" + L1.x + ", " + (L1.y + L1.height) + ")", width: L1.width }, l === "vertical" ? {} : ye({}, at(L1.width, L1.height), { labelX: 0, height: L1.height, transform: "translate(" + L1.x + ", " + L1.y + ")", width: 0 }));
  }, config: E1, immediate: !v1, initial: v1 ? void 0 : null }), W2 = j1(function() {
    return { borderRadius: g1, borderWidth: re, enableLabel: Z, isInteractive: Re, labelSkipWidth: q, labelSkipHeight: V, onClick: G1, onMouseEnter: ge, onMouseLeave: ce, getTooltipLabel: N1, tooltip: le, isFocusable: S1, ariaLabel: J1, ariaLabelledBy: ee, ariaDescribedBy: X1, ariaHidden: m1, ariaDisabled: M1 };
  }, [g1, re, Z, N1, Re, V, q, G1, ge, ce, le, S1, J1, ee, X1, m1, M1]), V2 = YM(u1, it, d1, { dataKey: "data", targetKey: "data.fill" }), C2 = { annotations: null, axes: null, bars: null, grid: null, legends: null, markers: null, totals: null };
  W.includes("annotations") && (C2.annotations = v(xK, { bars: it, annotations: $1 }, "annotations")), W.includes("axes") && (C2.axes = v(sk, { xScale: Ze, yScale: $2, width: Qe, height: je, top: b, right: y, bottom: _, left: S }, "axes")), W.includes("bars") && (C2.bars = v(N6, { children: Ct(function(L1, w2) {
    return s2(z, ye({}, W2, { bar: w2, style: L1, shouldRenderLabel: be(w2), label: N0(w2.data) }));
  }) }, "bars")), W.includes("grid") && (C2.grid = v(lk, { width: Qe, height: je, xScale: L ? Ze : null, yScale: I ? $2 : null, xValues: O, yValues: E }, "grid")), W.includes("legends") && (C2.legends = v(SK, { width: Qe, height: je, legends: Je, toggleSerie: de }, "legends")), W.includes("markers") && (C2.markers = v(qM, { markers: N, width: Qe, height: je, xScale: Ze, yScale: $2 }, "markers")), W.includes("totals") && oe && (C2.totals = v(jK, { data: De, springConfig: E1, animate: v1, layout: l }, "totals"));
  var u0 = j1(function() {
    return ye({}, W2, { margin: ke, width: i, height: a, innerWidth: Qe, innerHeight: je, bars: it, legendData: Je, enableLabel: Z, xScale: Ze, yScale: $2, tooltip: le, getTooltipLabel: N1, onClick: G1, onMouseEnter: ge, onMouseLeave: ce, getColor: Le });
  }, [W2, ke, i, a, Qe, je, it, Je, Z, Ze, $2, le, N1, G1, ge, ce, Le]);
  return v(b7, { width: te, height: ne, margin: ke, defs: V2, role: pe, ariaLabel: Ce, ariaLabelledBy: Xe, ariaDescribedBy: f1, isFocusable: S1, children: W.map(function(L1, w2) {
    var _2;
    return typeof L1 == "function" ? v(N6, { children: s2(L1, u0) }, w2) : (_2 = C2?.[L1]) != null ? _2 : null;
  }) });
}, UK = function(e) {
  var t = e.isInteractive, n = t === void 0 ? Ve.isInteractive : t, r = e.animate, o = r === void 0 ? Ve.animate : r, i = e.motionConfig, a = i === void 0 ? Ve.motionConfig : i, s = e.theme, l = e.renderWrapper, c = yn(e, qK);
  return v(Ls, { animate: o, isInteractive: n, motionConfig: a, renderWrapper: l, theme: s, children: v(zK, ye({ isInteractive: n }, c)) });
}, GK = ["isInteractive", "renderWrapper", "theme"], g6 = function(e, t, n, r) {
  return e.find(function(o) {
    return GM(o.x + t.left, o.y + t.top, o.width, o.height, n, r);
  });
}, YK = function(e) {
  var t = e.data, n = e.indexBy, r = e.keys, o = e.margin, i = e.width, a = e.height, s = e.groupMode, l = e.layout, c = e.reverse, f = e.minValue, u = e.maxValue, h = e.valueScale, p = e.indexScale, g = e.padding, m = e.innerPadding, b = e.axisTop, y = e.axisRight, C = e.axisBottom, _ = C === void 0 ? c2.axisBottom : C, M = e.axisLeft, S = M === void 0 ? c2.axisLeft : M, k = e.enableGridX, L = k === void 0 ? c2.enableGridX : k, P = e.enableGridY, I = P === void 0 ? c2.enableGridY : P, O = e.gridXValues, E = e.gridYValues, B = e.labelPosition, W = B === void 0 ? c2.labelPosition : B, F = e.labelOffset, z = F === void 0 ? c2.labelOffset : F, D = e.layers, Z = D === void 0 ? c2.layers : D, U = e.renderBar, $ = U === void 0 ? function(N1, B1) {
    var ae = B1.bar, be = ae.color, de = ae.height, Je = ae.width, De = ae.x, Le = ae.y, at = B1.borderColor, Ct = B1.borderRadius, W2 = B1.borderWidth, V2 = B1.label, C2 = B1.labelColor, u0 = B1.shouldRenderLabel, L1 = B1.labelX, w2 = B1.labelY, _2 = B1.textAnchor;
    if (N1.fillStyle = be, W2 > 0 && (N1.strokeStyle = at, N1.lineWidth = W2), N1.beginPath(), Ct > 0) {
      var O2 = Math.min(Ct, de);
      N1.moveTo(De + O2, Le), N1.lineTo(De + Je - O2, Le), N1.quadraticCurveTo(De + Je, Le, De + Je, Le + O2), N1.lineTo(De + Je, Le + de - O2), N1.quadraticCurveTo(De + Je, Le + de, De + Je - O2, Le + de), N1.lineTo(De + O2, Le + de), N1.quadraticCurveTo(De, Le + de, De, Le + de - O2), N1.lineTo(De, Le + O2), N1.quadraticCurveTo(De, Le, De + O2, Le), N1.closePath();
    } else N1.rect(De, Le, Je, de);
    N1.fill(), W2 > 0 && N1.stroke(), u0 && (N1.textBaseline = "middle", N1.textAlign = _2 === "middle" ? "center" : _2, N1.fillStyle = C2, N1.fillText(V2, De + L1, Le + w2));
  } : U, q = e.enableLabel, K = q === void 0 ? c2.enableLabel : q, V = e.label, n1 = e.labelSkipWidth, o1 = n1 === void 0 ? c2.labelSkipWidth : n1, r1 = e.labelSkipHeight, X = r1 === void 0 ? c2.labelSkipHeight : r1, Y = e.labelTextColor, Q = e.colorBy, N = e.colors, j = e.borderRadius, t1 = j === void 0 ? c2.borderRadius : j, T = e.borderWidth, u1 = T === void 0 ? c2.borderWidth : T, l1 = e.borderColor, d1 = e.annotations, C1 = d1 === void 0 ? c2.annotations : d1, g1 = e.legendLabel, D1 = e.tooltipLabel, re = e.valueFormat, q1 = e.isInteractive, w1 = q1 === void 0 ? c2.isInteractive : q1, $1 = e.tooltip, I1 = $1 === void 0 ? c2.tooltip : $1, me = e.onClick, Se = e.onMouseEnter, fe = e.onMouseLeave, Re = e.legends, se = e.pixelRatio, le = se === void 0 ? c2.pixelRatio : se, G1 = e.canvasRef, ge = e.enableTotals, ce = ge === void 0 ? c2.enableTotals : ge, he = e.totalsOffset, ve = he === void 0 ? c2.totalsOffset : he, pe = Be(null), Ce = Ue(), Xe = ks(i, a, o), f1 = Xe.margin, b1 = Xe.innerWidth, S1 = Xe.innerHeight, J1 = Xe.outerWidth, ee = Xe.outerHeight, X1 = Ek({ indexBy: n, label: V, tooltipLabel: D1, valueFormat: re, colors: N, colorBy: Q, borderColor: l1, labelTextColor: Y, groupMode: s, layout: l, reverse: c, data: t, keys: r, minValue: f, maxValue: u, margin: f1, width: b1, height: S1, padding: g, innerPadding: m, valueScale: h, indexScale: p, enableLabel: K, labelSkipWidth: o1, labelSkipHeight: X, legends: Re, legendLabel: g1, totalsOffset: ve }), m1 = X1.bars, M1 = X1.barsWithValue, k1 = X1.xScale, ue = X1.yScale, oe = X1.getLabel, ie = X1.getTooltipLabel, Me = X1.getBorderColor, $e = X1.getLabelColor, v1 = X1.shouldRenderBarLabel, E1 = X1.legendsWithData, U1 = X1.barTotals, te = X1.getColor, ne = d3(), ke = ne.showTooltipFromEvent, Qe = ne.hideTooltip, je = YZ({ annotations: pk({ data: m1, annotations: C1, getPosition: function(N1) {
    return { x: N1.x, y: N1.y };
  }, getDimensions: function(N1) {
    var B1 = N1.width, ae = N1.height;
    return { width: B1, height: ae, size: Math.max(B1, ae) };
  } }) }), we = j1(function() {
    return { borderRadius: t1, borderWidth: u1, isInteractive: w1, isFocusable: !1, labelSkipWidth: o1, labelSkipHeight: X, margin: f1, width: i, height: a, innerWidth: b1, innerHeight: S1, bars: m1, legendData: E1, enableLabel: K, xScale: k1, yScale: ue, tooltip: I1, getTooltipLabel: ie, onClick: me, onMouseEnter: Se, onMouseLeave: fe, getColor: te };
  }, [t1, u1, w1, o1, X, f1, i, a, b1, S1, m1, E1, K, k1, ue, I1, ie, me, Se, fe, te]), it = Lr(re), c0 = Mk(l, c, W, z);
  Te(function() {
    var N1, B1 = (N1 = pe.current) == null ? void 0 : N1.getContext("2d");
    pe.current && B1 && (pe.current.width = J1 * le, pe.current.height = ee * le, B1.scale(le, le), B1.fillStyle = Ce.background, B1.fillRect(0, 0, J1, ee), B1.translate(f1.left, f1.top), Z.forEach(function(ae) {
      ae === "grid" ? typeof Ce.grid.line.strokeWidth == "number" && Ce.grid.line.strokeWidth > 0 && (B1.lineWidth = Ce.grid.line.strokeWidth, B1.strokeStyle = Ce.grid.line.stroke, L && Si(B1, { width: b1, height: S1, scale: k1, axis: "x", values: O }), I && Si(B1, { width: b1, height: S1, scale: ue, axis: "y", values: E })) : ae === "axes" ? ck(B1, { xScale: k1, yScale: ue, width: b1, height: S1, top: b, right: y, bottom: _, left: S, theme: Ce }) : ae === "bars" ? M1.forEach(function(be) {
        $(B1, ye({ bar: be, borderColor: Me(be), borderRadius: t1, borderWidth: u1, label: oe(be.data), labelColor: $e(be), shouldRenderLabel: v1(be) }, c0(be.width, be.height)));
      }) : ae === "legends" ? E1.forEach(function(be) {
        var de = be[0], Je = be[1];
        _k(B1, ye({}, de, { data: Je, containerWidth: b1, containerHeight: S1, theme: Ce }));
      }) : ae === "annotations" ? tK(B1, { annotations: je, theme: Ce }) : ae === "totals" && ce ? function(be, de, Je, De) {
        De === void 0 && (De = c2.layout), be.fillStyle = Je.text.fill, be.font = "bold " + Je.labels.text.fontSize + "px " + Je.labels.text.fontFamily, be.textBaseline = De === "vertical" ? "alphabetic" : "middle", be.textAlign = De === "vertical" ? "center" : "start", de.forEach(function(Le) {
          be.fillText(Le.formattedValue, Le.x, Le.y);
        });
      }(B1, U1, Ce, l) : typeof ae == "function" && ae(B1, we);
    }), B1.save());
  }, [_, S, y, b, M1, t1, u1, je, L, I, Me, oe, $e, O, E, s, a, S1, b1, we, Z, l, E1, f1.left, f1.top, ee, J1, le, $, k1, ue, c, v1, Ce, i, U1, ce, it, c0]);
  var Ze = R1(function(N1) {
    if (m1 && pe.current) {
      var B1 = nr(pe.current, N1), ae = B1[0], be = B1[1], de = g6(m1, f1, ae, be);
      de !== void 0 ? (ke(s2(I1, ye({}, de.data, { color: de.color, label: de.label, value: Number(de.data.value) })), N1), N1.type === "mouseenter" && Se?.(de.data, N1)) : Qe();
    }
  }, [Qe, f1, Se, m1, ke, I1]), $2 = R1(function(N1) {
    if (m1 && pe.current) {
      Qe();
      var B1 = nr(pe.current, N1), ae = B1[0], be = B1[1], de = g6(m1, f1, ae, be);
      de && fe?.(de.data, N1);
    }
  }, [Qe, f1, fe, m1]), N0 = R1(function(N1) {
    if (m1 && pe.current) {
      var B1 = nr(pe.current, N1), ae = B1[0], be = B1[1], de = g6(m1, f1, ae, be);
      de !== void 0 && me?.(ye({}, de.data, { color: de.color }), N1);
    }
  }, [f1, me, m1]);
  return v("canvas", { ref: function(N1) {
    pe.current = N1, G1 && "current" in G1 && (G1.current = N1);
  }, width: J1 * le, height: ee * le, style: { width: J1, height: ee, cursor: w1 ? "auto" : "normal" }, onMouseEnter: w1 ? Ze : void 0, onMouseMove: w1 ? Ze : void 0, onMouseLeave: w1 ? $2 : void 0, onClick: w1 ? N0 : void 0 });
}, ZK = x1(function(e, t) {
  var n = e.isInteractive, r = e.renderWrapper, o = e.theme, i = yn(e, GK);
  return v(Ls, { isInteractive: n, renderWrapper: r, theme: o, animate: !1, children: v(YK, ye({}, i, { canvasRef: t })) });
}), KK = function(e) {
  return v(so, { children: function(t) {
    var n = t.width, r = t.height;
    return v(UK, ye({ width: n, height: r }, e));
  } });
};
x1(function(e, t) {
  return v(so, { children: function(n) {
    var r = n.width, o = n.height;
    return v(ZK, ye({ width: r, height: o }, e, { ref: t }));
  } });
});
function Tk({
  axisBottom: e,
  axisLeft: t,
  areaOpacity: n,
  gradientFillColor: r
}) {
  return j1(() => {
    const o = {
      text: {
        fontFamily: "Outfit, sans-serif"
      },
      axis: {
        ticks: {
          text: {
            fontSize: 10,
            fontWeight: 300,
            fill: "hsl(var(--ring))"
          }
        }
      },
      grid: {
        line: {
          stroke: "hsl(var(--muted))",
          strokeWidth: 1
        }
      },
      legends: {
        text: {
          fontSize: 12,
          fontWeight: 300,
          fill: "hsl(var(--secondary-foreground))"
        }
      },
      labels: {
        text: {
          fontSize: 12,
          fontWeight: 700
        }
      }
    }, i = {
      enableGridX: !1,
      enableGridY: !0
    }, a = {
      curve: "monotoneX",
      lineWidth: 1
    }, s = {
      pointSize: 5,
      pointColor: "hsl(var(--background))",
      pointBorderWidth: 1,
      pointBorderColor: { from: "serieColor" }
    }, l = {
      enableArea: !0,
      areaOpacity: n,
      defs: [
        {
          id: "gradientFill",
          type: "linearGradient",
          colors: [
            { offset: 0, color: r || "inherit" },
            { offset: 100, color: r || "inherit", opacity: 0 }
          ]
        }
      ],
      fill: [
        {
          match: "*",
          id: "gradientFill"
        }
      ]
    }, c = {};
    return e !== null && (c.axisBottom = {
      tickSize: 0,
      tickRotation: 0,
      tickPadding: 5,
      ...e
    }), t !== null && (c.axisLeft = {
      tickSize: 0,
      tickValues: 6,
      tickPadding: 10,
      ...t
    }), {
      theme: o,
      grid: i,
      axes: c,
      lineConfig: a,
      pointDefinition: s,
      gradientConfig: l
    };
  }, [e, t, n, r]);
}
function Rk({ className: e, ...t }) {
  const { theme: n, grid: r, axes: o } = Tk({
    axisBottom: t.axisBottom,
    axisLeft: t.axisLeft
  });
  return /* @__PURE__ */ v("div", { className: e, children: /* @__PURE__ */ v(KK, { ...t, theme: n, ...r, ...o }) });
}
Rk.displayName = "LBBarChart";
const XK = Z2(
  "relative w-full rounded-lg border px-4 py-3 text-sm [&>svg+div]:-translate-y-0.75 [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground [&>svg~*]:pl-7",
  {
    variants: {
      variant: {
        default: "bg-background text-foreground",
        destructive: "border-destructive/50 text-destructive dark:border-destructive [&>svg]:text-destructive",
        success: "border-success/50 bg-white text-success dark:border-success [&>svg]:text-success"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), QK = d.forwardRef(({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ v(
  "div",
  {
    ref: r,
    role: "alert",
    className: e1("flex gap-4", XK({ variant: t }), e),
    ...n
  }
));
QK.displayName = "LBAlert";
const JK = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  "h5",
  {
    ref: n,
    className: e1("mb-1 font-medium leading-none tracking-tight", e),
    ...t
  }
));
JK.displayName = "LBAlertTitle";
const eX = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  "div",
  {
    ref: n,
    className: e1("text-sm [&_p]:leading-relaxed", e),
    ...t
  }
));
eX.displayName = "LBAlertDescription";
var v6, bv;
function tX() {
  if (bv) return v6;
  bv = 1;
  var e = rS(), t = 0;
  function n(r) {
    var o = ++t;
    return e(r) + o;
  }
  return v6 = n, v6;
}
var nX = tX();
const rX = /* @__PURE__ */ h2(nX), Jt = 11102230246251565e-32, x2 = 134217729, oX = (3 + 8 * Jt) * Jt;
function b6(e, t, n, r, o) {
  let i, a, s, l, c = t[0], f = r[0], u = 0, h = 0;
  f > c == f > -c ? (i = c, c = t[++u]) : (i = f, f = r[++h]);
  let p = 0;
  if (u < e && h < n)
    for (f > c == f > -c ? (a = c + i, s = i - (a - c), c = t[++u]) : (a = f + i, s = i - (a - f), f = r[++h]), i = a, s !== 0 && (o[p++] = s); u < e && h < n; )
      f > c == f > -c ? (a = i + c, l = a - i, s = i - (a - l) + (c - l), c = t[++u]) : (a = i + f, l = a - i, s = i - (a - l) + (f - l), f = r[++h]), i = a, s !== 0 && (o[p++] = s);
  for (; u < e; )
    a = i + c, l = a - i, s = i - (a - l) + (c - l), c = t[++u], i = a, s !== 0 && (o[p++] = s);
  for (; h < n; )
    a = i + f, l = a - i, s = i - (a - l) + (f - l), f = r[++h], i = a, s !== 0 && (o[p++] = s);
  return (i !== 0 || p === 0) && (o[p++] = i), p;
}
function iX(e, t) {
  let n = t[0];
  for (let r = 1; r < e; r++) n += t[r];
  return n;
}
function lo(e) {
  return new Float64Array(e);
}
const aX = (3 + 16 * Jt) * Jt, sX = (2 + 12 * Jt) * Jt, lX = (9 + 64 * Jt) * Jt * Jt, k3 = lo(4), yv = lo(8), Cv = lo(12), wv = lo(16), R2 = lo(4);
function cX(e, t, n, r, o, i, a) {
  let s, l, c, f, u, h, p, g, m, b, y, C, _, M, S, k, L, P;
  const I = e - o, O = n - o, E = t - i, B = r - i;
  M = I * B, h = x2 * I, p = h - (h - I), g = I - p, h = x2 * B, m = h - (h - B), b = B - m, S = g * b - (M - p * m - g * m - p * b), k = E * O, h = x2 * E, p = h - (h - E), g = E - p, h = x2 * O, m = h - (h - O), b = O - m, L = g * b - (k - p * m - g * m - p * b), y = S - L, u = S - y, k3[0] = S - (y + u) + (u - L), C = M + y, u = C - M, _ = M - (C - u) + (y - u), y = _ - k, u = _ - y, k3[1] = _ - (y + u) + (u - k), P = C + y, u = P - C, k3[2] = C - (P - u) + (y - u), k3[3] = P;
  let W = iX(4, k3), F = sX * a;
  if (W >= F || -W >= F || (u = e - I, s = e - (I + u) + (u - o), u = n - O, c = n - (O + u) + (u - o), u = t - E, l = t - (E + u) + (u - i), u = r - B, f = r - (B + u) + (u - i), s === 0 && l === 0 && c === 0 && f === 0) || (F = lX * a + oX * Math.abs(W), W += I * f + B * s - (E * c + O * l), W >= F || -W >= F)) return W;
  M = s * B, h = x2 * s, p = h - (h - s), g = s - p, h = x2 * B, m = h - (h - B), b = B - m, S = g * b - (M - p * m - g * m - p * b), k = l * O, h = x2 * l, p = h - (h - l), g = l - p, h = x2 * O, m = h - (h - O), b = O - m, L = g * b - (k - p * m - g * m - p * b), y = S - L, u = S - y, R2[0] = S - (y + u) + (u - L), C = M + y, u = C - M, _ = M - (C - u) + (y - u), y = _ - k, u = _ - y, R2[1] = _ - (y + u) + (u - k), P = C + y, u = P - C, R2[2] = C - (P - u) + (y - u), R2[3] = P;
  const z = b6(4, k3, 4, R2, yv);
  M = I * f, h = x2 * I, p = h - (h - I), g = I - p, h = x2 * f, m = h - (h - f), b = f - m, S = g * b - (M - p * m - g * m - p * b), k = E * c, h = x2 * E, p = h - (h - E), g = E - p, h = x2 * c, m = h - (h - c), b = c - m, L = g * b - (k - p * m - g * m - p * b), y = S - L, u = S - y, R2[0] = S - (y + u) + (u - L), C = M + y, u = C - M, _ = M - (C - u) + (y - u), y = _ - k, u = _ - y, R2[1] = _ - (y + u) + (u - k), P = C + y, u = P - C, R2[2] = C - (P - u) + (y - u), R2[3] = P;
  const D = b6(z, yv, 4, R2, Cv);
  M = s * f, h = x2 * s, p = h - (h - s), g = s - p, h = x2 * f, m = h - (h - f), b = f - m, S = g * b - (M - p * m - g * m - p * b), k = l * c, h = x2 * l, p = h - (h - l), g = l - p, h = x2 * c, m = h - (h - c), b = c - m, L = g * b - (k - p * m - g * m - p * b), y = S - L, u = S - y, R2[0] = S - (y + u) + (u - L), C = M + y, u = C - M, _ = M - (C - u) + (y - u), y = _ - k, u = _ - y, R2[1] = _ - (y + u) + (u - k), P = C + y, u = P - C, R2[2] = C - (P - u) + (y - u), R2[3] = P;
  const Z = b6(D, Cv, 4, R2, wv);
  return wv[Z - 1];
}
function No(e, t, n, r, o, i) {
  const a = (t - i) * (n - o), s = (e - o) * (r - i), l = a - s, c = Math.abs(a + s);
  return Math.abs(l) >= aX * c ? l : -cX(e, t, n, r, o, i, c);
}
const _v = Math.pow(2, -52), Do = new Uint32Array(512);
class ki {
  static from(t, n = pX, r = mX) {
    const o = t.length, i = new Float64Array(o * 2);
    for (let a = 0; a < o; a++) {
      const s = t[a];
      i[2 * a] = n(s), i[2 * a + 1] = r(s);
    }
    return new ki(i);
  }
  constructor(t) {
    const n = t.length >> 1;
    if (n > 0 && typeof t[0] != "number") throw new Error("Expected coords to contain numbers.");
    this.coords = t;
    const r = Math.max(2 * n - 5, 0);
    this._triangles = new Uint32Array(r * 3), this._halfedges = new Int32Array(r * 3), this._hashSize = Math.ceil(Math.sqrt(n)), this._hullPrev = new Uint32Array(n), this._hullNext = new Uint32Array(n), this._hullTri = new Uint32Array(n), this._hullHash = new Int32Array(this._hashSize), this._ids = new Uint32Array(n), this._dists = new Float64Array(n), this.update();
  }
  update() {
    const { coords: t, _hullPrev: n, _hullNext: r, _hullTri: o, _hullHash: i } = this, a = t.length >> 1;
    let s = 1 / 0, l = 1 / 0, c = -1 / 0, f = -1 / 0;
    for (let I = 0; I < a; I++) {
      const O = t[2 * I], E = t[2 * I + 1];
      O < s && (s = O), E < l && (l = E), O > c && (c = O), E > f && (f = E), this._ids[I] = I;
    }
    const u = (s + c) / 2, h = (l + f) / 2;
    let p, g, m;
    for (let I = 0, O = 1 / 0; I < a; I++) {
      const E = y6(u, h, t[2 * I], t[2 * I + 1]);
      E < O && (p = I, O = E);
    }
    const b = t[2 * p], y = t[2 * p + 1];
    for (let I = 0, O = 1 / 0; I < a; I++) {
      if (I === p) continue;
      const E = y6(b, y, t[2 * I], t[2 * I + 1]);
      E < O && E > 0 && (g = I, O = E);
    }
    let C = t[2 * g], _ = t[2 * g + 1], M = 1 / 0;
    for (let I = 0; I < a; I++) {
      if (I === p || I === g) continue;
      const O = fX(b, y, C, _, t[2 * I], t[2 * I + 1]);
      O < M && (m = I, M = O);
    }
    let S = t[2 * m], k = t[2 * m + 1];
    if (M === 1 / 0) {
      for (let E = 0; E < a; E++)
        this._dists[E] = t[2 * E] - t[0] || t[2 * E + 1] - t[1];
      A3(this._ids, this._dists, 0, a - 1);
      const I = new Uint32Array(a);
      let O = 0;
      for (let E = 0, B = -1 / 0; E < a; E++) {
        const W = this._ids[E], F = this._dists[W];
        F > B && (I[O++] = W, B = F);
      }
      this.hull = I.subarray(0, O), this.triangles = new Uint32Array(0), this.halfedges = new Uint32Array(0);
      return;
    }
    if (No(b, y, C, _, S, k) < 0) {
      const I = g, O = C, E = _;
      g = m, C = S, _ = k, m = I, S = O, k = E;
    }
    const L = hX(b, y, C, _, S, k);
    this._cx = L.x, this._cy = L.y;
    for (let I = 0; I < a; I++)
      this._dists[I] = y6(t[2 * I], t[2 * I + 1], L.x, L.y);
    A3(this._ids, this._dists, 0, a - 1), this._hullStart = p;
    let P = 3;
    r[p] = n[m] = g, r[g] = n[p] = m, r[m] = n[g] = p, o[p] = 0, o[g] = 1, o[m] = 2, i.fill(-1), i[this._hashKey(b, y)] = p, i[this._hashKey(C, _)] = g, i[this._hashKey(S, k)] = m, this.trianglesLen = 0, this._addTriangle(p, g, m, -1, -1, -1);
    for (let I = 0, O, E; I < this._ids.length; I++) {
      const B = this._ids[I], W = t[2 * B], F = t[2 * B + 1];
      if (I > 0 && Math.abs(W - O) <= _v && Math.abs(F - E) <= _v || (O = W, E = F, B === p || B === g || B === m)) continue;
      let z = 0;
      for (let q = 0, K = this._hashKey(W, F); q < this._hashSize && (z = i[(K + q) % this._hashSize], !(z !== -1 && z !== r[z])); q++)
        ;
      z = n[z];
      let D = z, Z;
      for (; Z = r[D], No(W, F, t[2 * D], t[2 * D + 1], t[2 * Z], t[2 * Z + 1]) >= 0; )
        if (D = Z, D === z) {
          D = -1;
          break;
        }
      if (D === -1) continue;
      let U = this._addTriangle(D, B, r[D], -1, -1, o[D]);
      o[B] = this._legalize(U + 2), o[D] = U, P++;
      let $ = r[D];
      for (; Z = r[$], No(W, F, t[2 * $], t[2 * $ + 1], t[2 * Z], t[2 * Z + 1]) < 0; )
        U = this._addTriangle($, B, Z, o[B], -1, o[$]), o[B] = this._legalize(U + 2), r[$] = $, P--, $ = Z;
      if (D === z)
        for (; Z = n[D], No(W, F, t[2 * Z], t[2 * Z + 1], t[2 * D], t[2 * D + 1]) < 0; )
          U = this._addTriangle(Z, B, D, -1, o[D], o[Z]), this._legalize(U + 2), o[Z] = U, r[D] = D, P--, D = Z;
      this._hullStart = n[B] = D, r[D] = n[$] = B, r[B] = $, i[this._hashKey(W, F)] = B, i[this._hashKey(t[2 * D], t[2 * D + 1])] = D;
    }
    this.hull = new Uint32Array(P);
    for (let I = 0, O = this._hullStart; I < P; I++)
      this.hull[I] = O, O = r[O];
    this.triangles = this._triangles.subarray(0, this.trianglesLen), this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
  }
  _hashKey(t, n) {
    return Math.floor(uX(t - this._cx, n - this._cy) * this._hashSize) % this._hashSize;
  }
  _legalize(t) {
    const { _triangles: n, _halfedges: r, coords: o } = this;
    let i = 0, a = 0;
    for (; ; ) {
      const s = r[t], l = t - t % 3;
      if (a = l + (t + 2) % 3, s === -1) {
        if (i === 0) break;
        t = Do[--i];
        continue;
      }
      const c = s - s % 3, f = l + (t + 1) % 3, u = c + (s + 2) % 3, h = n[a], p = n[t], g = n[f], m = n[u];
      if (dX(
        o[2 * h],
        o[2 * h + 1],
        o[2 * p],
        o[2 * p + 1],
        o[2 * g],
        o[2 * g + 1],
        o[2 * m],
        o[2 * m + 1]
      )) {
        n[t] = m, n[s] = h;
        const y = r[u];
        if (y === -1) {
          let _ = this._hullStart;
          do {
            if (this._hullTri[_] === u) {
              this._hullTri[_] = t;
              break;
            }
            _ = this._hullPrev[_];
          } while (_ !== this._hullStart);
        }
        this._link(t, y), this._link(s, r[a]), this._link(a, u);
        const C = c + (s + 1) % 3;
        i < Do.length && (Do[i++] = C);
      } else {
        if (i === 0) break;
        t = Do[--i];
      }
    }
    return a;
  }
  _link(t, n) {
    this._halfedges[t] = n, n !== -1 && (this._halfedges[n] = t);
  }
  // add a new triangle given vertex indices and adjacent half-edge ids
  _addTriangle(t, n, r, o, i, a) {
    const s = this.trianglesLen;
    return this._triangles[s] = t, this._triangles[s + 1] = n, this._triangles[s + 2] = r, this._link(s, o), this._link(s + 1, i), this._link(s + 2, a), this.trianglesLen += 3, s;
  }
}
function uX(e, t) {
  const n = e / (Math.abs(e) + Math.abs(t));
  return (t > 0 ? 3 - n : 1 + n) / 4;
}
function y6(e, t, n, r) {
  const o = e - n, i = t - r;
  return o * o + i * i;
}
function dX(e, t, n, r, o, i, a, s) {
  const l = e - a, c = t - s, f = n - a, u = r - s, h = o - a, p = i - s, g = l * l + c * c, m = f * f + u * u, b = h * h + p * p;
  return l * (u * b - m * p) - c * (f * b - m * h) + g * (f * p - u * h) < 0;
}
function fX(e, t, n, r, o, i) {
  const a = n - e, s = r - t, l = o - e, c = i - t, f = a * a + s * s, u = l * l + c * c, h = 0.5 / (a * c - s * l), p = (c * f - s * u) * h, g = (a * u - l * f) * h;
  return p * p + g * g;
}
function hX(e, t, n, r, o, i) {
  const a = n - e, s = r - t, l = o - e, c = i - t, f = a * a + s * s, u = l * l + c * c, h = 0.5 / (a * c - s * l), p = e + (c * f - s * u) * h, g = t + (a * u - l * f) * h;
  return { x: p, y: g };
}
function A3(e, t, n, r) {
  if (r - n <= 20)
    for (let o = n + 1; o <= r; o++) {
      const i = e[o], a = t[i];
      let s = o - 1;
      for (; s >= n && t[e[s]] > a; ) e[s + 1] = e[s--];
      e[s + 1] = i;
    }
  else {
    const o = n + r >> 1;
    let i = n + 1, a = r;
    $n(e, o, i), t[e[n]] > t[e[r]] && $n(e, n, r), t[e[i]] > t[e[r]] && $n(e, i, r), t[e[n]] > t[e[i]] && $n(e, n, i);
    const s = e[i], l = t[s];
    for (; ; ) {
      do
        i++;
      while (t[e[i]] < l);
      do
        a--;
      while (t[e[a]] > l);
      if (a < i) break;
      $n(e, i, a);
    }
    e[n + 1] = e[a], e[a] = s, r - i + 1 >= a - n ? (A3(e, t, i, r), A3(e, t, n, a - 1)) : (A3(e, t, n, a - 1), A3(e, t, i, r));
  }
}
function $n(e, t, n) {
  const r = e[t];
  e[t] = e[n], e[n] = r;
}
function pX(e) {
  return e[0];
}
function mX(e) {
  return e[1];
}
const xv = 1e-6;
class G0 {
  constructor() {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "";
  }
  moveTo(t, n) {
    this._ += `M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +n}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
  }
  lineTo(t, n) {
    this._ += `L${this._x1 = +t},${this._y1 = +n}`;
  }
  arc(t, n, r) {
    t = +t, n = +n, r = +r;
    const o = t + r, i = n;
    if (r < 0) throw new Error("negative radius");
    this._x1 === null ? this._ += `M${o},${i}` : (Math.abs(this._x1 - o) > xv || Math.abs(this._y1 - i) > xv) && (this._ += "L" + o + "," + i), r && (this._ += `A${r},${r},0,1,1,${t - r},${n}A${r},${r},0,1,1,${this._x1 = o},${this._y1 = i}`);
  }
  rect(t, n, r, o) {
    this._ += `M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +n}h${+r}v${+o}h${-r}Z`;
  }
  value() {
    return this._ || null;
  }
}
class Hu {
  constructor() {
    this._ = [];
  }
  moveTo(t, n) {
    this._.push([t, n]);
  }
  closePath() {
    this._.push(this._[0].slice());
  }
  lineTo(t, n) {
    this._.push([t, n]);
  }
  value() {
    return this._.length ? this._ : null;
  }
}
class gX {
  constructor(t, [n, r, o, i] = [0, 0, 960, 500]) {
    if (!((o = +o) >= (n = +n)) || !((i = +i) >= (r = +r))) throw new Error("invalid bounds");
    this.delaunay = t, this._circumcenters = new Float64Array(t.points.length * 2), this.vectors = new Float64Array(t.points.length * 2), this.xmax = o, this.xmin = n, this.ymax = i, this.ymin = r, this._init();
  }
  update() {
    return this.delaunay.update(), this._init(), this;
  }
  _init() {
    const { delaunay: { points: t, hull: n, triangles: r }, vectors: o } = this;
    let i, a;
    const s = this.circumcenters = this._circumcenters.subarray(0, r.length / 3 * 2);
    for (let m = 0, b = 0, y = r.length, C, _; m < y; m += 3, b += 2) {
      const M = r[m] * 2, S = r[m + 1] * 2, k = r[m + 2] * 2, L = t[M], P = t[M + 1], I = t[S], O = t[S + 1], E = t[k], B = t[k + 1], W = I - L, F = O - P, z = E - L, D = B - P, Z = (W * D - F * z) * 2;
      if (Math.abs(Z) < 1e-9) {
        if (i === void 0) {
          i = a = 0;
          for (const $ of n) i += t[$ * 2], a += t[$ * 2 + 1];
          i /= n.length, a /= n.length;
        }
        const U = 1e9 * Math.sign((i - L) * D - (a - P) * z);
        C = (L + E) / 2 - U * D, _ = (P + B) / 2 + U * z;
      } else {
        const U = 1 / Z, $ = W * W + F * F, q = z * z + D * D;
        C = L + (D * $ - F * q) * U, _ = P + (W * q - z * $) * U;
      }
      s[b] = C, s[b + 1] = _;
    }
    let l = n[n.length - 1], c, f = l * 4, u, h = t[2 * l], p, g = t[2 * l + 1];
    o.fill(0);
    for (let m = 0; m < n.length; ++m)
      l = n[m], c = f, u = h, p = g, f = l * 4, h = t[2 * l], g = t[2 * l + 1], o[c + 2] = o[f] = p - g, o[c + 3] = o[f + 1] = h - u;
  }
  render(t) {
    const n = t == null ? t = new G0() : void 0, { delaunay: { halfedges: r, inedges: o, hull: i }, circumcenters: a, vectors: s } = this;
    if (i.length <= 1) return null;
    for (let f = 0, u = r.length; f < u; ++f) {
      const h = r[f];
      if (h < f) continue;
      const p = Math.floor(f / 3) * 2, g = Math.floor(h / 3) * 2, m = a[p], b = a[p + 1], y = a[g], C = a[g + 1];
      this._renderSegment(m, b, y, C, t);
    }
    let l, c = i[i.length - 1];
    for (let f = 0; f < i.length; ++f) {
      l = c, c = i[f];
      const u = Math.floor(o[c] / 3) * 2, h = a[u], p = a[u + 1], g = l * 4, m = this._project(h, p, s[g + 2], s[g + 3]);
      m && this._renderSegment(h, p, m[0], m[1], t);
    }
    return n && n.value();
  }
  renderBounds(t) {
    const n = t == null ? t = new G0() : void 0;
    return t.rect(this.xmin, this.ymin, this.xmax - this.xmin, this.ymax - this.ymin), n && n.value();
  }
  renderCell(t, n) {
    const r = n == null ? n = new G0() : void 0, o = this._clip(t);
    if (o === null || !o.length) return;
    n.moveTo(o[0], o[1]);
    let i = o.length;
    for (; o[0] === o[i - 2] && o[1] === o[i - 1] && i > 1; ) i -= 2;
    for (let a = 2; a < i; a += 2)
      (o[a] !== o[a - 2] || o[a + 1] !== o[a - 1]) && n.lineTo(o[a], o[a + 1]);
    return n.closePath(), r && r.value();
  }
  *cellPolygons() {
    const { delaunay: { points: t } } = this;
    for (let n = 0, r = t.length / 2; n < r; ++n) {
      const o = this.cellPolygon(n);
      o && (o.index = n, yield o);
    }
  }
  cellPolygon(t) {
    const n = new Hu();
    return this.renderCell(t, n), n.value();
  }
  _renderSegment(t, n, r, o, i) {
    let a;
    const s = this._regioncode(t, n), l = this._regioncode(r, o);
    s === 0 && l === 0 ? (i.moveTo(t, n), i.lineTo(r, o)) : (a = this._clipSegment(t, n, r, o, s, l)) && (i.moveTo(a[0], a[1]), i.lineTo(a[2], a[3]));
  }
  contains(t, n, r) {
    return n = +n, n !== n || (r = +r, r !== r) ? !1 : this.delaunay._step(t, n, r) === t;
  }
  *neighbors(t) {
    const n = this._clip(t);
    if (n) for (const r of this.delaunay.neighbors(t)) {
      const o = this._clip(r);
      if (o) {
        e: for (let i = 0, a = n.length; i < a; i += 2)
          for (let s = 0, l = o.length; s < l; s += 2)
            if (n[i] === o[s] && n[i + 1] === o[s + 1] && n[(i + 2) % a] === o[(s + l - 2) % l] && n[(i + 3) % a] === o[(s + l - 1) % l]) {
              yield r;
              break e;
            }
      }
    }
  }
  _cell(t) {
    const { circumcenters: n, delaunay: { inedges: r, halfedges: o, triangles: i } } = this, a = r[t];
    if (a === -1) return null;
    const s = [];
    let l = a;
    do {
      const c = Math.floor(l / 3);
      if (s.push(n[c * 2], n[c * 2 + 1]), l = l % 3 === 2 ? l - 2 : l + 1, i[l] !== t) break;
      l = o[l];
    } while (l !== a && l !== -1);
    return s;
  }
  _clip(t) {
    if (t === 0 && this.delaunay.hull.length === 1)
      return [this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax, this.xmin, this.ymin];
    const n = this._cell(t);
    if (n === null) return null;
    const { vectors: r } = this, o = t * 4;
    return this._simplify(r[o] || r[o + 1] ? this._clipInfinite(t, n, r[o], r[o + 1], r[o + 2], r[o + 3]) : this._clipFinite(t, n));
  }
  _clipFinite(t, n) {
    const r = n.length;
    let o = null, i, a, s = n[r - 2], l = n[r - 1], c, f = this._regioncode(s, l), u, h = 0;
    for (let p = 0; p < r; p += 2)
      if (i = s, a = l, s = n[p], l = n[p + 1], c = f, f = this._regioncode(s, l), c === 0 && f === 0)
        u = h, h = 0, o ? o.push(s, l) : o = [s, l];
      else {
        let g, m, b, y, C;
        if (c === 0) {
          if ((g = this._clipSegment(i, a, s, l, c, f)) === null) continue;
          [m, b, y, C] = g;
        } else {
          if ((g = this._clipSegment(s, l, i, a, f, c)) === null) continue;
          [y, C, m, b] = g, u = h, h = this._edgecode(m, b), u && h && this._edge(t, u, h, o, o.length), o ? o.push(m, b) : o = [m, b];
        }
        u = h, h = this._edgecode(y, C), u && h && this._edge(t, u, h, o, o.length), o ? o.push(y, C) : o = [y, C];
      }
    if (o)
      u = h, h = this._edgecode(o[0], o[1]), u && h && this._edge(t, u, h, o, o.length);
    else if (this.contains(t, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2))
      return [this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax, this.xmin, this.ymin];
    return o;
  }
  _clipSegment(t, n, r, o, i, a) {
    const s = i < a;
    for (s && ([t, n, r, o, i, a] = [r, o, t, n, a, i]); ; ) {
      if (i === 0 && a === 0) return s ? [r, o, t, n] : [t, n, r, o];
      if (i & a) return null;
      let l, c, f = i || a;
      f & 8 ? (l = t + (r - t) * (this.ymax - n) / (o - n), c = this.ymax) : f & 4 ? (l = t + (r - t) * (this.ymin - n) / (o - n), c = this.ymin) : f & 2 ? (c = n + (o - n) * (this.xmax - t) / (r - t), l = this.xmax) : (c = n + (o - n) * (this.xmin - t) / (r - t), l = this.xmin), i ? (t = l, n = c, i = this._regioncode(t, n)) : (r = l, o = c, a = this._regioncode(r, o));
    }
  }
  _clipInfinite(t, n, r, o, i, a) {
    let s = Array.from(n), l;
    if ((l = this._project(s[0], s[1], r, o)) && s.unshift(l[0], l[1]), (l = this._project(s[s.length - 2], s[s.length - 1], i, a)) && s.push(l[0], l[1]), s = this._clipFinite(t, s))
      for (let c = 0, f = s.length, u, h = this._edgecode(s[f - 2], s[f - 1]); c < f; c += 2)
        u = h, h = this._edgecode(s[c], s[c + 1]), u && h && (c = this._edge(t, u, h, s, c), f = s.length);
    else this.contains(t, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2) && (s = [this.xmin, this.ymin, this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax]);
    return s;
  }
  _edge(t, n, r, o, i) {
    for (; n !== r; ) {
      let a, s;
      switch (n) {
        case 5:
          n = 4;
          continue;
        // top-left
        case 4:
          n = 6, a = this.xmax, s = this.ymin;
          break;
        // top
        case 6:
          n = 2;
          continue;
        // top-right
        case 2:
          n = 10, a = this.xmax, s = this.ymax;
          break;
        // right
        case 10:
          n = 8;
          continue;
        // bottom-right
        case 8:
          n = 9, a = this.xmin, s = this.ymax;
          break;
        // bottom
        case 9:
          n = 1;
          continue;
        // bottom-left
        case 1:
          n = 5, a = this.xmin, s = this.ymin;
          break;
      }
      (o[i] !== a || o[i + 1] !== s) && this.contains(t, a, s) && (o.splice(i, 0, a, s), i += 2);
    }
    return i;
  }
  _project(t, n, r, o) {
    let i = 1 / 0, a, s, l;
    if (o < 0) {
      if (n <= this.ymin) return null;
      (a = (this.ymin - n) / o) < i && (l = this.ymin, s = t + (i = a) * r);
    } else if (o > 0) {
      if (n >= this.ymax) return null;
      (a = (this.ymax - n) / o) < i && (l = this.ymax, s = t + (i = a) * r);
    }
    if (r > 0) {
      if (t >= this.xmax) return null;
      (a = (this.xmax - t) / r) < i && (s = this.xmax, l = n + (i = a) * o);
    } else if (r < 0) {
      if (t <= this.xmin) return null;
      (a = (this.xmin - t) / r) < i && (s = this.xmin, l = n + (i = a) * o);
    }
    return [s, l];
  }
  _edgecode(t, n) {
    return (t === this.xmin ? 1 : t === this.xmax ? 2 : 0) | (n === this.ymin ? 4 : n === this.ymax ? 8 : 0);
  }
  _regioncode(t, n) {
    return (t < this.xmin ? 1 : t > this.xmax ? 2 : 0) | (n < this.ymin ? 4 : n > this.ymax ? 8 : 0);
  }
  _simplify(t) {
    if (t && t.length > 4) {
      for (let n = 0; n < t.length; n += 2) {
        const r = (n + 2) % t.length, o = (n + 4) % t.length;
        (t[n] === t[r] && t[r] === t[o] || t[n + 1] === t[r + 1] && t[r + 1] === t[o + 1]) && (t.splice(r, 2), n -= 2);
      }
      t.length || (t = null);
    }
    return t;
  }
}
const vX = 2 * Math.PI, L3 = Math.pow;
function bX(e) {
  return e[0];
}
function yX(e) {
  return e[1];
}
function CX(e) {
  const { triangles: t, coords: n } = e;
  for (let r = 0; r < t.length; r += 3) {
    const o = 2 * t[r], i = 2 * t[r + 1], a = 2 * t[r + 2];
    if ((n[a] - n[o]) * (n[i + 1] - n[o + 1]) - (n[i] - n[o]) * (n[a + 1] - n[o + 1]) > 1e-10) return !1;
  }
  return !0;
}
function wX(e, t, n) {
  return [e + Math.sin(e + t) * n, t + Math.cos(e - t) * n];
}
class _7 {
  static from(t, n = bX, r = yX, o) {
    return new _7("length" in t ? _X(t, n, r, o) : Float64Array.from(xX(t, n, r, o)));
  }
  constructor(t) {
    this._delaunator = new ki(t), this.inedges = new Int32Array(t.length / 2), this._hullIndex = new Int32Array(t.length / 2), this.points = this._delaunator.coords, this._init();
  }
  update() {
    return this._delaunator.update(), this._init(), this;
  }
  _init() {
    const t = this._delaunator, n = this.points;
    if (t.hull && t.hull.length > 2 && CX(t)) {
      this.collinear = Int32Array.from({ length: n.length / 2 }, (h, p) => p).sort((h, p) => n[2 * h] - n[2 * p] || n[2 * h + 1] - n[2 * p + 1]);
      const l = this.collinear[0], c = this.collinear[this.collinear.length - 1], f = [n[2 * l], n[2 * l + 1], n[2 * c], n[2 * c + 1]], u = 1e-8 * Math.hypot(f[3] - f[1], f[2] - f[0]);
      for (let h = 0, p = n.length / 2; h < p; ++h) {
        const g = wX(n[2 * h], n[2 * h + 1], u);
        n[2 * h] = g[0], n[2 * h + 1] = g[1];
      }
      this._delaunator = new ki(n);
    } else
      delete this.collinear;
    const r = this.halfedges = this._delaunator.halfedges, o = this.hull = this._delaunator.hull, i = this.triangles = this._delaunator.triangles, a = this.inedges.fill(-1), s = this._hullIndex.fill(-1);
    for (let l = 0, c = r.length; l < c; ++l) {
      const f = i[l % 3 === 2 ? l - 2 : l + 1];
      (r[l] === -1 || a[f] === -1) && (a[f] = l);
    }
    for (let l = 0, c = o.length; l < c; ++l)
      s[o[l]] = l;
    o.length <= 2 && o.length > 0 && (this.triangles = new Int32Array(3).fill(-1), this.halfedges = new Int32Array(3).fill(-1), this.triangles[0] = o[0], a[o[0]] = 1, o.length === 2 && (a[o[1]] = 0, this.triangles[1] = o[1], this.triangles[2] = o[1]));
  }
  voronoi(t) {
    return new gX(this, t);
  }
  *neighbors(t) {
    const { inedges: n, hull: r, _hullIndex: o, halfedges: i, triangles: a, collinear: s } = this;
    if (s) {
      const u = s.indexOf(t);
      u > 0 && (yield s[u - 1]), u < s.length - 1 && (yield s[u + 1]);
      return;
    }
    const l = n[t];
    if (l === -1) return;
    let c = l, f = -1;
    do {
      if (yield f = a[c], c = c % 3 === 2 ? c - 2 : c + 1, a[c] !== t) return;
      if (c = i[c], c === -1) {
        const u = r[(o[t] + 1) % r.length];
        u !== f && (yield u);
        return;
      }
    } while (c !== l);
  }
  find(t, n, r = 0) {
    if (t = +t, t !== t || (n = +n, n !== n)) return -1;
    const o = r;
    let i;
    for (; (i = this._step(r, t, n)) >= 0 && i !== r && i !== o; ) r = i;
    return i;
  }
  _step(t, n, r) {
    const { inedges: o, hull: i, _hullIndex: a, halfedges: s, triangles: l, points: c } = this;
    if (o[t] === -1 || !c.length) return (t + 1) % (c.length >> 1);
    let f = t, u = L3(n - c[t * 2], 2) + L3(r - c[t * 2 + 1], 2);
    const h = o[t];
    let p = h;
    do {
      let g = l[p];
      const m = L3(n - c[g * 2], 2) + L3(r - c[g * 2 + 1], 2);
      if (m < u && (u = m, f = g), p = p % 3 === 2 ? p - 2 : p + 1, l[p] !== t) break;
      if (p = s[p], p === -1) {
        if (p = i[(a[t] + 1) % i.length], p !== g && L3(n - c[p * 2], 2) + L3(r - c[p * 2 + 1], 2) < u)
          return p;
        break;
      }
    } while (p !== h);
    return f;
  }
  render(t) {
    const n = t == null ? t = new G0() : void 0, { points: r, halfedges: o, triangles: i } = this;
    for (let a = 0, s = o.length; a < s; ++a) {
      const l = o[a];
      if (l < a) continue;
      const c = i[a] * 2, f = i[l] * 2;
      t.moveTo(r[c], r[c + 1]), t.lineTo(r[f], r[f + 1]);
    }
    return this.renderHull(t), n && n.value();
  }
  renderPoints(t, n) {
    n === void 0 && (!t || typeof t.moveTo != "function") && (n = t, t = null), n = n == null ? 2 : +n;
    const r = t == null ? t = new G0() : void 0, { points: o } = this;
    for (let i = 0, a = o.length; i < a; i += 2) {
      const s = o[i], l = o[i + 1];
      t.moveTo(s + n, l), t.arc(s, l, n, 0, vX);
    }
    return r && r.value();
  }
  renderHull(t) {
    const n = t == null ? t = new G0() : void 0, { hull: r, points: o } = this, i = r[0] * 2, a = r.length;
    t.moveTo(o[i], o[i + 1]);
    for (let s = 1; s < a; ++s) {
      const l = 2 * r[s];
      t.lineTo(o[l], o[l + 1]);
    }
    return t.closePath(), n && n.value();
  }
  hullPolygon() {
    const t = new Hu();
    return this.renderHull(t), t.value();
  }
  renderTriangle(t, n) {
    const r = n == null ? n = new G0() : void 0, { points: o, triangles: i } = this, a = i[t *= 3] * 2, s = i[t + 1] * 2, l = i[t + 2] * 2;
    return n.moveTo(o[a], o[a + 1]), n.lineTo(o[s], o[s + 1]), n.lineTo(o[l], o[l + 1]), n.closePath(), r && r.value();
  }
  *trianglePolygons() {
    const { triangles: t } = this;
    for (let n = 0, r = t.length / 3; n < r; ++n)
      yield this.trianglePolygon(n);
  }
  trianglePolygon(t) {
    const n = new Hu();
    return this.renderTriangle(t, n), n.value();
  }
}
function _X(e, t, n, r) {
  const o = e.length, i = new Float64Array(o * 2);
  for (let a = 0; a < o; ++a) {
    const s = e[a];
    i[a * 2] = t.call(r, s, a, e), i[a * 2 + 1] = n.call(r, s, a, e);
  }
  return i;
}
function* xX(e, t, n, r) {
  let o = 0;
  for (const i of e)
    yield t.call(r, i, o, e), yield n.call(r, i, o, e), ++o;
}
var x7 = function(e) {
  return [e.x, e.y];
}, co = PM, Pk = "cursor", Ak = "top", SX = function(e) {
  var t = e.points, n = e.getNodePosition, r = n === void 0 ? x7 : n, o = e.margin, i = o === void 0 ? co : o;
  return t.map(function(a) {
    var s = r(a), l = s[0], c = s[1];
    return [l + i.left, c + i.top];
  });
}, MX = function(e) {
  var t = e.points, n = e.width, r = e.height, o = e.margin, i = o === void 0 ? co : o, a = e.debug, s = _7.from(t), l = a ? s.voronoi([0, 0, i.left + n + i.right, i.top + r + i.bottom]) : void 0;
  return { points: t, delaunay: s, voronoi: l };
}, Ik = function(e) {
  var t = e.points, n = e.getNodePosition, r = n === void 0 ? x7 : n, o = e.width, i = e.height, a = e.margin, s = a === void 0 ? co : a, l = e.debug;
  return j1(function() {
    return MX({ points: SX({ points: t, margin: s, getNodePosition: r }), width: o, height: i, margin: s, debug: l });
  }, [t, o, i, s, l]);
}, kX = function(e) {
  var t = e.elementRef, n = e.nodes, r = e.getNodePosition, o = r === void 0 ? x7 : r, i = e.delaunay, a = e.setCurrent, s = e.margin, l = s === void 0 ? co : s, c = e.detectionRadius, f = c === void 0 ? 1 / 0 : c, u = e.isInteractive, h = u === void 0 || u, p = e.onMouseEnter, g = e.onMouseMove, m = e.onMouseLeave, b = e.onClick, y = e.onTouchStart, C = e.onTouchMove, _ = e.onTouchEnd, M = e.enableTouchCrosshair, S = M !== void 0 && M, k = e.tooltip, L = e.tooltipPosition, P = L === void 0 ? Pk : L, I = e.tooltipAnchor, O = I === void 0 ? Ak : I, E = d2(null), B = E[0], W = E[1], F = Be(null);
  Te(function() {
    F.current = B;
  }, [F, B]);
  var z = R1(function(Q) {
    if (!t.current) return null;
    var N = nr(t.current, Q), j = N[0], t1 = N[1], T = i.find(j, t1), u1 = T !== void 0 ? n[T] : null;
    if (u1 && f !== 1 / 0) {
      var l1 = o(u1), d1 = l1[0], C1 = l1[1];
      gY(j, t1, d1 + l.left, C1 + l.top) > f && (T = null, u1 = null);
    }
    return T === null || u1 === null ? null : [T, u1];
  }, [t, i, n, o, l, f]), D = d3(), Z = D.showTooltipAt, U = D.showTooltipFromEvent, $ = D.hideTooltip, q = j1(function() {
    if (k) return P === "cursor" ? function(Q, N) {
      U(k(Q), N, O);
    } : function(Q) {
      var N = o(Q), j = N[0], t1 = N[1];
      Z(k(Q), [j + l.left, t1 + l.top], O);
    };
  }, [Z, U, k, P, O, o, l]), K = R1(function(Q) {
    var N = z(Q);
    if (W(N), a?.(N ? N[1] : null), N) {
      var j = N[1];
      q?.(j, Q), p?.(N[1], Q);
    }
  }, [z, W, a, q, p]), V = R1(function(Q) {
    var N = z(Q);
    if (W(N), N) {
      var j = N[0], t1 = N[1];
      if (a?.(t1), q?.(t1, Q), F.current) {
        var T = F.current, u1 = T[0], l1 = T[1];
        j !== u1 ? m?.(l1, Q) : g?.(t1, Q);
      } else p?.(t1, Q);
    } else a?.(null), $?.(), F.current && m?.(F.current[1], Q);
  }, [z, W, F, p, g, m, q, $]), n1 = R1(function(Q) {
    W(null), a?.(null), $(), m && F.current && m(F.current[1], Q);
  }, [W, a, F, $, m]), o1 = R1(function(Q) {
    var N = z(Q);
    W(N), N && b?.(N[1], Q);
  }, [z, W, b]), r1 = R1(function(Q) {
    var N = z(Q);
    S && (W(N), a?.(N ? N[1] : null)), N && y?.(N[1], Q);
  }, [z, W, a, S, y]), X = R1(function(Q) {
    var N = z(Q);
    S && (W(N), a?.(N ? N[1] : null)), N && C?.(N[1], Q);
  }, [z, W, a, S, C]), Y = R1(function(Q) {
    S && (W(null), a?.(null)), _ && F.current && _(F.current[1], Q);
  }, [S, W, a, _, F]);
  return { current: B, handleMouseEnter: h ? K : void 0, handleMouseMove: h ? V : void 0, handleMouseLeave: h ? n1 : void 0, handleClick: h ? o1 : void 0, handleTouchStart: h ? r1 : void 0, handleTouchMove: h ? X : void 0, handleTouchEnd: h ? Y : void 0 };
}, LX = function(e) {
  var t = e.nodes, n = e.width, r = e.height, o = e.margin, i = o === void 0 ? co : o, a = e.getNodePosition, s = e.setCurrent, l = e.onMouseEnter, c = e.onMouseMove, f = e.onMouseLeave, u = e.onClick, h = e.onTouchStart, p = e.onTouchMove, g = e.onTouchEnd, m = e.enableTouchCrosshair, b = m !== void 0 && m, y = e.detectionRadius, C = y === void 0 ? 1 / 0 : y, _ = e.tooltip, M = e.tooltipPosition, S = M === void 0 ? Pk : M, k = e.tooltipAnchor, L = k === void 0 ? Ak : k, P = e.debug, I = Be(null), O = Ik({ points: t, getNodePosition: a, width: n, height: r, margin: i, debug: P }), E = O.delaunay, B = O.voronoi, W = kX({ elementRef: I, nodes: t, delaunay: E, margin: i, detectionRadius: C, setCurrent: s, onMouseEnter: l, onMouseMove: c, onMouseLeave: f, onClick: u, onTouchStart: h, onTouchMove: p, onTouchEnd: g, enableTouchCrosshair: b, tooltip: _, tooltipPosition: S, tooltipAnchor: L }), F = W.current, z = W.handleMouseEnter, D = W.handleMouseMove, Z = W.handleMouseLeave, U = W.handleClick, $ = W.handleTouchStart, q = W.handleTouchMove, K = W.handleTouchEnd, V = j1(function() {
    if (P && B) return B.render();
  }, [P, B]);
  return s1("g", { ref: I, transform: "translate(" + -i.left + "," + -i.top + ")", children: [P && B && s1(ze, { children: [v("path", { d: V, stroke: "red", strokeWidth: 1, opacity: 0.75 }), C < 1 / 0 && v("path", { stroke: "red", strokeWidth: 0.35, fill: "none", d: E.renderPoints(void 0, C) }), F && v("path", { fill: "pink", opacity: 0.35, d: B.renderCell(F[0]) })] }), v("rect", { "data-ref": "mesh-interceptor", width: i.left + n + i.right, height: i.top + r + i.bottom, fill: "red", opacity: 0, style: { cursor: "auto" }, onMouseEnter: z, onMouseMove: D, onMouseLeave: Z, onTouchStart: $, onTouchMove: q, onTouchEnd: K, onClick: U })] });
}, EX = function(e, t) {
  e.save(), e.globalAlpha = 0.75, e.beginPath(), t.render(e), e.strokeStyle = "red", e.lineWidth = 1, e.stroke(), e.restore();
}, TX = function(e, t, n) {
  e.save(), e.globalAlpha = 0.35, e.beginPath(), t.renderCell(n, e), e.fillStyle = "pink", e.fill(), e.restore();
};
function A2() {
  return A2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, A2.apply(this, arguments);
}
var S7 = Ne(function(e) {
  var t = e.point;
  return v(yd, { id: s1("span", { children: ["x: ", v("strong", { children: t.data.xFormatted }), ", y:", " ", v("strong", { children: t.data.yFormatted })] }), enableChip: !0, color: t.serieColor });
}), Ok = Ne(function(e) {
  var t = e.slice, n = e.axis, r = Ue(), o = n === "x" ? "y" : "x";
  return v(Bx, { rows: t.points.map(function(i) {
    return [v(Dx, { color: i.serieColor, style: r.tooltip.chip }, "chip"), i.serieId, v("span", { style: r.tooltip.tableCellValue, children: i.data[o + "Formatted"] }, "value")];
  }) });
}), Nk = { curve: "linear", xScale: { type: "point" }, yScale: { type: "linear", min: 0, max: "auto" }, layers: ["grid", "markers", "axes", "areas", "crosshair", "lines", "points", "slices", "mesh", "legends"], axisBottom: {}, axisLeft: {}, enableGridX: !0, enableGridY: !0, enablePoints: !0, pointSize: 6, pointColor: { from: "color" }, pointBorderWidth: 0, pointBorderColor: { theme: "background" }, enablePointLabel: !1, pointLabel: "yFormatted", colors: { scheme: "nivo" }, enableArea: !1, areaBaselineValue: 0, areaOpacity: 0.2, areaBlendMode: "normal", lineWidth: 2, legends: [], isInteractive: !0, tooltip: S7, enableSlices: !1, debugSlices: !1, sliceTooltip: Ok, debugMesh: !1, enableCrosshair: !0, crosshairType: "bottom-left" }, Ut = A2({}, Nk, { enablePointLabel: !1, useMesh: !1, enableTouchCrosshair: !1, animate: !0, motionConfig: "gentle", defs: [], fill: [], role: "img", initialHiddenIds: [] });
A2({}, Nk, { pixelRatio: typeof window < "u" && window.devicePixelRatio || 1 });
var RX = function(e) {
  var t = e.curve;
  return j1(function() {
    return $S().defined(function(n) {
      return n.x !== null && n.y !== null;
    }).x(function(n) {
      return n.x;
    }).y(function(n) {
      return n.y;
    }).curve(RM(t));
  }, [t]);
}, PX = function(e) {
  var t = e.curve, n = e.yScale, r = e.areaBaselineValue;
  return j1(function() {
    return zz().defined(function(o) {
      return o.x !== null && o.y !== null;
    }).x(function(o) {
      return o.x;
    }).y1(function(o) {
      return o.y;
    }).curve(RM(t)).y0(n(r));
  }, [t, n, r]);
}, AX = function(e) {
  var t = e.componentId, n = e.enableSlices, r = e.points, o = e.width, i = e.height;
  return j1(function() {
    if (n === !1) return [];
    if (n === "x") {
      var a = /* @__PURE__ */ new Map();
      return r.forEach(function(l) {
        l.data.x !== null && l.data.y !== null && (a.has(l.x) ? a.get(l.x).push(l) : a.set(l.x, [l]));
      }), Array.from(a.entries()).sort(function(l, c) {
        return l[0] - c[0];
      }).map(function(l, c, f) {
        var u, h, p = l[0], g = l[1], m = f[c - 1], b = f[c + 1];
        return u = m ? p - (p - m[0]) / 2 : p, h = b ? p - u + (b[0] - p) / 2 : o - u, { id: "slice:" + t + ":" + p, x0: u, x: p, y0: 0, y: 0, width: h, height: i, points: g.reverse() };
      });
    }
    if (n === "y") {
      var s = /* @__PURE__ */ new Map();
      return r.forEach(function(l) {
        l.data.x !== null && l.data.y !== null && (s.has(l.y) ? s.get(l.y).push(l) : s.set(l.y, [l]));
      }), Array.from(s.entries()).sort(function(l, c) {
        return l[0] - c[0];
      }).map(function(l, c, f) {
        var u, h, p = l[0], g = l[1], m = f[c - 1], b = f[c + 1];
        return u = m ? p - (p - m[0]) / 2 : p, h = b ? p - u + (b[0] - p) / 2 : i - u, { id: p, x0: 0, x: 0, y0: u, y: p, width: o, height: h, points: g.reverse() };
      });
    }
  }, [t, n, i, r, o]);
}, IX = "line", Dk = function(e) {
  var t = e.data, n = e.xScale, r = n === void 0 ? Ut.xScale : n, o = e.xFormat, i = e.yScale, a = i === void 0 ? Ut.yScale : i, s = e.yFormat, l = e.width, c = e.height, f = e.colors, u = f === void 0 ? Ut.colors : f, h = e.curve, p = h === void 0 ? Ut.curve : h, g = e.areaBaselineValue, m = g === void 0 ? Ut.areaBaselineValue : g, b = e.pointColor, y = b === void 0 ? Ut.pointColor : b, C = e.pointBorderColor, _ = C === void 0 ? Ut.pointBorderColor : C, M = e.enableSlices, S = M === void 0 ? Ut.enableSlicesTooltip : M, k = e.initialHiddenIds, L = k === void 0 ? Ut.initialHiddenIds : k, P = d2(rX(IX))[0], I = Lr(o), O = Lr(s), E = bk(u, "id"), B = Ue(), W = K3(y, B), F = K3(_, B), z = d2(L ?? []), D = z[0], Z = z[1], U = j1(function() {
    return aZ(t.filter(function(Q) {
      return D.indexOf(Q.id) === -1;
    }), r, a, l, c);
  }, [t, D, r, a, l, c]), $ = U.xScale, q = U.yScale, K = U.series, V = j1(function() {
    var Q = t.map(function(j) {
      return { id: j.id, label: j.id, color: E(j) };
    }), N = Q.map(function(j) {
      return A2({}, K.find(function(t1) {
        return t1.id === j.id;
      }), { color: j.color });
    }).filter(function(j) {
      return !!j.id;
    });
    return { legendData: Q.map(function(j) {
      return A2({}, j, { hidden: !N.find(function(t1) {
        return t1.id === j.id;
      }) });
    }).reverse(), series: N };
  }, [t, K, E]), n1 = V.legendData, o1 = V.series, r1 = R1(function(Q) {
    Z(function(N) {
      return N.indexOf(Q) > -1 ? N.filter(function(j) {
        return j !== Q;
      }) : [].concat(N, [Q]);
    });
  }, []), X = function(Q) {
    var N = Q.series, j = Q.getPointColor, t1 = Q.getPointBorderColor, T = Q.formatX, u1 = Q.formatY;
    return j1(function() {
      return N.reduce(function(l1, d1) {
        return [].concat(l1, d1.data.filter(function(C1) {
          return C1.position.x !== null && C1.position.y !== null;
        }).map(function(C1, g1) {
          var D1 = { id: d1.id + "." + g1, index: l1.length + g1, serieId: d1.id, serieColor: d1.color, x: C1.position.x, y: C1.position.y };
          return D1.color = j(d1), D1.borderColor = t1(D1), D1.data = A2({}, C1.data, { xFormatted: T(C1.data.x), yFormatted: u1(C1.data.y) }), D1;
        }));
      }, []);
    }, [N, j, t1, T, u1]);
  }({ series: o1, getPointColor: W, getPointBorderColor: F, formatX: I, formatY: O }), Y = AX({ componentId: P, enableSlices: S, points: X, width: l, height: c });
  return { legendData: n1, toggleSerie: r1, lineGenerator: RX({ curve: p }), areaGenerator: PX({ curve: p, yScale: q, areaBaselineValue: m }), getColor: E, series: o1, xScale: $, yScale: q, slices: Y, points: X };
}, OX = function(e) {
  var t = e.areaBlendMode, n = e.areaOpacity, r = e.color, o = e.fill, i = e.path, a = rt(), s = a.animate, l = a.config, c = m7(i), f = Ft({ color: r, config: l, immediate: !s });
  return v(Ye.path, { d: c, fill: o || f.color, fillOpacity: n, strokeWidth: 0, style: { mixBlendMode: t } });
}, NX = Ne(function(e) {
  var t = e.areaGenerator, n = e.areaOpacity, r = e.areaBlendMode, o = e.lines.slice(0).reverse();
  return v("g", { children: o.map(function(i) {
    return v(OX, A2({ path: t(i.data.map(function(a) {
      return a.position;
    })) }, A2({ areaOpacity: n, areaBlendMode: r }, i)), i.id);
  }) });
}), DX = Ne(function(e) {
  var t = e.lineGenerator, n = e.points, r = e.color, o = e.thickness, i = j1(function() {
    return t(n);
  }, [t, n]), a = m7(i);
  return v(Ye.path, { d: a, fill: "none", strokeWidth: o, stroke: r });
}), BX = Ne(function(e) {
  var t = e.lines, n = e.lineGenerator, r = e.lineWidth;
  return t.slice(0).reverse().map(function(o) {
    var i = o.id, a = o.data, s = o.color;
    return v(DX, { id: i, points: a.map(function(l) {
      return l.position;
    }), lineGenerator: n, color: s, thickness: r }, i);
  });
}), FX = Ne(function(e) {
  var t = e.slice, n = e.slices, r = e.axis, o = e.debug, i = e.tooltip, a = e.isCurrent, s = e.setCurrent, l = e.onMouseEnter, c = e.onMouseMove, f = e.onMouseLeave, u = e.onClick, h = e.onTouchStart, p = e.onTouchMove, g = e.onTouchEnd, m = d3(), b = m.showTooltipFromEvent, y = m.hideTooltip, C = R1(function(I) {
    b(s2(i, { slice: t, axis: r }), I, "right"), s(t), l && l(t, I);
  }, [b, i, t, r, s, l]), _ = R1(function(I) {
    b(s2(i, { slice: t, axis: r }), I, "right"), c && c(t, I);
  }, [b, i, t, r, c]), M = R1(function(I) {
    y(), s(null), f && f(t, I);
  }, [y, s, f, t]), S = R1(function(I) {
    u && u(t, I);
  }, [t, u]), k = R1(function(I) {
    b(s2(i, { slice: t, axis: r }), I, "right"), s(t), h && h(t, I);
  }, [r, h, s, b, t, i]), L = R1(function(I) {
    var O = I.touches[0], E = document.elementFromPoint(O.clientX, O.clientY), B = E?.getAttribute("data-ref");
    if (B) {
      var W = n.find(function(F) {
        return F.id === B;
      });
      W && (b(s2(i, { slice: W, axis: r }), I, "right"), s(W));
    }
    p && p(t, I);
  }, [r, p, s, b, t, n, i]), P = R1(function(I) {
    y(), s(null), g && g(t, I);
  }, [y, s, g, t]);
  return v("rect", { x: t.x0, y: t.y0, width: t.width, height: t.height, stroke: "red", strokeWidth: o ? 1 : 0, strokeOpacity: 0.75, fill: "red", fillOpacity: a && o ? 0.35 : 0, onMouseEnter: C, onMouseMove: _, onMouseLeave: M, onClick: S, onTouchStart: k, onTouchMove: L, onTouchEnd: P, "data-ref": t.id });
}), $X = Ne(function(e) {
  var t = e.slices, n = e.axis, r = e.debug, o = e.height, i = e.tooltip, a = e.current, s = e.setCurrent, l = e.onMouseEnter, c = e.onMouseMove, f = e.onMouseLeave, u = e.onClick, h = e.onTouchStart, p = e.onTouchMove, g = e.onTouchEnd;
  return t.map(function(m) {
    return v(FX, { slice: m, slices: t, axis: n, debug: r, height: o, tooltip: i, setCurrent: s, isCurrent: a !== null && a.id === m.id, onMouseEnter: l, onMouseMove: c, onMouseLeave: f, onClick: u, onTouchStart: h, onTouchMove: p, onTouchEnd: g }, m.id);
  });
}), WX = Ne(function(e) {
  var t = e.points, n = e.symbol, r = e.size, o = e.borderWidth, i = e.enableLabel, a = e.label, s = e.labelYOffset, l = Ue(), c = mY(a), f = t.slice(0).reverse().map(function(u) {
    return { id: u.id, x: u.x, y: u.y, datum: u.data, fill: u.color, stroke: u.borderColor, label: i ? c(u) : null };
  });
  return v("g", { children: f.map(function(u) {
    return v(fY, { x: u.x, y: u.y, datum: u.datum, symbol: n, size: r, color: u.fill, borderWidth: o, borderColor: u.stroke, label: u.label, labelYOffset: s, theme: l }, u.id);
  }) });
}), VX = Ne(function(e) {
  var t = e.points, n = e.width, r = e.height, o = e.margin, i = e.setCurrent, a = e.onMouseEnter, s = e.onMouseMove, l = e.onMouseLeave, c = e.onClick, f = e.onTouchStart, u = e.onTouchMove, h = e.onTouchEnd, p = e.tooltip, g = e.debug, m = e.enableTouchCrosshair, b = d3(), y = b.showTooltipAt, C = b.hideTooltip, _ = R1(function(O, E) {
    y(s2(p, { point: O }), [O.x + o.left, O.y + o.top], "top"), a && a(O, E);
  }, [y, p, a, o]), M = R1(function(O, E) {
    y(s2(p, { point: O }), [O.x + o.left, O.y + o.top], "top"), s && s(O, E);
  }, [y, p, o.left, o.top, s]), S = R1(function(O, E) {
    C(), l && l(O, E);
  }, [C, l]), k = R1(function(O, E) {
    c && c(O, E);
  }, [c]), L = R1(function(O, E) {
    y(s2(p, { point: O }), [O.x + o.left, O.y + o.top], "top"), f && f(O, E);
  }, [o.left, o.top, f, y, p]), P = R1(function(O, E) {
    y(s2(p, { point: O }), [O.x + o.left, O.y + o.top], "top"), u && u(O, E);
  }, [o.left, o.top, u, y, p]), I = R1(function(O, E) {
    C(), h && h(O, E);
  }, [h, C]);
  return v(LX, { nodes: t, width: n, height: r, setCurrent: i, onMouseEnter: _, onMouseMove: M, onMouseLeave: S, onClick: k, onTouchStart: L, onTouchMove: P, onTouchEnd: I, enableTouchCrosshair: m, debug: g });
}), HX = zM(function(e) {
  var t = e.data, n = e.xScale, r = n === void 0 ? { type: "point" } : n, o = e.xFormat, i = e.yScale, a = i === void 0 ? { type: "linear", min: 0, max: "auto" } : i, s = e.yFormat, l = e.layers, c = l === void 0 ? ["grid", "markers", "axes", "areas", "crosshair", "lines", "points", "slices", "mesh", "legends"] : l, f = e.curve, u = f === void 0 ? "linear" : f, h = e.areaBaselineValue, p = h === void 0 ? 0 : h, g = e.colors, m = g === void 0 ? { scheme: "nivo" } : g, b = e.margin, y = e.width, C = e.height, _ = e.axisTop, M = e.axisRight, S = e.axisBottom, k = S === void 0 ? {} : S, L = e.axisLeft, P = L === void 0 ? {} : L, I = e.enableGridX, O = I === void 0 || I, E = e.enableGridY, B = E === void 0 || E, W = e.gridXValues, F = e.gridYValues, z = e.lineWidth, D = z === void 0 ? 2 : z, Z = e.enableArea, U = Z !== void 0 && Z, $ = e.areaOpacity, q = $ === void 0 ? 0.2 : $, K = e.areaBlendMode, V = K === void 0 ? "normal" : K, n1 = e.enablePoints, o1 = n1 === void 0 || n1, r1 = e.pointSymbol, X = e.pointSize, Y = X === void 0 ? 6 : X, Q = e.pointColor, N = Q === void 0 ? { from: "color" } : Q, j = e.pointBorderWidth, t1 = j === void 0 ? 0 : j, T = e.pointBorderColor, u1 = T === void 0 ? { theme: "background" } : T, l1 = e.enablePointLabel, d1 = l1 !== void 0 && l1, C1 = e.pointLabel, g1 = C1 === void 0 ? "data.yFormatted" : C1, D1 = e.pointLabelYOffset, re = e.defs, q1 = re === void 0 ? [] : re, w1 = e.fill, $1 = w1 === void 0 ? [] : w1, I1 = e.markers, me = e.legends, Se = me === void 0 ? [] : me, fe = e.isInteractive, Re = fe === void 0 || fe, se = e.useMesh, le = se !== void 0 && se, G1 = e.debugMesh, ge = G1 !== void 0 && G1, ce = e.onMouseEnter, he = e.onMouseMove, ve = e.onMouseLeave, pe = e.onClick, Ce = e.onTouchStart, Xe = e.onTouchMove, f1 = e.onTouchEnd, b1 = e.tooltip, S1 = b1 === void 0 ? S7 : b1, J1 = e.enableSlices, ee = J1 !== void 0 && J1, X1 = e.debugSlices, m1 = X1 !== void 0 && X1, M1 = e.sliceTooltip, k1 = M1 === void 0 ? Ok : M1, ue = e.enableCrosshair, oe = ue === void 0 || ue, ie = e.crosshairType, Me = ie === void 0 ? "bottom-left" : ie, $e = e.enableTouchCrosshair, v1 = $e !== void 0 && $e, E1 = e.role, U1 = E1 === void 0 ? "img" : E1, te = e.initialHiddenIds, ne = te === void 0 ? [] : te, ke = ks(y, C, b), Qe = ke.margin, je = ke.innerWidth, we = ke.innerHeight, it = ke.outerWidth, c0 = ke.outerHeight, Ze = Dk({ data: t, xScale: r, xFormat: o, yScale: a, yFormat: s, width: je, height: we, colors: m, curve: u, areaBaselineValue: p, pointColor: N, pointBorderColor: u1, enableSlices: ee, initialHiddenIds: ne }), $2 = Ze.legendData, N0 = Ze.toggleSerie, N1 = Ze.lineGenerator, B1 = Ze.areaGenerator, ae = Ze.series, be = Ze.xScale, de = Ze.yScale, Je = Ze.slices, De = Ze.points, Le = Ue(), at = K3(N, Le), Ct = K3(u1, Le), W2 = d2(null), V2 = W2[0], C2 = W2[1], u0 = d2(null), L1 = u0[0], w2 = u0[1], _2 = { grid: v(lk, { theme: Le, width: je, height: we, xScale: O ? be : null, yScale: B ? de : null, xValues: W, yValues: F }, "grid"), markers: v(qM, { markers: I1, width: je, height: we, xScale: be, yScale: de, theme: Le }, "markers"), axes: v(sk, { xScale: be, yScale: de, width: je, height: we, theme: Le, top: _, right: M, bottom: k, left: P }, "axes"), areas: null, lines: v(BX, { lines: ae, lineGenerator: N1, lineWidth: D }, "lines"), slices: null, points: null, crosshair: null, mesh: null, legends: Se.map(function(jt, D0) {
    return v(wk, A2({}, jt, { containerWidth: je, containerHeight: we, data: jt.data || $2, theme: Le, toggleSerie: jt.toggleSerie ? N0 : void 0 }), "legend." + D0);
  }) }, O2 = YM(q1, ae, $1);
  return U && (_2.areas = v(NX, { areaGenerator: B1, areaOpacity: q, areaBlendMode: V, lines: ae }, "areas")), Re && ee !== !1 && (_2.slices = v($X, { slices: Je, axis: ee, debug: m1, height: we, tooltip: k1, current: L1, setCurrent: w2, onMouseEnter: ce, onMouseMove: he, onMouseLeave: ve, onClick: pe, onTouchStart: Ce, onTouchMove: Xe, onTouchEnd: f1 }, "slices")), o1 && (_2.points = v(WX, { points: De, symbol: r1, size: Y, color: at, borderWidth: t1, borderColor: Ct, enableLabel: d1, label: g1, labelYOffset: D1 }, "points")), Re && oe && (V2 !== null && (_2.crosshair = v(wu, { width: je, height: we, x: V2.x, y: V2.y, type: Me }, "crosshair")), L1 !== null && (_2.crosshair = v(wu, { width: je, height: we, x: L1.x, y: L1.y, type: ee }, "crosshair"))), Re && le && ee === !1 && (_2.mesh = v(VX, { points: De, width: je, height: we, margin: Qe, current: V2, setCurrent: C2, onMouseEnter: ce, onMouseMove: he, onMouseLeave: ve, onClick: pe, onTouchStart: Ce, onTouchMove: Xe, onTouchEnd: f1, tooltip: S1, enableTouchCrosshair: v1, debug: ge }, "mesh")), v(b7, { defs: O2, width: it, height: c0, margin: Qe, role: U1, children: c.map(function(jt, D0) {
    return typeof jt == "function" ? v(N6, { children: jt(A2({}, e, { innerWidth: je, innerHeight: we, series: ae, slices: Je, points: De, xScale: be, yScale: de, lineGenerator: N1, areaGenerator: B1, currentPoint: V2, setCurrentPoint: C2, currentSlice: L1, setCurrentSlice: w2 })) }, D0) : _2[jt];
  }) });
}), jX = function(e) {
  return v(so, { children: function(t) {
    var n = t.width, r = t.height;
    return v(HX, A2({ width: n, height: r }, e));
  } });
}, qX = zM(function(e) {
  var t = Be(null), n = e.width, r = e.height, o = e.margin, i = e.pixelRatio, a = i === void 0 ? typeof window < "u" && window.devicePixelRatio || 1 : i, s = e.data, l = e.xScale, c = l === void 0 ? { type: "point" } : l, f = e.xFormat, u = e.yScale, h = u === void 0 ? { type: "linear", min: 0, max: "auto" } : u, p = e.yFormat, g = e.curve, m = g === void 0 ? "linear" : g, b = e.layers, y = b === void 0 ? ["grid", "markers", "axes", "areas", "crosshair", "lines", "points", "slices", "mesh", "legends"] : b, C = e.colors, _ = C === void 0 ? { scheme: "nivo" } : C, M = e.lineWidth, S = M === void 0 ? 2 : M, k = e.enableArea, L = k !== void 0 && k, P = e.areaBaselineValue, I = P === void 0 ? 0 : P, O = e.areaOpacity, E = O === void 0 ? 0.2 : O, B = e.enablePoints, W = B === void 0 || B, F = e.pointSize, z = F === void 0 ? 6 : F, D = e.pointColor, Z = D === void 0 ? { from: "color" } : D, U = e.pointBorderWidth, $ = U === void 0 ? 0 : U, q = e.pointBorderColor, K = q === void 0 ? { theme: "background" } : q, V = e.enableGridX, n1 = V === void 0 || V, o1 = e.gridXValues, r1 = e.enableGridY, X = r1 === void 0 || r1, Y = e.gridYValues, Q = e.axisTop, N = e.axisRight, j = e.axisBottom, t1 = j === void 0 ? {} : j, T = e.axisLeft, u1 = T === void 0 ? {} : T, l1 = e.legends, d1 = l1 === void 0 ? [] : l1, C1 = e.isInteractive, g1 = C1 === void 0 || C1, D1 = e.debugMesh, re = D1 !== void 0 && D1, q1 = e.onMouseLeave, w1 = e.onClick, $1 = e.tooltip, I1 = $1 === void 0 ? S7 : $1, me = e.canvasRef, Se = ks(n, r, o), fe = Se.margin, Re = Se.innerWidth, se = Se.innerHeight, le = Se.outerWidth, G1 = Se.outerHeight, ge = Ue(), ce = d2(null), he = ce[0], ve = ce[1], pe = Dk({ data: s, xScale: c, xFormat: f, yScale: h, yFormat: p, width: Re, height: se, colors: _, curve: m, areaBaselineValue: I, pointColor: Z, pointBorderColor: K }), Ce = pe.lineGenerator, Xe = pe.areaGenerator, f1 = pe.series, b1 = pe.xScale, S1 = pe.yScale, J1 = pe.points, ee = Ik({ points: J1, width: Re, height: se, debug: re }), X1 = ee.delaunay, m1 = ee.voronoi;
  Te(function() {
    me && (me.current = t.current), t.current.width = le * a, t.current.height = G1 * a;
    var v1 = t.current.getContext("2d");
    v1.scale(a, a), v1.fillStyle = ge.background, v1.fillRect(0, 0, le, G1), v1.translate(fe.left, fe.top), y.forEach(function(E1) {
      if (typeof E1 == "function" && E1({ ctx: v1, innerWidth: Re, innerHeight: se, series: f1, points: J1, xScale: b1, yScale: S1, lineWidth: S, lineGenerator: Ce, areaGenerator: Xe, currentPoint: he, setCurrentPoint: ve }), E1 === "grid" && ge.grid.line.strokeWidth > 0 && (v1.lineWidth = ge.grid.line.strokeWidth, v1.strokeStyle = ge.grid.line.stroke, n1 && Si(v1, { width: Re, height: se, scale: b1, axis: "x", values: o1 }), X && Si(v1, { width: Re, height: se, scale: S1, axis: "y", values: Y })), E1 === "axes" && ck(v1, { xScale: b1, yScale: S1, width: Re, height: se, top: Q, right: N, bottom: t1, left: u1, theme: ge }), E1 === "areas" && L === !0) {
        v1.save(), v1.globalAlpha = E, Xe.context(v1);
        for (var U1 = f1.length - 1; U1 >= 0; U1--) v1.fillStyle = f1[U1].color, v1.beginPath(), Xe(f1[U1].data.map(function(ne) {
          return ne.position;
        })), v1.fill();
        v1.restore();
      }
      if (E1 === "lines" && (Ce.context(v1), f1.forEach(function(ne) {
        v1.strokeStyle = ne.color, v1.lineWidth = S, v1.beginPath(), Ce(ne.data.map(function(ke) {
          return ke.position;
        })), v1.stroke();
      })), E1 === "points" && W === !0 && z > 0 && J1.forEach(function(ne) {
        v1.fillStyle = ne.color, v1.beginPath(), v1.arc(ne.x, ne.y, z / 2, 0, 2 * Math.PI), v1.fill(), $ > 0 && (v1.strokeStyle = ne.borderColor, v1.lineWidth = $, v1.stroke());
      }), E1 === "mesh" && re === !0 && (EX(v1, m1), he && TX(v1, m1, he.index)), E1 === "legends") {
        var te = f1.map(function(ne) {
          return { id: ne.id, label: ne.id, color: ne.color };
        }).reverse();
        d1.forEach(function(ne) {
          _k(v1, A2({}, ne, { data: ne.data || te, containerWidth: Re, containerHeight: se, theme: ge }));
        });
      }
    });
  }, [t, le, G1, y, ge, Ce, f1, b1, S1, n1, o1, X, Y, Q, N, t1, u1, d1, J1, W, z, he]);
  var M1 = R1(function(v1) {
    var E1 = nr(t.current, v1), U1 = E1[0], te = E1[1];
    if (!GM(fe.left, fe.top, Re, se, U1, te)) return null;
    var ne = X1.find(U1 - fe.left, te - fe.top);
    return J1[ne];
  }, [t, fe, Re, se, X1]), k1 = d3(), ue = k1.showTooltipFromEvent, oe = k1.hideTooltip, ie = R1(function(v1) {
    var E1 = M1(v1);
    ve(E1), E1 ? ue(s2(I1, { point: E1 }), v1) : oe();
  }, [M1, ve, ue, oe, I1]), Me = R1(function(v1) {
    oe(), ve(null), he && q1 && q1(he, v1);
  }, [oe, ve, q1]), $e = R1(function(v1) {
    if (w1) {
      var E1 = M1(v1);
      E1 && w1(E1, v1);
    }
  }, [M1, w1]);
  return v("canvas", { ref: t, width: le * a, height: G1 * a, style: { width: le, height: G1, cursor: g1 ? "auto" : "normal" }, onMouseEnter: g1 ? ie : void 0, onMouseMove: g1 ? ie : void 0, onMouseLeave: g1 ? Me : void 0, onClick: g1 ? $e : void 0 });
}), zX = x1(function(e, t) {
  return v(qX, A2({}, e, { canvasRef: t }));
});
x1(function(e, t) {
  return v(so, { children: function(n) {
    var r = n.width, o = n.height;
    return v(zX, A2({ width: r, height: o }, e, { ref: t }));
  } });
});
function UX({ className: e, ...t }) {
  const { theme: n, grid: r, axes: o, lineConfig: i, pointDefinition: a, gradientConfig: s } = Tk({
    axisBottom: t.axisBottom,
    axisLeft: t.axisLeft,
    areaOpacity: t?.areaOpacity,
    gradientFillColor: t?.gradientFillColor
  });
  return /* @__PURE__ */ v("div", { className: e, children: /* @__PURE__ */ v(
    jX,
    {
      ...t,
      theme: n,
      ...r,
      ...o,
      ...i,
      ...a,
      ...s
    }
  ) });
}
UX.displayName = "LBLineChart";
const GX = x1(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  "div",
  {
    className: e1(
      Or({ variant: "outline", size: "default" }),
      "flex-wrap h-fit justify-start",
      e
    ),
    ref: n,
    ...t,
    role: "toolbar",
    "aria-label": "Filter Chip Bar"
  }
));
GX.displayName = "LBFilterChipBar";
const YX = x1(
  ({ className: e, onClick: t, children: n, disabled: r, ...o }, i) => /* @__PURE__ */ s1(
    "div",
    {
      className: e1(
        Or({ variant: "ghost", size: "sm" }),
        "[&_svg]:size-3 focus-within:bg-indigo-100 focus-within:text-accent-foreground",
        e
      ),
      ref: i,
      ...o,
      children: [
        n,
        /* @__PURE__ */ s1(
          "button",
          {
            onClick: t,
            disabled: r,
            className: "disabled:text-muted-foreground",
            children: [
              /* @__PURE__ */ v("span", { className: "sr-only", children: "Remove filter" }),
              /* @__PURE__ */ v(ln, {})
            ]
          }
        )
      ]
    }
  )
);
YX.displayName = "LBFilterChip";
const ZX = x1(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  "div",
  {
    className: e1("text-sm  text-slate-500 font-bold text-center", e),
    ref: n,
    ...t
  }
));
ZX.displayName = "LBFilterChipLabel";
var KX = "Separator", Sv = "horizontal", XX = ["horizontal", "vertical"], Bk = d.forwardRef((e, t) => {
  const { decorative: n, orientation: r = Sv, ...o } = e, i = QX(r) ? r : Sv, s = n ? { role: "none" } : { "aria-orientation": i === "vertical" ? i : void 0, role: "separator" };
  return /* @__PURE__ */ v(
    y1.div,
    {
      "data-orientation": i,
      ...s,
      ...o,
      ref: t
    }
  );
});
Bk.displayName = KX;
function QX(e) {
  return XX.includes(e);
}
var JX = Bk;
const eQ = d.forwardRef(
  ({ className: e, orientation: t = "horizontal", decorative: n = !0, ...r }, o) => /* @__PURE__ */ v(
    JX,
    {
      ref: o,
      decorative: n,
      orientation: t,
      className: e1(
        "shrink-0 bg-border",
        t === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
        e
      ),
      ...r
    }
  )
);
eQ.displayName = "LBSeparator";
const tQ = $_;
tQ.displayName = "LBCollapsible";
const nQ = Z5;
nQ.displayName = "LBCollapsibleTrigger";
const rQ = X5;
rQ.displayName = "LBCollapsibleContent";
function oQ(e, t) {
  return d.useReducer((n, r) => t[n][r] ?? n, e);
}
var M7 = "ScrollArea", [Fk, K01] = o2(M7), [iQ, ot] = Fk(M7), $k = d.forwardRef(
  (e, t) => {
    const {
      __scopeScrollArea: n,
      type: r = "hover",
      dir: o,
      scrollHideDelay: i = 600,
      ...a
    } = e, [s, l] = d.useState(null), [c, f] = d.useState(null), [u, h] = d.useState(null), [p, g] = d.useState(null), [m, b] = d.useState(null), [y, C] = d.useState(0), [_, M] = d.useState(0), [S, k] = d.useState(!1), [L, P] = d.useState(!1), I = F1(t, (E) => l(E)), O = l3(o);
    return /* @__PURE__ */ v(
      iQ,
      {
        scope: n,
        type: r,
        dir: O,
        scrollHideDelay: i,
        scrollArea: s,
        viewport: c,
        onViewportChange: f,
        content: u,
        onContentChange: h,
        scrollbarX: p,
        onScrollbarXChange: g,
        scrollbarXEnabled: S,
        onScrollbarXEnabledChange: k,
        scrollbarY: m,
        onScrollbarYChange: b,
        scrollbarYEnabled: L,
        onScrollbarYEnabledChange: P,
        onCornerWidthChange: C,
        onCornerHeightChange: M,
        children: /* @__PURE__ */ v(
          y1.div,
          {
            dir: O,
            ...a,
            ref: I,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": y + "px",
              "--radix-scroll-area-corner-height": _ + "px",
              ...e.style
            }
          }
        )
      }
    );
  }
);
$k.displayName = M7;
var Wk = "ScrollAreaViewport", Vk = d.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, children: r, nonce: o, ...i } = e, a = ot(Wk, n), s = d.useRef(null), l = F1(t, s, a.onViewportChange);
    return /* @__PURE__ */ s1(ze, { children: [
      /* @__PURE__ */ v(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: o
        }
      ),
      /* @__PURE__ */ v(
        y1.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...i,
          ref: l,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: a.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: a.scrollbarYEnabled ? "scroll" : "hidden",
            ...e.style
          },
          children: /* @__PURE__ */ v("div", { ref: a.onContentChange, style: { minWidth: "100%", display: "table" }, children: r })
        }
      )
    ] });
  }
);
Vk.displayName = Wk;
var Vt = "ScrollAreaScrollbar", Hk = d.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, o = ot(Vt, e.__scopeScrollArea), { onScrollbarXEnabledChange: i, onScrollbarYEnabledChange: a } = o, s = e.orientation === "horizontal";
    return d.useEffect(() => (s ? i(!0) : a(!0), () => {
      s ? i(!1) : a(!1);
    }), [s, i, a]), o.type === "hover" ? /* @__PURE__ */ v(aQ, { ...r, ref: t, forceMount: n }) : o.type === "scroll" ? /* @__PURE__ */ v(sQ, { ...r, ref: t, forceMount: n }) : o.type === "auto" ? /* @__PURE__ */ v(jk, { ...r, ref: t, forceMount: n }) : o.type === "always" ? /* @__PURE__ */ v(k7, { ...r, ref: t }) : null;
  }
);
Hk.displayName = Vt;
var aQ = d.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, o = ot(Vt, e.__scopeScrollArea), [i, a] = d.useState(!1);
  return d.useEffect(() => {
    const s = o.scrollArea;
    let l = 0;
    if (s) {
      const c = () => {
        window.clearTimeout(l), a(!0);
      }, f = () => {
        l = window.setTimeout(() => a(!1), o.scrollHideDelay);
      };
      return s.addEventListener("pointerenter", c), s.addEventListener("pointerleave", f), () => {
        window.clearTimeout(l), s.removeEventListener("pointerenter", c), s.removeEventListener("pointerleave", f);
      };
    }
  }, [o.scrollArea, o.scrollHideDelay]), /* @__PURE__ */ v(i2, { present: n || i, children: /* @__PURE__ */ v(
    jk,
    {
      "data-state": i ? "visible" : "hidden",
      ...r,
      ref: t
    }
  ) });
}), sQ = d.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, o = ot(Vt, e.__scopeScrollArea), i = e.orientation === "horizontal", a = Ps(() => l("SCROLL_END"), 100), [s, l] = oQ("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return d.useEffect(() => {
    if (s === "idle") {
      const c = window.setTimeout(() => l("HIDE"), o.scrollHideDelay);
      return () => window.clearTimeout(c);
    }
  }, [s, o.scrollHideDelay, l]), d.useEffect(() => {
    const c = o.viewport, f = i ? "scrollLeft" : "scrollTop";
    if (c) {
      let u = c[f];
      const h = () => {
        const p = c[f];
        u !== p && (l("SCROLL"), a()), u = p;
      };
      return c.addEventListener("scroll", h), () => c.removeEventListener("scroll", h);
    }
  }, [o.viewport, i, l, a]), /* @__PURE__ */ v(i2, { present: n || s !== "hidden", children: /* @__PURE__ */ v(
    k7,
    {
      "data-state": s === "hidden" ? "hidden" : "visible",
      ...r,
      ref: t,
      onPointerEnter: p1(e.onPointerEnter, () => l("POINTER_ENTER")),
      onPointerLeave: p1(e.onPointerLeave, () => l("POINTER_LEAVE"))
    }
  ) });
}), jk = d.forwardRef((e, t) => {
  const n = ot(Vt, e.__scopeScrollArea), { forceMount: r, ...o } = e, [i, a] = d.useState(!1), s = e.orientation === "horizontal", l = Ps(() => {
    if (n.viewport) {
      const c = n.viewport.offsetWidth < n.viewport.scrollWidth, f = n.viewport.offsetHeight < n.viewport.scrollHeight;
      a(s ? c : f);
    }
  }, 10);
  return X3(n.viewport, l), X3(n.content, l), /* @__PURE__ */ v(i2, { present: r || i, children: /* @__PURE__ */ v(
    k7,
    {
      "data-state": i ? "visible" : "hidden",
      ...o,
      ref: t
    }
  ) });
}), k7 = d.forwardRef((e, t) => {
  const { orientation: n = "vertical", ...r } = e, o = ot(Vt, e.__scopeScrollArea), i = d.useRef(null), a = d.useRef(0), [s, l] = d.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), c = Yk(s.viewport, s.content), f = {
    ...r,
    sizes: s,
    onSizesChange: l,
    hasThumb: c > 0 && c < 1,
    onThumbChange: (h) => i.current = h,
    onThumbPointerUp: () => a.current = 0,
    onThumbPointerDown: (h) => a.current = h
  };
  function u(h, p) {
    return hQ(h, a.current, s, p);
  }
  return n === "horizontal" ? /* @__PURE__ */ v(
    lQ,
    {
      ...f,
      ref: t,
      onThumbPositionChange: () => {
        if (o.viewport && i.current) {
          const h = o.viewport.scrollLeft, p = Mv(h, s, o.dir);
          i.current.style.transform = `translate3d(${p}px, 0, 0)`;
        }
      },
      onWheelScroll: (h) => {
        o.viewport && (o.viewport.scrollLeft = h);
      },
      onDragScroll: (h) => {
        o.viewport && (o.viewport.scrollLeft = u(h, o.dir));
      }
    }
  ) : n === "vertical" ? /* @__PURE__ */ v(
    cQ,
    {
      ...f,
      ref: t,
      onThumbPositionChange: () => {
        if (o.viewport && i.current) {
          const h = o.viewport.scrollTop, p = Mv(h, s);
          i.current.style.transform = `translate3d(0, ${p}px, 0)`;
        }
      },
      onWheelScroll: (h) => {
        o.viewport && (o.viewport.scrollTop = h);
      },
      onDragScroll: (h) => {
        o.viewport && (o.viewport.scrollTop = u(h));
      }
    }
  ) : null;
}), lQ = d.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: r, ...o } = e, i = ot(Vt, e.__scopeScrollArea), [a, s] = d.useState(), l = d.useRef(null), c = F1(t, l, i.onScrollbarXChange);
  return d.useEffect(() => {
    l.current && s(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ v(
    zk,
    {
      "data-orientation": "horizontal",
      ...o,
      ref: c,
      sizes: n,
      style: {
        bottom: 0,
        left: i.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: i.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": Rs(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (f) => e.onThumbPointerDown(f.x),
      onDragScroll: (f) => e.onDragScroll(f.x),
      onWheelScroll: (f, u) => {
        if (i.viewport) {
          const h = i.viewport.scrollLeft + f.deltaX;
          e.onWheelScroll(h), Kk(h, u) && f.preventDefault();
        }
      },
      onResize: () => {
        l.current && i.viewport && a && r({
          content: i.viewport.scrollWidth,
          viewport: i.viewport.offsetWidth,
          scrollbar: {
            size: l.current.clientWidth,
            paddingStart: Ei(a.paddingLeft),
            paddingEnd: Ei(a.paddingRight)
          }
        });
      }
    }
  );
}), cQ = d.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: r, ...o } = e, i = ot(Vt, e.__scopeScrollArea), [a, s] = d.useState(), l = d.useRef(null), c = F1(t, l, i.onScrollbarYChange);
  return d.useEffect(() => {
    l.current && s(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ v(
    zk,
    {
      "data-orientation": "vertical",
      ...o,
      ref: c,
      sizes: n,
      style: {
        top: 0,
        right: i.dir === "ltr" ? 0 : void 0,
        left: i.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": Rs(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (f) => e.onThumbPointerDown(f.y),
      onDragScroll: (f) => e.onDragScroll(f.y),
      onWheelScroll: (f, u) => {
        if (i.viewport) {
          const h = i.viewport.scrollTop + f.deltaY;
          e.onWheelScroll(h), Kk(h, u) && f.preventDefault();
        }
      },
      onResize: () => {
        l.current && i.viewport && a && r({
          content: i.viewport.scrollHeight,
          viewport: i.viewport.offsetHeight,
          scrollbar: {
            size: l.current.clientHeight,
            paddingStart: Ei(a.paddingTop),
            paddingEnd: Ei(a.paddingBottom)
          }
        });
      }
    }
  );
}), [uQ, qk] = Fk(Vt), zk = d.forwardRef((e, t) => {
  const {
    __scopeScrollArea: n,
    sizes: r,
    hasThumb: o,
    onThumbChange: i,
    onThumbPointerUp: a,
    onThumbPointerDown: s,
    onThumbPositionChange: l,
    onDragScroll: c,
    onWheelScroll: f,
    onResize: u,
    ...h
  } = e, p = ot(Vt, n), [g, m] = d.useState(null), b = F1(t, (I) => m(I)), y = d.useRef(null), C = d.useRef(""), _ = p.viewport, M = r.content - r.viewport, S = u2(f), k = u2(l), L = Ps(u, 10);
  function P(I) {
    if (y.current) {
      const O = I.clientX - y.current.left, E = I.clientY - y.current.top;
      c({ x: O, y: E });
    }
  }
  return d.useEffect(() => {
    const I = (O) => {
      const E = O.target;
      g?.contains(E) && S(O, M);
    };
    return document.addEventListener("wheel", I, { passive: !1 }), () => document.removeEventListener("wheel", I, { passive: !1 });
  }, [_, g, M, S]), d.useEffect(k, [r, k]), X3(g, L), X3(p.content, L), /* @__PURE__ */ v(
    uQ,
    {
      scope: n,
      scrollbar: g,
      hasThumb: o,
      onThumbChange: u2(i),
      onThumbPointerUp: u2(a),
      onThumbPositionChange: k,
      onThumbPointerDown: u2(s),
      children: /* @__PURE__ */ v(
        y1.div,
        {
          ...h,
          ref: b,
          style: { position: "absolute", ...h.style },
          onPointerDown: p1(e.onPointerDown, (I) => {
            I.button === 0 && (I.target.setPointerCapture(I.pointerId), y.current = g.getBoundingClientRect(), C.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", p.viewport && (p.viewport.style.scrollBehavior = "auto"), P(I));
          }),
          onPointerMove: p1(e.onPointerMove, P),
          onPointerUp: p1(e.onPointerUp, (I) => {
            const O = I.target;
            O.hasPointerCapture(I.pointerId) && O.releasePointerCapture(I.pointerId), document.body.style.webkitUserSelect = C.current, p.viewport && (p.viewport.style.scrollBehavior = ""), y.current = null;
          })
        }
      )
    }
  );
}), Li = "ScrollAreaThumb", Uk = d.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, o = qk(Li, e.__scopeScrollArea);
    return /* @__PURE__ */ v(i2, { present: n || o.hasThumb, children: /* @__PURE__ */ v(dQ, { ref: t, ...r }) });
  }
), dQ = d.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, style: r, ...o } = e, i = ot(Li, n), a = qk(Li, n), { onThumbPositionChange: s } = a, l = F1(
      t,
      (u) => a.onThumbChange(u)
    ), c = d.useRef(void 0), f = Ps(() => {
      c.current && (c.current(), c.current = void 0);
    }, 100);
    return d.useEffect(() => {
      const u = i.viewport;
      if (u) {
        const h = () => {
          if (f(), !c.current) {
            const p = pQ(u, s);
            c.current = p, s();
          }
        };
        return s(), u.addEventListener("scroll", h), () => u.removeEventListener("scroll", h);
      }
    }, [i.viewport, f, s]), /* @__PURE__ */ v(
      y1.div,
      {
        "data-state": a.hasThumb ? "visible" : "hidden",
        ...o,
        ref: l,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...r
        },
        onPointerDownCapture: p1(e.onPointerDownCapture, (u) => {
          const p = u.target.getBoundingClientRect(), g = u.clientX - p.left, m = u.clientY - p.top;
          a.onThumbPointerDown({ x: g, y: m });
        }),
        onPointerUp: p1(e.onPointerUp, a.onThumbPointerUp)
      }
    );
  }
);
Uk.displayName = Li;
var L7 = "ScrollAreaCorner", Gk = d.forwardRef(
  (e, t) => {
    const n = ot(L7, e.__scopeScrollArea), r = !!(n.scrollbarX && n.scrollbarY);
    return n.type !== "scroll" && r ? /* @__PURE__ */ v(fQ, { ...e, ref: t }) : null;
  }
);
Gk.displayName = L7;
var fQ = d.forwardRef((e, t) => {
  const { __scopeScrollArea: n, ...r } = e, o = ot(L7, n), [i, a] = d.useState(0), [s, l] = d.useState(0), c = !!(i && s);
  return X3(o.scrollbarX, () => {
    const f = o.scrollbarX?.offsetHeight || 0;
    o.onCornerHeightChange(f), l(f);
  }), X3(o.scrollbarY, () => {
    const f = o.scrollbarY?.offsetWidth || 0;
    o.onCornerWidthChange(f), a(f);
  }), c ? /* @__PURE__ */ v(
    y1.div,
    {
      ...r,
      ref: t,
      style: {
        width: i,
        height: s,
        position: "absolute",
        right: o.dir === "ltr" ? 0 : void 0,
        left: o.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...e.style
      }
    }
  ) : null;
});
function Ei(e) {
  return e ? parseInt(e, 10) : 0;
}
function Yk(e, t) {
  const n = e / t;
  return isNaN(n) ? 0 : n;
}
function Rs(e) {
  const t = Yk(e.viewport, e.content), n = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, r = (e.scrollbar.size - n) * t;
  return Math.max(r, 18);
}
function hQ(e, t, n, r = "ltr") {
  const o = Rs(n), i = o / 2, a = t || i, s = o - a, l = n.scrollbar.paddingStart + a, c = n.scrollbar.size - n.scrollbar.paddingEnd - s, f = n.content - n.viewport, u = r === "ltr" ? [0, f] : [f * -1, 0];
  return Zk([l, c], u)(e);
}
function Mv(e, t, n = "ltr") {
  const r = Rs(t), o = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, i = t.scrollbar.size - o, a = t.content - t.viewport, s = i - r, l = n === "ltr" ? [0, a] : [a * -1, 0], c = G6(e, l);
  return Zk([0, a], [0, s])(c);
}
function Zk(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const r = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + r * (n - e[0]);
  };
}
function Kk(e, t) {
  return e > 0 && e < t;
}
var pQ = (e, t = () => {
}) => {
  let n = { left: e.scrollLeft, top: e.scrollTop }, r = 0;
  return function o() {
    const i = { left: e.scrollLeft, top: e.scrollTop }, a = n.left !== i.left, s = n.top !== i.top;
    (a || s) && t(), n = i, r = window.requestAnimationFrame(o);
  }(), () => window.cancelAnimationFrame(r);
};
function Ps(e, t) {
  const n = u2(e), r = d.useRef(0);
  return d.useEffect(() => () => window.clearTimeout(r.current), []), d.useCallback(() => {
    window.clearTimeout(r.current), r.current = window.setTimeout(n, t);
  }, [n, t]);
}
function X3(e, t) {
  const n = u2(t);
  r2(() => {
    let r = 0;
    if (e) {
      const o = new ResizeObserver(() => {
        cancelAnimationFrame(r), r = window.requestAnimationFrame(n);
      });
      return o.observe(e), () => {
        window.cancelAnimationFrame(r), o.unobserve(e);
      };
    }
  }, [e, n]);
}
var mQ = $k, gQ = Vk, vQ = Gk;
const bQ = x1(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ s1(
  mQ,
  {
    ref: r,
    className: e1("relative overflow-hidden", e),
    ...n,
    children: [
      /* @__PURE__ */ v(gQ, { className: "size-full rounded-[inherit]", children: t }),
      /* @__PURE__ */ v(Xk, {}),
      /* @__PURE__ */ v(vQ, {})
    ]
  }
));
bQ.displayName = "LBScrollArea";
const Xk = x1(({ className: e, orientation: t = "vertical", ...n }, r) => /* @__PURE__ */ v(
  Hk,
  {
    ref: r,
    orientation: t,
    className: e1(
      "flex touch-none select-none transition-colors",
      t === "vertical" && "h-full w-2 border-l border-l-transparent p-[1px]",
      t === "horizontal" && "h-2 flex-col border-t border-t-transparent p-[1px]",
      e
    ),
    ...n,
    children: /* @__PURE__ */ v(Uk, { className: "relative flex-1 rounded-full bg-border" })
  }
));
Xk.displayName = "LBScrollBar";
var Qk = "AlertDialog", [yQ, X01] = o2(Qk, [
  dw
]), s0 = dw(), Jk = (e) => {
  const { __scopeAlertDialog: t, ...n } = e, r = s0(t);
  return /* @__PURE__ */ v(ia, { ...r, ...n, modal: !0 });
};
Jk.displayName = Qk;
var CQ = "AlertDialogTrigger", eL = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, o = s0(n);
    return /* @__PURE__ */ v(A5, { ...o, ...r, ref: t });
  }
);
eL.displayName = CQ;
var wQ = "AlertDialogPortal", tL = (e) => {
  const { __scopeAlertDialog: t, ...n } = e, r = s0(t);
  return /* @__PURE__ */ v(aa, { ...r, ...n });
};
tL.displayName = wQ;
var _Q = "AlertDialogOverlay", nL = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, o = s0(n);
    return /* @__PURE__ */ v(Gr, { ...o, ...r, ref: t });
  }
);
nL.displayName = _Q;
var W3 = "AlertDialogContent", [xQ, SQ] = yQ(W3), MQ = /* @__PURE__ */ Jv("AlertDialogContent"), rL = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, children: r, ...o } = e, i = s0(n), a = d.useRef(null), s = F1(t, a), l = d.useRef(null);
    return /* @__PURE__ */ v(
      UN,
      {
        contentName: W3,
        titleName: oL,
        docsSlug: "alert-dialog",
        children: /* @__PURE__ */ v(xQ, { scope: n, cancelRef: l, children: /* @__PURE__ */ s1(
          un,
          {
            role: "alertdialog",
            ...i,
            ...o,
            ref: s,
            onOpenAutoFocus: p1(o.onOpenAutoFocus, (c) => {
              c.preventDefault(), l.current?.focus({ preventScroll: !0 });
            }),
            onPointerDownOutside: (c) => c.preventDefault(),
            onInteractOutside: (c) => c.preventDefault(),
            children: [
              /* @__PURE__ */ v(MQ, { children: r }),
              /* @__PURE__ */ v(LQ, { contentRef: a })
            ]
          }
        ) })
      }
    );
  }
);
rL.displayName = W3;
var oL = "AlertDialogTitle", iL = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, o = s0(n);
    return /* @__PURE__ */ v(sa, { ...o, ...r, ref: t });
  }
);
iL.displayName = oL;
var aL = "AlertDialogDescription", sL = d.forwardRef((e, t) => {
  const { __scopeAlertDialog: n, ...r } = e, o = s0(n);
  return /* @__PURE__ */ v(I5, { ...o, ...r, ref: t });
});
sL.displayName = aL;
var kQ = "AlertDialogAction", lL = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, o = s0(n);
    return /* @__PURE__ */ v(Yr, { ...o, ...r, ref: t });
  }
);
lL.displayName = kQ;
var cL = "AlertDialogCancel", uL = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, { cancelRef: o } = SQ(cL, n), i = s0(n), a = F1(t, o);
    return /* @__PURE__ */ v(Yr, { ...i, ...r, ref: a });
  }
);
uL.displayName = cL;
var LQ = ({ contentRef: e }) => {
  const t = `\`${W3}\` requires a description for the component to be accessible for screen reader users.

You can add a description to the \`${W3}\` by passing a \`${aL}\` component as a child, which also benefits sighted users by adding visible context to the dialog.

Alternatively, you can use your own component as a description by assigning it an \`id\` and passing the same value to the \`aria-describedby\` prop in \`${W3}\`. If the description is confusing or duplicative for sighted users, you can use the \`@radix-ui/react-visually-hidden\` primitive as a wrapper around your description component.

For more information, see https://radix-ui.com/primitives/docs/components/alert-dialog`;
  return d.useEffect(() => {
    document.getElementById(
      e.current?.getAttribute("aria-describedby")
    ) || console.warn(t);
  }, [t, e]), null;
}, EQ = Jk, TQ = eL, RQ = tL, PQ = nL, AQ = rL, IQ = lL, OQ = uL, NQ = iL, DQ = sL;
const BQ = EQ;
BQ.displayName = "LBAlertDialog";
const FQ = TQ;
FQ.displayName = "LBAlertDialogTrigger";
const dL = RQ;
dL.displayName = "LBAlertDialogPortal";
const fL = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  PQ,
  {
    className: e1(
      "fixed inset-0 z-50 bg-black/25  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t,
    ref: n
  }
));
fL.displayName = "LBAlertDialogOverlay";
const $Q = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ s1(dL, { children: [
  /* @__PURE__ */ v(fL, {}),
  /* @__PURE__ */ v(
    AQ,
    {
      ref: n,
      className: e1(
        "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg",
        e
      ),
      ...t
    }
  )
] }));
$Q.displayName = "LBAlertDialogContent";
function WQ({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ v(
    "div",
    {
      className: e1(
        "flex flex-col space-y-2 text-center sm:text-left",
        e
      ),
      ...t
    }
  );
}
WQ.displayName = "LBAlertDialogHeader";
function VQ({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ v(
    "div",
    {
      className: e1(
        "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
        e
      ),
      ...t
    }
  );
}
VQ.displayName = "LBAlertDialogFooter";
const HQ = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  NQ,
  {
    ref: n,
    className: e1("text-lg font-semibold", e),
    ...t
  }
));
HQ.displayName = "LBAlertDialogTitle";
const jQ = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  DQ,
  {
    ref: n,
    className: e1("text-sm text-muted-foreground", e),
    ...t
  }
));
jQ.displayName = "LBAlertDialogDescription";
const qQ = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  IQ,
  {
    ref: n,
    className: e1(Or(), e),
    ...t
  }
));
qQ.displayName = "LBAlertDialogAction";
const zQ = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ v(
  OQ,
  {
    ref: n,
    className: e1(
      Or({ variant: "outline" }),
      "mt-2 sm:mt-0",
      e
    ),
    ...t
  }
));
zQ.displayName = "LBAlertDialogCancel";
var E7 = "Progress", T7 = 100, [UQ, Q01] = o2(E7), [GQ, YQ] = UQ(E7), hL = d.forwardRef(
  (e, t) => {
    const {
      __scopeProgress: n,
      value: r = null,
      max: o,
      getValueLabel: i = ZQ,
      ...a
    } = e;
    (o || o === 0) && !kv(o) && console.error(KQ(`${o}`, "Progress"));
    const s = kv(o) ? o : T7;
    r !== null && !Lv(r, s) && console.error(XQ(`${r}`, "Progress"));
    const l = Lv(r, s) ? r : null, c = Ti(l) ? i(l, s) : void 0;
    return /* @__PURE__ */ v(GQ, { scope: n, value: l, max: s, children: /* @__PURE__ */ v(
      y1.div,
      {
        "aria-valuemax": s,
        "aria-valuemin": 0,
        "aria-valuenow": Ti(l) ? l : void 0,
        "aria-valuetext": c,
        role: "progressbar",
        "data-state": gL(l, s),
        "data-value": l ?? void 0,
        "data-max": s,
        ...a,
        ref: t
      }
    ) });
  }
);
hL.displayName = E7;
var pL = "ProgressIndicator", mL = d.forwardRef(
  (e, t) => {
    const { __scopeProgress: n, ...r } = e, o = YQ(pL, n);
    return /* @__PURE__ */ v(
      y1.div,
      {
        "data-state": gL(o.value, o.max),
        "data-value": o.value ?? void 0,
        "data-max": o.max,
        ...r,
        ref: t
      }
    );
  }
);
mL.displayName = pL;
function ZQ(e, t) {
  return `${Math.round(e / t * 100)}%`;
}
function gL(e, t) {
  return e == null ? "indeterminate" : e === t ? "complete" : "loading";
}
function Ti(e) {
  return typeof e == "number";
}
function kv(e) {
  return Ti(e) && !isNaN(e) && e > 0;
}
function Lv(e, t) {
  return Ti(e) && !isNaN(e) && e <= t && e >= 0;
}
function KQ(e, t) {
  return `Invalid prop \`max\` of value \`${e}\` supplied to \`${t}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${T7}\`.`;
}
function XQ(e, t) {
  return `Invalid prop \`value\` of value \`${e}\` supplied to \`${t}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${T7} if no \`max\` prop is set)
  - \`null\` or \`undefined\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
var QQ = hL, JQ = mL;
const eJ = x1(({ className: e, value: t, ...n }, r) => /* @__PURE__ */ v(
  QQ,
  {
    ref: r,
    className: e1(
      "relative h-2 w-full overflow-hidden rounded-full bg-primary/20",
      e
    ),
    ...n,
    children: /* @__PURE__ */ v(
      JQ,
      {
        className: "size-full flex-1 bg-primary transition-all",
        style: { transform: `translateX(-${100 - (t || 0)}%)` }
      }
    )
  }
));
eJ.displayName = "LBProgress";
function tJ({ ...e }) {
  return /* @__PURE__ */ v("nav", { "aria-label": "breadcrumb", "data-slot": "breadcrumb", ...e });
}
function nJ({ className: e, ...t }) {
  return /* @__PURE__ */ v(
    "ol",
    {
      "data-slot": "breadcrumb-list",
      className: e1(
        "text-muted-foreground flex flex-wrap items-center gap-1.5 text-sm break-words sm:gap-2.5",
        e
      ),
      ...t
    }
  );
}
function rJ({ className: e, ...t }) {
  return /* @__PURE__ */ v(
    "li",
    {
      "data-slot": "breadcrumb-item",
      className: e1("inline-flex items-center gap-1.5", e),
      ...t
    }
  );
}
function oJ({
  asChild: e,
  className: t,
  ...n
}) {
  return /* @__PURE__ */ v(
    e ? Ai : "a",
    {
      "data-slot": "breadcrumb-link",
      className: e1(
        "text-muted-foreground hover:text-foreground transition-colors no-underline",
        t
      ),
      ...n
    }
  );
}
function iJ({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ v(
    "span",
    {
      "data-slot": "breadcrumb-page",
      "aria-disabled": "true",
      "aria-current": "page",
      className: e1("text-foreground font-normal", e),
      ...t
    }
  );
}
function aJ({
  children: e,
  className: t,
  ...n
}) {
  return /* @__PURE__ */ v(
    "li",
    {
      "data-slot": "breadcrumb-separator",
      role: "presentation",
      "aria-hidden": "true",
      className: e1("[&>svg]:size-4 mx-2 text-muted-foreground", t),
      ...n,
      children: e ?? /* @__PURE__ */ v(CI, {})
    }
  );
}
function sJ({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ s1(
    "span",
    {
      "data-slot": "breadcrumb-ellipsis",
      role: "presentation",
      "aria-hidden": "true",
      className: e1("flex size-9 items-center justify-center", e),
      ...t,
      children: [
        /* @__PURE__ */ v(xI, { className: "size-4" }),
        /* @__PURE__ */ v("span", { className: "sr-only", children: "More" })
      ]
    }
  );
}
tJ.displayName = "LBBreadcrumb";
nJ.displayName = "LBBreadcrumbList";
rJ.displayName = "LBBreadcrumbItem";
oJ.displayName = "LBBreadcrumbLink";
iJ.displayName = "LBBreadcrumbPage";
aJ.displayName = "LBBreadcrumbSeparator";
sJ.displayName = "LBBreadcrumbEllipsis";
var lJ = Object.defineProperty, cJ = (e, t, n) => t in e ? lJ(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Z1 = (e, t, n) => cJ(e, typeof t != "symbol" ? t + "" : t, n), uJ = class {
  requestAnimationFrame(e) {
    return requestAnimationFrame(e);
  }
  cancelAnimationFrame(e) {
    cancelAnimationFrame(e);
  }
}, dJ = class {
  constructor() {
    Z1(this, "_lastHandleId", 0), Z1(this, "_lastImmediate", null);
  }
  requestAnimationFrame(e) {
    return this._lastHandleId >= Number.MAX_SAFE_INTEGER && (this._lastHandleId = 0), this._lastHandleId += 1, this._lastImmediate = setImmediate(() => {
      e(Date.now());
    }), this._lastHandleId;
  }
  cancelAnimationFrame(e) {
    this._lastImmediate && clearImmediate(this._lastImmediate);
  }
}, fJ = class {
  constructor() {
    Z1(this, "_strategy"), this._strategy = typeof requestAnimationFrame == "function" ? new uJ() : new dJ();
  }
  requestAnimationFrame(e) {
    return this._strategy.requestAnimationFrame(e);
  }
  cancelAnimationFrame(e) {
    this._strategy.cancelAnimationFrame(e);
  }
}, M2 = typeof window < "u" && typeof window.document < "u", C6 = new Uint8Array([80, 75, 3, 4]), hJ = ["v", "ip", "op", "layers", "fr", "w", "h"], vL = "0.47.0", bL = "@lottiefiles/dotlottie-web", pJ = 0.75, mJ = 4, gJ = (() => {
  var e = typeof document < "u" ? document.currentScript?.src : void 0;
  return function(t = {}) {
    var n, r = t, o, i, a = new Promise((w, x) => {
      o = w, i = x;
    }), s = Object.assign({}, r), l = "./this.program", c = "", f;
    typeof document < "u" && document.currentScript && (c = document.currentScript.src), e && (c = e), c.startsWith("blob:") ? c = "" : c = c.substr(0, c.replace(/[?#].*/, "").lastIndexOf("/") + 1), f = async (w) => {
      if (w = await fetch(w, { credentials: "same-origin" }), w.ok) return w.arrayBuffer();
      throw Error(w.status + " : " + w.url);
    };
    var u = r.print || console.log.bind(console), h = r.printErr || console.error.bind(console);
    Object.assign(r, s), s = null, r.thisProgram && (l = r.thisProgram);
    var p = r.wasmBinary, g, m = !1, b, y, C, _, M, S, k, L, P;
    function I() {
      var w = g.buffer;
      r.HEAP8 = y = new Int8Array(w), r.HEAP16 = _ = new Int16Array(w), r.HEAPU8 = C = new Uint8Array(w), r.HEAPU16 = M = new Uint16Array(w), r.HEAP32 = S = new Int32Array(w), r.HEAPU32 = k = new Uint32Array(w), r.HEAPF32 = L = new Float32Array(w), r.HEAPF64 = P = new Float64Array(w);
    }
    var O = [], E = [], B = [];
    function W() {
      var w = r.preRun.shift();
      O.unshift(w);
    }
    var F = 0, z = null;
    function D(w) {
      throw r.onAbort?.(w), w = "Aborted(" + w + ")", h(w), m = !0, w = new WebAssembly.RuntimeError(w + ". Build with -sASSERTIONS for more info."), i(w), w;
    }
    var Z = (w) => w.startsWith("data:application/octet-stream;base64,"), U;
    async function $(w) {
      if (!p) try {
        var x = await f(w);
        return new Uint8Array(x);
      } catch {
      }
      if (w == U && p) w = new Uint8Array(p);
      else throw "both async and sync fetching of the wasm failed";
      return w;
    }
    async function q(w, x) {
      try {
        var R = await $(w);
        return await WebAssembly.instantiate(R, x);
      } catch (A) {
        h(`failed to asynchronously prepare wasm: ${A}`), D(A);
      }
    }
    async function K(w) {
      var x = U;
      if (!p && typeof WebAssembly.instantiateStreaming == "function" && !Z(x) && typeof fetch == "function") try {
        var R = fetch(x, { credentials: "same-origin" });
        return await WebAssembly.instantiateStreaming(R, w);
      } catch (A) {
        h(`wasm streaming compile failed: ${A}`), h("falling back to ArrayBuffer instantiation");
      }
      return q(x, w);
    }
    class V {
      constructor(x) {
        Z1(this, "name", "ExitStatus"), this.message = `Program terminated with exit(${x})`, this.status = x;
      }
    }
    var n1 = (w) => {
      for (; 0 < w.length; ) w.shift()(r);
    }, o1 = r.noExitRuntime || !0, r1 = typeof TextDecoder < "u" ? new TextDecoder() : void 0, X = (w, x = 0, R = NaN) => {
      var A = x + R;
      for (R = x; w[R] && !(R >= A); ) ++R;
      if (16 < R - x && w.buffer && r1) return r1.decode(w.subarray(x, R));
      for (A = ""; x < R; ) {
        var H = w[x++];
        if (H & 128) {
          var J = w[x++] & 63;
          if ((H & 224) == 192) A += String.fromCharCode((H & 31) << 6 | J);
          else {
            var c1 = w[x++] & 63;
            H = (H & 240) == 224 ? (H & 15) << 12 | J << 6 | c1 : (H & 7) << 18 | J << 12 | c1 << 6 | w[x++] & 63, 65536 > H ? A += String.fromCharCode(H) : (H -= 65536, A += String.fromCharCode(55296 | H >> 10, 56320 | H & 1023));
          }
        } else A += String.fromCharCode(H);
      }
      return A;
    }, Y = 0;
    class Q {
      constructor(x) {
        this.Pa = x - 24;
      }
    }
    var N = () => {
      var w = [], x = Y;
      if (!x) return wn(0), 0;
      var R = new Q(x);
      k[R.Pa + 16 >> 2] = x;
      var A = k[R.Pa + 4 >> 2];
      if (!A) return wn(0), x;
      for (var H of w) {
        if (H === 0 || H === A) break;
        if (V7(H, A, R.Pa + 16)) return wn(H), x;
      }
      return wn(A), x;
    }, j = (w, x, R) => {
      var A = C;
      if (0 < R) {
        R = x + R - 1;
        for (var H = 0; H < w.length; ++H) {
          var J = w.charCodeAt(H);
          if (55296 <= J && 57343 >= J) {
            var c1 = w.charCodeAt(++H);
            J = 65536 + ((J & 1023) << 10) | c1 & 1023;
          }
          if (127 >= J) {
            if (x >= R) break;
            A[x++] = J;
          } else {
            if (2047 >= J) {
              if (x + 1 >= R) break;
              A[x++] = 192 | J >> 6;
            } else {
              if (65535 >= J) {
                if (x + 2 >= R) break;
                A[x++] = 224 | J >> 12;
              } else {
                if (x + 3 >= R) break;
                A[x++] = 240 | J >> 18, A[x++] = 128 | J >> 12 & 63;
              }
              A[x++] = 128 | J >> 6 & 63;
            }
            A[x++] = 128 | J & 63;
          }
        }
        A[x] = 0;
      }
    }, t1 = {}, T = (w) => {
      for (; w.length; ) {
        var x = w.pop();
        w.pop()(x);
      }
    };
    function u1(w) {
      return this.fromWireType(k[w >> 2]);
    }
    var l1 = {}, d1 = {}, C1 = {}, g1, D1 = (w, x, R) => {
      function A(a1) {
        if (a1 = R(a1), a1.length !== w.length) throw new g1("Mismatched type converter count");
        for (var _1 = 0; _1 < w.length; ++_1) I1(w[_1], a1[_1]);
      }
      w.forEach((a1) => C1[a1] = x);
      var H = Array(x.length), J = [], c1 = 0;
      x.forEach((a1, _1) => {
        d1.hasOwnProperty(a1) ? H[_1] = d1[a1] : (J.push(a1), l1.hasOwnProperty(a1) || (l1[a1] = []), l1[a1].push(() => {
          H[_1] = d1[a1], ++c1, c1 === J.length && A(H);
        }));
      }), J.length === 0 && A(H);
    }, re, q1 = (w) => {
      for (var x = ""; C[w]; ) x += re[C[w++]];
      return x;
    }, w1;
    function $1(w, x, R = {}) {
      var A = x.name;
      if (!w) throw new w1(`type "${A}" must have a positive integer typeid pointer`);
      if (d1.hasOwnProperty(w)) {
        if (R.vb) return;
        throw new w1(`Cannot register type '${A}' twice`);
      }
      d1[w] = x, delete C1[w], l1.hasOwnProperty(w) && (x = l1[w], delete l1[w], x.forEach((H) => H()));
    }
    function I1(w, x, R = {}) {
      return $1(w, x, R);
    }
    var me = (w) => {
      throw new w1(w.Oa.Ra.Qa.name + " instance already deleted");
    }, Se = !1, fe = () => {
    }, Re = (w, x, R) => x === R ? w : R.Ua === void 0 ? null : (w = Re(w, x, R.Ua), w === null ? null : R.ob(w)), se = {}, le = {}, G1 = (w, x) => {
      if (x === void 0) throw new w1("ptr should not be undefined");
      for (; w.Ua; ) x = w.eb(x), w = w.Ua;
      return le[x];
    }, ge = (w, x) => {
      if (!x.Ra || !x.Pa) throw new g1("makeClassHandle requires ptr and ptrType");
      if (!!x.Va != !!x.Ta) throw new g1("Both smartPtrType and smartPtr must be specified");
      return x.count = { value: 1 }, ce(Object.create(w, { Oa: { value: x, writable: !0 } }));
    }, ce = (w) => typeof FinalizationRegistry > "u" ? (ce = (x) => x, w) : (Se = new FinalizationRegistry((x) => {
      x = x.Oa, --x.count.value, x.count.value === 0 && (x.Ta ? x.Va.Ya(x.Ta) : x.Ra.Qa.Ya(x.Pa));
    }), ce = (x) => {
      var R = x.Oa;
      return R.Ta && Se.register(x, { Oa: R }, x), x;
    }, fe = (x) => {
      Se.unregister(x);
    }, ce(w));
    function he() {
    }
    var ve = (w, x) => Object.defineProperty(x, "name", { value: w }), pe = (w, x, R) => {
      if (w[x].Sa === void 0) {
        var A = w[x];
        w[x] = function(...H) {
          if (!w[x].Sa.hasOwnProperty(H.length)) throw new w1(`Function '${R}' called with an invalid number of arguments (${H.length}) - expects one of (${w[x].Sa})!`);
          return w[x].Sa[H.length].apply(this, H);
        }, w[x].Sa = [], w[x].Sa[A.ab] = A;
      }
    }, Ce = (w, x, R) => {
      if (r.hasOwnProperty(w)) {
        if (R === void 0 || r[w].Sa !== void 0 && r[w].Sa[R] !== void 0) throw new w1(`Cannot register public name '${w}' twice`);
        if (pe(r, w, w), r[w].Sa.hasOwnProperty(R)) throw new w1(`Cannot register multiple overloads of a function with the same number of arguments (${R})!`);
        r[w].Sa[R] = x;
      } else r[w] = x, r[w].ab = R;
    }, Xe = (w) => {
      w = w.replace(/[^a-zA-Z0-9_]/g, "$");
      var x = w.charCodeAt(0);
      return 48 <= x && 57 >= x ? `_${w}` : w;
    };
    function f1(w, x, R, A, H, J, c1, a1) {
      this.name = w, this.constructor = x, this.$a = R, this.Ya = A, this.Ua = H, this.qb = J, this.eb = c1, this.ob = a1, this.xb = [];
    }
    var b1 = (w, x, R) => {
      for (; x !== R; ) {
        if (!x.eb) throw new w1(`Expected null or instance of ${R.name}, got an instance of ${x.name}`);
        w = x.eb(w), x = x.Ua;
      }
      return w;
    };
    function S1(w, x) {
      if (x === null) {
        if (this.hb) throw new w1(`null is not a valid ${this.name}`);
        return 0;
      }
      if (!x.Oa) throw new w1(`Cannot pass "${$2(x)}" as a ${this.name}`);
      if (!x.Oa.Pa) throw new w1(`Cannot pass deleted object as a pointer of type ${this.name}`);
      return b1(x.Oa.Pa, x.Oa.Ra.Qa, this.Qa);
    }
    function J1(w, x) {
      if (x === null) {
        if (this.hb) throw new w1(`null is not a valid ${this.name}`);
        if (this.gb) {
          var R = this.ib();
          return w !== null && w.push(this.Ya, R), R;
        }
        return 0;
      }
      if (!x || !x.Oa) throw new w1(`Cannot pass "${$2(x)}" as a ${this.name}`);
      if (!x.Oa.Pa) throw new w1(`Cannot pass deleted object as a pointer of type ${this.name}`);
      if (!this.fb && x.Oa.Ra.fb) throw new w1(`Cannot convert argument of type ${x.Oa.Va ? x.Oa.Va.name : x.Oa.Ra.name} to parameter type ${this.name}`);
      if (R = b1(x.Oa.Pa, x.Oa.Ra.Qa, this.Qa), this.gb) {
        if (x.Oa.Ta === void 0) throw new w1("Passing raw pointer to smart pointer is illegal");
        switch (this.Cb) {
          case 0:
            if (x.Oa.Va === this) R = x.Oa.Ta;
            else throw new w1(`Cannot convert argument of type ${x.Oa.Va ? x.Oa.Va.name : x.Oa.Ra.name} to parameter type ${this.name}`);
            break;
          case 1:
            R = x.Oa.Ta;
            break;
          case 2:
            if (x.Oa.Va === this) R = x.Oa.Ta;
            else {
              var A = x.clone();
              R = this.yb(R, we(() => A.delete())), w !== null && w.push(this.Ya, R);
            }
            break;
          default:
            throw new w1("Unsupporting sharing policy");
        }
      }
      return R;
    }
    function ee(w, x) {
      if (x === null) {
        if (this.hb) throw new w1(`null is not a valid ${this.name}`);
        return 0;
      }
      if (!x.Oa) throw new w1(`Cannot pass "${$2(x)}" as a ${this.name}`);
      if (!x.Oa.Pa) throw new w1(`Cannot pass deleted object as a pointer of type ${this.name}`);
      if (x.Oa.Ra.fb) throw new w1(`Cannot convert argument of type ${x.Oa.Ra.name} to parameter type ${this.name}`);
      return b1(x.Oa.Pa, x.Oa.Ra.Qa, this.Qa);
    }
    function X1(w, x, R, A, H, J, c1, a1, _1, T1, P1) {
      this.name = w, this.Qa = x, this.hb = R, this.fb = A, this.gb = H, this.wb = J, this.Cb = c1, this.mb = a1, this.ib = _1, this.yb = T1, this.Ya = P1, H || x.Ua !== void 0 ? this.toWireType = J1 : (this.toWireType = A ? S1 : ee, this.Xa = null);
    }
    var m1 = (w, x, R) => {
      if (!r.hasOwnProperty(w)) throw new g1("Replacing nonexistent public symbol");
      r[w].Sa !== void 0 && R !== void 0 ? r[w].Sa[R] = x : (r[w] = x, r[w].ab = R);
    }, M1, k1 = (w, x, R = []) => (w.includes("j") ? (w = w.replace(/p/g, "i"), x = (0, r["dynCall_" + w])(x, ...R)) : x = M1.get(x)(...R), x), ue = (w, x) => (...R) => k1(w, x, R), oe = (w, x) => {
      w = q1(w);
      var R = w.includes("j") ? ue(w, x) : M1.get(x);
      if (typeof R != "function") throw new w1(`unknown function pointer with signature ${w}: ${x}`);
      return R;
    }, ie, Me = (w) => {
      w = $7(w);
      var x = q1(w);
      return qt(w), x;
    }, $e = (w, x) => {
      function R(J) {
        H[J] || d1[J] || (C1[J] ? C1[J].forEach(R) : (A.push(J), H[J] = !0));
      }
      var A = [], H = {};
      throw x.forEach(R), new ie(`${w}: ` + A.map(Me).join([", "]));
    }, v1 = (w, x) => {
      for (var R = [], A = 0; A < w; A++) R.push(k[x + 4 * A >> 2]);
      return R;
    };
    function E1(w) {
      for (var x = 1; x < w.length; ++x) if (w[x] !== null && w[x].Xa === void 0) return !0;
      return !1;
    }
    function U1(w, x, R, A, H) {
      var J = x.length;
      if (2 > J) throw new w1("argTypes array size mismatch! Must at least get return value and 'this' types!");
      var c1 = x[1] !== null && R !== null, a1 = E1(x), _1 = x[0].name !== "void", T1 = J - 2, P1 = Array(T1), Q1 = [], We = [];
      return ve(w, function(...H2) {
        if (We.length = 0, Q1.length = c1 ? 2 : 1, Q1[0] = H, c1) {
          var n2 = x[1].toWireType(We, this);
          Q1[1] = n2;
        }
        for (var a2 = 0; a2 < T1; ++a2) P1[a2] = x[a2 + 2].toWireType(We, H2[a2]), Q1.push(P1[a2]);
        if (H2 = A(...Q1), a1) T(We);
        else for (a2 = c1 ? 1 : 2; a2 < x.length; a2++) {
          var st = a2 === 1 ? n2 : P1[a2 - 2];
          x[a2].Xa !== null && x[a2].Xa(st);
        }
        return n2 = _1 ? x[0].fromWireType(H2) : void 0, n2;
      });
    }
    var te = (w) => {
      w = w.trim();
      let x = w.indexOf("(");
      return x !== -1 ? w.substr(0, x) : w;
    }, ne = [], ke = [], Qe = (w) => {
      9 < w && --ke[w + 1] === 0 && (ke[w] = void 0, ne.push(w));
    }, je = (w) => {
      if (!w) throw new w1("Cannot use deleted val. handle = " + w);
      return ke[w];
    }, we = (w) => {
      switch (w) {
        case void 0:
          return 2;
        case null:
          return 4;
        case !0:
          return 6;
        case !1:
          return 8;
        default:
          let x = ne.pop() || ke.length;
          return ke[x] = w, ke[x + 1] = 1, x;
      }
    }, it = { name: "emscripten::val", fromWireType: (w) => {
      var x = je(w);
      return Qe(w), x;
    }, toWireType: (w, x) => we(x), Wa: 8, readValueFromPointer: u1, Xa: null }, c0 = (w, x, R) => {
      switch (x) {
        case 1:
          return R ? function(A) {
            return this.fromWireType(y[A]);
          } : function(A) {
            return this.fromWireType(C[A]);
          };
        case 2:
          return R ? function(A) {
            return this.fromWireType(_[A >> 1]);
          } : function(A) {
            return this.fromWireType(M[A >> 1]);
          };
        case 4:
          return R ? function(A) {
            return this.fromWireType(S[A >> 2]);
          } : function(A) {
            return this.fromWireType(k[A >> 2]);
          };
        default:
          throw new TypeError(`invalid integer width (${x}): ${w}`);
      }
    }, Ze = (w, x) => {
      var R = d1[w];
      if (R === void 0) throw w = `${x} has unknown type ${Me(w)}`, new w1(w);
      return R;
    }, $2 = (w) => {
      if (w === null) return "null";
      var x = typeof w;
      return x === "object" || x === "array" || x === "function" ? w.toString() : "" + w;
    }, N0 = (w, x) => {
      switch (x) {
        case 4:
          return function(R) {
            return this.fromWireType(L[R >> 2]);
          };
        case 8:
          return function(R) {
            return this.fromWireType(P[R >> 3]);
          };
        default:
          throw new TypeError(`invalid float width (${x}): ${w}`);
      }
    }, N1 = (w, x, R) => {
      switch (x) {
        case 1:
          return R ? (A) => y[A] : (A) => C[A];
        case 2:
          return R ? (A) => _[A >> 1] : (A) => M[A >> 1];
        case 4:
          return R ? (A) => S[A >> 2] : (A) => k[A >> 2];
        default:
          throw new TypeError(`invalid integer width (${x}): ${w}`);
      }
    }, B1 = Object.assign({ optional: !0 }, it), ae = typeof TextDecoder < "u" ? new TextDecoder("utf-16le") : void 0, be = (w, x) => {
      for (var R = w >> 1, A = R + x / 2; !(R >= A) && M[R]; ) ++R;
      if (R <<= 1, 32 < R - w && ae) return ae.decode(C.subarray(w, R));
      for (R = "", A = 0; !(A >= x / 2); ++A) {
        var H = _[w + 2 * A >> 1];
        if (H == 0) break;
        R += String.fromCharCode(H);
      }
      return R;
    }, de = (w, x, R) => {
      if (R ?? (R = 2147483647), 2 > R) return 0;
      R -= 2;
      var A = x;
      R = R < 2 * w.length ? R / 2 : w.length;
      for (var H = 0; H < R; ++H) _[x >> 1] = w.charCodeAt(H), x += 2;
      return _[x >> 1] = 0, x - A;
    }, Je = (w) => 2 * w.length, De = (w, x) => {
      for (var R = 0, A = ""; !(R >= x / 4); ) {
        var H = S[w + 4 * R >> 2];
        if (H == 0) break;
        ++R, 65536 <= H ? (H -= 65536, A += String.fromCharCode(55296 | H >> 10, 56320 | H & 1023)) : A += String.fromCharCode(H);
      }
      return A;
    }, Le = (w, x, R) => {
      if (R ?? (R = 2147483647), 4 > R) return 0;
      var A = x;
      R = A + R - 4;
      for (var H = 0; H < w.length; ++H) {
        var J = w.charCodeAt(H);
        if (55296 <= J && 57343 >= J) {
          var c1 = w.charCodeAt(++H);
          J = 65536 + ((J & 1023) << 10) | c1 & 1023;
        }
        if (S[x >> 2] = J, x += 4, x + 4 > R) break;
      }
      return S[x >> 2] = 0, x - A;
    }, at = (w) => {
      for (var x = 0, R = 0; R < w.length; ++R) {
        var A = w.charCodeAt(R);
        55296 <= A && 57343 >= A && ++R, x += 4;
      }
      return x;
    }, Ct = 0, W2 = (w, x, R) => {
      var A = [];
      return w = w.toWireType(A, R), A.length && (k[x >> 2] = we(A)), w;
    }, V2 = [], C2 = (w) => {
      var x = V2.length;
      return V2.push(w), x;
    }, u0 = (w, x) => {
      for (var R = Array(w), A = 0; A < w; ++A) R[A] = Ze(k[x + 4 * A >> 2], "parameter " + A);
      return R;
    }, L1 = Reflect.construct, w2 = {}, _2 = (w) => {
      if (!(w instanceof V || w == "unwind")) throw w;
    }, O2 = (w) => {
      throw b = w, o1 || 0 < Ct || (r.onExit?.(w), m = !0), new V(w);
    }, jt = (w) => {
      if (!m) try {
        if (w(), !(o1 || 0 < Ct)) try {
          b = w = b, O2(w);
        } catch (x) {
          _2(x);
        }
      } catch (x) {
        _2(x);
      }
    }, D0 = {}, D7 = () => {
      if (!Os) {
        var w = { USER: "web_user", LOGNAME: "web_user", PATH: "/", PWD: "/", HOME: "/home/web_user", LANG: (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8", _: l || "./this.program" }, x;
        for (x in D0) D0[x] === void 0 ? delete w[x] : w[x] = D0[x];
        var R = [];
        for (x in w) R.push(`${x}=${w[x]}`);
        Os = R;
      }
      return Os;
    }, Os, sE = [null, [], []], lE = () => {
      if (typeof crypto == "object" && typeof crypto.getRandomValues == "function") return (w) => crypto.getRandomValues(w);
      D("initRandomDevice");
    }, B7 = (w) => (B7 = lE())(w);
    g1 = r.InternalError = class extends Error {
      constructor(w) {
        super(w), this.name = "InternalError";
      }
    };
    for (var F7 = Array(256), po = 0; 256 > po; ++po) F7[po] = String.fromCharCode(po);
    re = F7, w1 = r.BindingError = class extends Error {
      constructor(w) {
        super(w), this.name = "BindingError";
      }
    }, Object.assign(he.prototype, { isAliasOf: function(w) {
      if (!(this instanceof he && w instanceof he)) return !1;
      var x = this.Oa.Ra.Qa, R = this.Oa.Pa;
      w.Oa = w.Oa;
      var A = w.Oa.Ra.Qa;
      for (w = w.Oa.Pa; x.Ua; ) R = x.eb(R), x = x.Ua;
      for (; A.Ua; ) w = A.eb(w), A = A.Ua;
      return x === A && R === w;
    }, clone: function() {
      if (this.Oa.Pa || me(this), this.Oa.cb) return this.Oa.count.value += 1, this;
      var w = ce, x = Object, R = x.create, A = Object.getPrototypeOf(this), H = this.Oa;
      return w = w(R.call(x, A, { Oa: { value: { count: H.count, bb: H.bb, cb: H.cb, Pa: H.Pa, Ra: H.Ra, Ta: H.Ta, Va: H.Va } } })), w.Oa.count.value += 1, w.Oa.bb = !1, w;
    }, delete() {
      if (this.Oa.Pa || me(this), this.Oa.bb && !this.Oa.cb) throw new w1("Object already scheduled for deletion");
      fe(this);
      var w = this.Oa;
      --w.count.value, w.count.value === 0 && (w.Ta ? w.Va.Ya(w.Ta) : w.Ra.Qa.Ya(w.Pa)), this.Oa.cb || (this.Oa.Ta = void 0, this.Oa.Pa = void 0);
    }, isDeleted: function() {
      return !this.Oa.Pa;
    }, deleteLater: function() {
      if (this.Oa.Pa || me(this), this.Oa.bb && !this.Oa.cb) throw new w1("Object already scheduled for deletion");
      return this.Oa.bb = !0, this;
    } }), Object.assign(X1.prototype, { rb(w) {
      return this.mb && (w = this.mb(w)), w;
    }, kb(w) {
      this.Ya?.(w);
    }, Wa: 8, readValueFromPointer: u1, fromWireType: function(w) {
      function x() {
        return this.gb ? ge(this.Qa.$a, { Ra: this.wb, Pa: R, Va: this, Ta: w }) : ge(this.Qa.$a, { Ra: this, Pa: w });
      }
      var R = this.rb(w);
      if (!R) return this.kb(w), null;
      var A = G1(this.Qa, R);
      if (A !== void 0) return A.Oa.count.value === 0 ? (A.Oa.Pa = R, A.Oa.Ta = w, A.clone()) : (A = A.clone(), this.kb(w), A);
      if (A = this.Qa.qb(R), A = se[A], !A) return x.call(this);
      A = this.fb ? A.nb : A.pointerType;
      var H = Re(R, this.Qa, A.Qa);
      return H === null ? x.call(this) : this.gb ? ge(A.Qa.$a, { Ra: A, Pa: H, Va: this, Ta: w }) : ge(A.Qa.$a, { Ra: A, Pa: H });
    } }), ie = r.UnboundTypeError = ((w, x) => {
      var R = ve(x, function(A) {
        this.name = x, this.message = A, A = Error(A).stack, A !== void 0 && (this.stack = this.toString() + `
` + A.replace(/^Error(:[^\n]*)?\n/, ""));
      });
      return R.prototype = Object.create(w.prototype), R.prototype.constructor = R, R.prototype.toString = function() {
        return this.message === void 0 ? this.name : `${this.name}: ${this.message}`;
      }, R;
    })(Error, "UnboundTypeError"), ke.push(0, 1, void 0, 1, null, 1, !0, 1, !1, 1), r.count_emval_handles = () => ke.length / 2 - 5 - ne.length;
    var cE = { d: (w, x, R, A) => D(`Assertion failed: ${w ? X(C, w) : ""}, at: ` + [x ? x ? X(C, x) : "" : "unknown filename", R, A ? A ? X(C, A) : "" : "unknown function"]), c: () => N(), n: (w, x, R) => {
      var A = new Q(w);
      throw k[A.Pa + 16 >> 2] = 0, k[A.Pa + 4 >> 2] = x, k[A.Pa + 8 >> 2] = R, Y = w, Y;
    }, e: (w) => {
      throw Y || (Y = w), Y;
    }, T: () => {
    }, Q: () => {
    }, R: () => {
    }, V: function() {
    }, S: () => {
    }, X: () => D(""), w: (w) => {
      var x = t1[w];
      delete t1[w];
      var R = x.ib, A = x.Ya, H = x.lb, J = H.map((c1) => c1.ub).concat(H.map((c1) => c1.Ab));
      D1([w], J, (c1) => {
        var a1 = {};
        return H.forEach((_1, T1) => {
          var P1 = c1[T1], Q1 = _1.sb, We = _1.tb, H2 = c1[T1 + H.length], n2 = _1.zb, a2 = _1.Bb;
          a1[_1.pb] = { read: (st) => P1.fromWireType(Q1(We, st)), write: (st, _n) => {
            var j2 = [];
            n2(a2, st, H2.toWireType(j2, _n)), T(j2);
          } };
        }), [{ name: x.name, fromWireType: (_1) => {
          var T1 = {}, P1;
          for (P1 in a1) T1[P1] = a1[P1].read(_1);
          return A(_1), T1;
        }, toWireType: (_1, T1) => {
          for (var P1 in a1) if (!(P1 in T1)) throw new TypeError(`Missing field: "${P1}"`);
          var Q1 = R();
          for (P1 in a1) a1[P1].write(Q1, T1[P1]);
          return _1 !== null && _1.push(A, Q1), Q1;
        }, Wa: 8, readValueFromPointer: u1, Xa: A }];
      });
    }, H: () => {
    }, fa: (w, x, R, A) => {
      x = q1(x), I1(w, { name: x, fromWireType: function(H) {
        return !!H;
      }, toWireType: function(H, J) {
        return J ? R : A;
      }, Wa: 8, readValueFromPointer: function(H) {
        return this.fromWireType(C[H]);
      }, Xa: null });
    }, u: (w, x, R, A, H, J, c1, a1, _1, T1, P1, Q1, We) => {
      P1 = q1(P1), J = oe(H, J), a1 && (a1 = oe(c1, a1)), T1 && (T1 = oe(_1, T1)), We = oe(Q1, We);
      var H2 = Xe(P1);
      Ce(H2, function() {
        $e(`Cannot construct ${P1} due to unbound types`, [A]);
      }), D1([w, x, R], A ? [A] : [], (n2) => {
        if (n2 = n2[0], A) var a2 = n2.Qa, st = a2.$a;
        else st = he.prototype;
        n2 = ve(P1, function(...Ds) {
          if (Object.getPrototypeOf(this) !== _n) throw new w1("Use 'new' to construct " + P1);
          if (j2.Za === void 0) throw new w1(P1 + " has no accessible constructor");
          var q7 = j2.Za[Ds.length];
          if (q7 === void 0) throw new w1(`Tried to invoke ctor of ${P1} with invalid number of parameters (${Ds.length}) - expected (${Object.keys(j2.Za).toString()}) parameters instead!`);
          return q7.apply(this, Ds);
        });
        var _n = Object.create(st, { constructor: { value: n2 } });
        n2.prototype = _n;
        var j2 = new f1(P1, n2, _n, We, a2, J, a1, T1);
        if (j2.Ua) {
          var xn;
          (xn = j2.Ua).jb ?? (xn.jb = []), j2.Ua.jb.push(j2);
        }
        return a2 = new X1(P1, j2, !0, !1, !1), xn = new X1(P1 + "*", j2, !1, !1, !1), st = new X1(P1 + " const*", j2, !1, !0, !1), se[w] = { pointerType: xn, nb: st }, m1(H2, n2), [a2, xn, st];
      });
    }, t: (w, x, R, A, H, J) => {
      var c1 = v1(x, R);
      H = oe(A, H), D1([], [w], (a1) => {
        a1 = a1[0];
        var _1 = `constructor ${a1.name}`;
        if (a1.Qa.Za === void 0 && (a1.Qa.Za = []), a1.Qa.Za[x - 1] !== void 0) throw new w1(`Cannot register multiple constructors with identical number of parameters (${x - 1}) for class '${a1.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);
        return a1.Qa.Za[x - 1] = () => {
          $e(`Cannot construct ${a1.name} due to unbound types`, c1);
        }, D1([], c1, (T1) => (T1.splice(1, 0, null), a1.Qa.Za[x - 1] = U1(_1, T1, null, H, J), [])), [];
      });
    }, h: (w, x, R, A, H, J, c1, a1) => {
      var _1 = v1(R, A);
      x = q1(x), x = te(x), J = oe(H, J), D1([], [w], (T1) => {
        function P1() {
          $e(`Cannot call ${Q1} due to unbound types`, _1);
        }
        T1 = T1[0];
        var Q1 = `${T1.name}.${x}`;
        x.startsWith("@@") && (x = Symbol[x.substring(2)]), a1 && T1.Qa.xb.push(x);
        var We = T1.Qa.$a, H2 = We[x];
        return H2 === void 0 || H2.Sa === void 0 && H2.className !== T1.name && H2.ab === R - 2 ? (P1.ab = R - 2, P1.className = T1.name, We[x] = P1) : (pe(We, x, Q1), We[x].Sa[R - 2] = P1), D1([], _1, (n2) => (n2 = U1(Q1, n2, T1, J, c1), We[x].Sa === void 0 ? (n2.ab = R - 2, We[x] = n2) : We[x].Sa[R - 2] = n2, [])), [];
      });
    }, da: (w) => I1(w, it), y: (w, x, R, A) => {
      function H() {
      }
      x = q1(x), H.values = {}, I1(w, { name: x, constructor: H, fromWireType: function(J) {
        return this.constructor.values[J];
      }, toWireType: (J, c1) => c1.value, Wa: 8, readValueFromPointer: c0(x, R, A), Xa: null }), Ce(x, H);
    }, l: (w, x, R) => {
      var A = Ze(w, "enum");
      x = q1(x), w = A.constructor, A = Object.create(A.constructor.prototype, { value: { value: R }, constructor: { value: ve(`${A.name}_${x}`, function() {
      }) } }), w.values[R] = A, w[x] = A;
    }, E: (w, x, R) => {
      x = q1(x), I1(w, { name: x, fromWireType: (A) => A, toWireType: (A, H) => H, Wa: 8, readValueFromPointer: N0(x, R), Xa: null });
    }, v: (w, x, R, A, H, J) => {
      var c1 = v1(x, R);
      w = q1(w), w = te(w), H = oe(A, H), Ce(w, function() {
        $e(`Cannot call ${w} due to unbound types`, c1);
      }, x - 1), D1([], c1, (a1) => (m1(w, U1(w, [a1[0], null].concat(a1.slice(1)), null, H, J), x - 1), []));
    }, p: (w, x, R, A, H) => {
      if (x = q1(x), H === -1 && (H = 4294967295), H = (a1) => a1, A === 0) {
        var J = 32 - 8 * R;
        H = (a1) => a1 << J >>> J;
      }
      var c1 = x.includes("unsigned") ? function(a1, _1) {
        return _1 >>> 0;
      } : function(a1, _1) {
        return _1;
      };
      I1(w, { name: x, fromWireType: H, toWireType: c1, Wa: 8, readValueFromPointer: N1(x, R, A !== 0), Xa: null });
    }, k: (w, x, R) => {
      function A(J) {
        return new H(y.buffer, k[J + 4 >> 2], k[J >> 2]);
      }
      var H = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array][x];
      R = q1(R), I1(w, { name: R, fromWireType: A, Wa: 8, readValueFromPointer: A }, { vb: !0 });
    }, x: (w) => {
      I1(w, B1);
    }, la: (w, x, R, A, H, J, c1, a1, _1, T1, P1, Q1) => {
      R = q1(R), J = oe(H, J), a1 = oe(c1, a1), T1 = oe(_1, T1), Q1 = oe(P1, Q1), D1([w], [x], (We) => (We = We[0], [new X1(R, We.Qa, !1, !1, !0, We, A, J, a1, T1, Q1)]));
    }, ea: (w, x) => {
      x = q1(x), I1(w, { name: x, fromWireType: function(R) {
        for (var A = k[R >> 2], H = R + 4, J, c1 = H, a1 = 0; a1 <= A; ++a1) {
          var _1 = H + a1;
          (a1 == A || C[_1] == 0) && (c1 = c1 ? X(C, c1, _1 - c1) : "", J === void 0 ? J = c1 : (J += "\0", J += c1), c1 = _1 + 1);
        }
        return qt(R), J;
      }, toWireType: function(R, A) {
        A instanceof ArrayBuffer && (A = new Uint8Array(A));
        var H, J = typeof A == "string";
        if (!(J || A instanceof Uint8Array || A instanceof Uint8ClampedArray || A instanceof Int8Array)) throw new w1("Cannot pass non-string to std::string");
        if (J) for (var c1 = H = 0; c1 < A.length; ++c1) {
          var a1 = A.charCodeAt(c1);
          127 >= a1 ? H++ : 2047 >= a1 ? H += 2 : 55296 <= a1 && 57343 >= a1 ? (H += 4, ++c1) : H += 3;
        }
        else H = A.length;
        if (c1 = Ns(4 + H + 1), a1 = c1 + 4, k[c1 >> 2] = H, J) j(A, a1, H + 1);
        else if (J) for (J = 0; J < H; ++J) {
          var _1 = A.charCodeAt(J);
          if (255 < _1) throw qt(a1), new w1("String has UTF-16 code units that do not fit in 8 bits");
          C[a1 + J] = _1;
        }
        else for (J = 0; J < H; ++J) C[a1 + J] = A[J];
        return R !== null && R.push(qt, c1), c1;
      }, Wa: 8, readValueFromPointer: u1, Xa(R) {
        qt(R);
      } });
    }, A: (w, x, R) => {
      if (R = q1(R), x === 2) var A = be, H = de, J = Je, c1 = (a1) => M[a1 >> 1];
      else x === 4 && (A = De, H = Le, J = at, c1 = (a1) => k[a1 >> 2]);
      I1(w, { name: R, fromWireType: (a1) => {
        for (var _1 = k[a1 >> 2], T1, P1 = a1 + 4, Q1 = 0; Q1 <= _1; ++Q1) {
          var We = a1 + 4 + Q1 * x;
          (Q1 == _1 || c1(We) == 0) && (P1 = A(P1, We - P1), T1 === void 0 ? T1 = P1 : (T1 += "\0", T1 += P1), P1 = We + x);
        }
        return qt(a1), T1;
      }, toWireType: (a1, _1) => {
        if (typeof _1 != "string") throw new w1(`Cannot pass non-string to C++ string type ${R}`);
        var T1 = J(_1), P1 = Ns(4 + T1 + x);
        return k[P1 >> 2] = T1 / x, H(_1, P1 + 4, T1 + x), a1 !== null && a1.push(qt, P1), P1;
      }, Wa: 8, readValueFromPointer: u1, Xa(a1) {
        qt(a1);
      } });
    }, s: (w, x, R, A, H, J) => {
      t1[w] = { name: q1(x), ib: oe(R, A), Ya: oe(H, J), lb: [] };
    }, m: (w, x, R, A, H, J, c1, a1, _1, T1) => {
      t1[w].lb.push({ pb: q1(x), ub: R, sb: oe(A, H), tb: J, Ab: c1, zb: oe(a1, _1), Bb: T1 });
    }, ga: (w, x) => {
      x = q1(x), I1(w, { Db: !0, name: x, Wa: 0, fromWireType: () => {
      }, toWireType: () => {
      } });
    }, O: () => {
      o1 = !1, Ct = 0;
    }, I: () => {
      throw 1 / 0;
    }, F: (w, x, R) => (w = je(w), x = Ze(x, "emval::as"), W2(x, R, w)), ja: (w, x, R, A) => (w = V2[w], x = je(x), w(null, x, R, A)), M: Qe, ia: (w, x, R) => {
      var A = u0(w, x), H = A.shift();
      w--;
      var J = Array(w);
      return x = `methodCaller<(${A.map((c1) => c1.name).join(", ")}) => ${H.name}>`, C2(ve(x, (c1, a1, _1, T1) => {
        for (var P1 = 0, Q1 = 0; Q1 < w; ++Q1) J[Q1] = A[Q1].readValueFromPointer(T1 + P1), P1 += A[Q1].Wa;
        return c1 = R === 1 ? L1(a1, J) : a1.apply(c1, J), W2(H, _1, c1);
      }));
    }, ka: (w) => {
      9 < w && (ke[w + 1] += 1);
    }, ha: (w) => {
      var x = je(w);
      T(x), Qe(w);
    }, r: (w, x) => (w = Ze(w, "_emval_take_value"), w = w.readValueFromPointer(x), we(w)), K: (w, x) => {
      if (w2[w] && (clearTimeout(w2[w].id), delete w2[w]), !x) return 0;
      var R = setTimeout(() => {
        delete w2[w], jt(() => W7(w, performance.now()));
      }, x);
      return w2[w] = { id: R, Eb: x }, 0;
    }, L: (w, x, R, A) => {
      var H = (/* @__PURE__ */ new Date()).getFullYear(), J = new Date(H, 0, 1).getTimezoneOffset();
      H = new Date(H, 6, 1).getTimezoneOffset(), k[w >> 2] = 60 * Math.max(J, H), S[x >> 2] = +(J != H), x = (c1) => {
        var a1 = Math.abs(c1);
        return `UTC${0 <= c1 ? "-" : "+"}${String(Math.floor(a1 / 60)).padStart(2, "0")}${String(a1 % 60).padStart(2, "0")}`;
      }, w = x(J), x = x(H), H < J ? (j(w, R, 17), j(x, A, 17)) : (j(w, A, 17), j(x, R, 17));
    }, ca: () => performance.now(), N: (w) => {
      var x = C.length;
      if (w >>>= 0, 2147483648 < w) return !1;
      for (var R = 1; 4 >= R; R *= 2) {
        var A = x * (1 + 0.2 / R);
        A = Math.min(A, w + 100663296);
        e: {
          A = (Math.min(2147483648, 65536 * Math.ceil(Math.max(w, A) / 65536)) - g.buffer.byteLength + 65535) / 65536 | 0;
          try {
            g.grow(A), I();
            var H = 1;
            break e;
          } catch {
          }
          H = void 0;
        }
        if (H) return !0;
      }
      return !1;
    }, Z: (w, x) => {
      var R = 0;
      return D7().forEach((A, H) => {
        var J = x + R;
        for (H = k[w + 4 * H >> 2] = J, J = 0; J < A.length; ++J) y[H++] = A.charCodeAt(J);
        y[H] = 0, R += A.length + 1;
      }), 0;
    }, _: (w, x) => {
      var R = D7();
      k[w >> 2] = R.length;
      var A = 0;
      return R.forEach((H) => A += H.length + 1), k[x >> 2] = A, 0;
    }, W: () => 52, U: () => 52, B: (w, x, R, A) => {
      for (var H = 0, J = 0; J < R; J++) {
        var c1 = k[x >> 2], a1 = k[x + 4 >> 2];
        x += 8;
        for (var _1 = 0; _1 < a1; _1++) {
          var T1 = w, P1 = C[c1 + _1], Q1 = sE[T1];
          P1 === 0 || P1 === 10 ? ((T1 === 1 ? u : h)(X(Q1)), Q1.length = 0) : Q1.push(P1);
        }
        H += a1;
      }
      return k[A >> 2] = H, 0;
    }, $: xE, aa: _E, J: SE, j: pE, i: CE, g: yE, ba: dE, z: wE, C: bE, D: gE, a: uE, b: fE, f: hE, o: vE, q: mE, G: ME, Y: O2, P: (w, x) => (B7(C.subarray(w, w + x)), 0) }, Pe;
    (async function() {
      function w(A) {
        return Pe = A.exports, g = Pe.ma, I(), M1 = Pe.ra, E.unshift(Pe.na), F--, r.monitorRunDependencies?.(F), F == 0 && z && (A = z, z = null, A()), Pe;
      }
      F++, r.monitorRunDependencies?.(F);
      var x = { a: cE };
      if (r.instantiateWasm) try {
        return r.instantiateWasm(x, w);
      } catch (A) {
        h(`Module.instantiateWasm callback failed with error: ${A}`), i(A);
      }
      U ?? (U = Z("DotLottiePlayer.wasm") ? "DotLottiePlayer.wasm" : r.locateFile ? r.locateFile("DotLottiePlayer.wasm", c) : c + "DotLottiePlayer.wasm");
      try {
        var R = await K(x);
        return w(R.instance), R;
      } catch (A) {
        i(A);
      }
    })();
    var Ns = (w) => (Ns = Pe.oa)(w), $7 = (w) => ($7 = Pe.pa)(w), qt = (w) => (qt = Pe.qa)(w), W7 = (w, x) => (W7 = Pe.sa)(w, x), v2 = (w, x) => (v2 = Pe.ta)(w, x), wn = (w) => (wn = Pe.ua)(w), b2 = (w) => (b2 = Pe.va)(w), y2 = () => (y2 = Pe.wa)(), V7 = (w, x, R) => (V7 = Pe.xa)(w, x, R);
    r.dynCall_iijj = (w, x, R, A, H, J) => (r.dynCall_iijj = Pe.ya)(w, x, R, A, H, J), r.dynCall_vijj = (w, x, R, A, H, J) => (r.dynCall_vijj = Pe.za)(w, x, R, A, H, J), r.dynCall_jiii = (w, x, R, A) => (r.dynCall_jiii = Pe.Aa)(w, x, R, A);
    var H7 = r.dynCall_vijjjj = (w, x, R, A, H, J, c1, a1, _1, T1) => (H7 = r.dynCall_vijjjj = Pe.Ba)(w, x, R, A, H, J, c1, a1, _1, T1);
    r.dynCall_jii = (w, x, R) => (r.dynCall_jii = Pe.Ca)(w, x, R), r.dynCall_vjii = (w, x, R, A, H) => (r.dynCall_vjii = Pe.Da)(w, x, R, A, H), r.dynCall_vjfii = (w, x, R, A, H, J) => (r.dynCall_vjfii = Pe.Ea)(w, x, R, A, H, J), r.dynCall_vjiii = (w, x, R, A, H, J) => (r.dynCall_vjiii = Pe.Fa)(w, x, R, A, H, J), r.dynCall_vj = (w, x, R) => (r.dynCall_vj = Pe.Ga)(w, x, R), r.dynCall_vjiiiii = (w, x, R, A, H, J, c1, a1) => (r.dynCall_vjiiiii = Pe.Ha)(w, x, R, A, H, J, c1, a1), r.dynCall_vjiffii = (w, x, R, A, H, J, c1, a1) => (r.dynCall_vjiffii = Pe.Ia)(w, x, R, A, H, J, c1, a1), r.dynCall_vjiiii = (w, x, R, A, H, J, c1) => (r.dynCall_vjiiii = Pe.Ja)(w, x, R, A, H, J, c1), r.dynCall_viijii = (w, x, R, A, H, J, c1) => (r.dynCall_viijii = Pe.Ka)(w, x, R, A, H, J, c1), r.dynCall_iiiiij = (w, x, R, A, H, J, c1) => (r.dynCall_iiiiij = Pe.La)(w, x, R, A, H, J, c1), r.dynCall_iiiiijj = (w, x, R, A, H, J, c1, a1, _1) => (r.dynCall_iiiiijj = Pe.Ma)(w, x, R, A, H, J, c1, a1, _1), r.dynCall_iiiiiijj = (w, x, R, A, H, J, c1, a1, _1, T1) => (r.dynCall_iiiiiijj = Pe.Na)(w, x, R, A, H, J, c1, a1, _1, T1);
    function uE(w, x) {
      var R = y2();
      try {
        M1.get(w)(x);
      } catch (A) {
        if (b2(R), A !== A + 0) throw A;
        v2(1, 0);
      }
    }
    function dE(w, x, R, A, H) {
      var J = y2();
      try {
        return M1.get(w)(x, R, A, H);
      } catch (c1) {
        if (b2(J), c1 !== c1 + 0) throw c1;
        v2(1, 0);
      }
    }
    function fE(w, x, R) {
      var A = y2();
      try {
        M1.get(w)(x, R);
      } catch (H) {
        if (b2(A), H !== H + 0) throw H;
        v2(1, 0);
      }
    }
    function hE(w, x, R, A) {
      var H = y2();
      try {
        M1.get(w)(x, R, A);
      } catch (J) {
        if (b2(H), J !== J + 0) throw J;
        v2(1, 0);
      }
    }
    function pE(w, x) {
      var R = y2();
      try {
        return M1.get(w)(x);
      } catch (A) {
        if (b2(R), A !== A + 0) throw A;
        v2(1, 0);
      }
    }
    function mE(w, x, R, A, H, J) {
      var c1 = y2();
      try {
        M1.get(w)(x, R, A, H, J);
      } catch (a1) {
        if (b2(c1), a1 !== a1 + 0) throw a1;
        v2(1, 0);
      }
    }
    function gE(w) {
      var x = y2();
      try {
        M1.get(w)();
      } catch (R) {
        if (b2(x), R !== R + 0) throw R;
        v2(1, 0);
      }
    }
    function vE(w, x, R, A, H) {
      var J = y2();
      try {
        M1.get(w)(x, R, A, H);
      } catch (c1) {
        if (b2(J), c1 !== c1 + 0) throw c1;
        v2(1, 0);
      }
    }
    function bE(w, x, R, A, H, J, c1, a1) {
      var _1 = y2();
      try {
        return M1.get(w)(x, R, A, H, J, c1, a1);
      } catch (T1) {
        if (b2(_1), T1 !== T1 + 0) throw T1;
        v2(1, 0);
      }
    }
    function yE(w, x, R, A) {
      var H = y2();
      try {
        return M1.get(w)(x, R, A);
      } catch (J) {
        if (b2(H), J !== J + 0) throw J;
        v2(1, 0);
      }
    }
    function CE(w, x, R) {
      var A = y2();
      try {
        return M1.get(w)(x, R);
      } catch (H) {
        if (b2(A), H !== H + 0) throw H;
        v2(1, 0);
      }
    }
    function wE(w, x, R, A, H, J) {
      var c1 = y2();
      try {
        return M1.get(w)(x, R, A, H, J);
      } catch (a1) {
        if (b2(c1), a1 !== a1 + 0) throw a1;
        v2(1, 0);
      }
    }
    function _E(w, x, R, A) {
      var H = y2();
      try {
        return M1.get(w)(x, R, A);
      } catch (J) {
        if (b2(H), J !== J + 0) throw J;
        v2(1, 0);
      }
    }
    function xE(w, x) {
      var R = y2();
      try {
        return M1.get(w)(x);
      } catch (A) {
        if (b2(R), A !== A + 0) throw A;
        v2(1, 0);
      }
    }
    function SE(w, x, R) {
      var A = y2();
      try {
        return M1.get(w)(x, R);
      } catch (H) {
        if (b2(A), H !== H + 0) throw H;
        v2(1, 0);
      }
    }
    function ME(w, x, R, A, H, J, c1, a1, _1, T1) {
      var P1 = y2();
      try {
        H7(w, x, R, A, H, J, c1, a1, _1, T1);
      } catch (Q1) {
        if (b2(P1), Q1 !== Q1 + 0) throw Q1;
        v2(1, 0);
      }
    }
    var mo;
    z = function w() {
      mo || j7(), mo || (z = w);
    };
    function j7() {
      function w() {
        if (!mo && (mo = !0, r.calledRun = !0, !m)) {
          if (n1(E), o(r), r.onRuntimeInitialized?.(), r.postRun) for (typeof r.postRun == "function" && (r.postRun = [r.postRun]); r.postRun.length; ) {
            var x = r.postRun.shift();
            B.unshift(x);
          }
          n1(B);
        }
      }
      if (!(0 < F)) {
        if (r.preRun) for (typeof r.preRun == "function" && (r.preRun = [r.preRun]); r.preRun.length; ) W();
        n1(O), 0 < F || (r.setStatus ? (r.setStatus("Running..."), setTimeout(() => {
          setTimeout(() => r.setStatus(""), 1), w();
        }, 1)) : w());
      }
    }
    if (r.preInit) for (typeof r.preInit == "function" && (r.preInit = [r.preInit]); 0 < r.preInit.length; ) r.preInit.pop()();
    return j7(), n = a, n;
  };
})(), vJ = gJ, Ri = class {
  constructor() {
    throw new Error("RendererLoader is a static class and cannot be instantiated.");
  }
  static async _tryLoad(e) {
    return await vJ({ locateFile: () => e });
  }
  static async _loadWithBackup() {
    return this._ModulePromise || (this._ModulePromise = this._tryLoad(this._wasmURL).catch(async (e) => {
      let t = `https://unpkg.com/${bL}@${vL}/dist/dotlottie-player.wasm`;
      console.warn(`Primary WASM load failed from ${this._wasmURL}. Error: ${e.message}`), console.warn(`Attempting to load WASM from backup URL: ${t}`);
      try {
        return await this._tryLoad(t);
      } catch (n) {
        throw console.error(`Primary WASM URL failed: ${e.message}`), console.error(`Backup WASM URL failed: ${n.message}`), new Error("WASM loading failed from all sources.");
      }
    })), this._ModulePromise;
  }
  static async load() {
    return this._loadWithBackup();
  }
  static setWasmUrl(e) {
    e !== this._wasmURL && (this._wasmURL = e, this._ModulePromise = null);
  }
};
Z1(Ri, "_ModulePromise", null), Z1(Ri, "_wasmURL", `https://cdn.jsdelivr.net/npm/${bL}@${vL}/dist/dotlottie-player.wasm`);
var yL = class {
  constructor() {
    Z1(this, "_eventListeners", /* @__PURE__ */ new Map());
  }
  addEventListener(e, t) {
    let n = this._eventListeners.get(e);
    n || (n = /* @__PURE__ */ new Set(), this._eventListeners.set(e, n)), n.add(t);
  }
  removeEventListener(e, t) {
    let n = this._eventListeners.get(e);
    n && (t ? (n.delete(t), n.size === 0 && this._eventListeners.delete(e)) : this._eventListeners.delete(e));
  }
  dispatch(e) {
    this._eventListeners.get(e.type)?.forEach((t) => t(e));
  }
  removeAllEventListeners() {
    this._eventListeners.clear();
  }
}, Mt = class {
  static _initializeObserver() {
    if (this._observer) return;
    let e = (t) => {
      t.forEach((n) => {
        let r = this._observedCanvases.get(n.target);
        r && (n.isIntersecting ? r.unfreeze() : r.freeze());
      });
    };
    this._observer = new IntersectionObserver(e, { threshold: 0 });
  }
  static observe(e, t) {
    this._initializeObserver(), !this._observedCanvases.has(e) && (this._observedCanvases.set(e, t), this._observer?.observe(e));
  }
  static unobserve(e) {
    this._observer?.unobserve(e), this._observedCanvases.delete(e), this._observedCanvases.size === 0 && (this._observer?.disconnect(), this._observer = null);
  }
};
Z1(Mt, "_observer", null), Z1(Mt, "_observedCanvases", /* @__PURE__ */ new Map());
var kt = class {
  static _initializeObserver() {
    if (this._observer) return;
    let e = (t) => {
      t.forEach((n) => {
        let r = this._observedCanvases.get(n.target);
        if (!r) return;
        let [o, i] = r;
        clearTimeout(i);
        let a = setTimeout(() => {
          o.resize();
        }, 100);
        this._observedCanvases.set(n.target, [o, a]);
      });
    };
    this._observer = new ResizeObserver(e);
  }
  static observe(e, t) {
    this._initializeObserver(), !this._observedCanvases.has(e) && (this._observedCanvases.set(e, [t, 0]), this._observer?.observe(e));
  }
  static unobserve(e) {
    let t = this._observedCanvases.get(e);
    if (t) {
      let n = t[1];
      n && clearTimeout(n);
    }
    this._observer?.unobserve(e), this._observedCanvases.delete(e), !this._observedCanvases.size && this._observer && (this._observer.disconnect(), this._observer = null);
  }
};
Z1(kt, "_observer", null), Z1(kt, "_observedCanvases", /* @__PURE__ */ new Map());
function bJ(e) {
  return /^#([\da-f]{6}|[\da-f]{8})$/iu.test(e);
}
function yJ(e) {
  if (!bJ(e)) return 0;
  let t = e.replace("#", "");
  return t = t.length === 6 ? `${t}ff` : t, parseInt(t, 16);
}
function Ev(e) {
  if (e.byteLength < 4) return !1;
  let t = new Uint8Array(e.slice(0, C6.byteLength));
  for (let n = 0; n < C6.length; n += 1) if (C6[n] !== t[n]) return !1;
  return !0;
}
function Tv(e) {
  return hJ.every((t) => Object.prototype.hasOwnProperty.call(e, t));
}
function Rv(e) {
  if (typeof e == "string") try {
    return Tv(JSON.parse(e));
  } catch {
    return !1;
  }
  else return Tv(e);
}
function V0() {
  return 1 + ((M2 ? window.devicePixelRatio : 1) - 1) * pJ;
}
function CL(e) {
  let t = e.getBoundingClientRect();
  return t.top >= 0 && t.left >= 0 && t.bottom <= (window.innerHeight || document.documentElement.clientHeight) && t.right <= (window.innerWidth || document.documentElement.clientWidth);
}
var w6 = (e, t) => e === "reverse" ? t.Mode.Reverse : e === "bounce" ? t.Mode.Bounce : e === "reverse-bounce" ? t.Mode.ReverseBounce : t.Mode.Forward, CJ = (e, t) => e === "contain" ? t.Fit.Contain : e === "cover" ? t.Fit.Cover : e === "fill" ? t.Fit.Fill : e === "fit-height" ? t.Fit.FitHeight : e === "fit-width" ? t.Fit.FitWidth : t.Fit.None, wJ = (e, t) => {
  let n = new t.VectorFloat();
  return n.push_back(e[0]), n.push_back(e[1]), n;
}, _6 = (e, t) => {
  let n = new t.VectorFloat();
  return e.length !== 2 || (n.push_back(e[0]), n.push_back(e[1])), n;
}, x6 = (e, t) => e ? { align: wJ(e.align ?? [0.5, 0.5], t), fit: CJ(e.fit ?? "contain", t) } : t.createDefaultLayout(), wL = class Ge {
  constructor(t) {
    Z1(this, "_canvas"), Z1(this, "_context", null), Z1(this, "_eventManager"), Z1(this, "_animationFrameId", null), Z1(this, "_frameManager"), Z1(this, "_dotLottieCore", null), Z1(this, "_renderConfig", {}), Z1(this, "_isFrozen", !1), Z1(this, "_backgroundColor", null), Z1(this, "_pointerUpMethod"), Z1(this, "_pointerDownMethod"), Z1(this, "_pointerMoveMethod"), Z1(this, "_pointerEnterMethod"), Z1(this, "_pointerExitMethod"), this._canvas = t.canvas, this._eventManager = new yL(), this._frameManager = new fJ(), this._renderConfig = { ...t.renderConfig, devicePixelRatio: t.renderConfig?.devicePixelRatio || V0(), freezeOnOffscreen: t.renderConfig?.freezeOnOffscreen ?? !0 }, Ri.load().then((n) => {
      Ge._wasmModule = n, this._dotLottieCore = new n.DotLottiePlayer({ animationId: t.animationId ?? "", themeId: t.themeId ?? "", stateMachineId: "", autoplay: t.autoplay ?? !1, backgroundColor: 0, loopAnimation: t.loop ?? !1, mode: w6(t.mode ?? "forward", n), segment: _6(t.segment ?? [], n), speed: t.speed ?? 1, useFrameInterpolation: t.useFrameInterpolation ?? !0, marker: t.marker ?? "", layout: x6(t.layout, n) }), this._eventManager.dispatch({ type: "ready" }), t.data ? this._loadFromData(t.data) : t.src && this._loadFromSrc(t.src), t.backgroundColor && this.setBackgroundColor(t.backgroundColor);
    }).catch((n) => {
      this._eventManager.dispatch({ type: "loadError", error: new Error(`Failed to load wasm module: ${n}`) });
    }), this._pointerUpMethod = this._onPointerUp.bind(this), this._pointerDownMethod = this._onPointerDown.bind(this), this._pointerMoveMethod = this._onPointerMove.bind(this), this._pointerEnterMethod = this._onPointerEnter.bind(this), this._pointerExitMethod = this._onPointerLeave.bind(this);
  }
  _dispatchError(t) {
    console.error(t), this._eventManager.dispatch({ type: "loadError", error: new Error(t) });
  }
  async _fetchData(t) {
    let n = await fetch(t);
    if (!n.ok) throw new Error(`Failed to fetch animation data from URL: ${t}. ${n.status}: ${n.statusText}`);
    let r = await n.arrayBuffer();
    return Ev(r) ? r : new TextDecoder().decode(r);
  }
  _loadFromData(t) {
    if (this._dotLottieCore === null) return;
    let n = this._canvas.width, r = this._canvas.height, o = !1;
    if (typeof t == "string") {
      if (!Rv(t)) {
        this._dispatchError("Invalid Lottie JSON string: The provided string does not conform to the Lottie JSON format.");
        return;
      }
      o = this._dotLottieCore.loadAnimationData(t, n, r);
    } else if (t instanceof ArrayBuffer) {
      if (!Ev(t)) {
        this._dispatchError("Invalid dotLottie ArrayBuffer: The provided ArrayBuffer does not conform to the dotLottie format.");
        return;
      }
      o = this._dotLottieCore.loadDotLottieData(t, n, r);
    } else if (typeof t == "object") {
      if (!Rv(t)) {
        this._dispatchError("Invalid Lottie JSON object: The provided object does not conform to the Lottie JSON format.");
        return;
      }
      o = this._dotLottieCore.loadAnimationData(JSON.stringify(t), n, r);
    } else {
      this._dispatchError(`Unsupported data type for animation data. Expected: 
          - string (Lottie JSON),
          - ArrayBuffer (dotLottie),
          - object (Lottie JSON). 
          Received: ${typeof t}`);
      return;
    }
    o ? (this._eventManager.dispatch({ type: "load" }), M2 && this.resize(), this._eventManager.dispatch({ type: "frame", currentFrame: this.currentFrame }), this._render(), this._dotLottieCore.config().autoplay && (this._dotLottieCore.play(), this._dotLottieCore.isPlaying() ? (this._eventManager.dispatch({ type: "play" }), this._animationFrameId = this._frameManager.requestAnimationFrame(this._draw.bind(this))) : console.error("something went wrong, the animation was suppose to autoplay")), M2 && this._canvas instanceof HTMLCanvasElement && (this._renderConfig.freezeOnOffscreen && Mt.observe(this._canvas, this), this._renderConfig.autoResize && kt.observe(this._canvas, this))) : this._dispatchError("Failed to load animation data");
  }
  _loadFromSrc(t) {
    this._fetchData(t).then((n) => this._loadFromData(n)).catch((n) => this._dispatchError(`Failed to load animation data from URL: ${t}. ${n}`));
  }
  get buffer() {
    return this._dotLottieCore ? this._dotLottieCore.buffer() : null;
  }
  get activeAnimationId() {
    return this._dotLottieCore?.activeAnimationId();
  }
  get activeThemeId() {
    return this._dotLottieCore?.activeThemeId();
  }
  get layout() {
    let t = this._dotLottieCore?.config().layout;
    if (t) return { align: [t.align.get(0), t.align.get(1)], fit: (() => {
      switch (t.fit) {
        case Ge._wasmModule?.Fit.Contain:
          return "contain";
        case Ge._wasmModule?.Fit.Cover:
          return "cover";
        case Ge._wasmModule?.Fit.Fill:
          return "fill";
        case Ge._wasmModule?.Fit.FitHeight:
          return "fit-height";
        case Ge._wasmModule?.Fit.FitWidth:
          return "fit-width";
        case Ge._wasmModule?.Fit.None:
          return "none";
        default:
          return "contain";
      }
    })() };
  }
  get marker() {
    return this._dotLottieCore?.config().marker;
  }
  get manifest() {
    try {
      let t = this._dotLottieCore?.manifestString();
      if (this._dotLottieCore === null || !t) return null;
      let n = JSON.parse(t);
      return Object.keys(n).length === 0 ? null : n;
    } catch {
      return null;
    }
  }
  get renderConfig() {
    return this._renderConfig;
  }
  get segment() {
    let t = this._dotLottieCore?.config().segment;
    if (t && t.size() === 2) return [t.get(0), t.get(1)];
  }
  get loop() {
    return this._dotLottieCore?.config().loopAnimation ?? !1;
  }
  get mode() {
    let t = this._dotLottieCore?.config().mode;
    return t === Ge._wasmModule?.Mode.Reverse ? "reverse" : t === Ge._wasmModule?.Mode.Bounce ? "bounce" : t === Ge._wasmModule?.Mode.ReverseBounce ? "reverse-bounce" : "forward";
  }
  get isFrozen() {
    return this._isFrozen;
  }
  get backgroundColor() {
    return this._backgroundColor ?? "";
  }
  get autoplay() {
    return this._dotLottieCore?.config().autoplay ?? !1;
  }
  get useFrameInterpolation() {
    return this._dotLottieCore?.config().useFrameInterpolation ?? !1;
  }
  get speed() {
    return this._dotLottieCore?.config().speed ?? 0;
  }
  get isReady() {
    return this._dotLottieCore !== null;
  }
  get isLoaded() {
    return this._dotLottieCore?.isLoaded() ?? !1;
  }
  get isPlaying() {
    return this._dotLottieCore?.isPlaying() ?? !1;
  }
  get isPaused() {
    return this._dotLottieCore?.isPaused() ?? !1;
  }
  get isStopped() {
    return this._dotLottieCore?.isStopped() ?? !1;
  }
  get currentFrame() {
    return this._dotLottieCore ? Math.round(this._dotLottieCore.currentFrame() * 100) / 100 : 0;
  }
  get loopCount() {
    return this._dotLottieCore?.loopCount() ?? 0;
  }
  get totalFrames() {
    return this._dotLottieCore?.totalFrames() ?? 0;
  }
  get duration() {
    return this._dotLottieCore?.duration() ?? 0;
  }
  get segmentDuration() {
    return this._dotLottieCore?.segmentDuration() ?? 0;
  }
  get canvas() {
    return this._canvas;
  }
  load(t) {
    this._dotLottieCore === null || Ge._wasmModule === null || (this._animationFrameId !== null && (this._frameManager.cancelAnimationFrame(this._animationFrameId), this._animationFrameId = null), this._isFrozen = !1, this._dotLottieCore.setConfig({ animationId: t.animationId ?? "", themeId: t.themeId ?? "", stateMachineId: "", autoplay: t.autoplay ?? !1, backgroundColor: 0, loopAnimation: t.loop ?? !1, mode: w6(t.mode ?? "forward", Ge._wasmModule), segment: _6(t.segment ?? [], Ge._wasmModule), speed: t.speed ?? 1, useFrameInterpolation: t.useFrameInterpolation ?? !0, marker: t.marker ?? "", layout: x6(t.layout, Ge._wasmModule) }), t.data ? this._loadFromData(t.data) : t.src && this._loadFromSrc(t.src), this.setBackgroundColor(t.backgroundColor ?? ""));
  }
  _render() {
    if (this._dotLottieCore === null) return !1;
    if (!this._context && "getContext" in this._canvas && typeof this._canvas.getContext == "function" && (this._context = this._canvas.getContext("2d")), this._dotLottieCore.render()) {
      if (this._context) {
        let t = this._dotLottieCore.buffer(), n = this._canvas.width * this._canvas.height * mJ;
        if (t.byteLength !== n) return console.warn(`Buffer size mismatch: got ${t.byteLength}, expected ${n}`), !1;
        let r = null, o = new Uint8ClampedArray(t, 0, t.byteLength);
        typeof ImageData > "u" ? (r = this._context.createImageData(this._canvas.width, this._canvas.height), r.data.set(o)) : r = new ImageData(o, this._canvas.width, this._canvas.height), this._context.putImageData(r, 0, 0);
      }
      return this._eventManager.dispatch({ type: "render", currentFrame: this.currentFrame }), !0;
    }
    return !1;
  }
  _draw() {
    if (!(this._dotLottieCore === null || !this._dotLottieCore.isPlaying())) try {
      let t = Math.round(this._dotLottieCore.requestFrame() * 1e3) / 1e3;
      if (this._dotLottieCore.setFrame(t) && (this._eventManager.dispatch({ type: "frame", currentFrame: this.currentFrame }), this._render() && this._dotLottieCore.isComplete())) if (this._dotLottieCore.config().loopAnimation) this._eventManager.dispatch({ type: "loop", loopCount: this._dotLottieCore.loopCount() });
      else {
        this._eventManager.dispatch({ type: "complete" });
        return;
      }
      this._animationFrameId = this._frameManager.requestAnimationFrame(this._draw.bind(this));
    } catch (t) {
      console.error("Error in animation frame:", t), this._eventManager.dispatch({ type: "renderError", error: t }), t instanceof WebAssembly.RuntimeError && this.destroy();
    }
  }
  play() {
    this._dotLottieCore !== null && (this._animationFrameId !== null && (this._frameManager.cancelAnimationFrame(this._animationFrameId), this._animationFrameId = null), (this._dotLottieCore.play() || this._dotLottieCore.isPlaying()) && (this._isFrozen = !1, this._eventManager.dispatch({ type: "play" }), this._animationFrameId = this._frameManager.requestAnimationFrame(this._draw.bind(this))), M2 && this._canvas instanceof HTMLCanvasElement && this._renderConfig.freezeOnOffscreen && !CL(this._canvas) && this.freeze());
  }
  pause() {
    this._dotLottieCore !== null && (this._dotLottieCore.pause() || this._dotLottieCore.isPaused()) && this._eventManager.dispatch({ type: "pause" });
  }
  stop() {
    this._dotLottieCore !== null && this._dotLottieCore.stop() && (this._eventManager.dispatch({ type: "frame", currentFrame: this.currentFrame }), this._render(), this._eventManager.dispatch({ type: "stop" }));
  }
  setFrame(t) {
    this._dotLottieCore === null || t < 0 || t > this._dotLottieCore.totalFrames() || this._dotLottieCore.seek(t) && (this._eventManager.dispatch({ type: "frame", currentFrame: this.currentFrame }), this._render());
  }
  setSpeed(t) {
    this._dotLottieCore !== null && this._dotLottieCore.setConfig({ ...this._dotLottieCore.config(), speed: t });
  }
  setBackgroundColor(t) {
    this._dotLottieCore !== null && (M2 && this._canvas instanceof HTMLCanvasElement ? this._canvas.style.backgroundColor = t : this._dotLottieCore.setConfig({ ...this._dotLottieCore.config(), backgroundColor: yJ(t) }), this._backgroundColor = t);
  }
  setLoop(t) {
    this._dotLottieCore !== null && this._dotLottieCore.setConfig({ ...this._dotLottieCore.config(), loopAnimation: t });
  }
  setUseFrameInterpolation(t) {
    this._dotLottieCore !== null && this._dotLottieCore.setConfig({ ...this._dotLottieCore.config(), useFrameInterpolation: t });
  }
  addEventListener(t, n) {
    this._eventManager.addEventListener(t, n);
  }
  removeEventListener(t, n) {
    this._eventManager.removeEventListener(t, n);
  }
  destroy() {
    this._animationFrameId !== null && (this._frameManager.cancelAnimationFrame(this._animationFrameId), this._animationFrameId = null), M2 && this._canvas instanceof HTMLCanvasElement && (Mt.unobserve(this._canvas), kt.unobserve(this._canvas)), this._dotLottieCore?.delete(), this._dotLottieCore = null, this._context = null, this._eventManager.dispatch({ type: "destroy" }), this._eventManager.removeAllEventListeners(), this._cleanupStateMachineListeners();
  }
  freeze() {
    this._animationFrameId !== null && (this._frameManager.cancelAnimationFrame(this._animationFrameId), this._animationFrameId = null, this._isFrozen = !0, this._eventManager.dispatch({ type: "freeze" }));
  }
  unfreeze() {
    this._animationFrameId === null && (this._animationFrameId = this._frameManager.requestAnimationFrame(this._draw.bind(this)), this._isFrozen = !1, this._eventManager.dispatch({ type: "unfreeze" }));
  }
  resize() {
    if (!(!this._dotLottieCore || !this.isLoaded)) {
      if (M2 && this._canvas instanceof HTMLCanvasElement) {
        let t = this._renderConfig.devicePixelRatio || window.devicePixelRatio || 1, { height: n, width: r } = this._canvas.getBoundingClientRect();
        n !== 0 && r !== 0 && (this._canvas.width = r * t, this._canvas.height = n * t);
      }
      this._dotLottieCore.resize(this._canvas.width, this._canvas.height) && this._render();
    }
  }
  setSegment(t, n) {
    this._dotLottieCore === null || Ge._wasmModule === null || this._dotLottieCore.setConfig({ ...this._dotLottieCore.config(), segment: _6([t, n], Ge._wasmModule) });
  }
  setMode(t) {
    this._dotLottieCore === null || Ge._wasmModule === null || this._dotLottieCore.setConfig({ ...this._dotLottieCore.config(), mode: w6(t, Ge._wasmModule) });
  }
  setRenderConfig(t) {
    let { devicePixelRatio: n, freezeOnOffscreen: r, ...o } = t;
    this._renderConfig = { ...this._renderConfig, ...o, devicePixelRatio: n || V0(), freezeOnOffscreen: r ?? !0 }, M2 && this._canvas instanceof HTMLCanvasElement && (this._renderConfig.autoResize ? kt.observe(this._canvas, this) : kt.unobserve(this._canvas), this._renderConfig.freezeOnOffscreen ? Mt.observe(this._canvas, this) : (Mt.unobserve(this._canvas), this._isFrozen && this.unfreeze()));
  }
  loadAnimation(t) {
    this._dotLottieCore === null || this._dotLottieCore.activeAnimationId() === t || (this._dotLottieCore.loadAnimation(t, this._canvas.width, this._canvas.height) ? (this._eventManager.dispatch({ type: "load" }), this.resize()) : this._eventManager.dispatch({ type: "loadError", error: new Error(`Failed to animation :${t}`) }));
  }
  setMarker(t) {
    this._dotLottieCore !== null && this._dotLottieCore.setConfig({ ...this._dotLottieCore.config(), marker: t });
  }
  markers() {
    let t = this._dotLottieCore?.markers();
    if (t) {
      let n = [];
      for (let r = 0; r < t.size(); r += 1) {
        let o = t.get(r);
        n.push({ name: o.name, time: o.time, duration: o.duration });
      }
      return n;
    }
    return [];
  }
  setTheme(t) {
    if (this._dotLottieCore === null) return !1;
    let n = this._dotLottieCore.setTheme(t);
    return this._render(), n;
  }
  resetTheme() {
    return this._dotLottieCore === null ? !1 : this._dotLottieCore.resetTheme();
  }
  setThemeData(t) {
    if (this._dotLottieCore === null) return !1;
    let n = this._dotLottieCore.setThemeData(t);
    return this._render(), n;
  }
  setSlots(t) {
    this._dotLottieCore !== null && this._dotLottieCore.setSlots(t);
  }
  setLayout(t) {
    this._dotLottieCore === null || Ge._wasmModule === null || this._dotLottieCore.setConfig({ ...this._dotLottieCore.config(), layout: x6(t, Ge._wasmModule) });
  }
  setViewport(t, n, r, o) {
    return this._dotLottieCore === null ? !1 : this._dotLottieCore.setViewport(t, n, r, o);
  }
  static setWasmUrl(t) {
    Ri.setWasmUrl(t);
  }
  loadStateMachine(t) {
    return this._dotLottieCore?.stateMachineLoad(t) ?? !1;
  }
  startStateMachine() {
    if (Ge._wasmModule === null || this._dotLottieCore === null) return !1;
    let t = Ge._wasmModule.createDefaultOpenURL(), n = this._dotLottieCore.stateMachineStart(t);
    return n && this._setupStateMachineListeners(), n;
  }
  stopStateMachine() {
    let t = this._dotLottieCore?.stateMachineStop() ?? !1;
    return t && this._cleanupStateMachineListeners(), t;
  }
  _getPointerPosition(t) {
    let n = this._canvas.getBoundingClientRect(), r = this._canvas.width / n.width, o = this._canvas.height / n.height, i = this._renderConfig.devicePixelRatio || window.devicePixelRatio || 1, a = (t.clientX - n.left) * r / i, s = (t.clientY - n.top) * o / i;
    return { x: a, y: s };
  }
  _onPointerUp(t) {
    let { x: n, y: r } = this._getPointerPosition(t);
    this.postPointerUpEvent(n, r);
  }
  _onPointerDown(t) {
    let { x: n, y: r } = this._getPointerPosition(t);
    this.postPointerDownEvent(n, r);
  }
  _onPointerMove(t) {
    let { x: n, y: r } = this._getPointerPosition(t);
    this.postPointerMoveEvent(n, r);
  }
  _onPointerEnter(t) {
    let { x: n, y: r } = this._getPointerPosition(t);
    this.postPointerEnterEvent(n, r);
  }
  _onPointerLeave(t) {
    let { x: n, y: r } = this._getPointerPosition(t);
    this.postPointerExitEvent(n, r);
  }
  postPointerUpEvent(t, n) {
    return this._dotLottieCore?.stateMachinePostPointerUpEvent(t, n);
  }
  postPointerDownEvent(t, n) {
    return this._dotLottieCore?.stateMachinePostPointerDownEvent(t, n);
  }
  postPointerMoveEvent(t, n) {
    return this._dotLottieCore?.stateMachinePostPointerMoveEvent(t, n);
  }
  postPointerEnterEvent(t, n) {
    return this._dotLottieCore?.stateMachinePostPointerEnterEvent(t, n);
  }
  postPointerExitEvent(t, n) {
    return this._dotLottieCore?.stateMachinePostPointerExitEvent(t, n);
  }
  getStateMachineListeners() {
    if (!this._dotLottieCore) return [];
    let t = this._dotLottieCore.stateMachineFrameworkSetup(), n = [];
    for (let r = 0; r < t.size(); r += 1) n.push(t.get(r));
    return n;
  }
  _setupStateMachineListeners() {
    if (M2 && this._canvas instanceof HTMLCanvasElement && this._dotLottieCore !== null && this.isLoaded) {
      let t = this.getStateMachineListeners();
      t.includes("PointerUp") && this._canvas.addEventListener("pointerup", this._pointerUpMethod), t.includes("PointerDown") && this._canvas.addEventListener("pointerdown", this._pointerDownMethod), t.includes("PointerMove") && this._canvas.addEventListener("pointermove", this._pointerMoveMethod), t.includes("PointerEnter") && this._canvas.addEventListener("pointerenter", this._pointerEnterMethod), t.includes("PointerExit") && this._canvas.addEventListener("pointerleave", this._pointerExitMethod);
    }
  }
  _cleanupStateMachineListeners() {
    M2 && this._canvas instanceof HTMLCanvasElement && (this._canvas.removeEventListener("pointerup", this._pointerUpMethod), this._canvas.removeEventListener("pointerdown", this._pointerDownMethod), this._canvas.removeEventListener("pointermove", this._pointerMoveMethod), this._canvas.removeEventListener("pointerenter", this._pointerEnterMethod), this._canvas.removeEventListener("pointerleave", this._pointerExitMethod));
  }
  loadStateMachineData(t) {
    return this._dotLottieCore?.stateMachineLoadData(t) ?? !1;
  }
  animationSize() {
    let t = this._dotLottieCore?.animationSize().get(0) ?? 0, n = this._dotLottieCore?.animationSize().get(1) ?? 0;
    return { width: t, height: n };
  }
  setStateMachineBooleanContext(t, n) {
    return this._dotLottieCore?.stateMachineSetBooleanInput(t, n) ?? !1;
  }
  setStateMachineNumericContext(t, n) {
    return this._dotLottieCore?.stateMachineSetNumericInput(t, n) ?? !1;
  }
  setStateMachineStringContext(t, n) {
    return this._dotLottieCore?.stateMachineSetStringInput(t, n) ?? !1;
  }
  getLayerBoundingBox(t) {
    let n = this._dotLottieCore?.getLayerBounds(t);
    if (!n || n.size() !== 8) return;
    let r = [];
    for (let o = 0; o < 8; o += 1) r.push(n.get(o));
    return r;
  }
  static transformThemeToLottieSlots(t, n) {
    return Ge._wasmModule?.transformThemeToLottieSlots(t, n) ?? "";
  }
};
Z1(wL, "_wasmModule", null);
var _J = wL, xJ = class {
  constructor() {
    if (typeof Worker > "u") throw new Error("Worker is not supported in this environment.");
    let e = new Blob([new Uint8Array([34, 117, 115, 101, 32, 115, 116, 114, 105, 99, 116, 34, 59, 10, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 118, 97, 114, 32, 95, 95, 100, 101, 102, 80, 114, 111, 112, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 100, 101, 102, 105, 110, 101, 80, 114, 111, 112, 101, 114, 116, 121, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 100, 101, 102, 78, 111, 114, 109, 97, 108, 80, 114, 111, 112, 32, 61, 32, 40, 111, 98, 106, 44, 32, 107, 101, 121, 44, 32, 118, 97, 108, 117, 101, 41, 32, 61, 62, 32, 107, 101, 121, 32, 105, 110, 32, 111, 98, 106, 32, 63, 32, 95, 95, 100, 101, 102, 80, 114, 111, 112, 40, 111, 98, 106, 44, 32, 107, 101, 121, 44, 32, 123, 32, 101, 110, 117, 109, 101, 114, 97, 98, 108, 101, 58, 32, 116, 114, 117, 101, 44, 32, 99, 111, 110, 102, 105, 103, 117, 114, 97, 98, 108, 101, 58, 32, 116, 114, 117, 101, 44, 32, 119, 114, 105, 116, 97, 98, 108, 101, 58, 32, 116, 114, 117, 101, 44, 32, 118, 97, 108, 117, 101, 32, 125, 41, 32, 58, 32, 111, 98, 106, 91, 107, 101, 121, 93, 32, 61, 32, 118, 97, 108, 117, 101, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 32, 61, 32, 40, 111, 98, 106, 44, 32, 107, 101, 121, 44, 32, 118, 97, 108, 117, 101, 41, 32, 61, 62, 32, 95, 95, 100, 101, 102, 78, 111, 114, 109, 97, 108, 80, 114, 111, 112, 40, 111, 98, 106, 44, 32, 116, 121, 112, 101, 111, 102, 32, 107, 101, 121, 32, 33, 61, 61, 32, 34, 115, 121, 109, 98, 111, 108, 34, 32, 63, 32, 107, 101, 121, 32, 43, 32, 34, 34, 32, 58, 32, 107, 101, 121, 44, 32, 118, 97, 108, 117, 101, 41, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 97, 110, 105, 109, 97, 116, 105, 111, 110, 45, 102, 114, 97, 109, 101, 45, 109, 97, 110, 97, 103, 101, 114, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 87, 101, 98, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 83, 116, 114, 97, 116, 101, 103, 121, 32, 61, 32, 99, 108, 97, 115, 115, 32, 123, 10, 32, 32, 32, 32, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 99, 97, 108, 108, 98, 97, 99, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 99, 97, 108, 108, 98, 97, 99, 107, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 99, 97, 110, 99, 101, 108, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 105, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 97, 110, 99, 101, 108, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 105, 100, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 78, 111, 100, 101, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 83, 116, 114, 97, 116, 101, 103, 121, 32, 61, 32, 99, 108, 97, 115, 115, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 108, 97, 115, 116, 72, 97, 110, 100, 108, 101, 73, 100, 34, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 108, 97, 115, 116, 73, 109, 109, 101, 100, 105, 97, 116, 101, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 99, 97, 108, 108, 98, 97, 99, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 108, 97, 115, 116, 72, 97, 110, 100, 108, 101, 73, 100, 32, 62, 61, 32, 78, 117, 109, 98, 101, 114, 46, 77, 65, 88, 95, 83, 65, 70, 69, 95, 73, 78, 84, 69, 71, 69, 82, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 108, 97, 115, 116, 72, 97, 110, 100, 108, 101, 73, 100, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 108, 97, 115, 116, 72, 97, 110, 100, 108, 101, 73, 100, 32, 43, 61, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 108, 97, 115, 116, 73, 109, 109, 101, 100, 105, 97, 116, 101, 32, 61, 32, 115, 101, 116, 73, 109, 109, 101, 100, 105, 97, 116, 101, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 108, 108, 98, 97, 99, 107, 40, 68, 97, 116, 101, 46, 110, 111, 119, 40, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 108, 97, 115, 116, 72, 97, 110, 100, 108, 101, 73, 100, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 99, 97, 110, 99, 101, 108, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 95, 105, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 108, 97, 115, 116, 73, 109, 109, 101, 100, 105, 97, 116, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 108, 101, 97, 114, 73, 109, 109, 101, 100, 105, 97, 116, 101, 40, 116, 104, 105, 115, 46, 95, 108, 97, 115, 116, 73, 109, 109, 101, 100, 105, 97, 116, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 32, 61, 32, 99, 108, 97, 115, 115, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 115, 116, 114, 97, 116, 101, 103, 121, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 115, 116, 114, 97, 116, 101, 103, 121, 32, 61, 32, 116, 121, 112, 101, 111, 102, 32, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 32, 61, 61, 61, 32, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 63, 32, 110, 101, 119, 32, 87, 101, 98, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 83, 116, 114, 97, 116, 101, 103, 121, 40, 41, 32, 58, 32, 110, 101, 119, 32, 78, 111, 100, 101, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 83, 116, 114, 97, 116, 101, 103, 121, 40, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 99, 97, 108, 108, 98, 97, 99, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 115, 116, 114, 97, 116, 101, 103, 121, 46, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 99, 97, 108, 108, 98, 97, 99, 107, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 99, 97, 110, 99, 101, 108, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 105, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 115, 116, 114, 97, 116, 101, 103, 121, 46, 99, 97, 110, 99, 101, 108, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 105, 100, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 99, 111, 110, 115, 116, 97, 110, 116, 115, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 61, 32, 116, 121, 112, 101, 111, 102, 32, 119, 105, 110, 100, 111, 119, 32, 33, 61, 61, 32, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 32, 38, 38, 32, 116, 121, 112, 101, 111, 102, 32, 119, 105, 110, 100, 111, 119, 46, 100, 111, 99, 117, 109, 101, 110, 116, 32, 33, 61, 61, 32, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 59, 10, 32, 32, 118, 97, 114, 32, 90, 73, 80, 95, 83, 73, 71, 78, 65, 84, 85, 82, 69, 32, 61, 32, 110, 101, 119, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 40, 91, 56, 48, 44, 32, 55, 53, 44, 32, 51, 44, 32, 52, 93, 41, 59, 10, 32, 32, 118, 97, 114, 32, 76, 79, 84, 84, 73, 69, 95, 74, 83, 79, 78, 95, 77, 65, 78, 68, 65, 84, 79, 82, 89, 95, 70, 73, 69, 76, 68, 83, 32, 61, 32, 91, 34, 118, 34, 44, 32, 34, 105, 112, 34, 44, 32, 34, 111, 112, 34, 44, 32, 34, 108, 97, 121, 101, 114, 115, 34, 44, 32, 34, 102, 114, 34, 44, 32, 34, 119, 34, 44, 32, 34, 104, 34, 93, 59, 10, 32, 32, 118, 97, 114, 32, 80, 65, 67, 75, 65, 71, 69, 95, 86, 69, 82, 83, 73, 79, 78, 32, 61, 32, 34, 48, 46, 52, 55, 46, 48, 34, 59, 10, 32, 32, 118, 97, 114, 32, 80, 65, 67, 75, 65, 71, 69, 95, 78, 65, 77, 69, 32, 61, 32, 34, 64, 108, 111, 116, 116, 105, 101, 102, 105, 108, 101, 115, 47, 100, 111, 116, 108, 111, 116, 116, 105, 101, 45, 119, 101, 98, 34, 59, 10, 32, 32, 118, 97, 114, 32, 68, 69, 70, 65, 85, 76, 84, 95, 68, 80, 82, 95, 70, 65, 67, 84, 79, 82, 32, 61, 32, 48, 46, 55, 53, 59, 10, 32, 32, 118, 97, 114, 32, 66, 89, 84, 69, 83, 95, 80, 69, 82, 95, 80, 73, 88, 69, 76, 32, 61, 32, 52, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 99, 111, 114, 101, 47, 100, 111, 116, 108, 111, 116, 116, 105, 101, 45, 112, 108, 97, 121, 101, 114, 46, 106, 115, 10, 32, 32, 118, 97, 114, 32, 99, 114, 101, 97, 116, 101, 68, 111, 116, 76, 111, 116, 116, 105, 101, 80, 108, 97, 121, 101, 114, 77, 111, 100, 117, 108, 101, 32, 61, 32, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 118, 97, 114, 32, 95, 115, 99, 114, 105, 112, 116, 78, 97, 109, 101, 32, 61, 32, 116, 121, 112, 101, 111, 102, 32, 100, 111, 99, 117, 109, 101, 110, 116, 32, 33, 61, 32, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 32, 63, 32, 100, 111, 99, 117, 109, 101, 110, 116, 46, 99, 117, 114, 114, 101, 110, 116, 83, 99, 114, 105, 112, 116, 63, 46, 115, 114, 99, 32, 58, 32, 118, 111, 105, 100, 32, 48, 59, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 109, 111, 100, 117, 108, 101, 65, 114, 103, 32, 61, 32, 123, 125, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 109, 111, 100, 117, 108, 101, 82, 116, 110, 59, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 107, 32, 61, 32, 109, 111, 100, 117, 108, 101, 65, 114, 103, 44, 32, 97, 97, 44, 32, 98, 97, 44, 32, 99, 97, 32, 61, 32, 110, 101, 119, 32, 80, 114, 111, 109, 105, 115, 101, 40, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 97, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 97, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 44, 32, 100, 97, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 97, 115, 115, 105, 103, 110, 40, 123, 125, 44, 32, 107, 41, 44, 32, 101, 97, 32, 61, 32, 34, 46, 47, 116, 104, 105, 115, 46, 112, 114, 111, 103, 114, 97, 109, 34, 44, 32, 113, 32, 61, 32, 34, 34, 44, 32, 105, 97, 59, 10, 32, 32, 32, 32, 32, 32, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 32, 33, 61, 32, 116, 121, 112, 101, 111, 102, 32, 100, 111, 99, 117, 109, 101, 110, 116, 32, 38, 38, 32, 100, 111, 99, 117, 109, 101, 110, 116, 46, 99, 117, 114, 114, 101, 110, 116, 83, 99, 114, 105, 112, 116, 32, 38, 38, 32, 40, 113, 32, 61, 32, 100, 111, 99, 117, 109, 101, 110, 116, 46, 99, 117, 114, 114, 101, 110, 116, 83, 99, 114, 105, 112, 116, 46, 115, 114, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 115, 99, 114, 105, 112, 116, 78, 97, 109, 101, 32, 38, 38, 32, 40, 113, 32, 61, 32, 95, 115, 99, 114, 105, 112, 116, 78, 97, 109, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 113, 46, 115, 116, 97, 114, 116, 115, 87, 105, 116, 104, 40, 34, 98, 108, 111, 98, 58, 34, 41, 32, 63, 32, 113, 32, 61, 32, 34, 34, 32, 58, 32, 113, 32, 61, 32, 113, 46, 115, 117, 98, 115, 116, 114, 40, 48, 44, 32, 113, 46, 114, 101, 112, 108, 97, 99, 101, 40, 47, 91, 63, 35, 93, 46, 42, 47, 44, 32, 34, 34, 41, 46, 108, 97, 115, 116, 73, 110, 100, 101, 120, 79, 102, 40, 34, 47, 34, 41, 32, 43, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 97, 32, 61, 32, 97, 115, 121, 110, 99, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 97, 119, 97, 105, 116, 32, 102, 101, 116, 99, 104, 40, 97, 44, 32, 123, 32, 99, 114, 101, 100, 101, 110, 116, 105, 97, 108, 115, 58, 32, 34, 115, 97, 109, 101, 45, 111, 114, 105, 103, 105, 110, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 97, 46, 111, 107, 41, 32, 114, 101, 116, 117, 114, 110, 32, 97, 46, 97, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 69, 114, 114, 111, 114, 40, 97, 46, 115, 116, 97, 116, 117, 115, 32, 43, 32, 34, 32, 58, 32, 34, 32, 43, 32, 97, 46, 117, 114, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 106, 97, 32, 61, 32, 107, 46, 112, 114, 105, 110, 116, 32, 124, 124, 32, 99, 111, 110, 115, 111, 108, 101, 46, 108, 111, 103, 46, 98, 105, 110, 100, 40, 99, 111, 110, 115, 111, 108, 101, 41, 44, 32, 114, 32, 61, 32, 107, 46, 112, 114, 105, 110, 116, 69, 114, 114, 32, 124, 124, 32, 99, 111, 110, 115, 111, 108, 101, 46, 101, 114, 114, 111, 114, 46, 98, 105, 110, 100, 40, 99, 111, 110, 115, 111, 108, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 79, 98, 106, 101, 99, 116, 46, 97, 115, 115, 105, 103, 110, 40, 107, 44, 32, 100, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 100, 97, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 116, 104, 105, 115, 80, 114, 111, 103, 114, 97, 109, 32, 38, 38, 32, 40, 101, 97, 32, 61, 32, 107, 46, 116, 104, 105, 115, 80, 114, 111, 103, 114, 97, 109, 41, 59, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 107, 97, 32, 61, 32, 107, 46, 119, 97, 115, 109, 66, 105, 110, 97, 114, 121, 44, 32, 108, 97, 44, 32, 109, 97, 32, 61, 32, 102, 97, 108, 115, 101, 44, 32, 110, 97, 44, 32, 117, 44, 32, 120, 44, 32, 121, 44, 32, 122, 44, 32, 65, 44, 32, 66, 44, 32, 111, 97, 44, 32, 112, 97, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 113, 97, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 97, 32, 61, 32, 108, 97, 46, 98, 117, 102, 102, 101, 114, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 46, 72, 69, 65, 80, 56, 32, 61, 32, 117, 32, 61, 32, 110, 101, 119, 32, 73, 110, 116, 56, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 46, 72, 69, 65, 80, 49, 54, 32, 61, 32, 121, 32, 61, 32, 110, 101, 119, 32, 73, 110, 116, 49, 54, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 46, 72, 69, 65, 80, 85, 56, 32, 61, 32, 120, 32, 61, 32, 110, 101, 119, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 46, 72, 69, 65, 80, 85, 49, 54, 32, 61, 32, 122, 32, 61, 32, 110, 101, 119, 32, 85, 105, 110, 116, 49, 54, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 46, 72, 69, 65, 80, 51, 50, 32, 61, 32, 65, 32, 61, 32, 110, 101, 119, 32, 73, 110, 116, 51, 50, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 46, 72, 69, 65, 80, 85, 51, 50, 32, 61, 32, 66, 32, 61, 32, 110, 101, 119, 32, 85, 105, 110, 116, 51, 50, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 46, 72, 69, 65, 80, 70, 51, 50, 32, 61, 32, 111, 97, 32, 61, 32, 110, 101, 119, 32, 70, 108, 111, 97, 116, 51, 50, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 46, 72, 69, 65, 80, 70, 54, 52, 32, 61, 32, 112, 97, 32, 61, 32, 110, 101, 119, 32, 70, 108, 111, 97, 116, 54, 52, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 114, 97, 32, 61, 32, 91, 93, 44, 32, 115, 97, 32, 61, 32, 91, 93, 44, 32, 116, 97, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 117, 97, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 97, 32, 61, 32, 107, 46, 112, 114, 101, 82, 117, 110, 46, 115, 104, 105, 102, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 97, 46, 117, 110, 115, 104, 105, 102, 116, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 67, 32, 61, 32, 48, 44, 32, 68, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 118, 97, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 46, 111, 110, 65, 98, 111, 114, 116, 63, 46, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 34, 65, 98, 111, 114, 116, 101, 100, 40, 34, 32, 43, 32, 97, 32, 43, 32, 34, 41, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 97, 32, 61, 32, 116, 114, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 110, 101, 119, 32, 87, 101, 98, 65, 115, 115, 101, 109, 98, 108, 121, 46, 82, 117, 110, 116, 105, 109, 101, 69, 114, 114, 111, 114, 40, 97, 32, 43, 32, 34, 46, 32, 66, 117, 105, 108, 100, 32, 119, 105, 116, 104, 32, 45, 115, 65, 83, 83, 69, 82, 84, 73, 79, 78, 83, 32, 102, 111, 114, 32, 109, 111, 114, 101, 32, 105, 110, 102, 111, 46, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 97, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 119, 97, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 97, 46, 115, 116, 97, 114, 116, 115, 87, 105, 116, 104, 40, 34, 100, 97, 116, 97, 58, 97, 112, 112, 108, 105, 99, 97, 116, 105, 111, 110, 47, 111, 99, 116, 101, 116, 45, 115, 116, 114, 101, 97, 109, 59, 98, 97, 115, 101, 54, 52, 44, 34, 41, 44, 32, 120, 97, 59, 10, 32, 32, 32, 32, 32, 32, 97, 115, 121, 110, 99, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 121, 97, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 107, 97, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 97, 119, 97, 105, 116, 32, 105, 97, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 110, 101, 119, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 97, 32, 61, 61, 32, 120, 97, 32, 38, 38, 32, 107, 97, 41, 32, 97, 32, 61, 32, 110, 101, 119, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 40, 107, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 32, 116, 104, 114, 111, 119, 32, 34, 98, 111, 116, 104, 32, 97, 115, 121, 110, 99, 32, 97, 110, 100, 32, 115, 121, 110, 99, 32, 102, 101, 116, 99, 104, 105, 110, 103, 32, 111, 102, 32, 116, 104, 101, 32, 119, 97, 115, 109, 32, 102, 97, 105, 108, 101, 100, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 97, 115, 121, 110, 99, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 122, 97, 40, 97, 44, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 97, 119, 97, 105, 116, 32, 121, 97, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 119, 97, 105, 116, 32, 87, 101, 98, 65, 115, 115, 101, 109, 98, 108, 121, 46, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 101, 40, 99, 44, 32, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 40, 96, 102, 97, 105, 108, 101, 100, 32, 116, 111, 32, 97, 115, 121, 110, 99, 104, 114, 111, 110, 111, 117, 115, 108, 121, 32, 112, 114, 101, 112, 97, 114, 101, 32, 119, 97, 115, 109, 58, 32, 36, 123, 100, 125, 96, 41, 44, 32, 118, 97, 40, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 97, 115, 121, 110, 99, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 65, 97, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 120, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 107, 97, 32, 38, 38, 32, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 87, 101, 98, 65, 115, 115, 101, 109, 98, 108, 121, 46, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 101, 83, 116, 114, 101, 97, 109, 105, 110, 103, 32, 38, 38, 32, 33, 119, 97, 40, 98, 41, 32, 38, 38, 32, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 102, 101, 116, 99, 104, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 102, 101, 116, 99, 104, 40, 98, 44, 32, 123, 32, 99, 114, 101, 100, 101, 110, 116, 105, 97, 108, 115, 58, 32, 34, 115, 97, 109, 101, 45, 111, 114, 105, 103, 105, 110, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 119, 97, 105, 116, 32, 87, 101, 98, 65, 115, 115, 101, 109, 98, 108, 121, 46, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 101, 83, 116, 114, 101, 97, 109, 105, 110, 103, 40, 99, 44, 32, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 40, 96, 119, 97, 115, 109, 32, 115, 116, 114, 101, 97, 109, 105, 110, 103, 32, 99, 111, 109, 112, 105, 108, 101, 32, 102, 97, 105, 108, 101, 100, 58, 32, 36, 123, 100, 125, 96, 41, 44, 32, 114, 40, 34, 102, 97, 108, 108, 105, 110, 103, 32, 98, 97, 99, 107, 32, 116, 111, 32, 65, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 32, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 105, 111, 110, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 122, 97, 40, 98, 44, 32, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 99, 108, 97, 115, 115, 32, 66, 97, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 110, 97, 109, 101, 34, 44, 32, 34, 69, 120, 105, 116, 83, 116, 97, 116, 117, 115, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 109, 101, 115, 115, 97, 103, 101, 32, 61, 32, 96, 80, 114, 111, 103, 114, 97, 109, 32, 116, 101, 114, 109, 105, 110, 97, 116, 101, 100, 32, 119, 105, 116, 104, 32, 101, 120, 105, 116, 40, 36, 123, 97, 125, 41, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 115, 116, 97, 116, 117, 115, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 67, 97, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 59, 32, 48, 32, 60, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 32, 41, 32, 97, 46, 115, 104, 105, 102, 116, 40, 41, 40, 107, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 68, 97, 32, 61, 32, 107, 46, 110, 111, 69, 120, 105, 116, 82, 117, 110, 116, 105, 109, 101, 32, 124, 124, 32, 116, 114, 117, 101, 44, 32, 69, 97, 32, 61, 32, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 32, 33, 61, 32, 116, 121, 112, 101, 111, 102, 32, 84, 101, 120, 116, 68, 101, 99, 111, 100, 101, 114, 32, 63, 32, 110, 101, 119, 32, 84, 101, 120, 116, 68, 101, 99, 111, 100, 101, 114, 40, 41, 32, 58, 32, 118, 111, 105, 100, 32, 48, 44, 32, 71, 32, 61, 32, 40, 97, 44, 32, 98, 32, 61, 32, 48, 44, 32, 99, 32, 61, 32, 78, 97, 78, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 98, 32, 43, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 99, 32, 61, 32, 98, 59, 32, 97, 91, 99, 93, 32, 38, 38, 32, 33, 40, 99, 32, 62, 61, 32, 100, 41, 59, 32, 41, 32, 43, 43, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 49, 54, 32, 60, 32, 99, 32, 45, 32, 98, 32, 38, 38, 32, 97, 46, 98, 117, 102, 102, 101, 114, 32, 38, 38, 32, 69, 97, 41, 32, 114, 101, 116, 117, 114, 110, 32, 69, 97, 46, 100, 101, 99, 111, 100, 101, 40, 97, 46, 115, 117, 98, 97, 114, 114, 97, 121, 40, 98, 44, 32, 99, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 100, 32, 61, 32, 34, 34, 59, 32, 98, 32, 60, 32, 99, 59, 32, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 97, 91, 98, 43, 43, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 32, 38, 32, 49, 50, 56, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 97, 91, 98, 43, 43, 93, 32, 38, 32, 54, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 49, 57, 50, 32, 61, 61, 32, 40, 101, 32, 38, 32, 50, 50, 52, 41, 41, 32, 100, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 40, 101, 32, 38, 32, 51, 49, 41, 32, 60, 60, 32, 54, 32, 124, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 97, 91, 98, 43, 43, 93, 32, 38, 32, 54, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 50, 50, 52, 32, 61, 61, 32, 40, 101, 32, 38, 32, 50, 52, 48, 41, 32, 63, 32, 40, 101, 32, 38, 32, 49, 53, 41, 32, 60, 60, 32, 49, 50, 32, 124, 32, 102, 32, 60, 60, 32, 54, 32, 124, 32, 104, 32, 58, 32, 40, 101, 32, 38, 32, 55, 41, 32, 60, 60, 32, 49, 56, 32, 124, 32, 102, 32, 60, 60, 32, 49, 50, 32, 124, 32, 104, 32, 60, 60, 32, 54, 32, 124, 32, 97, 91, 98, 43, 43, 93, 32, 38, 32, 54, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 54, 53, 53, 51, 54, 32, 62, 32, 101, 32, 63, 32, 100, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 101, 41, 32, 58, 32, 40, 101, 32, 45, 61, 32, 54, 53, 53, 51, 54, 44, 32, 100, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 53, 53, 50, 57, 54, 32, 124, 32, 101, 32, 62, 62, 32, 49, 48, 44, 32, 53, 54, 51, 50, 48, 32, 124, 32, 101, 32, 38, 32, 49, 48, 50, 51, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 100, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 73, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 99, 108, 97, 115, 115, 32, 70, 97, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 80, 97, 32, 61, 32, 97, 32, 45, 32, 50, 52, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 72, 97, 32, 61, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 97, 32, 61, 32, 91, 93, 44, 32, 98, 32, 61, 32, 73, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 41, 32, 114, 101, 116, 117, 114, 110, 32, 74, 40, 48, 41, 44, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 110, 101, 119, 32, 70, 97, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 66, 91, 99, 46, 80, 97, 32, 43, 32, 49, 54, 32, 62, 62, 32, 50, 93, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 66, 91, 99, 46, 80, 97, 32, 43, 32, 52, 32, 62, 62, 32, 50, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 100, 41, 32, 114, 101, 116, 117, 114, 110, 32, 74, 40, 48, 41, 44, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 101, 32, 111, 102, 32, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 48, 32, 61, 61, 61, 32, 101, 32, 124, 124, 32, 101, 32, 61, 61, 61, 32, 100, 41, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 71, 97, 40, 101, 44, 32, 100, 44, 32, 99, 46, 80, 97, 32, 43, 32, 49, 54, 41, 41, 32, 114, 101, 116, 117, 114, 110, 32, 74, 40, 101, 41, 44, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 74, 40, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 73, 97, 32, 61, 32, 48, 44, 32, 75, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 120, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 48, 32, 60, 32, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 98, 32, 43, 32, 99, 32, 45, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 101, 32, 61, 32, 48, 59, 32, 101, 32, 60, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 32, 43, 43, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 97, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 53, 53, 50, 57, 54, 32, 60, 61, 32, 102, 32, 38, 38, 32, 53, 55, 51, 52, 51, 32, 62, 61, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 97, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 43, 43, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 32, 61, 32, 54, 53, 53, 51, 54, 32, 43, 32, 40, 40, 102, 32, 38, 32, 49, 48, 50, 51, 41, 32, 60, 60, 32, 49, 48, 41, 32, 124, 32, 104, 32, 38, 32, 49, 48, 50, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 49, 50, 55, 32, 62, 61, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 32, 62, 61, 32, 99, 41, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 43, 43, 93, 32, 61, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 50, 48, 52, 55, 32, 62, 61, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 32, 43, 32, 49, 32, 62, 61, 32, 99, 41, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 43, 43, 93, 32, 61, 32, 49, 57, 50, 32, 124, 32, 102, 32, 62, 62, 32, 54, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 54, 53, 53, 51, 53, 32, 62, 61, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 32, 43, 32, 50, 32, 62, 61, 32, 99, 41, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 43, 43, 93, 32, 61, 32, 50, 50, 52, 32, 124, 32, 102, 32, 62, 62, 32, 49, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 32, 43, 32, 51, 32, 62, 61, 32, 99, 41, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 43, 43, 93, 32, 61, 32, 50, 52, 48, 32, 124, 32, 102, 32, 62, 62, 32, 49, 56, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 43, 43, 93, 32, 61, 32, 49, 50, 56, 32, 124, 32, 102, 32, 62, 62, 32, 49, 50, 32, 38, 32, 54, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 43, 43, 93, 32, 61, 32, 49, 50, 56, 32, 124, 32, 102, 32, 62, 62, 32, 54, 32, 38, 32, 54, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 43, 43, 93, 32, 61, 32, 49, 50, 56, 32, 124, 32, 102, 32, 38, 32, 54, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 93, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 74, 97, 32, 61, 32, 123, 125, 44, 32, 75, 97, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 59, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 32, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 97, 46, 112, 111, 112, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 112, 111, 112, 40, 41, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 76, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 66, 91, 97, 32, 62, 62, 32, 50, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 77, 32, 61, 32, 123, 125, 44, 32, 78, 32, 61, 32, 123, 125, 44, 32, 76, 97, 32, 61, 32, 123, 125, 44, 32, 77, 97, 44, 32, 80, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 100, 40, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 61, 32, 99, 40, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 103, 46, 108, 101, 110, 103, 116, 104, 32, 33, 61, 61, 32, 97, 46, 108, 101, 110, 103, 116, 104, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 77, 97, 40, 34, 77, 105, 115, 109, 97, 116, 99, 104, 101, 100, 32, 116, 121, 112, 101, 32, 99, 111, 110, 118, 101, 114, 116, 101, 114, 32, 99, 111, 117, 110, 116, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 108, 32, 61, 32, 48, 59, 32, 108, 32, 60, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 32, 43, 43, 108, 41, 32, 79, 40, 97, 91, 108, 93, 44, 32, 103, 91, 108, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 103, 41, 32, 61, 62, 32, 76, 97, 91, 103, 93, 32, 61, 32, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 65, 114, 114, 97, 121, 40, 98, 46, 108, 101, 110, 103, 116, 104, 41, 44, 32, 102, 32, 61, 32, 91, 93, 44, 32, 104, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 103, 44, 32, 108, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 78, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 103, 41, 32, 63, 32, 101, 91, 108, 93, 32, 61, 32, 78, 91, 103, 93, 32, 58, 32, 40, 102, 46, 112, 117, 115, 104, 40, 103, 41, 44, 32, 77, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 103, 41, 32, 124, 124, 32, 40, 77, 91, 103, 93, 32, 61, 32, 91, 93, 41, 44, 32, 77, 91, 103, 93, 46, 112, 117, 115, 104, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 91, 108, 93, 32, 61, 32, 78, 91, 103, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 43, 43, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 104, 32, 61, 61, 61, 32, 102, 46, 108, 101, 110, 103, 116, 104, 32, 38, 38, 32, 100, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 48, 32, 61, 61, 61, 32, 102, 46, 108, 101, 110, 103, 116, 104, 32, 38, 38, 32, 100, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 78, 97, 44, 32, 81, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 98, 32, 61, 32, 34, 34, 59, 32, 120, 91, 97, 93, 59, 32, 41, 32, 98, 32, 43, 61, 32, 78, 97, 91, 120, 91, 97, 43, 43, 93, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 82, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 79, 97, 40, 97, 44, 32, 98, 44, 32, 99, 32, 61, 32, 123, 125, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 98, 46, 110, 97, 109, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 82, 40, 96, 116, 121, 112, 101, 32, 34, 36, 123, 100, 125, 34, 32, 109, 117, 115, 116, 32, 104, 97, 118, 101, 32, 97, 32, 112, 111, 115, 105, 116, 105, 118, 101, 32, 105, 110, 116, 101, 103, 101, 114, 32, 116, 121, 112, 101, 105, 100, 32, 112, 111, 105, 110, 116, 101, 114, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 78, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 97, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 46, 118, 98, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 82, 40, 96, 67, 97, 110, 110, 111, 116, 32, 114, 101, 103, 105, 115, 116, 101, 114, 32, 116, 121, 112, 101, 32, 39, 36, 123, 100, 125, 39, 32, 116, 119, 105, 99, 101, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 78, 91, 97, 93, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 108, 101, 116, 101, 32, 76, 97, 91, 97, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 77, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 97, 41, 32, 38, 38, 32, 40, 98, 32, 61, 32, 77, 91, 97, 93, 44, 32, 100, 101, 108, 101, 116, 101, 32, 77, 91, 97, 93, 44, 32, 98, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 101, 41, 32, 61, 62, 32, 101, 40, 41, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 79, 40, 97, 44, 32, 98, 44, 32, 99, 32, 61, 32, 123, 125, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 79, 97, 40, 97, 44, 32, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 81, 97, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 82, 40, 97, 46, 79, 97, 46, 82, 97, 46, 81, 97, 46, 110, 97, 109, 101, 32, 43, 32, 34, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 97, 108, 114, 101, 97, 100, 121, 32, 100, 101, 108, 101, 116, 101, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 82, 97, 32, 61, 32, 102, 97, 108, 115, 101, 44, 32, 83, 97, 32, 61, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 84, 97, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 32, 61, 61, 61, 32, 99, 41, 32, 114, 101, 116, 117, 114, 110, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 99, 46, 85, 97, 41, 32, 114, 101, 116, 117, 114, 110, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 84, 97, 40, 97, 44, 32, 98, 44, 32, 99, 46, 85, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 110, 117, 108, 108, 32, 61, 61, 61, 32, 97, 32, 63, 32, 110, 117, 108, 108, 32, 58, 32, 99, 46, 111, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 85, 97, 32, 61, 32, 123, 125, 44, 32, 86, 97, 32, 61, 32, 123, 125, 44, 32, 87, 97, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 98, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 82, 40, 34, 112, 116, 114, 32, 115, 104, 111, 117, 108, 100, 32, 110, 111, 116, 32, 98, 101, 32, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 59, 32, 97, 46, 85, 97, 59, 32, 41, 32, 98, 32, 61, 32, 97, 46, 101, 98, 40, 98, 41, 44, 32, 97, 32, 61, 32, 97, 46, 85, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 86, 97, 91, 98, 93, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 89, 97, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 46, 82, 97, 32, 124, 124, 32, 33, 98, 46, 80, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 77, 97, 40, 34, 109, 97, 107, 101, 67, 108, 97, 115, 115, 72, 97, 110, 100, 108, 101, 32, 114, 101, 113, 117, 105, 114, 101, 115, 32, 112, 116, 114, 32, 97, 110, 100, 32, 112, 116, 114, 84, 121, 112, 101, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 33, 98, 46, 86, 97, 32, 33, 61, 61, 32, 33, 33, 98, 46, 84, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 77, 97, 40, 34, 66, 111, 116, 104, 32, 115, 109, 97, 114, 116, 80, 116, 114, 84, 121, 112, 101, 32, 97, 110, 100, 32, 115, 109, 97, 114, 116, 80, 116, 114, 32, 109, 117, 115, 116, 32, 98, 101, 32, 115, 112, 101, 99, 105, 102, 105, 101, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 46, 99, 111, 117, 110, 116, 32, 61, 32, 123, 32, 118, 97, 108, 117, 101, 58, 32, 49, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 88, 97, 40, 79, 98, 106, 101, 99, 116, 46, 99, 114, 101, 97, 116, 101, 40, 97, 44, 32, 123, 32, 79, 97, 58, 32, 123, 32, 118, 97, 108, 117, 101, 58, 32, 98, 44, 32, 119, 114, 105, 116, 97, 98, 108, 101, 58, 32, 116, 114, 117, 101, 32, 125, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 88, 97, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 32, 61, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 70, 105, 110, 97, 108, 105, 122, 97, 116, 105, 111, 110, 82, 101, 103, 105, 115, 116, 114, 121, 41, 32, 114, 101, 116, 117, 114, 110, 32, 88, 97, 32, 61, 32, 40, 98, 41, 32, 61, 62, 32, 98, 44, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 82, 97, 32, 61, 32, 110, 101, 119, 32, 70, 105, 110, 97, 108, 105, 122, 97, 116, 105, 111, 110, 82, 101, 103, 105, 115, 116, 114, 121, 40, 40, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 98, 46, 79, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 45, 45, 98, 46, 99, 111, 117, 110, 116, 46, 118, 97, 108, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 48, 32, 61, 61, 61, 32, 98, 46, 99, 111, 117, 110, 116, 46, 118, 97, 108, 117, 101, 32, 38, 38, 32, 40, 98, 46, 84, 97, 32, 63, 32, 98, 46, 86, 97, 46, 89, 97, 40, 98, 46, 84, 97, 41, 32, 58, 32, 98, 46, 82, 97, 46, 81, 97, 46, 89, 97, 40, 98, 46, 80, 97, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 88, 97, 32, 61, 32, 40, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 98, 46, 79, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 46, 84, 97, 32, 38, 38, 32, 82, 97, 46, 114, 101, 103, 105, 115, 116, 101, 114, 40, 98, 44, 32, 123, 32, 79, 97, 58, 32, 99, 32, 125, 44, 32, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 83, 97, 32, 61, 32, 40, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 82, 97, 46, 117, 110, 114, 101, 103, 105, 115, 116, 101, 114, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 88, 97, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 90, 97, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 36, 97, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 97, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 79, 98, 106, 101, 99, 116, 46, 100, 101, 102, 105, 110, 101, 80, 114, 111, 112, 101, 114, 116, 121, 40, 98, 44, 32, 34, 110, 97, 109, 101, 34, 44, 32, 123, 32, 118, 97, 108, 117, 101, 58, 32, 97, 32, 125, 41, 44, 32, 98, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 97, 91, 98, 93, 46, 83, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 97, 91, 98, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 91, 98, 93, 32, 61, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 46, 46, 46, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 97, 91, 98, 93, 46, 83, 97, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 101, 46, 108, 101, 110, 103, 116, 104, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 82, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 96, 70, 117, 110, 99, 116, 105, 111, 110, 32, 39, 36, 123, 99, 125, 39, 32, 99, 97, 108, 108, 101, 100, 32, 119, 105, 116, 104, 32, 97, 110, 32, 105, 110, 118, 97, 108, 105, 100, 32, 110, 117, 109, 98, 101, 114, 32, 111, 102, 32, 97, 114, 103, 117, 109, 101, 110, 116, 115, 32, 40, 36, 123, 101, 46, 108, 101, 110, 103, 116, 104, 125, 41, 32, 45, 32, 101, 120, 112, 101, 99, 116, 115, 32, 111, 110, 101, 32, 111, 102, 32, 40, 36, 123, 97, 91, 98, 93, 46, 83, 97, 125, 41, 33, 96, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 91, 98, 93, 46, 83, 97, 91, 101, 46, 108, 101, 110, 103, 116, 104, 93, 46, 97, 112, 112, 108, 121, 40, 116, 104, 105, 115, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 91, 98, 93, 46, 83, 97, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 91, 98, 93, 46, 83, 97, 91, 100, 46, 97, 98, 93, 32, 61, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 99, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 107, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 97, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 99, 32, 124, 124, 32, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 107, 91, 97, 93, 46, 83, 97, 32, 38, 38, 32, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 107, 91, 97, 93, 46, 83, 97, 91, 99, 93, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 82, 40, 96, 67, 97, 110, 110, 111, 116, 32, 114, 101, 103, 105, 115, 116, 101, 114, 32, 112, 117, 98, 108, 105, 99, 32, 110, 97, 109, 101, 32, 39, 36, 123, 97, 125, 39, 32, 116, 119, 105, 99, 101, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 98, 40, 107, 44, 32, 97, 44, 32, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 107, 91, 97, 93, 46, 83, 97, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 99, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 82, 40, 96, 67, 97, 110, 110, 111, 116, 32, 114, 101, 103, 105, 115, 116, 101, 114, 32, 109, 117, 108, 116, 105, 112, 108, 101, 32, 111, 118, 101, 114, 108, 111, 97, 100, 115, 32, 111, 102, 32, 97, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 119, 105, 116, 104, 32, 116, 104, 101, 32, 115, 97, 109, 101, 32, 110, 117, 109, 98, 101, 114, 32, 111, 102, 32, 97, 114, 103, 117, 109, 101, 110, 116, 115, 32, 40, 36, 123, 99, 125, 41, 33, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 107, 91, 97, 93, 46, 83, 97, 91, 99, 93, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 107, 91, 97, 93, 32, 61, 32, 98, 44, 32, 107, 91, 97, 93, 46, 97, 98, 32, 61, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 100, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 97, 46, 114, 101, 112, 108, 97, 99, 101, 40, 47, 91, 94, 97, 45, 122, 65, 45, 90, 48, 45, 57, 95, 93, 47, 103, 44, 32, 34, 36, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 97, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 52, 56, 32, 60, 61, 32, 98, 32, 38, 38, 32, 53, 55, 32, 62, 61, 32, 98, 32, 63, 32, 96, 95, 36, 123, 97, 125, 96, 32, 58, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 101, 98, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 110, 97, 109, 101, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 36, 97, 32, 61, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 89, 97, 32, 61, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 85, 97, 32, 61, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 113, 98, 32, 61, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 101, 98, 32, 61, 32, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 111, 98, 32, 61, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 120, 98, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 59, 32, 98, 32, 33, 61, 61, 32, 99, 59, 32, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 46, 101, 98, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 82, 40, 96, 69, 120, 112, 101, 99, 116, 101, 100, 32, 110, 117, 108, 108, 32, 111, 114, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 111, 102, 32, 36, 123, 99, 46, 110, 97, 109, 101, 125, 44, 32, 103, 111, 116, 32, 97, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 111, 102, 32, 36, 123, 98, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 98, 46, 101, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 98, 46, 85, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 103, 98, 40, 97, 44, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 110, 117, 108, 108, 32, 61, 61, 61, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 104, 98, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 82, 40, 96, 110, 117, 108, 108, 32, 105, 115, 32, 110, 111, 116, 32, 97, 32, 118, 97, 108, 105, 100, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 46, 79, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 82, 40, 96, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 34, 36, 123, 104, 98, 40, 98, 41, 125, 34, 32, 97, 115, 32, 97, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 46, 79, 97, 46, 80, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 82, 40, 96, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 100, 101, 108, 101, 116, 101, 100, 32, 111, 98, 106, 101, 99, 116, 32, 97, 115, 32, 97, 32, 112, 111, 105, 110, 116, 101, 114, 32, 111, 102, 32, 116, 121, 112, 101, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 98, 40, 98, 46, 79, 97, 46, 80, 97, 44, 32, 98, 46, 79, 97, 46, 82, 97, 46, 81, 97, 44, 32, 116, 104, 105, 115, 46, 81, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 105, 98, 40, 97, 44, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 110, 117, 108, 108, 32, 61, 61, 61, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 104, 98, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 82, 40, 96, 110, 117, 108, 108, 32, 105, 115, 32, 110, 111, 116, 32, 97, 32, 118, 97, 108, 105, 100, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 103, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 116, 104, 105, 115, 46, 105, 98, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 97, 32, 38, 38, 32, 97, 46, 112, 117, 115, 104, 40, 116, 104, 105, 115, 46, 89, 97, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 32, 124, 124, 32, 33, 98, 46, 79, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 82, 40, 96, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 34, 36, 123, 104, 98, 40, 98, 41, 125, 34, 32, 97, 115, 32, 97, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 46, 79, 97, 46, 80, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 82, 40, 96, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 100, 101, 108, 101, 116, 101, 100, 32, 111, 98, 106, 101, 99, 116, 32, 97, 115, 32, 97, 32, 112, 111, 105, 110, 116, 101, 114, 32, 111, 102, 32, 116, 121, 112, 101, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 116, 104, 105, 115, 46, 102, 98, 32, 38, 38, 32, 98, 46, 79, 97, 46, 82, 97, 46, 102, 98, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 82, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 96, 67, 97, 110, 110, 111, 116, 32, 99, 111, 110, 118, 101, 114, 116, 32, 97, 114, 103, 117, 109, 101, 110, 116, 32, 111, 102, 32, 116, 121, 112, 101, 32, 36, 123, 98, 46, 79, 97, 46, 86, 97, 32, 63, 32, 98, 46, 79, 97, 46, 86, 97, 46, 110, 97, 109, 101, 32, 58, 32, 98, 46, 79, 97, 46, 82, 97, 46, 110, 97, 109, 101, 125, 32, 116, 111, 32, 112, 97, 114, 97, 109, 101, 116, 101, 114, 32, 116, 121, 112, 101, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 102, 98, 40, 98, 46, 79, 97, 46, 80, 97, 44, 32, 98, 46, 79, 97, 46, 82, 97, 46, 81, 97, 44, 32, 116, 104, 105, 115, 46, 81, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 103, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 98, 46, 79, 97, 46, 84, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 82, 40, 34, 80, 97, 115, 115, 105, 110, 103, 32, 114, 97, 119, 32, 112, 111, 105, 110, 116, 101, 114, 32, 116, 111, 32, 115, 109, 97, 114, 116, 32, 112, 111, 105, 110, 116, 101, 114, 32, 105, 115, 32, 105, 108, 108, 101, 103, 97, 108, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 119, 105, 116, 99, 104, 32, 40, 116, 104, 105, 115, 46, 67, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 48, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 46, 79, 97, 46, 86, 97, 32, 61, 61, 61, 32, 116, 104, 105, 115, 41, 32, 99, 32, 61, 32, 98, 46, 79, 97, 46, 84, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 82, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 96, 67, 97, 110, 110, 111, 116, 32, 99, 111, 110, 118, 101, 114, 116, 32, 97, 114, 103, 117, 109, 101, 110, 116, 32, 111, 102, 32, 116, 121, 112, 101, 32, 36, 123, 98, 46, 79, 97, 46, 86, 97, 32, 63, 32, 98, 46, 79, 97, 46, 86, 97, 46, 110, 97, 109, 101, 32, 58, 32, 98, 46, 79, 97, 46, 82, 97, 46, 110, 97, 109, 101, 125, 32, 116, 111, 32, 112, 97, 114, 97, 109, 101, 116, 101, 114, 32, 116, 121, 112, 101, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 49, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 98, 46, 79, 97, 46, 84, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 50, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 46, 79, 97, 46, 86, 97, 32, 61, 61, 61, 32, 116, 104, 105, 115, 41, 32, 99, 32, 61, 32, 98, 46, 79, 97, 46, 84, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 98, 46, 99, 108, 111, 110, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 116, 104, 105, 115, 46, 121, 98, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 106, 98, 40, 40, 41, 32, 61, 62, 32, 100, 91, 34, 100, 101, 108, 101, 116, 101, 34, 93, 40, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 97, 32, 38, 38, 32, 97, 46, 112, 117, 115, 104, 40, 116, 104, 105, 115, 46, 89, 97, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 102, 97, 117, 108, 116, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 82, 40, 34, 85, 110, 115, 117, 112, 112, 111, 114, 116, 105, 110, 103, 32, 115, 104, 97, 114, 105, 110, 103, 32, 112, 111, 108, 105, 99, 121, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 107, 98, 40, 97, 44, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 110, 117, 108, 108, 32, 61, 61, 61, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 104, 98, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 82, 40, 96, 110, 117, 108, 108, 32, 105, 115, 32, 110, 111, 116, 32, 97, 32, 118, 97, 108, 105, 100, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 46, 79, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 82, 40, 96, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 34, 36, 123, 104, 98, 40, 98, 41, 125, 34, 32, 97, 115, 32, 97, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 46, 79, 97, 46, 80, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 82, 40, 96, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 100, 101, 108, 101, 116, 101, 100, 32, 111, 98, 106, 101, 99, 116, 32, 97, 115, 32, 97, 32, 112, 111, 105, 110, 116, 101, 114, 32, 111, 102, 32, 116, 121, 112, 101, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 46, 79, 97, 46, 82, 97, 46, 102, 98, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 82, 40, 96, 67, 97, 110, 110, 111, 116, 32, 99, 111, 110, 118, 101, 114, 116, 32, 97, 114, 103, 117, 109, 101, 110, 116, 32, 111, 102, 32, 116, 121, 112, 101, 32, 36, 123, 98, 46, 79, 97, 46, 82, 97, 46, 110, 97, 109, 101, 125, 32, 116, 111, 32, 112, 97, 114, 97, 109, 101, 116, 101, 114, 32, 116, 121, 112, 101, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 98, 40, 98, 46, 79, 97, 46, 80, 97, 44, 32, 98, 46, 79, 97, 46, 82, 97, 46, 81, 97, 44, 32, 116, 104, 105, 115, 46, 81, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 108, 98, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 108, 44, 32, 109, 44, 32, 110, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 110, 97, 109, 101, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 81, 97, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 104, 98, 32, 61, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 102, 98, 32, 61, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 103, 98, 32, 61, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 119, 98, 32, 61, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 67, 98, 32, 61, 32, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 109, 98, 32, 61, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 105, 98, 32, 61, 32, 108, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 121, 98, 32, 61, 32, 109, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 89, 97, 32, 61, 32, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 124, 124, 32, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 98, 46, 85, 97, 32, 63, 32, 116, 104, 105, 115, 46, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 32, 61, 32, 105, 98, 32, 58, 32, 40, 116, 104, 105, 115, 46, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 32, 61, 32, 100, 32, 63, 32, 103, 98, 32, 58, 32, 107, 98, 44, 32, 116, 104, 105, 115, 46, 88, 97, 32, 61, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 109, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 107, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 97, 41, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 77, 97, 40, 34, 82, 101, 112, 108, 97, 99, 105, 110, 103, 32, 110, 111, 110, 101, 120, 105, 115, 116, 101, 110, 116, 32, 112, 117, 98, 108, 105, 99, 32, 115, 121, 109, 98, 111, 108, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 107, 91, 97, 93, 46, 83, 97, 32, 38, 38, 32, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 99, 32, 63, 32, 107, 91, 97, 93, 46, 83, 97, 91, 99, 93, 32, 61, 32, 98, 32, 58, 32, 40, 107, 91, 97, 93, 32, 61, 32, 98, 44, 32, 107, 91, 97, 93, 46, 97, 98, 32, 61, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 83, 44, 32, 110, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 32, 61, 32, 91, 93, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 106, 34, 41, 32, 63, 32, 40, 97, 32, 61, 32, 97, 46, 114, 101, 112, 108, 97, 99, 101, 40, 47, 112, 47, 103, 44, 32, 34, 105, 34, 41, 44, 32, 98, 32, 61, 32, 40, 48, 44, 32, 107, 91, 34, 100, 121, 110, 67, 97, 108, 108, 95, 34, 32, 43, 32, 97, 93, 41, 40, 98, 44, 32, 46, 46, 46, 99, 41, 41, 32, 58, 32, 98, 32, 61, 32, 83, 46, 103, 101, 116, 40, 98, 41, 40, 46, 46, 46, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 111, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 40, 46, 46, 46, 99, 41, 32, 61, 62, 32, 110, 98, 40, 97, 44, 32, 98, 44, 32, 99, 41, 44, 32, 84, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 81, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 97, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 106, 34, 41, 32, 63, 32, 111, 98, 40, 97, 44, 32, 98, 41, 32, 58, 32, 83, 46, 103, 101, 116, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 33, 61, 32, 116, 121, 112, 101, 111, 102, 32, 99, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 82, 40, 96, 117, 110, 107, 110, 111, 119, 110, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 112, 111, 105, 110, 116, 101, 114, 32, 119, 105, 116, 104, 32, 115, 105, 103, 110, 97, 116, 117, 114, 101, 32, 36, 123, 97, 125, 58, 32, 36, 123, 98, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 112, 98, 44, 32, 114, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 113, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 81, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 85, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 115, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 99, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 91, 102, 93, 32, 124, 124, 32, 78, 91, 102, 93, 32, 124, 124, 32, 40, 76, 97, 91, 102, 93, 32, 63, 32, 76, 97, 91, 102, 93, 46, 102, 111, 114, 69, 97, 99, 104, 40, 99, 41, 32, 58, 32, 40, 100, 46, 112, 117, 115, 104, 40, 102, 41, 44, 32, 101, 91, 102, 93, 32, 61, 32, 116, 114, 117, 101, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 91, 93, 44, 32, 101, 32, 61, 32, 123, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 46, 102, 111, 114, 69, 97, 99, 104, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 112, 98, 40, 96, 36, 123, 97, 125, 58, 32, 96, 32, 43, 32, 100, 46, 109, 97, 112, 40, 114, 98, 41, 46, 106, 111, 105, 110, 40, 91, 34, 44, 32, 34, 93, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 116, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 99, 32, 61, 32, 91, 93, 44, 32, 100, 32, 61, 32, 48, 59, 32, 100, 32, 60, 32, 97, 59, 32, 100, 43, 43, 41, 32, 99, 46, 112, 117, 115, 104, 40, 66, 91, 98, 32, 43, 32, 52, 32, 42, 32, 100, 32, 62, 62, 32, 50, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 117, 98, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 98, 32, 61, 32, 49, 59, 32, 98, 32, 60, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 32, 43, 43, 98, 41, 32, 105, 102, 32, 40, 110, 117, 108, 108, 32, 33, 61, 61, 32, 97, 91, 98, 93, 32, 38, 38, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 97, 91, 98, 93, 46, 88, 97, 41, 32, 114, 101, 116, 117, 114, 110, 32, 116, 114, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 118, 98, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 98, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 50, 32, 62, 32, 102, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 82, 40, 34, 97, 114, 103, 84, 121, 112, 101, 115, 32, 97, 114, 114, 97, 121, 32, 115, 105, 122, 101, 32, 109, 105, 115, 109, 97, 116, 99, 104, 33, 32, 77, 117, 115, 116, 32, 97, 116, 32, 108, 101, 97, 115, 116, 32, 103, 101, 116, 32, 114, 101, 116, 117, 114, 110, 32, 118, 97, 108, 117, 101, 32, 97, 110, 100, 32, 39, 116, 104, 105, 115, 39, 32, 116, 121, 112, 101, 115, 33, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 98, 91, 49, 93, 32, 38, 38, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 99, 44, 32, 103, 32, 61, 32, 117, 98, 40, 98, 41, 44, 32, 108, 32, 61, 32, 34, 118, 111, 105, 100, 34, 32, 33, 61, 61, 32, 98, 91, 48, 93, 46, 110, 97, 109, 101, 44, 32, 109, 32, 61, 32, 102, 32, 45, 32, 50, 44, 32, 110, 32, 61, 32, 65, 114, 114, 97, 121, 40, 109, 41, 44, 32, 112, 32, 61, 32, 91, 93, 44, 32, 116, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 98, 40, 97, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 46, 46, 46, 69, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 46, 108, 101, 110, 103, 116, 104, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 112, 46, 108, 101, 110, 103, 116, 104, 32, 61, 32, 104, 32, 63, 32, 50, 32, 58, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 112, 91, 48, 93, 32, 61, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 104, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 118, 32, 61, 32, 98, 91, 49, 93, 46, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 40, 116, 44, 32, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 112, 91, 49, 93, 32, 61, 32, 118, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 119, 32, 61, 32, 48, 59, 32, 119, 32, 60, 32, 109, 59, 32, 43, 43, 119, 41, 32, 110, 91, 119, 93, 32, 61, 32, 98, 91, 119, 32, 43, 32, 50, 93, 46, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 40, 116, 44, 32, 69, 91, 119, 93, 41, 44, 32, 112, 46, 112, 117, 115, 104, 40, 110, 91, 119, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 69, 32, 61, 32, 100, 40, 46, 46, 46, 112, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 103, 41, 32, 75, 97, 40, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 119, 32, 61, 32, 104, 32, 63, 32, 49, 32, 58, 32, 50, 59, 32, 119, 32, 60, 32, 98, 46, 108, 101, 110, 103, 116, 104, 59, 32, 119, 43, 43, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 72, 32, 61, 32, 49, 32, 61, 61, 61, 32, 119, 32, 63, 32, 118, 32, 58, 32, 110, 91, 119, 32, 45, 32, 50, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 98, 91, 119, 93, 46, 88, 97, 32, 38, 38, 32, 98, 91, 119, 93, 46, 88, 97, 40, 72, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 32, 61, 32, 108, 32, 63, 32, 98, 91, 48, 93, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 69, 41, 32, 58, 32, 118, 111, 105, 100, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 118, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 119, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 97, 46, 116, 114, 105, 109, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 98, 32, 61, 32, 97, 46, 105, 110, 100, 101, 120, 79, 102, 40, 34, 40, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 45, 49, 32, 33, 61, 61, 32, 98, 32, 63, 32, 97, 46, 115, 117, 98, 115, 116, 114, 40, 48, 44, 32, 98, 41, 32, 58, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 121, 98, 32, 61, 32, 91, 93, 44, 32, 86, 32, 61, 32, 91, 93, 44, 32, 122, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 57, 32, 60, 32, 97, 32, 38, 38, 32, 48, 32, 61, 61, 61, 32, 45, 45, 86, 91, 97, 32, 43, 32, 49, 93, 32, 38, 38, 32, 40, 86, 91, 97, 93, 32, 61, 32, 118, 111, 105, 100, 32, 48, 44, 32, 121, 98, 46, 112, 117, 115, 104, 40, 97, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 65, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 82, 40, 34, 67, 97, 110, 110, 111, 116, 32, 117, 115, 101, 32, 100, 101, 108, 101, 116, 101, 100, 32, 118, 97, 108, 46, 32, 104, 97, 110, 100, 108, 101, 32, 61, 32, 34, 32, 43, 32, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 86, 91, 97, 93, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 106, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 119, 105, 116, 99, 104, 32, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 118, 111, 105, 100, 32, 48, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 110, 117, 108, 108, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 52, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 116, 114, 117, 101, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 54, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 102, 97, 108, 115, 101, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 56, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 102, 97, 117, 108, 116, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 98, 32, 61, 32, 121, 98, 46, 112, 111, 112, 40, 41, 32, 124, 124, 32, 86, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 86, 91, 98, 93, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 86, 91, 98, 32, 43, 32, 49, 93, 32, 61, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 66, 98, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 34, 101, 109, 115, 99, 114, 105, 112, 116, 101, 110, 58, 58, 118, 97, 108, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 65, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 122, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 106, 98, 40, 98, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 87, 97, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 76, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 88, 97, 58, 32, 110, 117, 108, 108, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 67, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 119, 105, 116, 99, 104, 32, 40, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 49, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 32, 63, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 117, 91, 100, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 120, 91, 100, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 50, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 32, 63, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 121, 91, 100, 32, 62, 62, 32, 49, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 122, 91, 100, 32, 62, 62, 32, 49, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 52, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 32, 63, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 65, 91, 100, 32, 62, 62, 32, 50, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 66, 91, 100, 32, 62, 62, 32, 50, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 102, 97, 117, 108, 116, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 84, 121, 112, 101, 69, 114, 114, 111, 114, 40, 96, 105, 110, 118, 97, 108, 105, 100, 32, 105, 110, 116, 101, 103, 101, 114, 32, 119, 105, 100, 116, 104, 32, 40, 36, 123, 98, 125, 41, 58, 32, 36, 123, 97, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 68, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 78, 91, 97, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 99, 41, 32, 116, 104, 114, 111, 119, 32, 97, 32, 61, 32, 96, 36, 123, 98, 125, 32, 104, 97, 115, 32, 117, 110, 107, 110, 111, 119, 110, 32, 116, 121, 112, 101, 32, 36, 123, 114, 98, 40, 97, 41, 125, 96, 44, 32, 110, 101, 119, 32, 82, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 104, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 110, 117, 108, 108, 32, 61, 61, 61, 32, 97, 41, 32, 114, 101, 116, 117, 114, 110, 32, 34, 110, 117, 108, 108, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 116, 121, 112, 101, 111, 102, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 111, 98, 106, 101, 99, 116, 34, 32, 61, 61, 61, 32, 98, 32, 124, 124, 32, 34, 97, 114, 114, 97, 121, 34, 32, 61, 61, 61, 32, 98, 32, 124, 124, 32, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 61, 61, 61, 32, 98, 32, 63, 32, 97, 46, 116, 111, 83, 116, 114, 105, 110, 103, 40, 41, 32, 58, 32, 34, 34, 32, 43, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 69, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 119, 105, 116, 99, 104, 32, 40, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 52, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 111, 97, 91, 99, 32, 62, 62, 32, 50, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 56, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 112, 97, 91, 99, 32, 62, 62, 32, 51, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 102, 97, 117, 108, 116, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 84, 121, 112, 101, 69, 114, 114, 111, 114, 40, 96, 105, 110, 118, 97, 108, 105, 100, 32, 102, 108, 111, 97, 116, 32, 119, 105, 100, 116, 104, 32, 40, 36, 123, 98, 125, 41, 58, 32, 36, 123, 97, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 70, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 119, 105, 116, 99, 104, 32, 40, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 49, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 32, 63, 32, 40, 100, 41, 32, 61, 62, 32, 117, 91, 100, 93, 32, 58, 32, 40, 100, 41, 32, 61, 62, 32, 120, 91, 100, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 50, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 32, 63, 32, 40, 100, 41, 32, 61, 62, 32, 121, 91, 100, 32, 62, 62, 32, 49, 93, 32, 58, 32, 40, 100, 41, 32, 61, 62, 32, 122, 91, 100, 32, 62, 62, 32, 49, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 52, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 32, 63, 32, 40, 100, 41, 32, 61, 62, 32, 65, 91, 100, 32, 62, 62, 32, 50, 93, 32, 58, 32, 40, 100, 41, 32, 61, 62, 32, 66, 91, 100, 32, 62, 62, 32, 50, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 102, 97, 117, 108, 116, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 84, 121, 112, 101, 69, 114, 114, 111, 114, 40, 96, 105, 110, 118, 97, 108, 105, 100, 32, 105, 110, 116, 101, 103, 101, 114, 32, 119, 105, 100, 116, 104, 32, 40, 36, 123, 98, 125, 41, 58, 32, 36, 123, 97, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 71, 98, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 97, 115, 115, 105, 103, 110, 40, 123, 32, 111, 112, 116, 105, 111, 110, 97, 108, 58, 32, 116, 114, 117, 101, 32, 125, 44, 32, 66, 98, 41, 44, 32, 72, 98, 32, 61, 32, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 32, 33, 61, 32, 116, 121, 112, 101, 111, 102, 32, 84, 101, 120, 116, 68, 101, 99, 111, 100, 101, 114, 32, 63, 32, 110, 101, 119, 32, 84, 101, 120, 116, 68, 101, 99, 111, 100, 101, 114, 40, 34, 117, 116, 102, 45, 49, 54, 108, 101, 34, 41, 32, 58, 32, 118, 111, 105, 100, 32, 48, 44, 32, 73, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 97, 32, 62, 62, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 100, 32, 61, 32, 99, 32, 43, 32, 98, 32, 47, 32, 50, 59, 32, 33, 40, 99, 32, 62, 61, 32, 100, 41, 32, 38, 38, 32, 122, 91, 99, 93, 59, 32, 41, 32, 43, 43, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 60, 60, 61, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 51, 50, 32, 60, 32, 99, 32, 45, 32, 97, 32, 38, 38, 32, 72, 98, 41, 32, 114, 101, 116, 117, 114, 110, 32, 72, 98, 46, 100, 101, 99, 111, 100, 101, 40, 120, 46, 115, 117, 98, 97, 114, 114, 97, 121, 40, 97, 44, 32, 99, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 34, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 100, 32, 61, 32, 48, 59, 32, 33, 40, 100, 32, 62, 61, 32, 98, 32, 47, 32, 50, 41, 59, 32, 43, 43, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 121, 91, 97, 32, 43, 32, 50, 32, 42, 32, 100, 32, 62, 62, 32, 49, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 48, 32, 61, 61, 32, 101, 41, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 74, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 63, 63, 32, 40, 99, 32, 61, 32, 50, 49, 52, 55, 52, 56, 51, 54, 52, 55, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 50, 32, 62, 32, 99, 41, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 45, 61, 32, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 99, 32, 60, 32, 50, 32, 42, 32, 97, 46, 108, 101, 110, 103, 116, 104, 32, 63, 32, 99, 32, 47, 32, 50, 32, 58, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 101, 32, 61, 32, 48, 59, 32, 101, 32, 60, 32, 99, 59, 32, 43, 43, 101, 41, 32, 121, 91, 98, 32, 62, 62, 32, 49, 93, 32, 61, 32, 97, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 101, 41, 44, 32, 98, 32, 43, 61, 32, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 121, 91, 98, 32, 62, 62, 32, 49, 93, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 32, 45, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 75, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 50, 32, 42, 32, 97, 46, 108, 101, 110, 103, 116, 104, 44, 32, 76, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 99, 32, 61, 32, 48, 44, 32, 100, 32, 61, 32, 34, 34, 59, 32, 33, 40, 99, 32, 62, 61, 32, 98, 32, 47, 32, 52, 41, 59, 32, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 65, 91, 97, 32, 43, 32, 52, 32, 42, 32, 99, 32, 62, 62, 32, 50, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 48, 32, 61, 61, 32, 101, 41, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 43, 43, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 54, 53, 53, 51, 54, 32, 60, 61, 32, 101, 32, 63, 32, 40, 101, 32, 45, 61, 32, 54, 53, 53, 51, 54, 44, 32, 100, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 53, 53, 50, 57, 54, 32, 124, 32, 101, 32, 62, 62, 32, 49, 48, 44, 32, 53, 54, 51, 50, 48, 32, 124, 32, 101, 32, 38, 32, 49, 48, 50, 51, 41, 41, 32, 58, 32, 100, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 77, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 63, 63, 32, 40, 99, 32, 61, 32, 50, 49, 52, 55, 52, 56, 51, 54, 52, 55, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 52, 32, 62, 32, 99, 41, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 100, 32, 43, 32, 99, 32, 45, 32, 52, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 101, 32, 61, 32, 48, 59, 32, 101, 32, 60, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 32, 43, 43, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 97, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 53, 53, 50, 57, 54, 32, 60, 61, 32, 102, 32, 38, 38, 32, 53, 55, 51, 52, 51, 32, 62, 61, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 97, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 43, 43, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 32, 61, 32, 54, 53, 53, 51, 54, 32, 43, 32, 40, 40, 102, 32, 38, 32, 49, 48, 50, 51, 41, 32, 60, 60, 32, 49, 48, 41, 32, 124, 32, 104, 32, 38, 32, 49, 48, 50, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 65, 91, 98, 32, 62, 62, 32, 50, 93, 32, 61, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 43, 61, 32, 52, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 32, 43, 32, 52, 32, 62, 32, 99, 41, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 65, 91, 98, 32, 62, 62, 32, 50, 93, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 32, 45, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 78, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 98, 32, 61, 32, 48, 44, 32, 99, 32, 61, 32, 48, 59, 32, 99, 32, 60, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 32, 43, 43, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 97, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 53, 53, 50, 57, 54, 32, 60, 61, 32, 100, 32, 38, 38, 32, 53, 55, 51, 52, 51, 32, 62, 61, 32, 100, 32, 38, 38, 32, 43, 43, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 43, 61, 32, 52, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 79, 98, 32, 61, 32, 48, 44, 32, 80, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 97, 46, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 40, 100, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 46, 108, 101, 110, 103, 116, 104, 32, 38, 38, 32, 40, 66, 91, 98, 32, 62, 62, 32, 50, 93, 32, 61, 32, 106, 98, 40, 100, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 81, 98, 32, 61, 32, 91, 93, 44, 32, 82, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 81, 98, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 81, 98, 46, 112, 117, 115, 104, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 83, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 99, 32, 61, 32, 65, 114, 114, 97, 121, 40, 97, 41, 44, 32, 100, 32, 61, 32, 48, 59, 32, 100, 32, 60, 32, 97, 59, 32, 43, 43, 100, 41, 32, 99, 91, 100, 93, 32, 61, 32, 68, 98, 40, 66, 91, 98, 32, 43, 32, 52, 32, 42, 32, 100, 32, 62, 62, 32, 50, 93, 44, 32, 34, 112, 97, 114, 97, 109, 101, 116, 101, 114, 32, 34, 32, 43, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 84, 98, 32, 61, 32, 82, 101, 102, 108, 101, 99, 116, 46, 99, 111, 110, 115, 116, 114, 117, 99, 116, 44, 32, 85, 98, 32, 61, 32, 123, 125, 44, 32, 86, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 40, 97, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 66, 97, 32, 124, 124, 32, 34, 117, 110, 119, 105, 110, 100, 34, 32, 61, 61, 32, 97, 41, 41, 32, 116, 104, 114, 111, 119, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 87, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 68, 97, 32, 124, 124, 32, 48, 32, 60, 32, 79, 98, 32, 124, 124, 32, 40, 107, 46, 111, 110, 69, 120, 105, 116, 63, 46, 40, 97, 41, 44, 32, 109, 97, 32, 61, 32, 116, 114, 117, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 66, 97, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 88, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 109, 97, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 97, 40, 41, 44, 32, 33, 40, 68, 97, 32, 124, 124, 32, 48, 32, 60, 32, 79, 98, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 32, 61, 32, 97, 32, 61, 32, 110, 97, 44, 32, 87, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 86, 98, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 86, 98, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 89, 98, 32, 61, 32, 123, 125, 44, 32, 36, 98, 32, 61, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 90, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 97, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 83, 69, 82, 58, 32, 34, 119, 101, 98, 95, 117, 115, 101, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 76, 79, 71, 78, 65, 77, 69, 58, 32, 34, 119, 101, 98, 95, 117, 115, 101, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 80, 65, 84, 72, 58, 32, 34, 47, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 80, 87, 68, 58, 32, 34, 47, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 72, 79, 77, 69, 58, 32, 34, 47, 104, 111, 109, 101, 47, 119, 101, 98, 95, 117, 115, 101, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 76, 65, 78, 71, 58, 32, 40, 34, 111, 98, 106, 101, 99, 116, 34, 32, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 110, 97, 118, 105, 103, 97, 116, 111, 114, 32, 38, 38, 32, 110, 97, 118, 105, 103, 97, 116, 111, 114, 46, 108, 97, 110, 103, 117, 97, 103, 101, 115, 32, 38, 38, 32, 110, 97, 118, 105, 103, 97, 116, 111, 114, 46, 108, 97, 110, 103, 117, 97, 103, 101, 115, 91, 48, 93, 32, 124, 124, 32, 34, 67, 34, 41, 46, 114, 101, 112, 108, 97, 99, 101, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 34, 45, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 34, 95, 34, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 32, 43, 32, 34, 46, 85, 84, 70, 45, 56, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 95, 58, 32, 101, 97, 32, 124, 124, 32, 34, 46, 47, 116, 104, 105, 115, 46, 112, 114, 111, 103, 114, 97, 109, 34, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 98, 32, 105, 110, 32, 89, 98, 41, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 89, 98, 91, 98, 93, 32, 63, 32, 100, 101, 108, 101, 116, 101, 32, 97, 91, 98, 93, 32, 58, 32, 97, 91, 98, 93, 32, 61, 32, 89, 98, 91, 98, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 98, 32, 105, 110, 32, 97, 41, 32, 99, 46, 112, 117, 115, 104, 40, 96, 36, 123, 98, 125, 61, 36, 123, 97, 91, 98, 93, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 90, 98, 32, 61, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 90, 98, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 90, 98, 44, 32, 97, 99, 32, 61, 32, 91, 110, 117, 108, 108, 44, 32, 91, 93, 44, 32, 91, 93, 93, 44, 32, 98, 99, 32, 61, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 34, 111, 98, 106, 101, 99, 116, 34, 32, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 99, 114, 121, 112, 116, 111, 32, 38, 38, 32, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 99, 114, 121, 112, 116, 111, 46, 103, 101, 116, 82, 97, 110, 100, 111, 109, 86, 97, 108, 117, 101, 115, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 97, 41, 32, 61, 62, 32, 99, 114, 121, 112, 116, 111, 46, 103, 101, 116, 82, 97, 110, 100, 111, 109, 86, 97, 108, 117, 101, 115, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 40, 34, 105, 110, 105, 116, 82, 97, 110, 100, 111, 109, 68, 101, 118, 105, 99, 101, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 99, 99, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 40, 99, 99, 32, 61, 32, 98, 99, 40, 41, 41, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 77, 97, 32, 61, 32, 107, 46, 73, 110, 116, 101, 114, 110, 97, 108, 69, 114, 114, 111, 114, 32, 61, 32, 99, 108, 97, 115, 115, 32, 101, 120, 116, 101, 110, 100, 115, 32, 69, 114, 114, 111, 114, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 117, 112, 101, 114, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 110, 97, 109, 101, 32, 61, 32, 34, 73, 110, 116, 101, 114, 110, 97, 108, 69, 114, 114, 111, 114, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 100, 99, 32, 61, 32, 65, 114, 114, 97, 121, 40, 50, 53, 54, 41, 44, 32, 101, 99, 32, 61, 32, 48, 59, 32, 50, 53, 54, 32, 62, 32, 101, 99, 59, 32, 43, 43, 101, 99, 41, 32, 100, 99, 91, 101, 99, 93, 32, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 101, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 78, 97, 32, 61, 32, 100, 99, 59, 10, 32, 32, 32, 32, 32, 32, 82, 32, 61, 32, 107, 46, 66, 105, 110, 100, 105, 110, 103, 69, 114, 114, 111, 114, 32, 61, 32, 99, 108, 97, 115, 115, 32, 101, 120, 116, 101, 110, 100, 115, 32, 69, 114, 114, 111, 114, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 117, 112, 101, 114, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 110, 97, 109, 101, 32, 61, 32, 34, 66, 105, 110, 100, 105, 110, 103, 69, 114, 114, 111, 114, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 79, 98, 106, 101, 99, 116, 46, 97, 115, 115, 105, 103, 110, 40, 36, 97, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 65, 108, 105, 97, 115, 79, 102, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 40, 116, 104, 105, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 36, 97, 32, 38, 38, 32, 97, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 36, 97, 41, 41, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 116, 104, 105, 115, 46, 79, 97, 46, 82, 97, 46, 81, 97, 44, 32, 99, 32, 61, 32, 116, 104, 105, 115, 46, 79, 97, 46, 80, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 79, 97, 32, 61, 32, 97, 46, 79, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 97, 46, 79, 97, 46, 82, 97, 46, 81, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 97, 32, 61, 32, 97, 46, 79, 97, 46, 80, 97, 59, 32, 98, 46, 85, 97, 59, 32, 41, 32, 99, 32, 61, 32, 98, 46, 101, 98, 40, 99, 41, 44, 32, 98, 32, 61, 32, 98, 46, 85, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 59, 32, 100, 46, 85, 97, 59, 32, 41, 32, 97, 32, 61, 32, 100, 46, 101, 98, 40, 97, 41, 44, 32, 100, 32, 61, 32, 100, 46, 85, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 32, 61, 61, 61, 32, 100, 32, 38, 38, 32, 99, 32, 61, 61, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 108, 111, 110, 101, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 79, 97, 46, 80, 97, 32, 124, 124, 32, 81, 97, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 79, 97, 46, 99, 98, 41, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 79, 97, 46, 99, 111, 117, 110, 116, 46, 118, 97, 108, 117, 101, 32, 43, 61, 32, 49, 44, 32, 116, 104, 105, 115, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 97, 32, 61, 32, 88, 97, 44, 32, 98, 32, 61, 32, 79, 98, 106, 101, 99, 116, 44, 32, 99, 32, 61, 32, 98, 46, 99, 114, 101, 97, 116, 101, 44, 32, 100, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 103, 101, 116, 80, 114, 111, 116, 111, 116, 121, 112, 101, 79, 102, 40, 116, 104, 105, 115, 41, 44, 32, 101, 32, 61, 32, 116, 104, 105, 115, 46, 79, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 97, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 46, 99, 97, 108, 108, 40, 98, 44, 32, 100, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 97, 58, 32, 123, 32, 118, 97, 108, 117, 101, 58, 32, 123, 32, 99, 111, 117, 110, 116, 58, 32, 101, 46, 99, 111, 117, 110, 116, 44, 32, 98, 98, 58, 32, 101, 46, 98, 98, 44, 32, 99, 98, 58, 32, 101, 46, 99, 98, 44, 32, 80, 97, 58, 32, 101, 46, 80, 97, 44, 32, 82, 97, 58, 32, 101, 46, 82, 97, 44, 32, 84, 97, 58, 32, 101, 46, 84, 97, 44, 32, 86, 97, 58, 32, 101, 46, 86, 97, 32, 125, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 79, 97, 46, 99, 111, 117, 110, 116, 46, 118, 97, 108, 117, 101, 32, 43, 61, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 79, 97, 46, 98, 98, 32, 61, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 91, 34, 100, 101, 108, 101, 116, 101, 34, 93, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 79, 97, 46, 80, 97, 32, 124, 124, 32, 81, 97, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 79, 97, 46, 98, 98, 32, 38, 38, 32, 33, 116, 104, 105, 115, 46, 79, 97, 46, 99, 98, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 82, 40, 34, 79, 98, 106, 101, 99, 116, 32, 97, 108, 114, 101, 97, 100, 121, 32, 115, 99, 104, 101, 100, 117, 108, 101, 100, 32, 102, 111, 114, 32, 100, 101, 108, 101, 116, 105, 111, 110, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 97, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 97, 32, 61, 32, 116, 104, 105, 115, 46, 79, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 45, 45, 97, 46, 99, 111, 117, 110, 116, 46, 118, 97, 108, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 48, 32, 61, 61, 61, 32, 97, 46, 99, 111, 117, 110, 116, 46, 118, 97, 108, 117, 101, 32, 38, 38, 32, 40, 97, 46, 84, 97, 32, 63, 32, 97, 46, 86, 97, 46, 89, 97, 40, 97, 46, 84, 97, 41, 32, 58, 32, 97, 46, 82, 97, 46, 81, 97, 46, 89, 97, 40, 97, 46, 80, 97, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 79, 97, 46, 99, 98, 32, 124, 124, 32, 40, 116, 104, 105, 115, 46, 79, 97, 46, 84, 97, 32, 61, 32, 118, 111, 105, 100, 32, 48, 44, 32, 116, 104, 105, 115, 46, 79, 97, 46, 80, 97, 32, 61, 32, 118, 111, 105, 100, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 68, 101, 108, 101, 116, 101, 100, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 33, 116, 104, 105, 115, 46, 79, 97, 46, 80, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 108, 101, 116, 101, 76, 97, 116, 101, 114, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 79, 97, 46, 80, 97, 32, 124, 124, 32, 81, 97, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 79, 97, 46, 98, 98, 32, 38, 38, 32, 33, 116, 104, 105, 115, 46, 79, 97, 46, 99, 98, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 82, 40, 34, 79, 98, 106, 101, 99, 116, 32, 97, 108, 114, 101, 97, 100, 121, 32, 115, 99, 104, 101, 100, 117, 108, 101, 100, 32, 102, 111, 114, 32, 100, 101, 108, 101, 116, 105, 111, 110, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 90, 97, 46, 112, 117, 115, 104, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 79, 97, 46, 98, 98, 32, 61, 32, 116, 114, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 79, 98, 106, 101, 99, 116, 46, 97, 115, 115, 105, 103, 110, 40, 108, 98, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 98, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 109, 98, 32, 38, 38, 32, 40, 97, 32, 61, 32, 116, 104, 105, 115, 46, 109, 98, 40, 97, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 98, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 89, 97, 63, 46, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 87, 97, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 76, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 98, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 103, 98, 32, 63, 32, 89, 97, 40, 116, 104, 105, 115, 46, 81, 97, 46, 36, 97, 44, 32, 123, 32, 82, 97, 58, 32, 116, 104, 105, 115, 46, 119, 98, 44, 32, 80, 97, 58, 32, 99, 44, 32, 86, 97, 58, 32, 116, 104, 105, 115, 44, 32, 84, 97, 58, 32, 97, 32, 125, 41, 32, 58, 32, 89, 97, 40, 116, 104, 105, 115, 46, 81, 97, 46, 36, 97, 44, 32, 123, 32, 82, 97, 58, 32, 116, 104, 105, 115, 44, 32, 80, 97, 58, 32, 97, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 116, 104, 105, 115, 46, 114, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 99, 41, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 107, 98, 40, 97, 41, 44, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 87, 97, 40, 116, 104, 105, 115, 46, 81, 97, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 48, 32, 61, 61, 61, 32, 100, 46, 79, 97, 46, 99, 111, 117, 110, 116, 46, 118, 97, 108, 117, 101, 41, 32, 114, 101, 116, 117, 114, 110, 32, 100, 46, 79, 97, 46, 80, 97, 32, 61, 32, 99, 44, 32, 100, 46, 79, 97, 46, 84, 97, 32, 61, 32, 97, 44, 32, 100, 46, 99, 108, 111, 110, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 100, 46, 99, 108, 111, 110, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 107, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 116, 104, 105, 115, 46, 81, 97, 46, 113, 98, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 85, 97, 91, 100, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 100, 41, 32, 114, 101, 116, 117, 114, 110, 32, 98, 46, 99, 97, 108, 108, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 116, 104, 105, 115, 46, 102, 98, 32, 63, 32, 100, 46, 110, 98, 32, 58, 32, 100, 46, 112, 111, 105, 110, 116, 101, 114, 84, 121, 112, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 84, 97, 40, 99, 44, 32, 116, 104, 105, 115, 46, 81, 97, 44, 32, 100, 46, 81, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 110, 117, 108, 108, 32, 61, 61, 61, 32, 101, 32, 63, 32, 98, 46, 99, 97, 108, 108, 40, 116, 104, 105, 115, 41, 32, 58, 32, 116, 104, 105, 115, 46, 103, 98, 32, 63, 32, 89, 97, 40, 100, 46, 81, 97, 46, 36, 97, 44, 32, 123, 32, 82, 97, 58, 32, 100, 44, 32, 80, 97, 58, 32, 101, 44, 32, 86, 97, 58, 32, 116, 104, 105, 115, 44, 32, 84, 97, 58, 32, 97, 32, 125, 41, 32, 58, 32, 89, 97, 40, 100, 46, 81, 97, 46, 36, 97, 44, 32, 123, 32, 82, 97, 58, 32, 100, 44, 32, 80, 97, 58, 32, 101, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 112, 98, 32, 61, 32, 107, 46, 85, 110, 98, 111, 117, 110, 100, 84, 121, 112, 101, 69, 114, 114, 111, 114, 32, 61, 32, 40, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 97, 98, 40, 98, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 110, 97, 109, 101, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 109, 101, 115, 115, 97, 103, 101, 32, 61, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 69, 114, 114, 111, 114, 40, 100, 41, 46, 115, 116, 97, 99, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 100, 32, 38, 38, 32, 40, 116, 104, 105, 115, 46, 115, 116, 97, 99, 107, 32, 61, 32, 116, 104, 105, 115, 46, 116, 111, 83, 116, 114, 105, 110, 103, 40, 41, 32, 43, 32, 34, 92, 110, 34, 32, 43, 32, 100, 46, 114, 101, 112, 108, 97, 99, 101, 40, 47, 94, 69, 114, 114, 111, 114, 40, 58, 91, 94, 92, 110, 93, 42, 41, 63, 92, 110, 47, 44, 32, 34, 34, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 99, 114, 101, 97, 116, 101, 40, 97, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 46, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 32, 61, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 46, 116, 111, 83, 116, 114, 105, 110, 103, 32, 61, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 116, 104, 105, 115, 46, 109, 101, 115, 115, 97, 103, 101, 32, 63, 32, 116, 104, 105, 115, 46, 110, 97, 109, 101, 32, 58, 32, 96, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 58, 32, 36, 123, 116, 104, 105, 115, 46, 109, 101, 115, 115, 97, 103, 101, 125, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 40, 69, 114, 114, 111, 114, 44, 32, 34, 85, 110, 98, 111, 117, 110, 100, 84, 121, 112, 101, 69, 114, 114, 111, 114, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 86, 46, 112, 117, 115, 104, 40, 48, 44, 32, 49, 44, 32, 118, 111, 105, 100, 32, 48, 44, 32, 49, 44, 32, 110, 117, 108, 108, 44, 32, 49, 44, 32, 116, 114, 117, 101, 44, 32, 49, 44, 32, 102, 97, 108, 115, 101, 44, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 99, 111, 117, 110, 116, 95, 101, 109, 118, 97, 108, 95, 104, 97, 110, 100, 108, 101, 115, 32, 61, 32, 40, 41, 32, 61, 62, 32, 86, 46, 108, 101, 110, 103, 116, 104, 32, 47, 32, 50, 32, 45, 32, 53, 32, 45, 32, 121, 98, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 120, 99, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 61, 62, 32, 118, 97, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 96, 65, 115, 115, 101, 114, 116, 105, 111, 110, 32, 102, 97, 105, 108, 101, 100, 58, 32, 36, 123, 97, 32, 63, 32, 71, 40, 120, 44, 32, 97, 41, 32, 58, 32, 34, 34, 125, 44, 32, 97, 116, 58, 32, 96, 32, 43, 32, 91, 98, 32, 63, 32, 98, 32, 63, 32, 71, 40, 120, 44, 32, 98, 41, 32, 58, 32, 34, 34, 32, 58, 32, 34, 117, 110, 107, 110, 111, 119, 110, 32, 102, 105, 108, 101, 110, 97, 109, 101, 34, 44, 32, 99, 44, 32, 100, 32, 63, 32, 100, 32, 63, 32, 71, 40, 120, 44, 32, 100, 41, 32, 58, 32, 34, 34, 32, 58, 32, 34, 117, 110, 107, 110, 111, 119, 110, 32, 102, 117, 110, 99, 116, 105, 111, 110, 34, 93, 10, 32, 32, 32, 32, 32, 32, 32, 32, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 58, 32, 40, 41, 32, 61, 62, 32, 72, 97, 40, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 110, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 110, 101, 119, 32, 70, 97, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 66, 91, 100, 46, 80, 97, 32, 43, 32, 49, 54, 32, 62, 62, 32, 50, 93, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 66, 91, 100, 46, 80, 97, 32, 43, 32, 52, 32, 62, 62, 32, 50, 93, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 66, 91, 100, 46, 80, 97, 32, 43, 32, 56, 32, 62, 62, 32, 50, 93, 32, 61, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 73, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 73, 97, 43, 43, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 73, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 101, 58, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 73, 32, 124, 124, 32, 40, 73, 32, 61, 32, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 73, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 84, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 81, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 82, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 86, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 83, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 88, 58, 32, 40, 41, 32, 61, 62, 32, 118, 97, 40, 34, 34, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 119, 58, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 74, 97, 91, 97, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 108, 101, 116, 101, 32, 74, 97, 91, 97, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 98, 46, 105, 98, 44, 32, 100, 32, 61, 32, 98, 46, 89, 97, 44, 32, 101, 32, 61, 32, 98, 46, 108, 98, 44, 32, 102, 32, 61, 32, 101, 46, 109, 97, 112, 40, 40, 104, 41, 32, 61, 62, 32, 104, 46, 117, 98, 41, 46, 99, 111, 110, 99, 97, 116, 40, 101, 46, 109, 97, 112, 40, 40, 104, 41, 32, 61, 62, 32, 104, 46, 65, 98, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 80, 40, 91, 97, 93, 44, 32, 102, 44, 32, 40, 104, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 103, 32, 61, 32, 123, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 108, 44, 32, 109, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 110, 32, 61, 32, 104, 91, 109, 93, 44, 32, 112, 32, 61, 32, 108, 46, 115, 98, 44, 32, 116, 32, 61, 32, 108, 46, 116, 98, 44, 32, 69, 32, 61, 32, 104, 91, 109, 32, 43, 32, 101, 46, 108, 101, 110, 103, 116, 104, 93, 44, 32, 118, 32, 61, 32, 108, 46, 122, 98, 44, 32, 119, 32, 61, 32, 108, 46, 66, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 91, 108, 46, 112, 98, 93, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 58, 32, 40, 72, 41, 32, 61, 62, 32, 110, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 112, 40, 116, 44, 32, 72, 41, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 119, 114, 105, 116, 101, 58, 32, 40, 72, 44, 32, 102, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 70, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 40, 119, 44, 32, 72, 44, 32, 69, 46, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 40, 70, 44, 32, 102, 97, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 75, 97, 40, 70, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 98, 46, 110, 97, 109, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 108, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 109, 32, 61, 32, 123, 125, 44, 32, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 110, 32, 105, 110, 32, 103, 41, 32, 109, 91, 110, 93, 32, 61, 32, 103, 91, 110, 93, 46, 114, 101, 97, 100, 40, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 40, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 108, 44, 32, 109, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 110, 32, 105, 110, 32, 103, 41, 32, 105, 102, 32, 40, 33, 40, 110, 32, 105, 110, 32, 109, 41, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 84, 121, 112, 101, 69, 114, 114, 111, 114, 40, 96, 77, 105, 115, 115, 105, 110, 103, 32, 102, 105, 101, 108, 100, 58, 32, 34, 36, 123, 110, 125, 34, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 112, 32, 61, 32, 99, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 110, 32, 105, 110, 32, 103, 41, 32, 103, 91, 110, 93, 46, 119, 114, 105, 116, 101, 40, 112, 44, 32, 109, 91, 110, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 108, 32, 38, 38, 32, 108, 46, 112, 117, 115, 104, 40, 100, 44, 32, 112, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 112, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 97, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 76, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 97, 58, 32, 100, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 72, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 97, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 81, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 40, 97, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 98, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 33, 33, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 101, 44, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 32, 63, 32, 99, 32, 58, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 97, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 120, 91, 101, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 97, 58, 32, 110, 117, 108, 108, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 117, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 108, 44, 32, 109, 44, 32, 110, 44, 32, 112, 44, 32, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 32, 61, 32, 81, 40, 110, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 32, 61, 32, 84, 40, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 38, 38, 32, 40, 103, 32, 61, 32, 84, 40, 104, 44, 32, 103, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 32, 38, 38, 32, 40, 109, 32, 61, 32, 84, 40, 108, 44, 32, 109, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 32, 61, 32, 84, 40, 112, 44, 32, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 69, 32, 61, 32, 100, 98, 40, 110, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 98, 40, 69, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 98, 40, 96, 67, 97, 110, 110, 111, 116, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 32, 36, 123, 110, 125, 32, 100, 117, 101, 32, 116, 111, 32, 117, 110, 98, 111, 117, 110, 100, 32, 116, 121, 112, 101, 115, 96, 44, 32, 91, 100, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 80, 40, 91, 97, 44, 32, 98, 44, 32, 99, 93, 44, 32, 100, 32, 63, 32, 91, 100, 93, 32, 58, 32, 91, 93, 44, 32, 40, 118, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 32, 61, 32, 118, 91, 48, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 119, 32, 61, 32, 118, 46, 81, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 72, 32, 61, 32, 119, 46, 36, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 72, 32, 61, 32, 36, 97, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 32, 61, 32, 97, 98, 40, 110, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 46, 46, 46, 80, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 79, 98, 106, 101, 99, 116, 46, 103, 101, 116, 80, 114, 111, 116, 111, 116, 121, 112, 101, 79, 102, 40, 116, 104, 105, 115, 41, 32, 33, 61, 61, 32, 102, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 82, 40, 34, 85, 115, 101, 32, 39, 110, 101, 119, 39, 32, 116, 111, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 32, 34, 32, 43, 32, 110, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 70, 46, 90, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 82, 40, 110, 32, 43, 32, 34, 32, 104, 97, 115, 32, 110, 111, 32, 97, 99, 99, 101, 115, 115, 105, 98, 108, 101, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 120, 98, 32, 61, 32, 70, 46, 90, 97, 91, 80, 97, 46, 108, 101, 110, 103, 116, 104, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 120, 98, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 82, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 96, 84, 114, 105, 101, 100, 32, 116, 111, 32, 105, 110, 118, 111, 107, 101, 32, 99, 116, 111, 114, 32, 111, 102, 32, 36, 123, 110, 125, 32, 119, 105, 116, 104, 32, 105, 110, 118, 97, 108, 105, 100, 32, 110, 117, 109, 98, 101, 114, 32, 111, 102, 32, 112, 97, 114, 97, 109, 101, 116, 101, 114, 115, 32, 40, 36, 123, 80, 97, 46, 108, 101, 110, 103, 116, 104, 125, 41, 32, 45, 32, 101, 120, 112, 101, 99, 116, 101, 100, 32, 40, 36, 123, 79, 98, 106, 101, 99, 116, 46, 107, 101, 121, 115, 40, 70, 46, 90, 97, 41, 46, 116, 111, 83, 116, 114, 105, 110, 103, 40, 41, 125, 41, 32, 112, 97, 114, 97, 109, 101, 116, 101, 114, 115, 32, 105, 110, 115, 116, 101, 97, 100, 33, 96, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 120, 98, 46, 97, 112, 112, 108, 121, 40, 116, 104, 105, 115, 44, 32, 80, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 97, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 99, 114, 101, 97, 116, 101, 40, 72, 44, 32, 123, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 58, 32, 123, 32, 118, 97, 108, 117, 101, 58, 32, 118, 32, 125, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 32, 61, 32, 102, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 70, 32, 61, 32, 110, 101, 119, 32, 101, 98, 40, 110, 44, 32, 118, 44, 32, 102, 97, 44, 32, 116, 44, 32, 119, 44, 32, 102, 44, 32, 103, 44, 32, 109, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 70, 46, 85, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 40, 104, 97, 32, 61, 32, 70, 46, 85, 97, 41, 46, 106, 98, 32, 63, 63, 32, 40, 104, 97, 46, 106, 98, 32, 61, 32, 91, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 70, 46, 85, 97, 46, 106, 98, 46, 112, 117, 115, 104, 40, 70, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 119, 32, 61, 32, 110, 101, 119, 32, 108, 98, 40, 110, 44, 32, 70, 44, 32, 116, 114, 117, 101, 44, 32, 102, 97, 108, 115, 101, 44, 32, 102, 97, 108, 115, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 104, 97, 32, 61, 32, 110, 101, 119, 32, 108, 98, 40, 110, 32, 43, 32, 34, 42, 34, 44, 32, 70, 44, 32, 102, 97, 108, 115, 101, 44, 32, 102, 97, 108, 115, 101, 44, 32, 102, 97, 108, 115, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 72, 32, 61, 32, 110, 101, 119, 32, 108, 98, 40, 110, 32, 43, 32, 34, 32, 99, 111, 110, 115, 116, 42, 34, 44, 32, 70, 44, 32, 102, 97, 108, 115, 101, 44, 32, 116, 114, 117, 101, 44, 32, 102, 97, 108, 115, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 97, 91, 97, 93, 32, 61, 32, 123, 32, 112, 111, 105, 110, 116, 101, 114, 84, 121, 112, 101, 58, 32, 104, 97, 44, 32, 110, 98, 58, 32, 72, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 98, 40, 69, 44, 32, 118, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 119, 44, 32, 104, 97, 44, 32, 72, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 116, 98, 40, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 84, 40, 100, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 80, 40, 91, 93, 44, 32, 91, 97, 93, 44, 32, 40, 103, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 61, 32, 103, 91, 48, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 108, 32, 61, 32, 96, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 32, 36, 123, 103, 46, 110, 97, 109, 101, 125, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 103, 46, 81, 97, 46, 90, 97, 32, 38, 38, 32, 40, 103, 46, 81, 97, 46, 90, 97, 32, 61, 32, 91, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 103, 46, 81, 97, 46, 90, 97, 91, 98, 32, 45, 32, 49, 93, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 82, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 96, 67, 97, 110, 110, 111, 116, 32, 114, 101, 103, 105, 115, 116, 101, 114, 32, 109, 117, 108, 116, 105, 112, 108, 101, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 115, 32, 119, 105, 116, 104, 32, 105, 100, 101, 110, 116, 105, 99, 97, 108, 32, 110, 117, 109, 98, 101, 114, 32, 111, 102, 32, 112, 97, 114, 97, 109, 101, 116, 101, 114, 115, 32, 40, 36, 123, 98, 32, 45, 32, 49, 125, 41, 32, 102, 111, 114, 32, 99, 108, 97, 115, 115, 32, 39, 36, 123, 103, 46, 110, 97, 109, 101, 125, 39, 33, 32, 79, 118, 101, 114, 108, 111, 97, 100, 32, 114, 101, 115, 111, 108, 117, 116, 105, 111, 110, 32, 105, 115, 32, 99, 117, 114, 114, 101, 110, 116, 108, 121, 32, 111, 110, 108, 121, 32, 112, 101, 114, 102, 111, 114, 109, 101, 100, 32, 117, 115, 105, 110, 103, 32, 116, 104, 101, 32, 112, 97, 114, 97, 109, 101, 116, 101, 114, 32, 99, 111, 117, 110, 116, 44, 32, 110, 111, 116, 32, 97, 99, 116, 117, 97, 108, 32, 116, 121, 112, 101, 32, 105, 110, 102, 111, 33, 96, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 46, 81, 97, 46, 90, 97, 91, 98, 32, 45, 32, 49, 93, 32, 61, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 98, 40, 96, 67, 97, 110, 110, 111, 116, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 32, 36, 123, 103, 46, 110, 97, 109, 101, 125, 32, 100, 117, 101, 32, 116, 111, 32, 117, 110, 98, 111, 117, 110, 100, 32, 116, 121, 112, 101, 115, 96, 44, 32, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 80, 40, 91, 93, 44, 32, 104, 44, 32, 40, 109, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 46, 115, 112, 108, 105, 99, 101, 40, 49, 44, 32, 48, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 46, 81, 97, 46, 90, 97, 91, 98, 32, 45, 32, 49, 93, 32, 61, 32, 118, 98, 40, 108, 44, 32, 109, 44, 32, 110, 117, 108, 108, 44, 32, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 104, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 108, 32, 61, 32, 116, 98, 40, 99, 44, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 81, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 119, 98, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 32, 61, 32, 84, 40, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 80, 40, 91, 93, 44, 32, 91, 97, 93, 44, 32, 40, 109, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 98, 40, 96, 67, 97, 110, 110, 111, 116, 32, 99, 97, 108, 108, 32, 36, 123, 112, 125, 32, 100, 117, 101, 32, 116, 111, 32, 117, 110, 98, 111, 117, 110, 100, 32, 116, 121, 112, 101, 115, 96, 44, 32, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 32, 61, 32, 109, 91, 48, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 112, 32, 61, 32, 96, 36, 123, 109, 46, 110, 97, 109, 101, 125, 46, 36, 123, 98, 125, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 46, 115, 116, 97, 114, 116, 115, 87, 105, 116, 104, 40, 34, 64, 64, 34, 41, 32, 38, 38, 32, 40, 98, 32, 61, 32, 83, 121, 109, 98, 111, 108, 91, 98, 46, 115, 117, 98, 115, 116, 114, 105, 110, 103, 40, 50, 41, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 38, 38, 32, 109, 46, 81, 97, 46, 120, 98, 46, 112, 117, 115, 104, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 116, 32, 61, 32, 109, 46, 81, 97, 46, 36, 97, 44, 32, 69, 32, 61, 32, 116, 91, 98, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 69, 32, 124, 124, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 69, 46, 83, 97, 32, 38, 38, 32, 69, 46, 99, 108, 97, 115, 115, 78, 97, 109, 101, 32, 33, 61, 61, 32, 109, 46, 110, 97, 109, 101, 32, 38, 38, 32, 69, 46, 97, 98, 32, 61, 61, 61, 32, 99, 32, 45, 32, 50, 32, 63, 32, 40, 110, 46, 97, 98, 32, 61, 32, 99, 32, 45, 32, 50, 44, 32, 110, 46, 99, 108, 97, 115, 115, 78, 97, 109, 101, 32, 61, 32, 109, 46, 110, 97, 109, 101, 44, 32, 116, 91, 98, 93, 32, 61, 32, 110, 41, 32, 58, 32, 40, 98, 98, 40, 116, 44, 32, 98, 44, 32, 112, 41, 44, 32, 116, 91, 98, 93, 46, 83, 97, 91, 99, 32, 45, 32, 50, 93, 32, 61, 32, 110, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 80, 40, 91, 93, 44, 32, 108, 44, 32, 40, 118, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 32, 61, 32, 118, 98, 40, 112, 44, 32, 118, 44, 32, 109, 44, 32, 102, 44, 32, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 116, 91, 98, 93, 46, 83, 97, 32, 63, 32, 40, 118, 46, 97, 98, 32, 61, 32, 99, 32, 45, 32, 50, 44, 32, 116, 91, 98, 93, 32, 61, 32, 118, 41, 32, 58, 32, 116, 91, 98, 93, 46, 83, 97, 91, 99, 32, 45, 32, 50, 93, 32, 61, 32, 118, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 97, 58, 32, 40, 97, 41, 32, 61, 62, 32, 79, 40, 97, 44, 32, 66, 98, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 121, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 81, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 46, 118, 97, 108, 117, 101, 115, 32, 61, 32, 123, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 40, 97, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 98, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 58, 32, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 46, 118, 97, 108, 117, 101, 115, 91, 102, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 102, 44, 32, 104, 41, 32, 61, 62, 32, 104, 46, 118, 97, 108, 117, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 97, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 67, 98, 40, 98, 44, 32, 99, 44, 32, 100, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 97, 58, 32, 110, 117, 108, 108, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 98, 40, 98, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 68, 98, 40, 97, 44, 32, 34, 101, 110, 117, 109, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 81, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 100, 46, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 99, 114, 101, 97, 116, 101, 40, 100, 46, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 108, 117, 101, 58, 32, 123, 32, 118, 97, 108, 117, 101, 58, 32, 99, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 58, 32, 123, 32, 118, 97, 108, 117, 101, 58, 32, 97, 98, 40, 96, 36, 123, 100, 46, 110, 97, 109, 101, 125, 95, 36, 123, 98, 125, 96, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 118, 97, 108, 117, 101, 115, 91, 99, 93, 32, 61, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 91, 98, 93, 32, 61, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 69, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 81, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 40, 97, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 98, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 100, 41, 32, 61, 62, 32, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 100, 44, 32, 101, 41, 32, 61, 62, 32, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 97, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 69, 98, 40, 98, 44, 32, 99, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 97, 58, 32, 110, 117, 108, 108, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 116, 98, 40, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 81, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 119, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 84, 40, 100, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 98, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 98, 40, 96, 67, 97, 110, 110, 111, 116, 32, 99, 97, 108, 108, 32, 36, 123, 97, 125, 32, 100, 117, 101, 32, 116, 111, 32, 117, 110, 98, 111, 117, 110, 100, 32, 116, 121, 112, 101, 115, 96, 44, 32, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 45, 32, 49, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 80, 40, 91, 93, 44, 32, 104, 44, 32, 40, 103, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 98, 40, 97, 44, 32, 118, 98, 40, 97, 44, 32, 91, 103, 91, 48, 93, 44, 32, 110, 117, 108, 108, 93, 46, 99, 111, 110, 99, 97, 116, 40, 103, 46, 115, 108, 105, 99, 101, 40, 49, 41, 41, 44, 32, 110, 117, 108, 108, 44, 32, 101, 44, 32, 102, 41, 44, 32, 98, 32, 45, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 112, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 81, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 45, 49, 32, 61, 61, 61, 32, 101, 32, 38, 38, 32, 40, 101, 32, 61, 32, 52, 50, 57, 52, 57, 54, 55, 50, 57, 53, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 40, 103, 41, 32, 61, 62, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 48, 32, 61, 61, 61, 32, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 51, 50, 32, 45, 32, 56, 32, 42, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 40, 103, 41, 32, 61, 62, 32, 103, 32, 60, 60, 32, 102, 32, 62, 62, 62, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 98, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 117, 110, 115, 105, 103, 110, 101, 100, 34, 41, 32, 63, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 103, 44, 32, 108, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 108, 32, 62, 62, 62, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 103, 44, 32, 108, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 108, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 40, 97, 44, 32, 123, 32, 110, 97, 109, 101, 58, 32, 98, 44, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 101, 44, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 104, 44, 32, 87, 97, 58, 32, 56, 44, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 70, 98, 40, 98, 44, 32, 99, 44, 32, 48, 32, 33, 61, 61, 32, 100, 41, 44, 32, 88, 97, 58, 32, 110, 117, 108, 108, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 100, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 110, 101, 119, 32, 101, 40, 117, 46, 98, 117, 102, 102, 101, 114, 44, 32, 66, 91, 102, 32, 43, 32, 52, 32, 62, 62, 32, 50, 93, 44, 32, 66, 91, 102, 32, 62, 62, 32, 50, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 91, 73, 110, 116, 56, 65, 114, 114, 97, 121, 44, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 44, 32, 73, 110, 116, 49, 54, 65, 114, 114, 97, 121, 44, 32, 85, 105, 110, 116, 49, 54, 65, 114, 114, 97, 121, 44, 32, 73, 110, 116, 51, 50, 65, 114, 114, 97, 121, 44, 32, 85, 105, 110, 116, 51, 50, 65, 114, 114, 97, 121, 44, 32, 70, 108, 111, 97, 116, 51, 50, 65, 114, 114, 97, 121, 44, 32, 70, 108, 111, 97, 116, 54, 52, 65, 114, 114, 97, 121, 93, 91, 98, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 81, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 40, 97, 44, 32, 123, 32, 110, 97, 109, 101, 58, 32, 99, 44, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 100, 44, 32, 87, 97, 58, 32, 56, 44, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 100, 32, 125, 44, 32, 123, 32, 118, 98, 58, 32, 116, 114, 117, 101, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 120, 58, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 40, 97, 44, 32, 71, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 97, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 108, 44, 32, 109, 44, 32, 110, 44, 32, 112, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 81, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 32, 61, 32, 84, 40, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 61, 32, 84, 40, 104, 44, 32, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 32, 61, 32, 84, 40, 108, 44, 32, 109, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 112, 32, 61, 32, 84, 40, 110, 44, 32, 112, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 80, 40, 91, 97, 93, 44, 32, 91, 98, 93, 44, 32, 40, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 32, 61, 32, 116, 91, 48, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 110, 101, 119, 32, 108, 98, 40, 99, 44, 32, 116, 46, 81, 97, 44, 32, 102, 97, 108, 115, 101, 44, 32, 102, 97, 108, 115, 101, 44, 32, 116, 114, 117, 101, 44, 32, 116, 44, 32, 100, 44, 32, 102, 44, 32, 103, 44, 32, 109, 44, 32, 112, 41, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 101, 97, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 81, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 40, 97, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 98, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 100, 32, 61, 32, 66, 91, 99, 32, 62, 62, 32, 50, 93, 44, 32, 101, 32, 61, 32, 99, 32, 43, 32, 52, 44, 32, 102, 44, 32, 104, 32, 61, 32, 101, 44, 32, 103, 32, 61, 32, 48, 59, 32, 103, 32, 60, 61, 32, 100, 59, 32, 43, 43, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 108, 32, 61, 32, 101, 32, 43, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 103, 32, 61, 61, 32, 100, 32, 124, 124, 32, 48, 32, 61, 61, 32, 120, 91, 108, 93, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 104, 32, 61, 32, 104, 32, 63, 32, 71, 40, 120, 44, 32, 104, 44, 32, 108, 32, 45, 32, 104, 41, 32, 58, 32, 34, 34, 44, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 102, 32, 63, 32, 102, 32, 61, 32, 104, 32, 58, 32, 40, 102, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 48, 41, 44, 32, 102, 32, 43, 61, 32, 104, 41, 44, 32, 104, 32, 61, 32, 108, 32, 43, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 99, 44, 32, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 65, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 32, 38, 38, 32, 40, 100, 32, 61, 32, 110, 101, 119, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 40, 100, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 44, 32, 102, 32, 61, 32, 34, 115, 116, 114, 105, 110, 103, 34, 32, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 40, 102, 32, 124, 124, 32, 100, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 32, 124, 124, 32, 100, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 85, 105, 110, 116, 56, 67, 108, 97, 109, 112, 101, 100, 65, 114, 114, 97, 121, 32, 124, 124, 32, 100, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 73, 110, 116, 56, 65, 114, 114, 97, 121, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 82, 40, 34, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 110, 111, 110, 45, 115, 116, 114, 105, 110, 103, 32, 116, 111, 32, 115, 116, 100, 58, 58, 115, 116, 114, 105, 110, 103, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 102, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 104, 32, 61, 32, 101, 32, 61, 32, 48, 59, 32, 104, 32, 60, 32, 100, 46, 108, 101, 110, 103, 116, 104, 59, 32, 43, 43, 104, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 103, 32, 61, 32, 100, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 49, 50, 55, 32, 62, 61, 32, 103, 32, 63, 32, 101, 43, 43, 32, 58, 32, 50, 48, 52, 55, 32, 62, 61, 32, 103, 32, 63, 32, 101, 32, 43, 61, 32, 50, 32, 58, 32, 53, 53, 50, 57, 54, 32, 60, 61, 32, 103, 32, 38, 38, 32, 53, 55, 51, 52, 51, 32, 62, 61, 32, 103, 32, 63, 32, 40, 101, 32, 43, 61, 32, 52, 44, 32, 43, 43, 104, 41, 32, 58, 32, 101, 32, 43, 61, 32, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 32, 101, 32, 61, 32, 100, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 104, 32, 61, 32, 102, 99, 40, 52, 32, 43, 32, 101, 32, 43, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 61, 32, 104, 32, 43, 32, 52, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 66, 91, 104, 32, 62, 62, 32, 50, 93, 32, 61, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 102, 41, 32, 75, 40, 100, 44, 32, 103, 44, 32, 101, 32, 43, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 102, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 102, 32, 61, 32, 48, 59, 32, 102, 32, 60, 32, 101, 59, 32, 43, 43, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 108, 32, 61, 32, 100, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 50, 53, 53, 32, 60, 32, 108, 41, 32, 116, 104, 114, 111, 119, 32, 85, 40, 103, 41, 44, 32, 110, 101, 119, 32, 82, 40, 34, 83, 116, 114, 105, 110, 103, 32, 104, 97, 115, 32, 85, 84, 70, 45, 49, 54, 32, 99, 111, 100, 101, 32, 117, 110, 105, 116, 115, 32, 116, 104, 97, 116, 32, 100, 111, 32, 110, 111, 116, 32, 102, 105, 116, 32, 105, 110, 32, 56, 32, 98, 105, 116, 115, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 120, 91, 103, 32, 43, 32, 102, 93, 32, 61, 32, 108, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 32, 102, 111, 114, 32, 40, 102, 32, 61, 32, 48, 59, 32, 102, 32, 60, 32, 101, 59, 32, 43, 43, 102, 41, 32, 120, 91, 103, 32, 43, 32, 102, 93, 32, 61, 32, 100, 91, 102, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 99, 32, 38, 38, 32, 99, 46, 112, 117, 115, 104, 40, 85, 44, 32, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 97, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 76, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 97, 40, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 65, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 81, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 50, 32, 61, 61, 61, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 73, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 74, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 75, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 40, 103, 41, 32, 61, 62, 32, 122, 91, 103, 32, 62, 62, 32, 49, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 52, 32, 61, 61, 61, 32, 98, 32, 38, 38, 32, 40, 100, 32, 61, 32, 76, 98, 44, 32, 101, 32, 61, 32, 77, 98, 44, 32, 102, 32, 61, 32, 78, 98, 44, 32, 104, 32, 61, 32, 40, 103, 41, 32, 61, 62, 32, 66, 91, 103, 32, 62, 62, 32, 50, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 40, 97, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 103, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 108, 32, 61, 32, 66, 91, 103, 32, 62, 62, 32, 50, 93, 44, 32, 109, 44, 32, 110, 32, 61, 32, 103, 32, 43, 32, 52, 44, 32, 112, 32, 61, 32, 48, 59, 32, 112, 32, 60, 61, 32, 108, 59, 32, 43, 43, 112, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 116, 32, 61, 32, 103, 32, 43, 32, 52, 32, 43, 32, 112, 32, 42, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 112, 32, 61, 61, 32, 108, 32, 124, 124, 32, 48, 32, 61, 61, 32, 104, 40, 116, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 32, 61, 32, 100, 40, 110, 44, 32, 116, 32, 45, 32, 110, 41, 44, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 109, 32, 63, 32, 109, 32, 61, 32, 110, 32, 58, 32, 40, 109, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 48, 41, 44, 32, 109, 32, 43, 61, 32, 110, 41, 44, 32, 110, 32, 61, 32, 116, 32, 43, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 40, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 103, 44, 32, 108, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 34, 115, 116, 114, 105, 110, 103, 34, 32, 33, 61, 32, 116, 121, 112, 101, 111, 102, 32, 108, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 82, 40, 96, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 110, 111, 110, 45, 115, 116, 114, 105, 110, 103, 32, 116, 111, 32, 67, 43, 43, 32, 115, 116, 114, 105, 110, 103, 32, 116, 121, 112, 101, 32, 36, 123, 99, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 109, 32, 61, 32, 102, 40, 108, 41, 44, 32, 110, 32, 61, 32, 102, 99, 40, 52, 32, 43, 32, 109, 32, 43, 32, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 66, 91, 110, 32, 62, 62, 32, 50, 93, 32, 61, 32, 109, 32, 47, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 40, 108, 44, 32, 110, 32, 43, 32, 52, 44, 32, 109, 32, 43, 32, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 103, 32, 38, 38, 32, 103, 46, 112, 117, 115, 104, 40, 85, 44, 32, 110, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 97, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 76, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 97, 40, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 40, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 74, 97, 91, 97, 93, 32, 61, 32, 123, 32, 110, 97, 109, 101, 58, 32, 81, 40, 98, 41, 44, 32, 105, 98, 58, 32, 84, 40, 99, 44, 32, 100, 41, 44, 32, 89, 97, 58, 32, 84, 40, 101, 44, 32, 102, 41, 44, 32, 108, 98, 58, 32, 91, 93, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 108, 44, 32, 109, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 74, 97, 91, 97, 93, 46, 108, 98, 46, 112, 117, 115, 104, 40, 123, 32, 112, 98, 58, 32, 81, 40, 98, 41, 44, 32, 117, 98, 58, 32, 99, 44, 32, 115, 98, 58, 32, 84, 40, 100, 44, 32, 101, 41, 44, 32, 116, 98, 58, 32, 102, 44, 32, 65, 98, 58, 32, 104, 44, 32, 122, 98, 58, 32, 84, 40, 103, 44, 32, 108, 41, 44, 32, 66, 98, 58, 32, 109, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 103, 97, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 81, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 40, 97, 44, 32, 123, 32, 68, 98, 58, 32, 116, 114, 117, 101, 44, 32, 110, 97, 109, 101, 58, 32, 98, 44, 32, 87, 97, 58, 32, 48, 44, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 79, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 68, 97, 32, 61, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 98, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 73, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 73, 110, 102, 105, 110, 105, 116, 121, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 70, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 65, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 68, 98, 40, 98, 44, 32, 34, 101, 109, 118, 97, 108, 58, 58, 97, 115, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 80, 98, 40, 98, 44, 32, 99, 44, 32, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 106, 97, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 81, 98, 91, 97, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 65, 98, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 40, 110, 117, 108, 108, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 77, 58, 32, 122, 98, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 97, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 83, 98, 40, 97, 44, 32, 98, 41, 44, 32, 101, 32, 61, 32, 100, 46, 115, 104, 105, 102, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 45, 45, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 96, 109, 101, 116, 104, 111, 100, 67, 97, 108, 108, 101, 114, 60, 40, 36, 123, 100, 46, 109, 97, 112, 40, 40, 104, 41, 32, 61, 62, 32, 104, 46, 110, 97, 109, 101, 41, 46, 106, 111, 105, 110, 40, 34, 44, 32, 34, 41, 125, 41, 32, 61, 62, 32, 36, 123, 101, 46, 110, 97, 109, 101, 125, 62, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 82, 98, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 98, 40, 98, 44, 32, 40, 104, 44, 32, 103, 44, 32, 108, 44, 32, 109, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 110, 32, 61, 32, 48, 44, 32, 112, 32, 61, 32, 48, 59, 32, 112, 32, 60, 32, 97, 59, 32, 43, 43, 112, 41, 32, 102, 91, 112, 93, 32, 61, 32, 100, 91, 112, 93, 46, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 40, 109, 32, 43, 32, 110, 41, 44, 32, 110, 32, 43, 61, 32, 100, 91, 112, 93, 46, 87, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 104, 32, 61, 32, 49, 32, 61, 61, 61, 32, 99, 32, 63, 32, 84, 98, 40, 103, 44, 32, 102, 41, 32, 58, 32, 103, 46, 97, 112, 112, 108, 121, 40, 104, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 80, 98, 40, 101, 44, 32, 108, 44, 32, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 97, 58, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 57, 32, 60, 32, 97, 32, 38, 38, 32, 40, 86, 91, 97, 32, 43, 32, 49, 93, 32, 43, 61, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 104, 97, 58, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 65, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 75, 97, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 122, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 68, 98, 40, 97, 44, 32, 34, 95, 101, 109, 118, 97, 108, 95, 116, 97, 107, 101, 95, 118, 97, 108, 117, 101, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 97, 46, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 106, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 75, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 98, 91, 97, 93, 32, 38, 38, 32, 40, 99, 108, 101, 97, 114, 84, 105, 109, 101, 111, 117, 116, 40, 85, 98, 91, 97, 93, 46, 105, 100, 41, 44, 32, 100, 101, 108, 101, 116, 101, 32, 85, 98, 91, 97, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 41, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 115, 101, 116, 84, 105, 109, 101, 111, 117, 116, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 108, 101, 116, 101, 32, 85, 98, 91, 97, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 98, 40, 40, 41, 32, 61, 62, 32, 103, 99, 40, 97, 44, 32, 112, 101, 114, 102, 111, 114, 109, 97, 110, 99, 101, 46, 110, 111, 119, 40, 41, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 32, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 98, 91, 97, 93, 32, 61, 32, 123, 32, 105, 100, 58, 32, 99, 44, 32, 69, 98, 58, 32, 98, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 76, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 40, 47, 42, 32, 64, 95, 95, 80, 85, 82, 69, 95, 95, 32, 42, 47, 32, 110, 101, 119, 32, 68, 97, 116, 101, 40, 41, 41, 46, 103, 101, 116, 70, 117, 108, 108, 89, 101, 97, 114, 40, 41, 44, 32, 102, 32, 61, 32, 110, 101, 119, 32, 68, 97, 116, 101, 40, 101, 44, 32, 48, 44, 32, 49, 41, 46, 103, 101, 116, 84, 105, 109, 101, 122, 111, 110, 101, 79, 102, 102, 115, 101, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 110, 101, 119, 32, 68, 97, 116, 101, 40, 101, 44, 32, 54, 44, 32, 49, 41, 46, 103, 101, 116, 84, 105, 109, 101, 122, 111, 110, 101, 79, 102, 102, 115, 101, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 66, 91, 97, 32, 62, 62, 32, 50, 93, 32, 61, 32, 54, 48, 32, 42, 32, 77, 97, 116, 104, 46, 109, 97, 120, 40, 102, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 65, 91, 98, 32, 62, 62, 32, 50, 93, 32, 61, 32, 78, 117, 109, 98, 101, 114, 40, 102, 32, 33, 61, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 40, 104, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 103, 32, 61, 32, 77, 97, 116, 104, 46, 97, 98, 115, 40, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 96, 85, 84, 67, 36, 123, 48, 32, 60, 61, 32, 104, 32, 63, 32, 34, 45, 34, 32, 58, 32, 34, 43, 34, 125, 36, 123, 83, 116, 114, 105, 110, 103, 40, 77, 97, 116, 104, 46, 102, 108, 111, 111, 114, 40, 103, 32, 47, 32, 54, 48, 41, 41, 46, 112, 97, 100, 83, 116, 97, 114, 116, 40, 50, 44, 32, 34, 48, 34, 41, 125, 36, 123, 83, 116, 114, 105, 110, 103, 40, 103, 32, 37, 32, 54, 48, 41, 46, 112, 97, 100, 83, 116, 97, 114, 116, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 50, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 34, 48, 34, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 125, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 98, 40, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 98, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 60, 32, 102, 32, 63, 32, 40, 75, 40, 97, 44, 32, 99, 44, 32, 49, 55, 41, 44, 32, 75, 40, 98, 44, 32, 100, 44, 32, 49, 55, 41, 41, 32, 58, 32, 40, 75, 40, 97, 44, 32, 100, 44, 32, 49, 55, 41, 44, 32, 75, 40, 98, 44, 32, 99, 44, 32, 49, 55, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 58, 32, 40, 41, 32, 61, 62, 32, 112, 101, 114, 102, 111, 114, 109, 97, 110, 99, 101, 46, 110, 111, 119, 40, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 78, 58, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 120, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 62, 62, 62, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 50, 49, 52, 55, 52, 56, 51, 54, 52, 56, 32, 60, 32, 97, 41, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 99, 32, 61, 32, 49, 59, 32, 52, 32, 62, 61, 32, 99, 59, 32, 99, 32, 42, 61, 32, 50, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 98, 32, 42, 32, 40, 49, 32, 43, 32, 48, 46, 50, 32, 47, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 77, 97, 116, 104, 46, 109, 105, 110, 40, 100, 44, 32, 97, 32, 43, 32, 49, 48, 48, 54, 54, 51, 50, 57, 54, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 40, 77, 97, 116, 104, 46, 109, 105, 110, 40, 50, 49, 52, 55, 52, 56, 51, 54, 52, 56, 44, 32, 54, 53, 53, 51, 54, 32, 42, 32, 77, 97, 116, 104, 46, 99, 101, 105, 108, 40, 77, 97, 116, 104, 46, 109, 97, 120, 40, 97, 44, 32, 100, 41, 32, 47, 32, 54, 53, 53, 51, 54, 41, 41, 32, 45, 32, 108, 97, 46, 98, 117, 102, 102, 101, 114, 46, 98, 121, 116, 101, 76, 101, 110, 103, 116, 104, 32, 43, 32, 54, 53, 53, 51, 53, 41, 32, 47, 32, 54, 53, 53, 51, 54, 32, 124, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 108, 97, 46, 103, 114, 111, 119, 40, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 113, 97, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 114, 101, 97, 107, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 118, 111, 105, 100, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 41, 32, 114, 101, 116, 117, 114, 110, 32, 116, 114, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 90, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 36, 98, 40, 41, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 100, 44, 32, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 98, 32, 43, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 66, 91, 97, 32, 43, 32, 52, 32, 42, 32, 101, 32, 62, 62, 32, 50, 93, 32, 61, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 102, 32, 61, 32, 48, 59, 32, 102, 32, 60, 32, 100, 46, 108, 101, 110, 103, 116, 104, 59, 32, 43, 43, 102, 41, 32, 117, 91, 101, 43, 43, 93, 32, 61, 32, 100, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 117, 91, 101, 93, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 43, 61, 32, 100, 46, 108, 101, 110, 103, 116, 104, 32, 43, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 95, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 36, 98, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 66, 91, 97, 32, 62, 62, 32, 50, 93, 32, 61, 32, 99, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 101, 41, 32, 61, 62, 32, 100, 32, 43, 61, 32, 101, 46, 108, 101, 110, 103, 116, 104, 32, 43, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 66, 91, 98, 32, 62, 62, 32, 50, 93, 32, 61, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 87, 58, 32, 40, 41, 32, 61, 62, 32, 53, 50, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 85, 58, 32, 40, 41, 32, 61, 62, 32, 53, 50, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 66, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 101, 32, 61, 32, 48, 44, 32, 102, 32, 61, 32, 48, 59, 32, 102, 32, 60, 32, 99, 59, 32, 102, 43, 43, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 66, 91, 98, 32, 62, 62, 32, 50, 93, 44, 32, 103, 32, 61, 32, 66, 91, 98, 32, 43, 32, 52, 32, 62, 62, 32, 50, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 43, 61, 32, 56, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 108, 32, 61, 32, 48, 59, 32, 108, 32, 60, 32, 103, 59, 32, 108, 43, 43, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 109, 32, 61, 32, 97, 44, 32, 110, 32, 61, 32, 120, 91, 104, 32, 43, 32, 108, 93, 44, 32, 112, 32, 61, 32, 97, 99, 91, 109, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 48, 32, 61, 61, 61, 32, 110, 32, 124, 124, 32, 49, 48, 32, 61, 61, 61, 32, 110, 32, 63, 32, 40, 40, 49, 32, 61, 61, 61, 32, 109, 32, 63, 32, 106, 97, 32, 58, 32, 114, 41, 40, 71, 40, 112, 41, 41, 44, 32, 112, 46, 108, 101, 110, 103, 116, 104, 32, 61, 32, 48, 41, 32, 58, 32, 112, 46, 112, 117, 115, 104, 40, 110, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 43, 61, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 66, 91, 100, 32, 62, 62, 32, 50, 93, 32, 61, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 36, 58, 32, 104, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 97, 58, 32, 105, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 74, 58, 32, 106, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 106, 58, 32, 107, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 58, 32, 108, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 103, 58, 32, 109, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 97, 58, 32, 110, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 122, 58, 32, 111, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 67, 58, 32, 112, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 68, 58, 32, 113, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 58, 32, 114, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 58, 32, 115, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 58, 32, 116, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 111, 58, 32, 117, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 113, 58, 32, 118, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 71, 58, 32, 119, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 89, 58, 32, 87, 98, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 80, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 99, 40, 120, 46, 115, 117, 98, 97, 114, 114, 97, 121, 40, 97, 44, 32, 97, 32, 43, 32, 98, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 87, 59, 10, 32, 32, 32, 32, 32, 32, 40, 97, 115, 121, 110, 99, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 97, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 32, 61, 32, 100, 46, 101, 120, 112, 111, 114, 116, 115, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 108, 97, 32, 61, 32, 87, 46, 109, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 113, 97, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 32, 61, 32, 87, 46, 114, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 97, 46, 117, 110, 115, 104, 105, 102, 116, 40, 87, 46, 110, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 45, 45, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 107, 46, 109, 111, 110, 105, 116, 111, 114, 82, 117, 110, 68, 101, 112, 101, 110, 100, 101, 110, 99, 105, 101, 115, 63, 46, 40, 67, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 48, 32, 61, 61, 32, 67, 32, 38, 38, 32, 68, 32, 38, 38, 32, 40, 100, 32, 61, 32, 68, 44, 32, 68, 32, 61, 32, 110, 117, 108, 108, 44, 32, 100, 40, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 87, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 67, 43, 43, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 46, 109, 111, 110, 105, 116, 111, 114, 82, 117, 110, 68, 101, 112, 101, 110, 100, 101, 110, 99, 105, 101, 115, 63, 46, 40, 67, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 123, 32, 97, 58, 32, 120, 99, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 107, 46, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 101, 87, 97, 115, 109, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 107, 46, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 101, 87, 97, 115, 109, 40, 98, 44, 32, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 40, 96, 77, 111, 100, 117, 108, 101, 46, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 101, 87, 97, 115, 109, 32, 99, 97, 108, 108, 98, 97, 99, 107, 32, 102, 97, 105, 108, 101, 100, 32, 119, 105, 116, 104, 32, 101, 114, 114, 111, 114, 58, 32, 36, 123, 100, 125, 96, 41, 44, 32, 98, 97, 40, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 120, 97, 32, 63, 63, 32, 40, 120, 97, 32, 61, 32, 119, 97, 40, 34, 68, 111, 116, 76, 111, 116, 116, 105, 101, 80, 108, 97, 121, 101, 114, 46, 119, 97, 115, 109, 34, 41, 32, 63, 32, 34, 68, 111, 116, 76, 111, 116, 116, 105, 101, 80, 108, 97, 121, 101, 114, 46, 119, 97, 115, 109, 34, 32, 58, 32, 107, 46, 108, 111, 99, 97, 116, 101, 70, 105, 108, 101, 32, 63, 32, 107, 46, 108, 111, 99, 97, 116, 101, 70, 105, 108, 101, 40, 34, 68, 111, 116, 76, 111, 116, 116, 105, 101, 80, 108, 97, 121, 101, 114, 46, 119, 97, 115, 109, 34, 44, 32, 113, 41, 32, 58, 32, 113, 32, 43, 32, 34, 68, 111, 116, 76, 111, 116, 116, 105, 101, 80, 108, 97, 121, 101, 114, 46, 119, 97, 115, 109, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 97, 119, 97, 105, 116, 32, 65, 97, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 40, 99, 46, 105, 110, 115, 116, 97, 110, 99, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 97, 40, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 41, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 99, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 40, 102, 99, 32, 61, 32, 87, 46, 111, 97, 41, 40, 97, 41, 44, 32, 113, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 40, 113, 98, 32, 61, 32, 87, 46, 112, 97, 41, 40, 97, 41, 44, 32, 85, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 40, 85, 32, 61, 32, 87, 46, 113, 97, 41, 40, 97, 41, 44, 32, 103, 99, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 40, 103, 99, 32, 61, 32, 87, 46, 115, 97, 41, 40, 97, 44, 32, 98, 41, 44, 32, 88, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 40, 88, 32, 61, 32, 87, 46, 116, 97, 41, 40, 97, 44, 32, 98, 41, 44, 32, 74, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 40, 74, 32, 61, 32, 87, 46, 117, 97, 41, 40, 97, 41, 44, 32, 89, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 40, 89, 32, 61, 32, 87, 46, 118, 97, 41, 40, 97, 41, 44, 32, 90, 32, 61, 32, 40, 41, 32, 61, 62, 32, 40, 90, 32, 61, 32, 87, 46, 119, 97, 41, 40, 41, 44, 32, 71, 97, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 40, 71, 97, 32, 61, 32, 87, 46, 120, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 106, 106, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 106, 106, 32, 61, 32, 87, 46, 121, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 106, 106, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 106, 106, 32, 61, 32, 87, 46, 122, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 106, 105, 105, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 106, 105, 105, 105, 32, 61, 32, 87, 46, 65, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 121, 99, 32, 61, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 106, 106, 106, 106, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 108, 44, 32, 109, 41, 32, 61, 62, 32, 40, 121, 99, 32, 61, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 106, 106, 106, 106, 32, 61, 32, 87, 46, 66, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 108, 44, 32, 109, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 106, 105, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 106, 105, 105, 32, 61, 32, 87, 46, 67, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 106, 105, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 106, 105, 105, 32, 61, 32, 87, 46, 68, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 106, 102, 105, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 106, 102, 105, 105, 32, 61, 32, 87, 46, 69, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 106, 105, 105, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 106, 105, 105, 105, 32, 61, 32, 87, 46, 70, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 106, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 106, 32, 61, 32, 87, 46, 71, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 106, 105, 105, 105, 105, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 106, 105, 105, 105, 105, 105, 32, 61, 32, 87, 46, 72, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 106, 105, 102, 102, 105, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 106, 105, 102, 102, 105, 105, 32, 61, 32, 87, 46, 73, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 106, 105, 105, 105, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 106, 105, 105, 105, 105, 32, 61, 32, 87, 46, 74, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 105, 106, 105, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 105, 106, 105, 105, 32, 61, 32, 87, 46, 75, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 105, 105, 105, 106, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 105, 105, 105, 106, 32, 61, 32, 87, 46, 76, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 105, 105, 105, 106, 106, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 108, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 105, 105, 105, 106, 106, 32, 61, 32, 87, 46, 77, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 105, 105, 105, 105, 106, 106, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 108, 44, 32, 109, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 105, 105, 105, 105, 106, 106, 32, 61, 32, 87, 46, 78, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 108, 44, 32, 109, 41, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 114, 99, 40, 97, 44, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 100, 32, 33, 61, 61, 32, 100, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 110, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 104, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 104, 32, 33, 61, 61, 32, 104, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 115, 99, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 32, 33, 61, 61, 32, 101, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 116, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 102, 32, 33, 61, 61, 32, 102, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 107, 99, 40, 97, 44, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 100, 32, 33, 61, 61, 32, 100, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 118, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 103, 32, 33, 61, 61, 32, 103, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 113, 99, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 32, 33, 61, 61, 32, 99, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 117, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 104, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 104, 32, 33, 61, 61, 32, 104, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 112, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 108, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 109, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 109, 32, 33, 61, 61, 32, 109, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 109, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 109, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 102, 32, 33, 61, 61, 32, 102, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 108, 99, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 32, 33, 61, 61, 32, 101, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 111, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 103, 32, 33, 61, 61, 32, 103, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 105, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 102, 32, 33, 61, 61, 32, 102, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 104, 99, 40, 97, 44, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 100, 32, 33, 61, 61, 32, 100, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 106, 99, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 32, 33, 61, 61, 32, 101, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 119, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 108, 44, 32, 109, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 110, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 121, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 108, 44, 32, 109, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 112, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 110, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 112, 32, 33, 61, 61, 32, 112, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 112, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 122, 99, 59, 10, 32, 32, 32, 32, 32, 32, 68, 32, 61, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 65, 99, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 122, 99, 32, 124, 124, 32, 66, 99, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 122, 99, 32, 124, 124, 32, 40, 68, 32, 61, 32, 65, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 66, 99, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 97, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 122, 99, 32, 38, 38, 32, 40, 122, 99, 32, 61, 32, 116, 114, 117, 101, 44, 32, 107, 46, 99, 97, 108, 108, 101, 100, 82, 117, 110, 32, 61, 32, 116, 114, 117, 101, 44, 32, 33, 109, 97, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 97, 40, 115, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 97, 40, 107, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 107, 46, 111, 110, 82, 117, 110, 116, 105, 109, 101, 73, 110, 105, 116, 105, 97, 108, 105, 122, 101, 100, 63, 46, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 107, 46, 112, 111, 115, 116, 82, 117, 110, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 107, 46, 112, 111, 115, 116, 82, 117, 110, 32, 38, 38, 32, 40, 107, 46, 112, 111, 115, 116, 82, 117, 110, 32, 61, 32, 91, 107, 46, 112, 111, 115, 116, 82, 117, 110, 93, 41, 59, 32, 107, 46, 112, 111, 115, 116, 82, 117, 110, 46, 108, 101, 110, 103, 116, 104, 59, 32, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 107, 46, 112, 111, 115, 116, 82, 117, 110, 46, 115, 104, 105, 102, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 97, 46, 117, 110, 115, 104, 105, 102, 116, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 97, 40, 116, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 40, 48, 32, 60, 32, 67, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 107, 46, 112, 114, 101, 82, 117, 110, 41, 32, 102, 111, 114, 32, 40, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 107, 46, 112, 114, 101, 82, 117, 110, 32, 38, 38, 32, 40, 107, 46, 112, 114, 101, 82, 117, 110, 32, 61, 32, 91, 107, 46, 112, 114, 101, 82, 117, 110, 93, 41, 59, 32, 107, 46, 112, 114, 101, 82, 117, 110, 46, 108, 101, 110, 103, 116, 104, 59, 32, 41, 32, 117, 97, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 97, 40, 114, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 48, 32, 60, 32, 67, 32, 124, 124, 32, 40, 107, 46, 115, 101, 116, 83, 116, 97, 116, 117, 115, 32, 63, 32, 40, 107, 46, 115, 101, 116, 83, 116, 97, 116, 117, 115, 40, 34, 82, 117, 110, 110, 105, 110, 103, 46, 46, 46, 34, 41, 44, 32, 115, 101, 116, 84, 105, 109, 101, 111, 117, 116, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 101, 116, 84, 105, 109, 101, 111, 117, 116, 40, 40, 41, 32, 61, 62, 32, 107, 46, 115, 101, 116, 83, 116, 97, 116, 117, 115, 40, 34, 34, 41, 44, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 32, 49, 41, 41, 32, 58, 32, 97, 40, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 107, 46, 112, 114, 101, 73, 110, 105, 116, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 107, 46, 112, 114, 101, 73, 110, 105, 116, 32, 38, 38, 32, 40, 107, 46, 112, 114, 101, 73, 110, 105, 116, 32, 61, 32, 91, 107, 46, 112, 114, 101, 73, 110, 105, 116, 93, 41, 59, 32, 48, 32, 60, 32, 107, 46, 112, 114, 101, 73, 110, 105, 116, 46, 108, 101, 110, 103, 116, 104, 59, 32, 41, 32, 107, 46, 112, 114, 101, 73, 110, 105, 116, 46, 112, 111, 112, 40, 41, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 66, 99, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 109, 111, 100, 117, 108, 101, 82, 116, 110, 32, 61, 32, 99, 97, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 82, 116, 110, 59, 10, 32, 32, 32, 32, 125, 59, 10, 32, 32, 125, 41, 40, 41, 59, 10, 32, 32, 118, 97, 114, 32, 100, 111, 116, 108, 111, 116, 116, 105, 101, 95, 112, 108, 97, 121, 101, 114, 95, 100, 101, 102, 97, 117, 108, 116, 32, 61, 32, 99, 114, 101, 97, 116, 101, 68, 111, 116, 76, 111, 116, 116, 105, 101, 80, 108, 97, 121, 101, 114, 77, 111, 100, 117, 108, 101, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 99, 111, 114, 101, 47, 100, 111, 116, 108, 111, 116, 116, 105, 101, 45, 119, 97, 115, 109, 45, 108, 111, 97, 100, 101, 114, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 68, 111, 116, 76, 111, 116, 116, 105, 101, 87, 97, 115, 109, 76, 111, 97, 100, 101, 114, 32, 61, 32, 99, 108, 97, 115, 115, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 34, 82, 101, 110, 100, 101, 114, 101, 114, 76, 111, 97, 100, 101, 114, 32, 105, 115, 32, 97, 32, 115, 116, 97, 116, 105, 99, 32, 99, 108, 97, 115, 115, 32, 97, 110, 100, 32, 99, 97, 110, 110, 111, 116, 32, 98, 101, 32, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 101, 100, 46, 34, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 97, 115, 121, 110, 99, 32, 95, 116, 114, 121, 76, 111, 97, 100, 40, 117, 114, 108, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 111, 100, 117, 108, 101, 32, 61, 32, 97, 119, 97, 105, 116, 32, 100, 111, 116, 108, 111, 116, 116, 105, 101, 95, 112, 108, 97, 121, 101, 114, 95, 100, 101, 102, 97, 117, 108, 116, 40, 123, 32, 108, 111, 99, 97, 116, 101, 70, 105, 108, 101, 58, 32, 40, 41, 32, 61, 62, 32, 117, 114, 108, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 47, 42, 42, 10, 32, 32, 32, 32, 32, 42, 32, 84, 114, 105, 101, 115, 32, 116, 111, 32, 108, 111, 97, 100, 32, 116, 104, 101, 32, 87, 65, 83, 77, 32, 109, 111, 100, 117, 108, 101, 32, 102, 114, 111, 109, 32, 116, 104, 101, 32, 112, 114, 105, 109, 97, 114, 121, 32, 85, 82, 76, 44, 32, 102, 97, 108, 108, 105, 110, 103, 32, 98, 97, 99, 107, 32, 116, 111, 32, 97, 32, 98, 97, 99, 107, 117, 112, 32, 85, 82, 76, 32, 105, 102, 32, 110, 101, 99, 101, 115, 115, 97, 114, 121, 46, 10, 32, 32, 32, 32, 32, 42, 32, 84, 104, 114, 111, 119, 115, 32, 97, 110, 32, 101, 114, 114, 111, 114, 32, 105, 102, 32, 98, 111, 116, 104, 32, 85, 82, 76, 115, 32, 102, 97, 105, 108, 32, 116, 111, 32, 108, 111, 97, 100, 32, 116, 104, 101, 32, 109, 111, 100, 117, 108, 101, 46, 10, 32, 32, 32, 32, 32, 42, 32, 64, 114, 101, 116, 117, 114, 110, 115, 32, 80, 114, 111, 109, 105, 115, 101, 60, 77, 111, 100, 117, 108, 101, 62, 32, 45, 32, 65, 32, 112, 114, 111, 109, 105, 115, 101, 32, 116, 104, 97, 116, 32, 114, 101, 115, 111, 108, 118, 101, 115, 32, 116, 111, 32, 116, 104, 101, 32, 108, 111, 97, 100, 101, 100, 32, 109, 111, 100, 117, 108, 101, 46, 10, 32, 32, 32, 32, 32, 42, 47, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 97, 115, 121, 110, 99, 32, 95, 108, 111, 97, 100, 87, 105, 116, 104, 66, 97, 99, 107, 117, 112, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 116, 104, 105, 115, 46, 95, 77, 111, 100, 117, 108, 101, 80, 114, 111, 109, 105, 115, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 77, 111, 100, 117, 108, 101, 80, 114, 111, 109, 105, 115, 101, 32, 61, 32, 116, 104, 105, 115, 46, 95, 116, 114, 121, 76, 111, 97, 100, 40, 116, 104, 105, 115, 46, 95, 119, 97, 115, 109, 85, 82, 76, 41, 46, 99, 97, 116, 99, 104, 40, 97, 115, 121, 110, 99, 32, 40, 105, 110, 105, 116, 105, 97, 108, 69, 114, 114, 111, 114, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 98, 97, 99, 107, 117, 112, 85, 114, 108, 32, 61, 32, 96, 104, 116, 116, 112, 115, 58, 47, 47, 117, 110, 112, 107, 103, 46, 99, 111, 109, 47, 36, 123, 80, 65, 67, 75, 65, 71, 69, 95, 78, 65, 77, 69, 125, 64, 36, 123, 80, 65, 67, 75, 65, 71, 69, 95, 86, 69, 82, 83, 73, 79, 78, 125, 47, 100, 105, 115, 116, 47, 100, 111, 116, 108, 111, 116, 116, 105, 101, 45, 112, 108, 97, 121, 101, 114, 46, 119, 97, 115, 109, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 111, 108, 101, 46, 119, 97, 114, 110, 40, 96, 80, 114, 105, 109, 97, 114, 121, 32, 87, 65, 83, 77, 32, 108, 111, 97, 100, 32, 102, 97, 105, 108, 101, 100, 32, 102, 114, 111, 109, 32, 36, 123, 116, 104, 105, 115, 46, 95, 119, 97, 115, 109, 85, 82, 76, 125, 46, 32, 69, 114, 114, 111, 114, 58, 32, 36, 123, 105, 110, 105, 116, 105, 97, 108, 69, 114, 114, 111, 114, 46, 109, 101, 115, 115, 97, 103, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 111, 108, 101, 46, 119, 97, 114, 110, 40, 96, 65, 116, 116, 101, 109, 112, 116, 105, 110, 103, 32, 116, 111, 32, 108, 111, 97, 100, 32, 87, 65, 83, 77, 32, 102, 114, 111, 109, 32, 98, 97, 99, 107, 117, 112, 32, 85, 82, 76, 58, 32, 36, 123, 98, 97, 99, 107, 117, 112, 85, 114, 108, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 119, 97, 105, 116, 32, 116, 104, 105, 115, 46, 95, 116, 114, 121, 76, 111, 97, 100, 40, 98, 97, 99, 107, 117, 112, 85, 114, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 98, 97, 99, 107, 117, 112, 69, 114, 114, 111, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 111, 108, 101, 46, 101, 114, 114, 111, 114, 40, 96, 80, 114, 105, 109, 97, 114, 121, 32, 87, 65, 83, 77, 32, 85, 82, 76, 32, 102, 97, 105, 108, 101, 100, 58, 32, 36, 123, 105, 110, 105, 116, 105, 97, 108, 69, 114, 114, 111, 114, 46, 109, 101, 115, 115, 97, 103, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 111, 108, 101, 46, 101, 114, 114, 111, 114, 40, 96, 66, 97, 99, 107, 117, 112, 32, 87, 65, 83, 77, 32, 85, 82, 76, 32, 102, 97, 105, 108, 101, 100, 58, 32, 36, 123, 98, 97, 99, 107, 117, 112, 69, 114, 114, 111, 114, 46, 109, 101, 115, 115, 97, 103, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 34, 87, 65, 83, 77, 32, 108, 111, 97, 100, 105, 110, 103, 32, 102, 97, 105, 108, 101, 100, 32, 102, 114, 111, 109, 32, 97, 108, 108, 32, 115, 111, 117, 114, 99, 101, 115, 46, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 77, 111, 100, 117, 108, 101, 80, 114, 111, 109, 105, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 47, 42, 42, 10, 32, 32, 32, 32, 32, 42, 32, 80, 117, 98, 108, 105, 99, 32, 109, 101, 116, 104, 111, 100, 32, 116, 111, 32, 108, 111, 97, 100, 32, 116, 104, 101, 32, 87, 101, 98, 65, 115, 115, 101, 109, 98, 108, 121, 32, 109, 111, 100, 117, 108, 101, 46, 10, 32, 32, 32, 32, 32, 42, 32, 85, 116, 105, 108, 105, 122, 101, 115, 32, 97, 32, 112, 114, 105, 109, 97, 114, 121, 32, 97, 110, 100, 32, 98, 97, 99, 107, 117, 112, 32, 85, 82, 76, 32, 102, 111, 114, 32, 114, 111, 98, 117, 115, 116, 110, 101, 115, 115, 46, 10, 32, 32, 32, 32, 32, 42, 32, 64, 114, 101, 116, 117, 114, 110, 115, 32, 80, 114, 111, 109, 105, 115, 101, 60, 77, 111, 100, 117, 108, 101, 62, 32, 45, 32, 65, 32, 112, 114, 111, 109, 105, 115, 101, 32, 116, 104, 97, 116, 32, 114, 101, 115, 111, 108, 118, 101, 115, 32, 116, 111, 32, 116, 104, 101, 32, 108, 111, 97, 100, 101, 100, 32, 109, 111, 100, 117, 108, 101, 46, 10, 32, 32, 32, 32, 32, 42, 47, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 97, 115, 121, 110, 99, 32, 108, 111, 97, 100, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 108, 111, 97, 100, 87, 105, 116, 104, 66, 97, 99, 107, 117, 112, 40, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 47, 42, 42, 10, 32, 32, 32, 32, 32, 42, 32, 83, 101, 116, 115, 32, 97, 32, 110, 101, 119, 32, 85, 82, 76, 32, 102, 111, 114, 32, 116, 104, 101, 32, 87, 65, 83, 77, 32, 102, 105, 108, 101, 32, 97, 110, 100, 32, 105, 110, 118, 97, 108, 105, 100, 97, 116, 101, 115, 32, 116, 104, 101, 32, 99, 117, 114, 114, 101, 110, 116, 32, 109, 111, 100, 117, 108, 101, 32, 112, 114, 111, 109, 105, 115, 101, 46, 10, 32, 32, 32, 32, 32, 42, 10, 32, 32, 32, 32, 32, 42, 32, 64, 112, 97, 114, 97, 109, 32, 115, 116, 114, 105, 110, 103, 32, 45, 32, 32, 84, 104, 101, 32, 110, 101, 119, 32, 85, 82, 76, 32, 102, 111, 114, 32, 116, 104, 101, 32, 87, 65, 83, 77, 32, 102, 105, 108, 101, 46, 10, 32, 32, 32, 32, 32, 42, 47, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 115, 101, 116, 87, 97, 115, 109, 85, 114, 108, 40, 117, 114, 108, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 117, 114, 108, 32, 61, 61, 61, 32, 116, 104, 105, 115, 46, 95, 119, 97, 115, 109, 85, 82, 76, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 119, 97, 115, 109, 85, 82, 76, 32, 61, 32, 117, 114, 108, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 77, 111, 100, 117, 108, 101, 80, 114, 111, 109, 105, 115, 101, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 47, 47, 32, 101, 115, 108, 105, 110, 116, 45, 100, 105, 115, 97, 98, 108, 101, 45, 110, 101, 120, 116, 45, 108, 105, 110, 101, 32, 64, 116, 121, 112, 101, 115, 99, 114, 105, 112, 116, 45, 101, 115, 108, 105, 110, 116, 47, 110, 97, 109, 105, 110, 103, 45, 99, 111, 110, 118, 101, 110, 116, 105, 111, 110, 10, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 68, 111, 116, 76, 111, 116, 116, 105, 101, 87, 97, 115, 109, 76, 111, 97, 100, 101, 114, 44, 32, 34, 95, 77, 111, 100, 117, 108, 101, 80, 114, 111, 109, 105, 115, 101, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 47, 47, 32, 85, 82, 76, 32, 102, 111, 114, 32, 116, 104, 101, 32, 87, 65, 83, 77, 32, 102, 105, 108, 101, 44, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 101, 100, 32, 117, 115, 105, 110, 103, 32, 112, 97, 99, 107, 97, 103, 101, 32, 105, 110, 102, 111, 114, 109, 97, 116, 105, 111, 110, 10, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 68, 111, 116, 76, 111, 116, 116, 105, 101, 87, 97, 115, 109, 76, 111, 97, 100, 101, 114, 44, 32, 34, 95, 119, 97, 115, 109, 85, 82, 76, 34, 44, 32, 96, 104, 116, 116, 112, 115, 58, 47, 47, 99, 100, 110, 46, 106, 115, 100, 101, 108, 105, 118, 114, 46, 110, 101, 116, 47, 110, 112, 109, 47, 36, 123, 80, 65, 67, 75, 65, 71, 69, 95, 78, 65, 77, 69, 125, 64, 36, 123, 80, 65, 67, 75, 65, 71, 69, 95, 86, 69, 82, 83, 73, 79, 78, 125, 47, 100, 105, 115, 116, 47, 100, 111, 116, 108, 111, 116, 116, 105, 101, 45, 112, 108, 97, 121, 101, 114, 46, 119, 97, 115, 109, 96, 41, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 101, 118, 101, 110, 116, 45, 109, 97, 110, 97, 103, 101, 114, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 69, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 32, 61, 32, 99, 108, 97, 115, 115, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 34, 44, 32, 47, 42, 32, 64, 95, 95, 80, 85, 82, 69, 95, 95, 32, 42, 47, 32, 110, 101, 119, 32, 77, 97, 112, 40, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 116, 121, 112, 101, 44, 32, 108, 105, 115, 116, 101, 110, 101, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 108, 101, 116, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 32, 61, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 46, 103, 101, 116, 40, 116, 121, 112, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 108, 105, 115, 116, 101, 110, 101, 114, 115, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 32, 61, 32, 47, 42, 32, 64, 95, 95, 80, 85, 82, 69, 95, 95, 32, 42, 47, 32, 110, 101, 119, 32, 83, 101, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 46, 115, 101, 116, 40, 116, 121, 112, 101, 44, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 97, 100, 100, 40, 108, 105, 115, 116, 101, 110, 101, 114, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 116, 121, 112, 101, 44, 32, 108, 105, 115, 116, 101, 110, 101, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 32, 61, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 46, 103, 101, 116, 40, 116, 121, 112, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 108, 105, 115, 116, 101, 110, 101, 114, 115, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 105, 115, 116, 101, 110, 101, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 100, 101, 108, 101, 116, 101, 40, 108, 105, 115, 116, 101, 110, 101, 114, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 115, 105, 122, 101, 32, 61, 61, 61, 32, 48, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 46, 100, 101, 108, 101, 116, 101, 40, 116, 121, 112, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 46, 100, 101, 108, 101, 116, 101, 40, 116, 121, 112, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 100, 105, 115, 112, 97, 116, 99, 104, 40, 101, 118, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 32, 61, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 46, 103, 101, 116, 40, 101, 118, 101, 110, 116, 46, 116, 121, 112, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 63, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 108, 105, 115, 116, 101, 110, 101, 114, 41, 32, 61, 62, 32, 108, 105, 115, 116, 101, 110, 101, 114, 40, 101, 118, 101, 110, 116, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 109, 111, 118, 101, 65, 108, 108, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 46, 99, 108, 101, 97, 114, 40, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 111, 102, 102, 115, 99, 114, 101, 101, 110, 45, 111, 98, 115, 101, 114, 118, 101, 114, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 79, 102, 102, 115, 99, 114, 101, 101, 110, 79, 98, 115, 101, 114, 118, 101, 114, 32, 61, 32, 99, 108, 97, 115, 115, 32, 123, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 95, 105, 110, 105, 116, 105, 97, 108, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 116, 101, 114, 115, 101, 99, 116, 105, 111, 110, 79, 98, 115, 101, 114, 118, 101, 114, 67, 97, 108, 108, 98, 97, 99, 107, 32, 61, 32, 40, 101, 110, 116, 114, 105, 101, 115, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 101, 110, 116, 114, 105, 101, 115, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 101, 110, 116, 114, 121, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 103, 101, 116, 40, 101, 110, 116, 114, 121, 46, 116, 97, 114, 103, 101, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 110, 116, 114, 121, 46, 105, 115, 73, 110, 116, 101, 114, 115, 101, 99, 116, 105, 110, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 117, 110, 102, 114, 101, 101, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 102, 114, 101, 101, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 32, 61, 32, 110, 101, 119, 32, 73, 110, 116, 101, 114, 115, 101, 99, 116, 105, 111, 110, 79, 98, 115, 101, 114, 118, 101, 114, 40, 105, 110, 116, 101, 114, 115, 101, 99, 116, 105, 111, 110, 79, 98, 115, 101, 114, 118, 101, 114, 67, 97, 108, 108, 98, 97, 99, 107, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 101, 115, 104, 111, 108, 100, 58, 32, 48, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 44, 32, 100, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 105, 110, 105, 116, 105, 97, 108, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 104, 97, 115, 40, 99, 97, 110, 118, 97, 115, 41, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 115, 101, 116, 40, 99, 97, 110, 118, 97, 115, 44, 32, 100, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 63, 46, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 63, 46, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 100, 101, 108, 101, 116, 101, 40, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 115, 105, 122, 101, 32, 61, 61, 61, 32, 48, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 63, 46, 100, 105, 115, 99, 111, 110, 110, 101, 99, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 79, 102, 102, 115, 99, 114, 101, 101, 110, 79, 98, 115, 101, 114, 118, 101, 114, 44, 32, 34, 95, 111, 98, 115, 101, 114, 118, 101, 114, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 79, 102, 102, 115, 99, 114, 101, 101, 110, 79, 98, 115, 101, 114, 118, 101, 114, 44, 32, 34, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 34, 44, 32, 47, 42, 32, 64, 95, 95, 80, 85, 82, 69, 95, 95, 32, 42, 47, 32, 110, 101, 119, 32, 77, 97, 112, 40, 41, 41, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 114, 101, 115, 105, 122, 101, 45, 111, 98, 115, 101, 114, 118, 101, 114, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 82, 69, 83, 73, 90, 69, 95, 68, 69, 66, 79, 85, 78, 67, 69, 95, 84, 73, 77, 69, 32, 61, 32, 49, 48, 48, 59, 10, 32, 32, 118, 97, 114, 32, 67, 97, 110, 118, 97, 115, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 32, 61, 32, 99, 108, 97, 115, 115, 32, 123, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 95, 105, 110, 105, 116, 105, 97, 108, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 105, 122, 101, 72, 97, 110, 100, 108, 101, 114, 32, 61, 32, 40, 101, 110, 116, 114, 105, 101, 115, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 101, 110, 116, 114, 105, 101, 115, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 101, 110, 116, 114, 121, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 101, 108, 101, 109, 101, 110, 116, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 103, 101, 116, 40, 101, 110, 116, 114, 121, 46, 116, 97, 114, 103, 101, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 101, 108, 101, 109, 101, 110, 116, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 91, 100, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 44, 32, 116, 105, 109, 101, 111, 117, 116, 93, 32, 61, 32, 101, 108, 101, 109, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 108, 101, 97, 114, 84, 105, 109, 101, 111, 117, 116, 40, 116, 105, 109, 101, 111, 117, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 110, 101, 119, 84, 105, 109, 101, 111, 117, 116, 32, 61, 32, 115, 101, 116, 84, 105, 109, 101, 111, 117, 116, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 46, 114, 101, 115, 105, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 32, 82, 69, 83, 73, 90, 69, 95, 68, 69, 66, 79, 85, 78, 67, 69, 95, 84, 73, 77, 69, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 115, 101, 116, 40, 101, 110, 116, 114, 121, 46, 116, 97, 114, 103, 101, 116, 44, 32, 91, 100, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 44, 32, 110, 101, 119, 84, 105, 109, 101, 111, 117, 116, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 32, 61, 32, 110, 101, 119, 32, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 40, 114, 101, 115, 105, 122, 101, 72, 97, 110, 100, 108, 101, 114, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 44, 32, 100, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 105, 110, 105, 116, 105, 97, 108, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 104, 97, 115, 40, 99, 97, 110, 118, 97, 115, 41, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 115, 101, 116, 40, 99, 97, 110, 118, 97, 115, 44, 32, 91, 100, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 44, 32, 48, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 63, 46, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 101, 108, 101, 109, 101, 110, 116, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 103, 101, 116, 40, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 108, 101, 109, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 116, 105, 109, 101, 111, 117, 116, 73, 100, 32, 61, 32, 101, 108, 101, 109, 101, 110, 116, 91, 49, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 105, 109, 101, 111, 117, 116, 73, 100, 41, 32, 99, 108, 101, 97, 114, 84, 105, 109, 101, 111, 117, 116, 40, 116, 105, 109, 101, 111, 117, 116, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 63, 46, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 100, 101, 108, 101, 116, 101, 40, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 115, 105, 122, 101, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 46, 100, 105, 115, 99, 111, 110, 110, 101, 99, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 67, 97, 110, 118, 97, 115, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 44, 32, 34, 95, 111, 98, 115, 101, 114, 118, 101, 114, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 67, 97, 110, 118, 97, 115, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 44, 32, 34, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 34, 44, 32, 47, 42, 32, 64, 95, 95, 80, 85, 82, 69, 95, 95, 32, 42, 47, 32, 110, 101, 119, 32, 77, 97, 112, 40, 41, 41, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 117, 116, 105, 108, 115, 46, 116, 115, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 105, 115, 72, 101, 120, 67, 111, 108, 111, 114, 40, 99, 111, 108, 111, 114, 41, 32, 123, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 47, 94, 35, 40, 91, 92, 100, 97, 45, 102, 93, 123, 54, 125, 124, 91, 92, 100, 97, 45, 102, 93, 123, 56, 125, 41, 36, 47, 105, 117, 46, 116, 101, 115, 116, 40, 99, 111, 108, 111, 114, 41, 59, 10, 32, 32, 125, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 104, 101, 120, 83, 116, 114, 105, 110, 103, 84, 111, 82, 71, 66, 65, 73, 110, 116, 40, 99, 111, 108, 111, 114, 72, 101, 120, 41, 32, 123, 10, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 115, 72, 101, 120, 67, 111, 108, 111, 114, 40, 99, 111, 108, 111, 114, 72, 101, 120, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 108, 101, 116, 32, 104, 101, 120, 32, 61, 32, 99, 111, 108, 111, 114, 72, 101, 120, 46, 114, 101, 112, 108, 97, 99, 101, 40, 34, 35, 34, 44, 32, 34, 34, 41, 59, 10, 32, 32, 32, 32, 104, 101, 120, 32, 61, 32, 104, 101, 120, 46, 108, 101, 110, 103, 116, 104, 32, 61, 61, 61, 32, 54, 32, 63, 32, 96, 36, 123, 104, 101, 120, 125, 102, 102, 96, 32, 58, 32, 104, 101, 120, 59, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 112, 97, 114, 115, 101, 73, 110, 116, 40, 104, 101, 120, 44, 32, 49, 54, 41, 59, 10, 32, 32, 125, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 105, 115, 68, 111, 116, 76, 111, 116, 116, 105, 101, 40, 102, 105, 108, 101, 68, 97, 116, 97, 41, 32, 123, 10, 32, 32, 32, 32, 105, 102, 32, 40, 102, 105, 108, 101, 68, 97, 116, 97, 46, 98, 121, 116, 101, 76, 101, 110, 103, 116, 104, 32, 60, 32, 52, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 102, 105, 108, 101, 83, 105, 103, 110, 97, 116, 117, 114, 101, 32, 61, 32, 110, 101, 119, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 40, 102, 105, 108, 101, 68, 97, 116, 97, 46, 115, 108, 105, 99, 101, 40, 48, 44, 32, 90, 73, 80, 95, 83, 73, 71, 78, 65, 84, 85, 82, 69, 46, 98, 121, 116, 101, 76, 101, 110, 103, 116, 104, 41, 41, 59, 10, 32, 32, 32, 32, 102, 111, 114, 32, 40, 108, 101, 116, 32, 105, 32, 61, 32, 48, 59, 32, 105, 32, 60, 32, 90, 73, 80, 95, 83, 73, 71, 78, 65, 84, 85, 82, 69, 46, 108, 101, 110, 103, 116, 104, 59, 32, 105, 32, 43, 61, 32, 49, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 90, 73, 80, 95, 83, 73, 71, 78, 65, 84, 85, 82, 69, 91, 105, 93, 32, 33, 61, 61, 32, 102, 105, 108, 101, 83, 105, 103, 110, 97, 116, 117, 114, 101, 91, 105, 93, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 114, 117, 101, 59, 10, 32, 32, 125, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 105, 115, 76, 111, 116, 116, 105, 101, 74, 83, 79, 78, 40, 106, 115, 111, 110, 41, 32, 123, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 76, 79, 84, 84, 73, 69, 95, 74, 83, 79, 78, 95, 77, 65, 78, 68, 65, 84, 79, 82, 89, 95, 70, 73, 69, 76, 68, 83, 46, 101, 118, 101, 114, 121, 40, 40, 102, 105, 101, 108, 100, 41, 32, 61, 62, 32, 79, 98, 106, 101, 99, 116, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 46, 99, 97, 108, 108, 40, 106, 115, 111, 110, 44, 32, 102, 105, 101, 108, 100, 41, 41, 59, 10, 32, 32, 125, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 105, 115, 76, 111, 116, 116, 105, 101, 40, 102, 105, 108, 101, 68, 97, 116, 97, 41, 32, 123, 10, 32, 32, 32, 32, 105, 102, 32, 40, 116, 121, 112, 101, 111, 102, 32, 102, 105, 108, 101, 68, 97, 116, 97, 32, 61, 61, 61, 32, 34, 115, 116, 114, 105, 110, 103, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 115, 76, 111, 116, 116, 105, 101, 74, 83, 79, 78, 40, 74, 83, 79, 78, 46, 112, 97, 114, 115, 101, 40, 102, 105, 108, 101, 68, 97, 116, 97, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 95, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 115, 76, 111, 116, 116, 105, 101, 74, 83, 79, 78, 40, 102, 105, 108, 101, 68, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 103, 101, 116, 68, 101, 102, 97, 117, 108, 116, 68, 80, 82, 40, 41, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 100, 112, 114, 32, 61, 32, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 63, 32, 119, 105, 110, 100, 111, 119, 46, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 58, 32, 49, 59, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 49, 32, 43, 32, 40, 100, 112, 114, 32, 45, 32, 49, 41, 32, 42, 32, 68, 69, 70, 65, 85, 76, 84, 95, 68, 80, 82, 95, 70, 65, 67, 84, 79, 82, 59, 10, 32, 32, 125, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 105, 115, 69, 108, 101, 109, 101, 110, 116, 73, 110, 86, 105, 101, 119, 112, 111, 114, 116, 40, 101, 108, 101, 109, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 99, 116, 32, 61, 32, 101, 108, 101, 109, 101, 110, 116, 46, 103, 101, 116, 66, 111, 117, 110, 100, 105, 110, 103, 67, 108, 105, 101, 110, 116, 82, 101, 99, 116, 40, 41, 59, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 114, 101, 99, 116, 46, 116, 111, 112, 32, 62, 61, 32, 48, 32, 38, 38, 32, 114, 101, 99, 116, 46, 108, 101, 102, 116, 32, 62, 61, 32, 48, 32, 38, 38, 32, 114, 101, 99, 116, 46, 98, 111, 116, 116, 111, 109, 32, 60, 61, 32, 40, 119, 105, 110, 100, 111, 119, 46, 105, 110, 110, 101, 114, 72, 101, 105, 103, 104, 116, 32, 124, 124, 32, 100, 111, 99, 117, 109, 101, 110, 116, 46, 100, 111, 99, 117, 109, 101, 110, 116, 69, 108, 101, 109, 101, 110, 116, 46, 99, 108, 105, 101, 110, 116, 72, 101, 105, 103, 104, 116, 41, 32, 38, 38, 32, 114, 101, 99, 116, 46, 114, 105, 103, 104, 116, 32, 60, 61, 32, 40, 119, 105, 110, 100, 111, 119, 46, 105, 110, 110, 101, 114, 87, 105, 100, 116, 104, 32, 124, 124, 32, 100, 111, 99, 117, 109, 101, 110, 116, 46, 100, 111, 99, 117, 109, 101, 110, 116, 69, 108, 101, 109, 101, 110, 116, 46, 99, 108, 105, 101, 110, 116, 87, 105, 100, 116, 104, 41, 59, 10, 32, 32, 125, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 100, 111, 116, 108, 111, 116, 116, 105, 101, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 77, 111, 100, 101, 32, 61, 32, 40, 109, 111, 100, 101, 44, 32, 109, 111, 100, 117, 108, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 105, 102, 32, 40, 109, 111, 100, 101, 32, 61, 61, 61, 32, 34, 114, 101, 118, 101, 114, 115, 101, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 77, 111, 100, 101, 46, 82, 101, 118, 101, 114, 115, 101, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 109, 111, 100, 101, 32, 61, 61, 61, 32, 34, 98, 111, 117, 110, 99, 101, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 77, 111, 100, 101, 46, 66, 111, 117, 110, 99, 101, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 109, 111, 100, 101, 32, 61, 61, 61, 32, 34, 114, 101, 118, 101, 114, 115, 101, 45, 98, 111, 117, 110, 99, 101, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 77, 111, 100, 101, 46, 82, 101, 118, 101, 114, 115, 101, 66, 111, 117, 110, 99, 101, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 77, 111, 100, 101, 46, 70, 111, 114, 119, 97, 114, 100, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 70, 105, 116, 32, 61, 32, 40, 102, 105, 116, 44, 32, 109, 111, 100, 117, 108, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 105, 102, 32, 40, 102, 105, 116, 32, 61, 61, 61, 32, 34, 99, 111, 110, 116, 97, 105, 110, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 70, 105, 116, 46, 67, 111, 110, 116, 97, 105, 110, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 102, 105, 116, 32, 61, 61, 61, 32, 34, 99, 111, 118, 101, 114, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 70, 105, 116, 46, 67, 111, 118, 101, 114, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 102, 105, 116, 32, 61, 61, 61, 32, 34, 102, 105, 108, 108, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 70, 105, 116, 46, 70, 105, 108, 108, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 102, 105, 116, 32, 61, 61, 61, 32, 34, 102, 105, 116, 45, 104, 101, 105, 103, 104, 116, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 70, 105, 116, 46, 70, 105, 116, 72, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 102, 105, 116, 32, 61, 61, 61, 32, 34, 102, 105, 116, 45, 119, 105, 100, 116, 104, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 70, 105, 116, 46, 70, 105, 116, 87, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 70, 105, 116, 46, 78, 111, 110, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 65, 108, 105, 103, 110, 32, 61, 32, 40, 97, 108, 105, 103, 110, 44, 32, 109, 111, 100, 117, 108, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 99, 111, 114, 101, 65, 108, 105, 103, 110, 32, 61, 32, 110, 101, 119, 32, 109, 111, 100, 117, 108, 101, 46, 86, 101, 99, 116, 111, 114, 70, 108, 111, 97, 116, 40, 41, 59, 10, 32, 32, 32, 32, 99, 111, 114, 101, 65, 108, 105, 103, 110, 46, 112, 117, 115, 104, 95, 98, 97, 99, 107, 40, 97, 108, 105, 103, 110, 91, 48, 93, 41, 59, 10, 32, 32, 32, 32, 99, 111, 114, 101, 65, 108, 105, 103, 110, 46, 112, 117, 115, 104, 95, 98, 97, 99, 107, 40, 97, 108, 105, 103, 110, 91, 49, 93, 41, 59, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 111, 114, 101, 65, 108, 105, 103, 110, 59, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 83, 101, 103, 109, 101, 110, 116, 32, 61, 32, 40, 115, 101, 103, 109, 101, 110, 116, 44, 32, 109, 111, 100, 117, 108, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 99, 111, 114, 101, 115, 101, 103, 109, 101, 110, 116, 32, 61, 32, 110, 101, 119, 32, 109, 111, 100, 117, 108, 101, 46, 86, 101, 99, 116, 111, 114, 70, 108, 111, 97, 116, 40, 41, 59, 10, 32, 32, 32, 32, 105, 102, 32, 40, 115, 101, 103, 109, 101, 110, 116, 46, 108, 101, 110, 103, 116, 104, 32, 33, 61, 61, 32, 50, 41, 32, 114, 101, 116, 117, 114, 110, 32, 99, 111, 114, 101, 115, 101, 103, 109, 101, 110, 116, 59, 10, 32, 32, 32, 32, 99, 111, 114, 101, 115, 101, 103, 109, 101, 110, 116, 46, 112, 117, 115, 104, 95, 98, 97, 99, 107, 40, 115, 101, 103, 109, 101, 110, 116, 91, 48, 93, 41, 59, 10, 32, 32, 32, 32, 99, 111, 114, 101, 115, 101, 103, 109, 101, 110, 116, 46, 112, 117, 115, 104, 95, 98, 97, 99, 107, 40, 115, 101, 103, 109, 101, 110, 116, 91, 49, 93, 41, 59, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 111, 114, 101, 115, 101, 103, 109, 101, 110, 116, 59, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 76, 97, 121, 111, 117, 116, 32, 61, 32, 40, 108, 97, 121, 111, 117, 116, 44, 32, 109, 111, 100, 117, 108, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 105, 102, 32, 40, 33, 108, 97, 121, 111, 117, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 99, 114, 101, 97, 116, 101, 68, 101, 102, 97, 117, 108, 116, 76, 97, 121, 111, 117, 116, 40, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 97, 108, 105, 103, 110, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 65, 108, 105, 103, 110, 40, 108, 97, 121, 111, 117, 116, 46, 97, 108, 105, 103, 110, 32, 63, 63, 32, 91, 48, 46, 53, 44, 32, 48, 46, 53, 93, 44, 32, 109, 111, 100, 117, 108, 101, 41, 44, 10, 32, 32, 32, 32, 32, 32, 102, 105, 116, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 70, 105, 116, 40, 108, 97, 121, 111, 117, 116, 46, 102, 105, 116, 32, 63, 63, 32, 34, 99, 111, 110, 116, 97, 105, 110, 34, 44, 32, 109, 111, 100, 117, 108, 101, 41, 10, 32, 32, 32, 32, 125, 59, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 32, 61, 32, 99, 108, 97, 115, 115, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 99, 111, 110, 102, 105, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 99, 97, 110, 118, 97, 115, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 99, 111, 110, 116, 101, 120, 116, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 34, 44, 32, 123, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 105, 115, 70, 114, 111, 122, 101, 110, 34, 44, 32, 102, 97, 108, 115, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 112, 111, 105, 110, 116, 101, 114, 85, 112, 77, 101, 116, 104, 111, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 112, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 77, 101, 116, 104, 111, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 112, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 77, 101, 116, 104, 111, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 112, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 77, 101, 116, 104, 111, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 112, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 77, 101, 116, 104, 111, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 99, 97, 110, 118, 97, 115, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 32, 61, 32, 110, 101, 119, 32, 69, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 32, 61, 32, 110, 101, 119, 32, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 46, 46, 46, 99, 111, 110, 102, 105, 103, 46, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 58, 32, 99, 111, 110, 102, 105, 103, 46, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 63, 46, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 124, 124, 32, 103, 101, 116, 68, 101, 102, 97, 117, 108, 116, 68, 80, 82, 40, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 47, 47, 32, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 32, 105, 115, 32, 116, 114, 117, 101, 32, 98, 121, 32, 100, 101, 102, 97, 117, 108, 116, 32, 116, 111, 32, 112, 114, 101, 118, 101, 110, 116, 32, 117, 110, 110, 101, 99, 101, 115, 115, 97, 114, 121, 32, 114, 101, 110, 100, 101, 114, 105, 110, 103, 32, 119, 104, 101, 110, 32, 116, 104, 101, 32, 99, 97, 110, 118, 97, 115, 32, 105, 115, 32, 111, 102, 102, 115, 99, 114, 101, 101, 110, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 58, 32, 99, 111, 110, 102, 105, 103, 46, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 63, 46, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 32, 63, 63, 32, 116, 114, 117, 101, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 68, 111, 116, 76, 111, 116, 116, 105, 101, 87, 97, 115, 109, 76, 111, 97, 100, 101, 114, 46, 108, 111, 97, 100, 40, 41, 46, 116, 104, 101, 110, 40, 40, 109, 111, 100, 117, 108, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 32, 61, 32, 109, 111, 100, 117, 108, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 32, 110, 101, 119, 32, 109, 111, 100, 117, 108, 101, 46, 68, 111, 116, 76, 111, 116, 116, 105, 101, 80, 108, 97, 121, 101, 114, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 58, 32, 99, 111, 110, 102, 105, 103, 46, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 32, 63, 63, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 101, 109, 101, 73, 100, 58, 32, 99, 111, 110, 102, 105, 103, 46, 116, 104, 101, 109, 101, 73, 100, 32, 63, 63, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 73, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 117, 116, 111, 112, 108, 97, 121, 58, 32, 99, 111, 110, 102, 105, 103, 46, 97, 117, 116, 111, 112, 108, 97, 121, 32, 63, 63, 32, 102, 97, 108, 115, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 58, 32, 48, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 111, 112, 65, 110, 105, 109, 97, 116, 105, 111, 110, 58, 32, 99, 111, 110, 102, 105, 103, 46, 108, 111, 111, 112, 32, 63, 63, 32, 102, 97, 108, 115, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 111, 100, 101, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 77, 111, 100, 101, 40, 99, 111, 110, 102, 105, 103, 46, 109, 111, 100, 101, 32, 63, 63, 32, 34, 102, 111, 114, 119, 97, 114, 100, 34, 44, 32, 109, 111, 100, 117, 108, 101, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 101, 103, 109, 101, 110, 116, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 83, 101, 103, 109, 101, 110, 116, 40, 99, 111, 110, 102, 105, 103, 46, 115, 101, 103, 109, 101, 110, 116, 32, 63, 63, 32, 91, 93, 44, 32, 109, 111, 100, 117, 108, 101, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 112, 101, 101, 100, 58, 32, 99, 111, 110, 102, 105, 103, 46, 115, 112, 101, 101, 100, 32, 63, 63, 32, 49, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 58, 32, 99, 111, 110, 102, 105, 103, 46, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 32, 63, 63, 32, 116, 114, 117, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 97, 114, 107, 101, 114, 58, 32, 99, 111, 110, 102, 105, 103, 46, 109, 97, 114, 107, 101, 114, 32, 63, 63, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 108, 97, 121, 111, 117, 116, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 76, 97, 121, 111, 117, 116, 40, 99, 111, 110, 102, 105, 103, 46, 108, 97, 121, 111, 117, 116, 44, 32, 109, 111, 100, 117, 108, 101, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 114, 101, 97, 100, 121, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 111, 110, 102, 105, 103, 46, 100, 97, 116, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 108, 111, 97, 100, 70, 114, 111, 109, 68, 97, 116, 97, 40, 99, 111, 110, 102, 105, 103, 46, 100, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 99, 111, 110, 102, 105, 103, 46, 115, 114, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 108, 111, 97, 100, 70, 114, 111, 109, 83, 114, 99, 40, 99, 111, 110, 102, 105, 103, 46, 115, 114, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 111, 110, 102, 105, 103, 46, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 115, 101, 116, 66, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 40, 99, 111, 110, 102, 105, 103, 46, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 41, 46, 99, 97, 116, 99, 104, 40, 40, 101, 114, 114, 111, 114, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 121, 112, 101, 58, 32, 34, 108, 111, 97, 100, 69, 114, 114, 111, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 114, 114, 111, 114, 58, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 70, 97, 105, 108, 101, 100, 32, 116, 111, 32, 108, 111, 97, 100, 32, 119, 97, 115, 109, 32, 109, 111, 100, 117, 108, 101, 58, 32, 36, 123, 101, 114, 114, 111, 114, 125, 96, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 85, 112, 77, 101, 116, 104, 111, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 85, 112, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 77, 101, 116, 104, 111, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 77, 101, 116, 104, 111, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 77, 101, 116, 104, 111, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 77, 101, 116, 104, 111, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 76, 101, 97, 118, 101, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 100, 105, 115, 112, 97, 116, 99, 104, 69, 114, 114, 111, 114, 40, 109, 101, 115, 115, 97, 103, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 111, 108, 101, 46, 101, 114, 114, 111, 114, 40, 109, 101, 115, 115, 97, 103, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 108, 111, 97, 100, 69, 114, 114, 111, 114, 34, 44, 32, 101, 114, 114, 111, 114, 58, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 109, 101, 115, 115, 97, 103, 101, 41, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 97, 115, 121, 110, 99, 32, 95, 102, 101, 116, 99, 104, 68, 97, 116, 97, 40, 115, 114, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 97, 119, 97, 105, 116, 32, 102, 101, 116, 99, 104, 40, 115, 114, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 114, 101, 115, 112, 111, 110, 115, 101, 46, 111, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 70, 97, 105, 108, 101, 100, 32, 116, 111, 32, 102, 101, 116, 99, 104, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 32, 100, 97, 116, 97, 32, 102, 114, 111, 109, 32, 85, 82, 76, 58, 32, 36, 123, 115, 114, 99, 125, 46, 32, 36, 123, 114, 101, 115, 112, 111, 110, 115, 101, 46, 115, 116, 97, 116, 117, 115, 125, 58, 32, 36, 123, 114, 101, 115, 112, 111, 110, 115, 101, 46, 115, 116, 97, 116, 117, 115, 84, 101, 120, 116, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 100, 97, 116, 97, 32, 61, 32, 97, 119, 97, 105, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 46, 97, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 105, 115, 68, 111, 116, 76, 111, 116, 116, 105, 101, 40, 100, 97, 116, 97, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 100, 97, 116, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 110, 101, 119, 32, 84, 101, 120, 116, 68, 101, 99, 111, 100, 101, 114, 40, 41, 46, 100, 101, 99, 111, 100, 101, 40, 100, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 108, 111, 97, 100, 70, 114, 111, 109, 68, 97, 116, 97, 40, 100, 97, 116, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 119, 105, 100, 116, 104, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 104, 101, 105, 103, 104, 116, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 32, 32, 108, 101, 116, 32, 108, 111, 97, 100, 101, 100, 32, 61, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 121, 112, 101, 111, 102, 32, 100, 97, 116, 97, 32, 61, 61, 61, 32, 34, 115, 116, 114, 105, 110, 103, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 115, 76, 111, 116, 116, 105, 101, 40, 100, 97, 116, 97, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 105, 115, 112, 97, 116, 99, 104, 69, 114, 114, 111, 114, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 34, 73, 110, 118, 97, 108, 105, 100, 32, 76, 111, 116, 116, 105, 101, 32, 74, 83, 79, 78, 32, 115, 116, 114, 105, 110, 103, 58, 32, 84, 104, 101, 32, 112, 114, 111, 118, 105, 100, 101, 100, 32, 115, 116, 114, 105, 110, 103, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 99, 111, 110, 102, 111, 114, 109, 32, 116, 111, 32, 116, 104, 101, 32, 76, 111, 116, 116, 105, 101, 32, 74, 83, 79, 78, 32, 102, 111, 114, 109, 97, 116, 46, 34, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 97, 100, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 108, 111, 97, 100, 65, 110, 105, 109, 97, 116, 105, 111, 110, 68, 97, 116, 97, 40, 100, 97, 116, 97, 44, 32, 119, 105, 100, 116, 104, 44, 32, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 100, 97, 116, 97, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 65, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 115, 68, 111, 116, 76, 111, 116, 116, 105, 101, 40, 100, 97, 116, 97, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 105, 115, 112, 97, 116, 99, 104, 69, 114, 114, 111, 114, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 34, 73, 110, 118, 97, 108, 105, 100, 32, 100, 111, 116, 76, 111, 116, 116, 105, 101, 32, 65, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 58, 32, 84, 104, 101, 32, 112, 114, 111, 118, 105, 100, 101, 100, 32, 65, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 99, 111, 110, 102, 111, 114, 109, 32, 116, 111, 32, 116, 104, 101, 32, 100, 111, 116, 76, 111, 116, 116, 105, 101, 32, 102, 111, 114, 109, 97, 116, 46, 34, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 97, 100, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 108, 111, 97, 100, 68, 111, 116, 76, 111, 116, 116, 105, 101, 68, 97, 116, 97, 40, 100, 97, 116, 97, 44, 32, 119, 105, 100, 116, 104, 44, 32, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 116, 121, 112, 101, 111, 102, 32, 100, 97, 116, 97, 32, 61, 61, 61, 32, 34, 111, 98, 106, 101, 99, 116, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 115, 76, 111, 116, 116, 105, 101, 40, 100, 97, 116, 97, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 105, 115, 112, 97, 116, 99, 104, 69, 114, 114, 111, 114, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 34, 73, 110, 118, 97, 108, 105, 100, 32, 76, 111, 116, 116, 105, 101, 32, 74, 83, 79, 78, 32, 111, 98, 106, 101, 99, 116, 58, 32, 84, 104, 101, 32, 112, 114, 111, 118, 105, 100, 101, 100, 32, 111, 98, 106, 101, 99, 116, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 99, 111, 110, 102, 111, 114, 109, 32, 116, 111, 32, 116, 104, 101, 32, 76, 111, 116, 116, 105, 101, 32, 74, 83, 79, 78, 32, 102, 111, 114, 109, 97, 116, 46, 34, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 97, 100, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 108, 111, 97, 100, 65, 110, 105, 109, 97, 116, 105, 111, 110, 68, 97, 116, 97, 40, 74, 83, 79, 78, 46, 115, 116, 114, 105, 110, 103, 105, 102, 121, 40, 100, 97, 116, 97, 41, 44, 32, 119, 105, 100, 116, 104, 44, 32, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 105, 115, 112, 97, 116, 99, 104, 69, 114, 114, 111, 114, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 96, 85, 110, 115, 117, 112, 112, 111, 114, 116, 101, 100, 32, 100, 97, 116, 97, 32, 116, 121, 112, 101, 32, 102, 111, 114, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 32, 100, 97, 116, 97, 46, 32, 69, 120, 112, 101, 99, 116, 101, 100, 58, 32, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 45, 32, 115, 116, 114, 105, 110, 103, 32, 40, 76, 111, 116, 116, 105, 101, 32, 74, 83, 79, 78, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 45, 32, 65, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 32, 40, 100, 111, 116, 76, 111, 116, 116, 105, 101, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 45, 32, 111, 98, 106, 101, 99, 116, 32, 40, 76, 111, 116, 116, 105, 101, 32, 74, 83, 79, 78, 41, 46, 32, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 82, 101, 99, 101, 105, 118, 101, 100, 58, 32, 36, 123, 116, 121, 112, 101, 111, 102, 32, 100, 97, 116, 97, 125, 96, 10, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 111, 97, 100, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 108, 111, 97, 100, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 114, 101, 115, 105, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 121, 112, 101, 58, 32, 34, 102, 114, 97, 109, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 58, 32, 116, 104, 105, 115, 46, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 97, 117, 116, 111, 112, 108, 97, 121, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 112, 108, 97, 121, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 105, 115, 80, 108, 97, 121, 105, 110, 103, 40, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 112, 108, 97, 121, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 46, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 116, 104, 105, 115, 46, 95, 100, 114, 97, 119, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 111, 108, 101, 46, 101, 114, 114, 111, 114, 40, 34, 115, 111, 109, 101, 116, 104, 105, 110, 103, 32, 119, 101, 110, 116, 32, 119, 114, 111, 110, 103, 44, 32, 116, 104, 101, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 32, 119, 97, 115, 32, 115, 117, 112, 112, 111, 115, 101, 32, 116, 111, 32, 97, 117, 116, 111, 112, 108, 97, 121, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 46, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 102, 102, 115, 99, 114, 101, 101, 110, 79, 98, 115, 101, 114, 118, 101, 114, 46, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 44, 32, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 46, 97, 117, 116, 111, 82, 101, 115, 105, 122, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 97, 110, 118, 97, 115, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 46, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 44, 32, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 105, 115, 112, 97, 116, 99, 104, 69, 114, 114, 111, 114, 40, 34, 70, 97, 105, 108, 101, 100, 32, 116, 111, 32, 108, 111, 97, 100, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 32, 100, 97, 116, 97, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 108, 111, 97, 100, 70, 114, 111, 109, 83, 114, 99, 40, 115, 114, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 102, 101, 116, 99, 104, 68, 97, 116, 97, 40, 115, 114, 99, 41, 46, 116, 104, 101, 110, 40, 40, 100, 97, 116, 97, 41, 32, 61, 62, 32, 116, 104, 105, 115, 46, 95, 108, 111, 97, 100, 70, 114, 111, 109, 68, 97, 116, 97, 40, 100, 97, 116, 97, 41, 41, 46, 99, 97, 116, 99, 104, 40, 40, 101, 114, 114, 111, 114, 41, 32, 61, 62, 32, 116, 104, 105, 115, 46, 95, 100, 105, 115, 112, 97, 116, 99, 104, 69, 114, 114, 111, 114, 40, 96, 70, 97, 105, 108, 101, 100, 32, 116, 111, 32, 108, 111, 97, 100, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 32, 100, 97, 116, 97, 32, 102, 114, 111, 109, 32, 85, 82, 76, 58, 32, 36, 123, 115, 114, 99, 125, 46, 32, 36, 123, 101, 114, 114, 111, 114, 125, 96, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 98, 117, 102, 102, 101, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 114, 101, 116, 117, 114, 110, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 98, 117, 102, 102, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 97, 99, 116, 105, 118, 101, 65, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 63, 46, 97, 99, 116, 105, 118, 101, 65, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 40, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 97, 99, 116, 105, 118, 101, 84, 104, 101, 109, 101, 73, 100, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 63, 46, 97, 99, 116, 105, 118, 101, 84, 104, 101, 109, 101, 73, 100, 40, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 108, 97, 121, 111, 117, 116, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 97, 121, 111, 117, 116, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 63, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 108, 97, 121, 111, 117, 116, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 97, 121, 111, 117, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 108, 105, 103, 110, 58, 32, 91, 108, 97, 121, 111, 117, 116, 46, 97, 108, 105, 103, 110, 46, 103, 101, 116, 40, 48, 41, 44, 32, 108, 97, 121, 111, 117, 116, 46, 97, 108, 105, 103, 110, 46, 103, 101, 116, 40, 49, 41, 93, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 105, 116, 58, 32, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 119, 105, 116, 99, 104, 32, 40, 108, 97, 121, 111, 117, 116, 46, 102, 105, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 63, 46, 70, 105, 116, 46, 67, 111, 110, 116, 97, 105, 110, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 99, 111, 110, 116, 97, 105, 110, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 63, 46, 70, 105, 116, 46, 67, 111, 118, 101, 114, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 99, 111, 118, 101, 114, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 63, 46, 70, 105, 116, 46, 70, 105, 108, 108, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 102, 105, 108, 108, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 63, 46, 70, 105, 116, 46, 70, 105, 116, 72, 101, 105, 103, 104, 116, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 102, 105, 116, 45, 104, 101, 105, 103, 104, 116, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 63, 46, 70, 105, 116, 46, 70, 105, 116, 87, 105, 100, 116, 104, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 102, 105, 116, 45, 119, 105, 100, 116, 104, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 63, 46, 70, 105, 116, 46, 78, 111, 110, 101, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 110, 111, 110, 101, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 102, 97, 117, 108, 116, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 99, 111, 110, 116, 97, 105, 110, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 40, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 118, 111, 105, 100, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 109, 97, 114, 107, 101, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 97, 114, 107, 101, 114, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 63, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 109, 97, 114, 107, 101, 114, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 97, 114, 107, 101, 114, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 109, 97, 110, 105, 102, 101, 115, 116, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 97, 110, 105, 102, 101, 115, 116, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 63, 46, 109, 97, 110, 105, 102, 101, 115, 116, 83, 116, 114, 105, 110, 103, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 33, 109, 97, 110, 105, 102, 101, 115, 116, 41, 32, 114, 101, 116, 117, 114, 110, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 97, 110, 105, 102, 101, 115, 116, 74, 115, 111, 110, 32, 61, 32, 74, 83, 79, 78, 46, 112, 97, 114, 115, 101, 40, 109, 97, 110, 105, 102, 101, 115, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 79, 98, 106, 101, 99, 116, 46, 107, 101, 121, 115, 40, 109, 97, 110, 105, 102, 101, 115, 116, 74, 115, 111, 110, 41, 46, 108, 101, 110, 103, 116, 104, 32, 61, 61, 61, 32, 48, 41, 32, 114, 101, 116, 117, 114, 110, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 97, 110, 105, 102, 101, 115, 116, 74, 115, 111, 110, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 95, 101, 114, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 115, 101, 103, 109, 101, 110, 116, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 101, 103, 109, 101, 110, 116, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 63, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 115, 101, 103, 109, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 115, 101, 103, 109, 101, 110, 116, 32, 38, 38, 32, 115, 101, 103, 109, 101, 110, 116, 46, 115, 105, 122, 101, 40, 41, 32, 61, 61, 61, 32, 50, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 115, 101, 103, 109, 101, 110, 116, 46, 103, 101, 116, 40, 48, 41, 44, 32, 115, 101, 103, 109, 101, 110, 116, 46, 103, 101, 116, 40, 49, 41, 93, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 118, 111, 105, 100, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 108, 111, 111, 112, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 63, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 108, 111, 111, 112, 65, 110, 105, 109, 97, 116, 105, 111, 110, 32, 63, 63, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 109, 111, 100, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 111, 100, 101, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 63, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 109, 111, 100, 101, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 109, 111, 100, 101, 32, 61, 61, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 63, 46, 77, 111, 100, 101, 46, 82, 101, 118, 101, 114, 115, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 114, 101, 118, 101, 114, 115, 101, 34, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 109, 111, 100, 101, 32, 61, 61, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 63, 46, 77, 111, 100, 101, 46, 66, 111, 117, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 98, 111, 117, 110, 99, 101, 34, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 109, 111, 100, 101, 32, 61, 61, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 63, 46, 77, 111, 100, 101, 46, 82, 101, 118, 101, 114, 115, 101, 66, 111, 117, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 114, 101, 118, 101, 114, 115, 101, 45, 98, 111, 117, 110, 99, 101, 34, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 102, 111, 114, 119, 97, 114, 100, 34, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 105, 115, 70, 114, 111, 122, 101, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 105, 115, 70, 114, 111, 122, 101, 110, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 32, 63, 63, 32, 34, 34, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 97, 117, 116, 111, 112, 108, 97, 121, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 63, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 97, 117, 116, 111, 112, 108, 97, 121, 32, 63, 63, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 63, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 32, 63, 63, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 115, 112, 101, 101, 100, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 63, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 115, 112, 101, 101, 100, 32, 63, 63, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 105, 115, 82, 101, 97, 100, 121, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 33, 61, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 105, 115, 76, 111, 97, 100, 101, 100, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 63, 46, 105, 115, 76, 111, 97, 100, 101, 100, 40, 41, 32, 63, 63, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 105, 115, 80, 108, 97, 121, 105, 110, 103, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 63, 46, 105, 115, 80, 108, 97, 121, 105, 110, 103, 40, 41, 32, 63, 63, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 105, 115, 80, 97, 117, 115, 101, 100, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 63, 46, 105, 115, 80, 97, 117, 115, 101, 100, 40, 41, 32, 63, 63, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 105, 115, 83, 116, 111, 112, 112, 101, 100, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 63, 46, 105, 115, 83, 116, 111, 112, 112, 101, 100, 40, 41, 32, 63, 63, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 77, 97, 116, 104, 46, 114, 111, 117, 110, 100, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 40, 41, 32, 42, 32, 49, 48, 48, 41, 32, 47, 32, 49, 48, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 108, 111, 111, 112, 67, 111, 117, 110, 116, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 63, 46, 108, 111, 111, 112, 67, 111, 117, 110, 116, 40, 41, 32, 63, 63, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 116, 111, 116, 97, 108, 70, 114, 97, 109, 101, 115, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 63, 46, 116, 111, 116, 97, 108, 70, 114, 97, 109, 101, 115, 40, 41, 32, 63, 63, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 100, 117, 114, 97, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 63, 46, 100, 117, 114, 97, 116, 105, 111, 110, 40, 41, 32, 63, 63, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 115, 101, 103, 109, 101, 110, 116, 68, 117, 114, 97, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 63, 46, 115, 101, 103, 109, 101, 110, 116, 68, 117, 114, 97, 116, 105, 111, 110, 40, 41, 32, 63, 63, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 99, 97, 110, 118, 97, 115, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 108, 111, 97, 100, 40, 99, 111, 110, 102, 105, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 33, 61, 61, 32, 110, 117, 108, 108, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 46, 99, 97, 110, 99, 101, 108, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 105, 115, 70, 114, 111, 122, 101, 110, 32, 61, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 58, 32, 99, 111, 110, 102, 105, 103, 46, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 32, 63, 63, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 101, 109, 101, 73, 100, 58, 32, 99, 111, 110, 102, 105, 103, 46, 116, 104, 101, 109, 101, 73, 100, 32, 63, 63, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 73, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 117, 116, 111, 112, 108, 97, 121, 58, 32, 99, 111, 110, 102, 105, 103, 46, 97, 117, 116, 111, 112, 108, 97, 121, 32, 63, 63, 32, 102, 97, 108, 115, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 58, 32, 48, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 111, 112, 65, 110, 105, 109, 97, 116, 105, 111, 110, 58, 32, 99, 111, 110, 102, 105, 103, 46, 108, 111, 111, 112, 32, 63, 63, 32, 102, 97, 108, 115, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 111, 100, 101, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 77, 111, 100, 101, 40, 99, 111, 110, 102, 105, 103, 46, 109, 111, 100, 101, 32, 63, 63, 32, 34, 102, 111, 114, 119, 97, 114, 100, 34, 44, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 101, 103, 109, 101, 110, 116, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 83, 101, 103, 109, 101, 110, 116, 40, 99, 111, 110, 102, 105, 103, 46, 115, 101, 103, 109, 101, 110, 116, 32, 63, 63, 32, 91, 93, 44, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 112, 101, 101, 100, 58, 32, 99, 111, 110, 102, 105, 103, 46, 115, 112, 101, 101, 100, 32, 63, 63, 32, 49, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 58, 32, 99, 111, 110, 102, 105, 103, 46, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 32, 63, 63, 32, 116, 114, 117, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 97, 114, 107, 101, 114, 58, 32, 99, 111, 110, 102, 105, 103, 46, 109, 97, 114, 107, 101, 114, 32, 63, 63, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 97, 121, 111, 117, 116, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 76, 97, 121, 111, 117, 116, 40, 99, 111, 110, 102, 105, 103, 46, 108, 97, 121, 111, 117, 116, 44, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 111, 110, 102, 105, 103, 46, 100, 97, 116, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 108, 111, 97, 100, 70, 114, 111, 109, 68, 97, 116, 97, 40, 99, 111, 110, 102, 105, 103, 46, 100, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 99, 111, 110, 102, 105, 103, 46, 115, 114, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 108, 111, 97, 100, 70, 114, 111, 109, 83, 114, 99, 40, 99, 111, 110, 102, 105, 103, 46, 115, 114, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 115, 101, 116, 66, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 40, 99, 111, 110, 102, 105, 103, 46, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 32, 63, 63, 32, 34, 34, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 114, 101, 110, 100, 101, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 116, 104, 105, 115, 46, 95, 99, 111, 110, 116, 101, 120, 116, 32, 38, 38, 32, 34, 103, 101, 116, 67, 111, 110, 116, 101, 120, 116, 34, 32, 105, 110, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 38, 38, 32, 116, 121, 112, 101, 111, 102, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 103, 101, 116, 67, 111, 110, 116, 101, 120, 116, 32, 61, 61, 61, 32, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 111, 110, 116, 101, 120, 116, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 103, 101, 116, 67, 111, 110, 116, 101, 120, 116, 40, 34, 50, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 110, 100, 101, 114, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 114, 101, 110, 100, 101, 114, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 99, 111, 110, 116, 101, 120, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 98, 117, 102, 102, 101, 114, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 98, 117, 102, 102, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 101, 120, 112, 101, 99, 116, 101, 100, 76, 101, 110, 103, 116, 104, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 32, 42, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 32, 42, 32, 66, 89, 84, 69, 83, 95, 80, 69, 82, 95, 80, 73, 88, 69, 76, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 117, 102, 102, 101, 114, 46, 98, 121, 116, 101, 76, 101, 110, 103, 116, 104, 32, 33, 61, 61, 32, 101, 120, 112, 101, 99, 116, 101, 100, 76, 101, 110, 103, 116, 104, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 111, 108, 101, 46, 119, 97, 114, 110, 40, 96, 66, 117, 102, 102, 101, 114, 32, 115, 105, 122, 101, 32, 109, 105, 115, 109, 97, 116, 99, 104, 58, 32, 103, 111, 116, 32, 36, 123, 98, 117, 102, 102, 101, 114, 46, 98, 121, 116, 101, 76, 101, 110, 103, 116, 104, 125, 44, 32, 101, 120, 112, 101, 99, 116, 101, 100, 32, 36, 123, 101, 120, 112, 101, 99, 116, 101, 100, 76, 101, 110, 103, 116, 104, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 108, 101, 116, 32, 105, 109, 97, 103, 101, 68, 97, 116, 97, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 99, 108, 97, 109, 112, 101, 100, 66, 117, 102, 102, 101, 114, 32, 61, 32, 110, 101, 119, 32, 85, 105, 110, 116, 56, 67, 108, 97, 109, 112, 101, 100, 65, 114, 114, 97, 121, 40, 98, 117, 102, 102, 101, 114, 44, 32, 48, 44, 32, 98, 117, 102, 102, 101, 114, 46, 98, 121, 116, 101, 76, 101, 110, 103, 116, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 121, 112, 101, 111, 102, 32, 73, 109, 97, 103, 101, 68, 97, 116, 97, 32, 61, 61, 61, 32, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 109, 97, 103, 101, 68, 97, 116, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 111, 110, 116, 101, 120, 116, 46, 99, 114, 101, 97, 116, 101, 73, 109, 97, 103, 101, 68, 97, 116, 97, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 44, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 109, 97, 103, 101, 68, 97, 116, 97, 46, 100, 97, 116, 97, 46, 115, 101, 116, 40, 99, 108, 97, 109, 112, 101, 100, 66, 117, 102, 102, 101, 114, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 109, 97, 103, 101, 68, 97, 116, 97, 32, 61, 32, 110, 101, 119, 32, 73, 109, 97, 103, 101, 68, 97, 116, 97, 40, 99, 108, 97, 109, 112, 101, 100, 66, 117, 102, 102, 101, 114, 44, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 44, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 111, 110, 116, 101, 120, 116, 46, 112, 117, 116, 73, 109, 97, 103, 101, 68, 97, 116, 97, 40, 105, 109, 97, 103, 101, 68, 97, 116, 97, 44, 32, 48, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 121, 112, 101, 58, 32, 34, 114, 101, 110, 100, 101, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 58, 32, 116, 104, 105, 115, 46, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 114, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 100, 114, 97, 119, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 33, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 105, 115, 80, 108, 97, 121, 105, 110, 103, 40, 41, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 110, 101, 120, 116, 70, 114, 97, 109, 101, 32, 61, 32, 77, 97, 116, 104, 46, 114, 111, 117, 110, 100, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 114, 101, 113, 117, 101, 115, 116, 70, 114, 97, 109, 101, 40, 41, 32, 42, 32, 49, 101, 51, 41, 32, 47, 32, 49, 101, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 117, 112, 100, 97, 116, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 70, 114, 97, 109, 101, 40, 110, 101, 120, 116, 70, 114, 97, 109, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 117, 112, 100, 97, 116, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 121, 112, 101, 58, 32, 34, 102, 114, 97, 109, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 58, 32, 116, 104, 105, 115, 46, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 110, 100, 101, 114, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 114, 101, 110, 100, 101, 114, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 105, 115, 67, 111, 109, 112, 108, 101, 116, 101, 40, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 108, 111, 111, 112, 65, 110, 105, 109, 97, 116, 105, 111, 110, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 121, 112, 101, 58, 32, 34, 108, 111, 111, 112, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 111, 112, 67, 111, 117, 110, 116, 58, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 108, 111, 111, 112, 67, 111, 117, 110, 116, 40, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 99, 111, 109, 112, 108, 101, 116, 101, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 46, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 116, 104, 105, 115, 46, 95, 100, 114, 97, 119, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 101, 114, 114, 111, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 111, 108, 101, 46, 101, 114, 114, 111, 114, 40, 34, 69, 114, 114, 111, 114, 32, 105, 110, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 32, 102, 114, 97, 109, 101, 58, 34, 44, 32, 101, 114, 114, 111, 114, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 114, 101, 110, 100, 101, 114, 69, 114, 114, 111, 114, 34, 44, 32, 101, 114, 114, 111, 114, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 114, 114, 111, 114, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 87, 101, 98, 65, 115, 115, 101, 109, 98, 108, 121, 46, 82, 117, 110, 116, 105, 109, 101, 69, 114, 114, 111, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 100, 101, 115, 116, 114, 111, 121, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 112, 108, 97, 121, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 33, 61, 61, 32, 110, 117, 108, 108, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 46, 99, 97, 110, 99, 101, 108, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 111, 107, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 112, 108, 97, 121, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 111, 107, 32, 124, 124, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 105, 115, 80, 108, 97, 121, 105, 110, 103, 40, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 105, 115, 70, 114, 111, 122, 101, 110, 32, 61, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 112, 108, 97, 121, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 46, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 116, 104, 105, 115, 46, 95, 100, 114, 97, 119, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 46, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 32, 38, 38, 32, 33, 105, 115, 69, 108, 101, 109, 101, 110, 116, 73, 110, 86, 105, 101, 119, 112, 111, 114, 116, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 102, 114, 101, 101, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 112, 97, 117, 115, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 111, 107, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 112, 97, 117, 115, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 111, 107, 32, 124, 124, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 105, 115, 80, 97, 117, 115, 101, 100, 40, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 112, 97, 117, 115, 101, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 111, 112, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 111, 107, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 116, 111, 112, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 111, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 102, 114, 97, 109, 101, 34, 44, 32, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 58, 32, 116, 104, 105, 115, 46, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 115, 116, 111, 112, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 70, 114, 97, 109, 101, 40, 102, 114, 97, 109, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 102, 114, 97, 109, 101, 32, 60, 32, 48, 32, 124, 124, 32, 102, 114, 97, 109, 101, 32, 62, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 116, 111, 116, 97, 108, 70, 114, 97, 109, 101, 115, 40, 41, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 111, 107, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 101, 107, 40, 102, 114, 97, 109, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 111, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 102, 114, 97, 109, 101, 34, 44, 32, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 58, 32, 116, 104, 105, 115, 46, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 83, 112, 101, 101, 100, 40, 115, 112, 101, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 46, 46, 46, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 112, 101, 101, 100, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 66, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 40, 99, 111, 108, 111, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 115, 116, 121, 108, 101, 46, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 32, 61, 32, 99, 111, 108, 111, 114, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 46, 46, 46, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 58, 32, 104, 101, 120, 83, 116, 114, 105, 110, 103, 84, 111, 82, 71, 66, 65, 73, 110, 116, 40, 99, 111, 108, 111, 114, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 32, 61, 32, 99, 111, 108, 111, 114, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 76, 111, 111, 112, 40, 108, 111, 111, 112, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 46, 46, 46, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 111, 112, 65, 110, 105, 109, 97, 116, 105, 111, 110, 58, 32, 108, 111, 111, 112, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 85, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 40, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 46, 46, 46, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 116, 121, 112, 101, 44, 32, 108, 105, 115, 116, 101, 110, 101, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 116, 121, 112, 101, 44, 32, 108, 105, 115, 116, 101, 110, 101, 114, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 116, 121, 112, 101, 44, 32, 108, 105, 115, 116, 101, 110, 101, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 116, 121, 112, 101, 44, 32, 108, 105, 115, 116, 101, 110, 101, 114, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 100, 101, 115, 116, 114, 111, 121, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 33, 61, 61, 32, 110, 117, 108, 108, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 46, 99, 97, 110, 99, 101, 108, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 79, 102, 102, 115, 99, 114, 101, 101, 110, 79, 98, 115, 101, 114, 118, 101, 114, 46, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 67, 97, 110, 118, 97, 115, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 46, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 63, 46, 100, 101, 108, 101, 116, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 111, 110, 116, 101, 120, 116, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 121, 112, 101, 58, 32, 34, 100, 101, 115, 116, 114, 111, 121, 34, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 114, 101, 109, 111, 118, 101, 65, 108, 108, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 108, 101, 97, 110, 117, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 102, 114, 101, 101, 122, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 46, 99, 97, 110, 99, 101, 108, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 105, 115, 70, 114, 111, 122, 101, 110, 32, 61, 32, 116, 114, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 102, 114, 101, 101, 122, 101, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 117, 110, 102, 114, 101, 101, 122, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 33, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 46, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 116, 104, 105, 115, 46, 95, 100, 114, 97, 119, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 105, 115, 70, 114, 111, 122, 101, 110, 32, 61, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 117, 110, 102, 114, 101, 101, 122, 101, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 115, 105, 122, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 124, 124, 32, 33, 116, 104, 105, 115, 46, 105, 115, 76, 111, 97, 100, 101, 100, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 100, 112, 114, 32, 61, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 46, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 124, 124, 32, 119, 105, 110, 100, 111, 119, 46, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 124, 124, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 123, 32, 104, 101, 105, 103, 104, 116, 58, 32, 99, 108, 105, 101, 110, 116, 72, 101, 105, 103, 104, 116, 44, 32, 119, 105, 100, 116, 104, 58, 32, 99, 108, 105, 101, 110, 116, 87, 105, 100, 116, 104, 32, 125, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 103, 101, 116, 66, 111, 117, 110, 100, 105, 110, 103, 67, 108, 105, 101, 110, 116, 82, 101, 99, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 108, 105, 101, 110, 116, 72, 101, 105, 103, 104, 116, 32, 33, 61, 61, 32, 48, 32, 38, 38, 32, 99, 108, 105, 101, 110, 116, 87, 105, 100, 116, 104, 32, 33, 61, 61, 32, 48, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 32, 61, 32, 99, 108, 105, 101, 110, 116, 87, 105, 100, 116, 104, 32, 42, 32, 100, 112, 114, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 32, 61, 32, 99, 108, 105, 101, 110, 116, 72, 101, 105, 103, 104, 116, 32, 42, 32, 100, 112, 114, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 111, 107, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 114, 101, 115, 105, 122, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 44, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 111, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 83, 101, 103, 109, 101, 110, 116, 40, 115, 116, 97, 114, 116, 70, 114, 97, 109, 101, 44, 32, 101, 110, 100, 70, 114, 97, 109, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 46, 46, 46, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 101, 103, 109, 101, 110, 116, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 83, 101, 103, 109, 101, 110, 116, 40, 91, 115, 116, 97, 114, 116, 70, 114, 97, 109, 101, 44, 32, 101, 110, 100, 70, 114, 97, 109, 101, 93, 44, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 77, 111, 100, 101, 40, 109, 111, 100, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 46, 46, 46, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 111, 100, 101, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 77, 111, 100, 101, 40, 109, 111, 100, 101, 44, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 82, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 40, 99, 111, 110, 102, 105, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 123, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 44, 32, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 44, 32, 46, 46, 46, 114, 101, 115, 116, 67, 111, 110, 102, 105, 103, 32, 125, 32, 61, 32, 99, 111, 110, 102, 105, 103, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 46, 46, 46, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 46, 46, 46, 114, 101, 115, 116, 67, 111, 110, 102, 105, 103, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 47, 47, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 105, 115, 32, 97, 32, 115, 112, 101, 99, 105, 97, 108, 32, 99, 97, 115, 101, 44, 32, 105, 116, 32, 115, 104, 111, 117, 108, 100, 32, 98, 101, 32, 115, 101, 116, 32, 116, 111, 32, 116, 104, 101, 32, 100, 101, 102, 97, 117, 108, 116, 32, 118, 97, 108, 117, 101, 32, 105, 102, 32, 105, 116, 39, 115, 32, 110, 111, 116, 32, 112, 114, 111, 118, 105, 100, 101, 100, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 58, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 124, 124, 32, 103, 101, 116, 68, 101, 102, 97, 117, 108, 116, 68, 80, 82, 40, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 58, 32, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 32, 63, 63, 32, 116, 114, 117, 101, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 46, 97, 117, 116, 111, 82, 101, 115, 105, 122, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 97, 110, 118, 97, 115, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 46, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 44, 32, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 97, 110, 118, 97, 115, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 46, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 46, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 102, 102, 115, 99, 114, 101, 101, 110, 79, 98, 115, 101, 114, 118, 101, 114, 46, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 44, 32, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 102, 102, 115, 99, 114, 101, 101, 110, 79, 98, 115, 101, 114, 118, 101, 114, 46, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 105, 115, 70, 114, 111, 122, 101, 110, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 117, 110, 102, 114, 101, 101, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 108, 111, 97, 100, 65, 110, 105, 109, 97, 116, 105, 111, 110, 40, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 97, 99, 116, 105, 118, 101, 65, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 40, 41, 32, 61, 61, 61, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 111, 97, 100, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 108, 111, 97, 100, 65, 110, 105, 109, 97, 116, 105, 111, 110, 40, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 44, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 44, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 111, 97, 100, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 108, 111, 97, 100, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 114, 101, 115, 105, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 121, 112, 101, 58, 32, 34, 108, 111, 97, 100, 69, 114, 114, 111, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 114, 114, 111, 114, 58, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 70, 97, 105, 108, 101, 100, 32, 116, 111, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 32, 58, 36, 123, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 125, 96, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 77, 97, 114, 107, 101, 114, 40, 109, 97, 114, 107, 101, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 46, 46, 46, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 97, 114, 107, 101, 114, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 109, 97, 114, 107, 101, 114, 115, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 97, 114, 107, 101, 114, 115, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 63, 46, 109, 97, 114, 107, 101, 114, 115, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 109, 97, 114, 107, 101, 114, 115, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 117, 108, 116, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 108, 101, 116, 32, 105, 32, 61, 32, 48, 59, 32, 105, 32, 60, 32, 109, 97, 114, 107, 101, 114, 115, 46, 115, 105, 122, 101, 40, 41, 59, 32, 105, 32, 43, 61, 32, 49, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 97, 114, 107, 101, 114, 32, 61, 32, 109, 97, 114, 107, 101, 114, 115, 46, 103, 101, 116, 40, 105, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 46, 112, 117, 115, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 109, 97, 114, 107, 101, 114, 46, 110, 97, 109, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 105, 109, 101, 58, 32, 109, 97, 114, 107, 101, 114, 46, 116, 105, 109, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 117, 114, 97, 116, 105, 111, 110, 58, 32, 109, 97, 114, 107, 101, 114, 46, 100, 117, 114, 97, 116, 105, 111, 110, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 114, 101, 115, 117, 108, 116, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 93, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 84, 104, 101, 109, 101, 40, 116, 104, 101, 109, 101, 73, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 111, 97, 100, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 84, 104, 101, 109, 101, 40, 116, 104, 101, 109, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 108, 111, 97, 100, 101, 100, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 115, 101, 116, 84, 104, 101, 109, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 114, 101, 115, 101, 116, 84, 104, 101, 109, 101, 40, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 84, 104, 101, 109, 101, 68, 97, 116, 97, 40, 116, 104, 101, 109, 101, 68, 97, 116, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 111, 97, 100, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 84, 104, 101, 109, 101, 68, 97, 116, 97, 40, 116, 104, 101, 109, 101, 68, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 108, 111, 97, 100, 101, 100, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 83, 108, 111, 116, 115, 40, 115, 108, 111, 116, 115, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 83, 108, 111, 116, 115, 40, 115, 108, 111, 116, 115, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 76, 97, 121, 111, 117, 116, 40, 108, 97, 121, 111, 117, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 46, 46, 46, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 97, 121, 111, 117, 116, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 76, 97, 121, 111, 117, 116, 40, 108, 97, 121, 111, 117, 116, 44, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 86, 105, 101, 119, 112, 111, 114, 116, 40, 120, 44, 32, 121, 44, 32, 119, 105, 100, 116, 104, 44, 32, 104, 101, 105, 103, 104, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 86, 105, 101, 119, 112, 111, 114, 116, 40, 120, 44, 32, 121, 44, 32, 119, 105, 100, 116, 104, 44, 32, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 115, 101, 116, 87, 97, 115, 109, 85, 114, 108, 40, 117, 114, 108, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 68, 111, 116, 76, 111, 116, 116, 105, 101, 87, 97, 115, 109, 76, 111, 97, 100, 101, 114, 46, 115, 101, 116, 87, 97, 115, 109, 85, 114, 108, 40, 117, 114, 108, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 108, 111, 97, 100, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 73, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 63, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 111, 97, 100, 40, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 73, 100, 41, 32, 63, 63, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 114, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 111, 112, 101, 110, 85, 114, 108, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 46, 99, 114, 101, 97, 116, 101, 68, 101, 102, 97, 117, 108, 116, 79, 112, 101, 110, 85, 82, 76, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 116, 97, 114, 116, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 83, 116, 97, 114, 116, 40, 111, 112, 101, 110, 85, 114, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 115, 116, 97, 114, 116, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 115, 101, 116, 117, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 115, 116, 97, 114, 116, 101, 100, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 111, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 116, 111, 112, 112, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 63, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 83, 116, 111, 112, 40, 41, 32, 63, 63, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 115, 116, 111, 112, 112, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 108, 101, 97, 110, 117, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 115, 116, 111, 112, 112, 101, 100, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 103, 101, 116, 80, 111, 105, 110, 116, 101, 114, 80, 111, 115, 105, 116, 105, 111, 110, 40, 101, 118, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 99, 116, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 103, 101, 116, 66, 111, 117, 110, 100, 105, 110, 103, 67, 108, 105, 101, 110, 116, 82, 101, 99, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 99, 97, 108, 101, 88, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 32, 47, 32, 114, 101, 99, 116, 46, 119, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 99, 97, 108, 101, 89, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 32, 47, 32, 114, 101, 99, 116, 46, 104, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 61, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 46, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 124, 124, 32, 119, 105, 110, 100, 111, 119, 46, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 124, 124, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 120, 32, 61, 32, 40, 101, 118, 101, 110, 116, 46, 99, 108, 105, 101, 110, 116, 88, 32, 45, 32, 114, 101, 99, 116, 46, 108, 101, 102, 116, 41, 32, 42, 32, 115, 99, 97, 108, 101, 88, 32, 47, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 121, 32, 61, 32, 40, 101, 118, 101, 110, 116, 46, 99, 108, 105, 101, 110, 116, 89, 32, 45, 32, 114, 101, 99, 116, 46, 116, 111, 112, 41, 32, 42, 32, 115, 99, 97, 108, 101, 89, 32, 47, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 120, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 121, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 85, 112, 40, 101, 118, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 123, 32, 120, 44, 32, 121, 32, 125, 32, 61, 32, 116, 104, 105, 115, 46, 95, 103, 101, 116, 80, 111, 105, 110, 116, 101, 114, 80, 111, 115, 105, 116, 105, 111, 110, 40, 101, 118, 101, 110, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 85, 112, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 40, 101, 118, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 123, 32, 120, 44, 32, 121, 32, 125, 32, 61, 32, 116, 104, 105, 115, 46, 95, 103, 101, 116, 80, 111, 105, 110, 116, 101, 114, 80, 111, 115, 105, 116, 105, 111, 110, 40, 101, 118, 101, 110, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 40, 101, 118, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 123, 32, 120, 44, 32, 121, 32, 125, 32, 61, 32, 116, 104, 105, 115, 46, 95, 103, 101, 116, 80, 111, 105, 110, 116, 101, 114, 80, 111, 115, 105, 116, 105, 111, 110, 40, 101, 118, 101, 110, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 40, 101, 118, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 123, 32, 120, 44, 32, 121, 32, 125, 32, 61, 32, 116, 104, 105, 115, 46, 95, 103, 101, 116, 80, 111, 105, 110, 116, 101, 114, 80, 111, 115, 105, 116, 105, 111, 110, 40, 101, 118, 101, 110, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 76, 101, 97, 118, 101, 40, 101, 118, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 123, 32, 120, 44, 32, 121, 32, 125, 32, 61, 32, 116, 104, 105, 115, 46, 95, 103, 101, 116, 80, 111, 105, 110, 116, 101, 114, 80, 111, 115, 105, 116, 105, 111, 110, 40, 101, 118, 101, 110, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 85, 112, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 63, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 80, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 85, 112, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 63, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 80, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 63, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 80, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 63, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 80, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 63, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 80, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 114, 101, 116, 117, 114, 110, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 86, 101, 99, 116, 111, 114, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 70, 114, 97, 109, 101, 119, 111, 114, 107, 83, 101, 116, 117, 112, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 108, 101, 116, 32, 105, 32, 61, 32, 48, 59, 32, 105, 32, 60, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 86, 101, 99, 116, 111, 114, 46, 115, 105, 122, 101, 40, 41, 59, 32, 105, 32, 43, 61, 32, 49, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 112, 117, 115, 104, 40, 108, 105, 115, 116, 101, 110, 101, 114, 115, 86, 101, 99, 116, 111, 114, 46, 103, 101, 116, 40, 105, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 115, 101, 116, 117, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 33, 61, 61, 32, 110, 117, 108, 108, 32, 38, 38, 32, 116, 104, 105, 115, 46, 105, 115, 76, 111, 97, 100, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 32, 61, 32, 116, 104, 105, 115, 46, 103, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 80, 111, 105, 110, 116, 101, 114, 85, 112, 34, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 117, 112, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 85, 112, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 34, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 100, 111, 119, 110, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 34, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 109, 111, 118, 101, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 34, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 101, 110, 116, 101, 114, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 80, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 34, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 108, 101, 97, 118, 101, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 99, 108, 101, 97, 110, 117, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 117, 112, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 85, 112, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 100, 111, 119, 110, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 109, 111, 118, 101, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 101, 110, 116, 101, 114, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 108, 101, 97, 118, 101, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 108, 111, 97, 100, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 40, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 63, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 111, 97, 100, 68, 97, 116, 97, 40, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 41, 32, 63, 63, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 83, 105, 122, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 119, 105, 100, 116, 104, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 63, 46, 97, 110, 105, 109, 97, 116, 105, 111, 110, 83, 105, 122, 101, 40, 41, 46, 103, 101, 116, 40, 48, 41, 32, 63, 63, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 104, 101, 105, 103, 104, 116, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 63, 46, 97, 110, 105, 109, 97, 116, 105, 111, 110, 83, 105, 122, 101, 40, 41, 46, 103, 101, 116, 40, 49, 41, 32, 63, 63, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 119, 105, 100, 116, 104, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 104, 101, 105, 103, 104, 116, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 66, 111, 111, 108, 101, 97, 110, 67, 111, 110, 116, 101, 120, 116, 40, 110, 97, 109, 101, 44, 32, 118, 97, 108, 117, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 63, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 83, 101, 116, 66, 111, 111, 108, 101, 97, 110, 73, 110, 112, 117, 116, 40, 110, 97, 109, 101, 44, 32, 118, 97, 108, 117, 101, 41, 32, 63, 63, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 78, 117, 109, 101, 114, 105, 99, 67, 111, 110, 116, 101, 120, 116, 40, 110, 97, 109, 101, 44, 32, 118, 97, 108, 117, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 63, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 83, 101, 116, 78, 117, 109, 101, 114, 105, 99, 73, 110, 112, 117, 116, 40, 110, 97, 109, 101, 44, 32, 118, 97, 108, 117, 101, 41, 32, 63, 63, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 83, 116, 114, 105, 110, 103, 67, 111, 110, 116, 101, 120, 116, 40, 110, 97, 109, 101, 44, 32, 118, 97, 108, 117, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 63, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 83, 101, 116, 83, 116, 114, 105, 110, 103, 73, 110, 112, 117, 116, 40, 110, 97, 109, 101, 44, 32, 118, 97, 108, 117, 101, 41, 32, 63, 63, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 47, 42, 42, 10, 32, 32, 32, 32, 32, 42, 32, 71, 101, 116, 32, 116, 104, 101, 32, 79, 114, 105, 101, 110, 116, 101, 100, 32, 66, 111, 117, 110, 100, 105, 110, 103, 32, 66, 111, 120, 32, 40, 79, 66, 66, 41, 32, 112, 111, 105, 110, 116, 115, 32, 111, 102, 32, 97, 32, 108, 97, 121, 101, 114, 32, 98, 121, 32, 105, 116, 115, 32, 110, 97, 109, 101, 10, 32, 32, 32, 32, 32, 42, 32, 64, 112, 97, 114, 97, 109, 32, 108, 97, 121, 101, 114, 78, 97, 109, 101, 32, 45, 32, 84, 104, 101, 32, 110, 97, 109, 101, 32, 111, 102, 32, 116, 104, 101, 32, 108, 97, 121, 101, 114, 10, 32, 32, 32, 32, 32, 42, 32, 64, 114, 101, 116, 117, 114, 110, 115, 32, 65, 110, 32, 97, 114, 114, 97, 121, 32, 111, 102, 32, 56, 32, 110, 117, 109, 98, 101, 114, 115, 32, 114, 101, 112, 114, 101, 115, 101, 110, 116, 105, 110, 103, 32, 52, 32, 112, 111, 105, 110, 116, 115, 32, 40, 120, 44, 121, 41, 32, 111, 102, 32, 116, 104, 101, 32, 79, 66, 66, 32, 105, 110, 32, 99, 108, 111, 99, 107, 119, 105, 115, 101, 32, 111, 114, 100, 101, 114, 32, 115, 116, 97, 114, 116, 105, 110, 103, 32, 102, 114, 111, 109, 32, 116, 111, 112, 45, 108, 101, 102, 116, 10, 32, 32, 32, 32, 32, 42, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 91, 120, 48, 44, 32, 121, 48, 44, 32, 120, 49, 44, 32, 121, 49, 44, 32, 120, 50, 44, 32, 121, 50, 44, 32, 120, 51, 44, 32, 121, 51, 93, 10, 32, 32, 32, 32, 32, 42, 10, 32, 32, 32, 32, 32, 42, 32, 64, 101, 120, 97, 109, 112, 108, 101, 10, 32, 32, 32, 32, 32, 42, 32, 96, 96, 96, 116, 121, 112, 101, 115, 99, 114, 105, 112, 116, 10, 32, 32, 32, 32, 32, 42, 32, 47, 47, 32, 68, 114, 97, 119, 32, 97, 32, 112, 111, 108, 121, 103, 111, 110, 32, 97, 114, 111, 117, 110, 100, 32, 116, 104, 101, 32, 108, 97, 121, 101, 114, 32, 39, 76, 97, 121, 101, 114, 32, 49, 39, 10, 32, 32, 32, 32, 32, 42, 32, 100, 111, 116, 76, 111, 116, 116, 105, 101, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 39, 114, 101, 110, 100, 101, 114, 39, 44, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 42, 32, 32, 32, 99, 111, 110, 115, 116, 32, 111, 98, 98, 80, 111, 105, 110, 116, 115, 32, 61, 32, 100, 111, 116, 76, 111, 116, 116, 105, 101, 46, 103, 101, 116, 76, 97, 121, 101, 114, 66, 111, 117, 110, 100, 105, 110, 103, 66, 111, 120, 40, 39, 76, 97, 121, 101, 114, 32, 49, 39, 41, 59, 10, 32, 32, 32, 32, 32, 42, 10, 32, 32, 32, 32, 32, 42, 32, 32, 32, 105, 102, 32, 40, 111, 98, 98, 80, 111, 105, 110, 116, 115, 41, 32, 123, 10, 32, 32, 32, 32, 32, 42, 32, 32, 32, 32, 32, 99, 111, 110, 116, 101, 120, 116, 46, 98, 101, 103, 105, 110, 80, 97, 116, 104, 40, 41, 59, 10, 32, 32, 32, 32, 32, 42, 32, 32, 32, 32, 32, 99, 111, 110, 116, 101, 120, 116, 46, 109, 111, 118, 101, 84, 111, 40, 111, 98, 98, 80, 111, 105, 110, 116, 115, 91, 48, 93, 44, 32, 111, 98, 98, 80, 111, 105, 110, 116, 115, 91, 49, 93, 41, 59, 32, 47, 47, 32, 70, 105, 114, 115, 116, 32, 112, 111, 105, 110, 116, 10, 32, 32, 32, 32, 32, 42, 32, 32, 32, 32, 32, 99, 111, 110, 116, 101, 120, 116, 46, 108, 105, 110, 101, 84, 111, 40, 111, 98, 98, 80, 111, 105, 110, 116, 115, 91, 50, 93, 44, 32, 111, 98, 98, 80, 111, 105, 110, 116, 115, 91, 51, 93, 41, 59, 32, 47, 47, 32, 83, 101, 99, 111, 110, 100, 32, 112, 111, 105, 110, 116, 10, 32, 32, 32, 32, 32, 42, 32, 32, 32, 32, 32, 99, 111, 110, 116, 101, 120, 116, 46, 108, 105, 110, 101, 84, 111, 40, 111, 98, 98, 80, 111, 105, 110, 116, 115, 91, 52, 93, 44, 32, 111, 98, 98, 80, 111, 105, 110, 116, 115, 91, 53, 93, 41, 59, 32, 47, 47, 32, 84, 104, 105, 114, 100, 32, 112, 111, 105, 110, 116, 10, 32, 32, 32, 32, 32, 42, 32, 32, 32, 32, 32, 99, 111, 110, 116, 101, 120, 116, 46, 108, 105, 110, 101, 84, 111, 40, 111, 98, 98, 80, 111, 105, 110, 116, 115, 91, 54, 93, 44, 32, 111, 98, 98, 80, 111, 105, 110, 116, 115, 91, 55, 93, 41, 59, 32, 47, 47, 32, 70, 111, 117, 114, 116, 104, 32, 112, 111, 105, 110, 116, 10, 32, 32, 32, 32, 32, 42, 32, 32, 32, 32, 32, 99, 111, 110, 116, 101, 120, 116, 46, 99, 108, 111, 115, 101, 80, 97, 116, 104, 40, 41, 59, 10, 32, 32, 32, 32, 32, 42, 32, 32, 32, 32, 32, 99, 111, 110, 116, 101, 120, 116, 46, 115, 116, 114, 111, 107, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 42, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 42, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 42, 32, 96, 96, 96, 10, 32, 32, 32, 32, 32, 42, 47, 10, 32, 32, 32, 32, 103, 101, 116, 76, 97, 121, 101, 114, 66, 111, 117, 110, 100, 105, 110, 103, 66, 111, 120, 40, 108, 97, 121, 101, 114, 78, 97, 109, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 98, 111, 117, 110, 100, 115, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 63, 46, 103, 101, 116, 76, 97, 121, 101, 114, 66, 111, 117, 110, 100, 115, 40, 108, 97, 121, 101, 114, 78, 97, 109, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 111, 117, 110, 100, 115, 41, 32, 114, 101, 116, 117, 114, 110, 32, 118, 111, 105, 100, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 111, 117, 110, 100, 115, 46, 115, 105, 122, 101, 40, 41, 32, 33, 61, 61, 32, 56, 41, 32, 114, 101, 116, 117, 114, 110, 32, 118, 111, 105, 100, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 112, 111, 105, 110, 116, 115, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 108, 101, 116, 32, 105, 32, 61, 32, 48, 59, 32, 105, 32, 60, 32, 56, 59, 32, 105, 32, 43, 61, 32, 49, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 112, 111, 105, 110, 116, 115, 46, 112, 117, 115, 104, 40, 98, 111, 117, 110, 100, 115, 46, 103, 101, 116, 40, 105, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 112, 111, 105, 110, 116, 115, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 116, 114, 97, 110, 115, 102, 111, 114, 109, 84, 104, 101, 109, 101, 84, 111, 76, 111, 116, 116, 105, 101, 83, 108, 111, 116, 115, 40, 116, 104, 101, 109, 101, 44, 32, 115, 108, 111, 116, 115, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 63, 46, 116, 114, 97, 110, 115, 102, 111, 114, 109, 84, 104, 101, 109, 101, 84, 111, 76, 111, 116, 116, 105, 101, 83, 108, 111, 116, 115, 40, 116, 104, 101, 109, 101, 44, 32, 115, 108, 111, 116, 115, 41, 32, 63, 63, 32, 34, 34, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 44, 32, 34, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 118, 97, 114, 32, 68, 111, 116, 76, 111, 116, 116, 105, 101, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 119, 111, 114, 107, 101, 114, 47, 100, 111, 116, 108, 111, 116, 116, 105, 101, 46, 119, 111, 114, 107, 101, 114, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 32, 61, 32, 47, 42, 32, 64, 95, 95, 80, 85, 82, 69, 95, 95, 32, 42, 47, 32, 110, 101, 119, 32, 77, 97, 112, 40, 41, 59, 10, 32, 32, 118, 97, 114, 32, 101, 118, 101, 110, 116, 72, 97, 110, 100, 108, 101, 114, 77, 97, 112, 32, 61, 32, 123, 10, 32, 32, 32, 32, 114, 101, 97, 100, 121, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 82, 101, 97, 100, 121, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 99, 111, 109, 112, 108, 101, 116, 101, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 67, 111, 109, 112, 108, 101, 116, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 97, 100, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 111, 97, 100, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 76, 111, 97, 100, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 108, 111, 97, 100, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 97, 100, 69, 114, 114, 111, 114, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 111, 97, 100, 69, 114, 114, 111, 114, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 76, 111, 97, 100, 69, 114, 114, 111, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 108, 111, 97, 100, 69, 114, 114, 111, 114, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 114, 101, 110, 100, 101, 114, 69, 114, 114, 111, 114, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 110, 100, 101, 114, 69, 114, 114, 111, 114, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 82, 101, 110, 100, 101, 114, 69, 114, 114, 111, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 114, 101, 110, 100, 101, 114, 69, 114, 114, 111, 114, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 111, 112, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 111, 111, 112, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 76, 111, 111, 112, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 108, 111, 111, 112, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 108, 97, 121, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 112, 108, 97, 121, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 80, 108, 97, 121, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 112, 108, 97, 121, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 97, 117, 115, 101, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 112, 97, 117, 115, 101, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 80, 97, 117, 115, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 112, 97, 117, 115, 101, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 116, 111, 112, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 116, 111, 112, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 83, 116, 111, 112, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 115, 116, 111, 112, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 102, 114, 97, 109, 101, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 102, 114, 97, 109, 101, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 70, 114, 97, 109, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 102, 114, 97, 109, 101, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 114, 101, 110, 100, 101, 114, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 110, 100, 101, 114, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 82, 101, 110, 100, 101, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 114, 101, 110, 100, 101, 114, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 102, 114, 101, 101, 122, 101, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 102, 114, 101, 101, 122, 101, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 70, 114, 101, 101, 122, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 102, 114, 101, 101, 122, 101, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 117, 110, 102, 114, 101, 101, 122, 101, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 117, 110, 102, 114, 101, 101, 122, 101, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 85, 110, 102, 114, 101, 101, 122, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 117, 110, 102, 114, 101, 101, 122, 101, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 100, 101, 115, 116, 114, 111, 121, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 100, 101, 115, 116, 114, 111, 121, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 68, 101, 115, 116, 114, 111, 121, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 100, 101, 115, 116, 114, 111, 121, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 99, 111, 109, 109, 97, 110, 100, 115, 32, 61, 32, 123, 10, 32, 32, 32, 32, 103, 101, 116, 68, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 83, 116, 97, 116, 101, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 116, 97, 116, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 111, 112, 67, 111, 117, 110, 116, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 108, 111, 111, 112, 67, 111, 117, 110, 116, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 76, 111, 97, 100, 101, 100, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 105, 115, 76, 111, 97, 100, 101, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 80, 97, 117, 115, 101, 100, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 105, 115, 80, 97, 117, 115, 101, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 80, 108, 97, 121, 105, 110, 103, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 105, 115, 80, 108, 97, 121, 105, 110, 103, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 83, 116, 111, 112, 112, 101, 100, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 105, 115, 83, 116, 111, 112, 112, 101, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 70, 114, 111, 122, 101, 110, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 105, 115, 70, 114, 111, 122, 101, 110, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 111, 112, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 108, 111, 111, 112, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 111, 100, 101, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 109, 111, 100, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 112, 101, 101, 100, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 112, 101, 101, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 116, 97, 108, 70, 114, 97, 109, 101, 115, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 116, 111, 116, 97, 108, 70, 114, 97, 109, 101, 115, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 117, 114, 97, 116, 105, 111, 110, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 100, 117, 114, 97, 116, 105, 111, 110, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 97, 114, 107, 101, 114, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 109, 97, 114, 107, 101, 114, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 97, 114, 107, 101, 114, 115, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 109, 97, 114, 107, 101, 114, 115, 40, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 99, 116, 105, 118, 101, 65, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 97, 99, 116, 105, 118, 101, 65, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 99, 116, 105, 118, 101, 84, 104, 101, 109, 101, 73, 100, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 97, 99, 116, 105, 118, 101, 84, 104, 101, 109, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 117, 116, 111, 112, 108, 97, 121, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 97, 117, 116, 111, 112, 108, 97, 121, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 101, 103, 109, 101, 110, 116, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 103, 109, 101, 110, 116, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 97, 121, 111, 117, 116, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 108, 97, 121, 111, 117, 116, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 101, 103, 109, 101, 110, 116, 68, 117, 114, 97, 116, 105, 111, 110, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 103, 109, 101, 110, 116, 68, 117, 114, 97, 116, 105, 111, 110, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 82, 101, 97, 100, 121, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 105, 115, 82, 101, 97, 100, 121, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 97, 110, 105, 102, 101, 115, 116, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 109, 97, 110, 105, 102, 101, 115, 116, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 116, 97, 116, 101, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 76, 97, 121, 111, 117, 116, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 97, 121, 111, 117, 116, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 108, 97, 121, 111, 117, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 76, 97, 121, 111, 117, 116, 40, 108, 97, 121, 111, 117, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 117, 99, 99, 101, 115, 115, 58, 32, 116, 114, 117, 101, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 103, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 103, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 69, 118, 101, 110, 116, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 120, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 120, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 121, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 121, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 69, 118, 101, 110, 116, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 120, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 120, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 121, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 121, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 69, 118, 101, 110, 116, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 120, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 120, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 121, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 121, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 69, 118, 101, 110, 116, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 120, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 120, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 121, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 121, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 85, 112, 69, 118, 101, 110, 116, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 120, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 120, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 121, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 121, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 85, 112, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 116, 97, 114, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 116, 97, 114, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 116, 111, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 116, 111, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 97, 100, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 108, 111, 97, 100, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 97, 100, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 108, 111, 97, 100, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 40, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 99, 114, 101, 97, 116, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 99, 111, 110, 102, 105, 103, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 99, 111, 110, 102, 105, 103, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 119, 105, 100, 116, 104, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 119, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 104, 101, 105, 103, 104, 116, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 104, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 104, 97, 115, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 97, 108, 114, 101, 97, 100, 121, 32, 101, 120, 105, 115, 116, 115, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 110, 101, 119, 32, 68, 111, 116, 76, 111, 116, 116, 105, 101, 40, 99, 111, 110, 102, 105, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 32, 61, 32, 104, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 32, 61, 32, 119, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 115, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 32, 105, 110, 115, 116, 97, 110, 99, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 101, 118, 101, 110, 116, 115, 32, 61, 32, 91, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 99, 111, 109, 112, 108, 101, 116, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 102, 114, 97, 109, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 108, 111, 97, 100, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 108, 111, 97, 100, 69, 114, 114, 111, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 114, 101, 110, 100, 101, 114, 69, 114, 114, 111, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 108, 111, 111, 112, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 112, 97, 117, 115, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 112, 108, 97, 121, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 115, 116, 111, 112, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 100, 101, 115, 116, 114, 111, 121, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 102, 114, 101, 101, 122, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 117, 110, 102, 114, 101, 101, 122, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 114, 101, 110, 100, 101, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 114, 101, 97, 100, 121, 34, 10, 32, 32, 32, 32, 32, 32, 93, 59, 10, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 115, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 101, 118, 101, 110, 116, 44, 32, 101, 118, 101, 110, 116, 72, 97, 110, 100, 108, 101, 114, 77, 97, 112, 91, 101, 118, 101, 110, 116, 93, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 100, 101, 115, 116, 114, 111, 121, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 100, 101, 115, 116, 114, 111, 121, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 100, 101, 108, 101, 116, 101, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 102, 114, 101, 101, 122, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 102, 114, 101, 101, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 97, 100, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 99, 111, 110, 102, 105, 103, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 99, 111, 110, 102, 105, 103, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 108, 111, 97, 100, 40, 99, 111, 110, 102, 105, 103, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 97, 100, 65, 110, 105, 109, 97, 116, 105, 111, 110, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 108, 111, 97, 100, 65, 110, 105, 109, 97, 116, 105, 111, 110, 40, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 84, 104, 101, 109, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 116, 104, 101, 109, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 116, 104, 101, 109, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 84, 104, 101, 109, 101, 40, 116, 104, 101, 109, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 84, 104, 101, 109, 101, 68, 97, 116, 97, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 116, 104, 101, 109, 101, 68, 97, 116, 97, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 116, 104, 101, 109, 101, 68, 97, 116, 97, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 84, 104, 101, 109, 101, 68, 97, 116, 97, 40, 116, 104, 101, 109, 101, 68, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 97, 117, 115, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 112, 97, 117, 115, 101, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 108, 97, 121, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 112, 108, 97, 121, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 114, 101, 115, 105, 122, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 119, 105, 100, 116, 104, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 119, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 104, 101, 105, 103, 104, 116, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 104, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 32, 61, 32, 104, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 32, 61, 32, 119, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 114, 101, 115, 105, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 117, 99, 99, 101, 115, 115, 58, 32, 116, 114, 117, 101, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 66, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 66, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 40, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 70, 114, 97, 109, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 102, 114, 97, 109, 101, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 102, 114, 97, 109, 101, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 70, 114, 97, 109, 101, 40, 102, 114, 97, 109, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 77, 111, 100, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 111, 100, 101, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 109, 111, 100, 101, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 77, 111, 100, 101, 40, 109, 111, 100, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 82, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 82, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 40, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 83, 101, 103, 109, 101, 110, 116, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 101, 103, 109, 101, 110, 116, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 115, 101, 103, 109, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 83, 101, 103, 109, 101, 110, 116, 40, 115, 101, 103, 109, 101, 110, 116, 91, 48, 93, 44, 32, 115, 101, 103, 109, 101, 110, 116, 91, 49, 93, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 83, 112, 101, 101, 100, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 112, 101, 101, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 115, 112, 101, 101, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 83, 112, 101, 101, 100, 40, 115, 112, 101, 101, 100, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 85, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 85, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 40, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 87, 97, 115, 109, 85, 114, 108, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 115, 101, 116, 87, 97, 115, 109, 85, 114, 108, 40, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 117, 114, 108, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 116, 111, 112, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 116, 111, 112, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 117, 110, 102, 114, 101, 101, 122, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 117, 110, 102, 114, 101, 101, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 86, 105, 101, 119, 112, 111, 114, 116, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 120, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 120, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 121, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 121, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 119, 105, 100, 116, 104, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 119, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 104, 101, 105, 103, 104, 116, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 104, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 86, 105, 101, 119, 112, 111, 114, 116, 40, 120, 44, 32, 121, 44, 32, 119, 105, 100, 116, 104, 44, 32, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 83, 105, 122, 101, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 123, 32, 104, 101, 105, 103, 104, 116, 44, 32, 119, 105, 100, 116, 104, 32, 125, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 97, 110, 105, 109, 97, 116, 105, 111, 110, 83, 105, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 104, 101, 105, 103, 104, 116, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 119, 105, 100, 116, 104, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 77, 97, 114, 107, 101, 114, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 97, 114, 107, 101, 114, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 109, 97, 114, 107, 101, 114, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 77, 97, 114, 107, 101, 114, 40, 109, 97, 114, 107, 101, 114, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 117, 99, 99, 101, 115, 115, 58, 32, 116, 114, 117, 101, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 76, 111, 111, 112, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 111, 111, 112, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 108, 111, 111, 112, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 76, 111, 111, 112, 40, 108, 111, 111, 112, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 117, 99, 99, 101, 115, 115, 58, 32, 116, 114, 117, 101, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 101, 120, 101, 99, 117, 116, 101, 67, 111, 109, 109, 97, 110, 100, 40, 114, 112, 99, 82, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 101, 116, 104, 111, 100, 32, 61, 32, 114, 112, 99, 82, 101, 113, 117, 101, 115, 116, 46, 109, 101, 116, 104, 111, 100, 59, 10, 32, 32, 32, 32, 105, 102, 32, 40, 116, 121, 112, 101, 111, 102, 32, 99, 111, 109, 109, 97, 110, 100, 115, 91, 109, 101, 116, 104, 111, 100, 93, 32, 61, 61, 61, 32, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 111, 109, 109, 97, 110, 100, 115, 91, 109, 101, 116, 104, 111, 100, 93, 40, 114, 112, 99, 82, 101, 113, 117, 101, 115, 116, 41, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 77, 101, 116, 104, 111, 100, 32, 36, 123, 109, 101, 116, 104, 111, 100, 125, 32, 105, 115, 32, 110, 111, 116, 32, 105, 109, 112, 108, 101, 109, 101, 110, 116, 101, 100, 32, 105, 110, 32, 99, 111, 109, 109, 97, 110, 100, 115, 46, 96, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 10, 32, 32, 115, 101, 108, 102, 46, 111, 110, 109, 101, 115, 115, 97, 103, 101, 32, 61, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 117, 108, 116, 32, 61, 32, 101, 120, 101, 99, 117, 116, 101, 67, 111, 109, 109, 97, 110, 100, 40, 101, 118, 101, 110, 116, 46, 100, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 101, 118, 101, 110, 116, 46, 100, 97, 116, 97, 46, 105, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 101, 118, 101, 110, 116, 46, 100, 97, 116, 97, 46, 109, 101, 116, 104, 111, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 101, 114, 114, 111, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 101, 114, 114, 111, 114, 82, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 101, 118, 101, 110, 116, 46, 100, 97, 116, 97, 46, 105, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 101, 118, 101, 110, 116, 46, 100, 97, 116, 97, 46, 109, 101, 116, 104, 111, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 101, 114, 114, 111, 114, 58, 32, 101, 114, 114, 111, 114, 46, 109, 101, 115, 115, 97, 103, 101, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 101, 114, 114, 111, 114, 82, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 100, 117, 109, 109, 121, 32, 61, 32, 34, 34, 59, 10, 32, 32, 118, 97, 114, 32, 100, 111, 116, 108, 111, 116, 116, 105, 101, 95, 119, 111, 114, 107, 101, 114, 95, 100, 101, 102, 97, 117, 108, 116, 32, 61, 32, 100, 117, 109, 109, 121, 59, 10, 125, 41, 40, 41, 59, 10])], { type: "application/javascript" }), t = URL.createObjectURL(e), n = new Worker(t);
    return URL.revokeObjectURL(t), n;
  }
}, SJ = xJ, MJ = class {
  constructor() {
    Z1(this, "_workers", /* @__PURE__ */ new Map()), Z1(this, "_animationWorkerMap", /* @__PURE__ */ new Map());
  }
  getWorker(e) {
    return this._workers.has(e) || this._workers.set(e, new SJ()), this._workers.get(e);
  }
  assignAnimationToWorker(e, t) {
    this._animationWorkerMap.set(e, t);
  }
  unassignAnimationFromWorker(e) {
    this._animationWorkerMap.delete(e);
  }
  sendMessage(e, t, n) {
    this.getWorker(e).postMessage(t, n || []);
  }
  terminateWorker(e) {
    let t = this._workers.get(e);
    t && (t.terminate(), this._workers.delete(e));
  }
};
function Pv(e, t) {
  if (e instanceof HTMLCanvasElement) {
    let { height: n, width: r } = e.getBoundingClientRect();
    if (n !== 0 && r !== 0) return { width: r * t, height: n * t };
  }
  return { width: e.width, height: e.height };
}
function Av() {
  return Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
}
var Iv = class F0 {
  constructor(t) {
    Z1(this, "_eventManager", new yL()), Z1(this, "_id"), Z1(this, "_worker"), Z1(this, "_canvas"), Z1(this, "_dotLottieInstanceState", { loopCount: 0, markers: [], autoplay: !1, backgroundColor: "", currentFrame: 0, duration: 0, loop: !1, mode: "forward", segment: [0, 0], segmentDuration: 0, speed: 1, totalFrames: 0, isLoaded: !1, isPlaying: !1, isPaused: !1, isStopped: !0, isFrozen: !1, useFrameInterpolation: !1, renderConfig: { devicePixelRatio: V0() }, activeAnimationId: "", activeThemeId: "", layout: void 0, marker: void 0, isReady: !1, manifest: null }), Z1(this, "_created", !1), Z1(this, "_pointerUpMethod"), Z1(this, "_pointerDownMethod"), Z1(this, "_pointerMoveMethod"), Z1(this, "_pointerEnterMethod"), Z1(this, "_pointerExitMethod"), this._canvas = t.canvas, this._id = `dotlottie-${Av()}`;
    let n = t.workerId || "defaultWorker";
    this._worker = F0._workerManager.getWorker(n), F0._workerManager.assignAnimationToWorker(this._id, n), F0._wasmUrl && this._sendMessage("setWasmUrl", { url: F0._wasmUrl }), this._create({ ...t, renderConfig: { ...t.renderConfig, devicePixelRatio: t.renderConfig?.devicePixelRatio || V0(), freezeOnOffscreen: t.renderConfig?.freezeOnOffscreen ?? !0 } }), this._worker.addEventListener("message", this._handleWorkerEvent.bind(this)), this._pointerUpMethod = this._onPointerUp.bind(this), this._pointerDownMethod = this._onPointerDown.bind(this), this._pointerMoveMethod = this._onPointerMove.bind(this), this._pointerEnterMethod = this._onPointerEnter.bind(this), this._pointerExitMethod = this._onPointerLeave.bind(this);
  }
  async _handleWorkerEvent(t) {
    let n = t.data;
    n.id || (n.method === "onLoad" && n.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(n.result.event), M2 && this._canvas instanceof HTMLCanvasElement && (this._dotLottieInstanceState.renderConfig.freezeOnOffscreen && Mt.observe(this._canvas, this), this._dotLottieInstanceState.renderConfig.autoResize && kt.observe(this._canvas, this))), n.method === "onComplete" && n.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(n.result.event)), n.method === "onDestroy" && n.result.instanceId === this._id && this._eventManager.dispatch(n.result.event), n.method === "onUnfreeze" && n.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._dotLottieInstanceState.isFrozen = !1, this._eventManager.dispatch(n.result.event)), n.method === "onFrame" && n.result.instanceId === this._id && (this._dotLottieInstanceState.currentFrame = n.result.event.currentFrame, this._eventManager.dispatch(n.result.event)), n.method === "onRender" && n.result.instanceId === this._id && this._eventManager.dispatch(n.result.event), n.method === "onFreeze" && n.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(n.result.event)), n.method === "onPause" && n.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(n.result.event)), n.method === "onPlay" && n.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(n.result.event)), n.method === "onStop" && n.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(n.result.event)), n.method === "onLoadError" && n.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(n.result.event)), n.method === "onRenderError" && n.result.instanceId === this._id && this._eventManager.dispatch(n.result.event), n.method === "onReady" && n.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(n.result.event)), n.method === "onLoop" && n.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(n.result.event)));
  }
  async _create(t) {
    let n;
    this._canvas instanceof HTMLCanvasElement ? n = this._canvas.transferControlToOffscreen() : n = this._canvas;
    let { instanceId: r } = await this._sendMessage("create", { instanceId: this._id, config: { ...t, canvas: n }, ...Pv(this._canvas, t.renderConfig?.devicePixelRatio || V0()) }, [n]);
    if (r !== this._id) throw new Error("Instance ID mismatch");
    this._created = !0, await this._updateDotLottieInstanceState();
  }
  get loopCount() {
    return this._dotLottieInstanceState.loopCount;
  }
  get isLoaded() {
    return this._dotLottieInstanceState.isLoaded;
  }
  get isPlaying() {
    return this._dotLottieInstanceState.isPlaying;
  }
  get isPaused() {
    return this._dotLottieInstanceState.isPaused;
  }
  get isStopped() {
    return this._dotLottieInstanceState.isStopped;
  }
  get currentFrame() {
    return this._dotLottieInstanceState.currentFrame;
  }
  get isFrozen() {
    return this._dotLottieInstanceState.isFrozen;
  }
  get segmentDuration() {
    return this._dotLottieInstanceState.segmentDuration;
  }
  get totalFrames() {
    return this._dotLottieInstanceState.totalFrames;
  }
  get segment() {
    return this._dotLottieInstanceState.segment;
  }
  get speed() {
    return this._dotLottieInstanceState.speed;
  }
  get duration() {
    return this._dotLottieInstanceState.duration;
  }
  get isReady() {
    return this._dotLottieInstanceState.isReady;
  }
  get mode() {
    return this._dotLottieInstanceState.mode;
  }
  get canvas() {
    return this._canvas;
  }
  get autoplay() {
    return this._dotLottieInstanceState.autoplay;
  }
  get backgroundColor() {
    return this._dotLottieInstanceState.backgroundColor;
  }
  get loop() {
    return this._dotLottieInstanceState.loop;
  }
  get useFrameInterpolation() {
    return this._dotLottieInstanceState.useFrameInterpolation;
  }
  get renderConfig() {
    return this._dotLottieInstanceState.renderConfig;
  }
  get manifest() {
    return this._dotLottieInstanceState.manifest;
  }
  get activeAnimationId() {
    return this._dotLottieInstanceState.activeAnimationId;
  }
  get marker() {
    return this._dotLottieInstanceState.marker;
  }
  get activeThemeId() {
    return this._dotLottieInstanceState.activeThemeId;
  }
  get layout() {
    return this._dotLottieInstanceState.layout;
  }
  async play() {
    this._created && (await this._sendMessage("play", { instanceId: this._id }), await this._updateDotLottieInstanceState(), M2 && this._canvas instanceof HTMLCanvasElement && this._dotLottieInstanceState.renderConfig.freezeOnOffscreen && !CL(this._canvas) && await this.freeze());
  }
  async pause() {
    this._created && (await this._sendMessage("pause", { instanceId: this._id }), await this._updateDotLottieInstanceState());
  }
  async stop() {
    this._created && (await this._sendMessage("stop", { instanceId: this._id }), await this._updateDotLottieInstanceState());
  }
  async setSpeed(t) {
    this._created && (await this._sendMessage("setSpeed", { instanceId: this._id, speed: t }), await this._updateDotLottieInstanceState());
  }
  async setMode(t) {
    this._created && (await this._sendMessage("setMode", { instanceId: this._id, mode: t }), await this._updateDotLottieInstanceState());
  }
  async setFrame(t) {
    this._created && (await this._sendMessage("setFrame", { frame: t, instanceId: this._id }), await this._updateDotLottieInstanceState());
  }
  async setSegment(t, n) {
    this._created && (await this._sendMessage("setSegment", { instanceId: this._id, segment: [t, n] }), await this._updateDotLottieInstanceState());
  }
  async setRenderConfig(t) {
    if (!this._created) return;
    let { devicePixelRatio: n, freezeOnOffscreen: r, ...o } = t;
    await this._sendMessage("setRenderConfig", { instanceId: this._id, renderConfig: { ...this._dotLottieInstanceState.renderConfig, ...o, devicePixelRatio: n || V0(), freezeOnOffscreen: r ?? !0 } }), await this._updateDotLottieInstanceState(), M2 && this._canvas instanceof HTMLCanvasElement && (this._dotLottieInstanceState.renderConfig.autoResize ? kt.observe(this._canvas, this) : kt.unobserve(this._canvas), this._dotLottieInstanceState.renderConfig.freezeOnOffscreen ? Mt.observe(this._canvas, this) : (Mt.unobserve(this._canvas), this._dotLottieInstanceState.isFrozen && await this.unfreeze()));
  }
  async setUseFrameInterpolation(t) {
    this._created && (await this._sendMessage("setUseFrameInterpolation", { instanceId: this._id, useFrameInterpolation: t }), await this._updateDotLottieInstanceState());
  }
  async setTheme(t) {
    if (!this._created) return !1;
    let n = this._sendMessage("setTheme", { instanceId: this._id, themeId: t });
    return await this._updateDotLottieInstanceState(), n;
  }
  async load(t) {
    this._created && (await this._sendMessage("load", { config: t, instanceId: this._id }), await this._updateDotLottieInstanceState());
  }
  async setLoop(t) {
    this._created && (await this._sendMessage("setLoop", { instanceId: this._id, loop: t }), await this._updateDotLottieInstanceState());
  }
  async resize() {
    if (!this._created) return;
    let { height: t, width: n } = Pv(this._canvas, this._dotLottieInstanceState.renderConfig.devicePixelRatio || V0());
    await this._sendMessage("resize", { height: t, instanceId: this._id, width: n }), await this._updateDotLottieInstanceState();
  }
  async destroy() {
    this._created && (this._created = !1, await this._sendMessage("destroy", { instanceId: this._id }), this._cleanupStateMachineListeners(), F0._workerManager.unassignAnimationFromWorker(this._id), this._eventManager.removeAllEventListeners(), M2 && this._canvas instanceof HTMLCanvasElement && (Mt.unobserve(this._canvas), kt.unobserve(this._canvas)));
  }
  async freeze() {
    this._created && (await this._sendMessage("freeze", { instanceId: this._id }), await this._updateDotLottieInstanceState());
  }
  async unfreeze() {
    this._created && (await this._sendMessage("unfreeze", { instanceId: this._id }), await this._updateDotLottieInstanceState());
  }
  async setBackgroundColor(t) {
    this._created && (await this._sendMessage("setBackgroundColor", { instanceId: this._id, backgroundColor: t }), await this._updateDotLottieInstanceState());
  }
  async loadAnimation(t) {
    this._created && (await this._sendMessage("loadAnimation", { animationId: t, instanceId: this._id }), await this._updateDotLottieInstanceState());
  }
  async setLayout(t) {
    this._created && (await this._sendMessage("setLayout", { instanceId: this._id, layout: t }), await this._updateDotLottieInstanceState());
  }
  async _updateDotLottieInstanceState() {
    if (!this._created) return;
    let t = await this._sendMessage("getDotLottieInstanceState", { instanceId: this._id });
    this._dotLottieInstanceState = t.state;
  }
  markers() {
    return this._dotLottieInstanceState.markers;
  }
  async setMarker(t) {
    this._created && (await this._sendMessage("setMarker", { instanceId: this._id, marker: t }), await this._updateDotLottieInstanceState());
  }
  async setThemeData(t) {
    if (!this._created) return !1;
    let n = await this._sendMessage("setThemeData", { instanceId: this._id, themeData: t });
    return await this._updateDotLottieInstanceState(), n;
  }
  async setViewport(t, n, r, o) {
    return this._created ? this._sendMessage("setViewport", { x: t, y: n, width: r, height: o, instanceId: this._id }) : !1;
  }
  async animationSize() {
    return this._created ? this._sendMessage("animationSize", { instanceId: this._id }) : { height: 0, width: 0 };
  }
  async _sendMessage(t, n, r) {
    let o = { id: `dotlottie-request-${Av()}`, method: t, params: n };
    return this._worker.postMessage(o, r || []), new Promise((i, a) => {
      let s = (l) => {
        let c = l.data;
        c.id === o.id && (this._worker.removeEventListener("message", s), c.error ? a(new Error(`Failed to execute method ${t}: ${c.error}`)) : i(c.result));
      };
      this._worker.addEventListener("message", s);
    });
  }
  addEventListener(t, n) {
    this._eventManager.addEventListener(t, n);
  }
  removeEventListener(t, n) {
    this._eventManager.removeEventListener(t, n);
  }
  static setWasmUrl(t) {
    F0._wasmUrl = t;
  }
  async loadStateMachine(t) {
    if (!this._created) return !1;
    let n = await this._sendMessage("loadStateMachine", { instanceId: this._id, stateMachineId: t });
    return await this._updateDotLottieInstanceState(), n;
  }
  async loadStateMachineData(t) {
    if (!this._created) return !1;
    let n = await this._sendMessage("loadStateMachineData", { instanceId: this._id, stateMachineData: t });
    return await this._updateDotLottieInstanceState(), n;
  }
  async startStateMachine() {
    if (!this._created) return !1;
    this._setupStateMachineListeners();
    let t = await this._sendMessage("startStateMachine", { instanceId: this._id });
    return await this._updateDotLottieInstanceState(), t;
  }
  async stopStateMachine() {
    return this._created ? (this._cleanupStateMachineListeners(), this._sendMessage("stopStateMachine", { instanceId: this._id })) : !1;
  }
  async getStateMachineListeners() {
    return this._created ? this._sendMessage("getStateMachineListeners", { instanceId: this._id }) : [];
  }
  _getPointerPosition(t) {
    let n = this._canvas.getBoundingClientRect(), r = this._canvas.width / n.width, o = this._canvas.height / n.height, i = this._dotLottieInstanceState.renderConfig.devicePixelRatio || window.devicePixelRatio || 1, a = (t.clientX - n.left) * r / i, s = (t.clientY - n.top) * o / i;
    return { x: a, y: s };
  }
  _onPointerUp(t) {
    let { x: n, y: r } = this._getPointerPosition(t);
    this._sendMessage("postPointerUpEvent", { instanceId: this._id, x: n, y: r });
  }
  _onPointerDown(t) {
    let { x: n, y: r } = this._getPointerPosition(t);
    this._sendMessage("postPointerDownEvent", { instanceId: this._id, x: n, y: r });
  }
  _onPointerMove(t) {
    let { x: n, y: r } = this._getPointerPosition(t);
    this._sendMessage("postPointerMoveEvent", { instanceId: this._id, x: n, y: r });
  }
  _onPointerEnter(t) {
    let { x: n, y: r } = this._getPointerPosition(t);
    this._sendMessage("postPointerEnterEvent", { instanceId: this._id, x: n, y: r });
  }
  _onPointerLeave(t) {
    let { x: n, y: r } = this._getPointerPosition(t);
    this._sendMessage("postPointerExitEvent", { instanceId: this._id, x: n, y: r });
  }
  async _setupStateMachineListeners() {
    if (M2 && this._canvas instanceof HTMLCanvasElement && this.isLoaded) {
      let t = await this._sendMessage("getStateMachineListeners", { instanceId: this._id });
      t.includes("PointerUp") && this._canvas.addEventListener("pointerup", this._pointerUpMethod), t.includes("PointerDown") && this._canvas.addEventListener("pointerdown", this._pointerDownMethod), t.includes("PointerMove") && this._canvas.addEventListener("pointermove", this._pointerMoveMethod), t.includes("PointerEnter") && this._canvas.addEventListener("pointerenter", this._pointerEnterMethod), t.includes("PointerExit") && this._canvas.addEventListener("pointerleave", this._pointerExitMethod);
    }
  }
  _cleanupStateMachineListeners() {
    M2 && this._canvas instanceof HTMLCanvasElement && (this._canvas.removeEventListener("pointerup", this._pointerUpMethod), this._canvas.removeEventListener("pointerdown", this._pointerDownMethod), this._canvas.removeEventListener("pointermove", this._pointerMoveMethod), this._canvas.removeEventListener("pointerenter", this._pointerEnterMethod), this._canvas.removeEventListener("pointerleave", this._pointerExitMethod));
  }
};
Z1(Iv, "_workerManager", new MJ()), Z1(Iv, "_wasmUrl", "");
var kJ = ({ animationId: e, autoplay: t, backgroundColor: n, className: r, createDotLottie: o, data: i, dotLottieRefCallback: a, layout: s, loop: l, mode: c, playOnHover: f, renderConfig: u, segment: h, speed: p, src: g, style: m, themeData: b, themeId: y, useFrameInterpolation: C, workerId: _, ...M }) => {
  let S = Be(null), k = Be(null), L = Be(a), P = { speed: p, mode: c, loop: l, useFrameInterpolation: C, segment: h, backgroundColor: n, autoplay: t, themeId: y, workerId: _, src: g, data: i, layout: s, renderConfig: u, animationId: e }, I = Be(P);
  L.current = a, I.current = P;
  let O = R1((E) => {
    k.current = E, E ? S.current = o({ ...I.current, canvas: E }) : (S.current?.destroy(), S.current = null), L.current?.(S.current);
  }, []);
  return Te(() => {
    let E = (B) => {
      f && (B.type === "mouseenter" && S.current?.play(), B.type === "mouseleave" && S.current?.pause());
    };
    return k.current?.addEventListener("mouseenter", E), k.current?.addEventListener("mouseleave", E), () => {
      k.current?.removeEventListener("mouseenter", E), k.current?.removeEventListener("mouseleave", E);
    };
  }, [f]), Te(() => {
    S.current?.setSpeed(p ?? 1);
  }, [p]), Te(() => {
    S.current?.setMode(c ?? "forward");
  }, [c]), Te(() => {
    S.current?.setLoop(l ?? !1);
  }, [l]), Te(() => {
    S.current?.setUseFrameInterpolation(C ?? !0);
  }, [C]), Te(() => {
    typeof h?.[0] == "number" && typeof h[1] == "number" && S.current?.setSegment(h[0], h[1]);
  }, [h]), Te(() => {
    S.current?.setBackgroundColor(n ?? "");
  }, [n]), Te(() => {
    S.current?.setRenderConfig(u ?? {});
  }, [JSON.stringify(u)]), Te(() => {
    typeof i != "string" && typeof i != "object" || S.current?.load({ data: i, ...I.current });
  }, [i]), Te(() => {
    typeof g == "string" && S.current?.load({ src: g, ...I.current });
  }, [g]), Te(() => {
    S.current?.setMarker(M.marker ?? "");
  }, [M.marker]), Te(() => {
    S.current?.loadAnimation(e ?? "");
  }, [e]), Te(() => {
    typeof y == "string" && S.current?.setTheme(y);
  }, [y]), Te(() => {
    S.current?.setThemeData(b ?? "");
  }, [b]), Te(() => {
    S.current?.setLayout(s ?? {});
  }, [s?.fit, s?.align && s.align[0], s?.align && s.align[1]]), v("div", { className: r, ...!r && { style: { width: "100%", height: "100%", lineHeight: 0, ...m } }, children: v("canvas", { ref: O, style: { width: "100%", height: "100%" }, ...M }) });
}, LJ = (e) => new _J(e), EJ = (e) => v(kJ, { ...e, createDotLottie: LJ });
const TJ = "data:application/octet-stream;base64,UEsDBBQAAAAIABF101r1hhQegQAAALUAAAANAAAAbWFuaWZlc3QuanNvbo2NQQ7CIBBF7zJrqW1BrF31Ap7AuAAZFEPBwGhimt7dWbnu7v/kvbwFPlhqyAlG6GAHd0xYDOXCf3KZYiYKuP8v8axT1/RNy6x502MbmMJsiCMVxssCwbGjhoO3UktxG2wrlOuVODmphZIWfeettkdk9RXN95wdspFymU2E9br+AFBLAwQUAAAACAARddNadTSuHQMEAAA2FwAANAAAAGFuaW1hdGlvbnMvNDg1ZmIzNjMtYzhiMC00ZDI0LTlkMzYtNDNiZWYxZmI2YjdlLmpzb27tWNuOo0YQ/RXUzxj1vcFvm+wkUrRKomyUF2seWJsZk8HYAibJyJp/z6kGxsbg1W7kibQjay401UVdTlUdN96zv9ic6SiOOAvZJmtSNt+ze8g+bJsmz37Ii6wO3t0EIuJeBfvsp22ZNuu0DN4/lrv1E6QPkBbbdJVVYUDXvLxvF2FQ7/KyJLlfYAPqK6h/7G6D7/NqSU7yMtgVj3VQ5/dlUK/TXRakZb5Jm2zlTWUVnmyWeJQ9h+yuYnPFQ5bv2ByXLS7OhOxvNhecQ7DuF+VmytmH3uBqhWCgltZ11tRsvrgNWZE+ZRWt9y/beYmrgP8nuO2M/vxYFMEvn/7Mlk1wt62C37ZN2uTbElZrRAftBxjZsy39A24wA5zI2D/YFUgCWn6HVL27nATYXfDIWodQ4G4hbqHqjbQ7Sqluh9NOw+YSRileut+TwMStQFmIoOw9cigDpqNYFoaLKDEy1ImLlHEh73QlVH0nHKuG+O0VKHqf3EEBcIfdX6dkn8kMIh/XqUaQuP0EHBHWCc6yxVl3OLc1CzRw3aVVVuJRAPYZiCmKMcj9XjIBx6gAHn8PMpnoweeR09ZL6eE2BYL5gE0D1cVMqcipcMYjI3Urht1FK+2FlPXYm18NPKLa3Q5Ww3LPhJGRikWobRR31fMBIJaD2/Zm6E7Z1uhnk+ub6KybYUKdu9Pku450qOYxVH1XTnTaTCQicujKmXCJX/znrvM00k4ydRS7p5HPEQ6N9stAs6ygmT0xbHmEsQi761G4JzN0GAoqj+/Ym6LId3UW/AqaDAQRawnpu/ff3QR/gC3AFR89v82CThMqa8RzlxZ15gGjqO4oKvDdwFmkpTVCSkyrAbyR5dbFwmitucFtoqXAHX7iUHRh6b7I4wEx7XwABz+JXfgg/WI67B+rdLfOlwicdCajbgjiE4hGFT1f/C+hmCO4h8PdZWXPJ0yzVUMwfohQqofBHIHkcfm9SssaTL9h1L2DShNaJbLGWC19Zi+I+lQmodw+7gYIUlpfwZJwNcGS6n9mSdDCBJGYL2BJ8EQcJyOWJP4g+dfzJELueDIZ8qQ0CkJ8yr0qTZ7zcprQ4dNgkP6VJy/Lk04rK6xTSYJeJtrEMo6VkAq1QYVkrJRA+7rkSpRvmygxURNEKb+Z4yR4SJpwpnRk7DFRtvIX8QUOlKZ9G8CBD68DsX0tpjzr5jSl3uEJAFeqvPCR0iVCOqMkGBPc6KxOTMINPsX8kVJwcKZNONcI/UqVb5kqsT9BlRTIt0SVOFoJhdY9YUo6iLXyy1Gl1HEU8/iVmXLkZZTRgCkHeV6J8nJESRSpjbOczveR1s7G2hhlUC7iSemkFJLz5Pru/cZ4EtubtHpovxW+ff4XUEsBAhQAFAAAAAgAEXXTWvWGFB6BAAAAtQAAAA0AAAAAAAAAAAAAAAAAAAAAAG1hbmlmZXN0Lmpzb25QSwECFAAUAAAACAARddNadTSuHQMEAAA2FwAANAAAAAAAAAAAAAAAAACsAAAAYW5pbWF0aW9ucy80ODVmYjM2My1jOGIwLTRkMjQtOWQzNi00M2JlZjFmYjZiN2UuanNvblBLBQYAAAAAAgACAJ0AAAABBQAAAAA=";
function J01(e) {
  return /* @__PURE__ */ v("div", { ...e, children: /* @__PURE__ */ v(EJ, { loop: !0, autoplay: !0, src: TJ }) });
}
function e31({ className: e, ...t }) {
  return /* @__PURE__ */ v(
    "footer",
    {
      className: e1(
        "flex flex-row gap-3 items-center content-start",
        e
      ),
      ...t,
      role: "contentinfo"
    }
  );
}
function t31(e) {
  const { hoveredLegendKey: t, onClick: n, TooltipComponent: r, ...o } = e, { data: i, x: a, y: s, width: l, height: c, color: f } = o.bar, { id: u, indexValue: h, value: p } = i, g = !t || u === t, { showTooltipFromEvent: m, hideTooltip: b } = d3();
  function y(C) {
    m(
      r ? /* @__PURE__ */ v(r, { data: i, color: f }) : /* @__PURE__ */ v(
        yd,
        {
          id: `${u} - ${h}`,
          value: p ?? void 0,
          color: f,
          enableChip: !0
        }
      ),
      C
    );
  }
  return /* @__PURE__ */ v(
    "rect",
    {
      x: a,
      y: s,
      width: l,
      height: c,
      fill: f,
      className: e1(
        "cursor-pointer transition-opacity duration-200",
        g ? "opacity-100" : "opacity-30"
      ),
      onClick: (C) => n?.({ ...o.bar.data, color: f }, C),
      onMouseEnter: y,
      onMouseMove: y,
      onMouseLeave: b,
      "data-testid": "chart-custom-bar"
    }
  );
}
function RJ({
  className: e,
  direction: t,
  data: n,
  onClick: r,
  activeKeys: o = [],
  setHoveredLegendKey: i = () => {
  }
}) {
  const a = Be(null), s = Be(null);
  Te(() => () => {
    clearTimeout(a.current ?? void 0), clearTimeout(s.current ?? void 0);
  }, []);
  function l(h) {
    (o.length === 0 || o.includes(h)) && (clearTimeout(s.current ?? void 0), a.current = setTimeout(() => {
      i(h);
    }, 50));
  }
  function c() {
    clearTimeout(a.current ?? void 0), s.current = setTimeout(() => {
      i(null);
    }, 50);
  }
  function f(h) {
    return o.length === 0 || o.includes(h);
  }
  const u = t === "vertical";
  return /* @__PURE__ */ v(
    "div",
    {
      className: e1(
        "flex",
        t === "vertical" ? "flex-col gap-2" : " gap-3",
        e
      ),
      children: n.reverse().map((h) => {
        const p = h.color, g = `${parseInt((100 / n.length).toString())}%`, m = /* @__PURE__ */ v(
          "div",
          {
            className: e1(
              "mr-[6px] size-[9px]",
              h.borderColor ? "border" : "border-none",
              "bg-[var(--lb-portrait-color)]",
              h.borderColor && "border-[var(--lb-portrait-border)]"
            ),
            style: {
              "--lb-portrait-color": p,
              ...h.borderColor && {
                "--lb-portrait-border": h.borderColor
              }
            }
          }
        );
        return /* @__PURE__ */ s1(
          "div",
          {
            "data-testid": `chart-legend-item-${h.id}`,
            className: e1(
              "flex items-center transition-opacity duration-300",
              r && "cursor-pointer",
              f(h.id) ? "opacity-100" : "opacity-20",
              u ? "" : `max-w-[${g}]`
            ),
            onClick: () => r?.(h.id),
            onMouseEnter: () => l?.(h.id),
            onMouseLeave: () => c?.(),
            children: [
              m,
              /* @__PURE__ */ v("div", { className: "truncate text-sm text-foreground", children: h.label })
            ]
          },
          h.id
        );
      })
    }
  );
}
const PJ = Z2(
  "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive py-0.5 inline-flex w-fit shrink-0 items-center justify-center gap-1 overflow-hidden whitespace-nowrap rounded-md border px-2 text-xs font-medium transition-[color,box-shadow] focus-within:ring-2 focus-within:ring-primary focus-within:ring-offset-1 [&>a]:no-underline [&>a]:outline-none [&>button]:outline-none [&>svg]:pointer-events-none [&>svg]:size-3",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground [&:has(a)]:hover:bg-primary/90 [&:has(button)]:hover:bg-primary/90 [&>a]:text-white",
        secondary: "border-transparent bg-secondary text-secondary-foreground [&>a]:text-secondary-foreground [a&]:hover:bg-secondary/90",
        destructive: "border-transparent bg-destructive text-white focus-visible:ring-destructive/20 dark:bg-destructive/60 dark:focus-visible:ring-destructive/40 [&:has(a)]:hover:brightness-90 [&:has(button)]:hover:brightness-90 [&>a]:text-white",
        outline: "text-foreground [&>a]:text-foreground [a&]:hover:bg-accent [a&]:hover:text-accent-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function n31({
  className: e,
  variant: t,
  asChild: n = !1,
  ...r
}) {
  return /* @__PURE__ */ v(
    n ? Ai : "span",
    {
      "data-slot": "badge",
      className: e1(PJ({ variant: t }), e),
      ...r
    }
  );
}
const _L = 6048e5, AJ = 864e5, Ov = Symbol.for("constructDateFrom");
function f2(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && Ov in e ? e[Ov](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function Fe(e, t) {
  return f2(t || e, e);
}
function xL(e, t, n) {
  const r = Fe(e, n?.in);
  return isNaN(t) ? f2(e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
function SL(e, t, n) {
  const r = Fe(e, n?.in);
  if (isNaN(t)) return f2(e, NaN);
  if (!t)
    return r;
  const o = r.getDate(), i = f2(e, r.getTime());
  i.setMonth(r.getMonth() + t + 1, 0);
  const a = i.getDate();
  return o >= a ? i : (r.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    o
  ), r);
}
let IJ = {};
function uo() {
  return IJ;
}
function Q3(e, t) {
  const n = uo(), r = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, o = Fe(e, t?.in), i = o.getDay(), a = (i < r ? 7 : 0) + i - r;
  return o.setDate(o.getDate() - a), o.setHours(0, 0, 0, 0), o;
}
function Ar(e, t) {
  return Q3(e, { ...t, weekStartsOn: 1 });
}
function ML(e, t) {
  const n = Fe(e, t?.in), r = n.getFullYear(), o = f2(n, 0);
  o.setFullYear(r + 1, 0, 4), o.setHours(0, 0, 0, 0);
  const i = Ar(o), a = f2(n, 0);
  a.setFullYear(r, 0, 4), a.setHours(0, 0, 0, 0);
  const s = Ar(a);
  return n.getTime() >= i.getTime() ? r + 1 : n.getTime() >= s.getTime() ? r : r - 1;
}
function Nv(e) {
  const t = Fe(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function Cn(e, ...t) {
  const n = f2.bind(
    null,
    t.find((r) => typeof r == "object")
  );
  return t.map(n);
}
function Ir(e, t) {
  const n = Fe(e, t?.in);
  return n.setHours(0, 0, 0, 0), n;
}
function kL(e, t, n) {
  const [r, o] = Cn(
    n?.in,
    e,
    t
  ), i = Ir(r), a = Ir(o), s = +i - Nv(i), l = +a - Nv(a);
  return Math.round((s - l) / AJ);
}
function OJ(e, t) {
  const n = ML(e, t), r = f2(e, 0);
  return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), Ar(r);
}
function NJ(e, t, n) {
  return xL(e, t * 7, n);
}
function DJ(e, t, n) {
  return SL(e, t * 12, n);
}
function BJ(e, t) {
  let n, r = t?.in;
  return e.forEach((o) => {
    !r && typeof o == "object" && (r = f2.bind(null, o));
    const i = Fe(o, r);
    (!n || n < i || isNaN(+i)) && (n = i);
  }), f2(r, n || NaN);
}
function FJ(e, t) {
  let n, r = t?.in;
  return e.forEach((o) => {
    !r && typeof o == "object" && (r = f2.bind(null, o));
    const i = Fe(o, r);
    (!n || n > i || isNaN(+i)) && (n = i);
  }), f2(r, n || NaN);
}
function $J(e, t, n) {
  const [r, o] = Cn(
    n?.in,
    e,
    t
  );
  return +Ir(r) == +Ir(o);
}
function LL(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function WJ(e) {
  return !(!LL(e) && typeof e != "number" || isNaN(+Fe(e)));
}
function VJ(e, t, n) {
  const [r, o] = Cn(
    n?.in,
    e,
    t
  ), i = r.getFullYear() - o.getFullYear(), a = r.getMonth() - o.getMonth();
  return i * 12 + a;
}
function HJ(e, t) {
  const n = Fe(e, t?.in), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function jJ(e, t) {
  const [n, r] = Cn(e, t.start, t.end);
  return { start: n, end: r };
}
function qJ(e, t) {
  const { start: n, end: r } = jJ(t?.in, e);
  let o = +n > +r;
  const i = o ? +n : +r, a = o ? r : n;
  a.setHours(0, 0, 0, 0), a.setDate(1);
  let s = 1;
  const l = [];
  for (; +a <= i; )
    l.push(f2(n, a)), a.setMonth(a.getMonth() + s);
  return o ? l.reverse() : l;
}
function zJ(e, t) {
  const n = Fe(e, t?.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function UJ(e, t) {
  const n = Fe(e, t?.in), r = n.getFullYear();
  return n.setFullYear(r + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function EL(e, t) {
  const n = Fe(e, t?.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function TL(e, t) {
  const n = uo(), r = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, o = Fe(e, t?.in), i = o.getDay(), a = (i < r ? -7 : 0) + 6 - (i - r);
  return o.setDate(o.getDate() + a), o.setHours(23, 59, 59, 999), o;
}
function GJ(e, t) {
  return TL(e, { ...t, weekStartsOn: 1 });
}
const YJ = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, ZJ = (e, t, n) => {
  let r;
  const o = YJ[e];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", t.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function S6(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const KJ = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, XJ = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, QJ = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, JJ = {
  date: S6({
    formats: KJ,
    defaultWidth: "full"
  }),
  time: S6({
    formats: XJ,
    defaultWidth: "full"
  }),
  dateTime: S6({
    formats: QJ,
    defaultWidth: "full"
  })
}, e11 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, t11 = (e, t, n, r) => e11[e];
function Wn(e) {
  return (t, n) => {
    const r = n?.context ? String(n.context) : "standalone";
    let o;
    if (r === "formatting" && e.formattingValues) {
      const a = e.defaultFormattingWidth || e.defaultWidth, s = n?.width ? String(n.width) : a;
      o = e.formattingValues[s] || e.formattingValues[a];
    } else {
      const a = e.defaultWidth, s = n?.width ? String(n.width) : e.defaultWidth;
      o = e.values[s] || e.values[a];
    }
    const i = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[i];
  };
}
const n11 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, r11 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, o11 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, i11 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, a11 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, s11 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, l11 = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, c11 = {
  ordinalNumber: l11,
  era: Wn({
    values: n11,
    defaultWidth: "wide"
  }),
  quarter: Wn({
    values: r11,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Wn({
    values: o11,
    defaultWidth: "wide"
  }),
  day: Wn({
    values: i11,
    defaultWidth: "wide"
  }),
  dayPeriod: Wn({
    values: a11,
    defaultWidth: "wide",
    formattingValues: s11,
    defaultFormattingWidth: "wide"
  })
};
function Vn(e) {
  return (t, n = {}) => {
    const r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], i = t.match(o);
    if (!i)
      return null;
    const a = i[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? d11(s, (u) => u.test(a)) : (
      // [TODO] -- I challenge you to fix the type
      u11(s, (u) => u.test(a))
    );
    let c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(c)
    ) : c;
    const f = t.slice(a.length);
    return { value: c, rest: f };
  };
}
function u11(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function d11(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function f11(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const o = r[0], i = t.match(e.parsePattern);
    if (!i) return null;
    let a = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    a = n.valueCallback ? n.valueCallback(a) : a;
    const s = t.slice(o.length);
    return { value: a, rest: s };
  };
}
const h11 = /^(\d+)(th|st|nd|rd)?/i, p11 = /\d+/i, m11 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, g11 = {
  any: [/^b/i, /^(a|c)/i]
}, v11 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, b11 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, y11 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, C11 = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, w11 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, _11 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, x11 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, S11 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, M11 = {
  ordinalNumber: f11({
    matchPattern: h11,
    parsePattern: p11,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Vn({
    matchPatterns: m11,
    defaultMatchWidth: "wide",
    parsePatterns: g11,
    defaultParseWidth: "any"
  }),
  quarter: Vn({
    matchPatterns: v11,
    defaultMatchWidth: "wide",
    parsePatterns: b11,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Vn({
    matchPatterns: y11,
    defaultMatchWidth: "wide",
    parsePatterns: C11,
    defaultParseWidth: "any"
  }),
  day: Vn({
    matchPatterns: w11,
    defaultMatchWidth: "wide",
    parsePatterns: _11,
    defaultParseWidth: "any"
  }),
  dayPeriod: Vn({
    matchPatterns: x11,
    defaultMatchWidth: "any",
    parsePatterns: S11,
    defaultParseWidth: "any"
  })
}, R7 = {
  code: "en-US",
  formatDistance: ZJ,
  formatLong: JJ,
  formatRelative: t11,
  localize: c11,
  match: M11,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function k11(e, t) {
  const n = Fe(e, t?.in);
  return kL(n, EL(n)) + 1;
}
function RL(e, t) {
  const n = Fe(e, t?.in), r = +Ar(n) - +OJ(n);
  return Math.round(r / _L) + 1;
}
function PL(e, t) {
  const n = Fe(e, t?.in), r = n.getFullYear(), o = uo(), i = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? o.firstWeekContainsDate ?? o.locale?.options?.firstWeekContainsDate ?? 1, a = f2(t?.in || e, 0);
  a.setFullYear(r + 1, 0, i), a.setHours(0, 0, 0, 0);
  const s = Q3(a, t), l = f2(t?.in || e, 0);
  l.setFullYear(r, 0, i), l.setHours(0, 0, 0, 0);
  const c = Q3(l, t);
  return +n >= +s ? r + 1 : +n >= +c ? r : r - 1;
}
function L11(e, t) {
  const n = uo(), r = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, o = PL(e, t), i = f2(t?.in || e, 0);
  return i.setFullYear(o, 0, r), i.setHours(0, 0, 0, 0), Q3(i, t);
}
function AL(e, t) {
  const n = Fe(e, t?.in), r = +Q3(n, t) - +L11(n, t);
  return Math.round(r / _L) + 1;
}
function Oe(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const p0 = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return Oe(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : Oe(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return Oe(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return Oe(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return Oe(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return Oe(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return Oe(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), o = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return Oe(o, t.length);
  }
}, E3 = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Dv = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), o = r > 0 ? r : 1 - r;
      return n.ordinalNumber(o, { unit: "year" });
    }
    return p0.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const o = PL(e, r), i = o > 0 ? o : 1 - o;
    if (t === "YY") {
      const a = i % 100;
      return Oe(a, 2);
    }
    return t === "Yo" ? n.ordinalNumber(i, { unit: "year" }) : Oe(i, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = ML(e);
    return Oe(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return Oe(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return Oe(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return Oe(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return p0.M(e, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return Oe(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const o = AL(e, r);
    return t === "wo" ? n.ordinalNumber(o, { unit: "week" }) : Oe(o, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = RL(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : Oe(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : p0.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = k11(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : Oe(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const o = e.getDay(), i = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(i);
      // Padded numerical value
      case "ee":
        return Oe(i, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(i, { unit: "day" });
      case "eee":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const o = e.getDay(), i = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(i);
      // Padded numerical value
      case "cc":
        return Oe(i, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return n.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(o, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(o, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return n.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), o = r === 0 ? 7 : r;
    switch (t) {
      // 2
      case "i":
        return String(o);
      // 02
      case "ii":
        return Oe(o, t.length);
      // 2nd
      case "io":
        return n.ordinalNumber(o, { unit: "day" });
      // Tue
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r === 12 ? o = E3.noon : r === 0 ? o = E3.midnight : o = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r >= 17 ? o = E3.evening : r >= 12 ? o = E3.afternoon : r >= 4 ? o = E3.morning : o = E3.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return p0.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : p0.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : Oe(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : Oe(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : p0.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : p0.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return p0.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return Fv(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return $0(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return $0(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return Fv(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return $0(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return $0(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Bv(r, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + $0(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Bv(r, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + $0(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(+e / 1e3);
    return Oe(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    return Oe(+e, t.length);
  }
};
function Bv(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.trunc(r / 60), i = r % 60;
  return i === 0 ? n + String(o) : n + String(o) + t + Oe(i, 2);
}
function Fv(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + Oe(Math.abs(e) / 60, 2) : $0(e, t);
}
function $0(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Oe(Math.trunc(r / 60), 2), i = Oe(r % 60, 2);
  return n + o + t + i;
}
const $v = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, IL = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, E11 = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], o = n[2];
  if (!o)
    return $v(e, t);
  let i;
  switch (r) {
    case "P":
      i = t.dateTime({ width: "short" });
      break;
    case "PP":
      i = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = t.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", $v(r, t)).replace("{{time}}", IL(o, t));
}, T11 = {
  p: IL,
  P: E11
}, R11 = /^D+$/, P11 = /^Y+$/, A11 = ["D", "DD", "YY", "YYYY"];
function I11(e) {
  return R11.test(e);
}
function O11(e) {
  return P11.test(e);
}
function N11(e, t, n) {
  const r = D11(e, t, n);
  if (console.warn(r), A11.includes(e)) throw new RangeError(r);
}
function D11(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const B11 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, F11 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, $11 = /^'([^]*?)'?$/, W11 = /''/g, V11 = /[a-zA-Z]/;
function rr(e, t, n) {
  const r = uo(), o = n?.locale ?? r.locale ?? R7, i = n?.firstWeekContainsDate ?? n?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, a = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? r.weekStartsOn ?? r.locale?.options?.weekStartsOn ?? 0, s = Fe(e, n?.in);
  if (!WJ(s))
    throw new RangeError("Invalid time value");
  let l = t.match(F11).map((f) => {
    const u = f[0];
    if (u === "p" || u === "P") {
      const h = T11[u];
      return h(f, o.formatLong);
    }
    return f;
  }).join("").match(B11).map((f) => {
    if (f === "''")
      return { isToken: !1, value: "'" };
    const u = f[0];
    if (u === "'")
      return { isToken: !1, value: H11(f) };
    if (Dv[u])
      return { isToken: !0, value: f };
    if (u.match(V11))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + u + "`"
      );
    return { isToken: !1, value: f };
  });
  o.localize.preprocessor && (l = o.localize.preprocessor(s, l));
  const c = {
    firstWeekContainsDate: i,
    weekStartsOn: a,
    locale: o
  };
  return l.map((f) => {
    if (!f.isToken) return f.value;
    const u = f.value;
    (!n?.useAdditionalWeekYearTokens && O11(u) || !n?.useAdditionalDayOfYearTokens && I11(u)) && N11(u, t, String(e));
    const h = Dv[u[0]];
    return h(s, u, o.localize, c);
  }).join("");
}
function H11(e) {
  const t = e.match($11);
  return t ? t[1].replace(W11, "'") : e;
}
function j11(e, t) {
  const n = Fe(e, t?.in), r = n.getFullYear(), o = n.getMonth(), i = f2(n, 0);
  return i.setFullYear(r, o + 1, 0), i.setHours(0, 0, 0, 0), i.getDate();
}
function q11(e, t) {
  return Fe(e, t?.in).getMonth();
}
function z11(e, t) {
  return Fe(e, t?.in).getFullYear();
}
function U11(e, t) {
  return +Fe(e) > +Fe(t);
}
function G11(e, t) {
  return +Fe(e) < +Fe(t);
}
function Y11(e, t, n) {
  const [r, o] = Cn(
    n?.in,
    e,
    t
  );
  return r.getFullYear() === o.getFullYear() && r.getMonth() === o.getMonth();
}
function Z11(e, t, n) {
  const [r, o] = Cn(
    n?.in,
    e,
    t
  );
  return r.getFullYear() === o.getFullYear();
}
function K11(e, t, n) {
  const r = Fe(e, n?.in), o = r.getFullYear(), i = r.getDate(), a = f2(e, 0);
  a.setFullYear(o, t, 15), a.setHours(0, 0, 0, 0);
  const s = j11(a);
  return r.setMonth(t, Math.min(i, s)), r;
}
function X11(e, t, n) {
  const r = Fe(e, n?.in);
  return isNaN(+r) ? f2(e, NaN) : (r.setFullYear(t), r);
}
const Q11 = {}, Xn = {};
function or(e, t) {
  try {
    const r = (Q11[e] ||= new Intl.DateTimeFormat("en-GB", {
      timeZone: e,
      hour: "numeric",
      timeZoneName: "longOffset"
    }).format)(t).split("GMT")[1] || "";
    return r in Xn ? Xn[r] : Wv(r, r.split(":"));
  } catch {
    if (e in Xn) return Xn[e];
    const n = e?.match(J11);
    return n ? Wv(e, n.slice(1)) : NaN;
  }
}
const J11 = /([+-]\d\d):?(\d\d)?/;
function Wv(e, t) {
  const n = +t[0], r = +(t[1] || 0);
  return Xn[e] = n > 0 ? n * 60 + r : n * 60 - r;
}
class Lt extends Date {
  //#region static
  constructor(...t) {
    super(), t.length > 1 && typeof t[t.length - 1] == "string" && (this.timeZone = t.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(or(this.timeZone, this)) ? this.setTime(NaN) : t.length ? typeof t[0] == "number" && (t.length === 1 || t.length === 2 && typeof t[1] != "number") ? this.setTime(t[0]) : typeof t[0] == "string" ? this.setTime(+new Date(t[0])) : t[0] instanceof Date ? this.setTime(+t[0]) : (this.setTime(+new Date(...t)), OL(this), ju(this)) : this.setTime(Date.now());
  }
  static tz(t, ...n) {
    return n.length ? new Lt(...n, t) : new Lt(Date.now(), t);
  }
  //#endregion
  //#region time zone
  withTimeZone(t) {
    return new Lt(+this, t);
  }
  getTimezoneOffset() {
    return -or(this.timeZone, this);
  }
  //#endregion
  //#region time
  setTime(t) {
    return Date.prototype.setTime.apply(this, arguments), ju(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new Lt(+new Date(t), this.timeZone);
  }
  //#endregion
}
const Vv = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((e) => {
  if (!Vv.test(e)) return;
  const t = e.replace(Vv, "$1UTC");
  Lt.prototype[t] && (e.startsWith("get") ? Lt.prototype[e] = function() {
    return this.internal[t]();
  } : (Lt.prototype[e] = function() {
    return Date.prototype[t].apply(this.internal, arguments), ee1(this), +this;
  }, Lt.prototype[t] = function() {
    return Date.prototype[t].apply(this, arguments), ju(this), +this;
  }));
});
function ju(e) {
  e.internal.setTime(+e), e.internal.setUTCMinutes(e.internal.getUTCMinutes() - e.getTimezoneOffset());
}
function ee1(e) {
  Date.prototype.setFullYear.call(e, e.internal.getUTCFullYear(), e.internal.getUTCMonth(), e.internal.getUTCDate()), Date.prototype.setHours.call(e, e.internal.getUTCHours(), e.internal.getUTCMinutes(), e.internal.getUTCSeconds(), e.internal.getUTCMilliseconds()), OL(e);
}
function OL(e) {
  const t = or(e.timeZone, e), n = /* @__PURE__ */ new Date(+e);
  n.setUTCHours(n.getUTCHours() - 1);
  const r = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset(), o = -(/* @__PURE__ */ new Date(+n)).getTimezoneOffset(), i = r - o, a = Date.prototype.getHours.apply(e) !== e.internal.getUTCHours();
  i && a && e.internal.setUTCMinutes(e.internal.getUTCMinutes() + i);
  const s = r - t;
  s && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + s);
  const l = or(e.timeZone, e), f = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset() - l, u = l !== t, h = f - s;
  if (u && h) {
    Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + h);
    const p = or(e.timeZone, e), g = l - p;
    g && (e.internal.setUTCMinutes(e.internal.getUTCMinutes() + g), Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + g));
  }
}
class k2 extends Lt {
  //#region static
  static tz(t, ...n) {
    return n.length ? new k2(...n, t) : new k2(Date.now(), t);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [t, n, r] = this.tzComponents(), o = `${t}${n}:${r}`;
    return this.internal.toISOString().slice(0, -1) + o;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [t, n, r, o] = this.internal.toUTCString().split(" ");
    return `${t?.slice(0, -1)} ${r} ${n} ${o}`;
  }
  toTimeString() {
    const t = this.internal.toUTCString().split(" ")[4], [n, r, o] = this.tzComponents();
    return `${t} GMT${n}${r}${o} (${te1(this.timeZone, this)})`;
  }
  toLocaleString(t, n) {
    return Date.prototype.toLocaleString.call(this, t, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  toLocaleDateString(t, n) {
    return Date.prototype.toLocaleDateString.call(this, t, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  toLocaleTimeString(t, n) {
    return Date.prototype.toLocaleTimeString.call(this, t, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const t = this.getTimezoneOffset(), n = t > 0 ? "-" : "+", r = String(Math.floor(Math.abs(t) / 60)).padStart(2, "0"), o = String(Math.abs(t) % 60).padStart(2, "0");
    return [n, r, o];
  }
  //#endregion
  withTimeZone(t) {
    return new k2(+this, t);
  }
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new k2(+new Date(t), this.timeZone);
  }
  //#endregion
}
function te1(e, t) {
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: e,
    timeZoneName: "long"
  }).format(t).slice(12);
}
var O1;
(function(e) {
  e.Root = "root", e.Chevron = "chevron", e.Day = "day", e.DayButton = "day_button", e.CaptionLabel = "caption_label", e.Dropdowns = "dropdowns", e.Dropdown = "dropdown", e.DropdownRoot = "dropdown_root", e.Footer = "footer", e.MonthGrid = "month_grid", e.MonthCaption = "month_caption", e.MonthsDropdown = "months_dropdown", e.Month = "month", e.Months = "months", e.Nav = "nav", e.NextMonthButton = "button_next", e.PreviousMonthButton = "button_previous", e.Week = "week", e.Weeks = "weeks", e.Weekday = "weekday", e.Weekdays = "weekdays", e.WeekNumber = "week_number", e.WeekNumberHeader = "week_number_header", e.YearsDropdown = "years_dropdown";
})(O1 || (O1 = {}));
var Ke;
(function(e) {
  e.disabled = "disabled", e.hidden = "hidden", e.outside = "outside", e.focused = "focused", e.today = "today";
})(Ke || (Ke = {}));
var ht;
(function(e) {
  e.range_end = "range_end", e.range_middle = "range_middle", e.range_start = "range_start", e.selected = "selected";
})(ht || (ht = {}));
var z2;
(function(e) {
  e.weeks_before_enter = "weeks_before_enter", e.weeks_before_exit = "weeks_before_exit", e.weeks_after_enter = "weeks_after_enter", e.weeks_after_exit = "weeks_after_exit", e.caption_after_enter = "caption_after_enter", e.caption_after_exit = "caption_after_exit", e.caption_before_enter = "caption_before_enter", e.caption_before_exit = "caption_before_exit";
})(z2 || (z2 = {}));
const Hv = 5, ne1 = 4;
function re1(e, t) {
  const n = t.startOfMonth(e), r = n.getDay() > 0 ? n.getDay() : 7, o = t.addDays(e, -r + 1), i = t.addDays(o, Hv * 7 - 1);
  return t.getMonth(e) === t.getMonth(i) ? Hv : ne1;
}
function NL(e, t) {
  const n = t.startOfMonth(e), r = n.getDay();
  return r === 1 ? n : r === 0 ? t.addDays(n, -1 * 6) : t.addDays(n, -1 * (r - 1));
}
function oe1(e, t) {
  const n = NL(e, t), r = re1(e, t);
  return t.addDays(n, r * 7 - 1);
}
class l0 {
  /**
   * Creates an instance of `DateLib`.
   *
   * @param options Configuration options for the date library.
   * @param overrides Custom overrides for the date library functions.
   */
  constructor(t, n) {
    this.Date = Date, this.today = () => this.overrides?.today ? this.overrides.today() : this.options.timeZone ? k2.tz(this.options.timeZone) : new this.Date(), this.newDate = (r, o, i) => this.overrides?.newDate ? this.overrides.newDate(r, o, i) : this.options.timeZone ? new k2(r, o, i, this.options.timeZone) : new Date(r, o, i), this.addDays = (r, o) => this.overrides?.addDays ? this.overrides.addDays(r, o) : xL(r, o), this.addMonths = (r, o) => this.overrides?.addMonths ? this.overrides.addMonths(r, o) : SL(r, o), this.addWeeks = (r, o) => this.overrides?.addWeeks ? this.overrides.addWeeks(r, o) : NJ(r, o), this.addYears = (r, o) => this.overrides?.addYears ? this.overrides.addYears(r, o) : DJ(r, o), this.differenceInCalendarDays = (r, o) => this.overrides?.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(r, o) : kL(r, o), this.differenceInCalendarMonths = (r, o) => this.overrides?.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(r, o) : VJ(r, o), this.eachMonthOfInterval = (r) => this.overrides?.eachMonthOfInterval ? this.overrides.eachMonthOfInterval(r) : qJ(r), this.endOfBroadcastWeek = (r) => this.overrides?.endOfBroadcastWeek ? this.overrides.endOfBroadcastWeek(r) : oe1(r, this), this.endOfISOWeek = (r) => this.overrides?.endOfISOWeek ? this.overrides.endOfISOWeek(r) : GJ(r), this.endOfMonth = (r) => this.overrides?.endOfMonth ? this.overrides.endOfMonth(r) : HJ(r), this.endOfWeek = (r, o) => this.overrides?.endOfWeek ? this.overrides.endOfWeek(r, o) : TL(r, this.options), this.endOfYear = (r) => this.overrides?.endOfYear ? this.overrides.endOfYear(r) : UJ(r), this.format = (r, o, i) => {
      const a = this.overrides?.format ? this.overrides.format(r, o, this.options) : rr(r, o, this.options);
      return this.options.numerals && this.options.numerals !== "latn" ? this.replaceDigits(a) : a;
    }, this.getISOWeek = (r) => this.overrides?.getISOWeek ? this.overrides.getISOWeek(r) : RL(r), this.getMonth = (r, o) => this.overrides?.getMonth ? this.overrides.getMonth(r, this.options) : q11(r, this.options), this.getYear = (r, o) => this.overrides?.getYear ? this.overrides.getYear(r, this.options) : z11(r, this.options), this.getWeek = (r, o) => this.overrides?.getWeek ? this.overrides.getWeek(r, this.options) : AL(r, this.options), this.isAfter = (r, o) => this.overrides?.isAfter ? this.overrides.isAfter(r, o) : U11(r, o), this.isBefore = (r, o) => this.overrides?.isBefore ? this.overrides.isBefore(r, o) : G11(r, o), this.isDate = (r) => this.overrides?.isDate ? this.overrides.isDate(r) : LL(r), this.isSameDay = (r, o) => this.overrides?.isSameDay ? this.overrides.isSameDay(r, o) : $J(r, o), this.isSameMonth = (r, o) => this.overrides?.isSameMonth ? this.overrides.isSameMonth(r, o) : Y11(r, o), this.isSameYear = (r, o) => this.overrides?.isSameYear ? this.overrides.isSameYear(r, o) : Z11(r, o), this.max = (r) => this.overrides?.max ? this.overrides.max(r) : BJ(r), this.min = (r) => this.overrides?.min ? this.overrides.min(r) : FJ(r), this.setMonth = (r, o) => this.overrides?.setMonth ? this.overrides.setMonth(r, o) : K11(r, o), this.setYear = (r, o) => this.overrides?.setYear ? this.overrides.setYear(r, o) : X11(r, o), this.startOfBroadcastWeek = (r, o) => this.overrides?.startOfBroadcastWeek ? this.overrides.startOfBroadcastWeek(r, this) : NL(r, this), this.startOfDay = (r) => this.overrides?.startOfDay ? this.overrides.startOfDay(r) : Ir(r), this.startOfISOWeek = (r) => this.overrides?.startOfISOWeek ? this.overrides.startOfISOWeek(r) : Ar(r), this.startOfMonth = (r) => this.overrides?.startOfMonth ? this.overrides.startOfMonth(r) : zJ(r), this.startOfWeek = (r, o) => this.overrides?.startOfWeek ? this.overrides.startOfWeek(r, this.options) : Q3(r, this.options), this.startOfYear = (r) => this.overrides?.startOfYear ? this.overrides.startOfYear(r) : EL(r), this.options = { locale: R7, ...t }, this.overrides = n;
  }
  /**
   * Generates a mapping of Arabic digits (0-9) to the target numbering system
   * digits.
   *
   * @since 9.5.0
   * @returns A record mapping Arabic digits to the target numerals.
   */
  getDigitMap() {
    const { numerals: t = "latn" } = this.options, n = new Intl.NumberFormat("en-US", {
      numberingSystem: t
    }), r = {};
    for (let o = 0; o < 10; o++)
      r[o.toString()] = n.format(o);
    return r;
  }
  /**
   * Replaces Arabic digits in a string with the target numbering system digits.
   *
   * @since 9.5.0
   * @param input The string containing Arabic digits.
   * @returns The string with digits replaced.
   */
  replaceDigits(t) {
    const n = this.getDigitMap();
    return t.replace(/\d/g, (r) => n[r] || r);
  }
  /**
   * Formats a number using the configured numbering system.
   *
   * @since 9.5.0
   * @param value The number to format.
   * @returns The formatted number as a string.
   */
  formatNumber(t) {
    return this.replaceDigits(t.toString());
  }
}
const Ht = new l0();
class DL {
  constructor(t, n, r = Ht) {
    this.date = t, this.displayMonth = n, this.outside = !!(n && !r.isSameMonth(t, n)), this.dateLib = r;
  }
  /**
   * Checks if this day is equal to another `CalendarDay`, considering both the
   * date and the displayed month.
   *
   * @param day The `CalendarDay` to compare with.
   * @returns `true` if the days are equal, otherwise `false`.
   */
  isEqualTo(t) {
    return this.dateLib.isSameDay(t.date, this.date) && this.dateLib.isSameMonth(t.displayMonth, this.displayMonth);
  }
}
class ie1 {
  constructor(t, n) {
    this.date = t, this.weeks = n;
  }
}
class ae1 {
  constructor(t, n) {
    this.days = n, this.weekNumber = t;
  }
}
function Xt(e, t, n = !1, r = Ht) {
  let { from: o, to: i } = e;
  const { differenceInCalendarDays: a, isSameDay: s } = r;
  return o && i ? (a(i, o) < 0 && ([o, i] = [i, o]), a(t, o) >= (n ? 1 : 0) && a(i, t) >= (n ? 1 : 0)) : !n && i ? s(i, t) : !n && o ? s(o, t) : !1;
}
function BL(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function P7(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function FL(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function $L(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function WL(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function VL(e, t) {
  return Array.isArray(e) && e.every(t.isDate);
}
function Qt(e, t, n = Ht) {
  const r = Array.isArray(t) ? t : [t], { isSameDay: o, differenceInCalendarDays: i, isAfter: a } = n;
  return r.some((s) => {
    if (typeof s == "boolean")
      return s;
    if (n.isDate(s))
      return o(e, s);
    if (VL(s, n))
      return s.includes(e);
    if (P7(s))
      return Xt(s, e, !1, n);
    if (WL(s))
      return Array.isArray(s.dayOfWeek) ? s.dayOfWeek.includes(e.getDay()) : s.dayOfWeek === e.getDay();
    if (BL(s)) {
      const l = i(s.before, e), c = i(s.after, e), f = l > 0, u = c < 0;
      return a(s.before, s.after) ? u && f : f || u;
    }
    return FL(s) ? i(e, s.after) > 0 : $L(s) ? i(s.before, e) > 0 : typeof s == "function" ? s(e) : !1;
  });
}
function se1(e, t, n, r, o) {
  const { disabled: i, hidden: a, modifiers: s, showOutsideDays: l, broadcastCalendar: c, today: f } = t, { isSameDay: u, isSameMonth: h, startOfMonth: p, isBefore: g, endOfMonth: m, isAfter: b } = o, y = n && p(n), C = r && m(r), _ = {
    [Ke.focused]: [],
    [Ke.outside]: [],
    [Ke.disabled]: [],
    [Ke.hidden]: [],
    [Ke.today]: []
  }, M = {};
  for (const S of e) {
    const { date: k, displayMonth: L } = S, P = !!(L && !h(k, L)), I = !!(y && g(k, y)), O = !!(C && b(k, C)), E = !!(i && Qt(k, i, o)), B = !!(a && Qt(k, a, o)) || I || O || // Broadcast calendar will show outside days as default
    !c && !l && P || c && l === !1 && P, W = u(k, f ?? o.today());
    P && _.outside.push(S), E && _.disabled.push(S), B && _.hidden.push(S), W && _.today.push(S), s && Object.keys(s).forEach((F) => {
      const z = s?.[F];
      z && Qt(k, z, o) && (M[F] ? M[F].push(S) : M[F] = [S]);
    });
  }
  return (S) => {
    const k = {
      [Ke.focused]: !1,
      [Ke.disabled]: !1,
      [Ke.hidden]: !1,
      [Ke.outside]: !1,
      [Ke.today]: !1
    }, L = {};
    for (const P in _) {
      const I = _[P];
      k[P] = I.some((O) => O === S);
    }
    for (const P in M)
      L[P] = M[P].some((I) => I === S);
    return {
      ...k,
      // custom modifiers should override all the previous ones
      ...L
    };
  };
}
function le1(e, t, n = {}) {
  return Object.entries(e).filter(([, o]) => o === !0).reduce((o, [i]) => (n[i] ? o.push(n[i]) : t[Ke[i]] ? o.push(t[Ke[i]]) : t[ht[i]] && o.push(t[ht[i]]), o), [t[O1.Day]]);
}
function ce1(e) {
  return G.createElement("button", { ...e });
}
function ue1(e) {
  return G.createElement("span", { ...e });
}
function de1(e) {
  const { size: t = 24, orientation: n = "left", className: r } = e;
  return G.createElement(
    "svg",
    { className: r, width: t, height: t, viewBox: "0 0 24 24" },
    n === "up" && G.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }),
    n === "down" && G.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }),
    n === "left" && G.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }),
    n === "right" && G.createElement("polygon", { points: "8 18.112 14.18888889 12 8 5.87733333 9.91111111 4 18 12 9.91111111 20" })
  );
}
function fe1(e) {
  const { day: t, modifiers: n, ...r } = e;
  return G.createElement("td", { ...r });
}
function he1(e) {
  const { day: t, modifiers: n, ...r } = e, o = G.useRef(null);
  return G.useEffect(() => {
    n.focused && o.current?.focus();
  }, [n.focused]), G.createElement("button", { ref: o, ...r });
}
function pe1(e) {
  const { options: t, className: n, components: r, classNames: o, ...i } = e, a = [o[O1.Dropdown], n].join(" "), s = t?.find(({ value: l }) => l === i.value);
  return G.createElement(
    "span",
    { "data-disabled": i.disabled, className: o[O1.DropdownRoot] },
    G.createElement(r.Select, { className: a, ...i }, t?.map(({ value: l, label: c, disabled: f }) => G.createElement(r.Option, { key: l, value: l, disabled: f }, c))),
    G.createElement(
      "span",
      { className: o[O1.CaptionLabel], "aria-hidden": !0 },
      s?.label,
      G.createElement(r.Chevron, { orientation: "down", size: 18, className: o[O1.Chevron] })
    )
  );
}
function me1(e) {
  return G.createElement("div", { ...e });
}
function ge1(e) {
  return G.createElement("div", { ...e });
}
function ve1(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return G.createElement("div", { ...r }, e.children);
}
function be1(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return G.createElement("div", { ...r });
}
function ye1(e) {
  return G.createElement("table", { ...e });
}
function Ce1(e) {
  return G.createElement("div", { ...e });
}
const HL = s3(void 0);
function fo() {
  const e = Rt(HL);
  if (e === void 0)
    throw new Error("useDayPicker() must be used within a custom component.");
  return e;
}
function we1(e) {
  const { components: t } = fo();
  return G.createElement(t.Dropdown, { ...e });
}
function _e1(e) {
  const { onPreviousClick: t, onNextClick: n, previousMonth: r, nextMonth: o, ...i } = e, { components: a, classNames: s, labels: { labelPrevious: l, labelNext: c } } = fo(), f = R1((h) => {
    o && n?.(h);
  }, [o, n]), u = R1((h) => {
    r && t?.(h);
  }, [r, t]);
  return G.createElement(
    "nav",
    { ...i },
    G.createElement(
      a.PreviousMonthButton,
      { type: "button", className: s[O1.PreviousMonthButton], tabIndex: r ? void 0 : -1, "aria-disabled": r ? void 0 : !0, "aria-label": l(r), onClick: u },
      G.createElement(a.Chevron, { disabled: r ? void 0 : !0, className: s[O1.Chevron], orientation: "left" })
    ),
    G.createElement(
      a.NextMonthButton,
      { type: "button", className: s[O1.NextMonthButton], tabIndex: o ? void 0 : -1, "aria-disabled": o ? void 0 : !0, "aria-label": c(o), onClick: f },
      G.createElement(a.Chevron, { disabled: o ? void 0 : !0, orientation: "right", className: s[O1.Chevron] })
    )
  );
}
function xe1(e) {
  const { components: t } = fo();
  return G.createElement(t.Button, { ...e });
}
function Se1(e) {
  return G.createElement("option", { ...e });
}
function Me1(e) {
  const { components: t } = fo();
  return G.createElement(t.Button, { ...e });
}
function ke1(e) {
  const { rootRef: t, ...n } = e;
  return G.createElement("div", { ...n, ref: t });
}
function Le1(e) {
  return G.createElement("select", { ...e });
}
function Ee1(e) {
  const { week: t, ...n } = e;
  return G.createElement("tr", { ...n });
}
function Te1(e) {
  return G.createElement("th", { ...e });
}
function Re1(e) {
  return G.createElement(
    "thead",
    { "aria-hidden": !0 },
    G.createElement("tr", { ...e })
  );
}
function Pe1(e) {
  const { week: t, ...n } = e;
  return G.createElement("th", { ...n });
}
function Ae1(e) {
  return G.createElement("th", { ...e });
}
function Ie1(e) {
  return G.createElement("tbody", { ...e });
}
function Oe1(e) {
  const { components: t } = fo();
  return G.createElement(t.Dropdown, { ...e });
}
const Ne1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: ce1,
  CaptionLabel: ue1,
  Chevron: de1,
  Day: fe1,
  DayButton: he1,
  Dropdown: pe1,
  DropdownNav: me1,
  Footer: ge1,
  Month: ve1,
  MonthCaption: be1,
  MonthGrid: ye1,
  Months: Ce1,
  MonthsDropdown: we1,
  Nav: _e1,
  NextMonthButton: xe1,
  Option: Se1,
  PreviousMonthButton: Me1,
  Root: ke1,
  Select: Le1,
  Week: Ee1,
  WeekNumber: Pe1,
  WeekNumberHeader: Ae1,
  Weekday: Te1,
  Weekdays: Re1,
  Weeks: Ie1,
  YearsDropdown: Oe1
}, Symbol.toStringTag, { value: "Module" }));
function De1(e) {
  return {
    ...Ne1,
    ...e
  };
}
function Be1(e) {
  const t = {
    "data-mode": e.mode ?? void 0,
    "data-required": "required" in e ? e.required : void 0,
    "data-multiple-months": e.numberOfMonths && e.numberOfMonths > 1 || void 0,
    "data-week-numbers": e.showWeekNumber || void 0,
    "data-broadcast-calendar": e.broadcastCalendar || void 0,
    "data-nav-layout": e.navLayout || void 0
  };
  return Object.entries(e).forEach(([n, r]) => {
    n.startsWith("data-") && (t[n] = r);
  }), t;
}
function A7() {
  const e = {};
  for (const t in O1)
    e[O1[t]] = `rdp-${O1[t]}`;
  for (const t in Ke)
    e[Ke[t]] = `rdp-${Ke[t]}`;
  for (const t in ht)
    e[ht[t]] = `rdp-${ht[t]}`;
  for (const t in z2)
    e[z2[t]] = `rdp-${z2[t]}`;
  return e;
}
function jL(e, t, n) {
  return (n ?? new l0(t)).format(e, "LLLL y");
}
const Fe1 = jL;
function $e1(e, t, n) {
  return (n ?? new l0(t)).format(e, "d");
}
function We1(e, t = Ht) {
  return t.format(e, "LLLL");
}
function Ve1(e, t = Ht) {
  return e < 10 ? t.formatNumber(`0${e.toLocaleString()}`) : t.formatNumber(`${e.toLocaleString()}`);
}
function He1() {
  return "";
}
function je1(e, t, n) {
  return (n ?? new l0(t)).format(e, "cccccc");
}
function qL(e, t = Ht) {
  return t.format(e, "yyyy");
}
const qe1 = qL, ze1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCaption: jL,
  formatDay: $e1,
  formatMonthCaption: Fe1,
  formatMonthDropdown: We1,
  formatWeekNumber: Ve1,
  formatWeekNumberHeader: He1,
  formatWeekdayName: je1,
  formatYearCaption: qe1,
  formatYearDropdown: qL
}, Symbol.toStringTag, { value: "Module" }));
function Ue1(e) {
  return e?.formatMonthCaption && !e.formatCaption && (e.formatCaption = e.formatMonthCaption), e?.formatYearCaption && !e.formatYearDropdown && (e.formatYearDropdown = e.formatYearCaption), {
    ...ze1,
    ...e
  };
}
function Ge1(e, t, n, r, o) {
  const { startOfMonth: i, startOfYear: a, endOfYear: s, eachMonthOfInterval: l, getMonth: c } = o;
  return l({
    start: a(e),
    end: s(e)
  }).map((h) => {
    const p = r.formatMonthDropdown(h, o), g = c(h), m = t && h < i(t) || n && h > i(n) || !1;
    return { value: g, label: p, disabled: m };
  });
}
function Ye1(e, t = {}, n = {}) {
  let r = { ...t?.[O1.Day] };
  return Object.entries(e).filter(([, o]) => o === !0).forEach(([o]) => {
    r = {
      ...r,
      ...n?.[o]
    };
  }), r;
}
function Ze1(e, t, n) {
  const r = e.today(), o = t ? e.startOfISOWeek(r) : e.startOfWeek(r), i = [];
  for (let a = 0; a < 7; a++) {
    const s = e.addDays(o, a);
    i.push(s);
  }
  return i;
}
function Ke1(e, t, n, r) {
  if (!e || !t)
    return;
  const { startOfYear: o, endOfYear: i, addYears: a, getYear: s, isBefore: l, isSameYear: c } = r, f = o(e), u = i(t), h = [];
  let p = f;
  for (; l(p, u) || c(p, u); )
    h.push(p), p = a(p, 1);
  return h.map((g) => {
    const m = n.formatYearDropdown(g, r);
    return {
      value: s(g),
      label: m,
      disabled: !1
    };
  });
}
function zL(e, t, n) {
  return (n ?? new l0(t)).format(e, "LLLL y");
}
const Xe1 = zL;
function Qe1(e, t, n, r) {
  let o = (r ?? new l0(n)).format(e, "PPPP");
  return t?.today && (o = `Today, ${o}`), o;
}
function UL(e, t, n, r) {
  let o = (r ?? new l0(n)).format(e, "PPPP");
  return t.today && (o = `Today, ${o}`), t.selected && (o = `${o}, selected`), o;
}
const Je1 = UL;
function e21() {
  return "";
}
function t21(e) {
  return "Choose the Month";
}
function n21(e) {
  return "Go to the Next Month";
}
function r21(e) {
  return "Go to the Previous Month";
}
function o21(e, t, n) {
  return (n ?? new l0(t)).format(e, "cccc");
}
function i21(e, t) {
  return `Week ${e}`;
}
function a21(e) {
  return "Week Number";
}
function s21(e) {
  return "Choose the Year";
}
const l21 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  labelCaption: Xe1,
  labelDay: Je1,
  labelDayButton: UL,
  labelGrid: zL,
  labelGridcell: Qe1,
  labelMonthDropdown: t21,
  labelNav: e21,
  labelNext: n21,
  labelPrevious: r21,
  labelWeekNumber: i21,
  labelWeekNumberHeader: a21,
  labelWeekday: o21,
  labelYearDropdown: s21
}, Symbol.toStringTag, { value: "Module" })), ho = (e) => e instanceof HTMLElement ? e : null, M6 = (e) => [
  ...e.querySelectorAll("[data-animated-month]") ?? []
], c21 = (e) => ho(e.querySelector("[data-animated-month]")), k6 = (e) => ho(e.querySelector("[data-animated-caption]")), L6 = (e) => ho(e.querySelector("[data-animated-weeks]")), u21 = (e) => ho(e.querySelector("[data-animated-nav]")), d21 = (e) => ho(e.querySelector("[data-animated-weekdays]"));
function f21(e, t, { classNames: n, months: r, focused: o, dateLib: i }) {
  const a = Be(null), s = Be(r), l = Be(!1);
  Zu(() => {
    const c = s.current;
    if (s.current = r, !t || !e.current || // safety check because the ref can be set to anything by consumers
    !(e.current instanceof HTMLElement) || // validation required for the animation to work as expected
    r.length === 0 || c.length === 0 || r.length !== c.length)
      return;
    const f = i.isSameMonth(r[0].date, c[0].date), u = i.isAfter(r[0].date, c[0].date), h = u ? n[z2.caption_after_enter] : n[z2.caption_before_enter], p = u ? n[z2.weeks_after_enter] : n[z2.weeks_before_enter], g = a.current, m = e.current.cloneNode(!0);
    if (m instanceof HTMLElement ? (M6(m).forEach((_) => {
      if (!(_ instanceof HTMLElement))
        return;
      const M = c21(_);
      M && _.contains(M) && _.removeChild(M);
      const S = k6(_);
      S && S.classList.remove(h);
      const k = L6(_);
      k && k.classList.remove(p);
    }), a.current = m) : a.current = null, l.current || f || // skip animation if a day is focused because it can cause issues to the animation and is better for a11y
    o)
      return;
    const b = g instanceof HTMLElement ? M6(g) : [], y = M6(e.current);
    if (y && y.every((C) => C instanceof HTMLElement) && b && b.every((C) => C instanceof HTMLElement)) {
      l.current = !0, e.current.style.isolation = "isolate";
      const C = u21(e.current);
      C && (C.style.zIndex = "1"), y.forEach((_, M) => {
        const S = b[M];
        if (!S)
          return;
        _.style.position = "relative", _.style.overflow = "hidden";
        const k = k6(_);
        k && k.classList.add(h);
        const L = L6(_);
        L && L.classList.add(p);
        const P = () => {
          l.current = !1, e.current && (e.current.style.isolation = ""), C && (C.style.zIndex = ""), k && k.classList.remove(h), L && L.classList.remove(p), _.style.position = "", _.style.overflow = "", _.contains(S) && _.removeChild(S);
        };
        S.style.pointerEvents = "none", S.style.position = "absolute", S.style.overflow = "hidden", S.setAttribute("aria-hidden", "true");
        const I = d21(S);
        I && (I.style.opacity = "0");
        const O = k6(S);
        O && (O.classList.add(u ? n[z2.caption_before_exit] : n[z2.caption_after_exit]), O.addEventListener("animationend", P));
        const E = L6(S);
        E && E.classList.add(u ? n[z2.weeks_before_exit] : n[z2.weeks_after_exit]), _.insertBefore(S, _.firstChild);
      });
    }
  });
}
function h21(e, t, n, r) {
  const o = e[0], i = e[e.length - 1], { ISOWeek: a, fixedWeeks: s, broadcastCalendar: l } = n ?? {}, { addDays: c, differenceInCalendarDays: f, differenceInCalendarMonths: u, endOfBroadcastWeek: h, endOfISOWeek: p, endOfMonth: g, endOfWeek: m, isAfter: b, startOfBroadcastWeek: y, startOfISOWeek: C, startOfWeek: _ } = r, M = l ? y(o, r) : a ? C(o) : _(o), S = l ? h(i) : a ? p(g(i)) : m(g(i)), k = f(S, M), L = u(i, o) + 1, P = [];
  for (let E = 0; E <= k; E++) {
    const B = c(M, E);
    if (t && b(B, t))
      break;
    P.push(B);
  }
  const O = (l ? 35 : 42) * L;
  if (s && P.length < O) {
    const E = O - P.length;
    for (let B = 0; B < E; B++) {
      const W = c(P[P.length - 1], 1);
      P.push(W);
    }
  }
  return P;
}
function p21(e) {
  const t = [];
  return e.reduce((n, r) => {
    const o = r.weeks.reduce((i, a) => [...i, ...a.days], t);
    return [...n, ...o];
  }, t);
}
function m21(e, t, n, r) {
  const { numberOfMonths: o = 1 } = n, i = [];
  for (let a = 0; a < o; a++) {
    const s = r.addMonths(e, a);
    if (t && s > t)
      break;
    i.push(s);
  }
  return i;
}
function jv(e, t, n, r) {
  const { month: o, defaultMonth: i, today: a = r.today(), numberOfMonths: s = 1 } = e;
  let l = o || i || a;
  const { differenceInCalendarMonths: c, addMonths: f, startOfMonth: u } = r;
  if (n && c(n, l) < s - 1) {
    const h = -1 * (s - 1);
    l = f(n, h);
  }
  return t && c(l, t) < 0 && (l = t), u(l);
}
function g21(e, t, n, r) {
  const { addDays: o, endOfBroadcastWeek: i, endOfISOWeek: a, endOfMonth: s, endOfWeek: l, getISOWeek: c, getWeek: f, startOfBroadcastWeek: u, startOfISOWeek: h, startOfWeek: p } = r, g = e.reduce((m, b) => {
    const y = n.broadcastCalendar ? u(b, r) : n.ISOWeek ? h(b) : p(b), C = n.broadcastCalendar ? i(b) : n.ISOWeek ? a(s(b)) : l(s(b)), _ = t.filter((L) => L >= y && L <= C), M = n.broadcastCalendar ? 35 : 42;
    if (n.fixedWeeks && _.length < M) {
      const L = t.filter((P) => {
        const I = M - _.length;
        return P > C && P <= o(C, I);
      });
      _.push(...L);
    }
    const S = _.reduce((L, P) => {
      const I = n.ISOWeek ? c(P) : f(P), O = L.find((B) => B.weekNumber === I), E = new DL(P, b, r);
      return O ? O.days.push(E) : L.push(new ae1(I, [E])), L;
    }, []), k = new ie1(b, S);
    return m.push(k), m;
  }, []);
  return n.reverseMonths ? g.reverse() : g;
}
function v21(e, t) {
  let { startMonth: n, endMonth: r } = e;
  const { startOfYear: o, startOfDay: i, startOfMonth: a, endOfMonth: s, addYears: l, endOfYear: c, newDate: f, today: u } = t, { fromYear: h, toYear: p, fromMonth: g, toMonth: m } = e;
  !n && g && (n = g), !n && h && (n = t.newDate(h, 0, 1)), !r && m && (r = m), !r && p && (r = f(p, 11, 31));
  const b = e.captionLayout === "dropdown" || e.captionLayout === "dropdown-years";
  return n ? n = a(n) : h ? n = f(h, 0, 1) : !n && b && (n = o(l(e.today ?? u(), -100))), r ? r = s(r) : p ? r = f(p, 11, 31) : !r && b && (r = c(e.today ?? u())), [
    n && i(n),
    r && i(r)
  ];
}
function b21(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: o, numberOfMonths: i = 1 } = n, { startOfMonth: a, addMonths: s, differenceInCalendarMonths: l } = r, c = o ? i : 1, f = a(e);
  if (!t)
    return s(f, c);
  if (!(l(t, e) < i))
    return s(f, c);
}
function y21(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: o, numberOfMonths: i } = n, { startOfMonth: a, addMonths: s, differenceInCalendarMonths: l } = r, c = o ? i ?? 1 : 1, f = a(e);
  if (!t)
    return s(f, -c);
  if (!(l(f, t) <= 0))
    return s(f, -c);
}
function C21(e) {
  const t = [];
  return e.reduce((n, r) => [...n, ...r.weeks], t);
}
function As(e, t) {
  const [n, r] = d2(e);
  return [t === void 0 ? n : t, r];
}
function w21(e, t) {
  const [n, r] = v21(e, t), { startOfMonth: o, endOfMonth: i } = t, a = jv(e, n, r, t), [s, l] = As(
    a,
    // initialMonth is always computed from props.month if provided
    e.month ? a : void 0
  );
  Te(() => {
    const k = jv(e, n, r, t);
    l(k);
  }, [e.timeZone]);
  const c = m21(s, r, e, t), f = h21(c, e.endMonth ? i(e.endMonth) : void 0, e, t), u = g21(c, f, e, t), h = C21(u), p = p21(u), g = y21(s, n, e, t), m = b21(s, r, e, t), { disableNavigation: b, onMonthChange: y } = e, C = (k) => h.some((L) => L.days.some((P) => P.isEqualTo(k))), _ = (k) => {
    if (b)
      return;
    let L = o(k);
    n && L < o(n) && (L = o(n)), r && L > o(r) && (L = o(r)), l(L), y?.(L);
  };
  return {
    months: u,
    weeks: h,
    days: p,
    navStart: n,
    navEnd: r,
    previousMonth: g,
    nextMonth: m,
    goToMonth: _,
    goToDay: (k) => {
      C(k) || _(k.date);
    }
  };
}
var _t;
(function(e) {
  e[e.Today = 0] = "Today", e[e.Selected = 1] = "Selected", e[e.LastFocused = 2] = "LastFocused", e[e.FocusedModifier = 3] = "FocusedModifier";
})(_t || (_t = {}));
function qv(e) {
  return !e[Ke.disabled] && !e[Ke.hidden] && !e[Ke.outside];
}
function _21(e, t, n, r) {
  let o, i = -1;
  for (const a of e) {
    const s = t(a);
    qv(s) && (s[Ke.focused] && i < _t.FocusedModifier ? (o = a, i = _t.FocusedModifier) : r?.isEqualTo(a) && i < _t.LastFocused ? (o = a, i = _t.LastFocused) : n(a.date) && i < _t.Selected ? (o = a, i = _t.Selected) : s[Ke.today] && i < _t.Today && (o = a, i = _t.Today));
  }
  return o || (o = e.find((a) => qv(t(a)))), o;
}
function x21(e, t, n, r, o, i, a) {
  const { ISOWeek: s, broadcastCalendar: l } = i, { addDays: c, addMonths: f, addWeeks: u, addYears: h, endOfBroadcastWeek: p, endOfISOWeek: g, endOfWeek: m, max: b, min: y, startOfBroadcastWeek: C, startOfISOWeek: _, startOfWeek: M } = a;
  let k = {
    day: c,
    week: u,
    month: f,
    year: h,
    startOfWeek: (L) => l ? C(L, a) : s ? _(L) : M(L),
    endOfWeek: (L) => l ? p(L) : s ? g(L) : m(L)
  }[e](n, t === "after" ? 1 : -1);
  return t === "before" && r ? k = b([r, k]) : t === "after" && o && (k = y([o, k])), k;
}
function GL(e, t, n, r, o, i, a, s = 0) {
  if (s > 365)
    return;
  const l = x21(e, t, n.date, r, o, i, a), c = !!(i.disabled && Qt(l, i.disabled, a)), f = !!(i.hidden && Qt(l, i.hidden, a)), u = l, h = new DL(l, u, a);
  return !c && !f ? h : GL(e, t, h, r, o, i, a, s + 1);
}
function S21(e, t, n, r, o) {
  const { autoFocus: i } = e, [a, s] = d2(), l = _21(t.days, n, r || (() => !1), a), [c, f] = d2(i ? l : void 0);
  return {
    isFocusTarget: (m) => !!l?.isEqualTo(m),
    setFocused: f,
    focused: c,
    blur: () => {
      s(c), f(void 0);
    },
    moveFocus: (m, b) => {
      if (!c)
        return;
      const y = GL(m, b, c, t.navStart, t.navEnd, e, o);
      y && (t.goToDay(y), f(y));
    }
  };
}
function M21(e, t) {
  const { selected: n, required: r, onSelect: o } = e, [i, a] = As(n, o ? n : void 0), s = o ? n : i, { isSameDay: l } = t, c = (p) => s?.some((g) => l(g, p)) ?? !1, { min: f, max: u } = e;
  return {
    selected: s,
    select: (p, g, m) => {
      let b = [...s ?? []];
      if (c(p)) {
        if (s?.length === f || r && s?.length === 1)
          return;
        b = s?.filter((y) => !l(y, p));
      } else
        s?.length === u ? b = [p] : b = [...b, p];
      return o || a(b), o?.(b, p, g, m), b;
    },
    isSelected: c
  };
}
function k21(e, t, n = 0, r = 0, o = !1, i = Ht) {
  const { from: a, to: s } = t || {}, { isSameDay: l, isAfter: c, isBefore: f } = i;
  let u;
  if (!a && !s)
    u = { from: e, to: n > 0 ? void 0 : e };
  else if (a && !s)
    l(a, e) ? o ? u = { from: a, to: void 0 } : u = void 0 : f(e, a) ? u = { from: e, to: a } : u = { from: a, to: e };
  else if (a && s)
    if (l(a, e) && l(s, e))
      o ? u = { from: a, to: s } : u = void 0;
    else if (l(a, e))
      u = { from: a, to: n > 0 ? void 0 : e };
    else if (l(s, e))
      u = { from: e, to: n > 0 ? void 0 : e };
    else if (f(e, a))
      u = { from: e, to: s };
    else if (c(e, a))
      u = { from: a, to: e };
    else if (c(e, s))
      u = { from: a, to: e };
    else
      throw new Error("Invalid range");
  if (u?.from && u?.to) {
    const h = i.differenceInCalendarDays(u.to, u.from);
    r > 0 && h > r ? u = { from: e, to: void 0 } : n > 1 && h < n && (u = { from: e, to: void 0 });
  }
  return u;
}
function L21(e, t, n = Ht) {
  const r = Array.isArray(t) ? t : [t];
  let o = e.from;
  const i = n.differenceInCalendarDays(e.to, e.from), a = Math.min(i, 6);
  for (let s = 0; s <= a; s++) {
    if (r.includes(o.getDay()))
      return !0;
    o = n.addDays(o, 1);
  }
  return !1;
}
function zv(e, t, n = Ht) {
  return Xt(e, t.from, !1, n) || Xt(e, t.to, !1, n) || Xt(t, e.from, !1, n) || Xt(t, e.to, !1, n);
}
function E21(e, t, n = Ht) {
  const r = Array.isArray(t) ? t : [t];
  if (r.filter((s) => typeof s != "function").some((s) => typeof s == "boolean" ? s : n.isDate(s) ? Xt(e, s, !1, n) : VL(s, n) ? s.some((l) => Xt(e, l, !1, n)) : P7(s) ? s.from && s.to ? zv(e, { from: s.from, to: s.to }, n) : !1 : WL(s) ? L21(e, s.dayOfWeek, n) : BL(s) ? n.isAfter(s.before, s.after) ? zv(e, {
    from: n.addDays(s.after, 1),
    to: n.addDays(s.before, -1)
  }, n) : Qt(e.from, s, n) || Qt(e.to, s, n) : FL(s) || $L(s) ? Qt(e.from, s, n) || Qt(e.to, s, n) : !1))
    return !0;
  const a = r.filter((s) => typeof s == "function");
  if (a.length) {
    let s = e.from;
    const l = n.differenceInCalendarDays(e.to, e.from);
    for (let c = 0; c <= l; c++) {
      if (a.some((f) => f(s)))
        return !0;
      s = n.addDays(s, 1);
    }
  }
  return !1;
}
function T21(e, t) {
  const { disabled: n, excludeDisabled: r, selected: o, required: i, onSelect: a } = e, [s, l] = As(o, a ? o : void 0), c = a ? o : s;
  return {
    selected: c,
    select: (h, p, g) => {
      const { min: m, max: b } = e, y = h ? k21(h, c, m, b, i, t) : void 0;
      return r && n && y?.from && y.to && E21({ from: y.from, to: y.to }, n, t) && (y.from = h, y.to = void 0), a || l(y), a?.(y, h, p, g), y;
    },
    isSelected: (h) => c && Xt(c, h, !1, t)
  };
}
function R21(e, t) {
  const { selected: n, required: r, onSelect: o } = e, [i, a] = As(n, o ? n : void 0), s = o ? n : i, { isSameDay: l } = t;
  return {
    selected: s,
    select: (u, h, p) => {
      let g = u;
      return !r && s && s && l(u, s) && (g = void 0), o || a(g), o?.(g, u, h, p), g;
    },
    isSelected: (u) => s ? l(s, u) : !1
  };
}
function P21(e, t) {
  const n = R21(e, t), r = M21(e, t), o = T21(e, t);
  switch (e.mode) {
    case "single":
      return n;
    case "multiple":
      return r;
    case "range":
      return o;
    default:
      return;
  }
}
function A21(e) {
  let t = e;
  t.timeZone && (t = {
    ...e
  }, t.today && (t.today = new k2(t.today, t.timeZone)), t.month && (t.month = new k2(t.month, t.timeZone)), t.defaultMonth && (t.defaultMonth = new k2(t.defaultMonth, t.timeZone)), t.startMonth && (t.startMonth = new k2(t.startMonth, t.timeZone)), t.endMonth && (t.endMonth = new k2(t.endMonth, t.timeZone)), t.mode === "single" && t.selected ? t.selected = new k2(t.selected, t.timeZone) : t.mode === "multiple" && t.selected ? t.selected = t.selected?.map((f1) => new k2(f1, t.timeZone)) : t.mode === "range" && t.selected && (t.selected = {
    from: t.selected.from ? new k2(t.selected.from, t.timeZone) : void 0,
    to: t.selected.to ? new k2(t.selected.to, t.timeZone) : void 0
  }));
  const { components: n, formatters: r, labels: o, dateLib: i, locale: a, classNames: s } = j1(() => {
    const f1 = { ...R7, ...t.locale };
    return {
      dateLib: new l0({
        locale: f1,
        weekStartsOn: t.broadcastCalendar ? 1 : t.weekStartsOn,
        firstWeekContainsDate: t.firstWeekContainsDate,
        useAdditionalWeekYearTokens: t.useAdditionalWeekYearTokens,
        useAdditionalDayOfYearTokens: t.useAdditionalDayOfYearTokens,
        timeZone: t.timeZone,
        numerals: t.numerals
      }, t.dateLib),
      components: De1(t.components),
      formatters: Ue1(t.formatters),
      labels: { ...l21, ...t.labels },
      locale: f1,
      classNames: { ...A7(), ...t.classNames }
    };
  }, [
    t.locale,
    t.broadcastCalendar,
    t.weekStartsOn,
    t.firstWeekContainsDate,
    t.useAdditionalWeekYearTokens,
    t.useAdditionalDayOfYearTokens,
    t.timeZone,
    t.numerals,
    t.dateLib,
    t.components,
    t.formatters,
    t.labels,
    t.classNames
  ]), { captionLayout: l, mode: c, navLayout: f, numberOfMonths: u = 1, onDayBlur: h, onDayClick: p, onDayFocus: g, onDayKeyDown: m, onDayMouseEnter: b, onDayMouseLeave: y, onNextClick: C, onPrevClick: _, showWeekNumber: M, styles: S } = t, { formatCaption: k, formatDay: L, formatMonthDropdown: P, formatWeekNumber: I, formatWeekNumberHeader: O, formatWeekdayName: E, formatYearDropdown: B } = r, W = w21(t, i), { days: F, months: z, navStart: D, navEnd: Z, previousMonth: U, nextMonth: $, goToMonth: q } = W, K = se1(F, t, D, Z, i), { isSelected: V, select: n1, selected: o1 } = P21(t, i) ?? {}, { blur: r1, focused: X, isFocusTarget: Y, moveFocus: Q, setFocused: N } = S21(t, W, K, V ?? (() => !1), i), { labelDayButton: j, labelGridcell: t1, labelGrid: T, labelMonthDropdown: u1, labelNav: l1, labelPrevious: d1, labelNext: C1, labelWeekday: g1, labelWeekNumber: D1, labelWeekNumberHeader: re, labelYearDropdown: q1 } = o, w1 = j1(() => Ze1(i, t.ISOWeek), [i, t.ISOWeek]), $1 = c !== void 0 || p !== void 0, I1 = R1(() => {
    U && (q(U), _?.(U));
  }, [U, q, _]), me = R1(() => {
    $ && (q($), C?.($));
  }, [q, $, C]), Se = R1((f1, b1) => (S1) => {
    S1.preventDefault(), S1.stopPropagation(), N(f1), n1?.(f1.date, b1, S1), p?.(f1.date, b1, S1);
  }, [n1, p, N]), fe = R1((f1, b1) => (S1) => {
    N(f1), g?.(f1.date, b1, S1);
  }, [g, N]), Re = R1((f1, b1) => (S1) => {
    r1(), h?.(f1.date, b1, S1);
  }, [r1, h]), se = R1((f1, b1) => (S1) => {
    const J1 = {
      ArrowLeft: [
        S1.shiftKey ? "month" : "day",
        t.dir === "rtl" ? "after" : "before"
      ],
      ArrowRight: [
        S1.shiftKey ? "month" : "day",
        t.dir === "rtl" ? "before" : "after"
      ],
      ArrowDown: [S1.shiftKey ? "year" : "week", "after"],
      ArrowUp: [S1.shiftKey ? "year" : "week", "before"],
      PageUp: [S1.shiftKey ? "year" : "month", "before"],
      PageDown: [S1.shiftKey ? "year" : "month", "after"],
      Home: ["startOfWeek", "before"],
      End: ["endOfWeek", "after"]
    };
    if (J1[S1.key]) {
      S1.preventDefault(), S1.stopPropagation();
      const [ee, X1] = J1[S1.key];
      Q(ee, X1);
    }
    m?.(f1.date, b1, S1);
  }, [Q, m, t.dir]), le = R1((f1, b1) => (S1) => {
    b?.(f1.date, b1, S1);
  }, [b]), G1 = R1((f1, b1) => (S1) => {
    y?.(f1.date, b1, S1);
  }, [y]), ge = R1((f1) => (b1) => {
    const S1 = Number(b1.target.value), J1 = i.setMonth(i.startOfMonth(f1), S1);
    q(J1);
  }, [i, q]), ce = R1((f1) => (b1) => {
    const S1 = Number(b1.target.value), J1 = i.setYear(i.startOfMonth(f1), S1);
    q(J1);
  }, [i, q]), { className: he, style: ve } = j1(() => ({
    className: [s[O1.Root], t.className].filter(Boolean).join(" "),
    style: { ...S?.[O1.Root], ...t.style }
  }), [s, t.className, t.style, S]), pe = Be1(t), Ce = Be(null);
  f21(Ce, !!t.animate, {
    classNames: s,
    months: z,
    focused: X,
    dateLib: i
  });
  const Xe = {
    dayPickerProps: t,
    selected: o1,
    select: n1,
    isSelected: V,
    months: z,
    nextMonth: $,
    previousMonth: U,
    goToMonth: q,
    getModifiers: K,
    components: n,
    classNames: s,
    styles: S,
    labels: o,
    formatters: r
  };
  return G.createElement(
    HL.Provider,
    { value: Xe },
    G.createElement(
      n.Root,
      { rootRef: t.animate ? Ce : void 0, className: he, style: ve, dir: t.dir, id: t.id, lang: t.lang, nonce: t.nonce, title: t.title, role: t.role, "aria-label": t["aria-label"], ...pe },
      G.createElement(
        n.Months,
        { className: s[O1.Months], style: S?.[O1.Months] },
        !t.hideNavigation && !f && G.createElement(n.Nav, { "data-animated-nav": t.animate ? "true" : void 0, className: s[O1.Nav], style: S?.[O1.Nav], "aria-label": l1(), onPreviousClick: I1, onNextClick: me, previousMonth: U, nextMonth: $ }),
        z.map((f1, b1) => {
          const S1 = Ge1(f1.date, D, Z, r, i), J1 = Ke1(D, Z, r, i);
          return G.createElement(
            n.Month,
            { "data-animated-month": t.animate ? "true" : void 0, className: s[O1.Month], style: S?.[O1.Month], key: b1, displayIndex: b1, calendarMonth: f1 },
            f === "around" && !t.hideNavigation && b1 === 0 && G.createElement(
              n.PreviousMonthButton,
              { type: "button", className: s[O1.PreviousMonthButton], tabIndex: U ? void 0 : -1, "aria-disabled": U ? void 0 : !0, "aria-label": d1(U), onClick: I1, "data-animated-button": t.animate ? "true" : void 0 },
              G.createElement(n.Chevron, { disabled: U ? void 0 : !0, className: s[O1.Chevron], orientation: t.dir === "rtl" ? "right" : "left" })
            ),
            G.createElement(n.MonthCaption, { "data-animated-caption": t.animate ? "true" : void 0, className: s[O1.MonthCaption], style: S?.[O1.MonthCaption], calendarMonth: f1, displayIndex: b1 }, l?.startsWith("dropdown") ? G.createElement(
              n.DropdownNav,
              { className: s[O1.Dropdowns], style: S?.[O1.Dropdowns] },
              l === "dropdown" || l === "dropdown-months" ? G.createElement(n.MonthsDropdown, { className: s[O1.MonthsDropdown], "aria-label": u1(), classNames: s, components: n, disabled: !!t.disableNavigation, onChange: ge(f1.date), options: S1, style: S?.[O1.Dropdown], value: i.getMonth(f1.date) }) : G.createElement("span", null, P(f1.date, i)),
              l === "dropdown" || l === "dropdown-years" ? G.createElement(n.YearsDropdown, { className: s[O1.YearsDropdown], "aria-label": q1(i.options), classNames: s, components: n, disabled: !!t.disableNavigation, onChange: ce(f1.date), options: J1, style: S?.[O1.Dropdown], value: i.getYear(f1.date) }) : G.createElement("span", null, B(f1.date, i)),
              G.createElement("span", { role: "status", "aria-live": "polite", style: {
                border: 0,
                clip: "rect(0 0 0 0)",
                height: "1px",
                margin: "-1px",
                overflow: "hidden",
                padding: 0,
                position: "absolute",
                width: "1px",
                whiteSpace: "nowrap",
                wordWrap: "normal"
              } }, k(f1.date, i.options, i))
            ) : G.createElement(n.CaptionLabel, { className: s[O1.CaptionLabel], role: "status", "aria-live": "polite" }, k(f1.date, i.options, i))),
            f === "around" && !t.hideNavigation && b1 === u - 1 && G.createElement(
              n.NextMonthButton,
              { type: "button", className: s[O1.NextMonthButton], tabIndex: $ ? void 0 : -1, "aria-disabled": $ ? void 0 : !0, "aria-label": C1($), onClick: me, "data-animated-button": t.animate ? "true" : void 0 },
              G.createElement(n.Chevron, { disabled: $ ? void 0 : !0, className: s[O1.Chevron], orientation: t.dir === "rtl" ? "left" : "right" })
            ),
            b1 === u - 1 && f === "after" && !t.hideNavigation && G.createElement(n.Nav, { "data-animated-nav": t.animate ? "true" : void 0, className: s[O1.Nav], style: S?.[O1.Nav], "aria-label": l1(), onPreviousClick: I1, onNextClick: me, previousMonth: U, nextMonth: $ }),
            G.createElement(
              n.MonthGrid,
              { role: "grid", "aria-multiselectable": c === "multiple" || c === "range", "aria-label": T(f1.date, i.options, i) || void 0, className: s[O1.MonthGrid], style: S?.[O1.MonthGrid] },
              !t.hideWeekdays && G.createElement(
                n.Weekdays,
                { "data-animated-weekdays": t.animate ? "true" : void 0, className: s[O1.Weekdays], style: S?.[O1.Weekdays] },
                M && G.createElement(n.WeekNumberHeader, { "aria-label": re(i.options), className: s[O1.WeekNumberHeader], style: S?.[O1.WeekNumberHeader], scope: "col" }, O()),
                w1.map((ee, X1) => G.createElement(n.Weekday, { "aria-label": g1(ee, i.options, i), className: s[O1.Weekday], key: X1, style: S?.[O1.Weekday], scope: "col" }, E(ee, i.options, i)))
              ),
              G.createElement(n.Weeks, { "data-animated-weeks": t.animate ? "true" : void 0, className: s[O1.Weeks], style: S?.[O1.Weeks] }, f1.weeks.map((ee, X1) => G.createElement(
                n.Week,
                { className: s[O1.Week], key: ee.weekNumber, style: S?.[O1.Week], week: ee },
                M && G.createElement(n.WeekNumber, { week: ee, style: S?.[O1.WeekNumber], "aria-label": D1(ee.weekNumber, {
                  locale: a
                }), className: s[O1.WeekNumber], scope: "row", role: "rowheader" }, I(ee.weekNumber, i)),
                ee.days.map((m1) => {
                  const { date: M1 } = m1, k1 = K(m1);
                  if (k1[Ke.focused] = !k1.hidden && !!X?.isEqualTo(m1), k1[ht.selected] = V?.(M1) || k1.selected, P7(o1)) {
                    const { from: Me, to: $e } = o1;
                    k1[ht.range_start] = !!(Me && $e && i.isSameDay(M1, Me)), k1[ht.range_end] = !!(Me && $e && i.isSameDay(M1, $e)), k1[ht.range_middle] = Xt(o1, M1, !0, i);
                  }
                  const ue = Ye1(k1, S, t.modifiersStyles), oe = le1(k1, s, t.modifiersClassNames), ie = !$1 && !k1.hidden ? t1(M1, k1, i.options, i) : void 0;
                  return G.createElement(n.Day, { key: `${i.format(M1, "yyyy-MM-dd")}_${i.format(m1.displayMonth, "yyyy-MM")}`, day: m1, modifiers: k1, className: oe.join(" "), style: ue, role: "gridcell", "aria-selected": k1.selected || void 0, "aria-label": ie, "data-day": i.format(M1, "yyyy-MM-dd"), "data-month": m1.outside ? i.format(M1, "yyyy-MM") : void 0, "data-selected": k1.selected || void 0, "data-disabled": k1.disabled || void 0, "data-hidden": k1.hidden || void 0, "data-outside": m1.outside || void 0, "data-focused": k1.focused || void 0, "data-today": k1.today || void 0 }, !k1.hidden && $1 ? G.createElement(n.DayButton, { className: s[O1.DayButton], style: S?.[O1.DayButton], type: "button", day: m1, modifiers: k1, disabled: k1.disabled || void 0, tabIndex: Y(m1) ? 0 : -1, "aria-label": j(M1, k1, i.options, i), onClick: Se(m1, k1), onBlur: Re(m1, k1), onFocus: fe(m1, k1), onKeyDown: se(m1, k1), onMouseEnter: le(m1, k1), onMouseLeave: G1(m1, k1) }, L(M1, i.options, i)) : !k1.hidden && L(m1.date, i.options, i));
                })
              )))
            )
          );
        })
      ),
      t.footer && G.createElement(n.Footer, { className: s[O1.Footer], style: S?.[O1.Footer], role: "status", "aria-live": "polite" }, t.footer)
    )
  );
}
function YL({
  className: e,
  classNames: t,
  showOutsideDays: n = !0,
  captionLayout: r = "label",
  formatters: o,
  components: i,
  ...a
}) {
  const s = A7();
  return /* @__PURE__ */ v(
    A21,
    {
      showOutsideDays: n,
      className: e1(
        "bg-background group/calendar p-3 [--cell-size:2rem] [[data-slot=card-content]_&]:bg-transparent [[data-slot=popover-content]_&]:bg-transparent",
        String.raw`rtl:**:[.rdp-button\_next>svg]:rotate-180`,
        String.raw`rtl:**:[.rdp-button\_previous>svg]:rotate-180`,
        e
      ),
      captionLayout: r,
      formatters: {
        formatMonthDropdown: (l) => l.toLocaleString("default", { month: "short" }),
        ...o
      },
      classNames: {
        root: e1("w-fit", s.root),
        months: e1(
          "relative flex flex-col gap-4 md:flex-row",
          s.months
        ),
        month: e1("flex w-full flex-col gap-4", s.month),
        nav: e1(
          "absolute inset-x-0 top-0 flex w-full items-center justify-between gap-1",
          s.nav
        ),
        button_previous: e1(
          "border border-base-input flex items-center justify-center text-zinc-500 shadow-sm hover:bg-accent hover:text-primary h-[--cell-size] w-[--cell-size] select-none p-0 aria-disabled:opacity-50 rounded-md",
          s.button_previous
        ),
        button_next: e1(
          "border border-base-input flex items-center justify-center text-zinc-500 shadow-sm hover:bg-accent hover:text-primary h-[--cell-size] w-[--cell-size] select-none p-0 aria-disabled:opacity-50 rounded-md",
          s.button_next
        ),
        month_caption: e1(
          "flex h-[--cell-size] w-full items-center justify-center px-[--cell-size]",
          s.month_caption
        ),
        dropdowns: e1(
          "flex h-[--cell-size] w-full items-center justify-center gap-1.5 text-sm font-medium",
          s.dropdowns
        ),
        dropdown_root: e1(
          "has-focus:border-ring border-input shadow-xs has-focus:ring-ring/50 has-focus:ring-[3px] relative rounded-md border",
          s.dropdown_root
        ),
        dropdown: e1("absolute inset-0 opacity-0", s.dropdown),
        caption_label: e1(
          "select-none font-medium",
          r === "label" ? "text-sm" : "[&>svg]:text-muted-foreground flex h-8 items-center gap-1 rounded-md pl-2 pr-1 text-sm [&>svg]:size-3.5",
          s.caption_label
        ),
        table: "w-full border-collapse",
        weekdays: e1("flex", s.weekdays),
        weekday: e1(
          "text-muted-foreground flex-1 select-none rounded-md text-[0.8rem] font-normal",
          s.weekday
        ),
        week: e1("mt-2 flex w-full", s.week),
        week_number_header: e1(
          "w-[--cell-size] select-none",
          s.week_number_header
        ),
        week_number: e1(
          "text-muted-foreground select-none text-[0.8rem]",
          s.week_number
        ),
        day: e1(
          "group/day relative aspect-square h-full w-full select-none p-0 text-center",
          s.day
        ),
        range_start: e1(
          "bg-accent rounded-l-md",
          s.range_start
        ),
        range_middle: e1("rounded-none", s.range_middle),
        range_end: e1("bg-accent rounded-r-md", s.range_end),
        today: e1(
          "bg-accent text-accent-foreground rounded-md data-[selected=true]:rounded-none",
          s.today
        ),
        outside: e1(
          "text-muted-foreground aria-selected:text-muted-foreground",
          s.outside
        ),
        disabled: e1(
          "text-muted-foreground opacity-50",
          s.disabled
        ),
        hidden: e1("invisible", s.hidden),
        ...t
      },
      components: {
        Root: ({ className: l, rootRef: c, ...f }) => /* @__PURE__ */ v(
          "div",
          {
            "data-slot": "calendar",
            ref: c,
            className: e1(l),
            ...f
          }
        ),
        Chevron: ({ className: l, orientation: c, ...f }) => c === "left" ? /* @__PURE__ */ v(
          qi,
          {
            className: e1("size-4", l),
            ...f
          }
        ) : c === "right" ? /* @__PURE__ */ v(
          qr,
          {
            className: e1("size-4", l),
            ...f
          }
        ) : /* @__PURE__ */ v(sn, { className: e1("size-4", l), ...f }),
        DayButton: I21,
        WeekNumber: ({ children: l, ...c }) => /* @__PURE__ */ v("td", { ...c, children: /* @__PURE__ */ v("div", { className: "flex size-[--cell-size] items-center justify-center text-center", children: l }) }),
        ...i
      },
      ...a
    }
  );
}
function I21({
  className: e,
  day: t,
  modifiers: n,
  ...r
}) {
  const o = A7(), i = d.useRef(null);
  return d.useEffect(() => {
    n.focused && i.current?.focus();
  }, [n.focused]), /* @__PURE__ */ v(
    dt,
    {
      ref: i,
      variant: "ghost",
      size: "icon",
      "data-day": t.date.toLocaleDateString(),
      "data-selected-single": n.selected && !n.range_start && !n.range_end && !n.range_middle,
      "data-range-start": n.range_start,
      "data-range-end": n.range_end,
      "data-range-middle": n.range_middle,
      className: e1(
        "data-[selected-single=true]:bg-primary data-[selected-single=true]:text-primary-foreground data-[range-middle=true]:bg-accent data-[range-middle=true]:text-accent-foreground data-[range-start=true]:bg-primary data-[range-start=true]:text-primary-foreground data-[range-end=true]:bg-primary data-[range-end=true]:text-primary-foreground group-data-[focused=true]/day:border-ring group-data-[focused=true]/day:ring-ring/50 flex aspect-square h-auto w-full min-w-[--cell-size] flex-col gap-1 font-normal leading-none data-[range-middle=true]:rounded-none data-[range-start=true]:rounded-md group-data-[focused=true]/day:relative group-data-[focused=true]/day:z-10 group-data-[focused=true]/day:ring-[3px] [&>span]:text-xs [&>span]:opacity-70 rounded-md p-0",
        o.day,
        e
      ),
      ...r
    }
  );
}
function O21({
  placeholder: e,
  selected: t,
  className: n,
  ...r
}) {
  return /* @__PURE__ */ s1(ta, { children: [
    /* @__PURE__ */ v(na, { asChild: !0, children: /* @__PURE__ */ s1(
      dt,
      {
        variant: "outline",
        className: e1(
          "justify-start text-left font-normal rounded-md",
          !t && "text-muted-foreground",
          n
        ),
        children: [
          /* @__PURE__ */ v(C5, {}),
          t ? rr(t, "PPP") : /* @__PURE__ */ v("span", { children: e })
        ]
      }
    ) }),
    /* @__PURE__ */ v(ra, { className: "w-auto p-0", children: /* @__PURE__ */ v(YL, { ...r, mode: "single", selected: t, autoFocus: !0 }) })
  ] });
}
O21.displayName = "LBDatePicker";
function N21({
  className: e,
  selected: t,
  placeholder: n,
  defaultMonth: r,
  children: o,
  "data-testid": i,
  "data-cy": a,
  ...s
}) {
  return /* @__PURE__ */ v("div", { className: e1("grid gap-2", e), children: /* @__PURE__ */ s1(ta, { children: [
    /* @__PURE__ */ v(na, { asChild: !0, children: /* @__PURE__ */ s1(
      dt,
      {
        "data-testid": i,
        "data-cy": a,
        variant: "outline",
        className: e1(
          "justify-start text-left font-normal rounded-md",
          !t && "text-muted-foreground",
          e
        ),
        children: [
          /* @__PURE__ */ v(C5, {}),
          t?.from ? t.to ? /* @__PURE__ */ s1(ze, { children: [
            rr(t.from, "LLL dd, y"),
            " -",
            " ",
            rr(t.to, "LLL dd, y")
          ] }) : rr(t.from, "LLL dd, y") : /* @__PURE__ */ v("span", { children: n })
        ]
      }
    ) }),
    /* @__PURE__ */ s1(ra, { className: "w-auto p-0", align: "start", children: [
      /* @__PURE__ */ v(
        YL,
        {
          autoFocus: !0,
          defaultMonth: t?.from ?? r,
          selected: t,
          numberOfMonths: 2,
          ...s,
          mode: "range"
        }
      ),
      o
    ] })
  ] }) });
}
N21.displayName = "LBDateRangePicker";
function D21() {
  return /* @__PURE__ */ s1("div", { className: "flex size-full items-end  justify-between", children: [
    /* @__PURE__ */ v(q2, { className: "h-28 w-4" }),
    /* @__PURE__ */ v(q2, { className: "h-32 w-4" }),
    /* @__PURE__ */ v(q2, { className: "h-36 w-4" }),
    /* @__PURE__ */ v(q2, { className: "h-12 w-4" }),
    /* @__PURE__ */ v(q2, { className: "h-8 w-4" }),
    /* @__PURE__ */ v(q2, { className: "h-14 w-4" }),
    /* @__PURE__ */ v(q2, { className: "h-28 w-4" }),
    /* @__PURE__ */ v(q2, { className: "h-20 w-4" }),
    /* @__PURE__ */ v(q2, { className: "h-28 w-4" })
  ] });
}
D21.displayName = "LBBarChartSkeleton";
const B21 = Z2("flex items-center rounded-full", {
  variants: {
    size: {
      default: "size-14",
      sm: "size-8",
      lg: "size-16"
    }
  },
  defaultVariants: {
    size: "default"
  }
});
function F21({
  size: e,
  className: t,
  ...n
}) {
  return /* @__PURE__ */ v(
    q2,
    {
      className: e1(B21({ size: e }), t),
      ...n
    }
  );
}
F21.displayName = "LBCircleSkeleton";
const $21 = Z2(
  "flex items-center rounded-full p-4",
  {
    variants: {
      size: {
        default: "size-36",
        sm: "size-20",
        lg: "size-52"
      }
    },
    defaultVariants: {
      size: "default"
    }
  }
);
function W21({
  size: e,
  ...t
}) {
  return /* @__PURE__ */ v(
    q2,
    {
      className: e1($21({ size: e })),
      ...t,
      children: /* @__PURE__ */ v("div", { className: "m-auto size-full rounded-full bg-background" })
    }
  );
}
W21.displayName = "LBDoughnutChartSkeleton";
function r31() {
  return /* @__PURE__ */ v("div", { className: "size-full animate-pulse", children: /* @__PURE__ */ s1(
    "svg",
    {
      width: "100%",
      height: "100%",
      viewBox: "0 0 512 142",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ v("g", { clipPath: "url(#clip0_23513_22363)", children: /* @__PURE__ */ v(
          "path",
          {
            d: "M0 37.2686C28.4856 81.292 75.1182 124.684 94.9919 124.684C122.153 124.684 156.583 24.6907 192.304 24.6904C232.879 24.6901 231.974 96.817 304.88 96.817C326.522 96.817 329.735 117.307 352.932 123.045C381.219 130.041 384.372 126.323 410.097 126.323C430.744 126.323 493.451 64.9963 512 41.0828",
            stroke: "#181818",
            strokeOpacity: "0.03",
            strokeWidth: "8",
            strokeLinecap: "round"
          }
        ) }),
        /* @__PURE__ */ v("defs", { children: /* @__PURE__ */ v("clipPath", { id: "clip0_23513_22363", children: /* @__PURE__ */ v("rect", { width: "512", height: "142", fill: "white" }) }) })
      ]
    }
  ) });
}
function V21({
  className: e
}) {
  return /* @__PURE__ */ v(q2, { className: e1("h-4 w-full", e) });
}
V21.displayName = "LBProgressBarChartSkeleton";
const H21 = x1(({ children: e, variant: t, ...n }, r) => /* @__PURE__ */ s1(
  jy,
  {
    ref: r,
    ...n,
    className: "relative flex cursor-default select-none items-center py-1 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-secondary focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
    style: void 0,
    children: [
      /* @__PURE__ */ v("span", { className: "absolute left-2 flex size-3 items-center justify-center", children: /* @__PURE__ */ v(v5, { children: /* @__PURE__ */ v(y5, { className: "size-2 fill-current" }) }) }),
      /* @__PURE__ */ v(Xw, { variant: t, children: e })
    ]
  }
));
H21.displayName = "LBJiraStatusPickerItem";
function j21({
  value: e,
  label: t,
  variant: n,
  onValueChange: r,
  children: o
}) {
  return /* @__PURE__ */ s1(zi, { children: [
    /* @__PURE__ */ s1(
      Ui,
      {
        className: e1(
          V5({ variant: n }),
          "group transition-all duration-300 hover:brightness-95"
        ),
        children: [
          t,
          /* @__PURE__ */ v(sn, { className: "duration-300 group-data-[state=open]:-rotate-180" })
        ]
      }
    ),
    /* @__PURE__ */ v(Gi, { align: "start", children: /* @__PURE__ */ v(Qy, { value: e, onValueChange: r, children: o }) })
  ] });
}
j21.displayName = "LBJiraStatusPicker";
const q21 = x1(({ className: e, children: t, variant: n, ...r }, o) => /* @__PURE__ */ s1(
  _5,
  {
    ref: o,
    className: e1(
      V5({ variant: n }),
      "relative hover:brightness-95 transition-all",
      e
    ),
    ...r,
    children: [
      /* @__PURE__ */ v(x5, { className: "absolute inset-x-0 -bottom-2 h-1 bg-slate-600" }),
      t
    ]
  }
));
q21.displayName = "LBJiraStatusCheckbox";
function z21(e) {
  return /* @__PURE__ */ v(
    "div",
    {
      className: "flex h-20 flex-col justify-center space-y-2 bg-white px-6 text-center sm:text-left",
      ...e
    }
  );
}
z21.displayName = "LBWizardHeader";
const U21 = x1(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ s1(O5, { children: [
  /* @__PURE__ */ v(D5, {}),
  /* @__PURE__ */ s1(
    un,
    {
      ref: r,
      ...n,
      className: e1(
        "justify-stretch flex flex-col bg-slate-100 fixed left-1/2 top-1/2 z-50 min-w-[797px] -translate-x-1/2 -translate-y-1/2 border shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%]",
        e
      ),
      style: void 0,
      children: [
        t,
        /* @__PURE__ */ s1(N5, { className: "absolute right-8 top-9 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground", children: [
          /* @__PURE__ */ v(ln, { className: "size-4" }),
          /* @__PURE__ */ v("span", { className: "sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }));
U21.displayName = "LBWizard";
const G21 = x1((e, t) => /* @__PURE__ */ v(
  sa,
  {
    ref: t,
    ...e,
    className: "text-xl font-medium leading-5 tracking-tight",
    style: void 0
  }
));
G21.displayName = "LBWizardTitle";
function Y21({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ v(
    "div",
    {
      ...t,
      className: e1(
        "size-full p-2 flex flex-row gap-4 justify-stretch",
        e
      ),
      style: void 0
    }
  );
}
Y21.displayName = "LBWizardContent";
function Z21({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ v(
    "aside",
    {
      ...t,
      className: e1("grow-0 p-4", e),
      style: void 0
    }
  );
}
Z21.displayName = "LBWizardSidebar";
function K21({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ v(
    "main",
    {
      ...t,
      className: e1(
        "p-6 grow-1 bg-white rounded-md border w-full min-h-[560px] overflow-auto",
        e
      ),
      style: void 0
    }
  );
}
K21.displayName = "LBWizardMain";
function o31({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ v(
    Rk,
    {
      ...t,
      className: e,
      groupMode: "stacked",
      layout: "horizontal",
      enableGridY: !1,
      axisTop: null,
      axisRight: null,
      axisBottom: null,
      axisLeft: null
    }
  );
}
function X21(e) {
  const {
    open: t,
    value: n,
    onChange: r,
    placeholder: o,
    options: i,
    className: a,
    searchPlaceholder: s,
    disabled: l,
    emptyMessage: c,
    popoverClassname: f,
    onSearch: u,
    isLoading: h,
    loadingMessage: p
  } = e, [g, m] = d2(t);
  function b(y) {
    y.key === "ArrowDown" && !g && (y.preventDefault(), m(!0));
  }
  return Te(() => {
    m(t);
  }, [t]), Te(() => {
    i.find((y) => y.value === n) || r?.(void 0);
  }, [i]), /* @__PURE__ */ s1(ta, { open: g, onOpenChange: m, children: [
    /* @__PURE__ */ s1(
      na,
      {
        disabled: l,
        onKeyDown: b,
        className: e1(
          "flex h-9 items-center justify-between whitespace-nowrap rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-ring disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1",
          a
        ),
        role: "combobox",
        children: [
          n ? i.find((y) => y.value === n)?.label : /* @__PURE__ */ v("span", { className: "text-muted-foreground", children: o }),
          /* @__PURE__ */ v(Yy, { className: "opacity-50" })
        ]
      }
    ),
    /* @__PURE__ */ v(
      ra,
      {
        className: e1("p-0", f),
        align: "start",
        role: "listbox",
        children: /* @__PURE__ */ s1(
          F5,
          {
            onChange: (y) => {
              u?.(y.target.value);
            },
            children: [
              /* @__PURE__ */ v(Bw, { placeholder: s, className: "h-9" }),
              /* @__PURE__ */ v(Fw, { children: h ? /* @__PURE__ */ v(Hw, { children: p }) : /* @__PURE__ */ s1(ze, { children: [
                /* @__PURE__ */ v($w, { children: c }),
                /* @__PURE__ */ v(Ww, { children: i.map((y) => /* @__PURE__ */ s1(
                  Vw,
                  {
                    className: "py-2",
                    value: y.label,
                    onSelect: () => {
                      r?.(y.value === n ? "" : y.value), m(!1);
                    },
                    children: [
                      y.label,
                      /* @__PURE__ */ v(
                        zr,
                        {
                          className: e1(
                            "ml-auto",
                            n === y.value ? "opacity-100" : "opacity-0"
                          )
                        }
                      )
                    ]
                  },
                  y.value
                )) })
              ] }) })
            ]
          }
        )
      }
    )
  ] });
}
X21.displayName = "LBCombobox";
const Uv = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 13 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { opacity: 0.7, fillRule: "evenodd", clipRule: "evenodd", d: "M0.5 23.9898C0.66582 23.9966 0.832509 24 0.999999 24C7.62742 24 13 18.6274 13 12C13 5.37258 7.62742 0 0.999999 0C0.832509 0 0.66582 0.0034314 0.5 0.0102277C6.89554 0.272356 12 5.54007 12 12C12 18.4599 6.89554 23.7276 0.5 23.9898Z", fill: "currentColor" })), Q21 = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 11 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M6.29248 0.493669C6.21974 0.345539 6.1069 0.220768 5.96683 0.13351C5.82677 0.0462528 5.66504 0 5.49999 0C5.33495 0 5.17322 0.0462528 5.03315 0.13351C4.89309 0.220768 4.78025 0.345539 4.70751 0.493669L0.0762716 9.92834C0.0205237 10.0418 -0.00540404 10.1675 0.000936839 10.2937C0.00727772 10.4199 0.0456779 10.5424 0.112511 10.6497C0.179344 10.7569 0.272409 10.8454 0.382917 10.9067C0.493421 10.968 0.617725 11.0001 0.744093 11H10.2559C10.3823 11.0001 10.5066 10.968 10.6171 10.9067C10.7276 10.8454 10.8207 10.7569 10.8875 10.6497C10.9543 10.5424 10.9927 10.4199 10.9991 10.2937C11.0054 10.1675 10.9795 10.0418 10.9237 9.92834L6.29248 0.493669Z", fill: "#F59E0B" }), /* @__PURE__ */ d.createElement("path", { d: "M5.5 7.5V3", stroke: "white", strokeMiterlimit: 10, strokeLinecap: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M5 9.5C5 9.26746 5.22386 9 5.5 9C5.77614 9 6 9.26746 6 9.5C6 9.73254 5.77614 10 5.5 10C5.22386 10 5 9.73254 5 9.5Z", fill: "white" })), J21 = x1(
  ({
    avatarUrl: e,
    className: t,
    initials: n,
    disabled: r,
    github: o,
    warning: i,
    group: a,
    color: s,
    hideRipples: l,
    ...c
  }, f) => /* @__PURE__ */ s1(
    "div",
    {
      ref: f,
      className: e1("relative inline-block size-fit [&_svg.ripple]:h-6", {
        "grayscale opacity-50": r
      }),
      style: { "--lb-portrait-color": s },
      children: [
        /* @__PURE__ */ s1(
          o_,
          {
            className: e1(
              "size-6 text-white bg-[var(--lb-portrait-color)]",
              {
                "border border-[var(--lb-portrait-color)] bg-white text-[var(--lb-portrait-color)]": a,
                "border-slate-600 text-slate-600": !s && a
              },
              t
            ),
            ...c,
            children: [
              /* @__PURE__ */ v(
                i_,
                {
                  src: e,
                  className: e1({ "grayscale opacity-75": r })
                }
              ),
              /* @__PURE__ */ v(a_, { className: "bg-inherit text-[8px] font-semibold text-inherit", children: n })
            ]
          }
        ),
        a && !l && /* @__PURE__ */ s1(ze, { children: [
          /* @__PURE__ */ v(
            Uv,
            {
              className: e1(
                "ripple absolute -right-0.75 top-0 text-[var(--lb-portrait-color)] opacity-75",
                { "text-slate-600": !s }
              )
            }
          ),
          /* @__PURE__ */ v(
            Uv,
            {
              className: e1(
                "ripple absolute right-[-4.5px] top-0 text-[var(--lb-portrait-color)] opacity-40",
                { "text-slate-600": !s }
              )
            }
          )
        ] }),
        o && /* @__PURE__ */ v(aE, { className: "absolute bottom-[-2px] right-[-2px] size-[10px] rounded-full bg-white ring-white" }),
        i && /* @__PURE__ */ v(Q21, { className: "absolute bottom-[-2px] right-[-2px] size-[11px]" })
      ]
    }
  )
);
J21.displayName = "LBPortrait";
const et1 = [
  "#3B48B3",
  "#5467FF",
  "#8795FF",
  "#B36A00",
  "#FF9800",
  "#FFB74C",
  "#0276AB",
  "#03A9F4",
  "#4FC3F7",
  "#B30000",
  "#F61C3B",
  "#F96076",
  "#008114",
  "#00B81D",
  "#4CCD61",
  "#6A6538",
  "#979050",
  "#B6B184",
  "#798B0D",
  "#ADC613",
  "#C6D75A",
  "#669BB2",
  "#5BCEFF",
  "#8CDDFF",
  "#786AB2",
  "#AC98FF",
  "#C5B7FF",
  "#8B11A9",
  "#C618F1",
  "#D75DF5",
  "#A9687F",
  "#F294B6",
  "#F6B4CC",
  "#B25132",
  "#FF7448",
  "#FF9E7F"
];
function Gv({
  color: e = "transparent",
  ...t
}) {
  return /* @__PURE__ */ v(
    "div",
    {
      className: "size-6 cursor-pointer rounded-full bg-[var(--lb-swatch-color)]",
      style: { "--lb-swatch-color": e },
      ...t
    }
  );
}
const ZL = x1(({ children: e, position: t = "popper", flex: n, ...r }, o) => /* @__PURE__ */ v(qC, { children: /* @__PURE__ */ v(
  zC,
  {
    ref: o,
    position: t,
    className: "relative z-50 mt-1 w-fit rounded-md border bg-popover text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
    ...r,
    children: /* @__PURE__ */ v(
      UC,
      {
        className: e1("grid grid-cols-12 gap-2 p-2", { flex: n }),
        children: e
      }
    )
  }
) }));
ZL.displayName = "LBColorPickerContent";
const KL = x1(({ children: e, ...t }, n) => /* @__PURE__ */ v(
  GC,
  {
    className: 'rounded-full data-[state="checked"]:ring-1 data-[state="checked"]:ring-ring',
    ref: n,
    ...t,
    children: /* @__PURE__ */ v(YC, { children: e })
  }
));
KL.displayName = "LBColorPickerItem";
function i31({
  value: e,
  onValueChange: t,
  className: n,
  palette: r = et1
}) {
  return /* @__PURE__ */ s1(M5, { value: e, onValueChange: t, children: [
    /* @__PURE__ */ v(L5, { className: n, children: /* @__PURE__ */ s1(k5, { children: [
      /* @__PURE__ */ v("span", { className: "sr-only", children: e }),
      /* @__PURE__ */ v(Gv, { color: e })
    ] }) }),
    /* @__PURE__ */ v(ZL, { align: "start", flex: r.length < 12, children: r.map((o) => /* @__PURE__ */ s1(KL, { value: o, children: [
      /* @__PURE__ */ v(Gv, { color: o }),
      /* @__PURE__ */ v("span", { className: "sr-only", children: o })
    ] }, o)) })
  ] });
}
const tt1 = Z2(
  "mt-2 flex w-full flex-col items-start border-t-2",
  {
    variants: {
      variant: {
        elite: "border-benchmark-elite",
        good: "border-benchmark-good",
        fair: "border-benchmark-fair",
        poor: "border-benchmark-poor",
        "n/a": "border-benchmark-n/a"
      }
    },
    defaultVariants: {
      variant: "n/a"
    }
  }
), nt1 = d.forwardRef(({ colorVariant: e, duration: t }, n) => /* @__PURE__ */ s1("div", { ref: n, className: "flex w-20 flex-col items-start", children: [
  /* @__PURE__ */ v("div", { className: "pl-1 text-sm", "data-testid": "cycle-time-stage-text", children: t }),
  /* @__PURE__ */ v(
    "div",
    {
      className: e1(tt1({ variant: e })),
      "data-testid": "cycle-time-stage-line"
    }
  )
] }));
nt1.displayName = "LBCycleTimeStage";
function a31({
  className: e,
  direction: t,
  data: n,
  activeKeys: r,
  onClick: o,
  allKeys: i,
  setActiveKeys: a,
  setHoveredLegendKey: s
}) {
  function l(c) {
    a((f) => {
      const h = f.includes(c) ? f.filter((p) => p !== c) : [...f, c];
      return h.length === 0 || h.length === i.length ? [] : h;
    });
  }
  return /* @__PURE__ */ v(
    RJ,
    {
      className: e,
      direction: t,
      data: n,
      onClick: (c) => {
        l(c), o && o(c);
      },
      activeKeys: r,
      setHoveredLegendKey: s
    }
  );
}
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function b0(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Y2(e, t) {
  return (n) => {
    t.setState((r) => ({
      ...r,
      [e]: b0(n, r[e])
    }));
  };
}
function Is(e) {
  return e instanceof Function;
}
function rt1(e) {
  return Array.isArray(e) && e.every((t) => typeof t == "number");
}
function ot1(e, t) {
  const n = [], r = (o) => {
    o.forEach((i) => {
      n.push(i);
      const a = t(i);
      a != null && a.length && r(a);
    });
  };
  return r(e), n;
}
function W1(e, t, n) {
  let r = [], o;
  return (i) => {
    let a;
    n.key && n.debug && (a = Date.now());
    const s = e(i);
    if (!(s.length !== r.length || s.some((f, u) => r[u] !== f)))
      return o;
    r = s;
    let c;
    if (n.key && n.debug && (c = Date.now()), o = t(...s), n == null || n.onChange == null || n.onChange(o), n.key && n.debug && n != null && n.debug()) {
      const f = Math.round((Date.now() - a) * 100) / 100, u = Math.round((Date.now() - c) * 100) / 100, h = u / 16, p = (g, m) => {
        for (g = String(g); g.length < m; )
          g = " " + g;
        return g;
      };
      console.info(`%c⏱ ${p(u, 5)} /${p(f, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * h, 120))}deg 100% 31%);`, n?.key);
    }
    return o;
  };
}
function V1(e, t, n, r) {
  return {
    debug: () => {
      var o;
      return (o = e?.debugAll) != null ? o : e[t];
    },
    key: process.env.NODE_ENV === "development" && n,
    onChange: r
  };
}
function it1(e, t, n, r) {
  const o = () => {
    var a;
    return (a = i.getValue()) != null ? a : e.options.renderFallbackValue;
  }, i = {
    id: `${t.id}_${n.id}`,
    row: t,
    column: n,
    getValue: () => t.getValue(r),
    renderValue: o,
    getContext: W1(() => [e, n, t, i], (a, s, l, c) => ({
      table: a,
      column: s,
      row: l,
      cell: c,
      getValue: c.getValue,
      renderValue: c.renderValue
    }), V1(e.options, "debugCells", "cell.getContext"))
  };
  return e._features.forEach((a) => {
    a.createCell == null || a.createCell(i, n, t, e);
  }, {}), i;
}
function at1(e, t, n, r) {
  var o, i;
  const s = {
    ...e._getDefaultColumnDef(),
    ...t
  }, l = s.accessorKey;
  let c = (o = (i = s.id) != null ? i : l ? typeof String.prototype.replaceAll == "function" ? l.replaceAll(".", "_") : l.replace(/\./g, "_") : void 0) != null ? o : typeof s.header == "string" ? s.header : void 0, f;
  if (s.accessorFn ? f = s.accessorFn : l && (l.includes(".") ? f = (h) => {
    let p = h;
    for (const m of l.split(".")) {
      var g;
      p = (g = p) == null ? void 0 : g[m], process.env.NODE_ENV !== "production" && p === void 0 && console.warn(`"${m}" in deeply nested key "${l}" returned undefined.`);
    }
    return p;
  } : f = (h) => h[s.accessorKey]), !c)
    throw process.env.NODE_ENV !== "production" ? new Error(s.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let u = {
    id: `${String(c)}`,
    accessorFn: f,
    parent: r,
    depth: n,
    columnDef: s,
    columns: [],
    getFlatColumns: W1(() => [!0], () => {
      var h;
      return [u, ...(h = u.columns) == null ? void 0 : h.flatMap((p) => p.getFlatColumns())];
    }, V1(e.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: W1(() => [e._getOrderColumnsFn()], (h) => {
      var p;
      if ((p = u.columns) != null && p.length) {
        let g = u.columns.flatMap((m) => m.getLeafColumns());
        return h(g);
      }
      return [u];
    }, V1(e.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const h of e._features)
    h.createColumn == null || h.createColumn(u, e);
  return u;
}
const S2 = "debugHeaders";
function Yv(e, t, n) {
  var r;
  let i = {
    id: (r = n.id) != null ? r : t.id,
    column: t,
    index: n.index,
    isPlaceholder: !!n.isPlaceholder,
    placeholderId: n.placeholderId,
    depth: n.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const a = [], s = (l) => {
        l.subHeaders && l.subHeaders.length && l.subHeaders.map(s), a.push(l);
      };
      return s(i), a;
    },
    getContext: () => ({
      table: e,
      header: i,
      column: t
    })
  };
  return e._features.forEach((a) => {
    a.createHeader == null || a.createHeader(i, e);
  }), i;
}
const st1 = {
  createTable: (e) => {
    e.getHeaderGroups = W1(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r, o) => {
      var i, a;
      const s = (i = r?.map((u) => n.find((h) => h.id === u)).filter(Boolean)) != null ? i : [], l = (a = o?.map((u) => n.find((h) => h.id === u)).filter(Boolean)) != null ? a : [], c = n.filter((u) => !(r != null && r.includes(u.id)) && !(o != null && o.includes(u.id)));
      return Bo(t, [...s, ...c, ...l], e);
    }, V1(e.options, S2, "getHeaderGroups")), e.getCenterHeaderGroups = W1(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r, o) => (n = n.filter((i) => !(r != null && r.includes(i.id)) && !(o != null && o.includes(i.id))), Bo(t, n, e, "center")), V1(e.options, S2, "getCenterHeaderGroups")), e.getLeftHeaderGroups = W1(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left], (t, n, r) => {
      var o;
      const i = (o = r?.map((a) => n.find((s) => s.id === a)).filter(Boolean)) != null ? o : [];
      return Bo(t, i, e, "left");
    }, V1(e.options, S2, "getLeftHeaderGroups")), e.getRightHeaderGroups = W1(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.right], (t, n, r) => {
      var o;
      const i = (o = r?.map((a) => n.find((s) => s.id === a)).filter(Boolean)) != null ? o : [];
      return Bo(t, i, e, "right");
    }, V1(e.options, S2, "getRightHeaderGroups")), e.getFooterGroups = W1(() => [e.getHeaderGroups()], (t) => [...t].reverse(), V1(e.options, S2, "getFooterGroups")), e.getLeftFooterGroups = W1(() => [e.getLeftHeaderGroups()], (t) => [...t].reverse(), V1(e.options, S2, "getLeftFooterGroups")), e.getCenterFooterGroups = W1(() => [e.getCenterHeaderGroups()], (t) => [...t].reverse(), V1(e.options, S2, "getCenterFooterGroups")), e.getRightFooterGroups = W1(() => [e.getRightHeaderGroups()], (t) => [...t].reverse(), V1(e.options, S2, "getRightFooterGroups")), e.getFlatHeaders = W1(() => [e.getHeaderGroups()], (t) => t.map((n) => n.headers).flat(), V1(e.options, S2, "getFlatHeaders")), e.getLeftFlatHeaders = W1(() => [e.getLeftHeaderGroups()], (t) => t.map((n) => n.headers).flat(), V1(e.options, S2, "getLeftFlatHeaders")), e.getCenterFlatHeaders = W1(() => [e.getCenterHeaderGroups()], (t) => t.map((n) => n.headers).flat(), V1(e.options, S2, "getCenterFlatHeaders")), e.getRightFlatHeaders = W1(() => [e.getRightHeaderGroups()], (t) => t.map((n) => n.headers).flat(), V1(e.options, S2, "getRightFlatHeaders")), e.getCenterLeafHeaders = W1(() => [e.getCenterFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), V1(e.options, S2, "getCenterLeafHeaders")), e.getLeftLeafHeaders = W1(() => [e.getLeftFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), V1(e.options, S2, "getLeftLeafHeaders")), e.getRightLeafHeaders = W1(() => [e.getRightFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), V1(e.options, S2, "getRightLeafHeaders")), e.getLeafHeaders = W1(() => [e.getLeftHeaderGroups(), e.getCenterHeaderGroups(), e.getRightHeaderGroups()], (t, n, r) => {
      var o, i, a, s, l, c;
      return [...(o = (i = t[0]) == null ? void 0 : i.headers) != null ? o : [], ...(a = (s = n[0]) == null ? void 0 : s.headers) != null ? a : [], ...(l = (c = r[0]) == null ? void 0 : c.headers) != null ? l : []].map((f) => f.getLeafHeaders()).flat();
    }, V1(e.options, S2, "getLeafHeaders"));
  }
};
function Bo(e, t, n, r) {
  var o, i;
  let a = 0;
  const s = function(h, p) {
    p === void 0 && (p = 1), a = Math.max(a, p), h.filter((g) => g.getIsVisible()).forEach((g) => {
      var m;
      (m = g.columns) != null && m.length && s(g.columns, p + 1);
    }, 0);
  };
  s(e);
  let l = [];
  const c = (h, p) => {
    const g = {
      depth: p,
      id: [r, `${p}`].filter(Boolean).join("_"),
      headers: []
    }, m = [];
    h.forEach((b) => {
      const y = [...m].reverse()[0], C = b.column.depth === g.depth;
      let _, M = !1;
      if (C && b.column.parent ? _ = b.column.parent : (_ = b.column, M = !0), y && y?.column === _)
        y.subHeaders.push(b);
      else {
        const S = Yv(n, _, {
          id: [r, p, _.id, b?.id].filter(Boolean).join("_"),
          isPlaceholder: M,
          placeholderId: M ? `${m.filter((k) => k.column === _).length}` : void 0,
          depth: p,
          index: m.length
        });
        S.subHeaders.push(b), m.push(S);
      }
      g.headers.push(b), b.headerGroup = g;
    }), l.push(g), p > 0 && c(m, p - 1);
  }, f = t.map((h, p) => Yv(n, h, {
    depth: a,
    index: p
  }));
  c(f, a - 1), l.reverse();
  const u = (h) => h.filter((g) => g.column.getIsVisible()).map((g) => {
    let m = 0, b = 0, y = [0];
    g.subHeaders && g.subHeaders.length ? (y = [], u(g.subHeaders).forEach((_) => {
      let {
        colSpan: M,
        rowSpan: S
      } = _;
      m += M, y.push(S);
    })) : m = 1;
    const C = Math.min(...y);
    return b = b + C, g.colSpan = m, g.rowSpan = b, {
      colSpan: m,
      rowSpan: b
    };
  });
  return u((o = (i = l[0]) == null ? void 0 : i.headers) != null ? o : []), l;
}
const lt1 = (e, t, n, r, o, i, a) => {
  let s = {
    id: t,
    index: r,
    original: n,
    depth: o,
    parentId: a,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (l) => {
      if (s._valuesCache.hasOwnProperty(l))
        return s._valuesCache[l];
      const c = e.getColumn(l);
      if (c != null && c.accessorFn)
        return s._valuesCache[l] = c.accessorFn(s.original, r), s._valuesCache[l];
    },
    getUniqueValues: (l) => {
      if (s._uniqueValuesCache.hasOwnProperty(l))
        return s._uniqueValuesCache[l];
      const c = e.getColumn(l);
      if (c != null && c.accessorFn)
        return c.columnDef.getUniqueValues ? (s._uniqueValuesCache[l] = c.columnDef.getUniqueValues(s.original, r), s._uniqueValuesCache[l]) : (s._uniqueValuesCache[l] = [s.getValue(l)], s._uniqueValuesCache[l]);
    },
    renderValue: (l) => {
      var c;
      return (c = s.getValue(l)) != null ? c : e.options.renderFallbackValue;
    },
    subRows: [],
    getLeafRows: () => ot1(s.subRows, (l) => l.subRows),
    getParentRow: () => s.parentId ? e.getRow(s.parentId, !0) : void 0,
    getParentRows: () => {
      let l = [], c = s;
      for (; ; ) {
        const f = c.getParentRow();
        if (!f) break;
        l.push(f), c = f;
      }
      return l.reverse();
    },
    getAllCells: W1(() => [e.getAllLeafColumns()], (l) => l.map((c) => it1(e, s, c, c.id)), V1(e.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: W1(() => [s.getAllCells()], (l) => l.reduce((c, f) => (c[f.column.id] = f, c), {}), V1(e.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let l = 0; l < e._features.length; l++) {
    const c = e._features[l];
    c == null || c.createRow == null || c.createRow(s, e);
  }
  return s;
}, ct1 = {
  createColumn: (e, t) => {
    e._getFacetedRowModel = t.options.getFacetedRowModel && t.options.getFacetedRowModel(t, e.id), e.getFacetedRowModel = () => e._getFacetedRowModel ? e._getFacetedRowModel() : t.getPreFilteredRowModel(), e._getFacetedUniqueValues = t.options.getFacetedUniqueValues && t.options.getFacetedUniqueValues(t, e.id), e.getFacetedUniqueValues = () => e._getFacetedUniqueValues ? e._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getFacetedMinMaxValues = t.options.getFacetedMinMaxValues && t.options.getFacetedMinMaxValues(t, e.id), e.getFacetedMinMaxValues = () => {
      if (e._getFacetedMinMaxValues)
        return e._getFacetedMinMaxValues();
    };
  }
}, XL = (e, t, n) => {
  var r, o;
  const i = n == null || (r = n.toString()) == null ? void 0 : r.toLowerCase();
  return !!(!((o = e.getValue(t)) == null || (o = o.toString()) == null || (o = o.toLowerCase()) == null) && o.includes(i));
};
XL.autoRemove = (e) => pt(e);
const QL = (e, t, n) => {
  var r;
  return !!(!((r = e.getValue(t)) == null || (r = r.toString()) == null) && r.includes(n));
};
QL.autoRemove = (e) => pt(e);
const JL = (e, t, n) => {
  var r;
  return ((r = e.getValue(t)) == null || (r = r.toString()) == null ? void 0 : r.toLowerCase()) === n?.toLowerCase();
};
JL.autoRemove = (e) => pt(e);
const eE = (e, t, n) => {
  var r;
  return (r = e.getValue(t)) == null ? void 0 : r.includes(n);
};
eE.autoRemove = (e) => pt(e);
const tE = (e, t, n) => !n.some((r) => {
  var o;
  return !((o = e.getValue(t)) != null && o.includes(r));
});
tE.autoRemove = (e) => pt(e) || !(e != null && e.length);
const nE = (e, t, n) => n.some((r) => {
  var o;
  return (o = e.getValue(t)) == null ? void 0 : o.includes(r);
});
nE.autoRemove = (e) => pt(e) || !(e != null && e.length);
const rE = (e, t, n) => e.getValue(t) === n;
rE.autoRemove = (e) => pt(e);
const oE = (e, t, n) => e.getValue(t) == n;
oE.autoRemove = (e) => pt(e);
const I7 = (e, t, n) => {
  let [r, o] = n;
  const i = e.getValue(t);
  return i >= r && i <= o;
};
I7.resolveFilterValue = (e) => {
  let [t, n] = e, r = typeof t != "number" ? parseFloat(t) : t, o = typeof n != "number" ? parseFloat(n) : n, i = t === null || Number.isNaN(r) ? -1 / 0 : r, a = n === null || Number.isNaN(o) ? 1 / 0 : o;
  if (i > a) {
    const s = i;
    i = a, a = s;
  }
  return [i, a];
};
I7.autoRemove = (e) => pt(e) || pt(e[0]) && pt(e[1]);
const Yt = {
  includesString: XL,
  includesStringSensitive: QL,
  equalsString: JL,
  arrIncludes: eE,
  arrIncludesAll: tE,
  arrIncludesSome: nE,
  equals: rE,
  weakEquals: oE,
  inNumberRange: I7
};
function pt(e) {
  return e == null || e === "";
}
const ut1 = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (e) => ({
    columnFilters: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnFiltersChange: Y2("columnFilters", e),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (e, t) => {
    e.getAutoFilterFn = () => {
      const n = t.getCoreRowModel().flatRows[0], r = n?.getValue(e.id);
      return typeof r == "string" ? Yt.includesString : typeof r == "number" ? Yt.inNumberRange : typeof r == "boolean" || r !== null && typeof r == "object" ? Yt.equals : Array.isArray(r) ? Yt.arrIncludes : Yt.weakEquals;
    }, e.getFilterFn = () => {
      var n, r;
      return Is(e.columnDef.filterFn) ? e.columnDef.filterFn : e.columnDef.filterFn === "auto" ? e.getAutoFilterFn() : (
        // @ts-ignore
        (n = (r = t.options.filterFns) == null ? void 0 : r[e.columnDef.filterFn]) != null ? n : Yt[e.columnDef.filterFn]
      );
    }, e.getCanFilter = () => {
      var n, r, o;
      return ((n = e.columnDef.enableColumnFilter) != null ? n : !0) && ((r = t.options.enableColumnFilters) != null ? r : !0) && ((o = t.options.enableFilters) != null ? o : !0) && !!e.accessorFn;
    }, e.getIsFiltered = () => e.getFilterIndex() > -1, e.getFilterValue = () => {
      var n;
      return (n = t.getState().columnFilters) == null || (n = n.find((r) => r.id === e.id)) == null ? void 0 : n.value;
    }, e.getFilterIndex = () => {
      var n, r;
      return (n = (r = t.getState().columnFilters) == null ? void 0 : r.findIndex((o) => o.id === e.id)) != null ? n : -1;
    }, e.setFilterValue = (n) => {
      t.setColumnFilters((r) => {
        const o = e.getFilterFn(), i = r?.find((f) => f.id === e.id), a = b0(n, i ? i.value : void 0);
        if (Zv(o, a, e)) {
          var s;
          return (s = r?.filter((f) => f.id !== e.id)) != null ? s : [];
        }
        const l = {
          id: e.id,
          value: a
        };
        if (i) {
          var c;
          return (c = r?.map((f) => f.id === e.id ? l : f)) != null ? c : [];
        }
        return r != null && r.length ? [...r, l] : [l];
      });
    };
  },
  createRow: (e, t) => {
    e.columnFilters = {}, e.columnFiltersMeta = {};
  },
  createTable: (e) => {
    e.setColumnFilters = (t) => {
      const n = e.getAllLeafColumns(), r = (o) => {
        var i;
        return (i = b0(t, o)) == null ? void 0 : i.filter((a) => {
          const s = n.find((l) => l.id === a.id);
          if (s) {
            const l = s.getFilterFn();
            if (Zv(l, a.value, s))
              return !1;
          }
          return !0;
        });
      };
      e.options.onColumnFiltersChange == null || e.options.onColumnFiltersChange(r);
    }, e.resetColumnFilters = (t) => {
      var n, r;
      e.setColumnFilters(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.columnFilters) != null ? n : []);
    }, e.getPreFilteredRowModel = () => e.getCoreRowModel(), e.getFilteredRowModel = () => (!e._getFilteredRowModel && e.options.getFilteredRowModel && (e._getFilteredRowModel = e.options.getFilteredRowModel(e)), e.options.manualFiltering || !e._getFilteredRowModel ? e.getPreFilteredRowModel() : e._getFilteredRowModel());
  }
};
function Zv(e, t, n) {
  return (e && e.autoRemove ? e.autoRemove(t, n) : !1) || typeof t > "u" || typeof t == "string" && !t;
}
const dt1 = (e, t, n) => n.reduce((r, o) => {
  const i = o.getValue(e);
  return r + (typeof i == "number" ? i : 0);
}, 0), ft1 = (e, t, n) => {
  let r;
  return n.forEach((o) => {
    const i = o.getValue(e);
    i != null && (r > i || r === void 0 && i >= i) && (r = i);
  }), r;
}, ht1 = (e, t, n) => {
  let r;
  return n.forEach((o) => {
    const i = o.getValue(e);
    i != null && (r < i || r === void 0 && i >= i) && (r = i);
  }), r;
}, pt1 = (e, t, n) => {
  let r, o;
  return n.forEach((i) => {
    const a = i.getValue(e);
    a != null && (r === void 0 ? a >= a && (r = o = a) : (r > a && (r = a), o < a && (o = a)));
  }), [r, o];
}, mt1 = (e, t) => {
  let n = 0, r = 0;
  if (t.forEach((o) => {
    let i = o.getValue(e);
    i != null && (i = +i) >= i && (++n, r += i);
  }), n) return r / n;
}, gt1 = (e, t) => {
  if (!t.length)
    return;
  const n = t.map((i) => i.getValue(e));
  if (!rt1(n))
    return;
  if (n.length === 1)
    return n[0];
  const r = Math.floor(n.length / 2), o = n.sort((i, a) => i - a);
  return n.length % 2 !== 0 ? o[r] : (o[r - 1] + o[r]) / 2;
}, vt1 = (e, t) => Array.from(new Set(t.map((n) => n.getValue(e))).values()), bt1 = (e, t) => new Set(t.map((n) => n.getValue(e))).size, yt1 = (e, t) => t.length, E6 = {
  sum: dt1,
  min: ft1,
  max: ht1,
  extent: pt1,
  mean: mt1,
  median: gt1,
  unique: vt1,
  uniqueCount: bt1,
  count: yt1
}, Ct1 = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (e) => {
      var t, n;
      return (t = (n = e.getValue()) == null || n.toString == null ? void 0 : n.toString()) != null ? t : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (e) => ({
    grouping: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGroupingChange: Y2("grouping", e),
    groupedColumnMode: "reorder"
  }),
  createColumn: (e, t) => {
    e.toggleGrouping = () => {
      t.setGrouping((n) => n != null && n.includes(e.id) ? n.filter((r) => r !== e.id) : [...n ?? [], e.id]);
    }, e.getCanGroup = () => {
      var n, r;
      return ((n = e.columnDef.enableGrouping) != null ? n : !0) && ((r = t.options.enableGrouping) != null ? r : !0) && (!!e.accessorFn || !!e.columnDef.getGroupingValue);
    }, e.getIsGrouped = () => {
      var n;
      return (n = t.getState().grouping) == null ? void 0 : n.includes(e.id);
    }, e.getGroupedIndex = () => {
      var n;
      return (n = t.getState().grouping) == null ? void 0 : n.indexOf(e.id);
    }, e.getToggleGroupingHandler = () => {
      const n = e.getCanGroup();
      return () => {
        n && e.toggleGrouping();
      };
    }, e.getAutoAggregationFn = () => {
      const n = t.getCoreRowModel().flatRows[0], r = n?.getValue(e.id);
      if (typeof r == "number")
        return E6.sum;
      if (Object.prototype.toString.call(r) === "[object Date]")
        return E6.extent;
    }, e.getAggregationFn = () => {
      var n, r;
      if (!e)
        throw new Error();
      return Is(e.columnDef.aggregationFn) ? e.columnDef.aggregationFn : e.columnDef.aggregationFn === "auto" ? e.getAutoAggregationFn() : (n = (r = t.options.aggregationFns) == null ? void 0 : r[e.columnDef.aggregationFn]) != null ? n : E6[e.columnDef.aggregationFn];
    };
  },
  createTable: (e) => {
    e.setGrouping = (t) => e.options.onGroupingChange == null ? void 0 : e.options.onGroupingChange(t), e.resetGrouping = (t) => {
      var n, r;
      e.setGrouping(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.grouping) != null ? n : []);
    }, e.getPreGroupedRowModel = () => e.getFilteredRowModel(), e.getGroupedRowModel = () => (!e._getGroupedRowModel && e.options.getGroupedRowModel && (e._getGroupedRowModel = e.options.getGroupedRowModel(e)), e.options.manualGrouping || !e._getGroupedRowModel ? e.getPreGroupedRowModel() : e._getGroupedRowModel());
  },
  createRow: (e, t) => {
    e.getIsGrouped = () => !!e.groupingColumnId, e.getGroupingValue = (n) => {
      if (e._groupingValuesCache.hasOwnProperty(n))
        return e._groupingValuesCache[n];
      const r = t.getColumn(n);
      return r != null && r.columnDef.getGroupingValue ? (e._groupingValuesCache[n] = r.columnDef.getGroupingValue(e.original), e._groupingValuesCache[n]) : e.getValue(n);
    }, e._groupingValuesCache = {};
  },
  createCell: (e, t, n, r) => {
    e.getIsGrouped = () => t.getIsGrouped() && t.id === n.groupingColumnId, e.getIsPlaceholder = () => !e.getIsGrouped() && t.getIsGrouped(), e.getIsAggregated = () => {
      var o;
      return !e.getIsGrouped() && !e.getIsPlaceholder() && !!((o = n.subRows) != null && o.length);
    };
  }
};
function wt1(e, t, n) {
  if (!(t != null && t.length) || !n)
    return e;
  const r = e.filter((i) => !t.includes(i.id));
  return n === "remove" ? r : [...t.map((i) => e.find((a) => a.id === i)).filter(Boolean), ...r];
}
const _t1 = {
  getInitialState: (e) => ({
    columnOrder: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnOrderChange: Y2("columnOrder", e)
  }),
  createColumn: (e, t) => {
    e.getIndex = W1((n) => [ir(t, n)], (n) => n.findIndex((r) => r.id === e.id), V1(t.options, "debugColumns", "getIndex")), e.getIsFirstColumn = (n) => {
      var r;
      return ((r = ir(t, n)[0]) == null ? void 0 : r.id) === e.id;
    }, e.getIsLastColumn = (n) => {
      var r;
      const o = ir(t, n);
      return ((r = o[o.length - 1]) == null ? void 0 : r.id) === e.id;
    };
  },
  createTable: (e) => {
    e.setColumnOrder = (t) => e.options.onColumnOrderChange == null ? void 0 : e.options.onColumnOrderChange(t), e.resetColumnOrder = (t) => {
      var n;
      e.setColumnOrder(t ? [] : (n = e.initialState.columnOrder) != null ? n : []);
    }, e._getOrderColumnsFn = W1(() => [e.getState().columnOrder, e.getState().grouping, e.options.groupedColumnMode], (t, n, r) => (o) => {
      let i = [];
      if (!(t != null && t.length))
        i = o;
      else {
        const a = [...t], s = [...o];
        for (; s.length && a.length; ) {
          const l = a.shift(), c = s.findIndex((f) => f.id === l);
          c > -1 && i.push(s.splice(c, 1)[0]);
        }
        i = [...i, ...s];
      }
      return wt1(i, n, r);
    }, V1(e.options, "debugTable", "_getOrderColumnsFn"));
  }
}, T6 = () => ({
  left: [],
  right: []
}), xt1 = {
  getInitialState: (e) => ({
    columnPinning: T6(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnPinningChange: Y2("columnPinning", e)
  }),
  createColumn: (e, t) => {
    e.pin = (n) => {
      const r = e.getLeafColumns().map((o) => o.id).filter(Boolean);
      t.setColumnPinning((o) => {
        var i, a;
        if (n === "right") {
          var s, l;
          return {
            left: ((s = o?.left) != null ? s : []).filter((u) => !(r != null && r.includes(u))),
            right: [...((l = o?.right) != null ? l : []).filter((u) => !(r != null && r.includes(u))), ...r]
          };
        }
        if (n === "left") {
          var c, f;
          return {
            left: [...((c = o?.left) != null ? c : []).filter((u) => !(r != null && r.includes(u))), ...r],
            right: ((f = o?.right) != null ? f : []).filter((u) => !(r != null && r.includes(u)))
          };
        }
        return {
          left: ((i = o?.left) != null ? i : []).filter((u) => !(r != null && r.includes(u))),
          right: ((a = o?.right) != null ? a : []).filter((u) => !(r != null && r.includes(u)))
        };
      });
    }, e.getCanPin = () => e.getLeafColumns().some((r) => {
      var o, i, a;
      return ((o = r.columnDef.enablePinning) != null ? o : !0) && ((i = (a = t.options.enableColumnPinning) != null ? a : t.options.enablePinning) != null ? i : !0);
    }), e.getIsPinned = () => {
      const n = e.getLeafColumns().map((s) => s.id), {
        left: r,
        right: o
      } = t.getState().columnPinning, i = n.some((s) => r?.includes(s)), a = n.some((s) => o?.includes(s));
      return i ? "left" : a ? "right" : !1;
    }, e.getPinnedIndex = () => {
      var n, r;
      const o = e.getIsPinned();
      return o ? (n = (r = t.getState().columnPinning) == null || (r = r[o]) == null ? void 0 : r.indexOf(e.id)) != null ? n : -1 : 0;
    };
  },
  createRow: (e, t) => {
    e.getCenterVisibleCells = W1(() => [e._getAllVisibleCells(), t.getState().columnPinning.left, t.getState().columnPinning.right], (n, r, o) => {
      const i = [...r ?? [], ...o ?? []];
      return n.filter((a) => !i.includes(a.column.id));
    }, V1(t.options, "debugRows", "getCenterVisibleCells")), e.getLeftVisibleCells = W1(() => [e._getAllVisibleCells(), t.getState().columnPinning.left], (n, r) => (r ?? []).map((i) => n.find((a) => a.column.id === i)).filter(Boolean).map((i) => ({
      ...i,
      position: "left"
    })), V1(t.options, "debugRows", "getLeftVisibleCells")), e.getRightVisibleCells = W1(() => [e._getAllVisibleCells(), t.getState().columnPinning.right], (n, r) => (r ?? []).map((i) => n.find((a) => a.column.id === i)).filter(Boolean).map((i) => ({
      ...i,
      position: "right"
    })), V1(t.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (e) => {
    e.setColumnPinning = (t) => e.options.onColumnPinningChange == null ? void 0 : e.options.onColumnPinningChange(t), e.resetColumnPinning = (t) => {
      var n, r;
      return e.setColumnPinning(t ? T6() : (n = (r = e.initialState) == null ? void 0 : r.columnPinning) != null ? n : T6());
    }, e.getIsSomeColumnsPinned = (t) => {
      var n;
      const r = e.getState().columnPinning;
      if (!t) {
        var o, i;
        return !!((o = r.left) != null && o.length || (i = r.right) != null && i.length);
      }
      return !!((n = r[t]) != null && n.length);
    }, e.getLeftLeafColumns = W1(() => [e.getAllLeafColumns(), e.getState().columnPinning.left], (t, n) => (n ?? []).map((r) => t.find((o) => o.id === r)).filter(Boolean), V1(e.options, "debugColumns", "getLeftLeafColumns")), e.getRightLeafColumns = W1(() => [e.getAllLeafColumns(), e.getState().columnPinning.right], (t, n) => (n ?? []).map((r) => t.find((o) => o.id === r)).filter(Boolean), V1(e.options, "debugColumns", "getRightLeafColumns")), e.getCenterLeafColumns = W1(() => [e.getAllLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r) => {
      const o = [...n ?? [], ...r ?? []];
      return t.filter((i) => !o.includes(i.id));
    }, V1(e.options, "debugColumns", "getCenterLeafColumns"));
  }
};
function St1(e) {
  return e || (typeof document < "u" ? document : null);
}
const Fo = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, R6 = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), Mt1 = {
  getDefaultColumnDef: () => Fo,
  getInitialState: (e) => ({
    columnSizing: {},
    columnSizingInfo: R6(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: Y2("columnSizing", e),
    onColumnSizingInfoChange: Y2("columnSizingInfo", e)
  }),
  createColumn: (e, t) => {
    e.getSize = () => {
      var n, r, o;
      const i = t.getState().columnSizing[e.id];
      return Math.min(Math.max((n = e.columnDef.minSize) != null ? n : Fo.minSize, (r = i ?? e.columnDef.size) != null ? r : Fo.size), (o = e.columnDef.maxSize) != null ? o : Fo.maxSize);
    }, e.getStart = W1((n) => [n, ir(t, n), t.getState().columnSizing], (n, r) => r.slice(0, e.getIndex(n)).reduce((o, i) => o + i.getSize(), 0), V1(t.options, "debugColumns", "getStart")), e.getAfter = W1((n) => [n, ir(t, n), t.getState().columnSizing], (n, r) => r.slice(e.getIndex(n) + 1).reduce((o, i) => o + i.getSize(), 0), V1(t.options, "debugColumns", "getAfter")), e.resetSize = () => {
      t.setColumnSizing((n) => {
        let {
          [e.id]: r,
          ...o
        } = n;
        return o;
      });
    }, e.getCanResize = () => {
      var n, r;
      return ((n = e.columnDef.enableResizing) != null ? n : !0) && ((r = t.options.enableColumnResizing) != null ? r : !0);
    }, e.getIsResizing = () => t.getState().columnSizingInfo.isResizingColumn === e.id;
  },
  createHeader: (e, t) => {
    e.getSize = () => {
      let n = 0;
      const r = (o) => {
        if (o.subHeaders.length)
          o.subHeaders.forEach(r);
        else {
          var i;
          n += (i = o.column.getSize()) != null ? i : 0;
        }
      };
      return r(e), n;
    }, e.getStart = () => {
      if (e.index > 0) {
        const n = e.headerGroup.headers[e.index - 1];
        return n.getStart() + n.getSize();
      }
      return 0;
    }, e.getResizeHandler = (n) => {
      const r = t.getColumn(e.column.id), o = r?.getCanResize();
      return (i) => {
        if (!r || !o || (i.persist == null || i.persist(), P6(i) && i.touches && i.touches.length > 1))
          return;
        const a = e.getSize(), s = e ? e.getLeafHeaders().map((y) => [y.column.id, y.column.getSize()]) : [[r.id, r.getSize()]], l = P6(i) ? Math.round(i.touches[0].clientX) : i.clientX, c = {}, f = (y, C) => {
          typeof C == "number" && (t.setColumnSizingInfo((_) => {
            var M, S;
            const k = t.options.columnResizeDirection === "rtl" ? -1 : 1, L = (C - ((M = _?.startOffset) != null ? M : 0)) * k, P = Math.max(L / ((S = _?.startSize) != null ? S : 0), -0.999999);
            return _.columnSizingStart.forEach((I) => {
              let [O, E] = I;
              c[O] = Math.round(Math.max(E + E * P, 0) * 100) / 100;
            }), {
              ..._,
              deltaOffset: L,
              deltaPercentage: P
            };
          }), (t.options.columnResizeMode === "onChange" || y === "end") && t.setColumnSizing((_) => ({
            ..._,
            ...c
          })));
        }, u = (y) => f("move", y), h = (y) => {
          f("end", y), t.setColumnSizingInfo((C) => ({
            ...C,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, p = St1(n), g = {
          moveHandler: (y) => u(y.clientX),
          upHandler: (y) => {
            p?.removeEventListener("mousemove", g.moveHandler), p?.removeEventListener("mouseup", g.upHandler), h(y.clientX);
          }
        }, m = {
          moveHandler: (y) => (y.cancelable && (y.preventDefault(), y.stopPropagation()), u(y.touches[0].clientX), !1),
          upHandler: (y) => {
            var C;
            p?.removeEventListener("touchmove", m.moveHandler), p?.removeEventListener("touchend", m.upHandler), y.cancelable && (y.preventDefault(), y.stopPropagation()), h((C = y.touches[0]) == null ? void 0 : C.clientX);
          }
        }, b = kt1() ? {
          passive: !1
        } : !1;
        P6(i) ? (p?.addEventListener("touchmove", m.moveHandler, b), p?.addEventListener("touchend", m.upHandler, b)) : (p?.addEventListener("mousemove", g.moveHandler, b), p?.addEventListener("mouseup", g.upHandler, b)), t.setColumnSizingInfo((y) => ({
          ...y,
          startOffset: l,
          startSize: a,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: s,
          isResizingColumn: r.id
        }));
      };
    };
  },
  createTable: (e) => {
    e.setColumnSizing = (t) => e.options.onColumnSizingChange == null ? void 0 : e.options.onColumnSizingChange(t), e.setColumnSizingInfo = (t) => e.options.onColumnSizingInfoChange == null ? void 0 : e.options.onColumnSizingInfoChange(t), e.resetColumnSizing = (t) => {
      var n;
      e.setColumnSizing(t ? {} : (n = e.initialState.columnSizing) != null ? n : {});
    }, e.resetHeaderSizeInfo = (t) => {
      var n;
      e.setColumnSizingInfo(t ? R6() : (n = e.initialState.columnSizingInfo) != null ? n : R6());
    }, e.getTotalSize = () => {
      var t, n;
      return (t = (n = e.getHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? t : 0;
    }, e.getLeftTotalSize = () => {
      var t, n;
      return (t = (n = e.getLeftHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? t : 0;
    }, e.getCenterTotalSize = () => {
      var t, n;
      return (t = (n = e.getCenterHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? t : 0;
    }, e.getRightTotalSize = () => {
      var t, n;
      return (t = (n = e.getRightHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? t : 0;
    };
  }
};
let $o = null;
function kt1() {
  if (typeof $o == "boolean") return $o;
  let e = !1;
  try {
    const t = {
      get passive() {
        return e = !0, !1;
      }
    }, n = () => {
    };
    window.addEventListener("test", n, t), window.removeEventListener("test", n);
  } catch {
    e = !1;
  }
  return $o = e, $o;
}
function P6(e) {
  return e.type === "touchstart";
}
const Lt1 = {
  getInitialState: (e) => ({
    columnVisibility: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnVisibilityChange: Y2("columnVisibility", e)
  }),
  createColumn: (e, t) => {
    e.toggleVisibility = (n) => {
      e.getCanHide() && t.setColumnVisibility((r) => ({
        ...r,
        [e.id]: n ?? !e.getIsVisible()
      }));
    }, e.getIsVisible = () => {
      var n, r;
      const o = e.columns;
      return (n = o.length ? o.some((i) => i.getIsVisible()) : (r = t.getState().columnVisibility) == null ? void 0 : r[e.id]) != null ? n : !0;
    }, e.getCanHide = () => {
      var n, r;
      return ((n = e.columnDef.enableHiding) != null ? n : !0) && ((r = t.options.enableHiding) != null ? r : !0);
    }, e.getToggleVisibilityHandler = () => (n) => {
      e.toggleVisibility == null || e.toggleVisibility(n.target.checked);
    };
  },
  createRow: (e, t) => {
    e._getAllVisibleCells = W1(() => [e.getAllCells(), t.getState().columnVisibility], (n) => n.filter((r) => r.column.getIsVisible()), V1(t.options, "debugRows", "_getAllVisibleCells")), e.getVisibleCells = W1(() => [e.getLeftVisibleCells(), e.getCenterVisibleCells(), e.getRightVisibleCells()], (n, r, o) => [...n, ...r, ...o], V1(t.options, "debugRows", "getVisibleCells"));
  },
  createTable: (e) => {
    const t = (n, r) => W1(() => [r(), r().filter((o) => o.getIsVisible()).map((o) => o.id).join("_")], (o) => o.filter((i) => i.getIsVisible == null ? void 0 : i.getIsVisible()), V1(e.options, "debugColumns", n));
    e.getVisibleFlatColumns = t("getVisibleFlatColumns", () => e.getAllFlatColumns()), e.getVisibleLeafColumns = t("getVisibleLeafColumns", () => e.getAllLeafColumns()), e.getLeftVisibleLeafColumns = t("getLeftVisibleLeafColumns", () => e.getLeftLeafColumns()), e.getRightVisibleLeafColumns = t("getRightVisibleLeafColumns", () => e.getRightLeafColumns()), e.getCenterVisibleLeafColumns = t("getCenterVisibleLeafColumns", () => e.getCenterLeafColumns()), e.setColumnVisibility = (n) => e.options.onColumnVisibilityChange == null ? void 0 : e.options.onColumnVisibilityChange(n), e.resetColumnVisibility = (n) => {
      var r;
      e.setColumnVisibility(n ? {} : (r = e.initialState.columnVisibility) != null ? r : {});
    }, e.toggleAllColumnsVisible = (n) => {
      var r;
      n = (r = n) != null ? r : !e.getIsAllColumnsVisible(), e.setColumnVisibility(e.getAllLeafColumns().reduce((o, i) => ({
        ...o,
        [i.id]: n || !(i.getCanHide != null && i.getCanHide())
      }), {}));
    }, e.getIsAllColumnsVisible = () => !e.getAllLeafColumns().some((n) => !(n.getIsVisible != null && n.getIsVisible())), e.getIsSomeColumnsVisible = () => e.getAllLeafColumns().some((n) => n.getIsVisible == null ? void 0 : n.getIsVisible()), e.getToggleAllColumnsVisibilityHandler = () => (n) => {
      var r;
      e.toggleAllColumnsVisible((r = n.target) == null ? void 0 : r.checked);
    };
  }
};
function ir(e, t) {
  return t ? t === "center" ? e.getCenterVisibleLeafColumns() : t === "left" ? e.getLeftVisibleLeafColumns() : e.getRightVisibleLeafColumns() : e.getVisibleLeafColumns();
}
const Et1 = {
  createTable: (e) => {
    e._getGlobalFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, "__global__"), e.getGlobalFacetedRowModel = () => e.options.manualFiltering || !e._getGlobalFacetedRowModel ? e.getPreFilteredRowModel() : e._getGlobalFacetedRowModel(), e._getGlobalFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, "__global__"), e.getGlobalFacetedUniqueValues = () => e._getGlobalFacetedUniqueValues ? e._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getGlobalFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, "__global__"), e.getGlobalFacetedMinMaxValues = () => {
      if (e._getGlobalFacetedMinMaxValues)
        return e._getGlobalFacetedMinMaxValues();
    };
  }
}, Tt1 = {
  getInitialState: (e) => ({
    globalFilter: void 0,
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGlobalFilterChange: Y2("globalFilter", e),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (t) => {
      var n;
      const r = (n = e.getCoreRowModel().flatRows[0]) == null || (n = n._getAllCellsByColumnId()[t.id]) == null ? void 0 : n.getValue();
      return typeof r == "string" || typeof r == "number";
    }
  }),
  createColumn: (e, t) => {
    e.getCanGlobalFilter = () => {
      var n, r, o, i;
      return ((n = e.columnDef.enableGlobalFilter) != null ? n : !0) && ((r = t.options.enableGlobalFilter) != null ? r : !0) && ((o = t.options.enableFilters) != null ? o : !0) && ((i = t.options.getColumnCanGlobalFilter == null ? void 0 : t.options.getColumnCanGlobalFilter(e)) != null ? i : !0) && !!e.accessorFn;
    };
  },
  createTable: (e) => {
    e.getGlobalAutoFilterFn = () => Yt.includesString, e.getGlobalFilterFn = () => {
      var t, n;
      const {
        globalFilterFn: r
      } = e.options;
      return Is(r) ? r : r === "auto" ? e.getGlobalAutoFilterFn() : (t = (n = e.options.filterFns) == null ? void 0 : n[r]) != null ? t : Yt[r];
    }, e.setGlobalFilter = (t) => {
      e.options.onGlobalFilterChange == null || e.options.onGlobalFilterChange(t);
    }, e.resetGlobalFilter = (t) => {
      e.setGlobalFilter(t ? void 0 : e.initialState.globalFilter);
    };
  }
}, Rt1 = {
  getInitialState: (e) => ({
    expanded: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onExpandedChange: Y2("expanded", e),
    paginateExpandedRows: !0
  }),
  createTable: (e) => {
    let t = !1, n = !1;
    e._autoResetExpanded = () => {
      var r, o;
      if (!t) {
        e._queue(() => {
          t = !0;
        });
        return;
      }
      if ((r = (o = e.options.autoResetAll) != null ? o : e.options.autoResetExpanded) != null ? r : !e.options.manualExpanding) {
        if (n) return;
        n = !0, e._queue(() => {
          e.resetExpanded(), n = !1;
        });
      }
    }, e.setExpanded = (r) => e.options.onExpandedChange == null ? void 0 : e.options.onExpandedChange(r), e.toggleAllRowsExpanded = (r) => {
      r ?? !e.getIsAllRowsExpanded() ? e.setExpanded(!0) : e.setExpanded({});
    }, e.resetExpanded = (r) => {
      var o, i;
      e.setExpanded(r ? {} : (o = (i = e.initialState) == null ? void 0 : i.expanded) != null ? o : {});
    }, e.getCanSomeRowsExpand = () => e.getPrePaginationRowModel().flatRows.some((r) => r.getCanExpand()), e.getToggleAllRowsExpandedHandler = () => (r) => {
      r.persist == null || r.persist(), e.toggleAllRowsExpanded();
    }, e.getIsSomeRowsExpanded = () => {
      const r = e.getState().expanded;
      return r === !0 || Object.values(r).some(Boolean);
    }, e.getIsAllRowsExpanded = () => {
      const r = e.getState().expanded;
      return typeof r == "boolean" ? r === !0 : !(!Object.keys(r).length || e.getRowModel().flatRows.some((o) => !o.getIsExpanded()));
    }, e.getExpandedDepth = () => {
      let r = 0;
      return (e.getState().expanded === !0 ? Object.keys(e.getRowModel().rowsById) : Object.keys(e.getState().expanded)).forEach((i) => {
        const a = i.split(".");
        r = Math.max(r, a.length);
      }), r;
    }, e.getPreExpandedRowModel = () => e.getSortedRowModel(), e.getExpandedRowModel = () => (!e._getExpandedRowModel && e.options.getExpandedRowModel && (e._getExpandedRowModel = e.options.getExpandedRowModel(e)), e.options.manualExpanding || !e._getExpandedRowModel ? e.getPreExpandedRowModel() : e._getExpandedRowModel());
  },
  createRow: (e, t) => {
    e.toggleExpanded = (n) => {
      t.setExpanded((r) => {
        var o;
        const i = r === !0 ? !0 : !!(r != null && r[e.id]);
        let a = {};
        if (r === !0 ? Object.keys(t.getRowModel().rowsById).forEach((s) => {
          a[s] = !0;
        }) : a = r, n = (o = n) != null ? o : !i, !i && n)
          return {
            ...a,
            [e.id]: !0
          };
        if (i && !n) {
          const {
            [e.id]: s,
            ...l
          } = a;
          return l;
        }
        return r;
      });
    }, e.getIsExpanded = () => {
      var n;
      const r = t.getState().expanded;
      return !!((n = t.options.getIsRowExpanded == null ? void 0 : t.options.getIsRowExpanded(e)) != null ? n : r === !0 || r?.[e.id]);
    }, e.getCanExpand = () => {
      var n, r, o;
      return (n = t.options.getRowCanExpand == null ? void 0 : t.options.getRowCanExpand(e)) != null ? n : ((r = t.options.enableExpanding) != null ? r : !0) && !!((o = e.subRows) != null && o.length);
    }, e.getIsAllParentsExpanded = () => {
      let n = !0, r = e;
      for (; n && r.parentId; )
        r = t.getRow(r.parentId, !0), n = r.getIsExpanded();
      return n;
    }, e.getToggleExpandedHandler = () => {
      const n = e.getCanExpand();
      return () => {
        n && e.toggleExpanded();
      };
    };
  }
}, qu = 0, zu = 10, A6 = () => ({
  pageIndex: qu,
  pageSize: zu
}), Pt1 = {
  getInitialState: (e) => ({
    ...e,
    pagination: {
      ...A6(),
      ...e?.pagination
    }
  }),
  getDefaultOptions: (e) => ({
    onPaginationChange: Y2("pagination", e)
  }),
  createTable: (e) => {
    let t = !1, n = !1;
    e._autoResetPageIndex = () => {
      var r, o;
      if (!t) {
        e._queue(() => {
          t = !0;
        });
        return;
      }
      if ((r = (o = e.options.autoResetAll) != null ? o : e.options.autoResetPageIndex) != null ? r : !e.options.manualPagination) {
        if (n) return;
        n = !0, e._queue(() => {
          e.resetPageIndex(), n = !1;
        });
      }
    }, e.setPagination = (r) => {
      const o = (i) => b0(r, i);
      return e.options.onPaginationChange == null ? void 0 : e.options.onPaginationChange(o);
    }, e.resetPagination = (r) => {
      var o;
      e.setPagination(r ? A6() : (o = e.initialState.pagination) != null ? o : A6());
    }, e.setPageIndex = (r) => {
      e.setPagination((o) => {
        let i = b0(r, o.pageIndex);
        const a = typeof e.options.pageCount > "u" || e.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : e.options.pageCount - 1;
        return i = Math.max(0, Math.min(i, a)), {
          ...o,
          pageIndex: i
        };
      });
    }, e.resetPageIndex = (r) => {
      var o, i;
      e.setPageIndex(r ? qu : (o = (i = e.initialState) == null || (i = i.pagination) == null ? void 0 : i.pageIndex) != null ? o : qu);
    }, e.resetPageSize = (r) => {
      var o, i;
      e.setPageSize(r ? zu : (o = (i = e.initialState) == null || (i = i.pagination) == null ? void 0 : i.pageSize) != null ? o : zu);
    }, e.setPageSize = (r) => {
      e.setPagination((o) => {
        const i = Math.max(1, b0(r, o.pageSize)), a = o.pageSize * o.pageIndex, s = Math.floor(a / i);
        return {
          ...o,
          pageIndex: s,
          pageSize: i
        };
      });
    }, e.setPageCount = (r) => e.setPagination((o) => {
      var i;
      let a = b0(r, (i = e.options.pageCount) != null ? i : -1);
      return typeof a == "number" && (a = Math.max(-1, a)), {
        ...o,
        pageCount: a
      };
    }), e.getPageOptions = W1(() => [e.getPageCount()], (r) => {
      let o = [];
      return r && r > 0 && (o = [...new Array(r)].fill(null).map((i, a) => a)), o;
    }, V1(e.options, "debugTable", "getPageOptions")), e.getCanPreviousPage = () => e.getState().pagination.pageIndex > 0, e.getCanNextPage = () => {
      const {
        pageIndex: r
      } = e.getState().pagination, o = e.getPageCount();
      return o === -1 ? !0 : o === 0 ? !1 : r < o - 1;
    }, e.previousPage = () => e.setPageIndex((r) => r - 1), e.nextPage = () => e.setPageIndex((r) => r + 1), e.firstPage = () => e.setPageIndex(0), e.lastPage = () => e.setPageIndex(e.getPageCount() - 1), e.getPrePaginationRowModel = () => e.getExpandedRowModel(), e.getPaginationRowModel = () => (!e._getPaginationRowModel && e.options.getPaginationRowModel && (e._getPaginationRowModel = e.options.getPaginationRowModel(e)), e.options.manualPagination || !e._getPaginationRowModel ? e.getPrePaginationRowModel() : e._getPaginationRowModel()), e.getPageCount = () => {
      var r;
      return (r = e.options.pageCount) != null ? r : Math.ceil(e.getRowCount() / e.getState().pagination.pageSize);
    }, e.getRowCount = () => {
      var r;
      return (r = e.options.rowCount) != null ? r : e.getPrePaginationRowModel().rows.length;
    };
  }
}, I6 = () => ({
  top: [],
  bottom: []
}), At1 = {
  getInitialState: (e) => ({
    rowPinning: I6(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowPinningChange: Y2("rowPinning", e)
  }),
  createRow: (e, t) => {
    e.pin = (n, r, o) => {
      const i = r ? e.getLeafRows().map((l) => {
        let {
          id: c
        } = l;
        return c;
      }) : [], a = o ? e.getParentRows().map((l) => {
        let {
          id: c
        } = l;
        return c;
      }) : [], s = /* @__PURE__ */ new Set([...a, e.id, ...i]);
      t.setRowPinning((l) => {
        var c, f;
        if (n === "bottom") {
          var u, h;
          return {
            top: ((u = l?.top) != null ? u : []).filter((m) => !(s != null && s.has(m))),
            bottom: [...((h = l?.bottom) != null ? h : []).filter((m) => !(s != null && s.has(m))), ...Array.from(s)]
          };
        }
        if (n === "top") {
          var p, g;
          return {
            top: [...((p = l?.top) != null ? p : []).filter((m) => !(s != null && s.has(m))), ...Array.from(s)],
            bottom: ((g = l?.bottom) != null ? g : []).filter((m) => !(s != null && s.has(m)))
          };
        }
        return {
          top: ((c = l?.top) != null ? c : []).filter((m) => !(s != null && s.has(m))),
          bottom: ((f = l?.bottom) != null ? f : []).filter((m) => !(s != null && s.has(m)))
        };
      });
    }, e.getCanPin = () => {
      var n;
      const {
        enableRowPinning: r,
        enablePinning: o
      } = t.options;
      return typeof r == "function" ? r(e) : (n = r ?? o) != null ? n : !0;
    }, e.getIsPinned = () => {
      const n = [e.id], {
        top: r,
        bottom: o
      } = t.getState().rowPinning, i = n.some((s) => r?.includes(s)), a = n.some((s) => o?.includes(s));
      return i ? "top" : a ? "bottom" : !1;
    }, e.getPinnedIndex = () => {
      var n, r;
      const o = e.getIsPinned();
      if (!o) return -1;
      const i = (n = o === "top" ? t.getTopRows() : t.getBottomRows()) == null ? void 0 : n.map((a) => {
        let {
          id: s
        } = a;
        return s;
      });
      return (r = i?.indexOf(e.id)) != null ? r : -1;
    };
  },
  createTable: (e) => {
    e.setRowPinning = (t) => e.options.onRowPinningChange == null ? void 0 : e.options.onRowPinningChange(t), e.resetRowPinning = (t) => {
      var n, r;
      return e.setRowPinning(t ? I6() : (n = (r = e.initialState) == null ? void 0 : r.rowPinning) != null ? n : I6());
    }, e.getIsSomeRowsPinned = (t) => {
      var n;
      const r = e.getState().rowPinning;
      if (!t) {
        var o, i;
        return !!((o = r.top) != null && o.length || (i = r.bottom) != null && i.length);
      }
      return !!((n = r[t]) != null && n.length);
    }, e._getPinnedRows = (t, n, r) => {
      var o;
      return ((o = e.options.keepPinnedRows) == null || o ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (n ?? []).map((a) => {
          const s = e.getRow(a, !0);
          return s.getIsAllParentsExpanded() ? s : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (n ?? []).map((a) => t.find((s) => s.id === a))
      )).filter(Boolean).map((a) => ({
        ...a,
        position: r
      }));
    }, e.getTopRows = W1(() => [e.getRowModel().rows, e.getState().rowPinning.top], (t, n) => e._getPinnedRows(t, n, "top"), V1(e.options, "debugRows", "getTopRows")), e.getBottomRows = W1(() => [e.getRowModel().rows, e.getState().rowPinning.bottom], (t, n) => e._getPinnedRows(t, n, "bottom"), V1(e.options, "debugRows", "getBottomRows")), e.getCenterRows = W1(() => [e.getRowModel().rows, e.getState().rowPinning.top, e.getState().rowPinning.bottom], (t, n, r) => {
      const o = /* @__PURE__ */ new Set([...n ?? [], ...r ?? []]);
      return t.filter((i) => !o.has(i.id));
    }, V1(e.options, "debugRows", "getCenterRows"));
  }
}, It1 = {
  getInitialState: (e) => ({
    rowSelection: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowSelectionChange: Y2("rowSelection", e),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (e) => {
    e.setRowSelection = (t) => e.options.onRowSelectionChange == null ? void 0 : e.options.onRowSelectionChange(t), e.resetRowSelection = (t) => {
      var n;
      return e.setRowSelection(t ? {} : (n = e.initialState.rowSelection) != null ? n : {});
    }, e.toggleAllRowsSelected = (t) => {
      e.setRowSelection((n) => {
        t = typeof t < "u" ? t : !e.getIsAllRowsSelected();
        const r = {
          ...n
        }, o = e.getPreGroupedRowModel().flatRows;
        return t ? o.forEach((i) => {
          i.getCanSelect() && (r[i.id] = !0);
        }) : o.forEach((i) => {
          delete r[i.id];
        }), r;
      });
    }, e.toggleAllPageRowsSelected = (t) => e.setRowSelection((n) => {
      const r = typeof t < "u" ? t : !e.getIsAllPageRowsSelected(), o = {
        ...n
      };
      return e.getRowModel().rows.forEach((i) => {
        Uu(o, i.id, r, !0, e);
      }), o;
    }), e.getPreSelectedRowModel = () => e.getCoreRowModel(), e.getSelectedRowModel = W1(() => [e.getState().rowSelection, e.getCoreRowModel()], (t, n) => Object.keys(t).length ? O6(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, V1(e.options, "debugTable", "getSelectedRowModel")), e.getFilteredSelectedRowModel = W1(() => [e.getState().rowSelection, e.getFilteredRowModel()], (t, n) => Object.keys(t).length ? O6(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, V1(e.options, "debugTable", "getFilteredSelectedRowModel")), e.getGroupedSelectedRowModel = W1(() => [e.getState().rowSelection, e.getSortedRowModel()], (t, n) => Object.keys(t).length ? O6(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, V1(e.options, "debugTable", "getGroupedSelectedRowModel")), e.getIsAllRowsSelected = () => {
      const t = e.getFilteredRowModel().flatRows, {
        rowSelection: n
      } = e.getState();
      let r = !!(t.length && Object.keys(n).length);
      return r && t.some((o) => o.getCanSelect() && !n[o.id]) && (r = !1), r;
    }, e.getIsAllPageRowsSelected = () => {
      const t = e.getPaginationRowModel().flatRows.filter((o) => o.getCanSelect()), {
        rowSelection: n
      } = e.getState();
      let r = !!t.length;
      return r && t.some((o) => !n[o.id]) && (r = !1), r;
    }, e.getIsSomeRowsSelected = () => {
      var t;
      const n = Object.keys((t = e.getState().rowSelection) != null ? t : {}).length;
      return n > 0 && n < e.getFilteredRowModel().flatRows.length;
    }, e.getIsSomePageRowsSelected = () => {
      const t = e.getPaginationRowModel().flatRows;
      return e.getIsAllPageRowsSelected() ? !1 : t.filter((n) => n.getCanSelect()).some((n) => n.getIsSelected() || n.getIsSomeSelected());
    }, e.getToggleAllRowsSelectedHandler = () => (t) => {
      e.toggleAllRowsSelected(t.target.checked);
    }, e.getToggleAllPageRowsSelectedHandler = () => (t) => {
      e.toggleAllPageRowsSelected(t.target.checked);
    };
  },
  createRow: (e, t) => {
    e.toggleSelected = (n, r) => {
      const o = e.getIsSelected();
      t.setRowSelection((i) => {
        var a;
        if (n = typeof n < "u" ? n : !o, e.getCanSelect() && o === n)
          return i;
        const s = {
          ...i
        };
        return Uu(s, e.id, n, (a = r?.selectChildren) != null ? a : !0, t), s;
      });
    }, e.getIsSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return O7(e, n);
    }, e.getIsSomeSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return Gu(e, n) === "some";
    }, e.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return Gu(e, n) === "all";
    }, e.getCanSelect = () => {
      var n;
      return typeof t.options.enableRowSelection == "function" ? t.options.enableRowSelection(e) : (n = t.options.enableRowSelection) != null ? n : !0;
    }, e.getCanSelectSubRows = () => {
      var n;
      return typeof t.options.enableSubRowSelection == "function" ? t.options.enableSubRowSelection(e) : (n = t.options.enableSubRowSelection) != null ? n : !0;
    }, e.getCanMultiSelect = () => {
      var n;
      return typeof t.options.enableMultiRowSelection == "function" ? t.options.enableMultiRowSelection(e) : (n = t.options.enableMultiRowSelection) != null ? n : !0;
    }, e.getToggleSelectedHandler = () => {
      const n = e.getCanSelect();
      return (r) => {
        var o;
        n && e.toggleSelected((o = r.target) == null ? void 0 : o.checked);
      };
    };
  }
}, Uu = (e, t, n, r, o) => {
  var i;
  const a = o.getRow(t, !0);
  n ? (a.getCanMultiSelect() || Object.keys(e).forEach((s) => delete e[s]), a.getCanSelect() && (e[t] = !0)) : delete e[t], r && (i = a.subRows) != null && i.length && a.getCanSelectSubRows() && a.subRows.forEach((s) => Uu(e, s.id, n, r, o));
};
function O6(e, t) {
  const n = e.getState().rowSelection, r = [], o = {}, i = function(a, s) {
    return a.map((l) => {
      var c;
      const f = O7(l, n);
      if (f && (r.push(l), o[l.id] = l), (c = l.subRows) != null && c.length && (l = {
        ...l,
        subRows: i(l.subRows)
      }), f)
        return l;
    }).filter(Boolean);
  };
  return {
    rows: i(t.rows),
    flatRows: r,
    rowsById: o
  };
}
function O7(e, t) {
  var n;
  return (n = t[e.id]) != null ? n : !1;
}
function Gu(e, t, n) {
  var r;
  if (!((r = e.subRows) != null && r.length)) return !1;
  let o = !0, i = !1;
  return e.subRows.forEach((a) => {
    if (!(i && !o) && (a.getCanSelect() && (O7(a, t) ? i = !0 : o = !1), a.subRows && a.subRows.length)) {
      const s = Gu(a, t);
      s === "all" ? i = !0 : (s === "some" && (i = !0), o = !1);
    }
  }), o ? "all" : i ? "some" : !1;
}
const Yu = /([0-9]+)/gm, Ot1 = (e, t, n) => iE(T0(e.getValue(n)).toLowerCase(), T0(t.getValue(n)).toLowerCase()), Nt1 = (e, t, n) => iE(T0(e.getValue(n)), T0(t.getValue(n))), Dt1 = (e, t, n) => N7(T0(e.getValue(n)).toLowerCase(), T0(t.getValue(n)).toLowerCase()), Bt1 = (e, t, n) => N7(T0(e.getValue(n)), T0(t.getValue(n))), Ft1 = (e, t, n) => {
  const r = e.getValue(n), o = t.getValue(n);
  return r > o ? 1 : r < o ? -1 : 0;
}, $t1 = (e, t, n) => N7(e.getValue(n), t.getValue(n));
function N7(e, t) {
  return e === t ? 0 : e > t ? 1 : -1;
}
function T0(e) {
  return typeof e == "number" ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : typeof e == "string" ? e : "";
}
function iE(e, t) {
  const n = e.split(Yu).filter(Boolean), r = t.split(Yu).filter(Boolean);
  for (; n.length && r.length; ) {
    const o = n.shift(), i = r.shift(), a = parseInt(o, 10), s = parseInt(i, 10), l = [a, s].sort();
    if (isNaN(l[0])) {
      if (o > i)
        return 1;
      if (i > o)
        return -1;
      continue;
    }
    if (isNaN(l[1]))
      return isNaN(a) ? -1 : 1;
    if (a > s)
      return 1;
    if (s > a)
      return -1;
  }
  return n.length - r.length;
}
const Hn = {
  alphanumeric: Ot1,
  alphanumericCaseSensitive: Nt1,
  text: Dt1,
  textCaseSensitive: Bt1,
  datetime: Ft1,
  basic: $t1
}, Wt1 = {
  getInitialState: (e) => ({
    sorting: [],
    ...e
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (e) => ({
    onSortingChange: Y2("sorting", e),
    isMultiSortEvent: (t) => t.shiftKey
  }),
  createColumn: (e, t) => {
    e.getAutoSortingFn = () => {
      const n = t.getFilteredRowModel().flatRows.slice(10);
      let r = !1;
      for (const o of n) {
        const i = o?.getValue(e.id);
        if (Object.prototype.toString.call(i) === "[object Date]")
          return Hn.datetime;
        if (typeof i == "string" && (r = !0, i.split(Yu).length > 1))
          return Hn.alphanumeric;
      }
      return r ? Hn.text : Hn.basic;
    }, e.getAutoSortDir = () => {
      const n = t.getFilteredRowModel().flatRows[0];
      return typeof n?.getValue(e.id) == "string" ? "asc" : "desc";
    }, e.getSortingFn = () => {
      var n, r;
      if (!e)
        throw new Error();
      return Is(e.columnDef.sortingFn) ? e.columnDef.sortingFn : e.columnDef.sortingFn === "auto" ? e.getAutoSortingFn() : (n = (r = t.options.sortingFns) == null ? void 0 : r[e.columnDef.sortingFn]) != null ? n : Hn[e.columnDef.sortingFn];
    }, e.toggleSorting = (n, r) => {
      const o = e.getNextSortingOrder(), i = typeof n < "u" && n !== null;
      t.setSorting((a) => {
        const s = a?.find((p) => p.id === e.id), l = a?.findIndex((p) => p.id === e.id);
        let c = [], f, u = i ? n : o === "desc";
        if (a != null && a.length && e.getCanMultiSort() && r ? s ? f = "toggle" : f = "add" : a != null && a.length && l !== a.length - 1 ? f = "replace" : s ? f = "toggle" : f = "replace", f === "toggle" && (i || o || (f = "remove")), f === "add") {
          var h;
          c = [...a, {
            id: e.id,
            desc: u
          }], c.splice(0, c.length - ((h = t.options.maxMultiSortColCount) != null ? h : Number.MAX_SAFE_INTEGER));
        } else f === "toggle" ? c = a.map((p) => p.id === e.id ? {
          ...p,
          desc: u
        } : p) : f === "remove" ? c = a.filter((p) => p.id !== e.id) : c = [{
          id: e.id,
          desc: u
        }];
        return c;
      });
    }, e.getFirstSortDir = () => {
      var n, r;
      return ((n = (r = e.columnDef.sortDescFirst) != null ? r : t.options.sortDescFirst) != null ? n : e.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, e.getNextSortingOrder = (n) => {
      var r, o;
      const i = e.getFirstSortDir(), a = e.getIsSorted();
      return a ? a !== i && ((r = t.options.enableSortingRemoval) == null || r) && // If enableSortRemove, enable in general
      (!(n && (o = t.options.enableMultiRemove) != null) || o) ? !1 : a === "desc" ? "asc" : "desc" : i;
    }, e.getCanSort = () => {
      var n, r;
      return ((n = e.columnDef.enableSorting) != null ? n : !0) && ((r = t.options.enableSorting) != null ? r : !0) && !!e.accessorFn;
    }, e.getCanMultiSort = () => {
      var n, r;
      return (n = (r = e.columnDef.enableMultiSort) != null ? r : t.options.enableMultiSort) != null ? n : !!e.accessorFn;
    }, e.getIsSorted = () => {
      var n;
      const r = (n = t.getState().sorting) == null ? void 0 : n.find((o) => o.id === e.id);
      return r ? r.desc ? "desc" : "asc" : !1;
    }, e.getSortIndex = () => {
      var n, r;
      return (n = (r = t.getState().sorting) == null ? void 0 : r.findIndex((o) => o.id === e.id)) != null ? n : -1;
    }, e.clearSorting = () => {
      t.setSorting((n) => n != null && n.length ? n.filter((r) => r.id !== e.id) : []);
    }, e.getToggleSortingHandler = () => {
      const n = e.getCanSort();
      return (r) => {
        n && (r.persist == null || r.persist(), e.toggleSorting == null || e.toggleSorting(void 0, e.getCanMultiSort() ? t.options.isMultiSortEvent == null ? void 0 : t.options.isMultiSortEvent(r) : !1));
      };
    };
  },
  createTable: (e) => {
    e.setSorting = (t) => e.options.onSortingChange == null ? void 0 : e.options.onSortingChange(t), e.resetSorting = (t) => {
      var n, r;
      e.setSorting(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.sorting) != null ? n : []);
    }, e.getPreSortedRowModel = () => e.getGroupedRowModel(), e.getSortedRowModel = () => (!e._getSortedRowModel && e.options.getSortedRowModel && (e._getSortedRowModel = e.options.getSortedRowModel(e)), e.options.manualSorting || !e._getSortedRowModel ? e.getPreSortedRowModel() : e._getSortedRowModel());
  }
}, Vt1 = [
  st1,
  Lt1,
  _t1,
  xt1,
  ct1,
  ut1,
  Et1,
  //depends on ColumnFaceting
  Tt1,
  //depends on ColumnFiltering
  Wt1,
  Ct1,
  //depends on RowSorting
  Rt1,
  Pt1,
  At1,
  It1,
  Mt1
];
function Ht1(e) {
  var t, n;
  process.env.NODE_ENV !== "production" && (e.debugAll || e.debugTable) && console.info("Creating Table Instance...");
  const r = [...Vt1, ...(t = e._features) != null ? t : []];
  let o = {
    _features: r
  };
  const i = o._features.reduce((h, p) => Object.assign(h, p.getDefaultOptions == null ? void 0 : p.getDefaultOptions(o)), {}), a = (h) => o.options.mergeOptions ? o.options.mergeOptions(i, h) : {
    ...i,
    ...h
  };
  let l = {
    ...{},
    ...(n = e.initialState) != null ? n : {}
  };
  o._features.forEach((h) => {
    var p;
    l = (p = h.getInitialState == null ? void 0 : h.getInitialState(l)) != null ? p : l;
  });
  const c = [];
  let f = !1;
  const u = {
    _features: r,
    options: {
      ...i,
      ...e
    },
    initialState: l,
    _queue: (h) => {
      c.push(h), f || (f = !0, Promise.resolve().then(() => {
        for (; c.length; )
          c.shift()();
        f = !1;
      }).catch((p) => setTimeout(() => {
        throw p;
      })));
    },
    reset: () => {
      o.setState(o.initialState);
    },
    setOptions: (h) => {
      const p = b0(h, o.options);
      o.options = a(p);
    },
    getState: () => o.options.state,
    setState: (h) => {
      o.options.onStateChange == null || o.options.onStateChange(h);
    },
    _getRowId: (h, p, g) => {
      var m;
      return (m = o.options.getRowId == null ? void 0 : o.options.getRowId(h, p, g)) != null ? m : `${g ? [g.id, p].join(".") : p}`;
    },
    getCoreRowModel: () => (o._getCoreRowModel || (o._getCoreRowModel = o.options.getCoreRowModel(o)), o._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => o.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (h, p) => {
      let g = (p ? o.getPrePaginationRowModel() : o.getRowModel()).rowsById[h];
      if (!g && (g = o.getCoreRowModel().rowsById[h], !g))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${h}`) : new Error();
      return g;
    },
    _getDefaultColumnDef: W1(() => [o.options.defaultColumn], (h) => {
      var p;
      return h = (p = h) != null ? p : {}, {
        header: (g) => {
          const m = g.header.column.columnDef;
          return m.accessorKey ? m.accessorKey : m.accessorFn ? m.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (g) => {
          var m, b;
          return (m = (b = g.renderValue()) == null || b.toString == null ? void 0 : b.toString()) != null ? m : null;
        },
        ...o._features.reduce((g, m) => Object.assign(g, m.getDefaultColumnDef == null ? void 0 : m.getDefaultColumnDef()), {}),
        ...h
      };
    }, V1(e, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => o.options.columns,
    getAllColumns: W1(() => [o._getColumnDefs()], (h) => {
      const p = function(g, m, b) {
        return b === void 0 && (b = 0), g.map((y) => {
          const C = at1(o, y, b, m), _ = y;
          return C.columns = _.columns ? p(_.columns, C, b + 1) : [], C;
        });
      };
      return p(h);
    }, V1(e, "debugColumns", "getAllColumns")),
    getAllFlatColumns: W1(() => [o.getAllColumns()], (h) => h.flatMap((p) => p.getFlatColumns()), V1(e, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: W1(() => [o.getAllFlatColumns()], (h) => h.reduce((p, g) => (p[g.id] = g, p), {}), V1(e, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: W1(() => [o.getAllColumns(), o._getOrderColumnsFn()], (h, p) => {
      let g = h.flatMap((m) => m.getLeafColumns());
      return p(g);
    }, V1(e, "debugColumns", "getAllLeafColumns")),
    getColumn: (h) => {
      const p = o._getAllFlatColumnsById()[h];
      return process.env.NODE_ENV !== "production" && !p && console.error(`[Table] Column with id '${h}' does not exist.`), p;
    }
  };
  Object.assign(o, u);
  for (let h = 0; h < o._features.length; h++) {
    const p = o._features[h];
    p == null || p.createTable == null || p.createTable(o);
  }
  return o;
}
function jt1() {
  return (e) => W1(() => [e.options.data], (t) => {
    const n = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, r = function(o, i, a) {
      i === void 0 && (i = 0);
      const s = [];
      for (let c = 0; c < o.length; c++) {
        const f = lt1(e, e._getRowId(o[c], c, a), o[c], c, i, void 0, a?.id);
        if (n.flatRows.push(f), n.rowsById[f.id] = f, s.push(f), e.options.getSubRows) {
          var l;
          f.originalSubRows = e.options.getSubRows(o[c], c), (l = f.originalSubRows) != null && l.length && (f.subRows = r(f.originalSubRows, i + 1, f));
        }
      }
      return s;
    };
    return n.rows = r(t), n;
  }, V1(e.options, "debugTable", "getRowModel", () => e._autoResetPageIndex()));
}
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function Kv(e, t) {
  return e ? qt1(e) ? /* @__PURE__ */ d.createElement(e, t) : e : null;
}
function qt1(e) {
  return zt1(e) || typeof e == "function" || Ut1(e);
}
function zt1(e) {
  return typeof e == "function" && (() => {
    const t = Object.getPrototypeOf(e);
    return t.prototype && t.prototype.isReactComponent;
  })();
}
function Ut1(e) {
  return typeof e == "object" && typeof e.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(e.$$typeof.description);
}
function Gt1(e) {
  const t = {
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    ...e
  }, [n] = d.useState(() => ({
    current: Ht1(t)
  })), [r, o] = d.useState(() => n.current.initialState);
  return n.current.setOptions((i) => ({
    ...i,
    ...e,
    state: {
      ...r,
      ...e.state
    },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: (a) => {
      o(a), e.onStateChange == null || e.onStateChange(a);
    }
  })), n.current;
}
function Yt1({
  table: e
}) {
  return /* @__PURE__ */ s1("div", { className: "flex items-center justify-between p-2", children: [
    /* @__PURE__ */ s1("div", { className: "flex-1 text-sm text-muted-foreground", children: [
      e.getFilteredSelectedRowModel().rows.length,
      " of",
      " ",
      e.getFilteredRowModel().rows.length,
      " row(s) selected."
    ] }),
    /* @__PURE__ */ s1("div", { className: "flex items-center space-x-6 lg:space-x-8", children: [
      /* @__PURE__ */ v("div", { className: "flex items-center space-x-2", children: /* @__PURE__ */ s1(j5, { className: "flex items-center gap-2", children: [
        "Rows per page",
        /* @__PURE__ */ s1(
          M5,
          {
            value: `${e.getState().pagination.pageSize}`,
            onValueChange: (t) => {
              e.setPageSize(Number(t));
            },
            children: [
              /* @__PURE__ */ v(
                L5,
                {
                  className: "h-8 w-[70px]",
                  "data-testid": "data-table-pagination-page-size-picker",
                  children: /* @__PURE__ */ v(
                    k5,
                    {
                      placeholder: e.getState().pagination.pageSize
                    }
                  )
                }
              ),
              /* @__PURE__ */ v(XC, { side: "top", children: [10, 20, 30, 40, 50].map((t) => /* @__PURE__ */ v(QC, { value: `${t}`, children: t }, t)) })
            ]
          }
        )
      ] }) }),
      e.getPageCount() > 1 && /* @__PURE__ */ s1(ze, { children: [
        /* @__PURE__ */ s1("div", { className: "flex w-[100px] items-center justify-center text-sm font-medium", children: [
          "Page ",
          e.getState().pagination.pageIndex + 1,
          " of",
          " ",
          e.getPageCount()
        ] }),
        /* @__PURE__ */ s1("div", { className: "flex items-center space-x-2", children: [
          /* @__PURE__ */ s1(
            dt,
            {
              variant: "outline",
              className: "hidden size-8 p-0 lg:flex",
              "data-testid": "data-table-pagination-first-page",
              onClick: () => {
                e.setPageIndex(0), e.setRowSelection({});
              },
              disabled: !e.getCanPreviousPage(),
              children: [
                /* @__PURE__ */ v("span", { className: "sr-only", children: "Go to first page" }),
                /* @__PURE__ */ v(zy, {})
              ]
            }
          ),
          /* @__PURE__ */ s1(
            dt,
            {
              variant: "outline",
              className: "size-8 p-0",
              "data-testid": "data-table-pagination-previous-page",
              onClick: () => {
                e.previousPage(), e.setRowSelection({});
              },
              disabled: !e.getCanPreviousPage(),
              children: [
                /* @__PURE__ */ v("span", { className: "sr-only", children: "Go to previous page" }),
                /* @__PURE__ */ v(qi, {})
              ]
            }
          ),
          /* @__PURE__ */ s1(
            dt,
            {
              variant: "outline",
              className: "size-8 p-0",
              "data-testid": "data-table-pagination-next-page",
              onClick: () => {
                e.nextPage(), e.setRowSelection({});
              },
              disabled: !e.getCanNextPage(),
              children: [
                /* @__PURE__ */ v("span", { className: "sr-only", children: "Go to next page" }),
                /* @__PURE__ */ v(qr, {})
              ]
            }
          ),
          /* @__PURE__ */ s1(
            dt,
            {
              variant: "outline",
              className: "hidden size-8 p-0 lg:flex",
              "data-testid": "data-table-pagination-last-page",
              onClick: () => {
                e.setPageIndex(e.getPageCount() - 1), e.setRowSelection({});
              },
              disabled: !e.getCanNextPage(),
              children: [
                /* @__PURE__ */ v("span", { className: "sr-only", children: "Go to last page" }),
                /* @__PURE__ */ v(Uy, {})
              ]
            }
          )
        ] })
      ] })
    ] })
  ] });
}
function Zt1({
  table: e
}) {
  const t = e.getAllColumns();
  return /* @__PURE__ */ s1(zi, { children: [
    /* @__PURE__ */ v(Ui, { asChild: !0, children: /* @__PURE__ */ s1(dt, { variant: "outline", className: "mb-2 ml-auto hidden h-8 lg:flex", children: [
      /* @__PURE__ */ v(Zy, {}),
      "Edit Columns"
    ] }) }),
    /* @__PURE__ */ s1(Gi, { align: "end", className: "w-60", children: [
      /* @__PURE__ */ v(eC, { children: "Toggle columns" }),
      /* @__PURE__ */ v(tC, {}),
      t.filter((n) => typeof n.accessorFn < "u").map((n) => /* @__PURE__ */ v(
        Jy,
        {
          disabled: !n.getCanHide(),
          className: "capitalize",
          checked: n.getIsVisible(),
          onCheckedChange: (r) => n.toggleVisibility(!!r),
          children: typeof n.columnDef.header == "string" ? n.columnDef.header : n.id
        },
        n.id
      ))
    ] })
  ] });
}
function s31(e) {
  const {
    columns: t,
    data: n,
    rowCount: r,
    setPagination: o,
    pagination: i,
    rowSelection: a = {},
    setRowSelection: s,
    sorting: l,
    setSorting: c,
    isLoading: f,
    columnVisibility: u,
    setColumnVisibility: h
  } = e, p = Gt1({
    data: n,
    columns: t,
    rowCount: r,
    getCoreRowModel: jt1(),
    manualPagination: !0,
    onRowSelectionChange: s,
    onSortingChange: c,
    onPaginationChange: o,
    state: {
      rowSelection: a,
      sorting: l,
      pagination: i,
      columnVisibility: u
    },
    onColumnVisibilityChange: h
  });
  return /* @__PURE__ */ s1(ze, { children: [
    u && /* @__PURE__ */ v(Zt1, { table: p }),
    /* @__PURE__ */ s1(A_, { children: [
      /* @__PURE__ */ v(I_, { children: p.getHeaderGroups().map((g) => /* @__PURE__ */ v(zn, { children: g.headers.map((m) => /* @__PURE__ */ v(O_, { width: m.getSize(), children: m.isPlaceholder ? null : Kv(
        m.column.columnDef.header,
        m.getContext()
      ) }, m.id)) }, g.id)) }),
      f ? /* @__PURE__ */ v(ou, { children: Array.from({ length: i?.pageSize ?? 10 }).map(
        (g, m) => /* @__PURE__ */ v(zn, { children: p.getVisibleFlatColumns().map((b, y) => /* @__PURE__ */ v(jo, { width: b.getSize(), children: b?.columnDef?.meta?.skeleton }, y)) }, m)
      ) }) : /* @__PURE__ */ v(ou, { children: p.getRowModel().rows?.length ? p.getRowModel().rows.map((g) => /* @__PURE__ */ v(
        zn,
        {
          "data-state": g.getIsSelected() && "selected",
          children: g.getVisibleCells().map((m) => /* @__PURE__ */ v(jo, { width: m.column.getSize(), children: Kv(
            m.column.columnDef.cell,
            m.getContext()
          ) }, m.id))
        },
        g.id
      )) : /* @__PURE__ */ v(zn, { children: /* @__PURE__ */ v(
        jo,
        {
          colSpan: t.length,
          className: "h-24 text-center",
          children: "No results."
        }
      ) }) })
    ] }),
    i && /* @__PURE__ */ v(Yt1, { table: p })
  ] });
}
function l31({
  column: e,
  title: t,
  className: n,
  "data-testid": r
}) {
  return e.getCanSort() ? /* @__PURE__ */ v("div", { className: e1("flex items-center space-x-2", n), children: /* @__PURE__ */ s1(zi, { children: [
    /* @__PURE__ */ v(Ui, { asChild: !0, children: /* @__PURE__ */ s1(
      dt,
      {
        variant: "ghost",
        size: "default",
        className: "-ml-3 h-8 data-[state=open]:bg-accent",
        "data-testid": r,
        children: [
          /* @__PURE__ */ v("span", { children: t }),
          e.getIsSorted() === "desc" ? /* @__PURE__ */ v(q6, {}) : e.getIsSorted() === "asc" && /* @__PURE__ */ v(z6, {})
        ]
      }
    ) }),
    /* @__PURE__ */ s1(Gi, { align: "start", children: [
      /* @__PURE__ */ s1(U6, { onClick: () => e.toggleSorting(!1), children: [
        /* @__PURE__ */ v(z6, { className: "size-3 text-muted-foreground/70" }),
        "Asc"
      ] }),
      /* @__PURE__ */ s1(U6, { onClick: () => e.toggleSorting(!0), children: [
        /* @__PURE__ */ v(q6, { className: "size-3 text-muted-foreground/70" }),
        "Desc"
      ] })
    ] })
  ] }) }) : /* @__PURE__ */ v("div", { className: e1(n), children: t });
}
const Kt1 = "linearb_column_visibility_";
function c31(e = "default", t = {}) {
  const n = `${Kt1}${e}`, [r, o] = d2(() => {
    try {
      const a = localStorage.getItem(n);
      return a ? JSON.parse(a) : t;
    } catch {
      return t;
    }
  });
  Te(() => {
    try {
      localStorage.setItem(n, JSON.stringify(r));
    } catch (a) {
      console.warn("Failed to persist column visibility:", a);
    }
  }, [r, n]);
  const i = R1(() => {
    o({}), localStorage.removeItem(n);
  }, [n]);
  return {
    columnVisibility: r,
    setColumnVisibility: o,
    resetColumnVisibility: i
  };
}
function Xt1(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17830_6798)" }, /* @__PURE__ */ d.createElement("path", { d: "M8.04677 1.59712C7.95965 1.68418 7.89054 1.78756 7.84339 1.90134C7.79624 2.01512 7.77197 2.13708 7.77197 2.26024C7.77197 2.38341 7.79624 2.50537 7.84339 2.61915C7.89054 2.73293 7.95965 2.83631 8.04677 2.92337L13.4311 8.30774C13.5184 8.39479 13.6218 8.4638 13.7357 8.51084C13.8496 8.55789 13.9716 8.58204 14.0948 8.58192C14.2181 8.58181 14.34 8.55743 14.4538 8.51017C14.5676 8.46291 14.671 8.3937 14.758 8.3065C14.8451 8.21929 14.9141 8.11579 14.9611 8.00192C15.0082 7.88804 15.0323 7.76601 15.0322 7.6428C15.0321 7.51959 15.0077 7.3976 14.9604 7.28382C14.9132 7.17003 14.844 7.06666 14.7568 6.97962L9.3749 1.59712C9.2878 1.50972 9.18431 1.44037 9.07035 1.39306C8.9564 1.34574 8.83422 1.32138 8.71083 1.32138C8.58745 1.32138 8.46527 1.34574 8.35132 1.39306C8.23736 1.44037 8.13387 1.50972 8.04677 1.59712Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M1.24334 8.40086C1.41915 8.22511 1.65756 8.12637 1.90615 8.12637C2.15474 8.12637 2.39316 8.22511 2.56896 8.40086L7.95334 13.7852C8.04042 13.8724 8.10947 13.9759 8.15656 14.0898C8.20364 14.2037 8.22783 14.3258 8.22774 14.449C8.22765 14.5723 8.20329 14.6943 8.15605 14.8081C8.10881 14.9219 8.03961 15.0253 7.9524 15.1124C7.86519 15.1995 7.76169 15.2686 7.6478 15.3156C7.5339 15.3627 7.41185 15.3869 7.28861 15.3868C7.16537 15.3867 7.04336 15.3624 6.92953 15.3151C6.8157 15.2679 6.7123 15.1987 6.62521 15.1115L1.24334 9.72961C1.15584 9.6425 1.08642 9.53897 1.03904 9.42496C0.991672 9.31094 0.967285 9.1887 0.967285 9.06524C0.967285 8.94177 0.991672 8.81953 1.03904 8.70551C1.08642 8.5915 1.15584 8.48797 1.24334 8.40086Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M4.59766 10.4304L10.0755 4.95255L11.4013 6.27837L5.92348 11.7562L4.59766 10.4304Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M2.69953 13.6542C2.33342 13.2881 2.33342 12.6945 2.69953 12.3284L3.27185 11.7561L4.59767 13.0819L4.02536 13.6542C3.65924 14.0203 3.06565 14.0203 2.69953 13.6542V13.6542Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M11.4023 3.62582L11.9747 3.05351C12.3408 2.68739 12.9344 2.68739 13.3005 3.05351V3.05351C13.6666 3.41962 13.6666 4.01322 13.3005 4.37933L12.7282 4.95165L11.4023 3.62582Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17830_6798" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" }))));
}
Xt1.displayName = "LBCoachingIcon";
function Qt1(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17378_25)" }, /* @__PURE__ */ d.createElement("path", { d: "M22.1888 9.31512L12 1.62762L1.80192 9.31512C1.5911 9.50967 1.46433 9.77868 1.44849 10.0651V21.8045C1.44923 22.0474 1.54607 22.2802 1.71785 22.452C1.88964 22.6238 2.12242 22.7206 2.36536 22.7214H8.47974V17.8023C8.47974 16.8699 8.85013 15.9757 9.50944 15.3164C10.1687 14.6571 11.063 14.2867 11.9954 14.2867C12.9278 14.2867 13.822 14.6571 14.4813 15.3164C15.1406 15.9757 15.511 16.8699 15.511 17.8023V22.7242H21.6244C21.8675 22.7234 22.1003 22.6266 22.2723 22.4549C22.4442 22.2831 22.5412 22.0503 22.5422 21.8073V10.0651C22.526 9.77878 22.3993 9.50991 22.1888 9.31512Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17378_25" }, /* @__PURE__ */ d.createElement("rect", { width: 24, height: 24, fill: "white", transform: "translate(0 0.177307)" }))));
}
Qt1.displayName = "LBHomeIcon";
function Jt1(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17821_3437)" }, /* @__PURE__ */ d.createElement("path", { d: "M21.7868 4.58356L18.6771 7.69231H16.4852V5.50044L19.5939 2.39075C18.6334 1.8661 17.536 1.64614 16.4475 1.76009C15.359 1.87404 14.3309 2.31651 13.4999 3.0287C12.6688 3.7409 12.0742 4.68911 11.7949 5.74734C11.5156 6.80558 11.565 7.92374 11.9364 8.95325L2.23981 18.6461C1.80332 19.0825 1.55811 19.6746 1.55811 20.2918C1.55811 20.9091 1.80332 21.5011 2.23981 21.9376C2.6763 22.3741 3.26831 22.6193 3.8856 22.6193C4.50289 22.6193 5.0949 22.3741 5.53139 21.9376L15.2252 12.2401C16.2547 12.6115 17.3728 12.6609 18.4311 12.3816C19.4893 12.1024 20.4375 11.5077 21.1497 10.6767C21.8619 9.84565 22.3044 8.81758 22.4184 7.72907C22.5323 6.64055 22.3114 5.54407 21.7868 4.58356Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17821_3437" }, /* @__PURE__ */ d.createElement("rect", { width: 24, height: 24, fill: "white", transform: "translate(0 0.177307)" }))));
}
Jt1.displayName = "LBSettingsIcon";
function e01(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17378_34)" }, /* @__PURE__ */ d.createElement("path", { d: "M22.5469 1.63043L1.45312 22.7242", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M22.5469 7.95856V1.63043H16.2188", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M2.85938 7.25824C2.85938 8.00416 3.15569 8.71953 3.68314 9.24698C4.21058 9.77442 4.92595 10.0707 5.67188 10.0707C6.4178 10.0707 7.13317 9.77442 7.66061 9.24698C8.18806 8.71953 8.48438 8.00416 8.48438 7.25824C8.48438 6.51232 8.18806 5.79695 7.66061 5.2695C7.13317 4.74206 6.4178 4.44574 5.67188 4.44574C4.92595 4.44574 4.21058 4.74206 3.68314 5.2695C3.15569 5.79695 2.85938 6.51232 2.85938 7.25824Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M14.1094 18.5082C14.1094 19.2542 14.4057 19.9695 14.9331 20.497C15.4606 21.0244 16.176 21.3207 16.9219 21.3207C17.6678 21.3207 18.3832 21.0244 18.9106 20.497C19.4381 19.9695 19.7344 19.2542 19.7344 18.5082C19.7344 17.7623 19.4381 17.0469 18.9106 16.5195C18.3832 15.9921 17.6678 15.6957 16.9219 15.6957C16.176 15.6957 15.4606 15.9921 14.9331 16.5195C14.4057 17.0469 14.1094 17.7623 14.1094 18.5082Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17378_34" }, /* @__PURE__ */ d.createElement("rect", { width: 24, height: 24, fill: "white", transform: "translate(0 0.177307)" }))));
}
e01.displayName = "LBProductivityIcon";
function t01(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M9.42188 14.9898C10.9752 14.9898 12.2344 13.7307 12.2344 12.1773C12.2344 10.624 10.9752 9.36481 9.42188 9.36481C7.86858 9.36481 6.60938 10.624 6.60938 12.1773C6.60938 13.7307 7.86858 14.9898 9.42188 14.9898Z", stroke: "currentColor", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M6.60938 12.1773H1.45312", stroke: "currentColor", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M10.8691 9.66944C10.5762 9.96234 10.5762 10.4372 10.8691 10.7301C11.162 11.023 11.6369 11.023 11.9297 10.7301L10.8691 9.66944ZM11.9297 10.7301L20.2647 2.39514L19.204 1.33448L10.8691 9.66944L11.9297 10.7301Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M16.4531 1.86481H19.7344V4.67731", stroke: "currentColor", strokeWidth: 1.3, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M12.2344 11.4273C11.8202 11.4273 11.4844 11.7631 11.4844 12.1773C11.4844 12.5915 11.8202 12.9273 12.2344 12.9273V11.4273ZM12.2344 12.9273H22.5469V11.4273H12.2344V12.9273Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M20.2031 9.83356L22.5469 12.1773L20.2031 14.5211", stroke: "currentColor", strokeWidth: 1.3, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M11.9297 13.6245C11.6369 13.3317 11.162 13.3317 10.8691 13.6245C10.5762 13.9174 10.5762 14.3923 10.8691 14.6852L11.9297 13.6245ZM10.8691 14.6852L19.204 23.0201L20.2647 21.9595L11.9297 13.6245L10.8691 14.6852Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M16.4531 22.4898H19.7344V19.6773", stroke: "currentColor", strokeWidth: 1.3, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }));
}
t01.displayName = "LBResourcesIcon";
function n01(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M3.91406 8.31012C3.91406 9.33576 4.3215 10.3194 5.04674 11.0446C5.77197 11.7699 6.75561 12.1773 7.78125 12.1773C8.80689 12.1773 9.79053 11.7699 10.5158 11.0446C11.241 10.3194 11.6484 9.33576 11.6484 8.31012C11.6484 7.28448 11.241 6.30084 10.5158 5.57561C9.79053 4.85037 8.80689 4.44293 7.78125 4.44293C6.75561 4.44293 5.77197 4.85037 5.04674 5.57561C4.3215 6.30084 3.91406 7.28448 3.91406 8.31012Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M1.45312 19.9117C1.45313 18.2334 2.11984 16.6238 3.30659 15.437C4.49334 14.2503 6.10293 13.5836 7.78125 13.5836C9.45957 13.5836 11.0692 14.2503 12.2559 15.437C13.4427 16.6238 14.1094 18.2334 14.1094 19.9117", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M14.1101 5.06732C14.6941 4.6879 15.3696 4.4732 16.0654 4.44588C16.7613 4.41856 17.4516 4.57964 18.0635 4.91211C18.6753 5.24458 19.1861 5.7361 19.5418 6.33478C19.8975 6.93346 20.0849 7.61707 20.0843 8.31345C20.0837 9.00982 19.8951 9.69311 19.5384 10.2912C19.1816 10.8892 18.67 11.3799 18.0576 11.7113C17.4451 12.0427 16.7545 12.2026 16.0587 12.174C15.3629 12.1455 14.6878 11.9296 14.1045 11.5492", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M14.8125 13.7401C15.7393 13.5302 16.7014 13.5314 17.6276 13.7437C18.5539 13.956 19.4204 14.374 20.1632 14.9667C20.906 15.5594 21.5059 16.3116 21.9185 17.1676C22.3311 18.0236 22.5459 18.9614 22.5469 19.9117", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
}
n01.displayName = "LBTeamsIcon";
function r01(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17378_89)" }, /* @__PURE__ */ d.createElement("path", { d: "M9.1875 9.36485C9.1876 8.84925 9.32943 8.3436 9.59749 7.90317C9.86555 7.46273 10.2495 7.10445 10.7075 6.86749C11.1653 6.63054 11.6797 6.52402 12.194 6.55959C12.7084 6.59515 13.2031 6.77143 13.624 7.06915C14.045 7.36687 14.376 7.77458 14.5808 8.24772C14.7858 8.72085 14.8567 9.24121 14.7858 9.75192C14.7149 10.2626 14.5051 10.7441 14.1791 11.1435C13.8532 11.543 13.4236 11.8452 12.9375 12.017C12.6632 12.114 12.4257 12.2937 12.2578 12.5312C12.0899 12.7689 11.9998 13.0527 12 13.3436V14.2867", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M12 17.8023C11.8058 17.8023 11.6484 17.6449 11.6484 17.4507C11.6484 17.2566 11.8058 17.0992 12 17.0992", stroke: "currentColor", strokeWidth: 1.3 }), /* @__PURE__ */ d.createElement("path", { d: "M12 17.8023C12.1942 17.8023 12.3516 17.6449 12.3516 17.4507C12.3516 17.2566 12.1942 17.0992 12 17.0992", stroke: "currentColor", strokeWidth: 1.3 }), /* @__PURE__ */ d.createElement("path", { d: "M12 22.7242C17.8249 22.7242 22.5469 18.0022 22.5469 12.1773C22.5469 6.35243 17.8249 1.63043 12 1.63043C6.17513 1.63043 1.45312 6.35243 1.45312 12.1773C1.45312 18.0022 6.17513 22.7242 12 22.7242Z", stroke: "currentColor", strokeWidth: 1.3, strokeMiterlimit: 10 })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17378_89" }, /* @__PURE__ */ d.createElement("rect", { width: 24, height: 24, fill: "white", transform: "translate(0 0.177307)" }))));
}
r01.displayName = "LBHelpIcon";
function o01(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M0.778883 1.00007C0.551723 0.997078 0.334883 1.09665 0.186546 1.27205C0.0382088 1.44747 -0.0264454 1.68077 0.00992316 1.90938L3.27417 22.1102C3.35813 22.6205 3.78937 22.9957 4.2969 22.9999H19.9569C20.3378 23.0049 20.6649 22.7248 20.7258 22.3415L23.9901 1.91329C24.0265 1.68469 23.9618 1.45139 23.8135 1.27597C23.6651 1.10056 23.4483 1.001 23.2211 1.00398L0.778883 1.00007ZM14.5241 15.6001H9.52585L8.17251 8.39217H15.7353L14.5241 15.6001Z", fill: "#2684FF" }), /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23 9H15.9057L14.7151 15.9079H9.8017L4 22.752C4.18388 22.91 4.41833 22.9979 4.66142 22.9999H20.0594C20.434 23.0047 20.7555 22.7363 20.8154 22.3689L23 9Z", fill: "url(#paint0_linear_17893_199583)" }), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("linearGradient", { id: "paint0_linear_17893_199583", x1: 24.6403, y1: 10.9345, x2: 16.5126, y2: 22.5462, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ d.createElement("stop", { offset: 0.18, stopColor: "#0052CC" }), /* @__PURE__ */ d.createElement("stop", { offset: 1, stopColor: "#2684FF" }))));
}
o01.displayName = "LBBitbucketIcon";
function i01(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_43_616)" }, /* @__PURE__ */ d.createElement("path", { d: "M5.14016 15.1181C5.14016 16.4976 4.0252 17.6126 2.64567 17.6126C1.26614 17.6126 0.151184 16.4976 0.151184 15.1181C0.151184 13.7386 1.26614 12.6236 2.64567 12.6236H5.14016V15.1181ZM6.3874 15.1181C6.3874 13.7386 7.50237 12.6236 8.88189 12.6236C10.2614 12.6236 11.3764 13.7386 11.3764 15.1181V21.3543C11.3764 22.7339 10.2614 23.8488 8.88189 23.8488C7.50237 23.8488 6.3874 22.7339 6.3874 21.3543V15.1181Z", fill: "#E01E5A" }), /* @__PURE__ */ d.createElement("path", { d: "M8.8819 5.10236C7.50237 5.10236 6.38741 3.9874 6.38741 2.60788C6.38741 1.22835 7.50237 0.113388 8.8819 0.113388C10.2614 0.113388 11.3764 1.22835 11.3764 2.60788V5.10236H8.8819ZM8.8819 6.36851C10.2614 6.36851 11.3764 7.48347 11.3764 8.863C11.3764 10.2425 10.2614 11.3575 8.8819 11.3575H2.62678C1.24725 11.3575 0.132294 10.2425 0.132294 8.863C0.132294 7.48347 1.24725 6.36851 2.62678 6.36851H8.8819Z", fill: "#36C5F0" }), /* @__PURE__ */ d.createElement("path", { d: "M18.8787 8.863C18.8787 7.48347 19.9937 6.36851 21.3732 6.36851C22.7528 6.36851 23.8677 7.48347 23.8677 8.863C23.8677 10.2425 22.7528 11.3575 21.3732 11.3575H18.8787V8.863ZM17.6315 8.863C17.6315 10.2425 16.5165 11.3575 15.137 11.3575C13.7575 11.3575 12.6425 10.2425 12.6425 8.863V2.60788C12.6425 1.22835 13.7575 0.113388 15.137 0.113388C16.5165 0.113388 17.6315 1.22835 17.6315 2.60788V8.863Z", fill: "#2EB67D" }), /* @__PURE__ */ d.createElement("path", { d: "M15.137 18.8598C16.5165 18.8598 17.6315 19.9748 17.6315 21.3543C17.6315 22.7339 16.5165 23.8488 15.137 23.8488C13.7575 23.8488 12.6425 22.7339 12.6425 21.3543V18.8598H15.137ZM15.137 17.6126C13.7575 17.6126 12.6425 16.4976 12.6425 15.1181C12.6425 13.7386 13.7575 12.6236 15.137 12.6236H21.3921C22.7717 12.6236 23.8866 13.7386 23.8866 15.1181C23.8866 16.4976 22.7717 17.6126 21.3921 17.6126H15.137Z", fill: "#ECB22E" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_43_616" }, /* @__PURE__ */ d.createElement("rect", { width: 24, height: 24, fill: "white" }))));
}
i01.displayName = "LBSlackIcon";
function a01(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M22.9974 0H11.4402C11.4402 1.38366 11.9898 2.71065 12.9682 3.68905C13.9466 4.66744 15.2736 5.2171 16.6573 5.2171H18.7862V7.27253C18.7881 10.1512 21.1213 12.4844 24 12.4863V1.00265C24 0.4489 23.5511 0 22.9974 0Z", fill: "#2684FF" }), /* @__PURE__ */ d.createElement("path", { d: "M17.2789 5.75853H5.72177C5.72361 8.63725 8.05681 10.9704 10.9355 10.9723H13.0645V13.0344C13.0682 15.9131 15.4029 18.2448 18.2816 18.2448V6.76118C18.2816 6.20743 17.8327 5.75853 17.2789 5.75853Z", fill: "url(#paint0_linear_18118_199873)" }), /* @__PURE__ */ d.createElement("path", { d: "M11.5572 11.5137H0C0 14.395 2.33578 16.7308 5.2171 16.7308H7.35274V18.7862C7.35457 21.6623 9.68371 23.9945 12.5598 24V12.5164C12.5598 11.9626 12.1109 11.5137 11.5572 11.5137Z", fill: "url(#paint1_linear_18118_199873)" }), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("linearGradient", { id: "paint0_linear_18118_199873", x1: 1236.97, y1: 7.76388, x2: 748.332, y2: 517.636, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ d.createElement("stop", { offset: 0.18, stopColor: "#0052CC" }), /* @__PURE__ */ d.createElement("stop", { offset: 1, stopColor: "#2684FF" })), /* @__PURE__ */ d.createElement("linearGradient", { id: "paint1_linear_18118_199873", x1: 1264.34, y1: 17.1953, x2: 699.101, y2: 573.305, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ d.createElement("stop", { offset: 0.18, stopColor: "#0052CC" }), /* @__PURE__ */ d.createElement("stop", { offset: 1, stopColor: "#2684FF" }))));
}
a01.displayName = "LBJiraIcon";
function aE(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", null, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.0099 0C5.36875 0 0 5.40833 0 12.0992C0 17.4475 3.43994 21.9748 8.21205 23.5771C8.80869 23.6976 9.02724 23.3168 9.02724 22.9965C9.02724 22.716 9.00757 21.7545 9.00757 20.7527C5.6667 21.474 4.97099 19.3104 4.97099 19.3104C4.43409 17.9082 3.63858 17.5478 3.63858 17.5478C2.54511 16.8066 3.71823 16.8066 3.71823 16.8066C4.93117 16.8868 5.56763 18.0486 5.56763 18.0486C6.64118 19.8913 8.37111 19.3707 9.06706 19.0501C9.16638 18.2688 9.48473 17.728 9.82275 17.4276C7.15817 17.1471 4.35469 16.1055 4.35469 11.458C4.35469 10.1359 4.8316 9.05428 5.58729 8.21304C5.46807 7.91263 5.0504 6.67043 5.70677 5.00787C5.70677 5.00787 6.72083 4.6873 9.00732 6.24981C9.98625 5.98497 10.9958 5.85024 12.0099 5.84911C13.024 5.84911 14.0577 5.98948 15.0123 6.24981C17.299 4.6873 18.3131 5.00787 18.3131 5.00787C18.9695 6.67043 18.5515 7.91263 18.4323 8.21304C19.2079 9.05428 19.6652 10.1359 19.6652 11.458C19.6652 16.1055 16.8617 17.1269 14.1772 17.4276C14.6148 17.8081 14.9924 18.5292 14.9924 19.6711C14.9924 21.2936 14.9727 22.5957 14.9727 22.9962C14.9727 23.3168 15.1915 23.6976 15.7879 23.5774C20.56 21.9745 23.9999 17.4475 23.9999 12.0992C24.0196 5.40833 18.6312 0 12.0099 0Z", fill: "#24292F" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_43_449" }, /* @__PURE__ */ d.createElement("rect", { width: 24, height: 24, fill: "white" }))));
}
aE.displayName = "LBGithubIcon";
function s01(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", null, /* @__PURE__ */ d.createElement("path", { d: "M23.8689 12.8259L22.523 8.81649L19.8621 0.862476C19.8306 0.772415 19.7714 0.694418 19.693 0.639433C19.6146 0.584448 19.5208 0.555236 19.4249 0.555897C19.3292 0.555592 19.2358 0.58497 19.1577 0.63993C19.0797 0.69489 19.0208 0.772691 18.9894 0.862476L16.3285 8.81138H7.49024L4.82934 0.860772C4.79785 0.771166 4.73893 0.69359 4.66084 0.638918C4.58275 0.584245 4.48939 0.555216 4.39385 0.555897C4.29811 0.555338 4.2046 0.584615 4.12648 0.639611C4.04836 0.694606 3.98957 0.772551 3.95837 0.862476L1.3009 8.81138L-0.0432697 12.8259C-0.102759 13.0047 -0.102702 13.1979 -0.0431073 13.3767C0.0164873 13.5555 0.132453 13.7106 0.287629 13.8188L11.9119 22.0147L23.5328 13.8188C23.6887 13.7111 23.8055 13.5563 23.866 13.3775C23.9266 13.1987 23.9275 13.0053 23.8689 12.8259Z", fill: "#FC6D26" }), /* @__PURE__ */ d.createElement("path", { d: "M11.7701 22.0147L16.2886 8.74412H7.25333L11.7701 22.0147Z", fill: "#E24329" }), /* @__PURE__ */ d.createElement("path", { d: "M11.771 22.0147L7.41621 8.74412H1.32392L11.771 22.0147Z", fill: "#FC6D26" }), /* @__PURE__ */ d.createElement("path", { d: "M1.28439 8.74412L-0.0437996 12.7744C-0.102581 12.9542 -0.102525 13.1484 -0.0436391 13.3282C0.015247 13.5079 0.129834 13.6638 0.283165 13.7726L11.771 22.0147L1.28439 8.74583V8.74412Z", fill: "#FCA326" }), /* @__PURE__ */ d.createElement("path", { d: "M1.32392 8.74412H7.25333L4.7023 0.859977C4.67222 0.770924 4.61587 0.693757 4.54113 0.639245C4.46638 0.584732 4.37695 0.555594 4.28534 0.555896C4.19345 0.555241 4.10366 0.584215 4.02858 0.638752C3.95351 0.693289 3.89691 0.77065 3.86674 0.859977L1.32392 8.74412Z", fill: "#E24329" }), /* @__PURE__ */ d.createElement("path", { d: "M11.771 22.0147L16.2381 8.74412H22.5004L11.771 22.0147Z", fill: "#FC6D26" }), /* @__PURE__ */ d.createElement("path", { d: "M22.5085 8.74412L23.8667 12.7765C23.9272 12.9564 23.9273 13.1507 23.867 13.3307C23.8067 13.5106 23.6892 13.6665 23.5319 13.7752L11.771 22.0147L22.505 8.74412H22.5085Z", fill: "#FCA326" }), /* @__PURE__ */ d.createElement("path", { d: "M22.4969 8.74412H16.2886L18.956 0.859987C18.9873 0.770519 19.0466 0.693014 19.1253 0.638442C19.204 0.583871 19.2982 0.554996 19.3945 0.555906C19.5923 0.555906 19.7677 0.679228 19.8313 0.859987L22.5004 8.74412H22.4969Z", fill: "#E24329" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17893_199590" }, /* @__PURE__ */ d.createElement("rect", { width: 24, height: 24, fill: "white" }))));
}
s01.displayName = "LBGitlabIcon";
function l01(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17893_199594)" }, /* @__PURE__ */ d.createElement("path", { d: "M24 4.49486V19.0869L18 24L8.7 20.6143V23.9709L3.43543 17.0914L18.78 18.2914V5.15143L24 4.49486ZM18.8846 5.22857L10.2754 0V3.43029L2.36914 5.75314L0 8.79429V15.7011L3.39086 17.1977V8.34686L18.8846 5.22857Z", fill: "url(#paint0_linear_17893_199594)" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("linearGradient", { id: "paint0_linear_17893_199594", x1: 12, y1: 23.9246, x2: 12, y2: 0.0445711, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ d.createElement("stop", { stopColor: "#0078D4" }), /* @__PURE__ */ d.createElement("stop", { offset: 0.16, stopColor: "#1380DA" }), /* @__PURE__ */ d.createElement("stop", { offset: 0.53, stopColor: "#3C91E5" }), /* @__PURE__ */ d.createElement("stop", { offset: 0.82, stopColor: "#559CEC" }), /* @__PURE__ */ d.createElement("stop", { offset: 1, stopColor: "#5EA0EF" })), /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17893_199594" }, /* @__PURE__ */ d.createElement("rect", { width: 24, height: 24, fill: "white" }))));
}
l01.displayName = "LBAzureIcon";
function c01(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 23", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_19250_1656)" }, /* @__PURE__ */ d.createElement("path", { d: "M16.6481 9.6821C18.3296 9.68027 19.9525 10.2819 21.2048 11.3712V1.05569C21.205 0.931912 21.1801 0.809299 21.1315 0.694886C21.0828 0.580474 21.0113 0.476512 20.9212 0.388964C20.8311 0.301415 20.724 0.232003 20.6062 0.184707C20.4883 0.137411 20.362 0.113162 20.2345 0.113351H0.969741C0.432911 0.113351 0 0.534082 0 1.05569V16.3904C0 16.9125 0.432911 17.3332 0.969741 17.3332H9.89096C9.83973 17.0007 9.81405 16.6649 9.81413 16.3287C9.81069 12.6597 12.8736 9.6821 16.6481 9.6821Z", fill: "#00947D" }), /* @__PURE__ */ d.createElement("path", { d: "M6.46166 1.84074H1.74494V4.74282H6.46264V1.84074H6.46166Z", fill: "#1FC1A7" }), /* @__PURE__ */ d.createElement("path", { d: "M12.947 1.84074H8.22975V4.74282H12.947V1.84074Z", fill: "#61DDC9" }), /* @__PURE__ */ d.createElement("path", { d: "M6.46166 6.44056H1.74494V9.34313H6.46264V6.44056H6.46166Z", fill: "#9BFDEC" }), /* @__PURE__ */ d.createElement("path", { d: "M6.46166 11.0385H1.74494V13.899H6.46264V11.0385H6.46166Z", fill: "#00B99D" }), /* @__PURE__ */ d.createElement("path", { d: "M12.947 6.44056H8.22975V9.34313H12.947V6.44056Z", fill: "#04BCA1" }), /* @__PURE__ */ d.createElement("path", { d: "M19.4455 1.84074H14.7283V4.74282H19.446L19.4455 1.84074Z", fill: "#1DC0A7" }), /* @__PURE__ */ d.createElement("path", { d: "M21.2038 16.3899V11.3741C19.9521 10.2838 18.3289 9.68193 16.6471 9.68449C12.8726 9.68449 9.80921 12.6588 9.80921 16.3311C9.80921 16.6734 9.8363 17.0062 9.88653 17.3356H20.234C20.4916 17.3344 20.7382 17.2343 20.9199 17.057C21.1015 16.8798 21.2039 16.6399 21.2038 16.3899Z", fill: "#00BA9D" }), /* @__PURE__ */ d.createElement("path", { d: "M21.2053 11.3746V16.3937C21.2054 16.6436 21.1033 16.8832 20.9215 17.06C20.7396 17.2368 20.4929 17.3363 20.2355 17.3365H9.88801C10.3845 20.5293 13.2232 22.9781 16.6486 22.9781C20.4266 22.9753 23.4865 20.001 23.4865 16.3287C23.4877 15.3935 23.285 14.4686 22.8918 13.6147C22.4987 12.7609 21.9239 11.9975 21.2053 11.3746Z", fill: "#27CFB2" }), /* @__PURE__ */ d.createElement("path", { d: "M20.1612 13.0575L15.8764 17.2189L13.6754 15.0794L12.3604 16.3607L14.5614 18.5007L15.9601 19.8604L17.2756 18.5791L21.5604 14.4172L20.1612 13.0575Z", fill: "#C5FDF4" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_19250_1656" }, /* @__PURE__ */ d.createElement("rect", { width: 24, height: 23, fill: "white" }))));
}
c01.displayName = "LBAzureBoardsIcon";
function u01(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_43_476)" }, /* @__PURE__ */ d.createElement("path", { d: "M11.9998 9.81815V14.4654H18.458C18.1744 15.96 17.3234 17.2255 16.047 18.0764L19.9416 21.0982C22.2107 19.0037 23.5198 15.9273 23.5198 12.2728C23.5198 11.4219 23.4434 10.6037 23.3015 9.81828L11.9998 9.81815Z", fill: "#4285F4" }), /* @__PURE__ */ d.createElement("path", { d: "M5.27468 14.284L4.39631 14.9564L1.28717 17.3782C3.26171 21.2945 7.30868 24 11.9996 24C15.2395 24 17.9558 22.9309 19.9413 21.0982L16.0468 18.0764C14.9777 18.7964 13.614 19.2328 11.9996 19.2328C8.87957 19.2328 6.22874 17.1273 5.27958 14.291L5.27468 14.284Z", fill: "#34A853" }), /* @__PURE__ */ d.createElement("path", { d: "M1.28718 6.62183C0.469042 8.23631 0 10.0581 0 11.9999C0 13.9417 0.469042 15.7636 1.28718 17.378C1.28718 17.3889 5.27997 14.2799 5.27997 14.2799C5.03998 13.5599 4.89812 12.7963 4.89812 11.9998C4.89812 11.2033 5.03998 10.4398 5.27997 9.71976L1.28718 6.62183Z", fill: "#FBBC05" }), /* @__PURE__ */ d.createElement("path", { d: "M11.9998 4.77818C13.7671 4.77818 15.338 5.38907 16.5925 6.56727L20.0289 3.13095C17.9452 1.18917 15.2398 0 11.9998 0C7.30893 0 3.26171 2.69454 1.28717 6.62183L5.27984 9.72001C6.22888 6.88362 8.87982 4.77818 11.9998 4.77818Z", fill: "#EA4335" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_43_476" }, /* @__PURE__ */ d.createElement("rect", { width: 24, height: 24, fill: "white" }))));
}
u01.displayName = "LBGoogleIcon";
function d01(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M12.7497 8.00021C14.6828 8.00021 16.2499 6.43309 16.2499 4.49996C16.2499 2.56683 14.6828 0.99971 12.7497 0.99971C10.8166 0.99971 9.24945 2.56683 9.24945 4.49996C9.24945 6.43309 10.8166 8.00021 12.7497 8.00021Z", fill: "#7B83EB" }), /* @__PURE__ */ d.createElement("path", { opacity: 0.1, d: "M12.5003 5.25013H9.33002L9.34577 5.31988L9.34727 5.32588L9.36377 5.39038C9.59412 6.26391 10.153 7.01469 10.9238 7.48594C11.6945 7.95719 12.6175 8.11248 13.5 7.91938V6.24988C13.4992 5.98497 13.3936 5.73114 13.2063 5.54382C13.019 5.35651 12.7652 5.25092 12.5003 5.25013Z", fill: "black" }), /* @__PURE__ */ d.createElement("path", { opacity: 0.2, d: "M11.7507 6.00015H9.58768C9.87155 6.59867 10.3194 7.10435 10.8793 7.45842C11.4392 7.8125 12.088 8.00044 12.7504 8.0004V6.9999C12.7496 6.735 12.644 6.48116 12.4567 6.29385C12.2694 6.10653 12.0156 6.00094 11.7507 6.00015Z", fill: "black" }), /* @__PURE__ */ d.createElement("path", { d: "M20.6254 8.25008C22.0752 8.25008 23.2504 7.07482 23.2504 5.62508C23.2504 4.17533 22.0752 3.00008 20.6254 3.00008C19.1757 3.00008 18.0004 4.17533 18.0004 5.62508C18.0004 7.07482 19.1757 8.25008 20.6254 8.25008Z", fill: "#5059C9" }), /* @__PURE__ */ d.createElement("path", { d: "M22.8749 9.00023H16.9792C16.8519 9.00023 16.7298 9.0508 16.6398 9.14082C16.5498 9.23083 16.4992 9.35293 16.4992 9.48023V15.5627C16.4829 16.443 16.7696 17.3022 17.3113 17.9963C17.8529 18.6905 18.6166 19.1775 19.4744 19.3757C20.0208 19.4904 20.5859 19.4817 21.1285 19.3504C21.6711 19.2191 22.1776 18.9685 22.6111 18.6167C23.0446 18.265 23.3942 17.821 23.6344 17.3171C23.8747 16.8131 23.9996 16.262 23.9999 15.7037V10.1252C23.9999 9.82686 23.8814 9.54071 23.6704 9.32973C23.4595 9.11876 23.1733 9.00023 22.8749 9.00023Z", fill: "#5059C9" }), /* @__PURE__ */ d.createElement("path", { d: "M18.7497 10.1252V17.2502C18.7504 18.5706 18.3153 19.8544 17.5119 20.9022C16.7084 21.95 15.5816 22.7034 14.3062 23.0453C13.0308 23.3872 11.6782 23.2986 10.4584 22.7932C9.23851 22.2878 8.21958 21.3939 7.5597 20.2502C7.41537 20.0104 7.28999 19.7596 7.1847 19.5002C7.08653 19.2557 7.00387 19.0052 6.9372 18.7502C6.81355 18.2598 6.75058 17.756 6.7497 17.2502V10.1252C6.7495 9.97744 6.77846 9.83106 6.83493 9.69448C6.8914 9.5579 6.97426 9.4338 7.07876 9.32929C7.18327 9.22479 7.30736 9.14193 7.44394 9.08546C7.58052 9.029 7.7269 9.00003 7.8747 9.00023H17.6247C17.7725 9.00003 17.9189 9.029 18.0554 9.08546C18.192 9.14193 18.3161 9.22479 18.4206 9.32929C18.5251 9.4338 18.608 9.5579 18.6645 9.69448C18.7209 9.83106 18.7499 9.97744 18.7497 10.1252Z", fill: "#7B83EB" }), /* @__PURE__ */ d.createElement("path", { opacity: 0.2, d: "M11.7507 6.00015H9.58768C9.87155 6.59867 10.3194 7.10435 10.8793 7.45842C11.4392 7.8125 12.088 8.00044 12.7504 8.0004V6.9999C12.7496 6.735 12.644 6.48116 12.4567 6.29385C12.2694 6.10653 12.0156 6.00094 11.7507 6.00015Z", fill: "black" }), /* @__PURE__ */ d.createElement("path", { opacity: 0.1, d: "M13.4997 9.00023V18.5027C13.4997 18.7288 13.4223 18.9481 13.2804 19.1241C13.1385 19.3001 12.9406 19.4223 12.7197 19.4702C12.6491 19.4912 12.5758 19.5013 12.5022 19.5002H7.1847C7.08653 19.2557 7.00387 19.0052 6.9372 18.7502C6.81355 18.2598 6.75058 17.756 6.7497 17.2502V10.1252C6.7495 9.97744 6.77846 9.83106 6.83493 9.69448C6.8914 9.5579 6.97426 9.4338 7.07876 9.32929C7.18327 9.22479 7.30736 9.14193 7.44394 9.08546C7.58052 9.029 7.7269 9.00003 7.8747 9.00023H13.4997Z", fill: "black" }), /* @__PURE__ */ d.createElement("path", { opacity: 0.2, d: "M12.7497 9.00023V19.2527C12.7508 19.3263 12.7407 19.3997 12.7197 19.4702C12.6717 19.6912 12.5496 19.889 12.3736 20.031C12.1976 20.1729 11.9783 20.2502 11.7522 20.2502H7.5597C7.41537 20.0104 7.28999 19.7596 7.1847 19.5002C7.08653 19.2557 7.00387 19.0052 6.9372 18.7502C6.81355 18.2598 6.75058 17.756 6.7497 17.2502V10.1252C6.7495 9.97744 6.77846 9.83106 6.83493 9.69448C6.8914 9.5579 6.97426 9.4338 7.07876 9.32929C7.18327 9.22479 7.30736 9.14193 7.44394 9.08546C7.58052 9.029 7.7269 9.00003 7.8747 9.00023H12.7497Z", fill: "black" }), /* @__PURE__ */ d.createElement("path", { opacity: 0.2, d: "M12.7497 9.00023V17.7527C12.7485 18.0169 12.643 18.2699 12.4562 18.4568C12.2694 18.6436 12.0164 18.749 11.7522 18.7502H6.9372C6.81355 18.2598 6.75058 17.756 6.7497 17.2502V10.1252C6.7495 9.97744 6.77846 9.83106 6.83493 9.69448C6.8914 9.5579 6.97426 9.4338 7.07876 9.32929C7.18327 9.22479 7.30736 9.14193 7.44394 9.08546C7.58052 9.029 7.7269 9.00003 7.8747 9.00023H12.7497Z", fill: "black" }), /* @__PURE__ */ d.createElement("path", { opacity: 0.2, d: "M7.8747 9.00023C7.7269 9.00003 7.58052 9.029 7.44394 9.08546C7.30736 9.14193 7.18327 9.22479 7.07876 9.32929C6.97426 9.4338 6.8914 9.5579 6.83493 9.69448C6.77846 9.83106 6.7495 9.97744 6.7497 10.1252V17.2502C6.75058 17.756 6.81355 18.2598 6.9372 18.7502H11.0022C11.2664 18.749 11.5194 18.6436 11.7062 18.4568C11.893 18.2699 11.9985 18.0169 11.9997 17.7527V9.00023H7.8747Z", fill: "black" }), /* @__PURE__ */ d.createElement("path", { d: "M0.999749 6.00015H11.0002C11.2654 6.00015 11.5197 6.10548 11.7072 6.29297C11.8947 6.48046 12 6.73475 12 6.9999V17.0004C12 17.2656 11.8947 17.5198 11.7072 17.7073C11.5197 17.8948 11.2654 18.0002 11.0002 18.0002H0.999749C0.734599 18.0002 0.480309 17.8948 0.29282 17.7073C0.10533 17.5198 0 17.2656 0 17.0004L0 6.9999C0 6.73475 0.10533 6.48046 0.29282 6.29297C0.480309 6.10548 0.734599 6.00015 0.999749 6.00015Z", fill: "#4B53BC" }), /* @__PURE__ */ d.createElement("path", { d: "M8.98506 9.73145H6.74256V15.7465H5.27106V9.73145H3.01506V8.25395H8.98506V9.73145Z", fill: "white" }));
}
d01.displayName = "LBMsTeamsIcon";
function f01(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.66464 0L24 1.49598e-06L16.6043 8.27158L23.8582 15.6421L16.3849 24L0 23.9958L7.42667 15.6895L0.201506 8.34866L7.66464 0ZM8.76033 17.0446L4.28408 22.051L13.6901 22.0534L8.76033 17.0446ZM15.9505 21.6392L10.0304 15.6241L15.3343 9.69205L21.2544 15.7075L15.9505 21.6392ZM14.0007 8.33699L8.69672 14.2691L2.80508 8.28307L8.10871 2.35017L14.0007 8.33699ZM15.2708 6.91651L19.715 1.94594H10.3789L15.2708 6.91651Z", fill: "#494BCB" }));
}
f01.displayName = "LBShortcutIcon";
function h01(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17388_143)" }, /* @__PURE__ */ d.createElement("path", { d: "M12.3055 6.98773C12.3054 8.05015 12.0066 9.09113 11.443 9.99178C10.8795 10.8924 10.074 11.6164 9.11859 12.0811C8.16318 12.5458 7.09634 12.7324 6.03992 12.6196C4.9835 12.5068 3.98009 12.0992 3.14429 11.4434", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M1.00004 7.49898C0.985039 7.33232 0.977539 7.1619 0.977539 6.98773C0.97737 5.87345 1.30589 4.78387 1.92198 3.85539C2.53807 2.92691 3.41435 2.20079 4.44113 1.76793C5.4679 1.33507 6.59955 1.2147 7.69441 1.42189C8.78926 1.62908 9.79868 2.15463 10.5963 2.93273", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M10.647 10.9927L15.0313 15.3859", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M15.0312 4.80524V1.79211H12.0269", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M0.96875 11.1671L6.16875 5.96899C6.27982 5.85819 6.4303 5.79597 6.58719 5.79597C6.74407 5.79597 6.89455 5.85819 7.00562 5.96899L8.53438 7.49836C8.58929 7.55338 8.65452 7.59702 8.72632 7.62679C8.79812 7.65657 8.87508 7.6719 8.95281 7.6719C9.03054 7.6719 9.10751 7.65657 9.17931 7.62679C9.25111 7.59702 9.31633 7.55338 9.37125 7.49836L15.0312 1.79211", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17388_143" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" }))));
}
h01.displayName = "LBForecastingIcon";
function p01(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M10.0312 6.79211H11.5938C11.7812 6.79211 11.9688 6.91711 12.0938 7.04211L13.1562 8.66711L14.5938 9.16711C14.8438 9.22961 15.0312 9.47961 15.0312 9.72961V11.1671C15.0312 11.5421 14.7812 11.7921 14.4062 11.7921H13.1562M8.78125 11.7921H10.6604", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M11.9062 13.0421C12.5966 13.0421 13.1562 12.4825 13.1562 11.7921C13.1562 11.1017 12.5966 10.5421 11.9062 10.5421C11.2159 10.5421 10.6562 11.1017 10.6562 11.7921C10.6562 12.4825 11.2159 13.0421 11.9062 13.0421Z", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M3.15629 11.7921H1.59375C1.21875 11.7921 0.96875 11.5421 0.96875 11.1671V9.29211H9.09373V11.7921H5.65629", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M4.40625 13.0421C5.09661 13.0421 5.65625 12.4825 5.65625 11.7921C5.65625 11.1017 5.09661 10.5421 4.40625 10.5421C3.71589 10.5421 3.15625 11.1017 3.15625 11.7921C3.15625 12.4825 3.71589 13.0421 4.40625 13.0421Z", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M9.09377 3.66711H1.59375C1.21875 3.66711 0.96875 3.91711 0.96875 4.29211V9.29211H9.09377V3.66711Z", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M9.09375 6.79211H12.2188V5.79211C12.2188 5.29211 11.9062 4.79211 11.4062 4.60461L9.09375 3.66711V6.79211Z", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }));
}
p01.displayName = "LBDeliveryIcon";
function m01(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M0.96875 8.19836H3.15625C3.34137 8.19842 3.52236 8.14366 3.67641 8.041C3.83046 7.93834 3.95066 7.79237 4.02187 7.62149L5.64687 3.79961C5.68399 3.71229 5.74673 3.63829 5.82681 3.58738C5.90688 3.53648 6.00052 3.51108 6.09534 3.51453C6.19016 3.51799 6.2817 3.55014 6.35786 3.60673C6.43402 3.66332 6.49121 3.7417 6.52187 3.83149L9.48063 13.0346C9.51129 13.1244 9.56848 13.2028 9.64464 13.2594C9.7208 13.316 9.81234 13.3481 9.90716 13.3516C10.002 13.355 10.0956 13.3296 10.1757 13.2787C10.2558 13.2278 10.3185 13.1538 10.3556 13.0665L11.9775 8.77524C12.0487 8.60436 12.1689 8.45839 12.323 8.35573C12.477 8.25307 12.658 8.19831 12.8431 8.19836H15.0306", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
}
m01.displayName = "LBIterationsIcon";
function g01(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M0.96875 14.4484H15.0312", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M4.25 7.88586H2.375C2.25068 7.88586 2.13145 7.93525 2.04354 8.02316C1.95564 8.11107 1.90625 8.23029 1.90625 8.35461V14.4484H4.71875V8.35461C4.71875 8.23029 4.66936 8.11107 4.58146 8.02316C4.49355 7.93525 4.37432 7.88586 4.25 7.88586Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M8.9375 2.26086H7.0625C6.93818 2.26086 6.81895 2.31025 6.73104 2.39816C6.64314 2.48607 6.59375 2.60529 6.59375 2.72961V14.4484H9.40625V2.72961C9.40625 2.60529 9.35686 2.48607 9.26896 2.39816C9.18105 2.31025 9.06182 2.26086 8.9375 2.26086Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M13.625 5.07336H11.75C11.6257 5.07336 11.5065 5.12275 11.4185 5.21066C11.3306 5.29857 11.2812 5.41779 11.2812 5.54211V14.4484H14.0938V5.54211C14.0938 5.41779 14.0444 5.29857 13.9565 5.21066C13.8685 5.12275 13.7493 5.07336 13.625 5.07336Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
}
g01.displayName = "LBMetricsIcon";
function v01(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17390_41)" }, /* @__PURE__ */ d.createElement("path", { d: "M2.84375 3.19836C2.84375 3.69565 3.04129 4.17256 3.39292 4.52419C3.74456 4.87582 4.22147 5.07336 4.71875 5.07336C5.21603 5.07336 5.69294 4.87582 6.04458 4.52419C6.39621 4.17256 6.59375 3.69565 6.59375 3.19836C6.59375 2.70108 6.39621 2.22417 6.04458 1.87254C5.69294 1.52091 5.21603 1.32336 4.71875 1.32336C4.22147 1.32336 3.74456 1.52091 3.39292 1.87254C3.04129 2.22417 2.84375 2.70108 2.84375 3.19836Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M2.84375 13.5109C2.84375 14.0081 3.04129 14.4851 3.39292 14.8367C3.74456 15.1883 4.22147 15.3859 4.71875 15.3859C5.21603 15.3859 5.69294 15.1883 6.04458 14.8367C6.39621 14.4851 6.59375 14.0081 6.59375 13.5109C6.59375 13.0136 6.39621 12.5367 6.04458 12.185C5.69294 11.8334 5.21603 11.6359 4.71875 11.6359C4.22147 11.6359 3.74456 11.8334 3.39292 12.185C3.04129 12.5367 2.84375 13.0136 2.84375 13.5109Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M9.40625 3.19836C9.40625 3.69565 9.60379 4.17256 9.95542 4.52419C10.3071 4.87582 10.784 5.07336 11.2812 5.07336C11.7785 5.07336 12.2554 4.87582 12.6071 4.52419C12.9587 4.17256 13.1562 3.69565 13.1562 3.19836C13.1562 2.70108 12.9587 2.22417 12.6071 1.87254C12.2554 1.52091 11.7785 1.32336 11.2812 1.32336C10.784 1.32336 10.3071 1.52091 9.95542 1.87254C9.60379 2.22417 9.40625 2.70108 9.40625 3.19836Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M4.71875 5.07336V11.6359", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M4.71875 8.82336H7.53125C8.52581 8.82336 9.47964 8.42828 10.1829 7.72501C10.8862 7.02175 11.2812 6.06793 11.2812 5.07336", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17390_41" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" }))));
}
v01.displayName = "LBGitActivityIcon";
function b01(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17390_49)" }, /* @__PURE__ */ d.createElement("path", { d: "M1.90625 4.60461C1.90625 4.97757 2.05441 5.33526 2.31813 5.59898C2.58185 5.86271 2.93954 6.01086 3.3125 6.01086C3.68546 6.01086 4.04315 5.86271 4.30687 5.59898C4.57059 5.33526 4.71875 4.97757 4.71875 4.60461C4.71875 4.23165 4.57059 3.87397 4.30687 3.61025C4.04315 3.34652 3.68546 3.19836 3.3125 3.19836C2.93954 3.19836 2.58185 3.34652 2.31813 3.61025C2.05441 3.87397 1.90625 4.23165 1.90625 4.60461Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M3.3125 6.94836C3.00471 6.94836 2.69994 7.00899 2.41559 7.12677C2.13123 7.24456 1.87286 7.4172 1.65522 7.63483C1.21568 8.07437 0.96875 8.67051 0.96875 9.29211V10.6984H1.90625L2.375 14.4484H4.25", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M11.2812 4.60461C11.2813 4.97757 11.4294 5.33526 11.6931 5.59898C11.9569 5.86271 12.3145 6.01086 12.6875 6.01086C13.0605 6.01086 13.4181 5.86271 13.6819 5.59898C13.9456 5.33526 14.0938 4.97757 14.0938 4.60461C14.0938 4.23165 13.9456 3.87397 13.6819 3.61025C13.4181 3.34652 13.0605 3.19836 12.6875 3.19836C12.3145 3.19836 11.9569 3.34652 11.6931 3.61025C11.4294 3.87397 11.2812 4.23165 11.2812 4.60461Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M12.6875 6.94836C13.3091 6.94836 13.9052 7.19529 14.3448 7.63483C14.7843 8.07437 15.0312 8.67051 15.0312 9.29211V10.6984H14.0938L13.625 14.4484H11.75", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M6.125 3.19836C6.125 3.69565 6.32254 4.17256 6.67417 4.52419C7.02581 4.87582 7.50272 5.07336 8 5.07336C8.49728 5.07336 8.97419 4.87582 9.32583 4.52419C9.67746 4.17256 9.875 3.69565 9.875 3.19836C9.875 2.70108 9.67746 2.22417 9.32583 1.87254C8.97419 1.52091 8.49728 1.32336 8 1.32336C7.50272 1.32336 7.02581 1.52091 6.67417 1.87254C6.32254 2.22417 6.125 2.70108 6.125 3.19836Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M11.2812 9.29211C11.2812 8.42187 10.9355 7.58727 10.3202 6.97192C9.70484 6.35657 8.87024 6.01086 8 6.01086C7.12976 6.01086 6.29516 6.35657 5.67981 6.97192C5.06445 7.58727 4.71875 8.42187 4.71875 9.29211V10.6984H6.125L6.59375 15.3859H9.40625L9.875 10.6984H11.2812V9.29211Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17390_49" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" }))));
}
b01.displayName = "LBTeamActivityIcon";
function y01(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17390_58)" }, /* @__PURE__ */ d.createElement("path", { d: "M0.96875 8.35461C0.96875 10.2194 1.70954 12.0078 3.02816 13.3265C4.34677 14.6451 6.1352 15.3859 8 15.3859C9.8648 15.3859 11.6532 14.6451 12.9718 13.3265C14.2905 12.0078 15.0312 10.2194 15.0312 8.35461C15.0312 6.48981 14.2905 4.70138 12.9718 3.38277C11.6532 2.06415 9.8648 1.32336 8 1.32336C6.1352 1.32336 4.34677 2.06415 3.02816 3.38277C1.70954 4.70138 0.96875 6.48981 0.96875 8.35461Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M5.65625 8.35461C5.65625 8.97622 5.90318 9.57236 6.34272 10.0119C6.78226 10.4514 7.3784 10.6984 8 10.6984C8.6216 10.6984 9.21774 10.4514 9.65728 10.0119C10.0968 9.57236 10.3438 8.97622 10.3438 8.35461C10.3438 7.73301 10.0968 7.13687 9.65728 6.69733C9.21774 6.25779 8.6216 6.01086 8 6.01086C7.3784 6.01086 6.78226 6.25779 6.34272 6.69733C5.90318 7.13687 5.65625 7.73301 5.65625 8.35461Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M9.29297 6.40899L12.2223 2.72961", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M7.06256 6.2065L5.81006 1.67337", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M9.875 9.76086L13.2006 13.0865", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M8.83545 10.544L9.87482 15.1309", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17390_58" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" }))));
}
y01.displayName = "LBAllocationIcon";
function C01(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17390_67)" }, /* @__PURE__ */ d.createElement("path", { d: "M0.969238 15.3859C1.47826 15.4489 1.99493 15.3974 2.48151 15.2352C2.9681 15.073 3.41232 14.8042 3.78174 14.4484C4.04819 14.7435 4.37361 14.9794 4.73696 15.1409C5.10031 15.3024 5.4935 15.3858 5.89111 15.3858C6.28873 15.3858 6.68192 15.3024 7.04527 15.1409C7.40862 14.9794 7.73404 14.7435 8.00049 14.4484C8.26694 14.7435 8.59236 14.9794 8.95571 15.1409C9.31906 15.3024 9.71225 15.3858 10.1099 15.3858C10.5075 15.3858 10.9007 15.3024 11.264 15.1409C11.6274 14.9794 11.9528 14.7435 12.2192 14.4484C12.5887 14.8042 13.0329 15.073 13.5195 15.2352C14.006 15.3974 14.5227 15.4489 15.0317 15.3859", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M13.1569 5.5946C12.477 5.59714 11.8043 5.73361 11.1771 5.99621C10.5499 6.2588 9.98064 6.64239 9.50176 7.12505C9.02287 7.6077 8.64377 8.17998 8.3861 8.80918C8.12843 9.43839 7.99725 10.1122 8.00004 10.7921C8.67993 10.7895 9.35265 10.653 9.97978 10.3903C10.6069 10.1277 11.1762 9.74412 11.655 9.26148C12.1339 8.77884 12.513 8.2066 12.7707 7.57743C13.0284 6.94826 13.1596 6.2745 13.1569 5.5946Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M9.35708 7.27836C9.71099 6.25877 9.77211 5.16041 9.53349 4.10785C9.29488 3.05529 8.76608 2.09066 8.00708 1.32336C7.24511 2.09346 6.71515 3.06238 6.47775 4.1194C6.24035 5.17641 6.3051 6.2789 6.66458 7.30086", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M2.84428 5.5946C3.52409 5.59731 4.19671 5.73389 4.82373 5.99656C5.45075 6.25924 6.01988 6.64284 6.49864 7.12549C6.97739 7.60813 7.35638 8.18035 7.61397 8.80947C7.87156 9.43859 8.0027 10.1123 7.99991 10.7921C7.3201 10.7894 6.64748 10.6528 6.02046 10.3901C5.39344 10.1275 4.82431 9.74386 4.34555 9.26122C3.8668 8.77858 3.48781 8.20636 3.23022 7.57724C2.97263 6.94812 2.84149 6.27441 2.84428 5.5946Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M8.00049 13.0421V10.7915", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17390_67" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" }))));
}
C01.displayName = "LBInvestmentStrategyIcon";
function w01(e) {
  return /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17390_75)" }, /* @__PURE__ */ d.createElement("path", { d: "M7.38477 8.26648L9.98914 5.66211", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M9.98926 5.66211L10.3443 3.31836L12.3743 1.32336L12.688 2.96336L14.328 3.27711L12.333 5.30711L9.98926 5.66211Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M13.6593 6.80024C13.9905 8.0559 13.912 9.38455 13.4351 10.5924C12.9582 11.8003 12.1079 12.8243 11.0082 13.5149C9.90845 14.2056 8.61685 14.527 7.32171 14.432C6.02656 14.3371 4.79561 13.8309 3.80834 12.9873C2.82108 12.1437 2.12914 11.0067 1.83343 9.7422C1.53772 8.4777 1.65371 7.1518 2.16447 5.95784C2.67523 4.76389 3.55406 3.76432 4.67281 3.10491C5.79155 2.44549 7.09169 2.16072 8.38365 2.29211", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M10.9511 7.56524C11.1155 8.22817 11.069 8.92588 10.8181 9.56112C10.5671 10.1964 10.1242 10.7375 9.55108 11.109C8.97797 11.4806 8.30321 11.6641 7.62086 11.6339C6.93851 11.6038 6.28257 11.3615 5.74447 10.9408C5.20637 10.5201 4.81293 9.94205 4.61898 9.28715C4.42503 8.63225 4.44025 7.93315 4.6625 7.28731C4.88476 6.64146 5.30298 6.08106 5.85887 5.6842C6.41476 5.28734 7.08062 5.07381 7.76364 5.07336", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M4.57227 13.5109L4.10352 15.3859", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M11.1348 13.5109L11.6035 15.3859", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17390_75" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" }))));
}
w01.displayName = "LBGoalsIcon";
const u31 = (e) => /* @__PURE__ */ d.createElement("svg", { width: 180, height: 40, viewBox: "0 0 180 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", ...e }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.66921 11.7665C11.4765 11.3803 12.617 10.3272 12.9504 9.08302C13.3123 7.72704 14.3674 6.73089 15.8982 6.28974C17.3985 5.87502 19.2058 6.06815 20.8748 6.75936C22.4036 7.39567 24.0991 7.53391 25.3778 7.00738C27.0733 6.28771 27.4636 4.54547 26.3516 2.88658C24.959 0.812975 21.8445 -0.40273 19.5371 0.121772C18.3133 0.426714 17.5347 1.14435 17.3416 2.0856C17.12 3.19153 16.0913 4.04943 14.6459 4.43773L14.5341 4.46619C13.0602 4.85245 11.2264 4.71421 9.61432 4.023C8.22378 3.41515 6.58319 3.21999 5.11133 3.55339C2.22048 4.2446 0.941749 6.84474 2.74904 9.30664C4.19447 11.242 7.16868 12.293 9.67124 11.7685L9.66921 11.7665ZM35.6625 20.1484C34.1337 20.618 33.3002 21.8357 33.2718 23.3299C33.2169 25.0457 32.3549 26.5115 30.7977 27.2576L30.6859 27.3125C29.0737 28.087 26.9879 28.0037 24.959 27.1458C23.1233 26.3712 21.068 26.3428 19.3989 27.3125C17.12 28.64 16.2011 31.7382 17.5632 34.7246C19.3989 38.7641 24.0971 40.671 27.3762 38.8454C29.0168 37.9042 29.8788 36.2453 29.9337 34.3912C29.9886 32.3176 31.0172 30.7116 32.6294 29.9106C34.1866 29.1076 36.187 29.1076 38.1346 29.9939C39.8301 30.7685 41.5825 30.8519 42.8876 30.1322C45.3068 28.7762 44.9999 25.2084 42.4424 22.5249C40.4969 20.5611 37.6609 19.5385 35.6585 20.1463L35.6625 20.1484ZM32.548 7.53594C31.1026 7.84089 30.324 8.83703 30.324 10.0812C30.324 11.1871 29.769 12.0999 28.6 12.5146L28.2951 12.6244C27.1282 13.0391 25.5709 12.9009 24.1519 12.2097C22.6516 11.49 20.9277 11.2684 19.4823 11.7401C18.0084 12.2097 17.12 13.3177 16.9248 14.6452C16.7581 15.9442 15.8412 17.0237 14.3958 17.5218L14.0075 17.66C12.5336 18.1845 10.7833 17.965 9.19756 17.2169C7.39027 16.3589 5.16622 16.1943 3.22069 17.0237C0.718125 18.1032 -0.643952 20.7583 0.30137 23.3848C1.60856 26.9811 6.08308 28.7782 9.64278 27.3125C11.5334 26.5379 12.6739 25.0173 12.924 23.3299C13.1456 21.7808 14.1742 20.5631 15.6481 19.9837L15.8433 19.9003C17.2887 19.3474 19.0675 19.4856 20.6532 20.2886C22.3203 21.1181 24.2394 21.3112 25.7681 20.6769C27.2685 20.0691 28.0207 18.8229 28.0207 17.3856C28.0207 16.0865 28.7159 15.0619 29.9113 14.6187L30.0495 14.5639C31.2165 14.1207 32.7452 14.2874 34.1927 14.9786C35.7215 15.6982 37.3621 15.9198 38.5859 15.3933C40.7551 14.509 40.6981 11.8255 38.4741 9.66647C36.862 8.06248 34.3594 7.17611 32.5521 7.53594H32.548Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M66.2137 7.10083H61.4749V31.5857H64.9593H66.2137H77.4274V27.3714H66.2137V7.10083Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M84.6362 14.7631H80.0051V31.5858H84.6362V14.7631Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M82.3371 6.82037C81.595 6.82037 80.979 7.07449 80.4911 7.58883C80.0032 8.0991 79.7593 8.71508 79.7593 9.43475C79.7593 10.1544 80.0032 10.7989 80.4911 11.2969C80.979 11.795 81.593 12.0451 82.3371 12.0451C83.0811 12.0451 83.7256 11.795 84.2013 11.2969C84.677 10.7989 84.9148 10.1768 84.9148 9.43475C84.9148 8.69272 84.677 8.0991 84.2013 7.58883C83.7256 7.07653 83.1035 6.82037 82.3371 6.82037Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M101.164 15.3383C100.198 14.7223 99.0905 14.4133 97.8382 14.4133C96.5859 14.4133 95.417 14.6918 94.4066 15.2488C93.8598 15.5517 93.3779 15.9177 92.9612 16.3466V14.7609H88.3972V31.5836H92.9612V21.9352C92.9612 21.2867 93.1055 20.6992 93.3962 20.1787C93.687 19.6542 94.0874 19.2537 94.5977 18.9772C95.108 18.6967 95.6894 18.5585 96.34 18.5585C97.3158 18.5585 98.1168 18.8736 98.7429 19.4997C99.3711 20.1259 99.6842 20.939 99.6842 21.9372V31.5856H104.283V20.8943C104.283 19.7782 104.004 18.7292 103.447 17.7432C102.89 16.7532 102.13 15.9542 101.166 15.3403L101.164 15.3383Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M119.711 15.4605C118.456 14.7408 117.042 14.381 115.462 14.381C113.789 14.381 112.28 14.7632 110.935 15.5296C109.589 16.2981 108.525 17.341 107.747 18.6644C106.968 19.9879 106.58 21.4841 106.58 23.1572C106.58 24.8303 106.974 26.3632 107.765 27.6866C108.554 29.0101 109.64 30.053 111.02 30.8215C112.402 31.5858 113.976 31.9701 115.74 31.9701C117.111 31.9701 118.377 31.7261 119.538 31.2382C120.699 30.7503 121.709 30.0184 122.569 29.0447L119.853 26.3286C119.343 26.9324 118.739 27.3715 118.042 27.65C117.346 27.9306 116.568 28.0688 115.708 28.0688C114.756 28.0688 113.919 27.8696 113.199 27.4772C112.48 27.0829 111.929 26.5075 111.544 25.7533C111.392 25.4545 111.272 25.1333 111.181 24.7917L123.474 24.7612C123.567 24.3892 123.626 24.0477 123.649 23.7326C123.671 23.4174 123.683 23.1125 123.683 22.8076C123.683 21.1832 123.333 19.7317 122.638 18.453C121.941 17.1783 120.965 16.1801 119.711 15.4605ZM113.059 18.8026C113.732 18.4083 114.521 18.2111 115.427 18.2111C116.285 18.2111 117.007 18.3859 117.586 18.7356C118.166 19.0852 118.619 19.5935 118.944 20.2664C119.101 20.5916 119.221 20.9535 119.308 21.352L111.178 21.3764C111.262 21.0633 111.372 20.7685 111.508 20.492C111.868 19.7602 112.386 19.1991 113.059 18.8026Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M138.138 16.3527C137.672 15.8709 137.127 15.4663 136.501 15.1451C135.55 14.6572 134.48 14.4133 133.297 14.4133C131.742 14.4133 130.353 14.7955 129.134 15.5639C127.914 16.3283 126.956 17.3732 126.259 18.6967C125.564 20.0201 125.214 21.5205 125.214 23.1915C125.214 24.8626 125.562 26.3264 126.259 27.6478C126.956 28.9712 127.914 30.0182 129.134 30.7826C130.353 31.551 131.728 31.9332 133.261 31.9332C134.468 31.9332 135.554 31.6893 136.517 31.2014C137.139 30.8863 137.68 30.4898 138.138 30.0141V31.5856H142.736V14.7629H138.138V16.3527ZM137.233 26.43C136.444 27.292 135.409 27.7189 134.133 27.7189C133.319 27.7189 132.588 27.5238 131.937 27.1273C131.287 26.7329 130.782 26.2003 130.423 25.5254C130.063 24.8504 129.882 24.0637 129.882 23.155C129.882 22.2462 130.063 21.4961 130.423 20.8211C130.782 20.1503 131.28 19.6136 131.921 19.2192C132.559 18.8248 133.297 18.6276 134.133 18.6276C134.968 18.6276 135.735 18.8166 136.361 19.2029C136.989 19.5851 137.487 20.1238 137.859 20.8211C138.231 21.5184 138.416 22.3072 138.416 23.1915C138.416 24.4906 138.022 25.5701 137.233 26.428V26.43Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M157.554 14.8138C156.916 14.5474 156.18 14.4133 155.342 14.4133C153.462 14.4133 152.023 15.011 151.022 16.2084C151.01 16.2226 151 16.2389 150.988 16.2531V14.7629H146.424V31.5856H150.988V22.3194C150.988 21.0448 151.295 20.1035 151.911 19.4997C152.527 18.8959 153.322 18.595 154.297 18.595C154.761 18.595 155.174 18.6581 155.533 18.7841C155.893 18.9102 156.2 19.1277 156.456 19.4286L159.313 16.1209C158.776 15.5172 158.193 15.0841 157.552 14.8138H157.554Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M178.506 20.3191C177.869 19.5709 177.062 18.9611 176.087 18.4813C176.768 18.0849 177.339 17.6173 177.792 17.0786C178.64 16.0702 179.063 14.8667 179.063 13.4721C179.063 12.3357 178.778 11.2846 178.209 10.321C177.64 9.35741 176.808 8.58082 175.717 7.9872C174.625 7.39358 173.279 7.10083 171.677 7.10083H161.748V31.5857H171.815C173.533 31.5857 175.003 31.2645 176.221 30.6282C177.441 29.9898 178.374 29.1421 179.024 28.0849C179.675 27.0278 180 25.8507 180 24.5496C180 22.9009 179.502 21.4921 178.504 20.317L178.506 20.3191ZM171.088 10.9675C172.039 10.9675 172.811 11.2115 173.403 11.6994C173.995 12.1873 174.291 12.9293 174.291 13.9275C174.291 14.9257 174.001 15.6331 173.419 16.121C172.84 16.6089 172.051 16.8529 171.051 16.8529H166.452V10.9675H171.086H171.088ZM174.275 26.6741C173.637 27.3714 172.759 27.721 171.645 27.721H166.454V20.685H171.575C172.342 20.685 173.005 20.8456 173.562 21.1729C174.119 21.4982 174.537 21.921 174.814 22.4435C175.092 22.968 175.233 23.5555 175.233 24.204C175.233 25.1555 174.914 25.9808 174.275 26.6761V26.6741Z", fill: "currentColor" })), d31 = (e) => /* @__PURE__ */ d.createElement("svg", { width: 36, height: 36, viewBox: "0 0 36 36", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_3001_43460)" }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.81492 11.5226C9.27563 11.21 10.1974 10.3577 10.4669 9.35085C10.7593 8.25346 11.6121 7.44728 12.8493 7.09026C14.0619 6.75463 15.5226 6.91093 16.8716 7.47032C18.1072 7.98528 19.4776 8.09716 20.5111 7.67104C21.8814 7.08862 22.1969 5.67863 21.2981 4.3361C20.1726 2.65794 17.6554 1.67407 15.7905 2.09855C14.8013 2.34534 14.172 2.92611 14.0159 3.68787C13.8368 4.58289 13.0054 5.27719 11.8372 5.59143L11.7468 5.61447C10.5556 5.92706 9.07353 5.81519 7.77056 5.2558C6.64669 4.76387 5.32072 4.60592 4.13112 4.87574C1.79465 5.43513 0.761148 7.53942 2.22185 9.53183C3.39009 11.0981 5.79392 11.9487 7.81657 11.5242L7.81492 11.5226ZM28.8234 18.306C27.5878 18.686 26.9142 19.6716 26.8912 20.8808C26.8468 22.2694 26.1501 23.4556 24.8915 24.0595L24.8012 24.1039C23.4982 24.7307 21.8124 24.6633 20.1726 23.969C18.6889 23.3421 17.0277 23.3191 15.6787 24.1039C13.8368 25.1782 13.0942 27.6856 14.195 30.1025C15.6787 33.3716 19.4759 34.9149 22.1262 33.4374C23.4522 32.6757 24.1489 31.3331 24.1932 29.8327C24.2376 28.1545 25.069 26.8547 26.372 26.2065C27.6306 25.5566 29.2474 25.5566 30.8214 26.274C32.1918 26.9008 33.6081 26.9683 34.663 26.3858C36.6182 25.2885 36.3701 22.401 34.3031 20.2293C32.7307 18.64 30.4386 17.8124 28.8202 18.3043L28.8234 18.306ZM26.3062 8.09881C25.138 8.34559 24.5087 9.15177 24.5087 10.1587C24.5087 11.0537 24.0601 11.7924 23.1154 12.128L22.8689 12.2169C21.9258 12.5525 20.6672 12.4406 19.5203 11.8813C18.3077 11.2988 16.9143 11.1195 15.7461 11.5012C14.5549 11.8813 13.8368 12.7779 13.6791 13.8523C13.5444 14.9036 12.8033 15.7772 11.6351 16.1803L11.3213 16.2922C10.13 16.7167 8.71533 16.539 7.43373 15.9335C5.97302 15.2392 4.17548 15.106 2.60305 15.7772C0.580408 16.6509 -0.52046 18.7996 0.243575 20.9252C1.30008 23.8357 4.91652 25.2901 7.79356 24.1039C9.32163 23.477 10.2434 22.2464 10.4455 20.8808C10.6246 19.6271 11.456 18.6416 12.6472 18.1727L12.805 18.1053C13.9732 17.6578 15.4109 17.7696 16.6925 18.4195C18.0399 19.0908 19.5909 19.2471 20.8265 18.7338C22.0391 18.2418 22.6471 17.2333 22.6471 16.0701C22.6471 15.0188 23.209 14.1896 24.1751 13.8309L24.2869 13.7865C25.23 13.4278 26.4656 13.5627 27.6355 14.1221C28.8711 14.7045 30.1971 14.8838 31.1862 14.4577C32.9394 13.742 32.8934 11.5703 31.0958 9.82304C29.7929 8.52493 27.7702 7.80759 26.3095 8.09881H26.3062Z", fill: "currentColor" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_3001_43460" }, /* @__PURE__ */ d.createElement("rect", { width: 36, height: 36, fill: "white" }))));
export {
  S$ as LBAccordion,
  L$ as LBAccordionContent,
  M$ as LBAccordionItem,
  k$ as LBAccordionTrigger,
  YI as LBAddUserIcon,
  QK as LBAlert,
  cO as LBAlertCircleIcon,
  eX as LBAlertDescription,
  BQ as LBAlertDialog,
  qQ as LBAlertDialogAction,
  zQ as LBAlertDialogCancel,
  $Q as LBAlertDialogContent,
  jQ as LBAlertDialogDescription,
  VQ as LBAlertDialogFooter,
  WQ as LBAlertDialogHeader,
  fL as LBAlertDialogOverlay,
  dL as LBAlertDialogPortal,
  HQ as LBAlertDialogTitle,
  FQ as LBAlertDialogTrigger,
  JK as LBAlertTitle,
  y01 as LBAllocationIcon,
  SI as LBAnalyticsBarsIcon,
  GI as LBAreaChartIcon,
  r31 as LBAreaChartSkeleton,
  MI as LBArrowCornerLeftDownIcon,
  kI as LBArrowCornerLeftUpIcon,
  LI as LBArrowCornerRightDownIcon,
  EI as LBArrowCornerRightUpIcon,
  q6 as LBArrowDownIcon,
  TI as LBArrowLeftIcon,
  RI as LBArrowRightIcon,
  z6 as LBArrowUpIcon,
  o_ as LBAvatar,
  a_ as LBAvatarFallback,
  i_ as LBAvatarImage,
  c01 as LBAzureBoardsIcon,
  l01 as LBAzureIcon,
  n31 as LBBadge,
  Rk as LBBarChart,
  D21 as LBBarChartSkeleton,
  o01 as LBBitbucketIcon,
  tJ as LBBreadcrumb,
  sJ as LBBreadcrumbEllipsis,
  rJ as LBBreadcrumbItem,
  oJ as LBBreadcrumbLink,
  nJ as LBBreadcrumbList,
  iJ as LBBreadcrumbPage,
  aJ as LBBreadcrumbSeparator,
  dt as LBButton,
  PI as LBCDPartitionIcon,
  YL as LBCalendar,
  C5 as LBCalendarIcon,
  FO as LBCard,
  HO as LBCardContent,
  VO as LBCardDescription,
  jO as LBCardFooter,
  $O as LBCardHeader,
  WO as LBCardTitle,
  a31 as LBChartClickableLegend,
  t31 as LBChartCustomBar,
  RJ as LBChartCustomLegend,
  lO as LBCheckCircleIcon,
  zr as LBCheckIcon,
  RO as LBCheckbox,
  zy as LBChevronDoubleLeftIcon,
  Uy as LBChevronDoubleRightIcon,
  sn as LBChevronDownIcon,
  qi as LBChevronLeftIcon,
  qr as LBChevronRightIcon,
  Yy as LBChevronUpDownIcon,
  Gy as LBChevronUpIcon,
  F21 as LBCircleSkeleton,
  Xt1 as LBCoachingIcon,
  tQ as LBCollapsible,
  rQ as LBCollapsibleContent,
  nQ as LBCollapsibleTrigger,
  i31 as LBColorPicker,
  ZL as LBColorPickerContent,
  KL as LBColorPickerItem,
  Gv as LBColorSwatch,
  X21 as LBCombobox,
  F5 as LBCommand,
  MD as LBCommandDialog,
  $w as LBCommandEmpty,
  Ww as LBCommandGroup,
  Bw as LBCommandInput,
  Vw as LBCommandItem,
  Fw as LBCommandList,
  Hw as LBCommandLoading,
  kD as LBCommandSeparator,
  LD as LBCommandShortcut,
  sO as LBCopyIcon,
  nt1 as LBCycleTimeStage,
  s31 as LBDataTable,
  l31 as LBDataTableColumnHeader,
  Yt1 as LBDataTablePagination,
  Zt1 as LBDataTableViewOptions,
  O21 as LBDatePicker,
  N21 as LBDateRangePicker,
  p01 as LBDeliveryIcon,
  Lw as LBDialog,
  N5 as LBDialogClose,
  Ew as LBDialogContent,
  eD as LBDialogDescription,
  QN as LBDialogFooter,
  XN as LBDialogHeader,
  D5 as LBDialogOverlay,
  O5 as LBDialogPortal,
  JN as LBDialogTitle,
  KN as LBDialogTrigger,
  W21 as LBDoughnutChartSkeleton,
  zi as LBDropdownMenu,
  Jy as LBDropdownMenuCheckboxItem,
  Gi as LBDropdownMenuContent,
  yO as LBDropdownMenuGroup,
  U6 as LBDropdownMenuItem,
  eC as LBDropdownMenuLabel,
  CO as LBDropdownMenuPortal,
  Qy as LBDropdownMenuRadioGroup,
  SO as LBDropdownMenuRadioItem,
  tC as LBDropdownMenuSeparator,
  MO as LBDropdownMenuShortcut,
  wO as LBDropdownMenuSub,
  xO as LBDropdownMenuSubContent,
  _O as LBDropdownMenuSubTrigger,
  Ui as LBDropdownMenuTrigger,
  fO as LBDrownHandIcon,
  Zy as LBEditIcon,
  pO as LBEditMergedAccountsIcon,
  JI as LBEditProfileIcon,
  bO as LBExportFileIcon,
  YX as LBFilterChip,
  GX as LBFilterChipBar,
  ZX as LBFilterChipLabel,
  tO as LBFilterIcon,
  nO as LBFilterOffIcon,
  hO as LBFlameIcon,
  e31 as LBFooter,
  h01 as LBForecastingIcon,
  D01 as LBForm,
  AB as LBFormControl,
  IB as LBFormDescription,
  B01 as LBFormField,
  h_ as LBFormFieldContext,
  RB as LBFormItem,
  p_ as LBFormItemContext,
  PB as LBFormLabel,
  OB as LBFormMessage,
  v01 as LBGitActivityIcon,
  aE as LBGithubIcon,
  s01 as LBGitlabIcon,
  w01 as LBGoalsIcon,
  u01 as LBGoogleIcon,
  AI as LBGraphStatsAscendIcon,
  II as LBGraphStatsIcon,
  r01 as LBHelpIcon,
  oO as LBHideIcon,
  Qt1 as LBHomeIcon,
  W01 as LBHoverCard,
  zB as LBHoverCardContent,
  V01 as LBHoverCardTrigger,
  eO as LBImportIcon,
  lB as LBInput,
  C01 as LBInvestmentStrategyIcon,
  m01 as LBIterationsIcon,
  a01 as LBJiraIcon,
  Xw as LBJiraStatusBadge,
  q21 as LBJiraStatusCheckbox,
  j21 as LBJiraStatusPicker,
  H21 as LBJiraStatusPickerItem,
  Ky as LBKebabIcon,
  j5 as LBLabel,
  OI as LBLayoutIcon,
  UX as LBLineChart,
  qI as LBListIcon,
  NI as LBListToDoIcon,
  J01 as LBLoader,
  u31 as LBLogoFull,
  d31 as LBLogoIcon,
  uO as LBLogoutIcon,
  QI as LBLonelyUserIcon,
  iO as LBMergeAccountsIcon,
  g01 as LBMetricsIcon,
  d01 as LBMsTeamsIcon,
  mO as LBMultipleAccountsIcon,
  DI as LBMultipleNeutralIcon,
  ZI as LBMultipleUsersIcon,
  jI as LBNameIcon,
  BI as LBOrganicPlantGrowIcon,
  lF as LBPagination,
  G5 as LBPaginationButton,
  cF as LBPaginationContent,
  hF as LBPaginationEllipsis,
  uF as LBPaginationItem,
  fF as LBPaginationNext,
  dF as LBPaginationPrevious,
  WI as LBPlusIcon,
  ta as LBPopover,
  $N as LBPopoverAnchor,
  ra as LBPopoverContent,
  na as LBPopoverTrigger,
  J21 as LBPortrait,
  e01 as LBProductivityIcon,
  eJ as LBProgress,
  o31 as LBProgressBarChart,
  V21 as LBProgressBarChartSkeleton,
  zI as LBPublishsurveyIcon,
  vO as LBQuotesIcon,
  oF as LBRadioGroup,
  iF as LBRadioGroupItem,
  KI as LBRemoveUserIcon,
  $I as LBReplaceSwitchIcon,
  t01 as LBResourcesIcon,
  HI as LBSSurveyResultsIcon,
  bQ as LBScrollArea,
  Xk as LBScrollBar,
  Xy as LBSearchIcon,
  M5 as LBSelect,
  XC as LBSelectContent,
  _N as LBSelectGroup,
  QC as LBSelectItem,
  xN as LBSelectLabel,
  KC as LBSelectScrollDownButton,
  ZC as LBSelectScrollUpButton,
  SN as LBSelectSeparator,
  L5 as LBSelectTrigger,
  k5 as LBSelectValue,
  eQ as LBSeparator,
  Jt1 as LBSettingsIcon,
  pF as LBSheet,
  j01 as LBSheetClose,
  bF as LBSheetContent,
  wF as LBSheetDescription,
  yF as LBSheetHeader,
  CF as LBSheetTitle,
  mF as LBSheetTrigger,
  f01 as LBShortcutIcon,
  rO as LBShowIcon,
  q2 as LBSkeleton,
  i01 as LBSlackIcon,
  r$ as LBStep,
  o$ as LBStepper,
  U01 as LBStepperSeparator,
  VI as LBStopSignIcon,
  UI as LBSurveysIcon,
  BO as LBSwitch,
  A_ as LBTable,
  ou as LBTableBody,
  sF as LBTableCaption,
  jo as LBTableCell,
  aF as LBTableFooter,
  O_ as LBTableHead,
  I_ as LBTableHeader,
  zn as LBTableRow,
  VT as LBTabs,
  qT as LBTabsContent,
  HT as LBTabsList,
  jT as LBTabsTrigger,
  gO as LBTargetIcon,
  FI as LBTaskListCheckIcon,
  b01 as LBTeamActivityIcon,
  n01 as LBTeamsIcon,
  fB as LBTextarea,
  JF as LBToast,
  ZF as LBToaster,
  I01 as LBTooltip,
  ZD as LBTooltipContent,
  A01 as LBTooltipProvider,
  O01 as LBTooltipTrigger,
  dO as LBTrophyIcon,
  aO as LBUnmergeAccountsIcon,
  XI as LBUserIcon,
  U21 as LBWizard,
  Y21 as LBWizardContent,
  z21 as LBWizardHeader,
  K21 as LBWizardMain,
  Z21 as LBWizardSidebar,
  G21 as LBWizardTitle,
  ln as LBXIcon,
  et1 as LB_COLOR_PICKER_PALETTE,
  Or as buttonVariants,
  B21 as circleSkeletonVariants,
  e1 as cn,
  tt1 as cycleTimeVariants,
  $21 as doughnutChartSkeletonVariants,
  V5 as jiraStatusBadgeVariants,
  z01 as lbDefineStepper,
  q01 as lbToast,
  n$ as stepVariants,
  XF as toastButtonVariants,
  QF as toastCloseButtonVariants,
  KF as toastVariants,
  fa as useLBFormField,
  c31 as useLBPersistentColumnVisibility
};
